webpackJsonp([35],[
/* 0 */,
/* 1 */,
/* 2 */,
/* 3 */,
/* 4 */,
/* 5 */,
/* 6 */,
/* 7 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return baseUrl; });
var baseUrl =  true ? '/sunbackend' : '/api/sunbackend';

/***/ }),
/* 8 */,
/* 9 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export catalogs */
/* unused harmony export catalog */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return companies; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return company; });
var catalogs = [{
    "id": "5a097735e4b0c02db814bb59",
    "oosCompanyId": 1234,
    "companyId": "59dcd421e4b0bc51008ea0dc",
    "views": [{
        "viewId": 1,
        "name": {
            "de": "Online Bestellung",
            "en": "online order"
        }
    }, {
        "viewId": 2,
        "name": {
            "de": "Restaurant",
            "en": "Restaurant"
        }
    }, {
        "viewId": 3,
        "name": {
            "de": "Mittagsmenü",
            "en": "Lunch menu"
        }
    }, {
        "viewId": 4,
        "name": {
            "de": "Abholtheke",
            "en": "Take away"
        }
    }],
    "version": 2,
    "status": "inactive",
    "createdOn": "2017-11-13T10:43:01.375+0000",
    "createdBy": "12345",
    "modifiedOn": "2018-01-29T23:43:53.247+0000",
    "modifiedBy": "5a6fb154e4b021ef3c7a6fe6"
}, {
    "id": "5a5619f6e4b0e71bd94393c7",
    "companyId": "59c4f7b807587a0a5192cba2",
    "views": [{
        "name": {
            "en": "test"
        }
    }],
    "version": 1,
    "status": "active",
    "createdOn": "2018-01-10T13:49:42.886+0000",
    "createdBy": "5a560687e4b0e71bd9438a6d",
    "modifiedOn": "2018-01-18T08:45:39.438+0000",
    "modifiedBy": "5a4d578c46877612551d0db4",
    "lastItemId": 1,
    "lastViewId": 1
}, {
    "id": "5a5c8fe6e4b090d85d58abcb",
    "companyId": "59dcd421e4b0bc51008ea0dc",
    "views": [{
        "viewId": 1,
        "name": {
            "de": "Online Bestellung",
            "en": "online order"
        }
    }, {
        "viewId": 2,
        "name": {
            "de": "Restaurant",
            "en": "Restaurant"
        }
    }, {
        "viewId": 3,
        "name": {
            "de": "Mittagsmenü",
            "en": "Lunch menu"
        }
    }, {
        "viewId": 4,
        "name": {
            "de": "Abholtheke",
            "en": "Take away"
        }
    }],
    "version": 10,
    "status": "created",
    "createdOn": "2018-01-15T11:26:30.406+0000",
    "createdBy": "5a5c8d4fe4b090d85d58ab6a",
    "modifiedOn": "2018-01-15T11:26:30.406+0000",
    "modifiedBy": "5a5c8d4fe4b090d85d58ab6a",
    "lastItemId": 0,
    "lastViewId": 0
}, {
    "id": "5a5c9794e4b04e14d902a4d5",
    "companyId": "59c8fe13e4b085e2cd4c6d59",
    "views": [{
        "name": {
            "en": "x"
        }
    }],
    "version": 6,
    "status": "inactive",
    "createdOn": "2018-01-15T11:59:16.628+0000",
    "createdBy": "5a5c8d4fe4b090d85d58ab6a",
    "modifiedOn": "2018-01-18T10:35:07.191+0000",
    "modifiedBy": "5a605e18e4b04e14d902b31a",
    "lastItemId": 1,
    "lastViewId": 1
}, {
    "id": "5a5c97d9e4b04e14d902a4da",
    "companyId": "59c8fe13e4b085e2cd4c6d59",
    "views": [{
        "name": {
            "en": "x"
        }
    }],
    "version": 7,
    "status": "inactive",
    "createdOn": "2018-01-15T12:00:25.867+0000",
    "createdBy": "5a5c8d4fe4b090d85d58ab6a",
    "modifiedOn": "2018-01-18T10:35:25.031+0000",
    "modifiedBy": "5a605e18e4b04e14d902b31a",
    "lastItemId": 1,
    "lastViewId": 1
}, {
    "id": "5a0a2f4ee4b0c02db81529e9",
    "oosCompanyId": 1234,
    "companyId": "59dcd421e4b0bc51008ea0dc",
    "views": [{
        "viewId": 1,
        "name": {
            "en": "Online"
        }
    }, {
        "viewId": 2,
        "name": {
            "en": "Takeaway"
        }
    }, {
        "viewId": 3,
        "name": {
            "en": "Restaurant"
        }
    }],
    "version": 3,
    "status": "inactive",
    "createdOn": "2017-11-13T23:48:30.774+0000",
    "createdBy": "12345",
    "modifiedOn": "2018-01-15T11:04:31.281+0000",
    "modifiedBy": "5a5c6f0be4b090d85d58aa17"
}, {
    "id": "5a561a58e4b0e71bd9439415",
    "companyId": "59c4f7b807587a0a5192cba2",
    "views": [{
        "name": {
            "en": "test"
        }
    }],
    "version": 2,
    "status": "inactive",
    "createdOn": "2018-01-10T13:51:20.866+0000",
    "createdBy": "5a560687e4b0e71bd9438a6d",
    "modifiedOn": "2018-01-18T08:45:39.461+0000",
    "modifiedBy": "5a605e18e4b04e14d902b31a",
    "lastItemId": 1,
    "lastViewId": 1
}, {
    "id": "5a561a9be4b0e71bd9439432",
    "companyId": "59c4f7b807587a0a5192cba2",
    "views": [{
        "name": {
            "en": "test"
        }
    }],
    "version": 3,
    "status": "inactive",
    "createdOn": "2018-01-10T13:52:27.703+0000",
    "createdBy": "5a560687e4b0e71bd9438a6d",
    "modifiedOn": "2018-01-10T13:53:47.822+0000",
    "modifiedBy": "5a560687e4b0e71bd9438a6d",
    "lastItemId": 1,
    "lastViewId": 1
}, {
    "id": "5a561aebe4b0e71bd943944d",
    "companyId": "59c4f7b807587a0a5192cba2",
    "views": [{
        "name": {
            "en": "werwer"
        }
    }],
    "version": 4,
    "status": "inactive",
    "createdOn": "2018-01-10T13:53:47.775+0000",
    "createdBy": "5a560687e4b0e71bd9438a6d",
    "modifiedOn": "2018-01-10T13:54:33.103+0000",
    "modifiedBy": "5a560687e4b0e71bd9438a6d",
    "lastItemId": 1,
    "lastViewId": 1
}, {
    "id": "5a563017e4b0e71bd9439e49",
    "companyId": "59c4f7b807587a0a5192cba2",
    "views": [{
        "name": {
            "en": "xyz"
        }
    }],
    "version": 5,
    "status": "inactive",
    "createdOn": "2018-01-10T15:24:07.896+0000",
    "createdBy": "5a562e02e4b0e71bd9439d40",
    "modifiedOn": "2018-01-12T11:13:29.440+0000",
    "modifiedBy": "5a58720fe4b0e71bd944aa2e",
    "lastItemId": 1,
    "lastViewId": 1
}, {
    "id": "5a5632e3e4b0e71bd9439ff8",
    "companyId": "59dcd421e4b0bc51008ea0dc",
    "views": [{
        "name": {
            "en": "v1"
        }
    }],
    "version": 4,
    "status": "inactive",
    "createdOn": "2018-01-10T15:36:03.823+0000",
    "createdBy": "5a562e02e4b0e71bd9439d40",
    "modifiedOn": "2018-01-12T15:52:26.977+0000",
    "modifiedBy": "5a58d838e4b08c6c0f7457f8",
    "lastItemId": 1,
    "lastViewId": 1
}, {
    "id": "5a574ec6e4b0e71bd94421ba",
    "companyId": "59dcd421e4b0bc51008ea0dc",
    "views": [{
        "name": {
            "de": "Online Bestellung",
            "en": "online order"
        }
    }, {
        "name": {
            "de": "Restaurant",
            "en": "Restaurant"
        }
    }, {
        "name": {
            "de": "Mittagsmenü",
            "en": "Lunch menu"
        }
    }, {
        "name": {
            "de": "Abholtheke",
            "en": "Take away"
        }
    }],
    "version": 5,
    "status": "inactive",
    "createdOn": "2018-01-11T11:47:18.541+0000",
    "createdBy": "5a571ec5e4b0e71bd9440b54",
    "modifiedOn": "2018-01-12T11:18:36.606+0000",
    "modifiedBy": "5a58720fe4b0e71bd944aa2e",
    "lastItemId": 2,
    "lastViewId": 4
}, {
    "id": "5a57d2efe4b0e71bd9446232",
    "companyId": "59dcd421e4b0bc51008ea0dc",
    "views": [{
        "name": {
            "en": "Restaurant"
        }
    }],
    "version": 6,
    "status": "inactive",
    "createdOn": "2018-01-11T21:11:11.603+0000",
    "createdBy": "5a57cfa4e4b0e71bd944605e",
    "modifiedOn": "2018-01-18T08:45:21.965+0000",
    "modifiedBy": "5a605e18e4b04e14d902b31a",
    "lastItemId": 2,
    "lastViewId": 1
}, {
    "id": "5a589859e4b0e71bd944bc55",
    "companyId": "59c4f7b807587a0a5192cba2",
    "views": [{
        "name": {
            "en": "test"
        }
    }],
    "version": 6,
    "status": "inactive",
    "createdOn": "2018-01-12T11:13:29.394+0000",
    "createdBy": "5a58720fe4b0e71bd944aa2e",
    "modifiedOn": "2018-01-12T12:36:16.132+0000",
    "modifiedBy": "5a58720fe4b0e71bd944aa2e",
    "lastItemId": 0,
    "lastViewId": 0
}, {
    "id": "5a58af96e4b0e71bd944c9e8",
    "companyId": "59c8fe13e4b085e2cd4c6d59",
    "views": [{
        "name": {
            "en": "test"
        }
    }],
    "version": 1,
    "status": "inactive",
    "createdOn": "2018-01-12T12:52:38.390+0000",
    "createdBy": "5a58720fe4b0e71bd944aa2e",
    "modifiedOn": "2018-01-15T11:04:52.304+0000",
    "modifiedBy": "5a5c6f0be4b090d85d58aa17",
    "lastItemId": 1,
    "lastViewId": 1
}, {
    "id": "5a58c18be4b08c6c0f745775",
    "companyId": "59c4f7b807587a0a5192cba2",
    "views": [{
        "name": {
            "en": "test"
        }
    }],
    "version": 7,
    "status": "inactive",
    "createdOn": "2018-01-12T14:09:15.369+0000",
    "createdBy": "5a58a521e4b0e71bd944c491",
    "modifiedOn": "2018-01-12T14:09:15.369+0000",
    "modifiedBy": "5a58a521e4b0e71bd944c491",
    "lastItemId": 0,
    "lastViewId": 0
}, {
    "id": "5a58d8ece4b08c6c0f74581d",
    "companyId": "59dcd421e4b0bc51008ea0dc",
    "views": [{
        "name": {
            "en": "x"
        }
    }, {
        "name": {
            "en": "y"
        }
    }],
    "version": 7,
    "status": "inactive",
    "createdOn": "2018-01-12T15:49:00.870+0000",
    "createdBy": "5a58d838e4b08c6c0f7457f8",
    "modifiedOn": "2018-01-16T19:37:45.902+0000",
    "modifiedBy": "5a5e5476e4b04e14d902acf5",
    "lastItemId": 1,
    "lastViewId": 2
}, {
    "id": "5a58d93ce4b08c6c0f745836",
    "companyId": "59dcd421e4b0bc51008ea0dc",
    "views": [{
        "name": {
            "en": "x"
        }
    }],
    "version": 8,
    "status": "created",
    "createdOn": "2018-01-12T15:50:20.331+0000",
    "createdBy": "5a58d838e4b08c6c0f7457f8",
    "modifiedOn": "2018-01-12T15:50:20.331+0000",
    "modifiedBy": "5a58d838e4b08c6c0f7457f8",
    "lastItemId": 1,
    "lastViewId": 1
}, {
    "id": "5a58db7de4b08c6c0f745891",
    "companyId": "59c8fe13e4b085e2cd4c6d59",
    "views": [{
        "name": {
            "en": "test"
        }
    }],
    "version": 2,
    "status": "inactive",
    "createdOn": "2018-01-12T15:59:57.058+0000",
    "createdBy": "5a58d48fe4b08c6c0f7457dc",
    "modifiedOn": "2018-01-18T08:43:11.256+0000",
    "modifiedBy": "5a605e18e4b04e14d902b31a",
    "lastItemId": 0,
    "lastViewId": 0
}, {
    "id": "5a592346e4b08c6c0f74594d",
    "companyId": "59dcd421e4b0bc51008ea0dc",
    "views": [{
        "viewId": 1,
        "name": {
            "de": "Online Bestellung",
            "en": "online order"
        }
    }, {
        "viewId": 2,
        "name": {
            "de": "Restaurant",
            "en": "Restaurant"
        }
    }, {
        "viewId": 3,
        "name": {
            "de": "Mittagsmenü",
            "en": "Lunch menu"
        }
    }, {
        "viewId": 4,
        "name": {
            "de": "Abholtheke",
            "en": "Take away"
        }
    }],
    "version": 9,
    "status": "created",
    "createdOn": "2018-01-12T21:06:14.583+0000",
    "createdBy": "5a592295e4b08c6c0f74591a",
    "modifiedOn": "2018-01-12T21:06:14.583+0000",
    "modifiedBy": "5a592295e4b08c6c0f74591a",
    "lastItemId": 0,
    "lastViewId": 0
}, {
    "id": "59edae5be4b0c81a048e8491",
    "oosCompanyId": 1234,
    "companyId": "59dcd421e4b0bc51008ea0dc",
    "views": [{
        "viewId": 1,
        "name": {
            "en": "Restaurant"
        }
    }],
    "version": 3,
    "status": "inactive",
    "createdOn": "2018-01-12T10:16:03.318+0000",
    "createdBy": "OOS",
    "modifiedOn": "2018-01-15T09:22:27.379+0000",
    "modifiedBy": "5a5c72b8e4b090d85d58aa86",
    "lastItemId": 302,
    "lastViewId": 1
}, {
    "id": "5a5bb988e4b0f01cb23514dd",
    "companyId": "59c8fe13e4b085e2cd4c6d59",
    "views": [{
        "viewId": 1,
        "name": {
            "en": "Restaurant"
        }
    }],
    "version": 3,
    "status": "created",
    "createdOn": "2018-01-14T20:11:52.928+0000",
    "createdBy": "5a5b8466e4b0f01cb23514a2",
    "modifiedOn": "2018-01-14T20:11:52.928+0000",
    "modifiedBy": "5a5b8466e4b0f01cb23514a2",
    "lastItemId": 0,
    "lastViewId": 0
}, {
    "id": "5a5c9259e4b090d85d58abe4",
    "companyId": "59c8fe13e4b085e2cd4c6d59",
    "views": [{
        "viewId": 1,
        "name": {
            "en": "Restaurant"
        }
    }],
    "version": 4,
    "status": "created",
    "createdOn": "2018-01-15T11:36:57.966+0000",
    "createdBy": "5a5c8d4fe4b090d85d58ab6a",
    "modifiedOn": "2018-01-15T11:36:57.966+0000",
    "modifiedBy": "5a5c8d4fe4b090d85d58ab6a",
    "lastItemId": 0,
    "lastViewId": 0
}, {
    "id": "5a5c9299e4b090d85d58abf8",
    "companyId": "59c8fe13e4b085e2cd4c6d59",
    "views": [{
        "name": {
            "en": "x"
        }
    }],
    "version": 5,
    "status": "created",
    "createdOn": "2018-01-15T11:38:01.224+0000",
    "createdBy": "5a5c8d4fe4b090d85d58ab6a",
    "modifiedOn": "2018-01-15T11:38:01.224+0000",
    "modifiedBy": "5a5c8d4fe4b090d85d58ab6a",
    "lastItemId": 1,
    "lastViewId": 1
}, {
    "id": "5a5c97ffe4b04e14d902a4e5",
    "companyId": "59c8fe13e4b085e2cd4c6d59",
    "views": [{
        "name": {
            "en": "x"
        }
    }],
    "version": 8,
    "status": "created",
    "createdOn": "2018-01-15T12:01:03.002+0000",
    "createdBy": "5a5c8d4fe4b090d85d58ab6a",
    "modifiedOn": "2018-01-15T12:01:03.002+0000",
    "modifiedBy": "5a5c8d4fe4b090d85d58ab6a",
    "lastItemId": 1,
    "lastViewId": 1
}, {
    "id": "5a5c9820e4b04e14d902a4e8",
    "companyId": "59c8fe13e4b085e2cd4c6d59",
    "views": [{
        "name": {
            "en": "x"
        }
    }],
    "version": 9,
    "status": "created",
    "createdOn": "2018-01-15T12:01:36.339+0000",
    "createdBy": "5a5c8d4fe4b090d85d58ab6a",
    "modifiedOn": "2018-01-15T12:01:36.339+0000",
    "modifiedBy": "5a5c8d4fe4b090d85d58ab6a",
    "lastItemId": 1,
    "lastViewId": 1
}, {
    "id": "5a5c9870e4b04e14d902a4f3",
    "companyId": "59dcd421e4b0bc51008ea0dc",
    "views": [{
        "viewId": 1,
        "name": {
            "de": "Online Bestellung",
            "en": "online order"
        }
    }, {
        "viewId": 2,
        "name": {
            "de": "Restaurant",
            "en": "Restaurant"
        }
    }, {
        "viewId": 3,
        "name": {
            "de": "Mittagsmenü",
            "en": "Lunch menu"
        }
    }, {
        "viewId": 4,
        "name": {
            "de": "Abholtheke",
            "en": "Take away"
        }
    }],
    "version": 11,
    "status": "created",
    "createdOn": "2018-01-15T12:02:55.989+0000",
    "createdBy": "5a5c6f0be4b090d85d58aa17",
    "modifiedOn": "2018-01-15T12:02:55.989+0000",
    "modifiedBy": "5a5c6f0be4b090d85d58aa17",
    "lastItemId": 0,
    "lastViewId": 0
}, {
    "id": "5a5c992de4b04e14d902a51c",
    "companyId": "59dcd421e4b0bc51008ea0dc",
    "views": [{
        "viewId": 1,
        "name": {
            "de": "Online Bestellung",
            "en": "online order"
        }
    }, {
        "viewId": 2,
        "name": {
            "de": "Restaurant",
            "en": "Restaurant"
        }
    }, {
        "viewId": 3,
        "name": {
            "de": "Mittagsmenü",
            "en": "Lunch menu"
        }
    }, {
        "viewId": 4,
        "name": {
            "de": "Abholtheke",
            "en": "Take away"
        }
    }],
    "version": 12,
    "status": "created",
    "createdOn": "2018-01-15T12:06:05.175+0000",
    "createdBy": "5a5c6f0be4b090d85d58aa17",
    "modifiedOn": "2018-01-15T12:06:05.175+0000",
    "modifiedBy": "5a5c6f0be4b090d85d58aa17",
    "lastItemId": 0,
    "lastViewId": 0
}, {
    "id": "5a5ca3c9e4b04e14d902a5c6",
    "companyId": "59c4f7b807587a0a5192cba2",
    "views": [{
        "viewId": 1,
        "name": {
            "en": "testView"
        }
    }],
    "version": 8,
    "status": "created",
    "createdOn": "2018-01-15T12:51:21.950+0000",
    "createdBy": "5a5c93a3e4b090d85d58ac0f",
    "modifiedOn": "2018-01-15T12:51:21.950+0000",
    "modifiedBy": "5a5c93a3e4b090d85d58ac0f",
    "lastItemId": 1,
    "lastViewId": 1
}, {
    "id": "5a5ca584e4b04e14d902a5f5",
    "companyId": "59dcd421e4b0bc51008ea0dc",
    "views": [{
        "viewId": 1,
        "name": {
            "de": "Online Bestellung",
            "en": "online order"
        }
    }, {
        "viewId": 2,
        "name": {
            "de": "Restaurant",
            "en": "Restaurant"
        }
    }, {
        "viewId": 3,
        "name": {
            "de": "Mittagsmenü",
            "en": "Lunch menu"
        }
    }, {
        "viewId": 4,
        "name": {
            "de": "Abholtheke",
            "en": "Take away"
        }
    }, {
        "name": {
            "en": "111",
            "de": "121"
        }
    }],
    "version": 13,
    "status": "created",
    "createdOn": "2018-01-15T12:58:44.845+0000",
    "createdBy": "5a5c6f0be4b090d85d58aa17",
    "modifiedOn": "2018-01-15T12:58:44.845+0000",
    "modifiedBy": "5a5c6f0be4b090d85d58aa17",
    "lastItemId": 0,
    "lastViewId": 0
}, {
    "id": "5a5ca70ce4b04e14d902a61a",
    "companyId": "59dcd421e4b0bc51008ea0dc",
    "views": [{
        "viewId": 1,
        "name": {
            "de": "Online Bestellung",
            "en": "online order"
        }
    }, {
        "viewId": 2,
        "name": {
            "de": "Restaurant",
            "en": "Restaurant"
        }
    }, {
        "viewId": 3,
        "name": {
            "de": "Mittagsmenü",
            "en": "Lunch menu"
        }
    }, {
        "viewId": 4,
        "name": {
            "de": "Abholtheke",
            "en": "Take away"
        }
    }, {
        "viewId": 5,
        "name": {
            "en": "11",
            "de": "22"
        }
    }],
    "version": 14,
    "status": "created",
    "createdOn": "2018-01-15T13:05:16.331+0000",
    "createdBy": "5a5c6f0be4b090d85d58aa17",
    "modifiedOn": "2018-01-15T13:05:16.331+0000",
    "modifiedBy": "5a5c6f0be4b090d85d58aa17",
    "lastItemId": 0,
    "lastViewId": 0
}, {
    "id": "5a5ca7f6e4b04e14d902a63d",
    "companyId": "59c8fe13e4b085e2cd4c6d59",
    "views": [{
        "name": {
            "en": "test 2"
        }
    }],
    "version": 10,
    "status": "created",
    "createdOn": "2018-01-15T13:09:10.102+0000",
    "createdBy": "5a5c6f0be4b090d85d58aa17",
    "modifiedOn": "2018-01-15T13:09:10.102+0000",
    "modifiedBy": "5a5c6f0be4b090d85d58aa17",
    "lastItemId": 0,
    "lastViewId": 0
}, {
    "id": "5a5ca86de4b04e14d902a674",
    "companyId": "59dcd421e4b0bc51008ea0dc",
    "views": [{
        "viewId": 1,
        "name": {
            "de": "Online Bestellung",
            "en": "online order"
        }
    }, {
        "viewId": 2,
        "name": {
            "de": "Restaurant",
            "en": "Restaurant"
        }
    }, {
        "viewId": 3,
        "name": {
            "de": "Mittagsmenü",
            "en": "Lunch menu"
        }
    }, {
        "viewId": 4,
        "name": {
            "de": "Abholtheke",
            "en": "Take away"
        }
    }],
    "version": 15,
    "status": "created",
    "createdOn": "2018-01-15T13:11:09.582+0000",
    "createdBy": "5a5c6f0be4b090d85d58aa17",
    "modifiedOn": "2018-01-15T13:11:09.582+0000",
    "modifiedBy": "5a5c6f0be4b090d85d58aa17",
    "lastItemId": 0,
    "lastViewId": 0
}, {
    "id": "5a5cb2cfe4b04e14d902a6f9",
    "companyId": "5a0c4820e4b02a2fc346ea1a",
    "views": [{
        "viewId": 1,
        "name": {
            "en": "t2"
        }
    }, {
        "viewId": 2,
        "name": {
            "en": "t3"
        }
    }],
    "version": 1,
    "status": "inactive",
    "createdOn": "2018-01-15T13:55:27.709+0000",
    "createdBy": "5a5c6f0be4b090d85d58aa17",
    "modifiedOn": "2018-01-15T14:00:08.229+0000",
    "modifiedBy": "5a5c6f0be4b090d85d58aa17",
    "lastItemId": 0,
    "lastViewId": 0
}, {
    "id": "5a5cb2eee4b04e14d902a704",
    "companyId": "5a0c4820e4b02a2fc346ea1a",
    "views": [{
        "viewId": 1,
        "name": {
            "en": "t5"
        }
    }, {
        "viewId": 2,
        "name": {
            "en": "t3"
        }
    }],
    "version": 2,
    "status": "active",
    "createdOn": "2018-01-15T13:55:58.571+0000",
    "createdBy": "5a5c6f0be4b090d85d58aa17",
    "modifiedOn": "2018-01-15T14:00:08.192+0000",
    "modifiedBy": "5a4e83de46877628f1822ac7",
    "lastItemId": 0,
    "lastViewId": 0
}, {
    "id": "5a5cb496e4b04e14d902a74d",
    "companyId": "59d8f906e4b0f393948831f2",
    "views": [{
        "viewId": 1,
        "name": {
            "en": "Restaurant"
        }
    }],
    "version": 1,
    "status": "created",
    "createdOn": "2018-01-15T14:03:02.880+0000",
    "createdBy": "5a5cb494e4b04e14d902a749",
    "modifiedOn": "2018-01-15T14:03:02.880+0000",
    "modifiedBy": "5a5cb494e4b04e14d902a749",
    "lastItemId": 1,
    "lastViewId": 1
}, {
    "id": "5a5cb4a4e4b04e14d902a758",
    "companyId": "59d8f906e4b0f393948831f2",
    "views": [{
        "viewId": 1,
        "name": {
            "en": "Restaurant"
        }
    }],
    "version": 2,
    "status": "created",
    "createdOn": "2018-01-15T14:03:15.998+0000",
    "createdBy": "5a5cb494e4b04e14d902a749",
    "modifiedOn": "2018-01-15T14:03:15.998+0000",
    "modifiedBy": "5a5cb494e4b04e14d902a749",
    "lastItemId": 1,
    "lastViewId": 0
}, {
    "id": "5a5cb4b1e4b04e14d902a763",
    "companyId": "59d8f906e4b0f393948831f2",
    "views": [{
        "viewId": 1,
        "name": {
            "en": "Restaurant"
        }
    }],
    "version": 3,
    "status": "created",
    "createdOn": "2018-01-15T14:03:29.352+0000",
    "createdBy": "5a5cb494e4b04e14d902a749",
    "modifiedOn": "2018-01-15T14:03:29.352+0000",
    "modifiedBy": "5a5cb494e4b04e14d902a749",
    "lastItemId": 0,
    "lastViewId": 0
}, {
    "id": "5a5cb621e4b04e14d902a78d",
    "companyId": "5a5c4e10e4b0f01cb2351552",
    "views": [{
        "viewId": 1,
        "name": {
            "en": "test"
        }
    }, {
        "viewId": 2,
        "name": {
            "en": "test1"
        }
    }],
    "version": 1,
    "status": "created",
    "createdOn": "2018-01-15T14:09:37.470+0000",
    "createdBy": "5a5ca8c8e4b04e14d902a695",
    "modifiedOn": "2018-01-15T14:09:37.470+0000",
    "modifiedBy": "5a5ca8c8e4b04e14d902a695",
    "lastItemId": 1,
    "lastViewId": 2
}, {
    "id": "5a5cbc0de4b04e14d902a7bc",
    "companyId": "5a5c4e10e4b0f01cb2351552",
    "views": [{
        "viewId": 1,
        "name": {
            "en": "test"
        }
    }, {
        "viewId": 3,
        "name": {
            "en": "test2"
        }
    }],
    "version": 2,
    "status": "created",
    "createdOn": "2018-01-15T14:34:53.460+0000",
    "createdBy": "5a5ca8c8e4b04e14d902a695",
    "modifiedOn": "2018-01-15T14:34:53.460+0000",
    "modifiedBy": "5a5ca8c8e4b04e14d902a695",
    "lastItemId": 1,
    "lastViewId": 3
}, {
    "id": "5a5cbc1de4b04e14d902a7c7",
    "companyId": "5a5c4e10e4b0f01cb2351552",
    "views": [{
        "viewId": 1,
        "name": {
            "en": "test"
        }
    }],
    "version": 3,
    "status": "created",
    "createdOn": "2018-01-15T14:35:09.230+0000",
    "createdBy": "5a5ca8c8e4b04e14d902a695",
    "modifiedOn": "2018-01-15T14:35:09.230+0000",
    "modifiedBy": "5a5ca8c8e4b04e14d902a695",
    "lastItemId": 1,
    "lastViewId": 3
}, {
    "id": "5a5cc07fe4b04e14d902a7f3",
    "companyId": "59d8f906e4b0f393948831f2",
    "views": [{
        "viewId": 1,
        "name": {
            "en": "Restaurant"
        }
    }],
    "version": 4,
    "status": "created",
    "createdOn": "2018-01-15T14:53:51.833+0000",
    "createdBy": "5a5cbfb5e4b04e14d902a7d8",
    "modifiedOn": "2018-01-15T14:53:51.833+0000",
    "modifiedBy": "5a5cbfb5e4b04e14d902a7d8",
    "lastItemId": 0,
    "lastViewId": 0
}, {
    "id": "5a5cc40ee4b04e14d902a7fe",
    "companyId": "59d8f906e4b0f393948831f2",
    "views": [{
        "viewId": 1,
        "name": {
            "en": "Restaurant"
        }
    }],
    "version": 5,
    "status": "created",
    "createdOn": "2018-01-15T15:09:02.174+0000",
    "createdBy": "5a5cbfb5e4b04e14d902a7d8",
    "modifiedOn": "2018-01-15T15:09:02.174+0000",
    "modifiedBy": "5a5cbfb5e4b04e14d902a7d8",
    "lastItemId": 1,
    "lastViewId": 0
}, {
    "id": "5a5cc45ae4b04e14d902a809",
    "companyId": "59d8f906e4b0f393948831f2",
    "views": [{
        "viewId": 1,
        "name": {
            "en": "Restaurant"
        }
    }],
    "version": 6,
    "status": "created",
    "createdOn": "2018-01-15T15:10:18.956+0000",
    "createdBy": "5a5cbfb5e4b04e14d902a7d8",
    "modifiedOn": "2018-01-15T15:10:18.956+0000",
    "modifiedBy": "5a5cbfb5e4b04e14d902a7d8",
    "lastItemId": 2,
    "lastViewId": 0
}, {
    "id": "5a5cc4e8e4b04e14d902a820",
    "companyId": "59d8f906e4b0f393948831f2",
    "views": [{
        "viewId": 1,
        "name": {
            "en": "Restaurant"
        }
    }],
    "version": 7,
    "status": "created",
    "createdOn": "2018-01-15T15:12:40.052+0000",
    "createdBy": "5a5cbfb5e4b04e14d902a7d8",
    "modifiedOn": "2018-01-15T15:12:40.052+0000",
    "modifiedBy": "5a5cbfb5e4b04e14d902a7d8",
    "lastItemId": 4,
    "lastViewId": 0
}, {
    "id": "5a5cc518e4b04e14d902a82b",
    "companyId": "59d8f906e4b0f393948831f2",
    "views": [{
        "viewId": 1,
        "name": {
            "en": "Restaurant"
        }
    }],
    "version": 8,
    "status": "created",
    "createdOn": "2018-01-15T15:13:28.220+0000",
    "createdBy": "5a5cbfb5e4b04e14d902a7d8",
    "modifiedOn": "2018-01-15T15:13:28.220+0000",
    "modifiedBy": "5a5cbfb5e4b04e14d902a7d8",
    "lastItemId": 4,
    "lastViewId": 0
}, {
    "id": "5a5ce5b2e4b04e14d902a890",
    "companyId": "59d8f906e4b0f393948831f2",
    "views": [{
        "viewId": 1,
        "name": {
            "en": "Restaurant"
        }
    }],
    "version": 9,
    "status": "created",
    "createdOn": "2018-01-15T17:32:34.810+0000",
    "createdBy": "5a5ce532e4b04e14d902a885",
    "modifiedOn": "2018-01-15T17:32:34.810+0000",
    "modifiedBy": "5a5ce532e4b04e14d902a885",
    "lastItemId": 4,
    "lastViewId": 0
}, {
    "id": "5a5cfc7de4b04e14d902a948",
    "companyId": "59dcd421e4b0bc51008ea0dc",
    "views": [{
        "viewId": 1,
        "name": {
            "de": "Online Bestellung 11",
            "en": "online order 11"
        }
    }, {
        "viewId": 2,
        "name": {
            "de": "Restaurant",
            "en": "Restaurant"
        }
    }, {
        "viewId": 3,
        "name": {
            "de": "Mittagsmenü",
            "en": "Lunch menu"
        }
    }, {
        "viewId": 4,
        "name": {
            "de": "Abholtheke",
            "en": "Take away"
        }
    }],
    "version": 16,
    "status": "created",
    "createdOn": "2018-01-15T19:09:49.433+0000",
    "createdBy": "5a5ceb66e4b04e14d902a8d5",
    "modifiedOn": "2018-01-15T19:09:49.433+0000",
    "modifiedBy": "5a5ceb66e4b04e14d902a8d5",
    "lastItemId": 0,
    "lastViewId": 0
}, {
    "id": "5a5df82ce4b04e14d902ab3c",
    "companyId": "59dcd421e4b0bc51008ea0dc",
    "views": [{
        "viewId": 1,
        "name": {
            "de": "Online Bestellung",
            "en": "online order"
        }
    }, {
        "viewId": 2,
        "name": {
            "de": "Restaurant",
            "en": "Restaurant"
        }
    }, {
        "viewId": 3,
        "name": {
            "de": "Mittagsmenü",
            "en": "Lunch menu"
        }
    }, {
        "viewId": 4,
        "name": {
            "de": "Abholtheke",
            "en": "Take away"
        }
    }],
    "version": 18,
    "status": "created",
    "createdOn": "2018-01-16T13:03:40.110+0000",
    "createdBy": "5a5def39e4b04e14d902aac9",
    "modifiedOn": "2018-01-16T13:03:40.110+0000",
    "modifiedBy": "5a5def39e4b04e14d902aac9",
    "lastItemId": 225,
    "lastViewId": 4
}, {
    "id": "5a5df824e4b04e14d902ab35",
    "companyId": "59dcd421e4b0bc51008ea0dc",
    "views": [{
        "viewId": 1,
        "name": {
            "en": "Restaurant"
        }
    }],
    "version": 17,
    "status": "created",
    "createdOn": "2018-01-16T13:03:32.640+0000",
    "createdBy": "5a5df0a0e4b04e14d902aaed",
    "modifiedOn": "2018-01-16T13:03:32.640+0000",
    "modifiedBy": "5a5df0a0e4b04e14d902aaed",
    "lastItemId": 225,
    "lastViewId": 4
}, {
    "id": "5a5df887e4b04e14d902ab59",
    "companyId": "59dcd421e4b0bc51008ea0dc",
    "views": [{
        "viewId": 1,
        "name": {
            "de": "Online Bestellung",
            "en": "online order"
        }
    }, {
        "viewId": 2,
        "name": {
            "de": "Restaurant",
            "en": "Restaurant"
        }
    }, {
        "viewId": 3,
        "name": {
            "de": "Mittagsmenü",
            "en": "Lunch menu"
        }
    }, {
        "viewId": 4,
        "name": {
            "de": "Abholtheke",
            "en": "Take away"
        }
    }],
    "version": 19,
    "status": "created",
    "createdOn": "2018-01-16T13:05:11.622+0000",
    "createdBy": "5a5df0a0e4b04e14d902aaed",
    "modifiedOn": "2018-01-16T13:05:11.622+0000",
    "modifiedBy": "5a5df0a0e4b04e14d902aaed",
    "lastItemId": 225,
    "lastViewId": 4
}, {
    "id": "5a5e1463e4b04e14d902ac8f",
    "oosCompanyId": 0,
    "companyId": "59dcd421e4b0bc51008ea0dc",
    "views": [{
        "viewId": 1,
        "name": {
            "en": "Restaurant"
        }
    }],
    "version": 20,
    "status": "created",
    "createdOn": "2018-01-16T15:04:03.018+0000",
    "createdBy": "5a5df0a0e4b04e14d902aaed",
    "modifiedOn": "2018-01-16T15:04:03.018+0000",
    "modifiedBy": "5a5df0a0e4b04e14d902aaed",
    "lastItemId": 2,
    "lastViewId": 4
}, {
    "id": "5a5e8b40e4b04e14d902ad1d",
    "companyId": "59dcd421e4b0bc51008ea0dc",
    "views": [{
        "viewId": 1,
        "name": {
            "en": "Restaurant"
        }
    }],
    "version": 21,
    "status": "created",
    "createdOn": "2018-01-16T23:31:12.022+0000",
    "createdBy": "5a5e8855e4b04e14d902ad04",
    "modifiedOn": "2018-01-16T23:31:12.022+0000",
    "modifiedBy": "5a5e8855e4b04e14d902ad04",
    "lastItemId": 2,
    "lastViewId": 4
}, {
    "id": "5a5e8bfde4b04e14d902ad28",
    "companyId": "59dcd421e4b0bc51008ea0dc",
    "views": [{
        "viewId": 1,
        "name": {
            "en": "Restaurant"
        }
    }],
    "version": 22,
    "status": "created",
    "createdOn": "2018-01-16T23:34:21.628+0000",
    "createdBy": "5a5e8855e4b04e14d902ad04",
    "modifiedOn": "2018-01-16T23:34:21.628+0000",
    "modifiedBy": "5a5e8855e4b04e14d902ad04",
    "lastItemId": 2,
    "lastViewId": 4
}, {
    "id": "5a5e8cc9e4b04e14d902ad33",
    "companyId": "59dcd421e4b0bc51008ea0dc",
    "views": [{
        "viewId": 1,
        "name": {
            "en": "Restaurant"
        }
    }],
    "version": 23,
    "status": "created",
    "createdOn": "2018-01-16T23:37:45.241+0000",
    "createdBy": "5a5e8855e4b04e14d902ad04",
    "modifiedOn": "2018-01-16T23:37:45.241+0000",
    "modifiedBy": "5a5e8855e4b04e14d902ad04",
    "lastItemId": 2,
    "lastViewId": 4
}, {
    "id": "5a5e8d37e4b04e14d902ad3e",
    "companyId": "59dcd421e4b0bc51008ea0dc",
    "views": [{
        "viewId": 1,
        "name": {
            "en": "Restaurant"
        }
    }],
    "version": 24,
    "status": "created",
    "createdOn": "2018-01-16T23:39:35.160+0000",
    "createdBy": "5a5e8855e4b04e14d902ad04",
    "modifiedOn": "2018-01-16T23:39:35.160+0000",
    "modifiedBy": "5a5e8855e4b04e14d902ad04",
    "lastItemId": 2,
    "lastViewId": 4
}, {
    "id": "5a5e8ddee4b04e14d902ad51",
    "companyId": "59dcd421e4b0bc51008ea0dc",
    "views": [{
        "viewId": 1,
        "name": {
            "en": "Restaurant"
        }
    }],
    "version": 25,
    "status": "created",
    "createdOn": "2018-01-16T23:42:22.691+0000",
    "createdBy": "5a5e8855e4b04e14d902ad04",
    "modifiedOn": "2018-01-16T23:42:22.691+0000",
    "modifiedBy": "5a5e8855e4b04e14d902ad04",
    "lastItemId": 2,
    "lastViewId": 4
}, {
    "id": "5a5e8eb8e4b04e14d902ad5c",
    "companyId": "59dcd421e4b0bc51008ea0dc",
    "views": [{
        "viewId": 1,
        "name": {
            "en": "Restaurant"
        }
    }],
    "version": 26,
    "status": "created",
    "createdOn": "2018-01-16T23:46:00.408+0000",
    "createdBy": "5a5e8855e4b04e14d902ad04",
    "modifiedOn": "2018-01-16T23:46:00.408+0000",
    "modifiedBy": "5a5e8855e4b04e14d902ad04",
    "lastItemId": 2,
    "lastViewId": 4
}, {
    "id": "5a5f1e1ee4b04e14d902ae3d",
    "companyId": "59dcd421e4b0bc51008ea0dc",
    "views": [{
        "viewId": 1,
        "name": {
            "en": "Restaurant"
        }
    }],
    "version": 27,
    "status": "created",
    "createdOn": "2018-01-17T09:57:50.943+0000",
    "createdBy": "5a5f1c45e4b04e14d902ae1a",
    "modifiedOn": "2018-01-17T09:57:50.943+0000",
    "modifiedBy": "5a5f1c45e4b04e14d902ae1a",
    "lastItemId": 302,
    "lastViewId": 1
}, {
    "id": "5a5f1f8be4b04e14d902ae62",
    "companyId": "59dcd421e4b0bc51008ea0dc",
    "views": [{
        "viewId": 1,
        "name": {
            "en": "Restaurant"
        }
    }],
    "version": 28,
    "status": "created",
    "createdOn": "2018-01-17T10:03:55.578+0000",
    "createdBy": "5a5f1c45e4b04e14d902ae1a",
    "modifiedOn": "2018-01-17T10:03:55.578+0000",
    "modifiedBy": "5a5f1c45e4b04e14d902ae1a",
    "lastItemId": 302,
    "lastViewId": 1
}, {
    "id": "5a5f5186e4b04e14d902aefb",
    "companyId": "5a57c093e4b06683979bf4a7",
    "views": [{
        "viewId": 1,
        "name": {
            "en": "Restaurant"
        }
    }],
    "version": 1,
    "status": "created",
    "createdOn": "2018-01-17T13:37:10.699+0000",
    "createdBy": "5a5f5016e4b04e14d902aec8",
    "modifiedOn": "2018-01-17T13:37:10.699+0000",
    "modifiedBy": "5a5f5016e4b04e14d902aec8",
    "lastItemId": 302,
    "lastViewId": 1
}, {
    "id": "5a5f5240e4b04e14d902af0c",
    "companyId": "5a57c093e4b06683979bf4a7",
    "views": [{
        "viewId": 1,
        "name": {
            "en": "Restaurant"
        }
    }],
    "version": 2,
    "status": "inactive",
    "createdOn": "2018-01-17T13:40:16.898+0000",
    "createdBy": "5a5f5016e4b04e14d902aec8",
    "modifiedOn": "2018-01-17T14:19:13.930+0000",
    "modifiedBy": "5a5f545ee4b04e14d902af5a",
    "lastItemId": 302,
    "lastViewId": 1
}, {
    "id": "5a5f55cde4b04e14d902af82",
    "companyId": "5a57c093e4b06683979bf4a7",
    "views": [{
        "viewId": 1,
        "name": {
            "en": "Restaurant"
        }
    }, {
        "viewId": 2,
        "name": {
            "en": "Take awy"
        }
    }, {
        "viewId": 3,
        "name": {
            "en": "Drinks"
        }
    }],
    "version": 3,
    "status": "created",
    "createdOn": "2018-01-17T13:55:25.960+0000",
    "createdBy": "5a5f545ee4b04e14d902af5a",
    "modifiedOn": "2018-01-17T13:55:25.960+0000",
    "modifiedBy": "5a5f545ee4b04e14d902af5a",
    "lastItemId": 302,
    "lastViewId": 3
}, {
    "id": "5a5f56a4e4b04e14d902af9b",
    "companyId": "5a57c093e4b06683979bf4a7",
    "views": [{
        "viewId": 1,
        "name": {
            "en": "Restaurant"
        }
    }, {
        "viewId": 2,
        "name": {
            "en": "Take awy"
        }
    }, {
        "viewId": 3,
        "name": {
            "en": "Drinks"
        }
    }],
    "version": 4,
    "status": "created",
    "createdOn": "2018-01-17T13:59:00.061+0000",
    "createdBy": "5a5f545ee4b04e14d902af5a",
    "modifiedOn": "2018-01-17T13:59:00.061+0000",
    "modifiedBy": "5a5f545ee4b04e14d902af5a",
    "lastItemId": 302,
    "lastViewId": 3
}, {
    "id": "5a5f58dbe4b04e14d902afb3",
    "companyId": "5a57c093e4b06683979bf4a7",
    "views": [{
        "viewId": 1,
        "name": {
            "en": "Restaurant"
        }
    }, {
        "viewId": 4,
        "name": {
            "en": "Take away"
        }
    }, {
        "viewId": 3,
        "name": {
            "en": "Drinks"
        }
    }],
    "version": 5,
    "status": "created",
    "createdOn": "2018-01-17T14:08:27.224+0000",
    "createdBy": "5a5f578fe4b04e14d902afa8",
    "modifiedOn": "2018-01-17T14:08:27.224+0000",
    "modifiedBy": "5a5f578fe4b04e14d902afa8",
    "lastItemId": 302,
    "lastViewId": 3
}, {
    "id": "5a5f594fe4b04e14d902afbf",
    "companyId": "5a57c093e4b06683979bf4a7",
    "views": [{
        "viewId": 1,
        "name": {
            "en": "Restaurant"
        }
    }, {
        "viewId": 2,
        "name": {
            "en": "Take awy"
        }
    }, {
        "viewId": 3,
        "name": {
            "en": "Drinks"
        }
    }],
    "version": 6,
    "status": "inactive",
    "createdOn": "2018-01-17T14:10:23.587+0000",
    "createdBy": "5a5f545ee4b04e14d902af5a",
    "modifiedOn": "2018-01-17T15:13:09.684+0000",
    "modifiedBy": "5a5f545ee4b04e14d902af5a",
    "lastItemId": 302,
    "lastViewId": 3
}, {
    "id": "5a5f5c17e4b04e14d902afe5",
    "companyId": "5a57c093e4b06683979bf4a7",
    "views": [{
        "viewId": 1,
        "name": {
            "en": "Restaurant"
        }
    }, {
        "viewId": 2,
        "name": {
            "en": "Take awy"
        }
    }, {
        "viewId": 3,
        "name": {
            "en": "Drinks"
        }
    }],
    "version": 7,
    "status": "created",
    "createdOn": "2018-01-17T14:22:15.775+0000",
    "createdBy": "5a5f545ee4b04e14d902af5a",
    "modifiedOn": "2018-01-17T14:22:15.775+0000",
    "modifiedBy": "5a5f545ee4b04e14d902af5a",
    "lastItemId": 302,
    "lastViewId": 3
}, {
    "id": "5a5f5da3e4b04e14d902aff6",
    "companyId": "59dcd421e4b0bc51008ea0dc",
    "views": [{
        "name": {
            "de": "Online Bestellung",
            "en": "online order"
        }
    }, {
        "name": {
            "de": "Restaurant",
            "en": "Restaurant"
        }
    }, {
        "name": {
            "de": "Mittagsmenü",
            "en": "Lunch menu"
        }
    }, {
        "name": {
            "de": "Abholtheke",
            "en": "Take away"
        }
    }],
    "version": 29,
    "status": "created",
    "createdOn": "2018-01-17T14:28:51.664+0000",
    "createdBy": "5a5f04a8e4b04e14d902ad99",
    "modifiedOn": "2018-01-17T14:28:51.664+0000",
    "modifiedBy": "5a5f04a8e4b04e14d902ad99",
    "lastItemId": 2,
    "lastViewId": 4
}, {
    "id": "5a5f67dfe4b04e14d902b019",
    "companyId": "5a57c093e4b06683979bf4a7",
    "views": [{
        "viewId": 1,
        "name": {
            "en": "Restaurant"
        }
    }, {
        "viewId": 2,
        "name": {
            "en": "Take awy"
        }
    }, {
        "viewId": 3,
        "name": {
            "en": "Drinks"
        }
    }],
    "version": 8,
    "status": "inactive",
    "createdOn": "2018-01-17T15:12:31.621+0000",
    "createdBy": "5a5f545ee4b04e14d902af5a",
    "modifiedOn": "2018-01-17T22:47:50.296+0000",
    "modifiedBy": "5a5fce32e4b04e14d902b2c3",
    "lastItemId": 317,
    "lastViewId": 3
}, {
    "id": "5a5f6fc7e4b04e14d902b057",
    "companyId": "59dcd421e4b0bc51008ea0dc",
    "views": [{
        "name": {
            "de": "Online Bestellung",
            "en": "online order"
        }
    }, {
        "name": {
            "de": "Restaurant",
            "en": "Restaurant"
        }
    }, {
        "name": {
            "de": "Mittagsmenü",
            "en": "Lunch menu"
        }
    }, {
        "name": {
            "de": "Abholtheke",
            "en": "Take away"
        }
    }],
    "version": 30,
    "status": "created",
    "createdOn": "2018-01-17T15:46:15.780+0000",
    "createdBy": "5a5f69b6e4b04e14d902b035",
    "modifiedOn": "2018-01-17T15:46:15.780+0000",
    "modifiedBy": "5a5f69b6e4b04e14d902b035",
    "lastItemId": 2,
    "lastViewId": 4
}, {
    "id": "5a5f6fe4e4b04e14d902b05a",
    "companyId": "59dcd421e4b0bc51008ea0dc",
    "views": [{
        "viewId": 1,
        "name": {
            "de": "Online Bestellung",
            "en": "online order"
        }
    }, {
        "viewId": 2,
        "name": {
            "de": "Restaurant",
            "en": "Restaurant"
        }
    }, {
        "viewId": 3,
        "name": {
            "de": "Mittagsmenü",
            "en": "Lunch menu"
        }
    }, {
        "viewId": 4,
        "name": {
            "de": "Abholtheke",
            "en": "Take away"
        }
    }],
    "version": 31,
    "status": "created",
    "createdOn": "2018-01-17T15:46:44.464+0000",
    "createdBy": "5a5f69b6e4b04e14d902b035",
    "modifiedOn": "2018-01-17T15:46:44.464+0000",
    "modifiedBy": "5a5f69b6e4b04e14d902b035",
    "lastItemId": 2,
    "lastViewId": 4
}, {
    "id": "5a5f70ade4b04e14d902b065",
    "companyId": "59dcd421e4b0bc51008ea0dc",
    "views": [{
        "viewId": 1,
        "name": {
            "de": "Online Bestellung",
            "en": "online order"
        }
    }, {
        "viewId": 2,
        "name": {
            "de": "Restaurant",
            "en": "Restaurant"
        }
    }, {
        "viewId": 3,
        "name": {
            "de": "Mittagsmenü",
            "en": "Lunch menu"
        }
    }, {
        "viewId": 4,
        "name": {
            "de": "Abholtheke",
            "en": "Take away"
        }
    }],
    "version": 32,
    "status": "created",
    "createdOn": "2018-01-17T15:50:05.867+0000",
    "createdBy": "5a5f69b6e4b04e14d902b035",
    "modifiedOn": "2018-01-17T15:50:05.867+0000",
    "modifiedBy": "5a5f69b6e4b04e14d902b035",
    "lastItemId": 2,
    "lastViewId": 4
}, {
    "id": "5a5f70b9e4b04e14d902b068",
    "companyId": "59dcd421e4b0bc51008ea0dc",
    "views": [{
        "viewId": 1,
        "name": {
            "de": "Online Bestellung",
            "en": "online order"
        }
    }, {
        "viewId": 2,
        "name": {
            "de": "Restaurant",
            "en": "Restaurant"
        }
    }, {
        "viewId": 3,
        "name": {
            "de": "Mittagsmenü",
            "en": "Lunch menu"
        }
    }, {
        "viewId": 4,
        "name": {
            "de": "Abholtheke",
            "en": "Take away"
        }
    }],
    "version": 33,
    "status": "created",
    "createdOn": "2018-01-17T15:50:17.919+0000",
    "createdBy": "5a5f69b6e4b04e14d902b035",
    "modifiedOn": "2018-01-17T15:50:17.919+0000",
    "modifiedBy": "5a5f69b6e4b04e14d902b035",
    "lastItemId": 2,
    "lastViewId": 4
}, {
    "id": "5a5f77a5e4b04e14d902b0b8",
    "companyId": "59c4f7b807587a0a5192cba2",
    "views": [{
        "viewId": 1,
        "name": {
            "en": "aaa"
        }
    }],
    "version": 9,
    "status": "created",
    "createdOn": "2018-01-17T16:19:49.116+0000",
    "createdBy": "5a5f69b6e4b04e14d902b035",
    "modifiedOn": "2018-01-17T16:19:49.116+0000",
    "modifiedBy": "5a5f69b6e4b04e14d902b035",
    "lastItemId": 1,
    "lastViewId": 1
}, {
    "id": "5a5f7dfde4b04e14d902b124",
    "companyId": "59dcd421e4b0bc51008ea0dc",
    "views": [{
        "viewId": 1,
        "name": {
            "de": "Online Bestellung",
            "en": "online order"
        }
    }, {
        "viewId": 2,
        "name": {
            "de": "Restaurant",
            "en": "Restaurant"
        }
    }, {
        "viewId": 3,
        "name": {
            "de": "Mittagsmenü",
            "en": "Lunch menu"
        }
    }, {
        "viewId": 4,
        "name": {
            "de": "Abholtheke",
            "en": "Take away"
        }
    }],
    "version": 34,
    "status": "created",
    "createdOn": "2018-01-17T16:46:53.042+0000",
    "createdBy": "5a5f69b6e4b04e14d902b035",
    "modifiedOn": "2018-01-17T16:46:53.042+0000",
    "modifiedBy": "5a5f69b6e4b04e14d902b035",
    "lastItemId": 2,
    "lastViewId": 4
}, {
    "id": "5a5f7e51e4b04e14d902b135",
    "companyId": "59c4f7b807587a0a5192cba2",
    "views": [{
        "viewId": 1,
        "name": {
            "en": "aaaa"
        }
    }, {
        "viewId": 2,
        "name": {
            "en": "ddddd"
        }
    }],
    "version": 10,
    "status": "created",
    "createdOn": "2018-01-17T16:48:17.790+0000",
    "createdBy": "5a5f69b6e4b04e14d902b035",
    "modifiedOn": "2018-01-17T16:48:17.790+0000",
    "modifiedBy": "5a5f69b6e4b04e14d902b035",
    "lastItemId": 1,
    "lastViewId": 2
}, {
    "id": "5a5f8228e4b04e14d902b14e",
    "companyId": "59c4f7b807587a0a5192cba2",
    "views": [{
        "viewId": 1,
        "name": {
            "en": "aaaa"
        }
    }, {
        "viewId": 2,
        "name": {
            "en": "bbbb"
        }
    }],
    "version": 11,
    "status": "created",
    "createdOn": "2018-01-17T17:04:40.183+0000",
    "createdBy": "5a5f69b6e4b04e14d902b035",
    "modifiedOn": "2018-01-17T17:04:40.183+0000",
    "modifiedBy": "5a5f69b6e4b04e14d902b035",
    "lastItemId": 2,
    "lastViewId": 2
}, {
    "id": "5a5f89a8e4b04e14d902b178",
    "companyId": "5a57c093e4b06683979bf4a7",
    "views": [{
        "viewId": 1,
        "name": {
            "en": "Restaurant"
        }
    }, {
        "viewId": 2,
        "name": {
            "en": "Take awy"
        }
    }, {
        "viewId": 3,
        "name": {
            "en": "Drinks"
        }
    }],
    "version": 9,
    "status": "created",
    "createdOn": "2018-01-17T17:36:40.588+0000",
    "createdBy": "5a5f545ee4b04e14d902af5a",
    "modifiedOn": "2018-01-17T17:36:40.588+0000",
    "modifiedBy": "5a5f545ee4b04e14d902af5a",
    "lastItemId": 317,
    "lastViewId": 3
}, {
    "id": "5a5f89b4e4b04e14d902b183",
    "companyId": "5a57c093e4b06683979bf4a7",
    "views": [{
        "viewId": 1,
        "name": {
            "en": "Restaurant"
        }
    }, {
        "viewId": 2,
        "name": {
            "en": "Take awy"
        }
    }, {
        "viewId": 3,
        "name": {
            "en": "Drinks"
        }
    }],
    "version": 10,
    "status": "created",
    "createdOn": "2018-01-17T17:36:52.389+0000",
    "createdBy": "5a5f545ee4b04e14d902af5a",
    "modifiedOn": "2018-01-17T17:36:52.389+0000",
    "modifiedBy": "5a5f545ee4b04e14d902af5a",
    "lastItemId": 317,
    "lastViewId": 3
}, {
    "id": "5a5f8bdee4b04e14d902b1af",
    "companyId": "59dcd421e4b0bc51008ea0dc",
    "views": [{
        "viewId": 1,
        "name": {
            "de": "Online Bestellung",
            "en": "online order"
        }
    }, {
        "viewId": 2,
        "name": {
            "de": "Restaurant",
            "en": "Restaurant"
        }
    }, {
        "viewId": 3,
        "name": {
            "de": "Mittagsmenü",
            "en": "Lunch menu"
        }
    }, {
        "viewId": 4,
        "name": {
            "de": "Abholtheke",
            "en": "Take away"
        }
    }],
    "version": 35,
    "status": "created",
    "createdOn": "2018-01-17T17:46:06.735+0000",
    "createdBy": "5a5f69b6e4b04e14d902b035",
    "modifiedOn": "2018-01-17T17:46:06.735+0000",
    "modifiedBy": "5a5f69b6e4b04e14d902b035",
    "lastItemId": 2,
    "lastViewId": 4
}, {
    "id": "5a5f8c36e4b04e14d902b1c4",
    "companyId": "59c4f7b807587a0a5192cba2",
    "views": [{
        "viewId": 1,
        "name": {
            "en": "dsadsadsa"
        }
    }],
    "version": 12,
    "status": "created",
    "createdOn": "2018-01-17T17:47:34.229+0000",
    "createdBy": "5a5f69b6e4b04e14d902b035",
    "modifiedOn": "2018-01-17T17:47:34.229+0000",
    "modifiedBy": "5a5f69b6e4b04e14d902b035",
    "lastItemId": 1,
    "lastViewId": 1
}, {
    "id": "5a5f8c42e4b04e14d902b1cf",
    "companyId": "59c4f7b807587a0a5192cba2",
    "views": [{
        "viewId": 1,
        "name": {
            "en": "dsadsadsa"
        }
    }],
    "version": 13,
    "status": "created",
    "createdOn": "2018-01-17T17:47:46.011+0000",
    "createdBy": "5a5f69b6e4b04e14d902b035",
    "modifiedOn": "2018-01-17T17:47:46.011+0000",
    "modifiedBy": "5a5f69b6e4b04e14d902b035",
    "lastItemId": 1,
    "lastViewId": 1
}, {
    "id": "5a5f946ee4b04e14d902b201",
    "companyId": "5a57c093e4b06683979bf4a7",
    "views": [{
        "viewId": 1,
        "name": {
            "en": "Restaurant"
        }
    }, {
        "viewId": 2,
        "name": {
            "en": "Take awy"
        }
    }, {
        "viewId": 3,
        "name": {
            "en": "Drinks"
        }
    }],
    "version": 11,
    "status": "created",
    "createdOn": "2018-01-17T18:22:38.135+0000",
    "createdBy": "5a5f9112e4b04e14d902b1d5",
    "modifiedOn": "2018-01-17T18:22:38.135+0000",
    "modifiedBy": "5a5f9112e4b04e14d902b1d5",
    "lastItemId": 317,
    "lastViewId": 3
}, {
    "id": "5a5f9a31e4b04e14d902b224",
    "companyId": "5a57c093e4b06683979bf4a7",
    "views": [{
        "viewId": 1,
        "name": {
            "en": "Restaurant"
        }
    }, {
        "viewId": 2,
        "name": {
            "en": "Take awy"
        }
    }, {
        "viewId": 3,
        "name": {
            "en": "Drinks"
        }
    }],
    "version": 12,
    "status": "created",
    "createdOn": "2018-01-17T18:47:13.256+0000",
    "createdBy": "5a5f9112e4b04e14d902b1d5",
    "modifiedOn": "2018-01-17T18:47:13.256+0000",
    "modifiedBy": "5a5f9112e4b04e14d902b1d5",
    "lastItemId": 317,
    "lastViewId": 3
}, {
    "id": "5a5f9a73e4b04e14d902b231",
    "companyId": "5a57c093e4b06683979bf4a7",
    "views": [{
        "viewId": 1,
        "name": {
            "en": "Restaurant"
        }
    }, {
        "viewId": 2,
        "name": {
            "en": "Take awy"
        }
    }, {
        "viewId": 3,
        "name": {
            "en": "Drinks"
        }
    }],
    "version": 13,
    "status": "created",
    "createdOn": "2018-01-17T18:48:19.645+0000",
    "createdBy": "5a5f9112e4b04e14d902b1d5",
    "modifiedOn": "2018-01-17T18:48:19.645+0000",
    "modifiedBy": "5a5f9112e4b04e14d902b1d5",
    "lastItemId": 318,
    "lastViewId": 3
}, {
    "id": "5a5f9b04e4b04e14d902b23c",
    "companyId": "5a57c093e4b06683979bf4a7",
    "views": [{
        "viewId": 1,
        "name": {
            "en": "Restaurant"
        }
    }, {
        "viewId": 2,
        "name": {
            "en": "Take awy"
        }
    }, {
        "viewId": 3,
        "name": {
            "en": "Drinks"
        }
    }],
    "version": 14,
    "status": "created",
    "createdOn": "2018-01-17T18:50:44.887+0000",
    "createdBy": "5a5f9112e4b04e14d902b1d5",
    "modifiedOn": "2018-01-17T18:50:44.887+0000",
    "modifiedBy": "5a5f9112e4b04e14d902b1d5",
    "lastItemId": 320,
    "lastViewId": 3
}, {
    "id": "5a5f9ba8e4b04e14d902b247",
    "companyId": "5a57c093e4b06683979bf4a7",
    "views": [{
        "viewId": 1,
        "name": {
            "en": "Restaurant"
        }
    }, {
        "viewId": 2,
        "name": {
            "en": "Take awy"
        }
    }, {
        "viewId": 3,
        "name": {
            "en": "Drinks"
        }
    }],
    "version": 15,
    "status": "created",
    "createdOn": "2018-01-17T18:53:28.456+0000",
    "createdBy": "5a5f9112e4b04e14d902b1d5",
    "modifiedOn": "2018-01-17T18:53:28.456+0000",
    "modifiedBy": "5a5f9112e4b04e14d902b1d5",
    "lastItemId": 323,
    "lastViewId": 3
}, {
    "id": "5a5f9cc0e4b04e14d902b252",
    "companyId": "5a57c093e4b06683979bf4a7",
    "views": [{
        "viewId": 1,
        "name": {
            "en": "Restaurant"
        }
    }, {
        "viewId": 2,
        "name": {
            "en": "Take awy"
        }
    }, {
        "viewId": 3,
        "name": {
            "en": "Drinks"
        }
    }],
    "version": 16,
    "status": "created",
    "createdOn": "2018-01-17T18:58:08.812+0000",
    "createdBy": "5a5f9112e4b04e14d902b1d5",
    "modifiedOn": "2018-01-17T18:58:08.812+0000",
    "modifiedBy": "5a5f9112e4b04e14d902b1d5",
    "lastItemId": 328,
    "lastViewId": 3
}, {
    "id": "5a5fa29de4b04e14d902b272",
    "companyId": "5a57c093e4b06683979bf4a7",
    "views": [{
        "viewId": 1,
        "name": {
            "en": "Restaurant"
        }
    }, {
        "viewId": 2,
        "name": {
            "en": "Take awy"
        }
    }, {
        "viewId": 3,
        "name": {
            "en": "Drinks"
        }
    }],
    "version": 17,
    "status": "created",
    "createdOn": "2018-01-17T19:23:09.104+0000",
    "createdBy": "5a5f9112e4b04e14d902b1d5",
    "modifiedOn": "2018-01-17T19:23:09.104+0000",
    "modifiedBy": "5a5f9112e4b04e14d902b1d5",
    "lastItemId": 328,
    "lastViewId": 3
}, {
    "id": "5a5fa395e4b04e14d902b27f",
    "companyId": "5a57c093e4b06683979bf4a7",
    "views": [{
        "viewId": 1,
        "name": {
            "en": "Restaurant"
        }
    }, {
        "viewId": 2,
        "name": {
            "en": "Take awy"
        }
    }, {
        "viewId": 3,
        "name": {
            "en": "Drinks"
        }
    }],
    "version": 18,
    "status": "created",
    "createdOn": "2018-01-17T19:27:17.800+0000",
    "createdBy": "5a5f9112e4b04e14d902b1d5",
    "modifiedOn": "2018-01-17T19:27:17.800+0000",
    "modifiedBy": "5a5f9112e4b04e14d902b1d5",
    "lastItemId": 330,
    "lastViewId": 3
}, {
    "id": "5a5fd288e4b04e14d902b2d7",
    "companyId": "5a57c093e4b06683979bf4a7",
    "views": [{
        "viewId": 1,
        "name": {
            "en": "Restaurant"
        }
    }, {
        "viewId": 2,
        "name": {
            "en": "Take awy"
        }
    }, {
        "viewId": 3,
        "name": {
            "en": "Drinks"
        }
    }],
    "version": 19,
    "status": "inactive",
    "createdOn": "2018-01-17T22:47:36.412+0000",
    "createdBy": "5a5fce32e4b04e14d902b2c3",
    "modifiedOn": "2018-01-17T22:50:58.065+0000",
    "modifiedBy": "5a5fce32e4b04e14d902b2c3",
    "lastItemId": 337,
    "lastViewId": 3
}, {
    "id": "5a5fd291e4b04e14d902b2e2",
    "companyId": "5a57c093e4b06683979bf4a7",
    "views": [{
        "viewId": 1,
        "name": {
            "en": "Restaurant"
        }
    }, {
        "viewId": 2,
        "name": {
            "en": "Take awy"
        }
    }, {
        "viewId": 3,
        "name": {
            "en": "Drinks"
        }
    }],
    "version": 20,
    "status": "inactive",
    "createdOn": "2018-01-17T22:47:45.785+0000",
    "createdBy": "5a5fce32e4b04e14d902b2c3",
    "modifiedOn": "2018-02-12T21:18:58.836+0000",
    "modifiedBy": "5a81e206e4b0379a14b54bd4",
    "lastItemId": 337,
    "lastViewId": 3
}, {
    "id": "5a60612fe4b04e14d902b33e",
    "companyId": "59c4f7b807587a0a5192cba2",
    "views": [{
        "name": {
            "en": "test"
        }
    }],
    "version": 14,
    "status": "created",
    "createdOn": "2018-01-18T08:56:15.257+0000",
    "createdBy": "5a605e18e4b04e14d902b31a",
    "modifiedOn": "2018-01-18T08:56:15.257+0000",
    "modifiedBy": "5a605e18e4b04e14d902b31a",
    "lastItemId": 1,
    "lastViewId": 0
}, {
    "id": "5a5df113e4b04e14d902aafc",
    "companyId": "59c8fe13e4b085e2cd4c6d59",
    "views": [{
        "viewId": 1,
        "name": {
            "en": "Restaurant"
        }
    }, {
        "viewId": 2,
        "name": {
            "en": "Take awy"
        }
    }, {
        "viewId": 3,
        "name": {
            "en": "Drinks"
        }
    }],
    "version": 11,
    "status": "inactive",
    "createdOn": "2018-01-16T12:33:23.334+0000",
    "createdBy": "5a5df0a0e4b04e14d902aaed",
    "modifiedOn": "2018-01-19T15:35:57.720+0000",
    "modifiedBy": "5a621004e4b04e14d902b7cf",
    "lastItemId": 0,
    "lastViewId": 0
}, {
    "id": "5a60a68ae4b04e14d902b3e3",
    "companyId": "59c8fe13e4b085e2cd4c6d59",
    "views": [{
        "viewId": 1,
        "name": {
            "en": "Restaurant"
        }
    }, {
        "viewId": 2,
        "name": {
            "en": "Take awy"
        }
    }, {
        "viewId": 3,
        "name": {
            "en": "Drinks"
        }
    }],
    "version": 12,
    "status": "created",
    "createdOn": "2018-01-18T13:52:10.904+0000",
    "createdBy": "5a60a656e4b04e14d902b3d8",
    "modifiedOn": "2018-01-18T13:52:10.904+0000",
    "modifiedBy": "5a60a656e4b04e14d902b3d8",
    "lastItemId": 337,
    "lastViewId": 3
}, {
    "id": "5a60a70ee4b04e14d902b3f8",
    "companyId": "59c4f7b807587a0a5192cba2",
    "views": [{
        "viewId": 1,
        "name": {
            "en": "a"
        }
    }],
    "version": 15,
    "status": "created",
    "createdOn": "2018-01-18T13:54:22.300+0000",
    "createdBy": "5a60a656e4b04e14d902b3d8",
    "modifiedOn": "2018-01-18T13:54:22.300+0000",
    "modifiedBy": "5a60a656e4b04e14d902b3d8",
    "lastItemId": 1,
    "lastViewId": 1
}, {
    "id": "5a60bffde4b04e14d902b435",
    "companyId": "59c4f7b807587a0a5192cba2",
    "views": [{
        "viewId": 1,
        "name": {
            "en": "aaaa"
        }
    }],
    "version": 16,
    "status": "created",
    "createdOn": "2018-01-18T15:40:45.643+0000",
    "createdBy": "5a605e18e4b04e14d902b31a",
    "modifiedOn": "2018-01-18T15:40:45.643+0000",
    "modifiedBy": "5a605e18e4b04e14d902b31a",
    "lastItemId": 1,
    "lastViewId": 1
}, {
    "id": "5a621048e4b04e14d902b7e2",
    "companyId": "59c8fe13e4b085e2cd4c6d59",
    "views": [{
        "viewId": 1,
        "name": {
            "en": "a"
        }
    }],
    "version": 13,
    "status": "active",
    "createdOn": "2018-01-19T15:35:36.132+0000",
    "createdBy": "5a621004e4b04e14d902b7cf",
    "modifiedOn": "2018-01-19T15:35:57.694+0000",
    "modifiedBy": "59d224d88d60691acf763dba",
    "lastItemId": 0,
    "lastViewId": 0
}, {
    "id": "5a621056e4b04e14d902b7ed",
    "companyId": "59c4f7b807587a0a5192cba2",
    "views": [{
        "viewId": 1,
        "name": {
            "en": "a"
        }
    }],
    "version": 17,
    "status": "created",
    "createdOn": "2018-01-19T15:35:50.970+0000",
    "createdBy": "5a621004e4b04e14d902b7cf",
    "modifiedOn": "2018-01-19T15:35:50.970+0000",
    "modifiedBy": "5a621004e4b04e14d902b7cf",
    "lastItemId": 0,
    "lastViewId": 0
}, {
    "id": "5a621084e4b04e14d902b7fa",
    "companyId": "59c8fe13e4b085e2cd4c6d59",
    "views": [{
        "viewId": 1,
        "name": {
            "en": "a"
        }
    }],
    "version": 14,
    "status": "created",
    "createdOn": "2018-01-19T15:36:36.248+0000",
    "createdBy": "5a621004e4b04e14d902b7cf",
    "modifiedOn": "2018-01-19T15:36:36.248+0000",
    "modifiedBy": "5a621004e4b04e14d902b7cf",
    "lastItemId": 0,
    "lastViewId": 0
}, {
    "id": "5a6210a5e4b04e14d902b80d",
    "companyId": "59c8fe13e4b085e2cd4c6d59",
    "views": [{
        "viewId": 1,
        "name": {
            "en": "a"
        }
    }],
    "version": 15,
    "status": "created",
    "createdOn": "2018-01-19T15:37:09.540+0000",
    "createdBy": "5a621004e4b04e14d902b7cf",
    "modifiedOn": "2018-01-19T15:37:09.540+0000",
    "modifiedBy": "5a621004e4b04e14d902b7cf",
    "lastItemId": 0,
    "lastViewId": 0
}, {
    "id": "5a660215855b310f31352171",
    "companyId": "5a65e002e4b062975d2bc90c",
    "views": [{
        "viewId": 1,
        "name": {
            "en": "Restaurant"
        }
    }, {
        "viewId": 2,
        "name": {
            "en": "Take awy"
        }
    }, {
        "viewId": 3,
        "name": {
            "en": "Drinks"
        }
    }],
    "version": 0,
    "status": "active",
    "createdOn": "2018-01-17T22:47:45.785+0000",
    "createdBy": "5a5fce32e4b04e14d902b2c3",
    "modifiedOn": "2018-01-23T09:08:31.732+0000",
    "modifiedBy": "59d224d88d60691acf763dba",
    "lastItemId": 337,
    "lastViewId": 3
}, {
    "id": "5a673109e4b0835eeb980228",
    "companyId": "59dcd421e4b0bc51008ea0dc",
    "views": [{
        "viewId": 1,
        "name": {
            "de": "Online Bestellung",
            "en": "online order"
        }
    }, {
        "viewId": 2,
        "name": {
            "de": "Restaurant",
            "en": "Restaurant"
        }
    }, {
        "viewId": 3,
        "name": {
            "de": "Mittagsmenue",
            "en": "Lunch menu"
        }
    }, {
        "viewId": 4,
        "name": {
            "de": "Abholtheke",
            "en": "Take away"
        }
    }],
    "version": 36,
    "status": "created",
    "createdOn": "2018-01-23T12:56:41.487+0000",
    "createdBy": "5a6730b5e4b0835eeb980217",
    "modifiedOn": "2018-01-23T12:56:41.487+0000",
    "modifiedBy": "5a6730b5e4b0835eeb980217",
    "lastItemId": 2,
    "lastViewId": 4
}, {
    "id": "5a674578e4b0835eeb980268",
    "companyId": "59dcd421e4b0bc51008ea0dc",
    "views": [{
        "viewId": 1,
        "name": {
            "de": "Online Bestellung",
            "en": "online order"
        }
    }, {
        "viewId": 2,
        "name": {
            "de": "Restaurant",
            "en": "Restaurant"
        }
    }, {
        "viewId": 3,
        "name": {
            "de": "Mittagsmenue",
            "en": "Lunch menu"
        }
    }, {
        "viewId": 4,
        "name": {
            "de": "Abholtheke",
            "en": "Take away"
        }
    }],
    "version": 37,
    "status": "created",
    "createdOn": "2018-01-23T14:23:52.135+0000",
    "createdBy": "5a6730b5e4b0835eeb980217",
    "modifiedOn": "2018-01-23T14:23:52.135+0000",
    "modifiedBy": "5a6730b5e4b0835eeb980217",
    "lastItemId": 2,
    "lastViewId": 4
}, {
    "id": "5a686680e4b018a96394651e",
    "companyId": "5a685d50e4b018a963946479",
    "views": [{
        "viewId": 1,
        "name": {
            "en": "Default"
        }
    }],
    "version": 1,
    "status": "inactive",
    "createdOn": "2018-01-24T10:57:03.969+0000",
    "createdBy": "5a6865b5e4b018a96394650e",
    "modifiedOn": "2018-01-24T13:51:30.211+0000",
    "modifiedBy": "5a68674be4b018a963946565",
    "lastItemId": 1,
    "lastViewId": 1
}, {
    "id": "5a686c25e4b018a9639465d3",
    "companyId": "59dcd421e4b0bc51008ea0dc",
    "views": [{
        "viewId": 1,
        "name": {
            "de": "Online Bestellung",
            "en": "online order"
        }
    }, {
        "viewId": 2,
        "name": {
            "de": "Restaurant",
            "en": "Restaurant"
        }
    }, {
        "viewId": 3,
        "name": {
            "de": "Mittagsmenue",
            "en": "Lunch menu"
        }
    }, {
        "viewId": 4,
        "name": {
            "de": "Abholtheke",
            "en": "Take away"
        }
    }],
    "version": 38,
    "status": "created",
    "createdOn": "2018-01-24T11:21:09.129+0000",
    "createdBy": "5a685737e4b018a96394644e",
    "modifiedOn": "2018-01-24T11:21:09.129+0000",
    "modifiedBy": "5a685737e4b018a96394644e",
    "lastItemId": 2,
    "lastViewId": 4
}, {
    "id": "5a6882a3e4b0d82062f2b353",
    "companyId": "59c8fe13e4b085e2cd4c6d59",
    "views": [{
        "viewId": 1,
        "name": {
            "en": "x"
        }
    }],
    "version": 16,
    "status": "created",
    "createdOn": "2018-01-24T12:57:07.471+0000",
    "createdBy": "5a68674be4b018a963946565",
    "modifiedOn": "2018-01-24T12:57:07.471+0000",
    "modifiedBy": "5a68674be4b018a963946565",
    "lastItemId": 2,
    "lastViewId": 1
}, {
    "id": "5a688eb0e4b0499cb025976d",
    "companyId": "5a685d50e4b018a963946479",
    "views": [{
        "viewId": 1,
        "name": {
            "en": "Default"
        }
    }],
    "version": 2,
    "status": "created",
    "createdOn": "2018-01-24T13:48:32.916+0000",
    "createdBy": "5a685737e4b018a96394644e",
    "modifiedOn": "2018-01-24T13:48:32.916+0000",
    "modifiedBy": "5a685737e4b018a96394644e",
    "lastItemId": 1,
    "lastViewId": 1
}, {
    "id": "5a688f0de4b0499cb0259779",
    "companyId": "59c8fe13e4b085e2cd4c6d59",
    "views": [{
        "viewId": 1,
        "name": {
            "en": "aaaaa"
        }
    }, {
        "viewId": 2,
        "name": {
            "en": "ssssss"
        }
    }],
    "version": 17,
    "status": "created",
    "createdOn": "2018-01-24T13:50:05.764+0000",
    "createdBy": "5a685737e4b018a96394644e",
    "modifiedOn": "2018-01-24T13:50:05.764+0000",
    "modifiedBy": "5a685737e4b018a96394644e",
    "lastItemId": 1,
    "lastViewId": 2
}, {
    "id": "5a688f11e4b0499cb0259780",
    "companyId": "59c8fe13e4b085e2cd4c6d59",
    "views": [{
        "viewId": 1,
        "name": {
            "en": "x"
        }
    }],
    "version": 18,
    "status": "created",
    "createdOn": "2018-01-24T13:50:09.726+0000",
    "createdBy": "5a68674be4b018a963946565",
    "modifiedOn": "2018-01-24T13:50:09.726+0000",
    "modifiedBy": "5a68674be4b018a963946565",
    "lastItemId": 2,
    "lastViewId": 1
}, {
    "id": "5a688f5ae4b0499cb02597c2",
    "companyId": "5a685d50e4b018a963946479",
    "views": [{
        "viewId": 1,
        "name": {
            "en": "Default"
        }
    }],
    "version": 3,
    "status": "active",
    "createdOn": "2018-01-24T13:51:22.769+0000",
    "createdBy": "5a68674be4b018a963946565",
    "modifiedOn": "2018-01-24T13:51:30.185+0000",
    "modifiedBy": "59d224d88d60691acf763dba",
    "lastItemId": 2,
    "lastViewId": 1
}, {
    "id": "5a688fa7e4b0499cb02597f2",
    "companyId": "5a685d50e4b018a963946479",
    "views": [{
        "viewId": 1,
        "name": {
            "en": "Default"
        }
    }],
    "version": 4,
    "status": "created",
    "createdOn": "2018-01-24T13:52:39.774+0000",
    "createdBy": "5a68674be4b018a963946565",
    "modifiedOn": "2018-01-24T13:52:39.774+0000",
    "modifiedBy": "5a68674be4b018a963946565",
    "lastItemId": 3,
    "lastViewId": 1
}, {
    "id": "5a6b450fe4b0e8e18e950519",
    "companyId": "5a6afb0ce4b0e8e18e9502e8",
    "views": [{
        "viewId": 1,
        "name": {
            "en": "DINE IN"
        }
    }, {
        "viewId": 2,
        "name": {
            "en": "TAKE AWAY"
        }
    }, {
        "viewId": 3,
        "name": {
            "en": "Drinks"
        }
    }],
    "version": 1,
    "status": "inactive",
    "createdOn": "2018-01-26T15:11:11.659+0000",
    "createdBy": "5a6b42a9e4b0e8e18e9504c7",
    "modifiedOn": "2018-02-02T11:50:21.365+0000",
    "modifiedBy": "5a74506ce4b097458dd23e21",
    "lastItemId": 3,
    "lastViewId": 3
}, {
    "id": "5a6b4611e4b0e8e18e950559",
    "companyId": "5a6afb0ce4b0e8e18e9502e8",
    "views": [{
        "viewId": 1,
        "name": {
            "en": "DINE IN"
        }
    }, {
        "viewId": 2,
        "name": {
            "en": "TAKE AWAY"
        }
    }, {
        "viewId": 3,
        "name": {
            "en": "Drinks"
        }
    }],
    "version": 2,
    "status": "inactive",
    "createdOn": "2018-01-26T15:15:29.927+0000",
    "createdBy": "5a6b4591e4b0e8e18e95053e",
    "modifiedOn": "2018-01-29T17:08:53.348+0000",
    "modifiedBy": "5a6b4591e4b0e8e18e95053e",
    "lastItemId": 3,
    "lastViewId": 3
}, {
    "id": "5a6f0b5ce4b021ef3c7a6cd0",
    "companyId": "5a6f089ee4b0ed8f57f2facc",
    "views": [{
        "viewId": 1,
        "name": {
            "en": "test"
        }
    }],
    "version": 1,
    "status": "created",
    "createdOn": "2018-01-29T11:54:04.889+0000",
    "createdBy": "5a6f0b09e4b021ef3c7a6cc6",
    "modifiedOn": "2018-01-29T11:54:04.889+0000",
    "modifiedBy": "5a6f0b09e4b021ef3c7a6cc6",
    "lastItemId": 2,
    "lastViewId": 1
}, {
    "id": "5a6f0d6fe4b021ef3c7a6cfb",
    "companyId": "5a6f089ee4b0ed8f57f2facc",
    "views": [{
        "viewId": 1,
        "name": {
            "en": "test"
        }
    }],
    "version": 2,
    "status": "created",
    "createdOn": "2018-01-29T12:02:55.100+0000",
    "createdBy": "5a6f0b9de4b021ef3c7a6cec",
    "modifiedOn": "2018-01-29T12:02:55.100+0000",
    "modifiedBy": "5a6f0b9de4b021ef3c7a6cec",
    "lastItemId": 2,
    "lastViewId": 1
}, {
    "id": "5a6f1a01e4b021ef3c7a6d53",
    "companyId": "5a6f089ee4b0ed8f57f2facc",
    "views": [{
        "viewId": 1,
        "name": {
            "en": "test"
        }
    }],
    "version": 3,
    "status": "created",
    "createdOn": "2018-01-29T12:56:33.261+0000",
    "createdBy": "5a6f0b9de4b021ef3c7a6cec",
    "modifiedOn": "2018-01-29T12:56:33.261+0000",
    "modifiedBy": "5a6f0b9de4b021ef3c7a6cec",
    "lastItemId": 2,
    "lastViewId": 1
}, {
    "id": "5a6f1a49e4b021ef3c7a6d80",
    "companyId": "5a6f089ee4b0ed8f57f2facc",
    "views": [{
        "viewId": 1,
        "name": {
            "en": "test"
        }
    }],
    "version": 4,
    "status": "created",
    "createdOn": "2018-01-29T12:57:45.868+0000",
    "createdBy": "5a6f1a30e4b021ef3c7a6d73",
    "modifiedOn": "2018-01-29T12:57:45.868+0000",
    "modifiedBy": "5a6f1a30e4b021ef3c7a6d73",
    "lastItemId": 2,
    "lastViewId": 1
}, {
    "id": "5a6f1aa0e4b021ef3c7a6d8d",
    "companyId": "5a6f089ee4b0ed8f57f2facc",
    "views": [{
        "viewId": 1,
        "name": {
            "en": "test"
        }
    }],
    "version": 5,
    "status": "created",
    "createdOn": "2018-01-29T12:59:12.670+0000",
    "createdBy": "5a6f1a30e4b021ef3c7a6d73",
    "modifiedOn": "2018-01-29T12:59:12.670+0000",
    "modifiedBy": "5a6f1a30e4b021ef3c7a6d73",
    "lastItemId": 2,
    "lastViewId": 1
}, {
    "id": "5a6f2074e4b021ef3c7a6dba",
    "companyId": "5a6f089ee4b0ed8f57f2facc",
    "views": [{
        "viewId": 1,
        "name": {
            "en": "test"
        }
    }],
    "version": 6,
    "status": "created",
    "createdOn": "2018-01-29T13:24:03.997+0000",
    "createdBy": "5a6f1a30e4b021ef3c7a6d73",
    "modifiedOn": "2018-01-29T13:24:03.997+0000",
    "modifiedBy": "5a6f1a30e4b021ef3c7a6d73",
    "lastItemId": 2,
    "lastViewId": 1
}, {
    "id": "5a6f20bae4b021ef3c7a6ddd",
    "companyId": "5a6f089ee4b0ed8f57f2facc",
    "views": [{
        "viewId": 1,
        "name": {
            "en": "test"
        }
    }],
    "version": 7,
    "status": "created",
    "createdOn": "2018-01-29T13:25:14.565+0000",
    "createdBy": "5a6f20b3e4b021ef3c7a6dd0",
    "modifiedOn": "2018-01-29T13:25:14.565+0000",
    "modifiedBy": "5a6f20b3e4b021ef3c7a6dd0",
    "lastItemId": 2,
    "lastViewId": 1
}, {
    "id": "5a6f2d1de4b021ef3c7a6e08",
    "companyId": "5a6f089ee4b0ed8f57f2facc",
    "views": [{
        "viewId": 1,
        "name": {
            "en": "test"
        }
    }],
    "version": 8,
    "status": "created",
    "createdOn": "2018-01-29T14:18:05.362+0000",
    "createdBy": "5a6f20b3e4b021ef3c7a6dd0",
    "modifiedOn": "2018-01-29T14:18:05.362+0000",
    "modifiedBy": "5a6f20b3e4b021ef3c7a6dd0",
    "lastItemId": 2,
    "lastViewId": 1
}, {
    "id": "5a6f2f1ee4b021ef3c7a6e1f",
    "companyId": "5a6f089ee4b0ed8f57f2facc",
    "views": [{
        "viewId": 1,
        "name": {
            "en": "test"
        }
    }],
    "version": 9,
    "status": "created",
    "createdOn": "2018-01-29T14:26:38.900+0000",
    "createdBy": "5a6f20b3e4b021ef3c7a6dd0",
    "modifiedOn": "2018-01-29T14:26:38.900+0000",
    "modifiedBy": "5a6f20b3e4b021ef3c7a6dd0",
    "lastItemId": 2,
    "lastViewId": 1
}, {
    "id": "5a6f2fa0e4b021ef3c7a6e46",
    "companyId": "5a6f089ee4b0ed8f57f2facc",
    "views": [{
        "viewId": 1,
        "name": {
            "en": "test"
        }
    }],
    "version": 10,
    "status": "created",
    "createdOn": "2018-01-29T14:28:48.537+0000",
    "createdBy": "5a6f2f95e4b021ef3c7a6e39",
    "modifiedOn": "2018-01-29T14:28:48.537+0000",
    "modifiedBy": "5a6f2f95e4b021ef3c7a6e39",
    "lastItemId": 2,
    "lastViewId": 1
}, {
    "id": "5a6f2fe3e4b021ef3c7a6e75",
    "companyId": "5a6f089ee4b0ed8f57f2facc",
    "views": [{
        "viewId": 1,
        "name": {
            "en": "test"
        }
    }],
    "version": 11,
    "status": "created",
    "createdOn": "2018-01-29T14:29:55.661+0000",
    "createdBy": "5a6f2fd0e4b021ef3c7a6e68",
    "modifiedOn": "2018-01-29T14:29:55.661+0000",
    "modifiedBy": "5a6f2fd0e4b021ef3c7a6e68",
    "lastItemId": 2,
    "lastViewId": 1
}, {
    "id": "5a6f304ce4b021ef3c7a6eb6",
    "companyId": "5a6f089ee4b0ed8f57f2facc",
    "views": [{
        "viewId": 1,
        "name": {
            "en": "test"
        }
    }],
    "version": 12,
    "status": "created",
    "createdOn": "2018-01-29T14:31:40.690+0000",
    "createdBy": "5a6f303ae4b021ef3c7a6ea9",
    "modifiedOn": "2018-01-29T14:31:40.690+0000",
    "modifiedBy": "5a6f303ae4b021ef3c7a6ea9",
    "lastItemId": 2,
    "lastViewId": 1
}, {
    "id": "5a6f444de4b021ef3c7a6f37",
    "companyId": "5a6f089ee4b0ed8f57f2facc",
    "views": [{
        "viewId": 1,
        "name": {
            "en": "test"
        }
    }],
    "version": 13,
    "status": "created",
    "createdOn": "2018-01-29T15:57:01.896+0000",
    "createdBy": "5a6f303ae4b021ef3c7a6ea9",
    "modifiedOn": "2018-01-29T15:57:01.896+0000",
    "modifiedBy": "5a6f303ae4b021ef3c7a6ea9",
    "lastItemId": 3,
    "lastViewId": 1
}, {
    "id": "5a6f551fe4b021ef3c7a6f7e",
    "companyId": "5a6afb0ce4b0e8e18e9502e8",
    "views": [{
        "viewId": 1,
        "name": {
            "en": "DINE IN"
        }
    }, {
        "viewId": 2,
        "name": {
            "en": "TAKE AWAY"
        }
    }, {
        "viewId": 3,
        "name": {
            "en": "Drinks"
        }
    }],
    "version": 3,
    "status": "inactive",
    "createdOn": "2018-01-29T17:08:47.025+0000",
    "createdBy": "5a6b4591e4b0e8e18e95053e",
    "modifiedOn": "2018-01-29T17:11:39.323+0000",
    "modifiedBy": "5a6b4591e4b0e8e18e95053e",
    "lastItemId": 4,
    "lastViewId": 3
}, {
    "id": "5a6f55c9e4b021ef3c7a6f94",
    "companyId": "5a6afb0ce4b0e8e18e9502e8",
    "views": [{
        "viewId": 1,
        "name": {
            "en": "DINE IN"
        }
    }, {
        "viewId": 2,
        "name": {
            "en": "TAKE AWAY"
        }
    }, {
        "viewId": 3,
        "name": {
            "en": "Drinks"
        }
    }],
    "version": 4,
    "status": "inactive",
    "createdOn": "2018-01-29T17:11:37.305+0000",
    "createdBy": "5a6b4591e4b0e8e18e95053e",
    "modifiedOn": "2018-01-31T12:33:59.611+0000",
    "modifiedBy": "5a71b49fe4b00d23b27079f5",
    "lastItemId": 5,
    "lastViewId": 3
}, {
    "id": "5a6f55ebe4b021ef3c7a6fac",
    "companyId": "5a6afb0ce4b0e8e18e9502e8",
    "views": [{
        "viewId": 1,
        "name": {
            "en": "DINE IN"
        }
    }, {
        "viewId": 2,
        "name": {
            "en": "TAKE AWAY"
        }
    }, {
        "viewId": 3,
        "name": {
            "en": "Drinks"
        }
    }],
    "version": 5,
    "status": "inactive",
    "createdOn": "2018-01-29T17:12:11.760+0000",
    "createdBy": "5a6b4591e4b0e8e18e95053e",
    "modifiedOn": "2018-01-30T16:11:45.495+0000",
    "modifiedBy": "5a7066afe4b021ef3c7a711d",
    "lastItemId": 5,
    "lastViewId": 3
}, {
    "id": "5a6fb1b4e4b021ef3c7a6ff3",
    "companyId": "59dcd421e4b0bc51008ea0dc",
    "views": [{
        "viewId": 1,
        "name": {
            "de": "Online Bestellung",
            "en": "online order"
        }
    }, {
        "viewId": 2,
        "name": {
            "de": "Restaurant",
            "en": "Restaurant"
        }
    }, {
        "viewId": 3,
        "name": {
            "de": "Mittagsmenue",
            "en": "Lunch menu"
        }
    }, {
        "viewId": 4,
        "name": {
            "de": "Abholtheke",
            "en": "Take away"
        }
    }],
    "version": 39,
    "status": "inactive",
    "createdOn": "2018-01-29T23:43:48.554+0000",
    "createdBy": "5a6fb154e4b021ef3c7a6fe6",
    "modifiedOn": "2018-01-29T23:47:29.951+0000",
    "modifiedBy": "5a6fb154e4b021ef3c7a6fe6",
    "lastItemId": 3,
    "lastViewId": 4
}, {
    "id": "5a6fb1c8e4b021ef3c7a7007",
    "companyId": "59dcd421e4b0bc51008ea0dc",
    "views": [{
        "viewId": 1,
        "name": {
            "de": "Online Bestellung",
            "en": "online order"
        }
    }, {
        "viewId": 2,
        "name": {
            "de": "Restaurant",
            "en": "Restaurant"
        }
    }, {
        "viewId": 3,
        "name": {
            "de": "Mittagsmenue",
            "en": "Lunch menu"
        }
    }, {
        "viewId": 4,
        "name": {
            "de": "Abholtheke",
            "en": "Take away"
        }
    }],
    "version": 40,
    "status": "inactive",
    "createdOn": "2018-01-29T23:44:08.341+0000",
    "createdBy": "5a6fb154e4b021ef3c7a6fe6",
    "modifiedOn": "2018-02-12T12:53:53.352+0000",
    "modifiedBy": "5a818d95e4b0379a14b54b59",
    "lastItemId": 3,
    "lastViewId": 4
}, {
    "id": "5a705918e4b021ef3c7a7109",
    "companyId": "5a6f089ee4b0ed8f57f2facc",
    "views": [{
        "viewId": 1,
        "name": {
            "en": "test"
        }
    }],
    "version": 14,
    "status": "created",
    "createdOn": "2018-01-30T11:38:00.295+0000",
    "createdBy": "5a705757e4b021ef3c7a7094",
    "modifiedOn": "2018-01-30T11:38:00.295+0000",
    "modifiedBy": "5a705757e4b021ef3c7a7094",
    "lastItemId": 2,
    "lastViewId": 1
}, {
    "id": "5a70993de4b021ef3c7a71c6",
    "companyId": "5a6afb0ce4b0e8e18e9502e8",
    "views": [{
        "viewId": 1,
        "name": {
            "en": "DINE IN"
        }
    }, {
        "viewId": 2,
        "name": {
            "en": "TAKE AWAY"
        }
    }, {
        "viewId": 3,
        "name": {
            "en": "Drinks"
        }
    }],
    "version": 6,
    "status": "inactive",
    "createdOn": "2018-01-30T16:11:41.899+0000",
    "createdBy": "5a7066afe4b021ef3c7a711d",
    "modifiedOn": "2018-01-31T12:20:59.449+0000",
    "modifiedBy": "5a71b49fe4b00d23b27079f5",
    "lastItemId": 5,
    "lastViewId": 3
}, {
    "id": "5a71b4a8e4b00d23b2707a02",
    "companyId": "5a6afb0ce4b0e8e18e9502e8",
    "views": [{
        "viewId": 1,
        "name": {
            "en": "DINE IN"
        }
    }, {
        "viewId": 2,
        "name": {
            "en": "TAKE AWAY"
        }
    }, {
        "viewId": 3,
        "name": {
            "en": "Drinks"
        }
    }],
    "version": 7,
    "status": "inactive",
    "createdOn": "2018-01-31T12:20:56.466+0000",
    "createdBy": "5a71b49fe4b00d23b27079f5",
    "modifiedOn": "2018-01-31T12:34:46.997+0000",
    "modifiedBy": "5a71b49fe4b00d23b27079f5",
    "lastItemId": 5,
    "lastViewId": 3
}, {
    "id": "5a71b7e5e4b00d23b2707a2a",
    "companyId": "5a6afb0ce4b0e8e18e9502e8",
    "views": [{
        "viewId": 1,
        "name": {
            "en": "DINE IN"
        }
    }, {
        "viewId": 2,
        "name": {
            "en": "TAKE AWAY"
        }
    }, {
        "viewId": 3,
        "name": {
            "en": "Drinks"
        }
    }],
    "version": 8,
    "status": "inactive",
    "createdOn": "2018-01-31T12:34:45.069+0000",
    "createdBy": "5a71b49fe4b00d23b27079f5",
    "modifiedOn": "2018-01-31T12:36:25.634+0000",
    "modifiedBy": "5a71b49fe4b00d23b27079f5",
    "lastItemId": 6,
    "lastViewId": 3
}, {
    "id": "5a71b847e4b00d23b2707a40",
    "companyId": "5a6afb0ce4b0e8e18e9502e8",
    "views": [{
        "viewId": 1,
        "name": {
            "en": "DINE IN"
        }
    }, {
        "viewId": 2,
        "name": {
            "en": "TAKE AWAY"
        }
    }, {
        "viewId": 3,
        "name": {
            "en": "Drinks"
        }
    }, {
        "viewId": 4,
        "name": {
            "en": "OUTSIDE"
        }
    }],
    "version": 9,
    "status": "inactive",
    "createdOn": "2018-01-31T12:36:23.589+0000",
    "createdBy": "5a71b49fe4b00d23b27079f5",
    "modifiedOn": "2018-01-31T13:25:10.271+0000",
    "modifiedBy": "5a71b49fe4b00d23b27079f5",
    "lastItemId": 6,
    "lastViewId": 4
}, {
    "id": "5a71c3b3e4b00d23b2707a5a",
    "companyId": "5a6afb0ce4b0e8e18e9502e8",
    "views": [{
        "viewId": 1,
        "name": {
            "en": "DINE IN"
        }
    }, {
        "viewId": 2,
        "name": {
            "en": "TAKE AWAY"
        }
    }, {
        "viewId": 3,
        "name": {
            "en": "Drinks"
        }
    }, {
        "viewId": 4,
        "name": {
            "en": "OUTSIDE"
        }
    }],
    "version": 10,
    "status": "inactive",
    "createdOn": "2018-01-31T13:25:07.676+0000",
    "createdBy": "5a71b49fe4b00d23b27079f5",
    "modifiedOn": "2018-01-31T13:26:34.794+0000",
    "modifiedBy": "5a71b49fe4b00d23b27079f5",
    "lastItemId": 6,
    "lastViewId": 4
}, {
    "id": "5a71c408e4b00d23b2707a70",
    "companyId": "5a6afb0ce4b0e8e18e9502e8",
    "views": [{
        "viewId": 1,
        "name": {
            "en": "DINE IN"
        }
    }, {
        "viewId": 2,
        "name": {
            "en": "TAKE AWAY"
        }
    }, {
        "viewId": 3,
        "name": {
            "en": "Drinks"
        }
    }, {
        "viewId": 4,
        "name": {
            "en": "OUTSIDE"
        }
    }],
    "version": 11,
    "status": "inactive",
    "createdOn": "2018-01-31T13:26:32.167+0000",
    "createdBy": "5a71b49fe4b00d23b27079f5",
    "modifiedOn": "2018-01-31T13:35:49.061+0000",
    "modifiedBy": "5a71b49fe4b00d23b27079f5",
    "lastItemId": 6,
    "lastViewId": 4
}, {
    "id": "5a71c632e4b00d23b2707a86",
    "companyId": "5a6afb0ce4b0e8e18e9502e8",
    "views": [{
        "viewId": 1,
        "name": {
            "en": "DINE IN"
        }
    }, {
        "viewId": 2,
        "name": {
            "en": "TAKE AWAY"
        }
    }, {
        "viewId": 3,
        "name": {
            "en": "Drinks"
        }
    }, {
        "viewId": 4,
        "name": {
            "en": "OUTSIDE"
        }
    }],
    "version": 12,
    "status": "active",
    "createdOn": "2018-01-31T13:35:46.448+0000",
    "createdBy": "5a71b49fe4b00d23b27079f5",
    "modifiedOn": "2018-02-02T11:50:21.337+0000",
    "modifiedBy": "5a5805ba922eb20435b28e88",
    "lastItemId": 6,
    "lastViewId": 4
}, {
    "id": "5a818e5ee4b0379a14b54b6e",
    "companyId": "59dcd421e4b0bc51008ea0dc",
    "views": [{
        "viewId": 1,
        "name": {
            "de": "Online Bestellung",
            "en": "online order"
        }
    }, {
        "viewId": 2,
        "name": {
            "de": "Restaurant",
            "en": "Restaurant"
        }
    }, {
        "viewId": 3,
        "name": {
            "de": "Mittagsmenue",
            "en": "Lunch menu"
        }
    }, {
        "viewId": 4,
        "name": {
            "de": "Abholtheke",
            "en": "Take away"
        }
    }],
    "version": 41,
    "status": "inactive",
    "createdOn": "2018-02-12T12:53:50.594+0000",
    "createdBy": "5a818d95e4b0379a14b54b59",
    "modifiedOn": "2018-02-19T18:04:23.345+0000",
    "modifiedBy": "5a8b116ce4b0e3b61098d6b0",
    "lastItemId": 6,
    "lastViewId": 4
}, {
    "id": "5a8191c2e4b0379a14b54ba4",
    "companyId": "59dcd421e4b0bc51008ea0dc",
    "views": [{
        "viewId": 1,
        "name": {
            "de": "Online Bestellung",
            "en": "online order"
        }
    }, {
        "viewId": 2,
        "name": {
            "de": "Restaurant",
            "en": "Restaurant"
        }
    }, {
        "viewId": 3,
        "name": {
            "de": "Mittagsmenue",
            "en": "Lunch menu"
        }
    }, {
        "viewId": 4,
        "name": {
            "de": "Abholtheke",
            "en": "Take away"
        }
    }],
    "version": 42,
    "status": "created",
    "createdOn": "2018-02-12T13:08:18.621+0000",
    "createdBy": "5a818d95e4b0379a14b54b59",
    "modifiedOn": "2018-02-12T13:08:18.621+0000",
    "modifiedBy": "5a818d95e4b0379a14b54b59",
    "lastItemId": 7,
    "lastViewId": 4
}, {
    "id": "5a688f57e4b0499cb02597bb",
    "companyId": "59c8fe13e4b085e2cd4c6d59",
    "views": [{
        "viewId": 1,
        "name": {
            "en": "Restaurant"
        }
    }, {
        "viewId": 2,
        "name": {
            "en": "Take awy"
        }
    }, {
        "viewId": 3,
        "name": {
            "en": "Drinks"
        }
    }],
    "version": 19,
    "status": "created",
    "createdOn": "2018-01-24T13:51:19.034+0000",
    "createdBy": "5a685737e4b018a96394644e",
    "modifiedOn": "2018-01-24T13:51:19.034+0000",
    "modifiedBy": "5a685737e4b018a96394644e",
    "lastItemId": 2,
    "lastViewId": 2
}, {
    "id": "5a820162e4b0379a14b54c63",
    "companyId": "5a57c093e4b06683979bf4a7",
    "views": [{
        "viewId": 1,
        "name": {
            "en": "Restaurant"
        }
    }, {
        "viewId": 2,
        "name": {
            "en": "Take awy"
        }
    }, {
        "viewId": 3,
        "name": {
            "en": "Drinks"
        }
    }],
    "version": 21,
    "status": "created",
    "createdOn": "2018-02-12T21:04:34.771+0000",
    "createdBy": "5a818d95e4b0379a14b54b59",
    "modifiedOn": "2018-02-12T21:04:34.771+0000",
    "modifiedBy": "5a818d95e4b0379a14b54b59",
    "lastItemId": 337,
    "lastViewId": 3
}, {
    "id": "5a8204c0e4b0379a14b54c77",
    "companyId": "5a57c093e4b06683979bf4a7",
    "views": [{
        "viewId": 1,
        "name": {
            "en": "Restaurant"
        }
    }, {
        "viewId": 2,
        "name": {
            "en": "Take awy"
        }
    }, {
        "viewId": 3,
        "name": {
            "en": "Drinks"
        }
    }],
    "version": 22,
    "status": "inactive",
    "createdOn": "2018-02-12T21:18:56.422+0000",
    "createdBy": "5a81e206e4b0379a14b54bd4",
    "modifiedOn": "2018-02-12T21:22:56.814+0000",
    "modifiedBy": "5a81e206e4b0379a14b54bd4",
    "lastItemId": 338,
    "lastViewId": 3
}, {
    "id": "5a8205aee4b0379a14b54c8d",
    "companyId": "5a57c093e4b06683979bf4a7",
    "views": [{
        "viewId": 1,
        "name": {
            "en": "Restaurant"
        }
    }, {
        "viewId": 2,
        "name": {
            "en": "Take awy"
        }
    }, {
        "viewId": 3,
        "name": {
            "en": "Drinks"
        }
    }],
    "version": 23,
    "status": "inactive",
    "createdOn": "2018-02-12T21:22:54.837+0000",
    "createdBy": "5a81e206e4b0379a14b54bd4",
    "modifiedOn": "2018-02-12T21:23:47.903+0000",
    "modifiedBy": "5a81e206e4b0379a14b54bd4",
    "lastItemId": 341,
    "lastViewId": 3
}, {
    "id": "5a8205e1e4b0379a14b54ca1",
    "companyId": "5a57c093e4b06683979bf4a7",
    "views": [{
        "viewId": 1,
        "name": {
            "en": "Restaurant"
        }
    }, {
        "viewId": 2,
        "name": {
            "en": "Take awy"
        }
    }, {
        "viewId": 3,
        "name": {
            "en": "Drinks"
        }
    }],
    "version": 24,
    "status": "inactive",
    "createdOn": "2018-02-12T21:23:45.395+0000",
    "createdBy": "5a81e206e4b0379a14b54bd4",
    "modifiedOn": "2018-02-19T13:25:36.880+0000",
    "modifiedBy": "5a8aced0e4b0e3b61098d31f",
    "lastItemId": 341,
    "lastViewId": 3
}, {
    "id": "5a82c1fce4b0379a14b54e42",
    "companyId": "59dcd421e4b0bc51008ea0dc",
    "views": [{
        "viewId": 1,
        "name": {
            "de": "Online Bestellung",
            "en": "online order"
        }
    }, {
        "viewId": 2,
        "name": {
            "de": "Restaurant",
            "en": "Restaurant"
        }
    }, {
        "viewId": 3,
        "name": {
            "de": "Mittagsmenue",
            "en": "Lunch menu"
        }
    }, {
        "viewId": 4,
        "name": {
            "de": "Abholtheke",
            "en": "Take away"
        }
    }],
    "version": 43,
    "status": "created",
    "createdOn": "2018-02-13T10:46:20.470+0000",
    "createdBy": "5a82c1a2e4b0379a14b54e15",
    "modifiedOn": "2018-02-13T10:46:20.470+0000",
    "modifiedBy": "5a82c1a2e4b0379a14b54e15",
    "lastItemId": 2,
    "lastViewId": 4
}, {
    "id": "5a82c219e4b0379a14b54e4f",
    "companyId": "59dcd421e4b0bc51008ea0dc",
    "views": [{
        "viewId": 1,
        "name": {
            "de": "Online Bestellung",
            "en": "online order"
        }
    }, {
        "viewId": 2,
        "name": {
            "de": "Restaurant",
            "en": "Restaurant"
        }
    }, {
        "viewId": 3,
        "name": {
            "de": "Mittagsmenue",
            "en": "Lunch menu"
        }
    }, {
        "viewId": 4,
        "name": {
            "de": "Abholtheke",
            "en": "Take away"
        }
    }],
    "version": 44,
    "status": "created",
    "createdOn": "2018-02-13T10:46:49.760+0000",
    "createdBy": "5a82c1a2e4b0379a14b54e15",
    "modifiedOn": "2018-02-13T10:46:49.760+0000",
    "modifiedBy": "5a82c1a2e4b0379a14b54e15",
    "lastItemId": 2,
    "lastViewId": 4
}, {
    "id": "5a86dc34e4b03106de48b4f2",
    "companyId": "5a86c97ce4b0b364a6138b1d",
    "views": [{
        "viewId": 1,
        "name": {
            "en": "test"
        }
    }],
    "version": 1,
    "status": "inactive",
    "createdOn": "2018-02-16T13:27:16.507+0000",
    "createdBy": "5a86dbd9e4b03106de48b4e8",
    "modifiedOn": "2018-02-16T15:02:15.603+0000",
    "modifiedBy": "5a86d75ee4b03106de48b4ce",
    "lastItemId": 1,
    "lastViewId": 1
}, {
    "id": "5a86dd1de4b03106de48b508",
    "companyId": "5a86c97ce4b0b364a6138b1d",
    "views": [{
        "viewId": 1,
        "name": {
            "en": "One View Test"
        }
    }],
    "version": 2,
    "status": "inactive",
    "createdOn": "2018-02-16T13:31:09.033+0000",
    "createdBy": "5a86dc65e4b03106de48b4f8",
    "modifiedOn": "2018-02-16T15:00:48.141+0000",
    "modifiedBy": "5a86d75ee4b03106de48b4ce",
    "lastItemId": 3,
    "lastViewId": 1
}, {
    "id": "5a86f21be4b0e3b61098cd40",
    "companyId": "5a86c97ce4b0b364a6138b1d",
    "views": [{
        "viewId": 1,
        "name": {
            "en": "One View Test"
        }
    }],
    "version": 3,
    "status": "inactive",
    "createdOn": "2018-02-16T15:00:43.486+0000",
    "createdBy": "5a86d75ee4b03106de48b4ce",
    "modifiedOn": "2018-02-16T15:02:13.439+0000",
    "modifiedBy": "5a86d75ee4b03106de48b4ce",
    "lastItemId": 3,
    "lastViewId": 1
}, {
    "id": "5a86f273e4b0e3b61098cd56",
    "companyId": "5a86c97ce4b0b364a6138b1d",
    "views": [{
        "viewId": 1,
        "name": {
            "en": "One View Test"
        }
    }],
    "version": 4,
    "status": "inactive",
    "createdOn": "2018-02-16T15:02:11.276+0000",
    "createdBy": "5a86d75ee4b03106de48b4ce",
    "modifiedOn": "2018-02-16T15:20:21.930+0000",
    "modifiedBy": "5a86d75ee4b03106de48b4ce",
    "lastItemId": 4,
    "lastViewId": 1
}, {
    "id": "5a86f6b2e4b0e3b61098cd72",
    "companyId": "5a86c97ce4b0b364a6138b1d",
    "views": [{
        "viewId": 1,
        "name": {
            "en": "One View Test"
        }
    }],
    "version": 5,
    "status": "inactive",
    "createdOn": "2018-02-16T15:20:18.804+0000",
    "createdBy": "5a86d75ee4b03106de48b4ce",
    "modifiedOn": "2018-02-16T15:21:36.508+0000",
    "modifiedBy": "5a86d75ee4b03106de48b4ce",
    "lastItemId": 8,
    "lastViewId": 1
}, {
    "id": "5a86f6fee4b0e3b61098cd88",
    "companyId": "5a86c97ce4b0b364a6138b1d",
    "views": [{
        "viewId": 1,
        "name": {
            "en": "One View Test"
        }
    }],
    "version": 6,
    "status": "inactive",
    "createdOn": "2018-02-16T15:21:33.993+0000",
    "createdBy": "5a86d75ee4b03106de48b4ce",
    "modifiedOn": "2018-02-16T15:54:49.132+0000",
    "modifiedBy": "5a86d75ee4b03106de48b4ce",
    "lastItemId": 9,
    "lastViewId": 1
}, {
    "id": "5a86f7aae4b0e3b61098cda8",
    "companyId": "5a86c97ce4b0b364a6138b1d",
    "views": [{
        "viewId": 1,
        "name": {
            "en": "One View Test"
        }
    }],
    "version": 7,
    "status": "inactive",
    "createdOn": "2018-02-16T15:24:26.817+0000",
    "createdBy": "5a86d75ee4b03106de48b4ce",
    "modifiedOn": "2018-02-16T15:33:09.717+0000",
    "modifiedBy": "5a86d75ee4b03106de48b4ce",
    "lastItemId": 10,
    "lastViewId": 1
}, {
    "id": "5a86f7d8e4b0e3b61098cdbe",
    "companyId": "5a86c97ce4b0b364a6138b1d",
    "views": [{
        "viewId": 1,
        "name": {
            "en": "One View Test"
        }
    }],
    "version": 8,
    "status": "inactive",
    "createdOn": "2018-02-16T15:25:12.730+0000",
    "createdBy": "5a86d75ee4b03106de48b4ce",
    "modifiedOn": "2018-02-16T15:54:17.649+0000",
    "modifiedBy": "5a86d75ee4b03106de48b4ce",
    "lastItemId": 10,
    "lastViewId": 1
}, {
    "id": "5a86fd15e4b0e3b61098ce68",
    "companyId": "5a86c97ce4b0b364a6138b1d",
    "views": [{
        "viewId": 1,
        "name": {
            "en": "One View Test"
        }
    }],
    "version": 9,
    "status": "inactive",
    "createdOn": "2018-02-16T15:47:32.984+0000",
    "createdBy": "5a86fcfee4b0e3b61098ce51",
    "modifiedOn": "2018-02-19T10:02:43.145+0000",
    "modifiedBy": "5a8a9f6ce4b0e3b61098d048",
    "lastItemId": 10,
    "lastViewId": 1
}, {
    "id": "5a8aa085e4b0e3b61098d062",
    "companyId": "5a86c97ce4b0b364a6138b1d",
    "views": [{
        "viewId": 1,
        "name": {
            "en": "One View Test"
        }
    }],
    "version": 10,
    "status": "created",
    "createdOn": "2018-02-19T10:01:41.827+0000",
    "createdBy": "5a8a9f6ce4b0e3b61098d048",
    "modifiedOn": "2018-02-19T10:01:41.827+0000",
    "modifiedBy": "5a8a9f6ce4b0e3b61098d048",
    "lastItemId": 11,
    "lastViewId": 1
}, {
    "id": "5a8aa097e4b0e3b61098d06f",
    "companyId": "5a86c97ce4b0b364a6138b1d",
    "views": [{
        "viewId": 1,
        "name": {
            "en": "One View Test"
        }
    }],
    "version": 11,
    "status": "created",
    "createdOn": "2018-02-19T10:01:59.263+0000",
    "createdBy": "5a8a9f6ce4b0e3b61098d048",
    "modifiedOn": "2018-02-19T10:01:59.263+0000",
    "modifiedBy": "5a8a9f6ce4b0e3b61098d048",
    "lastItemId": 12,
    "lastViewId": 1
}, {
    "id": "5a8aa0c0e4b0e3b61098d07c",
    "companyId": "5a86c97ce4b0b364a6138b1d",
    "views": [{
        "viewId": 1,
        "name": {
            "en": "One View Test"
        }
    }],
    "version": 12,
    "status": "inactive",
    "createdOn": "2018-02-19T10:02:40.328+0000",
    "createdBy": "5a8a9f6ce4b0e3b61098d048",
    "modifiedOn": "2018-02-19T10:07:32.167+0000",
    "modifiedBy": "5a8a9f6ce4b0e3b61098d048",
    "lastItemId": 14,
    "lastViewId": 1
}, {
    "id": "5a8aa16ee4b0e3b61098d092",
    "companyId": "5a86c97ce4b0b364a6138b1d",
    "views": [{
        "viewId": 1,
        "name": {
            "en": "One View Test"
        }
    }],
    "version": 13,
    "status": "created",
    "createdOn": "2018-02-19T10:05:34.341+0000",
    "createdBy": "5a8a9f6ce4b0e3b61098d048",
    "modifiedOn": "2018-02-19T10:05:34.341+0000",
    "modifiedBy": "5a8a9f6ce4b0e3b61098d048",
    "lastItemId": 15,
    "lastViewId": 1
}, {
    "id": "5a8aa1e0e4b0e3b61098d09f",
    "companyId": "5a86c97ce4b0b364a6138b1d",
    "views": [{
        "viewId": 1,
        "name": {
            "en": "One View Test"
        }
    }],
    "version": 14,
    "status": "inactive",
    "createdOn": "2018-02-19T10:07:28.860+0000",
    "createdBy": "5a8a9f6ce4b0e3b61098d048",
    "modifiedOn": "2018-02-19T10:39:50.368+0000",
    "modifiedBy": "5a8a9f6ce4b0e3b61098d048",
    "lastItemId": 18,
    "lastViewId": 1
}, {
    "id": "5a8aa973e4b0e3b61098d0b8",
    "companyId": "5a86c97ce4b0b364a6138b1d",
    "views": [{
        "viewId": 1,
        "name": {
            "en": "One View Test"
        }
    }],
    "version": 15,
    "status": "inactive",
    "createdOn": "2018-02-19T10:39:47.895+0000",
    "createdBy": "5a8a9f6ce4b0e3b61098d048",
    "modifiedOn": "2018-02-19T10:46:36.872+0000",
    "modifiedBy": "5a8a9f6ce4b0e3b61098d048",
    "lastItemId": 19,
    "lastViewId": 1
}, {
    "id": "5a8aab0ae4b0e3b61098d0ce",
    "companyId": "5a86c97ce4b0b364a6138b1d",
    "views": [{
        "viewId": 1,
        "name": {
            "en": "One View Test"
        }
    }],
    "version": 16,
    "status": "inactive",
    "createdOn": "2018-02-19T10:46:34.063+0000",
    "createdBy": "5a8a9f6ce4b0e3b61098d048",
    "modifiedOn": "2018-02-19T10:49:21.324+0000",
    "modifiedBy": "5a8a9f6ce4b0e3b61098d048",
    "lastItemId": 24,
    "lastViewId": 1
}, {
    "id": "5a8aabaee4b0e3b61098d0e4",
    "companyId": "5a86c97ce4b0b364a6138b1d",
    "views": [{
        "viewId": 1,
        "name": {
            "en": "One View Test"
        }
    }],
    "version": 17,
    "status": "inactive",
    "createdOn": "2018-02-19T10:49:18.037+0000",
    "createdBy": "5a8a9f6ce4b0e3b61098d048",
    "modifiedOn": "2018-02-19T10:50:25.445+0000",
    "modifiedBy": "5a8a9f6ce4b0e3b61098d048",
    "lastItemId": 24,
    "lastViewId": 1
}, {
    "id": "5a8aabede4b0e3b61098d0fa",
    "companyId": "5a86c97ce4b0b364a6138b1d",
    "views": [{
        "viewId": 1,
        "name": {
            "en": "One View Test"
        }
    }],
    "version": 18,
    "status": "inactive",
    "createdOn": "2018-02-19T10:50:21.217+0000",
    "createdBy": "5a8a9f6ce4b0e3b61098d048",
    "modifiedOn": "2018-02-19T10:54:09.501+0000",
    "modifiedBy": "5a8a9f6ce4b0e3b61098d048",
    "lastItemId": 24,
    "lastViewId": 1
}, {
    "id": "5a8aaccee4b0e3b61098d110",
    "companyId": "5a86c97ce4b0b364a6138b1d",
    "views": [{
        "viewId": 1,
        "name": {
            "en": "One View Test"
        }
    }],
    "version": 19,
    "status": "inactive",
    "createdOn": "2018-02-19T10:54:06.907+0000",
    "createdBy": "5a8a9f6ce4b0e3b61098d048",
    "modifiedOn": "2018-02-19T10:55:33.041+0000",
    "modifiedBy": "5a8a9f6ce4b0e3b61098d048",
    "lastItemId": 30,
    "lastViewId": 1
}, {
    "id": "5a8aad21e4b0e3b61098d126",
    "companyId": "5a86c97ce4b0b364a6138b1d",
    "views": [{
        "viewId": 1,
        "name": {
            "en": "One View Test"
        }
    }],
    "version": 20,
    "status": "inactive",
    "createdOn": "2018-02-19T10:55:29.702+0000",
    "createdBy": "5a8a9f6ce4b0e3b61098d048",
    "modifiedOn": "2018-02-19T10:59:12.685+0000",
    "modifiedBy": "5a8a9f6ce4b0e3b61098d048",
    "lastItemId": 31,
    "lastViewId": 1
}, {
    "id": "5a8aadfde4b0e3b61098d13f",
    "companyId": "5a86c97ce4b0b364a6138b1d",
    "views": [{
        "viewId": 1,
        "name": {
            "en": "One View Test"
        }
    }],
    "version": 21,
    "status": "inactive",
    "createdOn": "2018-02-19T10:59:09.951+0000",
    "createdBy": "5a8a9f6ce4b0e3b61098d048",
    "modifiedOn": "2018-02-19T11:04:41.317+0000",
    "modifiedBy": "5a8a9f6ce4b0e3b61098d048",
    "lastItemId": 38,
    "lastViewId": 1
}, {
    "id": "5a8aaf46e4b0e3b61098d155",
    "companyId": "5a86c97ce4b0b364a6138b1d",
    "views": [{
        "viewId": 1,
        "name": {
            "en": "One View Test"
        }
    }],
    "version": 22,
    "status": "inactive",
    "createdOn": "2018-02-19T11:04:38.015+0000",
    "createdBy": "5a8a9f6ce4b0e3b61098d048",
    "modifiedOn": "2018-02-19T11:15:43.090+0000",
    "modifiedBy": "5a8a9f6ce4b0e3b61098d048",
    "lastItemId": 43,
    "lastViewId": 1
}, {
    "id": "5a8ab1d9e4b0e3b61098d16b",
    "companyId": "5a86c97ce4b0b364a6138b1d",
    "views": [{
        "viewId": 1,
        "name": {
            "en": "One View Test"
        }
    }],
    "version": 23,
    "status": "inactive",
    "createdOn": "2018-02-19T11:15:37.452+0000",
    "createdBy": "5a8a9f6ce4b0e3b61098d048",
    "modifiedOn": "2018-02-19T11:18:57.329+0000",
    "modifiedBy": "5a8a9f6ce4b0e3b61098d048",
    "lastItemId": 58,
    "lastViewId": 1
}, {
    "id": "5a8ab29de4b0e3b61098d181",
    "companyId": "5a86c97ce4b0b364a6138b1d",
    "views": [{
        "viewId": 1,
        "name": {
            "en": "One View Test"
        }
    }],
    "version": 24,
    "status": "inactive",
    "createdOn": "2018-02-19T11:18:53.745+0000",
    "createdBy": "5a8a9f6ce4b0e3b61098d048",
    "modifiedOn": "2018-02-19T11:25:23.247+0000",
    "modifiedBy": "5a8a9f6ce4b0e3b61098d048",
    "lastItemId": 64,
    "lastViewId": 1
}, {
    "id": "5a8ab418e4b0e3b61098d1a1",
    "companyId": "5a86c97ce4b0b364a6138b1d",
    "views": [{
        "viewId": 1,
        "name": {
            "en": "One View Test"
        }
    }],
    "version": 25,
    "status": "inactive",
    "createdOn": "2018-02-19T11:25:12.245+0000",
    "createdBy": "5a8a9f6ce4b0e3b61098d048",
    "modifiedOn": "2018-02-19T11:41:31.260+0000",
    "modifiedBy": "5a8a9f6ce4b0e3b61098d048",
    "lastItemId": 70,
    "lastViewId": 1
}, {
    "id": "5a8ab7e7e4b0e3b61098d1ba",
    "companyId": "5a86c97ce4b0b364a6138b1d",
    "views": [{
        "viewId": 1,
        "name": {
            "en": "One View Test"
        }
    }],
    "version": 26,
    "status": "inactive",
    "createdOn": "2018-02-19T11:41:27.344+0000",
    "createdBy": "5a8a9f6ce4b0e3b61098d048",
    "modifiedOn": "2018-02-19T11:48:27.494+0000",
    "modifiedBy": "5a8a9f6ce4b0e3b61098d048",
    "lastItemId": 79,
    "lastViewId": 1
}, {
    "id": "5a8ab988e4b0e3b61098d1d0",
    "companyId": "5a86c97ce4b0b364a6138b1d",
    "views": [{
        "viewId": 1,
        "name": {
            "en": "One View Test"
        }
    }],
    "version": 27,
    "status": "inactive",
    "createdOn": "2018-02-19T11:48:24.153+0000",
    "createdBy": "5a8a9f6ce4b0e3b61098d048",
    "modifiedOn": "2018-02-19T11:50:11.452+0000",
    "modifiedBy": "5a8a9f6ce4b0e3b61098d048",
    "lastItemId": 86,
    "lastViewId": 1
}, {
    "id": "5a8ab9ede4b0e3b61098d1e6",
    "companyId": "5a86c97ce4b0b364a6138b1d",
    "views": [{
        "viewId": 1,
        "name": {
            "en": "One View Test"
        }
    }],
    "version": 28,
    "status": "inactive",
    "createdOn": "2018-02-19T11:50:05.294+0000",
    "createdBy": "5a8a9f6ce4b0e3b61098d048",
    "modifiedOn": "2018-02-19T11:52:59.943+0000",
    "modifiedBy": "5a8a9f6ce4b0e3b61098d048",
    "lastItemId": 89,
    "lastViewId": 1
}, {
    "id": "5a8aba98e4b0e3b61098d1fc",
    "companyId": "5a86c97ce4b0b364a6138b1d",
    "views": [{
        "viewId": 1,
        "name": {
            "en": "One View Test"
        }
    }],
    "version": 29,
    "status": "inactive",
    "createdOn": "2018-02-19T11:52:56.565+0000",
    "createdBy": "5a8a9f6ce4b0e3b61098d048",
    "modifiedOn": "2018-02-19T11:55:30.931+0000",
    "modifiedBy": "5a8a9f6ce4b0e3b61098d048",
    "lastItemId": 94,
    "lastViewId": 1
}, {
    "id": "5a8abb09e4b0e3b61098d212",
    "companyId": "5a86c97ce4b0b364a6138b1d",
    "views": [{
        "viewId": 1,
        "name": {
            "en": "One View Test"
        }
    }],
    "version": 30,
    "status": "inactive",
    "createdOn": "2018-02-19T11:54:49.566+0000",
    "createdBy": "5a8a9f6ce4b0e3b61098d048",
    "modifiedOn": "2018-02-19T13:13:55.821+0000",
    "modifiedBy": "5a8acd47e4b0e3b61098d2fd",
    "lastItemId": 94,
    "lastViewId": 1
}, {
    "id": "5a8acd8ee4b0e3b61098d30a",
    "companyId": "5a86c97ce4b0b364a6138b1d",
    "views": [{
        "viewId": 1,
        "name": {
            "en": "One View Test"
        }
    }],
    "version": 31,
    "status": "inactive",
    "createdOn": "2018-02-19T13:13:50.610+0000",
    "createdBy": "5a8acd47e4b0e3b61098d2fd",
    "modifiedOn": "2018-02-19T14:46:16.716+0000",
    "modifiedBy": "5a8ae290e4b0e3b61098d42c",
    "lastItemId": 94,
    "lastViewId": 1
}, {
    "id": "5a8b11a4e4b0e3b61098d6bf",
    "companyId": "59dcd421e4b0bc51008ea0dc",
    "views": [{
        "viewId": 1,
        "name": {
            "de": "Online Bestellung",
            "en": "online order"
        }
    }, {
        "viewId": 2,
        "name": {
            "de": "Restaurant",
            "en": "Restaurant"
        }
    }, {
        "viewId": 3,
        "name": {
            "de": "Mittagsmenue",
            "en": "Lunch menu"
        }
    }, {
        "viewId": 4,
        "name": {
            "de": "Abholtheke",
            "en": "Take away"
        }
    }],
    "version": 45,
    "status": "active",
    "createdOn": "2018-02-19T18:04:20.864+0000",
    "createdBy": "5a8b116ce4b0e3b61098d6b0",
    "modifiedOn": "2018-02-19T18:04:23.316+0000",
    "modifiedBy": "59d224d88d60691acf763dba",
    "lastItemId": 6,
    "lastViewId": 4
}, {
    "id": "5a8bdc0ae4b0e3b61098d89c",
    "companyId": "5a6f089ee4b0ed8f57f2facc",
    "views": [{
        "viewId": 1,
        "name": {
            "en": "aaaaa"
        }
    }],
    "version": 15,
    "status": "created",
    "createdOn": "2018-02-20T08:27:54.549+0000",
    "createdBy": "5a8bd497e4b0e3b61098d880",
    "modifiedOn": "2018-02-20T08:27:54.549+0000",
    "modifiedBy": "5a8bd497e4b0e3b61098d880",
    "lastItemId": 3,
    "lastViewId": 1
}, {
    "id": "5a8bdc89e4b0e3b61098d8a9",
    "companyId": "5a6f089ee4b0ed8f57f2facc",
    "views": [{
        "viewId": 1,
        "name": {
            "en": "aaaaa"
        }
    }],
    "version": 16,
    "status": "created",
    "createdOn": "2018-02-20T08:30:01.132+0000",
    "createdBy": "5a8bd497e4b0e3b61098d880",
    "modifiedOn": "2018-02-20T08:30:01.132+0000",
    "modifiedBy": "5a8bd497e4b0e3b61098d880",
    "lastItemId": 3,
    "lastViewId": 1
}, {
    "id": "5a8c0527e4b0e3b61098d956",
    "companyId": "59dcd421e4b0bc51008ea0dc",
    "views": [{
        "viewId": 1,
        "name": {
            "de": "Online Bestellung",
            "en": "online order"
        }
    }, {
        "viewId": 2,
        "name": {
            "de": "Restaurant",
            "en": "Restaurant"
        }
    }, {
        "viewId": 3,
        "name": {
            "de": "Mittagsmenue",
            "en": "Lunch menu"
        }
    }, {
        "viewId": 4,
        "name": {
            "de": "Abholtheke",
            "en": "Take away"
        }
    }],
    "version": 46,
    "status": "created",
    "createdOn": "2018-02-20T11:23:19.952+0000",
    "createdBy": "5a8c0515e4b0e3b61098d949",
    "modifiedOn": "2018-02-20T11:23:19.952+0000",
    "modifiedBy": "5a8c0515e4b0e3b61098d949",
    "lastItemId": 6,
    "lastViewId": 4
}, {
    "id": "5a8ad043e4b0e3b61098d32c",
    "companyId": "5a57c093e4b06683979bf4a7",
    "views": [{
        "viewId": 1,
        "name": {
            "en": "Restaurant"
        }
    }, {
        "viewId": 2,
        "name": {
            "en": "Take awy"
        }
    }, {
        "viewId": 3,
        "name": {
            "en": "Drinks"
        }
    }],
    "version": 25,
    "status": "inactive",
    "createdOn": "2018-02-19T13:25:23.425+0000",
    "createdBy": "5a8aced0e4b0e3b61098d31f",
    "modifiedOn": "2018-02-19T13:35:48.677+0000",
    "modifiedBy": "5a8aced0e4b0e3b61098d31f",
    "lastItemId": 341,
    "lastViewId": 3
}, {
    "id": "5a8ad2ace4b0e3b61098d345",
    "companyId": "5a57c093e4b06683979bf4a7",
    "views": [{
        "viewId": 1,
        "name": {
            "en": "Restaurant"
        }
    }, {
        "viewId": 2,
        "name": {
            "en": "Take awy"
        }
    }, {
        "viewId": 3,
        "name": {
            "en": "Drinks"
        }
    }],
    "version": 26,
    "status": "inactive",
    "createdOn": "2018-02-19T13:35:40.503+0000",
    "createdBy": "5a8aced0e4b0e3b61098d31f",
    "modifiedOn": "2018-02-19T13:40:34.243+0000",
    "modifiedBy": "5a8aced0e4b0e3b61098d31f",
    "lastItemId": 342,
    "lastViewId": 3
}, {
    "id": "5a8ad3cde4b0e3b61098d365",
    "companyId": "5a57c093e4b06683979bf4a7",
    "views": [{
        "viewId": 1,
        "name": {
            "en": "Restaurant"
        }
    }, {
        "viewId": 2,
        "name": {
            "en": "Take awy"
        }
    }, {
        "viewId": 3,
        "name": {
            "en": "Drinks"
        }
    }],
    "version": 27,
    "status": "inactive",
    "createdOn": "2018-02-19T13:40:29.133+0000",
    "createdBy": "5a8aced0e4b0e3b61098d31f",
    "modifiedOn": "2018-02-19T13:47:40.512+0000",
    "modifiedBy": "5a8aced0e4b0e3b61098d31f",
    "lastItemId": 342,
    "lastViewId": 3
}, {
    "id": "5a8ad575e4b0e3b61098d37b",
    "companyId": "5a57c093e4b06683979bf4a7",
    "views": [{
        "viewId": 1,
        "name": {
            "en": "Restaurant"
        }
    }, {
        "viewId": 2,
        "name": {
            "en": "Take awy"
        }
    }, {
        "viewId": 3,
        "name": {
            "en": "Drinks"
        }
    }],
    "version": 28,
    "status": "inactive",
    "createdOn": "2018-02-19T13:47:33.829+0000",
    "createdBy": "5a8aced0e4b0e3b61098d31f",
    "modifiedOn": "2018-02-19T14:03:55.615+0000",
    "modifiedBy": "5a8ad930e4b0e3b61098d3ac",
    "lastItemId": 345,
    "lastViewId": 3
}, {
    "id": "5a8ad5c9e4b0e3b61098d391",
    "companyId": "5a57c093e4b06683979bf4a7",
    "views": [{
        "viewId": 1,
        "name": {
            "en": "Restaurant"
        }
    }, {
        "viewId": 2,
        "name": {
            "en": "Take awy"
        }
    }, {
        "viewId": 3,
        "name": {
            "en": "Drinks"
        }
    }],
    "version": 29,
    "status": "created",
    "createdOn": "2018-02-19T13:48:57.501+0000",
    "createdBy": "5a8aced0e4b0e3b61098d31f",
    "modifiedOn": "2018-02-19T13:48:57.501+0000",
    "modifiedBy": "5a8aced0e4b0e3b61098d31f",
    "lastItemId": 345,
    "lastViewId": 3
}, {
    "id": "5a8ad7f7e4b0e3b61098d39e",
    "companyId": "5a57c093e4b06683979bf4a7",
    "views": [{
        "viewId": 1,
        "name": {
            "en": "Restaurant"
        }
    }, {
        "viewId": 2,
        "name": {
            "en": "Take awy"
        }
    }, {
        "viewId": 3,
        "name": {
            "en": "Drinks"
        }
    }],
    "version": 30,
    "status": "created",
    "createdOn": "2018-02-19T13:58:15.282+0000",
    "createdBy": "5a8aced0e4b0e3b61098d31f",
    "modifiedOn": "2018-02-19T13:58:15.282+0000",
    "modifiedBy": "5a8aced0e4b0e3b61098d31f",
    "lastItemId": 345,
    "lastViewId": 3
}, {
    "id": "5a8ad7fde4b0e3b61098d3a5",
    "companyId": "5a57c093e4b06683979bf4a7",
    "views": [{
        "viewId": 1,
        "name": {
            "en": "Restaurant"
        }
    }, {
        "viewId": 2,
        "name": {
            "en": "Take awy"
        }
    }, {
        "viewId": 3,
        "name": {
            "en": "Drinks"
        }
    }],
    "version": 31,
    "status": "inactive",
    "createdOn": "2018-02-19T13:58:21.950+0000",
    "createdBy": "5a8aced0e4b0e3b61098d31f",
    "modifiedOn": "2018-02-19T14:06:28.176+0000",
    "modifiedBy": "5a8ad930e4b0e3b61098d3ac",
    "lastItemId": 345,
    "lastViewId": 3
}, {
    "id": "5a8ad9dfe4b0e3b61098d3c2",
    "companyId": "5a57c093e4b06683979bf4a7",
    "views": [{
        "viewId": 1,
        "name": {
            "en": "Restaurant"
        }
    }, {
        "viewId": 2,
        "name": {
            "en": "Take awy"
        }
    }, {
        "viewId": 3,
        "name": {
            "en": "Drinks"
        }
    }],
    "version": 32,
    "status": "inactive",
    "createdOn": "2018-02-19T14:06:23.051+0000",
    "createdBy": "5a8ad930e4b0e3b61098d3ac",
    "modifiedOn": "2018-02-19T14:09:14.356+0000",
    "modifiedBy": "5a8ad930e4b0e3b61098d3ac",
    "lastItemId": 345,
    "lastViewId": 3
}, {
    "id": "5a8ada84e4b0e3b61098d3d6",
    "companyId": "5a57c093e4b06683979bf4a7",
    "views": [{
        "viewId": 1,
        "name": {
            "en": "Restaurant"
        }
    }, {
        "viewId": 2,
        "name": {
            "en": "Take awy"
        }
    }, {
        "viewId": 3,
        "name": {
            "en": "Drinks"
        }
    }],
    "version": 33,
    "status": "inactive",
    "createdOn": "2018-02-19T14:09:08.014+0000",
    "createdBy": "5a8ad930e4b0e3b61098d3ac",
    "modifiedOn": "2018-02-19T14:18:01.515+0000",
    "modifiedBy": "5a8ad930e4b0e3b61098d3ac",
    "lastItemId": 345,
    "lastViewId": 3
}, {
    "id": "5a8adc96e4b0e3b61098d3eb",
    "companyId": "5a57c093e4b06683979bf4a7",
    "views": [{
        "viewId": 1,
        "name": {
            "en": "Restaurant"
        }
    }, {
        "viewId": 2,
        "name": {
            "en": "Take awy"
        }
    }, {
        "viewId": 3,
        "name": {
            "en": "Drinks"
        }
    }],
    "version": 34,
    "status": "inactive",
    "createdOn": "2018-02-19T14:17:58.292+0000",
    "createdBy": "5a8ad930e4b0e3b61098d3ac",
    "modifiedOn": "2018-02-19T15:13:58.405+0000",
    "modifiedBy": "5a8ae964e4b0e3b61098d491",
    "lastItemId": 347,
    "lastViewId": 3
}, {
    "id": "5a8ae334e4b0e3b61098d439",
    "companyId": "5a86c97ce4b0b364a6138b1d",
    "views": [{
        "viewId": 1,
        "name": {
            "en": "One View Test"
        }
    }],
    "version": 32,
    "status": "inactive",
    "createdOn": "2018-02-19T14:46:12.438+0000",
    "createdBy": "5a8ae290e4b0e3b61098d42c",
    "modifiedOn": "2018-02-23T13:41:39.650+0000",
    "modifiedBy": "5a9019b8e4b0aafe8d0fa1c9",
    "lastItemId": 94,
    "lastViewId": 1
}, {
    "id": "5a8ae39fe4b0e3b61098d460",
    "companyId": "5a86c97ce4b0b364a6138b1d",
    "views": [{
        "viewId": 1,
        "name": {
            "en": "One View Test"
        }
    }],
    "version": 33,
    "status": "created",
    "createdOn": "2018-02-19T14:47:59.628+0000",
    "createdBy": "5a8ae382e4b0e3b61098d453",
    "modifiedOn": "2018-02-19T14:47:59.628+0000",
    "modifiedBy": "5a8ae382e4b0e3b61098d453",
    "lastItemId": 94,
    "lastViewId": 1
}, {
    "id": "5a8ae9b1e4b0e3b61098d49e",
    "companyId": "5a57c093e4b06683979bf4a7",
    "views": [{
        "viewId": 1,
        "name": {
            "en": "Restaurant"
        }
    }, {
        "viewId": 2,
        "name": {
            "en": "Take awy"
        }
    }, {
        "viewId": 3,
        "name": {
            "en": "Drinks"
        }
    }],
    "version": 35,
    "status": "inactive",
    "createdOn": "2018-02-19T15:13:53.864+0000",
    "createdBy": "5a8ae964e4b0e3b61098d491",
    "modifiedOn": "2018-02-19T15:15:29.956+0000",
    "modifiedBy": "5a8ae964e4b0e3b61098d491",
    "lastItemId": 347,
    "lastViewId": 3
}, {
    "id": "5a8aea0ee4b0e3b61098d4b2",
    "companyId": "5a57c093e4b06683979bf4a7",
    "views": [{
        "viewId": 1,
        "name": {
            "en": "Restaurant"
        }
    }, {
        "viewId": 2,
        "name": {
            "en": "Take awy"
        }
    }, {
        "viewId": 3,
        "name": {
            "en": "Drinks"
        }
    }],
    "version": 36,
    "status": "inactive",
    "createdOn": "2018-02-19T15:15:26.015+0000",
    "createdBy": "5a8ae964e4b0e3b61098d491",
    "modifiedOn": "2018-02-19T15:17:13.337+0000",
    "modifiedBy": "5a8ae964e4b0e3b61098d491",
    "lastItemId": 348,
    "lastViewId": 3
}, {
    "id": "5a8aea76e4b0e3b61098d4c5",
    "companyId": "5a57c093e4b06683979bf4a7",
    "views": [{
        "viewId": 1,
        "name": {
            "en": "Restaurant"
        }
    }, {
        "viewId": 2,
        "name": {
            "en": "Take awy"
        }
    }, {
        "viewId": 3,
        "name": {
            "en": "Drinks"
        }
    }],
    "version": 37,
    "status": "inactive",
    "createdOn": "2018-02-19T15:17:10.336+0000",
    "createdBy": "5a8ae964e4b0e3b61098d491",
    "modifiedOn": "2018-02-19T15:19:41.287+0000",
    "modifiedBy": "5a8ae964e4b0e3b61098d491",
    "lastItemId": 349,
    "lastViewId": 3
}, {
    "id": "5a8aeafbe4b0e3b61098d4da",
    "companyId": "5a57c093e4b06683979bf4a7",
    "views": [{
        "viewId": 1,
        "name": {
            "en": "Restaurant"
        }
    }, {
        "viewId": 2,
        "name": {
            "en": "Take awy"
        }
    }, {
        "viewId": 3,
        "name": {
            "en": "Drinks"
        }
    }],
    "version": 38,
    "status": "inactive",
    "createdOn": "2018-02-19T15:19:23.315+0000",
    "createdBy": "5a8ae964e4b0e3b61098d491",
    "modifiedOn": "2018-02-19T15:27:27.520+0000",
    "modifiedBy": "5a8ae964e4b0e3b61098d491",
    "lastItemId": 350,
    "lastViewId": 3
}, {
    "id": "5a8aecdce4b0e3b61098d4f0",
    "companyId": "5a57c093e4b06683979bf4a7",
    "views": [{
        "viewId": 1,
        "name": {
            "en": "Restaurant"
        }
    }, {
        "viewId": 2,
        "name": {
            "en": "Take awy"
        }
    }, {
        "viewId": 3,
        "name": {
            "en": "Drinks"
        }
    }],
    "version": 39,
    "status": "inactive",
    "createdOn": "2018-02-19T15:27:24.846+0000",
    "createdBy": "5a8ae964e4b0e3b61098d491",
    "modifiedOn": "2018-02-19T15:33:17.175+0000",
    "modifiedBy": "5a8ae964e4b0e3b61098d491",
    "lastItemId": 354,
    "lastViewId": 3
}, {
    "id": "5a8aee3ae4b0e3b61098d509",
    "companyId": "5a57c093e4b06683979bf4a7",
    "views": [{
        "viewId": 1,
        "name": {
            "en": "Restaurant"
        }
    }, {
        "viewId": 2,
        "name": {
            "en": "Take awy"
        }
    }, {
        "viewId": 3,
        "name": {
            "en": "Drinks"
        }
    }],
    "version": 40,
    "status": "inactive",
    "createdOn": "2018-02-19T15:33:14.464+0000",
    "createdBy": "5a8ae964e4b0e3b61098d491",
    "modifiedOn": "2018-02-19T15:37:17.218+0000",
    "modifiedBy": "5a8ae964e4b0e3b61098d491",
    "lastItemId": 360,
    "lastViewId": 3
}, {
    "id": "5a8aef2ae4b0e3b61098d51d",
    "companyId": "5a57c093e4b06683979bf4a7",
    "views": [{
        "viewId": 1,
        "name": {
            "en": "Restaurant"
        }
    }, {
        "viewId": 2,
        "name": {
            "en": "Take awy"
        }
    }, {
        "viewId": 3,
        "name": {
            "en": "Drinks"
        }
    }],
    "version": 41,
    "status": "inactive",
    "createdOn": "2018-02-19T15:37:14.613+0000",
    "createdBy": "5a8ae964e4b0e3b61098d491",
    "modifiedOn": "2018-02-19T15:41:50.159+0000",
    "modifiedBy": "5a8ae964e4b0e3b61098d491",
    "lastItemId": 360,
    "lastViewId": 3
}, {
    "id": "5a8af03be4b0e3b61098d532",
    "companyId": "5a57c093e4b06683979bf4a7",
    "views": [{
        "viewId": 1,
        "name": {
            "en": "Restaurant"
        }
    }, {
        "viewId": 2,
        "name": {
            "en": "Take awy"
        }
    }, {
        "viewId": 3,
        "name": {
            "en": "Drinks"
        }
    }],
    "version": 42,
    "status": "inactive",
    "createdOn": "2018-02-19T15:41:47.774+0000",
    "createdBy": "5a8ae964e4b0e3b61098d491",
    "modifiedOn": "2018-02-19T15:46:48.563+0000",
    "modifiedBy": "5a8ae964e4b0e3b61098d491",
    "lastItemId": 363,
    "lastViewId": 3
}, {
    "id": "5a8af165e4b0e3b61098d548",
    "companyId": "5a57c093e4b06683979bf4a7",
    "views": [{
        "viewId": 1,
        "name": {
            "en": "Restaurant"
        }
    }, {
        "viewId": 2,
        "name": {
            "en": "Take awy"
        }
    }, {
        "viewId": 3,
        "name": {
            "en": "Drinks"
        }
    }],
    "version": 43,
    "status": "inactive",
    "createdOn": "2018-02-19T15:46:45.070+0000",
    "createdBy": "5a8ae964e4b0e3b61098d491",
    "modifiedOn": "2018-02-19T15:53:39.994+0000",
    "modifiedBy": "5a8ae964e4b0e3b61098d491",
    "lastItemId": 367,
    "lastViewId": 3
}, {
    "id": "5a8af300e4b0e3b61098d55e",
    "companyId": "5a57c093e4b06683979bf4a7",
    "views": [{
        "viewId": 1,
        "name": {
            "en": "Restaurant"
        }
    }, {
        "viewId": 2,
        "name": {
            "en": "Take awy"
        }
    }, {
        "viewId": 3,
        "name": {
            "en": "Drinks"
        }
    }],
    "version": 44,
    "status": "inactive",
    "createdOn": "2018-02-19T15:53:36.036+0000",
    "createdBy": "5a8ae964e4b0e3b61098d491",
    "modifiedOn": "2018-02-19T16:01:56.009+0000",
    "modifiedBy": "5a8ae964e4b0e3b61098d491",
    "lastItemId": 371,
    "lastViewId": 3
}, {
    "id": "5a8af4f1e4b0e3b61098d574",
    "companyId": "5a57c093e4b06683979bf4a7",
    "views": [{
        "viewId": 1,
        "name": {
            "en": "Restaurant"
        }
    }, {
        "viewId": 2,
        "name": {
            "en": "Take awy"
        }
    }, {
        "viewId": 3,
        "name": {
            "en": "Drinks"
        }
    }],
    "version": 45,
    "status": "inactive",
    "createdOn": "2018-02-19T16:01:53.557+0000",
    "createdBy": "5a8ae964e4b0e3b61098d491",
    "modifiedOn": "2018-02-19T16:11:29.480+0000",
    "modifiedBy": "5a8ae964e4b0e3b61098d491",
    "lastItemId": 375,
    "lastViewId": 3
}, {
    "id": "5a8af6b9e4b0e3b61098d58d",
    "companyId": "5a57c093e4b06683979bf4a7",
    "views": [{
        "viewId": 1,
        "name": {
            "en": "Restaurant"
        }
    }, {
        "viewId": 2,
        "name": {
            "en": "Take awy"
        }
    }, {
        "viewId": 3,
        "name": {
            "en": "Drinks"
        }
    }],
    "version": 46,
    "status": "inactive",
    "createdOn": "2018-02-19T16:09:29.374+0000",
    "createdBy": "5a8ae964e4b0e3b61098d491",
    "modifiedOn": "2018-02-19T16:23:18.859+0000",
    "modifiedBy": "5a8ae964e4b0e3b61098d491",
    "lastItemId": 379,
    "lastViewId": 3
}, {
    "id": "5a8af9f3e4b0e3b61098d5a3",
    "companyId": "5a57c093e4b06683979bf4a7",
    "views": [{
        "viewId": 1,
        "name": {
            "en": "Restaurant"
        }
    }, {
        "viewId": 2,
        "name": {
            "en": "Take awy"
        }
    }, {
        "viewId": 3,
        "name": {
            "en": "Drinks"
        }
    }],
    "version": 47,
    "status": "inactive",
    "createdOn": "2018-02-19T16:23:15.747+0000",
    "createdBy": "5a8ae964e4b0e3b61098d491",
    "modifiedOn": "2018-02-19T16:49:14.758+0000",
    "modifiedBy": "5a8ae964e4b0e3b61098d491",
    "lastItemId": 394,
    "lastViewId": 3
}, {
    "id": "5a8b0006e4b0e3b61098d5bc",
    "companyId": "5a57c093e4b06683979bf4a7",
    "views": [{
        "viewId": 1,
        "name": {
            "en": "Restaurant"
        }
    }, {
        "viewId": 2,
        "name": {
            "en": "Take awy"
        }
    }, {
        "viewId": 3,
        "name": {
            "en": "Drinks"
        }
    }],
    "version": 48,
    "status": "inactive",
    "createdOn": "2018-02-19T16:49:10.752+0000",
    "createdBy": "5a8ae964e4b0e3b61098d491",
    "modifiedOn": "2018-02-19T17:06:52.852+0000",
    "modifiedBy": "5a8ae964e4b0e3b61098d491",
    "lastItemId": 408,
    "lastViewId": 3
}, {
    "id": "5a8b0426e4b0e3b61098d5d5",
    "companyId": "5a57c093e4b06683979bf4a7",
    "views": [{
        "viewId": 1,
        "name": {
            "en": "Restaurant"
        }
    }, {
        "viewId": 2,
        "name": {
            "en": "Take awy"
        }
    }, {
        "viewId": 3,
        "name": {
            "en": "Drinks"
        }
    }],
    "version": 49,
    "status": "inactive",
    "createdOn": "2018-02-19T17:06:46.608+0000",
    "createdBy": "5a8ae964e4b0e3b61098d491",
    "modifiedOn": "2018-02-19T17:14:23.688+0000",
    "modifiedBy": "5a8b0515e4b0e3b61098d5eb",
    "lastItemId": 418,
    "lastViewId": 3
}, {
    "id": "5a8b05e8e4b0e3b61098d5f8",
    "companyId": "5a57c093e4b06683979bf4a7",
    "views": [{
        "viewId": 1,
        "name": {
            "en": "Restaurant"
        }
    }, {
        "viewId": 2,
        "name": {
            "en": "Take awy"
        }
    }, {
        "viewId": 3,
        "name": {
            "en": "Drinks"
        }
    }],
    "version": 50,
    "status": "inactive",
    "createdOn": "2018-02-19T17:14:16.508+0000",
    "createdBy": "5a8b0515e4b0e3b61098d5eb",
    "modifiedOn": "2018-02-19T17:15:39.480+0000",
    "modifiedBy": "5a8b0515e4b0e3b61098d5eb",
    "lastItemId": 418,
    "lastViewId": 3
}, {
    "id": "5a8b0634e4b0e3b61098d60e",
    "companyId": "5a57c093e4b06683979bf4a7",
    "views": [{
        "viewId": 1,
        "name": {
            "en": "Restaurant"
        }
    }, {
        "viewId": 2,
        "name": {
            "en": "Take awy"
        }
    }, {
        "viewId": 3,
        "name": {
            "en": "Drinks"
        }
    }],
    "version": 51,
    "status": "inactive",
    "createdOn": "2018-02-19T17:15:32.938+0000",
    "createdBy": "5a8b0515e4b0e3b61098d5eb",
    "modifiedOn": "2018-02-19T17:16:31.738+0000",
    "modifiedBy": "5a8b0515e4b0e3b61098d5eb",
    "lastItemId": 418,
    "lastViewId": 3
}, {
    "id": "5a8b0668e4b0e3b61098d622",
    "companyId": "5a57c093e4b06683979bf4a7",
    "views": [{
        "viewId": 1,
        "name": {
            "en": "Restaurant"
        }
    }, {
        "viewId": 2,
        "name": {
            "en": "Take awy"
        }
    }, {
        "viewId": 3,
        "name": {
            "en": "Drinks"
        }
    }],
    "version": 52,
    "status": "inactive",
    "createdOn": "2018-02-19T17:16:24.109+0000",
    "createdBy": "5a8b0515e4b0e3b61098d5eb",
    "modifiedOn": "2018-02-19T17:48:21.073+0000",
    "modifiedBy": "5a8b0ca5e4b0e3b61098d635",
    "lastItemId": 418,
    "lastViewId": 3
}, {
    "id": "5a8b0de2e4b0e3b61098d642",
    "companyId": "5a57c093e4b06683979bf4a7",
    "views": [{
        "viewId": 1,
        "name": {
            "en": "Restaurant"
        }
    }, {
        "viewId": 2,
        "name": {
            "en": "Take awy"
        }
    }, {
        "viewId": 3,
        "name": {
            "en": "Drinks"
        }
    }],
    "version": 53,
    "status": "inactive",
    "createdOn": "2018-02-19T17:48:18.109+0000",
    "createdBy": "5a8b0ca5e4b0e3b61098d635",
    "modifiedOn": "2018-02-19T17:51:24.489+0000",
    "modifiedBy": "5a8b0ca5e4b0e3b61098d635",
    "lastItemId": 419,
    "lastViewId": 3
}, {
    "id": "5a8b0e98e4b0e3b61098d658",
    "companyId": "5a57c093e4b06683979bf4a7",
    "views": [{
        "viewId": 1,
        "name": {
            "en": "Restaurant"
        }
    }, {
        "viewId": 2,
        "name": {
            "en": "Take awy"
        }
    }, {
        "viewId": 3,
        "name": {
            "en": "Drinks"
        }
    }],
    "version": 54,
    "status": "inactive",
    "createdOn": "2018-02-19T17:51:20.914+0000",
    "createdBy": "5a8b0ca5e4b0e3b61098d635",
    "modifiedOn": "2018-02-19T17:55:43.067+0000",
    "modifiedBy": "5a8b0ca5e4b0e3b61098d635",
    "lastItemId": 420,
    "lastViewId": 3
}, {
    "id": "5a8b0f9ce4b0e3b61098d66e",
    "companyId": "5a57c093e4b06683979bf4a7",
    "views": [{
        "viewId": 1,
        "name": {
            "en": "Restaurant"
        }
    }, {
        "viewId": 2,
        "name": {
            "en": "Take awy"
        }
    }, {
        "viewId": 3,
        "name": {
            "en": "Drinks"
        }
    }],
    "version": 55,
    "status": "inactive",
    "createdOn": "2018-02-19T17:55:40.317+0000",
    "createdBy": "5a8b0ca5e4b0e3b61098d635",
    "modifiedOn": "2018-02-19T17:58:03.768+0000",
    "modifiedBy": "5a8b0ca5e4b0e3b61098d635",
    "lastItemId": 422,
    "lastViewId": 3
}, {
    "id": "5a8b1028e4b0e3b61098d682",
    "companyId": "5a57c093e4b06683979bf4a7",
    "views": [{
        "viewId": 1,
        "name": {
            "en": "Restaurant"
        }
    }, {
        "viewId": 2,
        "name": {
            "en": "Take awy"
        }
    }, {
        "viewId": 3,
        "name": {
            "en": "Drinks"
        }
    }],
    "version": 56,
    "status": "inactive",
    "createdOn": "2018-02-19T17:58:00.394+0000",
    "createdBy": "5a8b0ca5e4b0e3b61098d635",
    "modifiedOn": "2018-02-19T18:02:54.689+0000",
    "modifiedBy": "5a8b0ca5e4b0e3b61098d635",
    "lastItemId": 422,
    "lastViewId": 3
}, {
    "id": "5a8b114be4b0e3b61098d69c",
    "companyId": "5a57c093e4b06683979bf4a7",
    "views": [{
        "viewId": 1,
        "name": {
            "en": "Restaurant"
        }
    }, {
        "viewId": 2,
        "name": {
            "en": "Take awy"
        }
    }, {
        "viewId": 3,
        "name": {
            "en": "Drinks"
        }
    }],
    "version": 57,
    "status": "inactive",
    "createdOn": "2018-02-19T18:02:51.215+0000",
    "createdBy": "5a8b0ca5e4b0e3b61098d635",
    "modifiedOn": "2018-02-19T18:08:02.353+0000",
    "modifiedBy": "5a8b0ca5e4b0e3b61098d635",
    "lastItemId": 423,
    "lastViewId": 3
}, {
    "id": "5a8b127ee4b0e3b61098d6d5",
    "companyId": "5a57c093e4b06683979bf4a7",
    "views": [{
        "viewId": 1,
        "name": {
            "en": "Restaurant"
        }
    }, {
        "viewId": 2,
        "name": {
            "en": "Take awy"
        }
    }, {
        "viewId": 3,
        "name": {
            "en": "Drinks"
        }
    }],
    "version": 58,
    "status": "inactive",
    "createdOn": "2018-02-19T18:07:58.958+0000",
    "createdBy": "5a8b0ca5e4b0e3b61098d635",
    "modifiedOn": "2018-02-19T18:11:38.219+0000",
    "modifiedBy": "5a8b12cbe4b0e3b61098d6e9",
    "lastItemId": 424,
    "lastViewId": 3
}, {
    "id": "5a8b1353e4b0e3b61098d6f6",
    "companyId": "5a57c093e4b06683979bf4a7",
    "views": [{
        "viewId": 1,
        "name": {
            "en": "Restaurant"
        }
    }, {
        "viewId": 2,
        "name": {
            "en": "Take awy"
        }
    }, {
        "viewId": 3,
        "name": {
            "en": "Drinks"
        }
    }],
    "version": 59,
    "status": "inactive",
    "createdOn": "2018-02-19T18:11:31.048+0000",
    "createdBy": "5a8b12cbe4b0e3b61098d6e9",
    "modifiedOn": "2018-02-19T18:14:28.966+0000",
    "modifiedBy": "5a8b12cbe4b0e3b61098d6e9",
    "lastItemId": 425,
    "lastViewId": 3
}, {
    "id": "5a8b13ffe4b0e3b61098d70c",
    "companyId": "5a57c093e4b06683979bf4a7",
    "views": [{
        "viewId": 1,
        "name": {
            "en": "Restaurant"
        }
    }, {
        "viewId": 2,
        "name": {
            "en": "Take awy"
        }
    }, {
        "viewId": 3,
        "name": {
            "en": "Drinks"
        }
    }],
    "version": 60,
    "status": "inactive",
    "createdOn": "2018-02-19T18:14:23.957+0000",
    "createdBy": "5a8b12cbe4b0e3b61098d6e9",
    "modifiedOn": "2018-02-19T18:16:10.543+0000",
    "modifiedBy": "5a8b12cbe4b0e3b61098d6e9",
    "lastItemId": 426,
    "lastViewId": 3
}, {
    "id": "5a8b1466e4b0e3b61098d720",
    "companyId": "5a57c093e4b06683979bf4a7",
    "views": [{
        "viewId": 1,
        "name": {
            "en": "Restaurant"
        }
    }, {
        "viewId": 2,
        "name": {
            "en": "Take awy"
        }
    }, {
        "viewId": 3,
        "name": {
            "en": "Drinks"
        }
    }],
    "version": 61,
    "status": "inactive",
    "createdOn": "2018-02-19T18:16:06.062+0000",
    "createdBy": "5a8b12cbe4b0e3b61098d6e9",
    "modifiedOn": "2018-02-19T18:31:28.929+0000",
    "modifiedBy": "5a8b1735e4b0e3b61098d764",
    "lastItemId": 427,
    "lastViewId": 3
}, {
    "id": "5a8b17c4e4b0e3b61098d771",
    "companyId": "5a57c093e4b06683979bf4a7",
    "views": [{
        "viewId": 1,
        "name": {
            "en": "Restaurant"
        }
    }, {
        "viewId": 2,
        "name": {
            "en": "Take awy"
        }
    }, {
        "viewId": 3,
        "name": {
            "en": "Drinks"
        }
    }],
    "version": 62,
    "status": "inactive",
    "createdOn": "2018-02-19T18:30:28.872+0000",
    "createdBy": "5a8b1735e4b0e3b61098d764",
    "modifiedOn": "2018-02-19T18:33:19.366+0000",
    "modifiedBy": "5a8b1735e4b0e3b61098d764",
    "lastItemId": 428,
    "lastViewId": 3
}, {
    "id": "5a8b186be4b0e3b61098d78a",
    "companyId": "5a57c093e4b06683979bf4a7",
    "views": [{
        "viewId": 1,
        "name": {
            "en": "Restaurant"
        }
    }, {
        "viewId": 2,
        "name": {
            "en": "Take awy"
        }
    }, {
        "viewId": 3,
        "name": {
            "en": "Drinks"
        }
    }],
    "version": 63,
    "status": "inactive",
    "createdOn": "2018-02-19T18:33:15.640+0000",
    "createdBy": "5a8b1735e4b0e3b61098d764",
    "modifiedOn": "2018-02-19T18:36:30.347+0000",
    "modifiedBy": "5a8b1735e4b0e3b61098d764",
    "lastItemId": 430,
    "lastViewId": 3
}, {
    "id": "5a8b192be4b0e3b61098d79e",
    "companyId": "5a57c093e4b06683979bf4a7",
    "views": [{
        "viewId": 1,
        "name": {
            "en": "Restaurant"
        }
    }, {
        "viewId": 2,
        "name": {
            "en": "Take awy"
        }
    }, {
        "viewId": 3,
        "name": {
            "en": "Drinks"
        }
    }],
    "version": 64,
    "status": "inactive",
    "createdOn": "2018-02-19T18:36:27.758+0000",
    "createdBy": "5a8b1735e4b0e3b61098d764",
    "modifiedOn": "2018-02-19T18:38:57.501+0000",
    "modifiedBy": "5a8b1735e4b0e3b61098d764",
    "lastItemId": 433,
    "lastViewId": 3
}, {
    "id": "5a8b19bde4b0e3b61098d7b3",
    "companyId": "5a57c093e4b06683979bf4a7",
    "views": [{
        "viewId": 1,
        "name": {
            "en": "Restaurant"
        }
    }, {
        "viewId": 2,
        "name": {
            "en": "Take awy"
        }
    }, {
        "viewId": 3,
        "name": {
            "en": "Drinks"
        }
    }],
    "version": 65,
    "status": "inactive",
    "createdOn": "2018-02-19T18:38:53.700+0000",
    "createdBy": "5a8b1735e4b0e3b61098d764",
    "modifiedOn": "2018-02-19T18:40:50.361+0000",
    "modifiedBy": "5a8b1735e4b0e3b61098d764",
    "lastItemId": 436,
    "lastViewId": 3
}, {
    "id": "5a8b1a2fe4b0e3b61098d7c7",
    "companyId": "5a57c093e4b06683979bf4a7",
    "views": [{
        "viewId": 1,
        "name": {
            "en": "Restaurant"
        }
    }, {
        "viewId": 2,
        "name": {
            "en": "Take awy"
        }
    }, {
        "viewId": 3,
        "name": {
            "en": "Drinks"
        }
    }],
    "version": 66,
    "status": "inactive",
    "createdOn": "2018-02-19T18:40:47.911+0000",
    "createdBy": "5a8b1735e4b0e3b61098d764",
    "modifiedOn": "2018-02-19T18:43:00.808+0000",
    "modifiedBy": "5a8b1735e4b0e3b61098d764",
    "lastItemId": 439,
    "lastViewId": 3
}, {
    "id": "5a8b1aabe4b0e3b61098d7dc",
    "companyId": "5a57c093e4b06683979bf4a7",
    "views": [{
        "viewId": 1,
        "name": {
            "en": "Restaurant"
        }
    }, {
        "viewId": 2,
        "name": {
            "en": "Take awy"
        }
    }, {
        "viewId": 3,
        "name": {
            "en": "Drinks"
        }
    }],
    "version": 67,
    "status": "inactive",
    "createdOn": "2018-02-19T18:42:51.963+0000",
    "createdBy": "5a8b1735e4b0e3b61098d764",
    "modifiedOn": "2018-02-19T18:50:31.822+0000",
    "modifiedBy": "5a8b1735e4b0e3b61098d764",
    "lastItemId": 440,
    "lastViewId": 3
}, {
    "id": "5a8b1c74e4b0e3b61098d7f2",
    "companyId": "5a57c093e4b06683979bf4a7",
    "views": [{
        "viewId": 1,
        "name": {
            "en": "Restaurant"
        }
    }, {
        "viewId": 2,
        "name": {
            "en": "Take awy"
        }
    }, {
        "viewId": 3,
        "name": {
            "en": "Drinks"
        }
    }],
    "version": 68,
    "status": "inactive",
    "createdOn": "2018-02-19T18:50:27.995+0000",
    "createdBy": "5a8b1735e4b0e3b61098d764",
    "modifiedOn": "2018-02-19T18:56:07.057+0000",
    "modifiedBy": "5a8b1735e4b0e3b61098d764",
    "lastItemId": 444,
    "lastViewId": 3
}, {
    "id": "5a8b1dc2e4b0e3b61098d808",
    "companyId": "5a57c093e4b06683979bf4a7",
    "views": [{
        "viewId": 1,
        "name": {
            "en": "Restaurant"
        }
    }, {
        "viewId": 2,
        "name": {
            "en": "Take awy"
        }
    }, {
        "viewId": 3,
        "name": {
            "en": "Drinks"
        }
    }],
    "version": 69,
    "status": "active",
    "createdOn": "2018-02-19T18:56:02.413+0000",
    "createdBy": "5a8b1735e4b0e3b61098d764",
    "modifiedOn": "2018-02-19T18:56:06.994+0000",
    "modifiedBy": "5a5805ba922eb20435b28e88",
    "lastItemId": 444,
    "lastViewId": 3
}, {
    "id": "5a901a0fe4b0aafe8d0fa1d6",
    "companyId": "5a86c97ce4b0b364a6138b1d",
    "views": [{
        "viewId": 1,
        "name": {
            "en": "One View Test"
        }
    }],
    "version": 34,
    "status": "inactive",
    "createdOn": "2018-02-23T13:41:35.243+0000",
    "createdBy": "5a9019b8e4b0aafe8d0fa1c9",
    "modifiedOn": "2018-02-23T13:44:59.451+0000",
    "modifiedBy": "5a9019b8e4b0aafe8d0fa1c9",
    "lastItemId": 94,
    "lastViewId": 1
}, {
    "id": "5a901a51e4b0aafe8d0fa1f6",
    "companyId": "5a86c97ce4b0b364a6138b1d",
    "views": [{
        "viewId": 1,
        "name": {
            "en": "One View Test"
        }
    }],
    "version": 35,
    "status": "created",
    "createdOn": "2018-02-23T13:42:41.522+0000",
    "createdBy": "5a9019b8e4b0aafe8d0fa1c9",
    "modifiedOn": "2018-02-23T13:42:41.522+0000",
    "modifiedBy": "5a9019b8e4b0aafe8d0fa1c9",
    "lastItemId": 94,
    "lastViewId": 1
}, {
    "id": "5a901ad4e4b0aafe8d0fa203",
    "companyId": "5a86c97ce4b0b364a6138b1d",
    "views": [{
        "viewId": 1,
        "name": {
            "en": "One View Test"
        }
    }],
    "version": 36,
    "status": "inactive",
    "createdOn": "2018-02-23T13:44:52.592+0000",
    "createdBy": "5a9019b8e4b0aafe8d0fa1c9",
    "modifiedOn": "2018-02-23T13:47:15.702+0000",
    "modifiedBy": "5a9019b8e4b0aafe8d0fa1c9",
    "lastItemId": 94,
    "lastViewId": 1
}, {
    "id": "5a901b10e4b0aafe8d0fa223",
    "companyId": "5a86c97ce4b0b364a6138b1d",
    "views": [{
        "viewId": 1,
        "name": {
            "en": "One View Test"
        }
    }],
    "version": 37,
    "status": "inactive",
    "createdOn": "2018-02-23T13:45:52.340+0000",
    "createdBy": "5a9019b8e4b0aafe8d0fa1c9",
    "modifiedOn": "2018-02-23T13:57:22.628+0000",
    "modifiedBy": "5a901d8be4b0aafe8d0fa279",
    "lastItemId": 94,
    "lastViewId": 1
}, {
    "id": "5a901dbce4b0aafe8d0fa286",
    "companyId": "5a86c97ce4b0b364a6138b1d",
    "views": [{
        "viewId": 1,
        "name": {
            "en": "One View Test"
        }
    }],
    "version": 38,
    "status": "active",
    "createdOn": "2018-02-23T13:57:16.447+0000",
    "createdBy": "5a901d8be4b0aafe8d0fa279",
    "modifiedOn": "2018-02-23T13:57:22.591+0000",
    "modifiedBy": "5a5805ba922eb20435b28e88",
    "lastItemId": 94,
    "lastViewId": 1
}];

var catalog = {
    "status": "Success",
    "statusText": "Catalog:Get successful.",
    "catalog": {
        "id": "5a5df113e4b04e14d902aafc",
        "companyId": "59c8fe13e4b085e2cd4c6d59",
        "itemsList": [{
            "itemId": 1,
            "name": {
                "en": "Starters"
            },
            "vatRate": 0,
            "printerCategories": [],
            "views": [1],
            "items": [{
                "itemId": 22,
                "name": {
                    "en": "Pan Fried Onion Balls"
                },
                "desc": {
                    "en": "Onion Pakora pan fried with touch of garlic, ginger, spring onions, coriander and tomatoes"
                },
                "vatRate": 0,
                "sizes": [{
                    "name": {
                        "en": "Standard"
                    },
                    "price": 4.5
                }],
                "options": [],
                "styles": [{
                    "name": {
                        "en": "Standard"
                    }
                }],
                "variants": [{
                    "name": {
                        "en": "Standard"
                    },
                    "price": 0
                }],
                "printerCategories": ["KITCHEN1"],
                "settings": {
                    "labelPrint": false,
                    "askDetails": false
                },
                "views": [1]
            }, {
                "itemId": 3,
                "name": {
                    "en": "Devon Crab Cake"
                },
                "desc": {
                    "en": "Crab meat mixed with crusted potatoes, toasted cumin, fennel & Coram seeds, spices, fresh herbs and served with tarter chutney"
                },
                "vatRate": 0,
                "sizes": [{
                    "name": {
                        "en": "Standard"
                    },
                    "price": 6.95
                }],
                "styles": [{
                    "name": {
                        "en": "Standard"
                    }
                }],
                "variants": [{
                    "name": {
                        "en": "Standard"
                    },
                    "price": 0
                }],
                "printerCategories": ["KITCHEN1"],
                "settings": {
                    "labelPrint": false,
                    "askDetails": false
                },
                "views": [1]
            }, {
                "itemId": 4,
                "name": {
                    "en": "Bhaji Mix"
                },
                "desc": {
                    "en": "Onion Bhaji and Samosa served with tamarind chutney"
                },
                "vatRate": 0,
                "sizes": [{
                    "name": {
                        "en": "Standard"
                    },
                    "price": 4.5
                }],
                "styles": [{
                    "name": {
                        "en": "Standard"
                    }
                }],
                "variants": [{
                    "name": {
                        "en": "Standard"
                    },
                    "price": 0
                }],
                "printerCategories": ["KITCHEN1"],
                "settings": {
                    "labelPrint": false,
                    "askDetails": false
                },
                "views": [1]
            }, {
                "itemId": 5,
                "name": {
                    "en": "Momo"
                },
                "desc": {
                    "en": "(Lamb or Chicken) Nepalese special steamed Lamb or Chicken dumplings served with tomato chutney"
                },
                "vatRate": 0,
                "sizes": [{
                    "name": {
                        "en": "Standard"
                    },
                    "price": 5.95
                }],
                "styles": [{
                    "name": {
                        "en": "Standard"
                    }
                }],
                "variants": [{
                    "name": {
                        "en": "Chicken"
                    },
                    "price": 0
                }, {
                    "name": {
                        "en": "Lamb"
                    },
                    "price": 0
                }],
                "printerCategories": ["KITCHEN1"],
                "settings": {
                    "labelPrint": false,
                    "askDetails": false
                },
                "views": [1]
            }, {
                "itemId": 6,
                "name": {
                    "en": "King Prawn Puri"
                },
                "desc": {
                    "en": "King Prawns cooked with Nepalese spices and served with deep fried Indian bread 'Puri'"
                },
                "vatRate": 0,
                "sizes": [{
                    "name": {
                        "en": "Standard"
                    },
                    "price": 6.95
                }],
                "styles": [{
                    "name": {
                        "en": "Standard"
                    }
                }],
                "variants": [{
                    "name": {
                        "en": "Standard"
                    },
                    "price": 0
                }],
                "printerCategories": ["KITCHEN1"],
                "settings": {
                    "labelPrint": false,
                    "askDetails": false
                },
                "views": [1]
            }, {
                "itemId": 7,
                "name": {
                    "en": "Chicken Balls"
                },
                "desc": {
                    "en": "Spiced Chicken minced meat balls marinated with toasted cumin, fennel, onion seeds and herbs toasted with sweet crusted chilli, pepper, herbs and onion sauce"
                },
                "vatRate": 0,
                "sizes": [{
                    "name": {
                        "en": "Standard"
                    },
                    "price": 5.95
                }],
                "styles": [{
                    "name": {
                        "en": "Standard"
                    }
                }],
                "variants": [{
                    "name": {
                        "en": "Standard"
                    },
                    "price": 0
                }],
                "printerCategories": ["KITCHEN1"],
                "settings": {
                    "labelPrint": false,
                    "askDetails": false
                },
                "views": [1]
            }, {
                "itemId": 8,
                "name": {
                    "en": "Chilli King Prawns"
                },
                "desc": {
                    "en": "King Prawns pan fried with peppers, onions, green chillies, garlic & fresh herbs"
                },
                "vatRate": 0,
                "sizes": [{
                    "name": {
                        "en": "Standard"
                    },
                    "price": 7.95
                }],
                "styles": [{
                    "name": {
                        "en": "Standard"
                    }
                }],
                "variants": [{
                    "name": {
                        "en": "Standard"
                    },
                    "price": 0
                }],
                "printerCategories": ["KITCHEN1"],
                "settings": {
                    "labelPrint": false,
                    "askDetails": false
                },
                "views": [1]
            }, {
                "itemId": 9,
                "name": {
                    "en": "Mushroom Special"
                },
                "desc": {
                    "en": "Fresh mushrooms stuffed with marinated Lamb minced meat, garlic, ginger, herbs and served with tamarind chutney"
                },
                "vatRate": 0,
                "sizes": [{
                    "name": {
                        "en": "Standard"
                    },
                    "price": 5.95
                }],
                "styles": [{
                    "name": {
                        "en": "Standard"
                    }
                }],
                "variants": [{
                    "name": {
                        "en": "Standard"
                    },
                    "price": 0
                }],
                "printerCategories": ["KITCHEN1"],
                "settings": {
                    "labelPrint": false,
                    "askDetails": false
                },
                "views": [1]
            }, {
                "itemId": 10,
                "name": {
                    "en": "Aloo Chana Puri"
                },
                "desc": {
                    "en": "Potatoes and chick peas cooked with fresh herbs and spices served with deep fried Indian bread 'Puri'"
                },
                "vatRate": 0,
                "sizes": [{
                    "name": {
                        "en": "Standard"
                    },
                    "price": 4.5
                }],
                "styles": [{
                    "name": {
                        "en": "Standard"
                    }
                }],
                "variants": [{
                    "name": {
                        "en": "Standard"
                    },
                    "price": 0
                }],
                "printerCategories": ["KITCHEN1"],
                "settings": {
                    "labelPrint": false,
                    "askDetails": false
                },
                "views": [1]
            }, {
                "itemId": 11,
                "name": {
                    "en": "Magic Chicken Tikka"
                },
                "desc": {
                    "en": "Breast of Chicken marinated with garlic, ginger, herbs, cashew nuts & fresh cream served with yoghurt chutney"
                },
                "vatRate": 0,
                "sizes": [{
                    "name": {
                        "en": "Standard"
                    },
                    "price": 5.95
                }],
                "styles": [{
                    "name": {
                        "en": "Standard"
                    }
                }],
                "variants": [{
                    "name": {
                        "en": "Standard"
                    },
                    "price": 0
                }],
                "printerCategories": ["KITCHEN1"],
                "settings": {
                    "labelPrint": false,
                    "askDetails": false
                },
                "views": [1]
            }, {
                "itemId": 12,
                "name": {
                    "en": "Deep fried Calamari with sweet chilli sauce"
                },
                "desc": {
                    "en": "Squid rings marinated with chef‟s special spiced battered served with sweet chilli sauce"
                },
                "vatRate": 0,
                "sizes": [{
                    "name": {
                        "en": "Standard"
                    },
                    "price": 5.95
                }],
                "styles": [{
                    "name": {
                        "en": "Standard"
                    }
                }],
                "variants": [{
                    "name": {
                        "en": "Standard"
                    },
                    "price": 0
                }],
                "printerCategories": ["KITCHEN1"],
                "settings": {
                    "labelPrint": false,
                    "askDetails": false
                },
                "views": [1]
            }, {
                "itemId": 13,
                "name": {
                    "en": "Mixed Kebabs"
                },
                "desc": {
                    "en": "Spiced Chicken minced meat and Lamb minced meat cooked in Tandoori oven and served with fresh mint and yoghurt chutney"
                },
                "vatRate": 0,
                "sizes": [{
                    "name": {
                        "en": "Standard"
                    },
                    "price": 5.95
                }],
                "styles": [{
                    "name": {
                        "en": "Standard"
                    }
                }],
                "variants": [{
                    "name": {
                        "en": "Standard"
                    },
                    "price": 0
                }],
                "printerCategories": ["KITCHEN1"],
                "settings": {
                    "labelPrint": false,
                    "askDetails": false
                },
                "views": [1]
            }, {
                "itemId": 14,
                "name": {
                    "en": "Tandoori Rack of Lamb"
                },
                "desc": {
                    "en": "Beautifully marinated rack of Lamb cooked in oven & served with Chefs special fresh mint, yoghurt, grated lime zest and green chilli chutney"
                },
                "vatRate": 0,
                "sizes": [{
                    "name": {
                        "en": "Standard"
                    },
                    "price": 8.95
                }],
                "styles": [{
                    "name": {
                        "en": "Standard"
                    }
                }],
                "variants": [{
                    "name": {
                        "en": "Standard"
                    },
                    "price": 0
                }],
                "printerCategories": ["KITCHEN1"],
                "settings": {
                    "labelPrint": false,
                    "askDetails": false
                },
                "views": [1]
            }]
        }, {
            "itemId": 100,
            "name": {
                "en": "Oven Dishes (Main)"
            },
            "vatRate": 0,
            "printerCategories": [],
            "views": [1],
            "items": [{
                "itemId": 101,
                "abbr": {
                    "en": "14"
                },
                "name": {
                    "en": "Tikka Special"
                },
                "desc": {
                    "en": "Diced Chicken or Paneer marinated with yoghurt & spices and cooked in tandoori oven"
                },
                "vatRate": 0,
                "sizes": [{
                    "name": {
                        "en": "Standard"
                    },
                    "price": 9.95
                }],
                "options": [],
                "styles": [{
                    "name": {
                        "en": "Standard"
                    }
                }],
                "variants": [{
                    "name": {
                        "en": "Chicken"
                    },
                    "price": 1.25
                }, {
                    "name": {
                        "en": "Paneer"
                    }
                }],
                "printerCategories": ["KITCHEN1"],
                "settings": {
                    "labelPrint": false,
                    "askDetails": false
                },
                "views": [1]
            }, {
                "itemId": 102,
                "abbr": {
                    "en": "15"
                },
                "name": {
                    "en": "Shaslik Special"
                },
                "desc": {
                    "en": "Diced Chicken or Paneer cooked in oven and served with mixed peppers, onions & tomatoes"
                },
                "vatRate": 0,
                "sizes": [{
                    "name": {
                        "en": "Standard"
                    },
                    "price": 10.95
                }],
                "styles": [{
                    "name": {
                        "en": "Standard"
                    }
                }],
                "variants": [{
                    "name": {
                        "en": "Chicken"
                    },
                    "price": 0
                }, {
                    "name": {
                        "en": "Paneer"
                    },
                    "price": 0
                }],
                "printerCategories": ["KITCHEN1"],
                "settings": {
                    "labelPrint": false,
                    "askDetails": false
                },
                "views": [1]
            }, {
                "itemId": 21,
                "name": {
                    "en": "Fish Mix Grill"
                },
                "desc": {
                    "en": "Selection of Fish (Salmon, Red Mullet, Haddock & Cod) marinated with roasted cumin, dill, coriander, parsley, coram and spices cooked in oven and served with plain nan bread."
                },
                "vatRate": 0,
                "sizes": [{
                    "name": {
                        "en": "Standard"
                    },
                    "price": 14.95
                }],
                "styles": [{
                    "name": {
                        "en": "Standard"
                    }
                }],
                "variants": [{
                    "name": {
                        "en": "Standard"
                    },
                    "price": 0
                }],
                "printerCategories": ["KITCHEN1"],
                "settings": {
                    "labelPrint": false,
                    "askDetails": false
                },
                "views": [1]
            }, {
                "itemId": 2,
                "name": {
                    "en": "Sekuwa Special (Duck or Lamb)"
                },
                "vatRate": 0,
                "sizes": [{
                    "name": {
                        "en": "Standard"
                    },
                    "price": 11.95
                }],
                "styles": [{
                    "name": {
                        "en": "Standard"
                    }
                }],
                "variants": [{
                    "name": {
                        "en": "Duck"
                    },
                    "price": 0
                }, {
                    "name": {
                        "en": "Lamb"
                    },
                    "price": 0
                }],
                "printerCategories": ["KITCHEN1"],
                "settings": {
                    "labelPrint": false,
                    "askDetails": false
                },
                "views": [1]
            }, {
                "itemId": 33,
                "name": {
                    "en": "Everest Mix Grill"
                },
                "desc": {
                    "en": "Selections of tandoori Chicken, Lamb sheek kebab, Chicken tikka and Lamb tikka served with plain nan bread"
                },
                "vatRate": 0,
                "sizes": [{
                    "name": {
                        "en": "Standard"
                    },
                    "price": 14.95
                }],
                "styles": [{
                    "name": {
                        "en": "Standard"
                    }
                }],
                "variants": [{
                    "name": {
                        "en": "Standard"
                    },
                    "price": 0
                }],
                "printerCategories": ["KITCHEN1"],
                "settings": {
                    "labelPrint": false,
                    "askDetails": false
                },
                "views": [1]
            }, {
                "itemId": 25,
                "name": {
                    "en": "Chicken Grill"
                },
                "desc": {
                    "en": "Selection of Chicken tikka, tandoori Chicken, Chicken Sheek kebab and magic tikka served with plain nan bread"
                },
                "vatRate": 0,
                "sizes": [{
                    "name": {
                        "en": "Standard"
                    },
                    "price": 13.95
                }],
                "styles": [{
                    "name": {
                        "en": "Standard"
                    }
                }],
                "variants": [{
                    "name": {
                        "en": "Standard"
                    },
                    "price": 0
                }],
                "printerCategories": ["KITCHEN1"],
                "settings": {
                    "labelPrint": false,
                    "askDetails": false
                },
                "views": [1]
            }]
        }, {
            "itemId": 200,
            "name": {
                "en": "Vegetable Dishes"
            },
            "vatRate": 0,
            "sizes": [{
                "name": {
                    "en": "Side"
                },
                "price": 4.95
            }, {
                "name": {
                    "en": "Main"
                },
                "price": 7.95
            }],
            "printerCategories": [],
            "views": [1],
            "items": [{
                "itemId": 201,
                "abbr": {
                    "en": "44"
                },
                "name": {
                    "en": "Tarka Dal"
                },
                "desc": {
                    "en": "Lentils cooked with garlic and mild spices"
                },
                "vatRate": 0,
                "sizes": [{
                    "name": {
                        "en": "Side"
                    },
                    "price": 4.95
                }, {
                    "name": {
                        "en": "Main"
                    },
                    "price": 7.95
                }],
                "styles": [{
                    "name": {
                        "en": "Standard"
                    }
                }],
                "variants": [{
                    "name": {
                        "en": "Standard"
                    },
                    "price": 0
                }],
                "printerCategories": ["KITCHEN1"],
                "settings": {
                    "labelPrint": false,
                    "askDetails": false
                },
                "views": [1]
            }, {
                "itemId": 202,
                "abbr": {
                    "en": "45"
                },
                "name": {
                    "en": "Bombay Aloo"
                },
                "desc": {
                    "en": "Spicy potatoes"
                },
                "vatRate": 0,
                "sizes": [{
                    "name": {
                        "en": "Side"
                    },
                    "price": 4.95
                }, {
                    "name": {
                        "en": "Main"
                    },
                    "price": 7.95
                }],
                "styles": [{
                    "name": {
                        "en": "Standard"
                    }
                }],
                "variants": [{
                    "name": {
                        "en": "Standard"
                    },
                    "price": 0
                }],
                "printerCategories": ["KITCHEN1"],
                "settings": {
                    "labelPrint": false,
                    "askDetails": false
                },
                "views": [1]
            }]
        }, {
            "itemId": 300,
            "name": {
                "en": "Traditional Dishes"
            },
            "vatRate": 0,
            "sizes": [{
                "name": {
                    "en": "Standard"
                },
                "price": 0
            }],
            "variants": [{
                "name": {
                    "en": "Vegetable"
                },
                "price": 4.95
            }, {
                "name": {
                    "en": "Chicken"
                },
                "price": 8.95
            }, {
                "name": {
                    "en": "Lamb"
                },
                "price": 10.95
            }, {
                "name": {
                    "en": "King Prawn"
                },
                "price": 11.95
            }],
            "printerCategories": [],
            "views": [1],
            "items": [{
                "itemId": 301,
                "abbr": {
                    "en": "52"
                },
                "name": {
                    "en": "Tikka Masala"
                },
                "desc": {
                    "en": "(Mild) Cooked In butter, ground almonds, fresh cream and Chef‟s special masala sauce"
                },
                "vatRate": 0,
                "sizes": [],
                "styles": [],
                "variants": [{
                    "name": {
                        "en": "Standard"
                    },
                    "price": 0
                }],
                "printerCategories": ["KITCHEN1"],
                "settings": {
                    "labelPrint": false,
                    "askDetails": false
                },
                "views": [1]
            }, {
                "itemId": 302,
                "abbr": {
                    "en": "53"
                },
                "name": {
                    "en": "Korma"
                },
                "desc": {
                    "en": "(Mild) Cooked with coconut in very mild creamy sauce"
                },
                "vatRate": 0,
                "sizes": [{
                    "name": {
                        "en": "Standard"
                    },
                    "price": 0
                }],
                "styles": [{
                    "name": {
                        "en": "Standard"
                    }
                }],
                "variants": [{
                    "name": {
                        "en": "Vegetable"
                    },
                    "price": 7.95
                }, {
                    "name": {
                        "en": "Chicken"
                    },
                    "price": 8.95
                }, {
                    "name": {
                        "en": "Lamb"
                    },
                    "price": 10.95
                }, {
                    "name": {
                        "en": "King prawn"
                    },
                    "price": 11.95
                }],
                "printerCategories": ["KITCHEN1"],
                "settings": {
                    "labelPrint": false,
                    "askDetails": false
                },
                "views": [1]
            }]
        }, {
            "itemId": 303,
            "name": {
                "en": "Chef's Recommendations (Nepalese Dishes)"
            },
            "vatRate": 0,
            "sizes": [{
                "name": {
                    "en": "Standard"
                },
                "price": 0
            }],
            "styles": [{
                "name": {
                    "en": "Lamb"
                }
            }, {
                "name": {
                    "en": "Chicken"
                }
            }, {
                "name": {
                    "en": "Duck"
                }
            }],
            "printerCategories": ["KITCHEN1", "BAR1"],
            "settings": {
                "labelPrint": false,
                "askDetails": false
            },
            "views": [1],
            "items": [{
                "itemId": 304,
                "name": {
                    "en": "Bhutuwa Special"
                },
                "vatRate": 0,
                "sizes": [{
                    "name": {
                        "en": "Standard"
                    },
                    "price": 11.95
                }],
                "options": [],
                "styles": [{
                    "name": {
                        "en": "Chicken"
                    }
                }, {
                    "name": {
                        "en": "Lamb"
                    }
                }, {
                    "name": {
                        "en": "Duck"
                    }
                }],
                "variants": [],
                "printerCategories": [],
                "settings": {
                    "labelPrint": false,
                    "askDetails": false
                },
                "views": []
            }, {
                "itemId": 305,
                "name": {
                    "en": "Fish Modi Khola "
                },
                "vatRate": 0,
                "sizes": [{
                    "name": {
                        "en": "Standard"
                    },
                    "price": 10.95
                }],
                "styles": [{
                    "name": {
                        "en": "FISH"
                    }
                }],
                "printerCategories": ["KITCHEN1"],
                "settings": {
                    "labelPrint": false,
                    "askDetails": false
                },
                "views": []
            }, {
                "itemId": 306,
                "name": {
                    "en": "Hariyali"
                },
                "vatRate": 0,
                "sizes": [{
                    "name": {
                        "en": "Standard"
                    },
                    "price": 11.95
                }],
                "styles": [{
                    "name": {
                        "en": "Chicken"
                    }
                }, {
                    "name": {
                        "en": "Lamb"
                    }
                }],
                "printerCategories": [],
                "settings": {
                    "labelPrint": false,
                    "askDetails": false
                },
                "views": []
            }, {
                "itemId": 307,
                "name": {
                    "en": "Chati Kukhura"
                },
                "vatRate": 0,
                "sizes": [{
                    "name": {
                        "en": "Standard"
                    },
                    "price": 10.5
                }],
                "styles": [{
                    "name": {
                        "en": "Standard"
                    }
                }],
                "printerCategories": [],
                "settings": {
                    "labelPrint": false,
                    "askDetails": false
                },
                "views": []
            }, {
                "itemId": 308,
                "name": {
                    "en": "Keema Aloo Mutter "
                },
                "vatRate": 0,
                "sizes": [{
                    "name": {
                        "en": "Standard"
                    },
                    "price": 9.95
                }],
                "styles": [{
                    "name": {
                        "en": "Standard"
                    }
                }],
                "printerCategories": [],
                "settings": {
                    "labelPrint": false,
                    "askDetails": false
                },
                "views": []
            }, {
                "itemId": 309,
                "name": {
                    "en": "Chicken Nepal (Mild)"
                },
                "vatRate": 0,
                "sizes": [{
                    "name": {
                        "en": "Standard"
                    },
                    "price": 10.95
                }],
                "styles": [{
                    "name": {
                        "en": "Standard"
                    }
                }],
                "printerCategories": [],
                "settings": {
                    "labelPrint": false,
                    "askDetails": false
                },
                "views": []
            }, {
                "itemId": 310,
                "name": {
                    "en": "Chicken Lasun Khursani – Madras Hot! "
                },
                "vatRate": 0,
                "sizes": [{
                    "name": {
                        "en": "Standard"
                    },
                    "price": 10.95
                }],
                "styles": [{
                    "name": {
                        "en": "Standard"
                    }
                }],
                "printerCategories": [],
                "settings": {
                    "labelPrint": false,
                    "askDetails": false
                },
                "views": []
            }, {
                "itemId": 311,
                "name": {
                    "en": "Special Mix Karahi "
                },
                "vatRate": 0,
                "sizes": [{
                    "name": {
                        "en": "Standard"
                    },
                    "price": 10.95
                }],
                "styles": [{
                    "name": {
                        "en": "Standard"
                    }
                }],
                "printerCategories": [],
                "settings": {
                    "labelPrint": false,
                    "askDetails": false
                },
                "views": []
            }, {
                "itemId": 312,
                "name": {
                    "en": "Chicken Chilli Masala - Madras Hot! "
                },
                "vatRate": 0,
                "sizes": [{
                    "name": {
                        "en": "Standard"
                    },
                    "price": 10.95
                }],
                "styles": [{
                    "name": {
                        "en": "Standard"
                    }
                }],
                "printerCategories": [],
                "settings": {
                    "labelPrint": false,
                    "askDetails": false
                },
                "views": []
            }, {
                "itemId": 313,
                "name": {
                    "en": "Gurkhali "
                },
                "vatRate": 0,
                "sizes": [{
                    "name": {
                        "en": "Standard"
                    },
                    "price": 11.95
                }],
                "styles": [{
                    "name": {
                        "en": "Standard"
                    }
                }],
                "variants": [{
                    "name": {
                        "en": "Lamb"
                    },
                    "price": 11.95
                }, {
                    "name": {
                        "en": "Chicken"
                    },
                    "price": 11.95
                }],
                "printerCategories": [],
                "settings": {
                    "labelPrint": false,
                    "askDetails": false
                },
                "views": []
            }, {
                "itemId": 314,
                "name": {
                    "en": "Himalayan King Prawn - Madras Hot! "
                },
                "vatRate": 0,
                "sizes": [{
                    "name": {
                        "en": "Standard"
                    },
                    "price": 12.95
                }],
                "styles": [{
                    "name": {
                        "en": "Standard"
                    }
                }],
                "printerCategories": [],
                "settings": {
                    "labelPrint": false,
                    "askDetails": false
                },
                "views": []
            }, {
                "itemId": 315,
                "name": {
                    "en": "Lakeside Fish- dry fry "
                },
                "vatRate": 0,
                "sizes": [{
                    "name": {
                        "en": "Standard"
                    },
                    "price": 10.95
                }],
                "styles": [{
                    "name": {
                        "en": "Standard"
                    }
                }],
                "printerCategories": [],
                "settings": {
                    "labelPrint": false,
                    "askDetails": false
                },
                "views": []
            }, {
                "itemId": 316,
                "name": {
                    "en": "Paneer Chilli Masala (V) - Madras Hot!"
                },
                "vatRate": 0,
                "sizes": [{
                    "name": {
                        "en": "Standard"
                    },
                    "price": 7.95
                }],
                "styles": [{
                    "name": {
                        "en": "Standard"
                    }
                }],
                "printerCategories": [],
                "settings": {
                    "labelPrint": false,
                    "askDetails": false
                },
                "views": []
            }, {
                "itemId": 317,
                "name": {
                    "en": "Fish Malabar Special "
                },
                "vatRate": 0,
                "sizes": [{
                    "name": {
                        "en": "Standard"
                    },
                    "price": 0
                }],
                "styles": [{
                    "name": {
                        "en": "Standard"
                    }
                }],
                "printerCategories": [],
                "settings": {
                    "labelPrint": false,
                    "askDetails": false
                },
                "views": []
            }]
        }, {
            "itemId": 318,
            "name": {
                "en": "Everest Special Platter (Eat In Only)"
            },
            "vatRate": 0,
            "sizes": [{
                "name": {
                    "en": "Standard"
                },
                "price": 0
            }],
            "options": [],
            "styles": [{
                "name": {
                    "en": "Standard"
                }
            }],
            "variants": [],
            "printerCategories": [],
            "settings": {
                "labelPrint": false,
                "askDetails": false
            },
            "views": [1],
            "items": [{
                "itemId": 319,
                "name": {
                    "en": "Tandoori Chicken Fillet with Creamy Mushroom Sauce £12.95"
                },
                "desc": {
                    "en": "Chicken fillet marinated with yoghurt, cumin, coriander, chilli & fresh herbs and served with creamy mushroom sauce and pilau rice"
                },
                "vatRate": 0,
                "sizes": [{
                    "name": {
                        "en": "Standard"
                    },
                    "price": 12.95
                }],
                "styles": [{
                    "name": {
                        "en": "Standard"
                    }
                }],
                "variants": [{
                    "name": {
                        "en": "Standard"
                    },
                    "price": 0
                }],
                "printerCategories": ["KITCHEN1"],
                "settings": {
                    "labelPrint": false,
                    "askDetails": false
                },
                "views": [1]
            }, {
                "itemId": 320,
                "name": {
                    "en": "Lamb Shank Special - Chefs Signature dish"
                },
                "vatRate": 0,
                "sizes": [{
                    "name": {
                        "en": "Standard"
                    },
                    "price": 0
                }],
                "styles": [{
                    "name": {
                        "en": "Standard"
                    }
                }],
                "variants": [{
                    "name": {
                        "en": "Standard"
                    },
                    "price": 0
                }],
                "printerCategories": ["KITCHEN1"],
                "settings": {
                    "labelPrint": false,
                    "askDetails": false
                },
                "views": [1]
            }, {
                "itemId": 321,
                "name": {
                    "en": "Malabar Prawn Special – Most popular dish and recipe from Kerala – South India"
                },
                "vatRate": 0,
                "sizes": [{
                    "name": {
                        "en": "Standard"
                    },
                    "price": 14.95
                }],
                "styles": [{
                    "name": {
                        "en": "Standard"
                    }
                }],
                "variants": [{
                    "name": {
                        "en": "Standard"
                    },
                    "price": 0
                }],
                "printerCategories": ["KITCHEN1"],
                "settings": {
                    "labelPrint": false,
                    "askDetails": false
                },
                "views": [1]
            }, {
                "itemId": 322,
                "name": {
                    "en": "Chicken Kofta with Pilau Rice"
                },
                "vatRate": 0,
                "sizes": [{
                    "name": {
                        "en": "Standard"
                    },
                    "price": 12.95
                }],
                "styles": [{
                    "name": {
                        "en": "Standard"
                    }
                }],
                "variants": [{
                    "name": {
                        "en": "Standard"
                    },
                    "price": 0
                }],
                "printerCategories": ["KITCHEN1"],
                "settings": {
                    "labelPrint": false,
                    "askDetails": false
                },
                "views": [1]
            }, {
                "itemId": 323,
                "name": {
                    "en": "Stir-fried King Prawn with Green beans, Mushroom & Rice "
                },
                "desc": {
                    "en": "Marinated king prawn cooked with green beans, fresh mushrooms pan fried with chef special spices and served with plain rice"
                },
                "vatRate": 0,
                "sizes": [{
                    "name": {
                        "en": "Standard"
                    },
                    "price": 14.95
                }],
                "styles": [{
                    "name": {
                        "en": "Standard"
                    }
                }],
                "variants": [{
                    "name": {
                        "en": "Standard"
                    },
                    "price": 0
                }],
                "printerCategories": ["KITCHEN1"],
                "settings": {
                    "labelPrint": false,
                    "askDetails": false
                },
                "views": [1]
            }, {
                "itemId": 324,
                "name": {
                    "en": "Dahi Kadhi with onion Pakora and Rice (V) "
                },
                "vatRate": 0,
                "sizes": [{
                    "name": {
                        "en": "Standard"
                    },
                    "price": 9.95
                }],
                "styles": [{
                    "name": {
                        "en": "Standard"
                    }
                }],
                "variants": [{
                    "name": {
                        "en": "Standard"
                    },
                    "price": 0
                }],
                "printerCategories": ["KITCHEN1"],
                "settings": {
                    "labelPrint": false,
                    "askDetails": false
                },
                "views": [1]
            }, {
                "itemId": 325,
                "name": {
                    "en": "Chilli Flaked Salmon Fillet with Potatoes & Kadhi"
                },
                "vatRate": 0,
                "sizes": [{
                    "name": {
                        "en": "Standard"
                    },
                    "price": 12.95
                }],
                "styles": [{
                    "name": {
                        "en": "Standard"
                    }
                }],
                "variants": [{
                    "name": {
                        "en": "Standard"
                    },
                    "price": 0
                }],
                "printerCategories": ["KITCHEN1"],
                "settings": {
                    "labelPrint": false,
                    "askDetails": false
                },
                "views": [1]
            }, {
                "itemId": 326,
                "name": {
                    "en": "Whole Tandoori Sea Bass with Green Beans & Potatoes"
                },
                "desc": {
                    "en": "Whole sea bass marinated with cumin, onion seeds, spices and cooked in oven and served with fresh green beans and potatoes"
                },
                "vatRate": 0,
                "sizes": [{
                    "name": {
                        "en": "Standard"
                    },
                    "price": 13.95
                }],
                "options": [{
                    "name": {
                        "en": "Standard"
                    },
                    "price": 0
                }],
                "styles": [{
                    "name": {
                        "en": "Standard"
                    }
                }],
                "variants": [{
                    "name": {
                        "en": "Standard"
                    },
                    "price": 0
                }],
                "printerCategories": ["KITCHEN1"],
                "settings": {
                    "labelPrint": false,
                    "askDetails": false
                },
                "views": [1]
            }, {
                "itemId": 327,
                "name": {
                    "en": "Pan Fried Red Snapper with stir-fried cabbage and creamy tomato sauce"
                },
                "vatRate": 0,
                "sizes": [{
                    "name": {
                        "en": "Standard"
                    },
                    "price": 12.95
                }],
                "styles": [{
                    "name": {
                        "en": "Standard"
                    }
                }],
                "variants": [{
                    "name": {
                        "en": "Standard"
                    },
                    "price": 0
                }],
                "printerCategories": ["KITCHEN1"],
                "settings": {
                    "labelPrint": false,
                    "askDetails": false
                },
                "views": [1, 2]
            }, {
                "itemId": 328,
                "name": {
                    "en": "Stir-fried Duck with Mushroom, Green Beans and Pilau Rice "
                },
                "vatRate": 0,
                "sizes": [{
                    "name": {
                        "en": "Standard"
                    },
                    "price": 14.95
                }],
                "options": [{
                    "name": {
                        "en": "Standard"
                    },
                    "price": 0
                }],
                "styles": [{
                    "name": {
                        "en": "Standard"
                    }
                }],
                "variants": [{
                    "name": {
                        "en": "Standard"
                    },
                    "price": 0
                }],
                "printerCategories": ["KITCHEN1"],
                "settings": {
                    "labelPrint": false,
                    "askDetails": false
                },
                "views": [1, 2]
            }]
        }, {
            "itemId": 329,
            "name": {
                "en": "Traditional Dishes"
            },
            "vatRate": 0,
            "sizes": [{
                "name": {
                    "en": "Standard"
                },
                "price": 0
            }],
            "styles": [{
                "name": {
                    "en": "Standard"
                }
            }],
            "printerCategories": [],
            "settings": {
                "labelPrint": false,
                "askDetails": false
            },
            "views": [1, 2],
            "items": [{
                "itemId": 330,
                "name": {
                    "en": "Tikka Masala"
                },
                "vatRate": 0,
                "sizes": [{
                    "name": {
                        "en": "Standard"
                    },
                    "price": 0
                }],
                "styles": [{
                    "name": {
                        "en": "Curry (Medium)"
                    }
                }, {
                    "name": {
                        "en": "Madras (Hot)"
                    }
                }, {
                    "name": {
                        "en": "Vindaloo (very hot)"
                    }
                }],
                "variants": [{
                    "name": {
                        "en": "Vegetable (V)"
                    },
                    "price": 7.95
                }, {
                    "name": {
                        "en": "Chicken"
                    },
                    "price": 8.95
                }, {
                    "name": {
                        "en": "Lamb"
                    },
                    "price": 10.95
                }, {
                    "name": {
                        "en": "King Prawn Dishes"
                    },
                    "price": 11.95
                }],
                "printerCategories": ["KITCHEN1"],
                "settings": {
                    "labelPrint": false,
                    "askDetails": false
                },
                "views": [1, 2]
            }, {
                "itemId": 331,
                "name": {
                    "en": "Korma"
                },
                "vatRate": 0,
                "sizes": [{
                    "name": {
                        "en": "Standard"
                    },
                    "price": 0
                }],
                "styles": [{
                    "name": {
                        "en": "Curry (Medium)"
                    }
                }, {
                    "name": {
                        "en": "Madras (Hot)"
                    }
                }, {
                    "name": {
                        "en": "Vindaloo (very hot)"
                    }
                }],
                "variants": [{
                    "name": {
                        "en": "Vegetable (V)"
                    },
                    "price": 7.95
                }, {
                    "name": {
                        "en": "Chicken"
                    },
                    "price": 8.95
                }, {
                    "name": {
                        "en": "Lamb"
                    },
                    "price": 10.95
                }, {
                    "name": {
                        "en": "King Prawn Dishes"
                    },
                    "price": 11.95
                }],
                "printerCategories": ["KITCHEN1"],
                "settings": {
                    "labelPrint": false,
                    "askDetails": false
                },
                "views": [1, 2]
            }, {
                "itemId": 332,
                "name": {
                    "en": "Bhuna"
                },
                "vatRate": 0,
                "sizes": [{
                    "name": {
                        "en": "Standard"
                    },
                    "price": 0
                }],
                "styles": [{
                    "name": {
                        "en": "Curry (Medium)"
                    }
                }, {
                    "name": {
                        "en": "Madras (Hot)"
                    }
                }, {
                    "name": {
                        "en": "Vindaloo (very hot)"
                    }
                }],
                "variants": [{
                    "name": {
                        "en": "Vegetable (V)"
                    },
                    "price": 7.95
                }, {
                    "name": {
                        "en": "Chicken"
                    },
                    "price": 8.95
                }, {
                    "name": {
                        "en": "Lamb"
                    },
                    "price": 10.95
                }, {
                    "name": {
                        "en": "King Prawn Dishes"
                    },
                    "price": 11.95
                }],
                "printerCategories": ["KITCHEN1"],
                "settings": {
                    "labelPrint": false,
                    "askDetails": false
                },
                "views": [1, 2]
            }, {
                "itemId": 333,
                "name": {
                    "en": "Sag"
                },
                "vatRate": 0,
                "sizes": [{
                    "name": {
                        "en": "Standard"
                    },
                    "price": 0
                }],
                "styles": [{
                    "name": {
                        "en": "Curry (Medium)"
                    }
                }, {
                    "name": {
                        "en": "Madras (Hot)"
                    }
                }, {
                    "name": {
                        "en": "Vindaloo (very hot)"
                    }
                }],
                "variants": [{
                    "name": {
                        "en": "Vegetable (V)"
                    },
                    "price": 7.95
                }, {
                    "name": {
                        "en": "Chicken"
                    },
                    "price": 8.95
                }, {
                    "name": {
                        "en": "Lamb"
                    },
                    "price": 10.95
                }, {
                    "name": {
                        "en": "King Prawn Dishes"
                    },
                    "price": 11.95
                }],
                "printerCategories": ["KITCHEN1"],
                "settings": {
                    "labelPrint": false,
                    "askDetails": false
                },
                "views": [1, 2]
            }, {
                "itemId": 334,
                "name": {
                    "en": "Rogan\t"
                },
                "vatRate": 0,
                "sizes": [{
                    "name": {
                        "en": "Standard"
                    },
                    "price": 0
                }],
                "styles": [{
                    "name": {
                        "en": "Curry (Medium)"
                    }
                }, {
                    "name": {
                        "en": "Madras (Hot)"
                    }
                }, {
                    "name": {
                        "en": "Vindaloo (very hot)"
                    }
                }],
                "variants": [{
                    "name": {
                        "en": "Vegetable (V)"
                    },
                    "price": 7.95
                }, {
                    "name": {
                        "en": "Chicken"
                    },
                    "price": 8.95
                }, {
                    "name": {
                        "en": "Lamb"
                    },
                    "price": 10.95
                }, {
                    "name": {
                        "en": "King Prawn Dishes"
                    },
                    "price": 11.95
                }],
                "printerCategories": ["KITCHEN1"],
                "settings": {
                    "labelPrint": false,
                    "askDetails": false
                },
                "views": [1, 2]
            }, {
                "itemId": 335,
                "name": {
                    "en": "Dhansak"
                },
                "vatRate": 0,
                "sizes": [{
                    "name": {
                        "en": "Standard"
                    },
                    "price": 0
                }],
                "styles": [{
                    "name": {
                        "en": "Curry (Medium)"
                    }
                }, {
                    "name": {
                        "en": "Madras (Hot)"
                    }
                }, {
                    "name": {
                        "en": "Vindaloo (very hot)"
                    }
                }],
                "variants": [{
                    "name": {
                        "en": "Vegetable (V)"
                    },
                    "price": 7.95
                }, {
                    "name": {
                        "en": "Chicken"
                    },
                    "price": 8.95
                }, {
                    "name": {
                        "en": "Lamb"
                    },
                    "price": 10.95
                }, {
                    "name": {
                        "en": "King Prawn Dishes"
                    },
                    "price": 11.95
                }],
                "printerCategories": ["KITCHEN1"],
                "settings": {
                    "labelPrint": false,
                    "askDetails": false
                },
                "views": [1, 2]
            }, {
                "itemId": 336,
                "name": {
                    "en": "Jalfrazi"
                },
                "vatRate": 0,
                "sizes": [{
                    "name": {
                        "en": "Standard"
                    },
                    "price": 0
                }],
                "styles": [{
                    "name": {
                        "en": "Curry (Medium)"
                    }
                }, {
                    "name": {
                        "en": "Madras (Hot)"
                    }
                }, {
                    "name": {
                        "en": "Vindaloo (very hot)"
                    }
                }],
                "variants": [{
                    "name": {
                        "en": "Vegetable (V)"
                    },
                    "price": 7.95
                }, {
                    "name": {
                        "en": "Chicken"
                    },
                    "price": 8.95
                }, {
                    "name": {
                        "en": "Lamb"
                    },
                    "price": 10.95
                }, {
                    "name": {
                        "en": "King Prawn Dishes"
                    },
                    "price": 11.95
                }],
                "printerCategories": ["KITCHEN1"],
                "settings": {
                    "labelPrint": false,
                    "askDetails": false
                },
                "views": [1, 2]
            }, {
                "itemId": 337,
                "name": {
                    "en": "Tikka Masala"
                },
                "vatRate": 0,
                "sizes": [{
                    "name": {
                        "en": "Standard"
                    },
                    "price": 0
                }],
                "styles": [{
                    "name": {
                        "en": "Curry (Medium)"
                    }
                }, {
                    "name": {
                        "en": "Madras (Hot)"
                    }
                }, {
                    "name": {
                        "en": "Vindaloo (very hot)"
                    }
                }],
                "variants": [{
                    "name": {
                        "en": "Vegetable (V)"
                    },
                    "price": 7.95
                }, {
                    "name": {
                        "en": "Chicken"
                    },
                    "price": 8.95
                }, {
                    "name": {
                        "en": "Lamb"
                    },
                    "price": 10.95
                }, {
                    "name": {
                        "en": "King Prawn Dishes"
                    },
                    "price": 11.95
                }],
                "printerCategories": ["KITCHEN1"],
                "settings": {
                    "labelPrint": false,
                    "askDetails": false
                },
                "views": [1, 2]
            }]
        }],
        "views": [{
            "viewId": 1,
            "name": {
                "en": "Restaurant"
            }
        }, {
            "viewId": 2,
            "name": {
                "en": "Take awy"
            }
        }, {
            "viewId": 3,
            "name": {
                "en": "Drinks"
            }
        }],
        "version": 11,
        "status": "active",
        "createdOn": "2018-01-16T12:33:23.334+0000",
        "createdBy": "5a5df0a0e4b04e14d902aaed",
        "modifiedOn": "2018-01-18T09:00:56.592+0000",
        "modifiedBy": "59d224d88d60691acf763dba",
        "lastItemId": 0,
        "lastViewId": 0
    }
};

var companies = [{
    "id": "59d751e3e4b0e99a1cc38ed5",
    "name": "1",
    "companyStatus": "inactive",
    "currency": "EUR"
}, {
    "id": "5a52facde4b0eb99b3ba3289",
    "name": "12",
    "companyStatus": "inactive",
    "currency": "EUR"
}, {
    "id": "5a13ab30e4b0018614c6cf41",
    "name": "123sup1",
    "companyStatus": "inactive",
    "currency": "EUR"
}, {
    "id": "5a6866fbe4b018a963946550",
    "name": "333",
    "companyStatus": "inactive",
    "currency": "EUR"
}, {
    "id": "59d2221fe4b024ef2fe2243b",
    "name": "4",
    "companyStatus": "inactive",
    "currency": "EUR"
}, {
    "id": "5a854e26e4b0b364a61387a0",
    "name": "5QA",
    "companyStatus": "inactive",
    "currency": "GBP"
}, {
    "id": "5a567d40e4b06683979bf32c",
    "name": "Ace Restaurant Tech Ltd.",
    "companyStatus": "inactive",
    "currency": "GBP",
    "lastSynchedOn": "2018-01-11T20:18:03.915+0000",
    "lastContactedOn": "2018-01-11T20:35:00.424+0000"
}, {
    "id": "59d75f2de4b0fb3ee74cfeb7",
    "name": "Atrium",
    "companyStatus": "inactive",
    "currency": "EUR"
}, {
    "id": "5a2538f0e4b04224bf9b9ac8",
    "name": "Atrium(pune)",
    "companyStatus": "inactive",
    "currency": "EUR"
}, {
    "id": "5a57c093e4b06683979bf4a7",
    "name": "Everest Inn Ashford",
    "companyStatus": "active",
    "currency": "GBP",
    "lastSynchedOn": "2018-02-22T13:47:22.922+0000",
    "lastContactedOn": "2018-02-26T11:24:34.724+0000"
}, {
    "id": "5a617b56b64a80f585223734",
    "name": "Gouri",
    "companyStatus": "inactive",
    "currency": "EUR"
}, {
    "id": "5a6189a5b64a80f585223742",
    "name": "Gouri's 2",
    "companyStatus": "inactive",
    "currency": "EUR"
}, {
    "id": "5a5c4e10e4b0f01cb2351552",
    "name": "Gouri's Company",
    "companyStatus": "inactive",
    "currency": "EUR"
}, {
    "id": "5a73e739e4b097458dd23b00",
    "name": "Gouri's Test Company",
    "companyStatus": "inactive",
    "currency": "GBP"
}, {
    "id": "5a66b579e4b0835eeb97fd45",
    "name": "Gouri's new Company",
    "companyStatus": "inactive",
    "currency": "EUR"
}, {
    "id": "5a7be5aae4b06aa88acf0c50",
    "name": "Green Roof",
    "companyStatus": "inactive",
    "currency": "EUR"
}, {
    "id": "5a5c4dd8e4b0f01cb235154b",
    "name": "Madhuri's Company",
    "companyStatus": "inactive",
    "currency": "GBP"
}, {
    "id": "5a612a4fe4b04e14d902b454",
    "name": "Madhuri's Test",
    "companyStatus": "inactive",
    "currency": "EUR"
}, {
    "id": "5a612e00b64a80f5852235e3",
    "name": "Madhuri's Test22",
    "companyStatus": "inactive",
    "currency": "EUR"
}, {
    "id": "5a612ca5b64a80f5852235d1",
    "name": "Madhuri2",
    "companyStatus": "inactive",
    "currency": "EUR"
}, {
    "id": "5a09d4dcb64a8298a8702e59",
    "name": "Madhuri22",
    "companyStatus": "inactive",
    "currency": "EUR"
}, {
    "id": "5a6afb0ce4b0e8e18e9502e8",
    "name": "Mahmoud office test",
    "companyStatus": "active",
    "currency": "GBP",
    "lastSynchedOn": "2018-02-02T11:50:25.485+0000",
    "lastContactedOn": "2018-02-26T11:24:34.575+0000"
}, {
    "id": "5a6f089ee4b0ed8f57f2facc",
    "name": "Maks Test Company",
    "companyStatus": "active",
    "currency": "EUR"
}, {
    "id": "5a86c97ce4b0b364a6138b1d",
    "name": "N- JOY CAFE BAR",
    "companyStatus": "active",
    "currency": "GBP",
    "lastSynchedOn": "2018-02-23T14:35:51.187+0000",
    "lastContactedOn": "2018-02-26T11:24:33.960+0000"
}, {
    "id": "5a68720ce4b018a96394663e",
    "name": "Nitin's test company",
    "companyStatus": "inactive",
    "currency": "EUR"
}, {
    "id": "5a685d50e4b018a963946479",
    "name": "PaymentSense Ltd",
    "companyStatus": "active",
    "currency": "GBP",
    "lastSynchedOn": "2018-01-24T17:46:08.851+0000",
    "lastContactedOn": "2018-02-02T04:16:27.964+0000"
}, {
    "id": "5a82ce2ee4b0379a14b54ebb",
    "name": "QA",
    "companyStatus": "inactive",
    "currency": "GBP"
}, {
    "id": "5a77e38ce4b0f00aebcb2021",
    "name": "QA1",
    "companyStatus": "inactive",
    "currency": "GBP"
}, {
    "id": "5a93eb62e4b0441a44672c0d",
    "name": "QA1A",
    "companyStatus": "active",
    "currency": "GBP"
}, {
    "id": "5a854d36e4b0b364a6138789",
    "name": "QA2",
    "companyStatus": "inactive",
    "currency": "GBP"
}, {
    "id": "5a854d99e4b0b364a6138799",
    "name": "QA5",
    "companyStatus": "inactive",
    "currency": "GBP"
}, {
    "id": "5a85614be4b0b364a6138960",
    "name": "QA87",
    "companyStatus": "inactive",
    "currency": "GBP"
}, {
    "id": "5a85634de4b0b364a613898f",
    "name": "QA98",
    "companyStatus": "inactive",
    "currency": "GBP"
}, {
    "id": "5a85641be4b0b364a61389fa",
    "name": "QW",
    "companyStatus": "inactive",
    "currency": "GBP"
}, {
    "id": "59c4f7b807587a0a5192cba2",
    "name": "Sun Admin Company",
    "companyStatus": "active",
    "currency": "GBP"
}, {
    "id": "59d77a52e4b0fb3ee74d0075",
    "name": "Test",
    "companyStatus": "inactive",
    "currency": "EUR"
}, {
    "id": "59db2cc2e4b0bc51008e9ee9",
    "name": "Test 234",
    "companyStatus": "inactive",
    "currency": "GBP"
}, {
    "id": "5a69a15ae4b0499cb0259a27",
    "name": "Test1",
    "companyStatus": "inactive",
    "currency": "GBP"
}, {
    "id": "5a612d08b64a80f5852235da",
    "name": "Test12",
    "companyStatus": "inactive",
    "currency": "EUR"
}, {
    "id": "59d8f7fce4b0f393948831dc",
    "name": "Test2",
    "companyStatus": "inactive",
    "currency": "EUR"
}, {
    "id": "5a0c4820e4b02a2fc346ea1a",
    "name": "Test22",
    "companyStatus": "inactive",
    "currency": "EUR",
    "lastContactedOn": "2018-01-13T10:59:47.322+0000"
}, {
    "id": "5a73f47ae4b097458dd23b53",
    "name": "TestComp1",
    "companyStatus": "inactive",
    "currency": "EUR"
}, {
    "id": "5a73f589e4b097458dd23b6e",
    "name": "TestComp2",
    "companyStatus": "inactive",
    "currency": "GBP"
}, {
    "id": "5a69c1dce4b0e8e18e94fe76",
    "name": "TestPreeti",
    "companyStatus": "inactive",
    "currency": "EUR"
}, {
    "id": "5a65e002e4b062975d2bc90c",
    "name": "The Tiffin Tin (West Hampstead)",
    "companyStatus": "active",
    "currency": "GBP",
    "lastSynchedOn": "2018-02-22T13:48:57.936+0000",
    "lastContactedOn": "2018-02-26T11:24:34.517+0000"
}, {
    "id": "59d7a3d3e4b0f3939488311c",
    "name": "True Chinese Specialties",
    "companyStatus": "inactive",
    "currency": "EUR"
}, {
    "id": "5a11e653e4b0018614c6c6e3",
    "name": "Unbelievable great stuff",
    "companyStatus": "inactive",
    "currency": "GBP"
}, {
    "id": "5a73f6e6e4b097458dd23ba5",
    "name": "Z",
    "companyStatus": "inactive",
    "currency": "GBP"
}, {
    "id": "5a0d1789e4b02455036b4abe",
    "name": "abc",
    "companyStatus": "inactive",
    "currency": "EUR"
}, {
    "id": "5a0d1dd0e4b02455036b4e81",
    "name": "abcd",
    "companyStatus": "inactive",
    "currency": "EUR"
}, {
    "id": "5a0d1e93e4b02455036b4efa",
    "name": "abcde",
    "companyStatus": "inactive",
    "currency": "EUR"
}, {
    "id": "5a618b08b64a80f58522375d",
    "name": "atrium2",
    "companyStatus": "inactive",
    "currency": "EUR"
}, {
    "id": "59c8fe13e4b085e2cd4c6d59",
    "name": "george's Japanese",
    "companyStatus": "active",
    "currency": "EUR",
    "lastSynchedOn": "2018-01-13T18:15:49.919+0000",
    "lastContactedOn": "2018-01-13T20:28:54.308+0000"
}, {
    "id": "5a9317bae4b0e46cdc475f61",
    "name": "george's Thai Restaurant",
    "companyStatus": "active",
    "currency": "GBP",
    "lastSynchedOn": "2018-02-25T20:20:35.668+0000",
    "lastContactedOn": "2018-02-25T20:26:45.460+0000"
}, {
    "id": "59dcd421e4b0bc51008ea0dc",
    "name": "george's pizzeria",
    "companyStatus": "active",
    "currency": "GBP",
    "lastSynchedOn": "2018-02-25T10:22:40.077+0000",
    "lastContactedOn": "2018-02-26T11:24:34.546+0000"
}, {
    "id": "5a0eeff2e4b023f150c803f4",
    "name": "mmm",
    "companyStatus": "inactive",
    "currency": "EUR"
}, {
    "id": "5a69b7f7e4b0e8e18e94fdee",
    "name": "nitin's 2 company",
    "companyStatus": "inactive",
    "currency": "EUR"
}, {
    "id": "5a77ecf3e4b0f00aebcb20ee",
    "name": "sdsada",
    "companyStatus": "inactive",
    "currency": "GBP"
}, {
    "id": "5a0e56eae4b0614999a86798",
    "name": "sss",
    "companyStatus": "inactive",
    "currency": "EUR"
}, {
    "id": "5a13b859e4b0018614c6cfa2",
    "name": "sup4",
    "companyStatus": "inactive",
    "currency": "EUR"
}, {
    "id": "5a13b88ce4b0018614c6cfa5",
    "name": "sup5",
    "companyStatus": "inactive",
    "currency": "EUR"
}, {
    "id": "5a13b8e4e4b0018614c6cfa8",
    "name": "sup6",
    "companyStatus": "inactive",
    "currency": "EUR"
}, {
    "id": "5a612eb2b64a80f5852235f0",
    "name": "t",
    "companyStatus": "inactive",
    "currency": "EUR"
}, {
    "id": "5a150c0be4b0c4cba4c0cb4a",
    "name": "uuuiii",
    "companyStatus": "inactive",
    "currency": "EUR"
}, {
    "id": "59d8f906e4b0f393948831f2",
    "name": "x",
    "companyStatus": "inactive",
    "currency": "EUR"
}, {
    "id": "59f37975e4b0ed18a75174b9",
    "name": "xxxxx",
    "companyStatus": "inactive",
    "currency": "GBP"
}];

var company = {
    "id": "59dcd421e4b0bc51008ea0dc",
    "oosId": 1234567,
    "phone": "123",
    "name": "george's pizzeria",
    "email": "george@damudo.at",
    "createdOn": "2017-10-10T14:07:29.260+0000",
    "createdBy": "59d224d88d60691acf763dba",
    "modifiedBy": "59d224d88d60691acf763dba",
    "modifiedOn": "2018-01-23T12:21:43.505+0000",
    "companyStatus": "active",
    "currency": "GBP",
    "test": false,
    "completePrint": true,
    "deliveryChargesTaxRate": 0,
    "tipTaxRate": 0,
    "address": {
        "line1": "masterstreet 1a",
        "locality": ".",
        "townCity": "London",
        "country": "UK",
        "postalCode": "SW1A 1AA"
    },
    "openingDaysAndHours": [{
        "day": "MONDAY",
        "start": "8.3",
        "end": "12:30"
    }, {
        "day": "MONDAY",
        "start": "14.0",
        "end": "23.0"
    }, {
        "day": "TUESDAY",
        "start": "8.0",
        "end": "12.0"
    }, {
        "day": "TUESDAY",
        "start": "14.0",
        "end": "23.0"
    }, {
        "day": "FRIDAY",
        "start": "10:00",
        "end": "14:30"
    }],
    "deliveryCharges": {
        "type": "chargespermile",
        "chargesPerMile": 3
    },
    "paymentTypes": ["Cash", "Card"],
    "config_update_frequency_in_minutes": 1,
    "vatRates": [0, 10],
    "paymentIntegration": false,
    "lastSynchedOn": "2018-01-23T10:56:38.227+0000",
    "lastContactedOn": "2018-01-23T12:21:43.505+0000"
};

/***/ }),
/* 10 */,
/* 11 */,
/* 12 */,
/* 13 */,
/* 14 */,
/* 15 */,
/* 16 */,
/* 17 */,
/* 18 */,
/* 19 */,
/* 20 */,
/* 21 */,
/* 22 */,
/* 23 */,
/* 24 */,
/* 25 */,
/* 26 */,
/* 27 */,
/* 28 */,
/* 29 */,
/* 30 */,
/* 31 */,
/* 32 */,
/* 33 */,
/* 34 */,
/* 35 */,
/* 36 */,
/* 37 */,
/* 38 */,
/* 39 */,
/* 40 */,
/* 41 */,
/* 42 */,
/* 43 */,
/* 44 */,
/* 45 */,
/* 46 */,
/* 47 */,
/* 48 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ([{
  path: 'companies',
  roles: ['ROLE_SUN_ADMIN_COMPANY', 'ROLE_SUN_LOCAL_ADMIN']
}, {
  path: 'accounts',
  roles: ['ROLE_SUN_ADMIN_ACCOUNT', 'ROLE_SUN_LOCAL_ADMIN']
}, {
  path: 'app-resources',
  roles: ['ROLE_SUN_ADMIN_APPS']
}, {
  path: 'paymentTerminals',
  roles: ['ROLE_SUN_ADMIN_PAYMENT_TERMINAL', 'ROLE_SUN_LOCAL_ADMIN']
}, {
  path: 'paymentServers',
  roles: ['ROLE_SUN_ADMIN_PAYMENT_SERVER', 'ROLE_SUN_LOCAL_ADMIN']
}, {
  path: 'printers',
  roles: ['ROLE_SUN_ADMIN_PRINTER', 'ROLE_SUN_LOCAL_ADMIN']
}, {
  path: 'licenses',
  roles: ['ROLE_SUN_ADMIN_LICENSE']
}, {
  path: 'print-servers',
  roles: ['ROLE_SUN_ADMIN_PRINT_SERVER', 'ROLE_SUN_LOCAL_ADMIN']
}, {
  path: 'caller-id-servers',
  roles: ['ROLE_SUN_ADMIN_CALLERID_SERVER']
}, {
  path: 'catalog',
  roles: ['ROLE_SUN_ADMIN_CATALOG', 'ROLE_SUN_LOCAL_ADMIN']
}, {
  path: 'tables',
  roles: ['ROLE_SUN_ADMIN_TABLE_CREATOR', 'ROLE_SUN_LOCAL_ADMIN']
}, {
  path: 'table-categories',
  roles: ['ROLE_SUN_ADMIN_TABLE_CREATOR', 'ROLE_SUN_LOCAL_ADMIN']
}, {
  path: 'corporations',
  roles: ['ROLE_SUN_ADMIN_CORPORATION']
}, {
  path: 'web-space-dashboard',
  roles: ['ROLE_SUN_ADMIN_WEB_RESOURCE']
}, {
  path: 'domain-dashboard',
  roles: ['ROLE_SUN_ADMIN_WEB_RESOURCE']
}, {
  path: 'license-reports',
  roles: ['ROLE_SUN_ADMIN']
}, {
  path: 'invoices',
  roles: ['ROLE_SUN_ADMIN_PRICING', 'ROLE_SUN_ADMIN_COMPANY']
}, {
  path: 'resource-tracking',
  roles: ['ROLE_SUN_ADMIN_PRICING']
}, {
  path: 'audit-log',
  roles: ['ROLE_SUN_ADMIN']
}, {
  path: 'auto-jobs',
  roles: ['ROLE_SUN_ADMIN']
}, {
  path: 'config-updates',
  roles: ['ROLE_SUN_ADMIN']
}, {
  path: 'discount',
  roles: ['ROLE_SUN_ADMIN']
}, {
  path: 'language-mappings',
  roles: ['ROLE_SUN_ADMIN']
}, {
  path: 'moon-backup',
  roles: ['ROLE_SUN_ADMIN']
}, {
  path: 'moon-instance-dashboard',
  roles: ['ROLE_SUN_ADMIN']
}, {
  path: 'print-templates',
  roles: ['ROLE_SUN_ADMIN']
}, {
  path: 'system-logs',
  roles: ['ROLE_SUN_ADMIN']
}, {
  path: 'web-shop-dashboard',
  roles: ['ROLE_SUN_ADMIN', 'ROLE_SUN_LOCAL_ADMIN']
}, {
  path: 'webshopusage-reports',
  roles: ['ROLE_SUN_ADMIN']
}, {
  path: 'cash-register',
  roles: ['ROLE_SUN_ADMIN_CASHREGISTER']
}, {
  path: 'images',
  roles: ['ROLE_SUN_ADMIN_CATALOG', 'ROLE_SUN_LOCAL_ADMIN']
}]);

/***/ }),
/* 49 */,
/* 50 */,
/* 51 */,
/* 52 */,
/* 53 */,
/* 54 */,
/* 55 */,
/* 56 */,
/* 57 */,
/* 58 */,
/* 59 */,
/* 60 */,
/* 61 */,
/* 62 */,
/* 63 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/dashboard-bg.40e997c.jpg";

/***/ }),
/* 64 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__(230);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_cookie__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_cookie___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_vue_cookie__);





var helper = function helper(vue) {
  return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()({
    isLoggedIn: !!__WEBPACK_IMPORTED_MODULE_3_vue_cookie___default.a.get('uuid'),
    roles: JSON.parse(__WEBPACK_IMPORTED_MODULE_3_vue_cookie___default.a.get('roles') || '[]'),
    expires: '8h',

    rolesCookieUpdate: function rolesCookieUpdate(newRoles) {
      this.roles = newRoles;
      __WEBPACK_IMPORTED_MODULE_3_vue_cookie___default.a.set('roles', __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify___default()(newRoles), { expires: this.expires });
    },

    // Post form data for auth
    login: function login(authData) {
      var _this = this;

      return new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve) {
        vue.http.post('login', authData).then(function (res) {
          if (res.body.status !== 'Success') throw new Error();
          __WEBPACK_IMPORTED_MODULE_3_vue_cookie___default.a.set('uuid', res.body.sessionId, { expires: _this.expires });
          __WEBPACK_IMPORTED_MODULE_3_vue_cookie___default.a.delete('companyedit');
          localStorage.currentUser = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify___default()(res.body);
          _this.isLoggedIn = true;
          return vue.http.get('account/roles');
        }).then(function (res) {
          if (res.body.status !== 'Success') throw new Error();
          _this.rolesCookieUpdate(res.body.roles);
          resolve(null);
        }).catch(function (err) {
          _this.logout();
          resolve('Failed to log in');
        });
      });
    },
    logout: function logout() {
      this.roles = [];
      this.isLoggedIn = false;
      this.loginProcessStarted = false;
    }
  }, 'isLoggedIn', function isLoggedIn() {
    return this.isLoggedIn;
  });
};
/* eslint-disable */
var auth = {
  install: function install(Vue) {
    Vue.prototype.$auth = helper(Vue);
  }
};

/* harmony default export */ __webpack_exports__["a"] = (auth);

/***/ }),
/* 65 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_router__ = __webpack_require__(441);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_cookie__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_cookie___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_vue_cookie__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_Layout__ = __webpack_require__(320);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_Layout___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_Layout__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_Home__ = __webpack_require__(319);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_Home___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__components_Home__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_LogIn__ = __webpack_require__(321);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_LogIn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__components_LogIn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_SignUp__ = __webpack_require__(322);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_SignUp___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__components_SignUp__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_FixedLayout__ = __webpack_require__(318);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_FixedLayout___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__components_FixedLayout__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_accounts_Accounts__ = __webpack_require__(324);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_accounts_Accounts___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__components_accounts_Accounts__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_accounts_AccountDetails__ = __webpack_require__(323);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_accounts_AccountDetails___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__components_accounts_AccountDetails__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_appResource_AppResource__ = __webpack_require__(325);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_appResource_AppResource___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__components_appResource_AppResource__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__components_appResource_AppResourceDetails__ = __webpack_require__(326);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__components_appResource_AppResourceDetails___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11__components_appResource_AppResourceDetails__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__components_audit_AuditLog__ = __webpack_require__(327);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__components_audit_AuditLog___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12__components_audit_AuditLog__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__components_autoJob_AutoJob__ = __webpack_require__(328);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__components_autoJob_AutoJob___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13__components_autoJob_AutoJob__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__components_company_Companies__ = __webpack_require__(335);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__components_company_Companies___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14__components_company_Companies__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__components_company_CompanyDetails__ = __webpack_require__(336);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__components_company_CompanyDetails___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15__components_company_CompanyDetails__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__components_configUpdates_ConfigUpdates__ = __webpack_require__(337);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__components_configUpdates_ConfigUpdates___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_16__components_configUpdates_ConfigUpdates__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__components_corporations_Corporations__ = __webpack_require__(339);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__components_corporations_Corporations___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_17__components_corporations_Corporations__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__components_corporations_CorporationDetails__ = __webpack_require__(338);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__components_corporations_CorporationDetails___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_18__components_corporations_CorporationDetails__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__components_callerID_CallerIdServers__ = __webpack_require__(330);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__components_callerID_CallerIdServers___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_19__components_callerID_CallerIdServers__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__components_callerID_CallerIdDetails__ = __webpack_require__(329);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__components_callerID_CallerIdDetails___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_20__components_callerID_CallerIdDetails__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__components_discountRules_DiscountRules__ = __webpack_require__(341);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__components_discountRules_DiscountRules___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_21__components_discountRules_DiscountRules__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__components_discountRules_DiscountRuleDetails__ = __webpack_require__(340);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__components_discountRules_DiscountRuleDetails___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_22__components_discountRules_DiscountRuleDetails__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__components_domains_Domains__ = __webpack_require__(342);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__components_domains_Domains___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_23__components_domains_Domains__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__components_domains_NewDomain__ = __webpack_require__(343);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__components_domains_NewDomain___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_24__components_domains_NewDomain__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__components_languageMappings_LanguageMappings__ = __webpack_require__(348);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__components_languageMappings_LanguageMappings___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_25__components_languageMappings_LanguageMappings__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26__components_languageMappings_LanguageMappingDetails__ = __webpack_require__(347);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26__components_languageMappings_LanguageMappingDetails___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_26__components_languageMappings_LanguageMappingDetails__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27__components_licenses_Licenses__ = __webpack_require__(351);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27__components_licenses_Licenses___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_27__components_licenses_Licenses__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28__components_licenses_LicenseDetails__ = __webpack_require__(349);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28__components_licenses_LicenseDetails___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_28__components_licenses_LicenseDetails__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_29__components_licenses_LicenseReports__ = __webpack_require__(350);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_29__components_licenses_LicenseReports___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_29__components_licenses_LicenseReports__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_30__components_moonInstances_MoonInstances__ = __webpack_require__(355);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_30__components_moonInstances_MoonInstances___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_30__components_moonInstances_MoonInstances__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_31__components_moonInstances_MoonInstanceDetails__ = __webpack_require__(354);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_31__components_moonInstances_MoonInstanceDetails___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_31__components_moonInstances_MoonInstanceDetails__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_32__components_invoices_Invoices__ = __webpack_require__(346);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_32__components_invoices_Invoices___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_32__components_invoices_Invoices__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_33__components_images_Images__ = __webpack_require__(345);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_33__components_images_Images___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_33__components_images_Images__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_34__components_images_ImageDetails__ = __webpack_require__(344);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_34__components_images_ImageDetails___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_34__components_images_ImageDetails__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_35__components_paymentTerminals_PaymentTerminals__ = __webpack_require__(359);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_35__components_paymentTerminals_PaymentTerminals___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_35__components_paymentTerminals_PaymentTerminals__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_36__components_paymentTerminals_PaymentTerminalDetails__ = __webpack_require__(358);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_36__components_paymentTerminals_PaymentTerminalDetails___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_36__components_paymentTerminals_PaymentTerminalDetails__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_37__components_printers_Printers__ = __webpack_require__(365);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_37__components_printers_Printers___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_37__components_printers_Printers__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_38__components_printers_PrinterDetails__ = __webpack_require__(364);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_38__components_printers_PrinterDetails___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_38__components_printers_PrinterDetails__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_39__components_printTemplates_PrintTemplates__ = __webpack_require__(363);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_39__components_printTemplates_PrintTemplates___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_39__components_printTemplates_PrintTemplates__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_40__components_printTemplates_PrintTemplateDetails__ = __webpack_require__(362);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_40__components_printTemplates_PrintTemplateDetails___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_40__components_printTemplates_PrintTemplateDetails__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_41__components_printServers_PrintServers__ = __webpack_require__(361);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_41__components_printServers_PrintServers___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_41__components_printServers_PrintServers__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_42__components_printServers_PrintServerDetails__ = __webpack_require__(360);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_42__components_printServers_PrintServerDetails___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_42__components_printServers_PrintServerDetails__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_43__components_paymentServers_PaymentServers__ = __webpack_require__(357);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_43__components_paymentServers_PaymentServers___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_43__components_paymentServers_PaymentServers__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_44__components_paymentServers_PaymentServerDetails__ = __webpack_require__(356);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_44__components_paymentServers_PaymentServerDetails___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_44__components_paymentServers_PaymentServerDetails__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_45__components_resourceTracking_ResourceTracking__ = __webpack_require__(366);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_45__components_resourceTracking_ResourceTracking___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_45__components_resourceTracking_ResourceTracking__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_46__components_webshopReports_WebshopReports__ = __webpack_require__(377);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_46__components_webshopReports_WebshopReports___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_46__components_webshopReports_WebshopReports__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_47__components_tables_Tables__ = __webpack_require__(371);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_47__components_tables_Tables___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_47__components_tables_Tables__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_48__components_tables_TableDetail__ = __webpack_require__(370);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_48__components_tables_TableDetail___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_48__components_tables_TableDetail__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_49__components_tables_TableCategories__ = __webpack_require__(368);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_49__components_tables_TableCategories___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_49__components_tables_TableCategories__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_50__components_tables_TableCategoryDetail__ = __webpack_require__(369);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_50__components_tables_TableCategoryDetail___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_50__components_tables_TableCategoryDetail__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_51__components_systemLogs_SystemLogs__ = __webpack_require__(367);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_51__components_systemLogs_SystemLogs___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_51__components_systemLogs_SystemLogs__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_52__components_webShop_WebShop__ = __webpack_require__(372);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_52__components_webShop_WebShop___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_52__components_webShop_WebShop__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_53__components_webShop_WebShopDetail__ = __webpack_require__(373);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_53__components_webShop_WebShopDetail___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_53__components_webShop_WebShopDetail__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_54__components_webShop_WebShopOrder__ = __webpack_require__(374);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_54__components_webShop_WebShopOrder___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_54__components_webShop_WebShopOrder__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_55__components_webSpace_WebSpaces__ = __webpack_require__(376);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_55__components_webSpace_WebSpaces___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_55__components_webSpace_WebSpaces__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_56__components_webSpace_NewWebSpace__ = __webpack_require__(375);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_56__components_webSpace_NewWebSpace___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_56__components_webSpace_NewWebSpace__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_57__components_catalog_List__ = __webpack_require__(333);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_57__components_catalog_List___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_57__components_catalog_List__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_58__components_catalog_Single__ = __webpack_require__(334);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_58__components_catalog_Single___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_58__components_catalog_Single__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_59__components_cashRegister_CashRegister__ = __webpack_require__(331);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_59__components_cashRegister_CashRegister___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_59__components_cashRegister_CashRegister__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_60__components_cashRegister_CashRegisterDetails__ = __webpack_require__(332);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_60__components_cashRegister_CashRegisterDetails___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_60__components_cashRegister_CashRegisterDetails__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_61__components_404__ = __webpack_require__(317);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_61__components_404___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_61__components_404__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_62__role_map__ = __webpack_require__(48);































































































__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]);

var lang = __WEBPACK_IMPORTED_MODULE_2_vue_cookie___default.a.get('lang') || 'en';

var shouldBlock = function shouldBlock(route) {
  var roles = __WEBPACK_IMPORTED_MODULE_2_vue_cookie___default.a.get('roles') || [];
  var currentGuard = __WEBPACK_IMPORTED_MODULE_62__role_map__["a" /* default */].find(function (block) {
    return block.path === route;
  });
  if (!currentGuard) return false;
  var shouldBlock = true;
  currentGuard.roles.forEach(function (role) {
    if (roles.includes(role)) shouldBlock = false;
  });
  return shouldBlock;
};

/* harmony default export */ __webpack_exports__["a"] = (new __WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]({
  routes: [{
    path: '/',
    redirect: '/' + lang
  }, {
    path: '/log-in',
    name: 'logIn',
    component: __WEBPACK_IMPORTED_MODULE_5__components_LogIn___default.a,
    // If logged in, redirect
    beforeEnter: function beforeEnter(to, from, next) {
      if (!!__WEBPACK_IMPORTED_MODULE_2_vue_cookie___default.a.get('uuid')) {
        next({ name: 'home' });
      } else {
        next();
      }
    }
  }, {
    path: '/log-out',
    name: 'logOut',
    // Log out and redirect
    beforeEnter: function beforeEnter(to, from, next) {
      __WEBPACK_IMPORTED_MODULE_2_vue_cookie___default.a.delete('uuid');
      __WEBPACK_IMPORTED_MODULE_2_vue_cookie___default.a.delete('roles');
      localStorage.removeItem('currentUser');
      next({ name: 'logIn' });
    }
  }, {
    path: '/sign-up',
    name: 'signUp',
    component: __WEBPACK_IMPORTED_MODULE_6__components_SignUp___default.a
  }, {
    path: '/:lang',
    component: __WEBPACK_IMPORTED_MODULE_3__components_Layout___default.a,
    // If not logged in, redirect
    beforeEnter: function beforeEnter(to, from, next) {
      if (!!__WEBPACK_IMPORTED_MODULE_2_vue_cookie___default.a.get('uuid')) {
        next();
      } else {
        next({ name: 'logIn' });
      }
    },
    children: [{
      path: '',
      name: 'home',
      component: __WEBPACK_IMPORTED_MODULE_4__components_Home___default.a
    }, {
      path: 'accounts',
      component: __WEBPACK_IMPORTED_MODULE_7__components_FixedLayout___default.a,
      beforeEnter: function beforeEnter(to, from, next) {
        if (!shouldBlock('accounts')) {
          next();
        } else {
          next({ name: 'home' });
        }
      },
      children: [{
        path: '',
        component: __WEBPACK_IMPORTED_MODULE_8__components_accounts_Accounts___default.a,
        name: 'accounts'
      }, {
        path: 'create',
        component: __WEBPACK_IMPORTED_MODULE_9__components_accounts_AccountDetails___default.a,
        name: 'createAccount'
      }, {
        path: 'edit/:id',
        component: __WEBPACK_IMPORTED_MODULE_9__components_accounts_AccountDetails___default.a,
        name: 'editAccunt'
      }]
    }, {
      path: 'app-resources',
      component: __WEBPACK_IMPORTED_MODULE_7__components_FixedLayout___default.a,
      beforeEnter: function beforeEnter(to, from, next) {
        if (!shouldBlock('app-resources')) {
          next();
        } else {
          next({ name: 'home' });
        }
      },
      children: [{
        path: '',
        component: __WEBPACK_IMPORTED_MODULE_10__components_appResource_AppResource___default.a,
        name: 'appResources'
      }, {
        path: 'create',
        component: __WEBPACK_IMPORTED_MODULE_11__components_appResource_AppResourceDetails___default.a,
        name: 'appResourceCreate'
      }, {
        path: 'edit/:id',
        component: __WEBPACK_IMPORTED_MODULE_11__components_appResource_AppResourceDetails___default.a,
        name: 'appResourceEdit'
      }]
    }, {
      path: 'audit-log',
      component: __WEBPACK_IMPORTED_MODULE_7__components_FixedLayout___default.a,
      beforeEnter: function beforeEnter(to, from, next) {
        if (!shouldBlock('audit-log')) {
          next();
        } else {
          next({ name: 'home' });
        }
      },
      children: [{
        path: '',
        component: __WEBPACK_IMPORTED_MODULE_12__components_audit_AuditLog___default.a,
        name: 'auditLog'
      }]
    }, {
      path: 'auto-jobs',
      component: __WEBPACK_IMPORTED_MODULE_7__components_FixedLayout___default.a,
      beforeEnter: function beforeEnter(to, from, next) {
        if (!shouldBlock('auto-jobs')) {
          next();
        } else {
          next({ name: 'home' });
        }
      },
      children: [{
        path: '',
        component: __WEBPACK_IMPORTED_MODULE_13__components_autoJob_AutoJob___default.a,
        name: 'autoJobs'
      }]
    }, {
      path: 'companies',
      component: __WEBPACK_IMPORTED_MODULE_7__components_FixedLayout___default.a,
      beforeEnter: function beforeEnter(to, from, next) {
        if (!shouldBlock('companies')) {
          next();
        } else {
          next({ name: 'home' });
        }
      },
      children: [{
        path: '',
        component: __WEBPACK_IMPORTED_MODULE_14__components_company_Companies___default.a,
        name: 'companies'
      }, {
        path: 'create',
        component: __WEBPACK_IMPORTED_MODULE_15__components_company_CompanyDetails___default.a,
        name: 'createCompany'
      }, {
        path: 'edit/:id',
        component: __WEBPACK_IMPORTED_MODULE_15__components_company_CompanyDetails___default.a,
        name: 'editCompany'
      }]
    }, {
      path: 'catalog',
      component: __WEBPACK_IMPORTED_MODULE_7__components_FixedLayout___default.a,
      beforeEnter: function beforeEnter(to, from, next) {
        if (!shouldBlock('catalog')) {
          next();
        } else {
          next({ name: 'home' });
        }
      },
      children: [{
        path: '',
        redirect: { name: 'catalogList' }
      }, {
        path: 'list',
        component: __WEBPACK_IMPORTED_MODULE_57__components_catalog_List___default.a,
        name: 'catalogList'
      }, {
        path: 'create',
        component: __WEBPACK_IMPORTED_MODULE_58__components_catalog_Single___default.a,
        name: 'catalogCreate'
      }]
    }, {
      path: 'caller-id-servers',
      component: __WEBPACK_IMPORTED_MODULE_7__components_FixedLayout___default.a,
      beforeEnter: function beforeEnter(to, from, next) {
        if (!shouldBlock('caller-id-servers')) {
          next();
        } else {
          next({ name: 'home' });
        }
      },
      children: [{
        path: '',
        component: __WEBPACK_IMPORTED_MODULE_19__components_callerID_CallerIdServers___default.a,
        name: 'callerIdServers'
      }, {
        path: 'create',
        component: __WEBPACK_IMPORTED_MODULE_20__components_callerID_CallerIdDetails___default.a,
        name: 'callerIdCreate'
      }, {
        path: 'edit/:id',
        component: __WEBPACK_IMPORTED_MODULE_20__components_callerID_CallerIdDetails___default.a,
        name: 'callerIdEdit'
      }]
    }, {
      path: 'corporations',
      component: __WEBPACK_IMPORTED_MODULE_7__components_FixedLayout___default.a,
      beforeEnter: function beforeEnter(to, from, next) {
        if (!shouldBlock('corporations')) {
          next();
        } else {
          next({ name: 'home' });
        }
      },
      children: [{
        path: '',
        component: __WEBPACK_IMPORTED_MODULE_17__components_corporations_Corporations___default.a,
        name: 'corporations'
      }, {
        path: 'create',
        component: __WEBPACK_IMPORTED_MODULE_18__components_corporations_CorporationDetails___default.a,
        name: 'corporationCreate'
      }, {
        path: 'edit/:id',
        component: __WEBPACK_IMPORTED_MODULE_18__components_corporations_CorporationDetails___default.a,
        name: 'corporationEdit'
      }]
    }, {
      path: 'config-updates',
      component: __WEBPACK_IMPORTED_MODULE_7__components_FixedLayout___default.a,
      beforeEnter: function beforeEnter(to, from, next) {
        if (!shouldBlock('config-updates')) {
          next();
        } else {
          next({ name: 'home' });
        }
      },
      children: [{
        path: '',
        component: __WEBPACK_IMPORTED_MODULE_16__components_configUpdates_ConfigUpdates___default.a,
        name: 'configUpdates'
      }]
    }, {
      path: 'discount',
      component: __WEBPACK_IMPORTED_MODULE_7__components_FixedLayout___default.a,
      beforeEnter: function beforeEnter(to, from, next) {
        if (!shouldBlock('discount')) {
          next();
        } else {
          next({ name: 'home' });
        }
      },
      children: [{
        path: '',
        component: __WEBPACK_IMPORTED_MODULE_21__components_discountRules_DiscountRules___default.a,
        name: 'discountRules'
      }, {
        path: 'create',
        component: __WEBPACK_IMPORTED_MODULE_22__components_discountRules_DiscountRuleDetails___default.a,
        name: 'discountCreate'
      }, {
        path: 'edit/:id',
        component: __WEBPACK_IMPORTED_MODULE_22__components_discountRules_DiscountRuleDetails___default.a,
        name: 'discountEdit'
      }]
    }, {
      path: 'domain-dashboard',
      component: __WEBPACK_IMPORTED_MODULE_7__components_FixedLayout___default.a,
      beforeEnter: function beforeEnter(to, from, next) {
        if (!shouldBlock('domain-dashboard')) {
          next();
        } else {
          next({ name: 'home' });
        }
      },
      children: [{
        path: '',
        component: __WEBPACK_IMPORTED_MODULE_23__components_domains_Domains___default.a,
        name: 'domains'
      }, {
        path: 'domain-create',
        component: __WEBPACK_IMPORTED_MODULE_24__components_domains_NewDomain___default.a,
        name: 'newDomain'
      }, {
        path: 'domain-edit/:id',
        component: __WEBPACK_IMPORTED_MODULE_24__components_domains_NewDomain___default.a,
        name: 'editDomain'
      }]
    }, {
      path: 'language-mappings',
      component: __WEBPACK_IMPORTED_MODULE_7__components_FixedLayout___default.a,
      beforeEnter: function beforeEnter(to, from, next) {
        if (!shouldBlock('language-mappings')) {
          next();
        } else {
          next({ name: 'home' });
        }
      },
      children: [{
        path: '',
        component: __WEBPACK_IMPORTED_MODULE_25__components_languageMappings_LanguageMappings___default.a,
        name: 'languageMappings'
      }, {
        path: 'create',
        component: __WEBPACK_IMPORTED_MODULE_26__components_languageMappings_LanguageMappingDetails___default.a,
        name: 'languageMappingCreate'
      }, {
        path: 'edit/:id',
        component: __WEBPACK_IMPORTED_MODULE_26__components_languageMappings_LanguageMappingDetails___default.a,
        name: 'languageMappingEdit'
      }]
    }, {
      path: 'webshopusage-reports',
      component: __WEBPACK_IMPORTED_MODULE_7__components_FixedLayout___default.a,
      beforeEnter: function beforeEnter(to, from, next) {
        if (!shouldBlock('webshopusage-reports')) {
          next();
        } else {
          next({ name: 'home' });
        }
      },
      children: [{
        path: '',
        component: __WEBPACK_IMPORTED_MODULE_46__components_webshopReports_WebshopReports___default.a,
        name: 'webshopReports'
      }]
    }, {
      path: 'licenses',
      component: __WEBPACK_IMPORTED_MODULE_7__components_FixedLayout___default.a,
      beforeEnter: function beforeEnter(to, from, next) {
        if (!shouldBlock('licenses')) {
          next();
        } else {
          next({ name: 'home' });
        }
      },
      children: [{
        path: '',
        component: __WEBPACK_IMPORTED_MODULE_27__components_licenses_Licenses___default.a,
        name: 'licenses'
      }, {
        path: 'license-create',
        component: __WEBPACK_IMPORTED_MODULE_28__components_licenses_LicenseDetails___default.a,
        name: 'licenseCreate'
      }, {
        path: 'license/:id',
        component: __WEBPACK_IMPORTED_MODULE_28__components_licenses_LicenseDetails___default.a,
        name: 'license'
      }]
    }, {
      path: 'license-reports',
      component: __WEBPACK_IMPORTED_MODULE_7__components_FixedLayout___default.a,
      beforeEnter: function beforeEnter(to, from, next) {
        if (!shouldBlock('license-reports')) {
          next();
        } else {
          next({ name: 'home' });
        }
      },
      children: [{
        path: '',
        component: __WEBPACK_IMPORTED_MODULE_29__components_licenses_LicenseReports___default.a,
        name: 'licenseReports'
      }]
    }, {
      path: 'invoices',
      component: __WEBPACK_IMPORTED_MODULE_7__components_FixedLayout___default.a,
      beforeEnter: function beforeEnter(to, from, next) {
        if (!shouldBlock('invoices')) {
          next();
        } else {
          next({ name: 'home' });
        }
      },
      children: [{
        path: '',
        component: __WEBPACK_IMPORTED_MODULE_32__components_invoices_Invoices___default.a,
        name: 'invoices'
      }]
    }, {
      path: 'images',
      component: __WEBPACK_IMPORTED_MODULE_7__components_FixedLayout___default.a,
      beforeEnter: function beforeEnter(to, from, next) {
        if (!shouldBlock('images')) {
          next();
        } else {
          next({ name: 'home' });
        }
      },
      children: [{
        path: '',
        component: __WEBPACK_IMPORTED_MODULE_33__components_images_Images___default.a,
        name: 'images'
      }, {
        path: 'create',
        component: __WEBPACK_IMPORTED_MODULE_34__components_images_ImageDetails___default.a,
        name: 'imageCreate'
      }, {
        path: 'edit/:id',
        component: __WEBPACK_IMPORTED_MODULE_34__components_images_ImageDetails___default.a,
        name: 'image'
      }]
    }, {
      path: 'payment-terminals',
      component: __WEBPACK_IMPORTED_MODULE_7__components_FixedLayout___default.a,
      beforeEnter: function beforeEnter(to, from, next) {
        if (!shouldBlock('paymentTerminals')) {
          next();
        } else {
          next({ name: 'home' });
        }
      },
      children: [{
        path: '',
        component: __WEBPACK_IMPORTED_MODULE_35__components_paymentTerminals_PaymentTerminals___default.a,
        name: 'paymentTerminals'
      }, {
        path: 'create',
        component: __WEBPACK_IMPORTED_MODULE_36__components_paymentTerminals_PaymentTerminalDetails___default.a,
        name: 'paymentTerminalCreate'
      }, {
        path: 'edit/:id',
        component: __WEBPACK_IMPORTED_MODULE_36__components_paymentTerminals_PaymentTerminalDetails___default.a,
        name: 'paymentTerminal'
      }]
    }, {
      path: 'payment-servers',
      component: __WEBPACK_IMPORTED_MODULE_7__components_FixedLayout___default.a,
      beforeEnter: function beforeEnter(to, from, next) {
        if (!shouldBlock('paymentServers')) {
          next();
        } else {
          next({ name: 'home' });
        }
      },
      children: [{
        path: '',
        component: __WEBPACK_IMPORTED_MODULE_43__components_paymentServers_PaymentServers___default.a,
        name: 'paymentServers'
      }, {
        path: 'create',
        component: __WEBPACK_IMPORTED_MODULE_44__components_paymentServers_PaymentServerDetails___default.a,
        name: 'paymentServerCreate'
      }, {
        path: 'edit/:id',
        component: __WEBPACK_IMPORTED_MODULE_44__components_paymentServers_PaymentServerDetails___default.a,
        name: 'paymentServer'
      }]
    }, {
      path: 'printers',
      component: __WEBPACK_IMPORTED_MODULE_7__components_FixedLayout___default.a,
      beforeEnter: function beforeEnter(to, from, next) {
        if (!shouldBlock('printers')) {
          next();
        } else {
          next({ name: 'home' });
        }
      },
      children: [{
        path: '',
        component: __WEBPACK_IMPORTED_MODULE_37__components_printers_Printers___default.a,
        name: 'printers'
      }, {
        path: 'create',
        component: __WEBPACK_IMPORTED_MODULE_38__components_printers_PrinterDetails___default.a,
        name: 'printerCreate'
      }, {
        path: 'edit/:id',
        component: __WEBPACK_IMPORTED_MODULE_38__components_printers_PrinterDetails___default.a,
        name: 'printer'
      }]
    }, {
      path: 'print-servers',
      component: __WEBPACK_IMPORTED_MODULE_7__components_FixedLayout___default.a,
      beforeEnter: function beforeEnter(to, from, next) {
        if (!shouldBlock('print-servers')) {
          next();
        } else {
          next({ name: 'home' });
        }
      },
      children: [{
        path: '',
        component: __WEBPACK_IMPORTED_MODULE_41__components_printServers_PrintServers___default.a,
        name: 'printServers'
      }, {
        path: 'create',
        component: __WEBPACK_IMPORTED_MODULE_42__components_printServers_PrintServerDetails___default.a,
        name: 'printServerCreate'
      }, {
        path: 'edit/:id',
        component: __WEBPACK_IMPORTED_MODULE_42__components_printServers_PrintServerDetails___default.a,
        name: 'printServer'
      }]
    }, {
      path: 'print-templates',
      component: __WEBPACK_IMPORTED_MODULE_7__components_FixedLayout___default.a,
      beforeEnter: function beforeEnter(to, from, next) {
        if (!shouldBlock('print-templates')) {
          next();
        } else {
          next({ name: 'home' });
        }
      },
      children: [{
        path: '',
        component: __WEBPACK_IMPORTED_MODULE_39__components_printTemplates_PrintTemplates___default.a,
        name: 'printTemplates'
      }, {
        path: 'create',
        component: __WEBPACK_IMPORTED_MODULE_40__components_printTemplates_PrintTemplateDetails___default.a,
        name: 'printTemplateCreate'
      }, {
        path: 'view/:id',
        component: __WEBPACK_IMPORTED_MODULE_40__components_printTemplates_PrintTemplateDetails___default.a,
        name: 'printTemplate'
      }, {
        path: 'clone/:id',
        component: __WEBPACK_IMPORTED_MODULE_40__components_printTemplates_PrintTemplateDetails___default.a,
        name: 'printTemplateClone'
      }]
    }, {
      path: 'web-space-dashboard',
      component: __WEBPACK_IMPORTED_MODULE_7__components_FixedLayout___default.a,
      beforeEnter: function beforeEnter(to, from, next) {
        if (!shouldBlock('web-space-dashboard')) {
          next();
        } else {
          next({ name: 'home' });
        }
      },
      children: [{
        path: '',
        component: __WEBPACK_IMPORTED_MODULE_55__components_webSpace_WebSpaces___default.a,
        name: 'webSpaces'
      }, {
        path: 'web-space-create',
        component: __WEBPACK_IMPORTED_MODULE_56__components_webSpace_NewWebSpace___default.a,
        name: 'newWebSpace'
      }, {
        path: 'web-space-edit/:id',
        component: __WEBPACK_IMPORTED_MODULE_56__components_webSpace_NewWebSpace___default.a,
        name: 'editWebSpace'
      }]
    }, {
      path: 'tables',
      component: __WEBPACK_IMPORTED_MODULE_7__components_FixedLayout___default.a,
      beforeEnter: function beforeEnter(to, from, next) {
        if (!shouldBlock('tables')) {
          next();
        } else {
          next({ name: 'home' });
        }
      },
      children: [{
        path: '',
        component: __WEBPACK_IMPORTED_MODULE_47__components_tables_Tables___default.a,
        name: 'tables'
      }, {
        path: 'create',
        component: __WEBPACK_IMPORTED_MODULE_48__components_tables_TableDetail___default.a,
        name: 'tableDetailsCreate'
      }, {
        path: 'edit/:id',
        component: __WEBPACK_IMPORTED_MODULE_48__components_tables_TableDetail___default.a,
        name: 'tableDetails'
      }]
    }, {
      path: 'table-categories',
      component: __WEBPACK_IMPORTED_MODULE_7__components_FixedLayout___default.a,
      beforeEnter: function beforeEnter(to, from, next) {
        if (!shouldBlock('table-categories')) {
          next();
        } else {
          next({ name: 'home' });
        }
      },
      children: [{
        path: '',
        component: __WEBPACK_IMPORTED_MODULE_49__components_tables_TableCategories___default.a,
        name: 'tableCategories'
      }, {
        path: 'table-category-create',
        component: __WEBPACK_IMPORTED_MODULE_50__components_tables_TableCategoryDetail___default.a,
        name: 'tableCategoryCreate'
      }, {
        path: 'table-category-edit/:id',
        component: __WEBPACK_IMPORTED_MODULE_50__components_tables_TableCategoryDetail___default.a,
        name: 'tableCategoryUpdate'
      }]
    }, {
      path: 'moon-instance-dashboard',
      component: __WEBPACK_IMPORTED_MODULE_7__components_FixedLayout___default.a,
      beforeEnter: function beforeEnter(to, from, next) {
        if (!shouldBlock('moon-instance-dashboard')) {
          next();
        } else {
          next({ name: 'home' });
        }
      },
      children: [{
        path: '',
        component: __WEBPACK_IMPORTED_MODULE_30__components_moonInstances_MoonInstances___default.a,
        name: 'moonInstances'
      }, {
        path: 'moon-instance-detail/:id',
        component: __WEBPACK_IMPORTED_MODULE_31__components_moonInstances_MoonInstanceDetails___default.a,
        name: 'moonInstanceDetails'
      }]
    }, {
      path: 'resource-tracking',
      component: __WEBPACK_IMPORTED_MODULE_7__components_FixedLayout___default.a,
      beforeEnter: function beforeEnter(to, from, next) {
        if (!shouldBlock('resource-tracking')) {
          next();
        } else {
          next({ name: 'home' });
        }
      },
      children: [{
        path: '',
        component: __WEBPACK_IMPORTED_MODULE_45__components_resourceTracking_ResourceTracking___default.a,
        name: 'resourceTracking'
      }]
    }, {
      path: 'system-logs',
      component: __WEBPACK_IMPORTED_MODULE_7__components_FixedLayout___default.a,
      beforeEnter: function beforeEnter(to, from, next) {
        if (!shouldBlock('system-logs')) {
          next();
        } else {
          next({ name: 'home' });
        }
      },
      children: [{
        path: '',
        component: __WEBPACK_IMPORTED_MODULE_51__components_systemLogs_SystemLogs___default.a,
        name: 'systemLogs'
      }]
    }, {
      path: 'web-shop-dashboard',
      component: __WEBPACK_IMPORTED_MODULE_7__components_FixedLayout___default.a,
      beforeEnter: function beforeEnter(to, from, next) {
        if (!shouldBlock('web-shop-dashboard')) {
          next();
        } else {
          next({ name: 'home' });
        }
      },
      children: [{
        path: '',
        component: __WEBPACK_IMPORTED_MODULE_52__components_webShop_WebShop___default.a,
        name: 'webShop'
      }, {
        path: 'web-shop-create',
        component: __WEBPACK_IMPORTED_MODULE_53__components_webShop_WebShopDetail___default.a,
        name: 'webShopDetail'
      }, {
        path: 'web-shop-edit/:id',
        component: __WEBPACK_IMPORTED_MODULE_53__components_webShop_WebShopDetail___default.a,
        name: 'webShopEdit'
      }, {
        path: 'web-shop-order/:id',
        component: __WEBPACK_IMPORTED_MODULE_54__components_webShop_WebShopOrder___default.a,
        name: 'webShopOrder'
      }]
    }, {
      path: 'cash-register',
      component: __WEBPACK_IMPORTED_MODULE_7__components_FixedLayout___default.a,
      beforeEnter: function beforeEnter(to, from, next) {
        if (!shouldBlock('cash-register')) {
          next();
        } else {
          next({ name: 'home' });
        }
      },
      children: [{
        path: '',
        component: __WEBPACK_IMPORTED_MODULE_59__components_cashRegister_CashRegister___default.a,
        name: 'cashRegister'
      }, {
        path: 'cash-register-create',
        component: __WEBPACK_IMPORTED_MODULE_60__components_cashRegister_CashRegisterDetails___default.a,
        name: 'cashRegisterCreate'
      }, {
        path: 'cash-register-edit/:id',
        component: __WEBPACK_IMPORTED_MODULE_60__components_cashRegister_CashRegisterDetails___default.a,
        name: 'cashRegisterEdit'
      }]
    }]
  }, {
    path: '*',
    component: __WEBPACK_IMPORTED_MODULE_3__components_Layout___default.a,
    children: [{
      path: '',
      component: __WEBPACK_IMPORTED_MODULE_61__components_404___default.a,
      name: 'error-page'
    }]
  }],
  mode: 'history'
}));

/***/ }),
/* 66 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 67 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 68 */,
/* 69 */,
/* 70 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(293)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(165),
  /* template */
  __webpack_require__(411),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 71 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(304)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(181),
  /* template */
  __webpack_require__(432),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-bf5bb850",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 72 */,
/* 73 */,
/* 74 */,
/* 75 */,
/* 76 */
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./ar/actions.js": 85,
	"./ar/errors.js": 86,
	"./ar/global.js": 87,
	"./ar/header.js": 88,
	"./ar/labels.js": 89,
	"./de/actions.js": 90,
	"./de/errors.js": 91,
	"./de/global.js": 92,
	"./de/header.js": 93,
	"./de/labels.js": 94,
	"./de/license.js": 95,
	"./de/placeholders.js": 96,
	"./el/actions.js": 97,
	"./el/errors.js": 98,
	"./el/global.js": 99,
	"./el/header.js": 100,
	"./el/labels.js": 101,
	"./en/actions.js": 102,
	"./en/errors.js": 103,
	"./en/global.js": 104,
	"./en/header.js": 105,
	"./en/labels.js": 106,
	"./en/license.js": 107,
	"./en/placeholders.js": 108,
	"./es/actions.js": 109,
	"./es/errors.js": 110,
	"./es/global.js": 111,
	"./es/header.js": 112,
	"./es/labels.js": 113,
	"./fa/actions.js": 114,
	"./fa/errors.js": 115,
	"./fa/global.js": 116,
	"./fa/header.js": 117,
	"./fa/labels.js": 118,
	"./hi/actions.js": 119,
	"./hi/errors.js": 120,
	"./hi/global.js": 121,
	"./hi/header.js": 122,
	"./hi/labels.js": 123,
	"./it/actions.js": 124,
	"./it/errors.js": 125,
	"./it/global.js": 126,
	"./it/header.js": 127,
	"./it/labels.js": 128,
	"./ja/actions.js": 129,
	"./ja/errors.js": 130,
	"./ja/global.js": 131,
	"./ja/header.js": 132,
	"./ja/labels.js": 133,
	"./ko/actions.js": 134,
	"./ko/errors.js": 135,
	"./ko/global.js": 136,
	"./ko/header.js": 137,
	"./ko/labels.js": 138,
	"./nl/actions.js": 139,
	"./nl/errors.js": 140,
	"./nl/global.js": 141,
	"./nl/header.js": 142,
	"./nl/labels.js": 143,
	"./pl/actions.js": 144,
	"./pl/errors.js": 145,
	"./pl/global.js": 146,
	"./pl/header.js": 147,
	"./pl/labels.js": 148,
	"./pt/actions.js": 149,
	"./pt/errors.js": 150,
	"./pt/global.js": 151,
	"./pt/header.js": 152,
	"./pt/labels.js": 153,
	"./tr/actions.js": 154,
	"./tr/errors.js": 155,
	"./tr/global.js": 156,
	"./tr/header.js": 157,
	"./tr/labels.js": 158,
	"./zh/actions.js": 159,
	"./zh/errors.js": 160,
	"./zh/global.js": 161,
	"./zh/header.js": 162,
	"./zh/labels.js": 163
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 76;

/***/ }),
/* 77 */,
/* 78 */,
/* 79 */,
/* 80 */,
/* 81 */,
/* 82 */,
/* 83 */,
/* 84 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return allergensData; });
var allergensData = [{
  allergenId: 1,
  name: {
    de: "(A) Glutenhaltiges Getreide und daraus gewonnene Erzeugnisse",
    en: "(A) Cereals containing gluten: namely wheat (including specific varieties like spelt and Khorasan), rye, barley, oats and their hybridised strains) and products thereof"
  }
}, {
  allergenId: 2,
  name: {
    de: "(B) Krebstiere und daraus gewonnene Erzeugnisse",
    en: "(B) Crustaceans and products thereof (for example prawns, lobster, crabs and crayfish)"
  }
}, {
  allergenId: 3,
  name: {
    de: "(C) Eier von Geflügel und daraus gewonnene Erzeugnisse",
    en: "(C) Egg and products thereof"
  }
}, {
  allergenId: 4,
  name: {
    de: "(D) Fisch und daraus gewonnene Erzeugnisse (ausser Fischgelatine)",
    en: "(D) Fish and products thereof"
  }
}, {
  allergenId: 5,
  name: {
    de: "(E) Erdnüsse und daraus gewonnene Erzeugnisse",
    en: "(E) Peanut and products thereof"
  }
}, {
  allergenId: 6,
  name: {
    de: "(F) Sojabohnen und daraus gewonnene Erzeugnisse",
    en: "(F) Soybeans and products thereof"
  }
}, {
  allergenId: 7,
  name: {
    de: "(G) Milch von Säugetieren und Milcherzeugnisse (inklusive Laktose)",
    en: "(G) Milk and products thereof (including lactose)"
  }
}, {
  allergenId: 8,
  name: {
    de: "(H) Schalenfrüchte und daraus gewonnene Erzeugnisse",
    en: "(H) Nuts: namely almond, hazelnut, walnut, cashew, pecan nut, Brazil nut, pistachio nut and Macadamia nut (Queensland nut) and products thereof"
  }
}, {
  allergenId: 9,
  name: {
    de: "(L) Sellerie und daraus gewonnene Erzeugnisse",
    en: "(L) Celery and products thereof"
  }
}, {
  allergenId: 10,
  name: {
    de: "(M) Senf und daraus gewonnene Erzeugnisse",
    en: "(M) Mustard and products thereof"
  }
}, {
  allergenId: 11,
  name: {
    de: "(N) Sesamsamen und daraus gewonnene Erzeugnisse",
    en: "(N) Sesame seeds and products thereof"
  }
}, {
  allergenId: 12,
  name: {
    de: "(O) Schwefeldioxid und Sulfite",
    en: "(O) Sulphur dioxide and sulphites"
  }
}, {
  allergenId: 13,
  name: {
    de: "(P) Lupinen und daraus gewonnene Erzeugnisse",
    en: "(P) Lupin and products thereof"
  }
}, {
  allergenId: 14,
  name: {
    de: "(R) Weichtiere wie Schnecken, Muscheln, Tintenfische und daraus gewonnene Erzeugnisse",
    en: "(R) Molluscs and products thereof (for example clams, oysters, scallops, snails and squid)"
  }
}];

/***/ }),
/* 85 */
/***/ (function(module, exports) {

module.exports = {
  createCompany: '创建公司',
  createCatalog: '创建目录',
  edit: '编辑',
  activate: '启用',
  deactivate: '关闭',
  cancel: '取消',
  create: '创建',
  update: '更新',
  submit: '提交'
};

/***/ }),
/* 86 */
/***/ (function(module, exports) {

module.exports = {
  missingRequired: 'You must enter a value for required feilds!',
  missingUsername: 'Please enter your username.',
  missingPassword: 'Please enter your password.',
  'Web:User Login userName cannot be null or empty': 'Username cannot be null or empty',
  'Web:User Login password cannot be null or empty': 'Password cannot be null or empty',
  'Error in fields': 'Error in fields',
  'Access Denied': 'Access Denied',
  'Company:Create Duplicate oosId.': 'Duplicate oosId.',
  'Company:Create OosId cannot be null.': 'OosId cannot be null.',
  'Company:Create Duplicate name.': 'Duplicate name.',
  'Company:Create Invalid currency code.': 'Invalid currency code.',
  'Company:Create Test cannot be null.': 'Test cannot be null.',
  'Company:Create Address Line1 cannot be null or empty.': 'Address Line1 cannot be null or empty.',
  'Company:Create Address Town City cannot be null or empty.': 'Address Town City cannot be null or empty.',
  'Company:Create Address Country cannot be null or empty.': 'Address Country cannot be null or empty.',
  'Company:Create Address PostalCode cannot be null or empty.': 'Address PostalCode cannot be null or empty.',
  'Company:Create Name cannot be null or empty.': 'Name cannot be null or empty.',
  'Company:Create Currency cannot be null or empty.': 'Currency cannot be null or empty.',
  'Company:Create Invalid Email.': 'Invalid Email.',
  'Company:Update Duplicate oosId': 'Duplicate oosId',
  'Company:Update OosId cannot be null.': 'OosId cannot be null.',
  'Company:Update Duplicate name.': 'Duplicate name.',
  'Company:Update Invalid currency code.': 'Invalid currency code.',
  'Company:Update Test cannot be null.': 'Test cannot be null.',
  'Company:Update Failed to update company details.': 'Failed to update company details.',
  'Company:Update Name cannot be null or empty.': 'Name cannot be null or empty.',
  'Company:Update Currency cannot be null or empty.': 'Currency cannot be null or empty.',
  'Company:Update Invalid Email.': 'Invalid Email.',
  'Company:Get Company not found.': 'Company not found.',
  'Company:Activate Failed to update company status. Invalid company id': 'Failed to update company status. Invalid company id',
  'Request method \'POST\' not supported': 'Request method \'POST\' not supported',
  'Company:Deactivate Failed to update company status. Invalid company id': 'Failed to update company status. Invalid company id'
};

/***/ }),
/* 87 */
/***/ (function(module, exports) {

module.exports = {
  projectName: 'Application name',
  eng: 'English',
  de: 'German',
  error404: 'The page you are looking for does not exist!'
};

/***/ }),
/* 88 */
/***/ (function(module, exports) {

module.exports = {
  companies: '公司',
  catalogs: '目录',
  accounts: '账户',
  printers: '打印机',
  login: '登录',
  logout: '登出'
};

/***/ }),
/* 89 */
/***/ (function(module, exports) {

module.exports = {
  username: 'Username',
  password: 'Password',
  name: 'Name',
  currency: 'Currency',
  status: 'Status',
  modified: 'Modified on',
  created: 'Created on',
  actions: 'Actions',
  filter: 'Filter for company',
  catalogFilter: 'Filter for catalogs',
  active: 'Active',
  inactive: 'Inactive',
  phone: 'Phone',
  email: 'Email',
  externalID: 'External ID',
  testMode: 'Test mode',
  addressLine: 'Address line',
  locality: 'Locality',
  townCity: 'Town/City',
  country: 'Country',
  postalcode: 'Postalcode',
  createCompany: 'Create company',
  editCompany: 'Edit company'
};

/***/ }),
/* 90 */
/***/ (function(module, exports) {

module.exports = {
  createCompany: 'Create New Company',
  createCatalog: 'Neuen Katalog erstellen',
  createDomain: 'Create New Domain',
  createWebSpace: 'Create New Webspace',
  createTable: 'Create New Table',
  createLicense: 'Create New License',
  createPrinter: 'Create New Printer',
  createPrintServer: 'Neuen Druckserver erstellen',
  createAccount: 'Create New Account',
  createCallerId: 'Create New CallerID Server',
  createAppRes: 'Create New App Resource',
  createCorporation: 'Create New Corporation',
  createPrintTemplate: 'Create New Print Template',
  createLangMapp: 'Create New Printer Category Language Mapping',
  selectCompany: 'Select Company',
  selectCompanies: 'Select Companies',
  selectDomain: 'Select Domain',
  selectDomainType: 'Select Domain Type',
  selectPrinters: 'Select Printers',
  selectPrinterCategories: 'Wähle Drucker Kategorien',
  selectPrinterCategory: 'Wähle Drucker Kategorie',
  selectTemplateType: 'Select Template Type',
  selectTemplate: 'Select Template',
  selectTemplateImport: 'Select template to import pre- and postfix',
  selectPrintTemplateType: 'Select Print Template Type',
  selectLanguage: 'Select Language',
  selectCategory: 'Select Table Category',
  selectDefaultPrinter: 'Select Default Printer',
  selectRoles: 'Select Roles',
  selectMonth: 'Select Month',
  selectYear: 'Select Year',
  showLogs: 'Show Logs',
  showDetails: 'Show Details',
  showUpdates: 'Show Updates',
  addProperty: 'Add Property',
  selectPropType: 'Select Property Type',
  addTableName: 'Add Table Name',
  prefixLines: 'Add Prefix Lines',
  postfixLines: 'Add Postfix Lines',
  preview: 'Vorschau',
  edit: 'Edit',
  delete: 'Delete',
  activate: 'Activate',
  deactivate: 'Deactivate',
  cancel: 'Cancel',
  close: 'Close',
  view: 'View',
  reset: 'Reset',
  create: 'Create',
  update: 'Update',
  submit: 'Submit',
  save: 'Save',
  generateJson: 'Generate JSON',
  ok: 'Ok',
  selectPlanet: 'Select WebShop Planet',
  selectPayment: 'Select Payment Type',
  selectOrderType: 'Select Order Type',
  selectCatalogVersion: 'Select Catalog Version',
  selectSubscription: 'Select Subscription',
  selectCatalogView: 'Select Catalog View',
  openingHours: 'Add Opening Hours',
  addVat: 'Add Vat Percentage',
  viewMiniLicense: 'View Mini License',
  copyKey: 'Copy Key',
  addLangMapp: 'Add Language Mapping',
  clone: 'Clone',
  showReports: 'Show Reports',
  createCopy: 'Create a Copy',
  generateMonthly: 'Generate Aggregated Monthly',
  generate: 'Generate',
  chargebyMiles: 'Add Charge by Miles',
  chargebyAmount: 'Add Charge by Invoice Amount',
  showAudit: 'Show Audit Logs',
  startDate: 'Select Start Date',
  endDate: 'Select End Date',
  serviceType: 'Selecte Service Type',
  pushConfUpdate: 'Push Config Update',
  selectUrl: 'Select URL',
  createDiscount: 'Create New Discount',
  selectDays: 'Select Days',
  selectOrderTypes: 'Select Order Types',
  selectPaymentMethods: 'Select Payment Methods',
  selectRules: 'Select Dicount Rules',
  resetPassword: 'Reset Password',
  checkValidation: 'Check Validation',
  populate: 'Populate',
  copy: 'kopieren',
  homePage: 'Return to Home Page',
  backup: 'Backup',
  backupConfirm: 'Are you sure you want to restore from this file?',
  no: 'No',
  yes: 'Yes',
  selectAppResType: 'Select Type',
  selectAppResSubModel: 'Select Subscription',
  selectResTrackingTypes: 'Select Resource Tracking Types',
  pushToCorp: 'Push to Corporation',
  createCashRegister: 'Create new register',
  registerReciept: 'Register',
  startReciept: 'Start',
  endReciept: 'End',
  nullReciept: 'Null',
  deleteHtmlHint: 'Delete selected Html Hint?',
  addImage: 'Add new image',
  selectLabel: 'Select Label',
  deleteProperty: 'Delete selected Property?',
  showPaymentOverview: 'Show Payment Overview',
  hidePaymentOverview: 'Hide Payment Overview',
  paymentTerminalCreate: 'Create Payment Terminal',
  paymentServerCreate: 'Zahlungsserver erstellen',
  selectTerminals: 'Terminal auswählen',
  chargebyMeters: 'Add Charge by Meters',
  next: 'Next',
  back: 'Back',
  importCompany: 'Import from other company',
  changeCompany: 'Change company',
  addViews: 'Click to add views',
  addViews1: 'Sicht hinzufügen',
  addAllergens: 'Allergen hinzufügen',
  addPrinters: 'Drucker hinzufügen',
  removePrinters: 'Drucker entfernen',
  addVAT: 'Mehrwertsteuer hinzufügen',
  translate: 'Übersetzen',
  exportCSV: 'Export CSV',
  showAllChildren: 'Zeige alle Kinder',
  hideAllChildren: 'Verstecke alle Kinder',
  copyItem: 'Artikel kopieren',
  massAdd: 'Maßenänderung hinzufügen',
  massRemove: 'Maßenänderung entfernen',
  paste: 'Einfügen',
  importFromParent: 'Von Eltern importieren',
  addlanguage: 'Sprache hinzufügen',
  deleteitem: 'Eintrag löschen',
  editViews: 'Sichten bearbeiten',
  editAllergens: 'Allergene bearbeiten',
  editPrinterCategories: 'Druckkategorien bearbeiten',
  addImage1: 'Bild hinzufügen',
  overwrite: 'überschreiben',
  copyEdit: 'Copy & edit',
  copyCatalog: 'Copy catalog',
  pasteCatalog: 'Paste catalog',
  pasteCatalogTurnOn: 'Turn On Paste Listener',
  pasteCatalogTurnOff: 'Turn Off Paste Listener'
};

/***/ }),
/* 91 */
/***/ (function(module, exports) {

module.exports = {
  missingCompany: 'Company is required',
  missingCompanyName: 'Company Name is required',
  missingAppResName: 'App Resource Name is required',
  errorsAppResType: 'App Resource Type is required',
  missingAppResSubModel: 'App Resource Subscription Model is required',
  missingCompanyPhone: 'Company Phone is required',
  missingCompanyCountry: 'Country is required',
  missingCompanyTown: 'Town/City is required',
  missingCompanyPostal: 'Postal Code is required',
  missingCompanyAddress: 'Address Line 1 is required',
  missingFetchConf: 'Fetch Configuration Frequency (In Min.)',
  missingLang: 'Default Language is requierd',
  missingChargeType: 'Delivery Charge Type is requierd',
  missingChargePerMile: 'Delivery Charge Per Mile is requierd',
  missingDomain: 'Domain is required',
  missingMinPersons: 'Min # of Persons is required',
  missingMaxPersons: 'Max # of Persons is required',
  missingCategory: 'Table Category is required',
  missingCurrency: 'Currency is required',
  missingCuisines: 'Cuisines are required',
  missingMaxDist: 'Max Delivery Distance is required',
  missingDomainType: 'Domain Type is required',
  missingRegisteredOn: 'Registration Date is required',
  missingTemplateType: 'Template Type is required',
  missingTemplate: 'Template is required',
  missingRequired: 'You must enter a value for required feilds!',
  missingUsername: 'Please enter your username.',
  missingPassword: 'Please enter your password.',
  missingPlanet: 'WebShop Planet is required',
  missingPayment: 'Payment Type is required',
  missingPayments: 'Payment Types are required',
  missingOrder: 'Order Type is required',
  missingCatalogVersion: 'Catalog Version is required',
  missingSubscription: 'Subscription is required',
  missingCatalogView: 'Catalog View is required',
  missingName: 'WebShop Name is required',
  missingDeliery: 'Minimum Delivery Amount is required',
  missingEmailID: 'Email ID is required',
  missingMerchantId: 'Merchant ID is required',
  missingStoreId: 'Store ID is required',
  missingPass: 'Password is required',
  missingPreSharedKey: 'Pre Shared Key is required',
  missingLicenseType: 'License Type is required',
  missingSunLicense: 'Sun License System Version is required',
  missingConcurrent: 'Number of Concurrent Users is required',
  missingActivationDate: 'Activation Date is required',
  missingExpiryDate: 'Expiry Date is required',
  missingPrinterName: 'Printer Name is required',
  missingManufacturer: 'Manufacturer is required',
  missingModel: 'Model is required',
  missingPrintServerName: 'Druckservername ist erforderlich',
  missingPrinters: 'Printers are required',
  missingHolder: 'Account Holder Name is required',
  missingDicount: 'Max Discount Percentage is required',
  missingUserName: 'Username is required',
  missingDefaultPrinter: 'Default Printer is required',
  missingCallerIdName: 'CallerID Server Name is required',
  missingCorporationName: 'Corporation Name is required',
  missingCompanies: 'Companies are required',
  missingTemplateName: 'Template Name is required',
  missingPrintTemplateType: 'Print Template Type is required',
  missingNoPrints: 'Number of Prints is required',
  missingMonth: 'Month is required',
  missingYear: 'Year is required',
  missingMainaway: 'Mainaway Template is required',
  missingUnpaidBill: 'Unpaid Bill Template is required',
  missingItemTemplate: 'Item Template is required',
  missingTaxTemplate: 'Tax Template is required',
  missingLabelTemplate: 'Label Template is required',
  missingKitchenTemplate: 'Kitchen Template is required',
  missingDriverTemplate: 'Driver Template is required',
  missingFromDate: 'From Date is required',
  missingToDate: 'To Date is required',
  missingStartDate: 'Start Date is required',
  missingEndDate: 'End Date is required',
  missingCfgUpdate: 'Configuration Update Type is required',
  missingTableMin: 'Table Idle Time In Minutes is required',
  missingOrderSubmission: 'Order Submission Allowed From is required',
  missingPricingGroups: 'Pricing Groups are required',
  wrongInterval: 'Backup Interval has wrong value',
  validTime: 'Time is not in valid format',
  validEmail: 'E-mail must be valid',
  noData: 'No data available',
  missingRuleName: 'Rule Name is required',
  serverUrl: 'Server URL is required',
  primaryCompany: 'Primary Company is required',
  timeError: 'Time value is not valid',
  required: 'Field is required',
  notValid: 'Value is not valid',
  'Web:User Login userName cannot be null or empty': 'Username cannot be null or empty',
  'Web:User Login password cannot be null or empty': 'Password cannot be null or empty',
  'Error in fields': 'Error in fields',
  'Access Denied': 'Access Denied',
  'Company:Create Duplicate oosId.': 'Duplicate oosId.',
  'Company:Create OosId cannot be null.': 'OosId cannot be null.',
  'Company:Create Duplicate name.': 'Duplicate name.',
  'Company:Create Invalid currency code.': 'Invalid currency code.',
  'Company:Create Test cannot be null.': 'Test cannot be null.',
  'Company:Create Address Line1 cannot be null or empty.': 'Address Line1 cannot be null or empty.',
  'Company:Create Address Town City cannot be null or empty.': 'Address Town City cannot be null or empty.',
  'Company:Create Address Country cannot be null or empty.': 'Address Country cannot be null or empty.',
  'Company:Create Address PostalCode cannot be null or empty.': 'Address PostalCode cannot be null or empty.',
  'Company:Create Name cannot be null or empty.': 'Name cannot be null or empty.',
  'Company:Create Currency cannot be null or empty.': 'Currency cannot be null or empty.',
  'Company:Create Invalid Email.': 'Invalid Email.',
  'Company:Update Duplicate oosId': 'Duplicate oosId',
  'Company:Update OosId cannot be null.': 'OosId cannot be null.',
  'Company:Update Duplicate name.': 'Duplicate name.',
  'Company:Update Invalid currency code.': 'Invalid currency code.',
  'Company:Update Test cannot be null.': 'Test cannot be null.',
  'Company:Update Failed to update company details.': 'Failed to update company details.',
  'Company:Update Name cannot be null or empty.': 'Name cannot be null or empty.',
  'Company:Update Currency cannot be null or empty.': 'Currency cannot be null or empty.',
  'Company:Update Invalid Email.': 'Invalid Email.',
  'Company:Get Company not found.': 'Company not found.',
  'Company:Activate Failed to update company status. Invalid company id': 'Failed to update company status. Invalid company id',
  'Request method \'POST\' not supported': 'Request method \'POST\' not supported',
  'Company:Deactivate Failed to update company status. Invalid company id': 'Failed to update company status. Invalid company id',
  noVatRates: 'You must enter at least one VAT rate',
  wrongVAT: 'VAT rates must be at least one of the following',
  missingImageName: 'Image Name is required',
  missingImageLabel: 'Image Label is required',
  missingdistanceUnit: 'Distance Unit is required',
  wrongVatUK: 'VAT rates must be at least one of the following',
  missingHint: 'Missing mandatory HtmlHint',
  missingAllHint: 'Please add the mandatory fields needed for the T&C respective data protection pages',
  wrongEmail: 'Book keeper Email for is not in good format',
  emptyValue: 'cannot be empty',
  postal: 'postal code not found!',
  validPostalOrAddress: 'Postal code or address is not valid, please change',
  notValidUrl: 'Url format is not valid!',
  missingTimezone: 'Timezone is missing!',
  missingTerminals: 'At least one Terminal is required',
  missingApiKey: 'Api Key is required',
  missingUsernameP: 'Username is required',
  validConfirmEmail: 'E-mails are not the same',
  noAvailableTemplate: 'No available template for import',
  inputOutputLangs: 'You must select Input and Output languages!',
  inputOutputLangsSame: 'Input and Output languages cannot be the same!'
};

/***/ }),
/* 92 */
/***/ (function(module, exports) {

module.exports = {
  projectName: 'Sun',
  eng: 'Englisch',
  de: 'Deutsch',
  error404: 'The page you are looking for does not exist!'
};

/***/ }),
/* 93 */
/***/ (function(module, exports) {

module.exports = {
  apps: 'Apps',
  autoJobs: 'Auto Jobs',
  auditLog: 'Audit Log',
  companies: 'Firmen',
  configUpdates: 'Config Updates',
  catalogs: 'Kataloge',
  callerId: 'CallerID Servers',
  corporations: 'Corporations',
  domains: 'Domains',
  languageMappings: 'Language Mappings',
  licenses: 'Licenses',
  licenseReports: 'License Reports',
  webshopusageReports: 'Webshopusage Reports',
  model: 'Model',
  printTemplates: 'Print Templates',
  manufacturer: 'Manufacturer',
  discounts: 'Discounts',
  domain: 'Domain',
  moonBackup: 'Moon Backup',
  moonInstances: 'Moon Instances',
  systemlog: 'System Logs',
  system: 'System',
  tables: 'Tische',
  tableName: 'Tisch Name',
  tableCategory: 'Tisch Kategorie Name',
  tableCategories: 'Tisch Kategorie',
  webShops: 'Web Shops',
  webspace: 'Web Spaces',
  accounts: 'Benutzer',
  printers: 'Printers',
  printServers: 'Druck Servers',
  login: 'Login',
  logout: 'Logout',
  emailConf: 'Email Configuration Settings',
  pending: 'Pending Orders',
  lastPending: 'Last Pending Order',
  historyId: 'History ID',
  srNo: 'Sr No',
  orderIdSource: 'Order ID/Source',
  orderCode: 'Order Code',
  customerName: 'Customer Name',
  totalAmount: 'Total Amount',
  contactedOn: 'Last Contacted On',
  templateType: 'Template Type',
  templateName: 'Template Name',
  day: 'Day',
  start: 'Start',
  end: 'End',
  catalogVersion: 'Katalog Version',
  licenseType: 'License Type',
  licenseKey: 'License Key',
  moonInstName: 'Moon Instace Name',
  activationDate: 'Activation Date',
  expiryDate: 'Expiry Date',
  createdDate: 'Created Date',
  modifiedDate: 'Modified Date',
  limit: 'Limit',
  callerIdName: 'CallerID Server Name',
  webShopResourceId: 'Web Shop Resource ID',
  noOfOrders: 'No Of Orders',
  ordersSum: 'Orders Sum',
  prefixLines: 'Prefix Lines',
  postixLines: 'Postfix Lines',
  jobName: 'Job Name',
  jobDesc: 'Job Description',
  lastExec: 'Last Executed On',
  nextExec: 'Next Planned Execution On',
  fromMiles: 'From Miles',
  toMiles: 'To Miles',
  charges: 'Charges',
  defaultCharges: 'Default Charges',
  fromAmount: 'From Amount',
  toAmount: 'To Amount',
  action: 'Action',
  sourceVersion: 'Source/Version',
  createdBy: 'Created By',
  synched: 'Synched On',
  instanceName: 'Instance Name',
  conditions: 'Conditions',
  values: 'Values',
  callerIdServers: 'CallerID Servers',
  webShopResource: 'Web Shop Resources',
  catalogName: 'Katalog Name',
  emailPhone: 'Email/Phone',
  webshop: 'webshop',
  orderingApp: 'ordering app',
  pricingInvoices: 'Invoices',
  pricingGroupName: 'Pricing Group Name',
  resourceTracking: 'Resource Tracking',
  resourceType: 'Resource Type/ID',
  trackingAction: 'Tracking Action',
  closedReason: 'Closed/Reason For Closure',
  cashRegister: 'Cash Register',
  htmlHints: 'Html Hints',
  images: 'Bilder',
  label: 'Label',
  companyGeneralData: 'Company General Data',
  companySettings: 'Company Settings',
  companyAddress: 'Company Address',
  properties: 'Properties',
  paymentSummary: 'Payment Summary',
  paymentType: 'Payment Type',
  amount: 'Amount',
  paymentGatewaySettings: 'Payment Gateway Settings',
  paymentTerminals: 'Zahlungs Terminals',
  paymentServers: 'Zahlungsserver',
  delivery: 'Delivery',
  keys: 'Keys',
  automatedPrinting: 'Automated printing',
  fromMeters: 'From Meters',
  toMeters: 'To Meters',
  companyInfo: 'Company Info',
  account: 'Account',
  roleManagement: 'Role Management',
  originalVersion: 'Ursprüngliche Version',
  views: 'Sichten',
  allergens: 'Allergene',
  massAddRemove: 'Maßenänderung Hinzufügen/Entfernen',
  items: 'Artikel',
  edit: 'Edit',
  add: 'Add',
  item: 'Item',
  printerCategories: 'Druckkategorien',
  abbreviation: 'Abkürzung',
  name: 'Name',
  description: 'Beschreibung',
  sizes: 'Größen',
  variants: 'Varianten',
  options: 'Optionen',
  styles: 'Stil',
  settings: 'Einstellungen',
  color: 'Farben',
  language: 'Sprachen',
  default: 'Standard',
  actions: 'Aktionen',
  massTranslate: 'Maßen Übersetzung',
  overwriteOptions: 'Zu überschreiben',
  abbrevation: 'Abkürzung',
  taxCategory: 'Tax category',
  courseNo: 'Course No',
  vat: 'VAT'
};

/***/ }),
/* 94 */
/***/ (function(module, exports) {

module.exports = {
  username: 'Username',
  password: 'Password',
  name: 'Name (Not visible to customers)',
  search: 'Search',
  overview: 'Overview',
  generate: 'Generate',
  currency: 'Currency',
  status: 'Status',
  modified: 'Modified On',
  created: 'Erstellt am',
  actions: 'Aktionen',
  filter: 'Filter for company',
  catalogFilter: 'Filter for catalogs',
  active: 'Active',
  inactive: 'Inactive',
  phone: 'Phone',
  email: 'Email',
  externalID: 'External ID',
  externalIDres: 'External Resource ID',
  testMode: 'Enable Test Mode',
  addressLine: 'Address line',
  locality: 'Locality',
  townCity: 'Town/City',
  country: 'Country',
  postalcode: 'Postal Code',
  createCompany: 'Create company',
  editCompany: 'Edit company',
  companyDomain: 'Company Domain',
  type: 'Type',
  company: 'Company',
  companyName: 'Company Name',
  companyId: 'Company ID',
  propKey: 'Property Key',
  propValue: 'Property Value',
  fromDate: 'From Date',
  toDate: 'To Date',
  errorMessage: 'Error Message',
  language: 'Select Language',
  multipleTables: 'Do you want to create multiple tables?',
  sequenceNumber: 'Displace sequence',
  minDelivery: 'Min Delivery Amount',
  sendToMoon: 'Do you want to send web shop orders to Moon?',
  sendEmail: 'Sending Email Address',
  sendBCC: 'Order Recipients Email Addresses (separated by ,)',
  prefix: 'Prefix',
  postfix: 'Postfix',
  numberOfPrints: 'Number of Prints',
  numberOfTables: 'Number of Tables',
  payGateway: 'Payment Gateway',
  merchantId: 'Merchant ID',
  preSharedKey: 'Pre Shared Key',
  data: 'Data',
  url: 'URL',
  moonUrl: 'Moon URL',
  macAddress: 'Mac Addresses',
  queueUrl: 'Moon Queue URL',
  publicKeySun: 'Sun Public Key',
  privateKeySun: 'Sun Private Key',
  publicKeyMoon: 'Moon Public Key',
  instanceId: 'Instance ID',
  totalAmount: 'Total Amount',
  backup: 'Backup Interval (In Hours)',
  fetchConf: 'Fetch Configuration Frequency (In Min.)',
  paymentTypes: 'Payment Types',
  tipTax: 'Tip Tax Rate',
  left: 'Left',
  right: 'Right',
  defLang: 'Default Language',
  cuisines: 'Cuisines',
  maxDist: 'Max Delivery Distance',
  delPostal: 'Delivery Postal Codes (separated by ,)',
  updatePassword: 'Set/Update password',
  chargeTax: 'Delivery Charges Tax Rate',
  chargeType: 'Delivery Charge Type',
  delChargePerMile: 'Delivery Charge Per Mile',
  chargesPerMile: 'Charges Per Mile',
  noCharge: 'No Delivery Charge',
  chargeByMile: 'Charge By Miles',
  chargeByInvoice: 'Charge By Invoice Amount',
  payIntegModule: 'Activate Moon payment integration',
  orderPrint: 'Enable complete order print?',
  enquiryContact: 'Enable contact form on webpage',
  enquiryReser: 'Enable reservation form on webpage?',
  minPersons: 'Min # of Persons',
  maxPersons: 'Max # of Persons',
  sunday: 'SUNDAY',
  monday: 'MONDAY',
  tuesday: 'TUESDAY',
  wednesday: 'WEDNESDAY',
  thursday: 'THURSDAY',
  friday: 'FRIDAY',
  saturday: 'SATURDAY',
  concurrent: 'Concurrent Users',
  sunLicense: 'Sun License System Version',
  moonInstID: 'Moon Instance ID',
  printerName: 'Printer Name',
  ipAddress: 'IP Address',
  portNumber: 'Port Number',
  maxRetriesOnErrors: 'Max Retries On Errors',
  maxTransactionDuration: 'Max Transaction Duration (in sec)',
  notes: 'Notes',
  controlledByMoon: 'Do you want to assign this printer to Moon?',
  pdfPrinter: 'PDF Printer',
  printServerName: 'Druckserver Name',
  key: 'Key',
  records: '# Records For Printing',
  holder: 'Account Holder Name',
  maxDiscount: 'Max Discount Percentage',
  lowerCase: 'Username should be lowercase',
  corporationName: 'Corporation Name',
  templateName: 'Template Name',
  fontHeight: 'Font Height',
  fontStyle: 'Font Style',
  mainawayTemplate: 'Mainaway Template',
  content: 'Content',
  month: 'Month',
  year: 'Year',
  january: 'January',
  february: 'February',
  march: 'March',
  april: 'April',
  may: 'May',
  june: 'June',
  july: 'July',
  august: 'August',
  september: 'September',
  october: 'October',
  november: 'November',
  december: 'December',
  unpaidBillTemplate: 'Unpaid Bill Template',
  taxTemplate: 'Tax Template',
  itemTemplate: 'Item Template',
  labelTemplate: 'Label Template',
  kitchenTemplate: 'Kitchen Template',
  driverTemplate: 'Driver Template',
  licenseSyncStatus: 'License Sync Status',
  daily: 'Daily',
  monthly: 'Monthly',
  monthlyAgg: 'Monthly Aggregate',
  noService: 'No Service Charge',
  percOfTotal: 'Charge by Percentage of Total',
  serviceTaxRate: 'Service Charge Tax Rate',
  percentage: 'Percentage',
  configUpdates: 'Config Updates',
  planetType: 'Planet Type',
  planetInstName: 'Planet Instance Name',
  companyDataUpdated: 'Company Data Updated',
  langMapforPrintCat: 'Languages Mapped For Printer Categories',
  ruleName: 'Rule Name',
  amountOfPersons: 'Amount of Persons',
  minAmount: 'Minimum Amount of',
  voucherCode: 'Voucher Code',
  startTime: 'Start Time',
  endTime: 'End Time',
  discountAmount: 'Discount Amount',
  discountPercent: 'Discount Percent',
  discountRules: 'Discount Rules',
  discountRuleNames: 'Discount Rule Names',
  refreshCatalog: 'Refresh Catalog',
  yourPassword: 'Your password is: ',
  description: 'Beschreibung',
  showActive: 'Show Active Only',
  swithcCode: 'Table Switch Code',
  swithcCodeHint: 'Table Switch Code must be 4 digits',
  auditDirection: 'Audit Direction',
  domainType: 'Domain Type',
  tableIdleTimeInMinutes: 'Table Idle Time (In Min)',
  align: 'Align',
  idForS3: 'ID for S3 Server',
  all: 'All',
  incoming: 'Incoming',
  outgoing: 'Outgoing',
  currentVersion: 'Current Version',
  previousVersion: 'Previous Version',
  printerID: 'Printer ID',
  lastLoggedinOn: 'Last Logged in on',
  orderSubmission: 'Order Submission Allowed From',
  externalId: 'External ID',
  licenseID: 'License ID',
  confirmationText: 'Do you want to deactive?',
  activationText: 'Would you like to activate this webshop?',
  catalogActivationText: 'Would you like to activate this catalog?',
  licenseActivationText: 'Would you like to activate this license?',
  default: 'Default',
  rgu: 'RGU',
  sourceSystem: 'Source System',
  orderType: 'Order Type',
  printType: 'Print Type',
  autoPrinting: 'Auto Printing',
  pricingGroups: 'Pricing Groups',
  moon: 'moon',
  webshop: 'webshop',
  buildOverview: 'Build overview',
  generateInvoice: 'Generate invoice',
  massRemoveViews: 'Are you sure you want to remove this View? Deleting it will remove it from all existing items.',
  maxDeliveryDisWarning: 'Attention: please take into account that setting max delivery distance to 0 turns on delivery without any (!) limitations.',
  accountImpactWarning: 'Attention: the local admin rights shall be carefully assigned and only to customer accounts as it will impact Sun Front-End behavior.',
  sendToMoonWarning: 'Please make sure to set up a Moon instance with an active license as otherwise orders can not be processed.',
  detailed: 'Detailed',
  noVATtax: 'no VAT tax',
  noTipTax: 'No tip tax',
  noDeliveryTax: 'No delivery tax',
  noServiceTax: 'No service tax',
  deliveryDurationFrom: 'Delivery duration from (in min)',
  deliveryDurationTo: 'Delivery duration to (in min)',
  statusCode: 'Status Code',
  activateAfterCopy: 'Activate Catalog After Copy',
  primaryCompany: 'Primary Company',
  contactServerSettings: 'Contact server',
  addressServerSettings: 'Address server',
  walletServerSettings: 'Wallet server',
  depServerSettings: 'DEP Server',
  inventoryServerSettings: 'Inventory server',
  contactServerKey: 'Contact server key',
  addressServerKey: 'Address server key',
  walletServerKey: 'Wallet server key',
  depServerKey: 'DEP Server key',
  inventoryServerKey: 'Inventory server key',
  enableDEP: 'DEP enable',
  latitude: 'Latitude',
  longitude: 'Longitude',
  dailyOrdersCounterEnabled: 'Enable daily orders counter',
  cashRegisterName: 'Cash Register Name',
  cashRegisterId: 'Cash Register ID',
  depAccessKey: 'DEP access key',
  corporation: 'Corporation',
  aesKey: 'AES key',
  aesKeyCheckSum: 'AES key checksum',
  inUseFrom: 'In use from',
  storeId: 'Store ID',
  addHtml: 'Add new Html Hint',
  imageName: 'Image Name',
  imageId: 'Image ID',
  distanceUnit: 'Distance Unit',
  en: 'Englisch',
  de: 'Deutsch',
  zh: 'Chinesisch',
  registrationNumber: 'Registration number',
  registrationLocation: 'Registration location',
  bookKeeperEmails: 'Book keeper Recipients Email (separated by ,)',
  visibleToCustomer: 'Visible to customer',
  massRemoveAllergens: 'Are you sure you want to remove this Allergen? Deleting it will remove it from all existing items.',
  importHtml: 'Import Html Hints',
  enableKitchenPrintPersistence: 'Enable kitchen print persistence',
  numberOfSeats: 'Number of Seats',
  addProperty: 'Add new Property',
  importProperty: 'Import Properties',
  foreignId: 'Foreign ID',
  dailyOrderCounterPrefixes: 'Daily Order Counter Prefixes',
  delivery: "Delivery",
  collection: "Collection",
  takeaway: "Takeaway",
  card: 'Card',
  cash: 'Cash',
  amazon: 'Amazon',
  cardmanual: 'Card Manual',
  deliveroo: 'Deliveroo',
  hungryhouse: 'Hungry House',
  invoice: 'Invoice',
  justeat: 'Justeat',
  ubereats: 'Ubereats',
  voucher: 'Voucher',
  galaxycard: 'Galaxy Card',
  webshopOrderNo: 'Webshop Order #',
  appOrderNo: 'OrderApp Order #',
  webshopTotal: 'Webshop Total Amount',
  appTotal: 'OrderApp Total Amount',
  authServerSettings: 'Auth Server',
  publiclyAvailable: 'Publicly Available',
  reservationServerSettings: 'Reservation Server',
  addressLookup: 'Address Lookup',
  postalCode: 'Postal code',
  line1: 'Line 1',
  line2: 'Line 2',
  line3: 'Line 3',
  line4: 'Line 4',
  line3AT: 'Staircase/apartment/Address details',
  line2AT: 'House number',
  line1AT: 'Street',
  acceptingOrders: 'Accept orders (disable to temporary stopping accepting orders)',
  labelPrint: 'Sticker Druck',
  askDetails: 'Details erfragen',
  vatPrint: 'MwSt Druck',
  noDiscount: 'Kein Rabatt anwendbar',
  addsGalaxyCardBalance: 'Fügt Galaxy Card Guthaben hinzu',
  quantityOfIncludedOptions: 'Anzahl an inkludierten Optionen',
  restaurant: "Restaurant",
  defaultPaymentType: 'Standard Zahlungsmethode',
  notifyOwnerOnPaymentFailure: 'Notify Owner On Payment Failure',
  webshopUrl: 'Webshop Url',
  copy: 'Kopieren',
  apiKey: 'API Key',
  nfcToken: 'NFC Token',
  passwordResetPrefixText: 'Please select a payment gateway provider, enter the basic data and save the record to trigger the key generation. Please wait and refresh the screen in order to enable password entry.',
  printTemplateActivationText: 'Would you like to activate this print template?',
  activateShopFirst: 'Please activate the webshop first. Then you will be able to set up a payment gateway.',
  timezone: 'Timezone',
  upload: 'Chose file',
  predefinedViews: 'Vordefinierte Sicht hinzufügen',
  showEmail: 'Show email',
  showPhoneNumber: 'Show phone number',
  smsConfirmationFirstOrder: 'SMS confirmation first order',
  smsUsername: 'SMS username',
  smsSettings: 'Sms Settings',
  discountSettings: 'Discount Settings',
  updateSmsPassword: 'Set/Update Sms Password',
  passwordSmaResetPrefixText: 'Please enable Sms confirmation first order, add username and save the record to enable password set. Please wait and refresh the screen in order to enable password entry.',
  generalSettings: 'General Settings',
  terminalName: 'Terminal Name',
  terminalId: 'Terminal ID',
  terminalIdentifier: 'Terminal Identifier',
  paymentServerName: 'Zahlungsserver Name',
  depReceipts: 'Dep Receipts',
  delChargePerMeter: 'Delivery Charge Per Meter',
  publicHoliday: 'PUBLIC HOLIDAY',
  allChildren: 'All children',
  paymentTerminals: 'Payment Terminals',
  paymentServers: 'Zahlungsserver',
  frontEndVersion: 'Frontend',
  backendversion: 'Backend',
  webshopQr: 'Webshop QR',
  contactTrackingQr: 'Contact tracking QR',
  menuQr: 'Menu QR',
  connectEApiKey: 'Api Key',
  connectEUsername: 'Username',
  signUp: 'Sign-up',
  confirmEmail: 'Confirm Email',
  account: 'Account',
  selectedAddress: 'Selected Address',
  none: 'None',
  atUser: 'AT User',
  atLocalAdmin: 'AT Local Admin',
  merchantPrint: 'Merchant print',
  customerPrint: 'Customer print',
  automaticPrint: 'Automatic Printing',
  maxDiscountPercentage: 'Max Discount Percentage',
  merchant: 'Merchant',
  customer: 'Customer',
  switchReceiptType: 'First Receipt Type',
  selectCompany: 'Select company',
  filterCategories: 'Filter categories',
  name1: 'Name',
  printerCategories: 'Druckkategorien',
  settings: 'Einstellungen',
  VAT: 'Mehrwertsteuer',
  taxCategory: 'Steuer Kategorie',
  defPrice: 'Standardpreis',
  choseLabelToAddImage: 'Chose label to add image',
  selectLabelFirst: 'Select label first',
  selectImage: 'Select Image',
  inputLanguage: 'Input language',
  outputLanguage: 'Output language',
  parentCopy: 'Copy all children from selected source',
  views: 'Sichten',
  size: 'Größen',
  variant: 'Varianten',
  option: 'Optionen',
  style: 'Stil',
  parentCopyFrom: 'Elternelement von dem die Kinder kopiert werden sollen',
  includedQuantity: 'Included Quantity'
};

/***/ }),
/* 95 */
/***/ (function(module, exports) {

module.exports = {
  productionLicenses: 'Production Licenses',
  testLicense: 'Test License',
  totalActive: 'Total number of Active Licenses',
  totalConcurrent: 'Total number of Concurrent Users',
  registeredUsers: 'Registered Users',
  active: 'Active',
  inactive: 'Inactive',
  domains: 'Domains',
  webSpaceTypes: 'Web space types',
  premium: 'Premium',
  basic: 'Basic',
  link: 'Link',
  custom: 'Custom',
  orders: '# orders',
  totalAmount: 'Total Amount',
  webShopRes: 'WebShop Resources',
  category: 'Category',
  module: 'Module',
  users: '# of users',
  moon: 'Moon',
  paymentM: 'Payment Management',
  contactM: 'Contact Management',
  reportsM: 'Reports Management',
  ordertM: 'Order Management',
  invoiceM: 'Invoice Management',
  inventoryM: 'Inventory Management',
  drawerHandlerM: 'Drawer Handler Management',
  DBOptM: 'DB Optimization Management',
  moonBackupM: 'Moon Backup Management',
  sun: 'Sun',
  autoJobM: 'Auto Job Management',
  catalogM: 'Catalog Management',
  printerM: 'Printer Management',
  printServerM: 'Druckserver Verwaltung',
  licenseM: 'License Management',
  tableM: 'Table Management',
  accountM: 'Account Management',
  companyM: 'Company Management',
  sunBackupM: 'Sun Backup Management',
  userCounts: 'User Counts By License Type',
  type: 'Type',
  companyName: 'Company Name',
  concUsers: '# of concurrent users',
  activeUsers: '# of active users',
  domainsByWSType: 'Domains By Web Space Type',
  domainNames: 'Domain Names',
  webShopResourceByType: 'Webshop Resources By Type',
  ActiveWebShopResources: 'Active Web Shop Resources',
  InactiveWebShopResources: 'Inactive Web Shop Resources',
  webShopResourceId: 'Webshop Resource ID',
  webShopResourceName: 'Webshop Resource Name'
};

/***/ }),
/* 96 */
/***/ (function(module, exports) {

module.exports = {
  emailId: 'Please ensure to use a preconfigured one',
  emailBCC: 'Email addresses that receive orders',
  companyName: 'Company Name Goes Here',
  companyEmail: 'Email contact for the compmany',
  phone: 'Phone number including country code',
  companyCountry: 'Country for the company',
  companyTown: 'Town/City for the company',
  companyLocality: 'Locality for the company',
  companyPostal: 'Postal Code for the company',
  paymentTypes: 'Select Payment Types',
  pricingGroups: 'Select Pricing Groups',
  backupInterval: 'Backup Interval should be between 3 and 168 hours'
};

/***/ }),
/* 97 */
/***/ (function(module, exports) {

module.exports = {
  createCompany: '创建公司',
  createCatalog: '创建目录',
  edit: '编辑',
  activate: '启用',
  deactivate: '关闭',
  cancel: '取消',
  create: '创建',
  update: '更新',
  submit: '提交'
};

/***/ }),
/* 98 */
/***/ (function(module, exports) {

module.exports = {
  missingRequired: 'You must enter a value for required feilds!',
  missingUsername: 'Please enter your username.',
  missingPassword: 'Please enter your password.',
  'Web:User Login userName cannot be null or empty': 'Username cannot be null or empty',
  'Web:User Login password cannot be null or empty': 'Password cannot be null or empty',
  'Error in fields': 'Error in fields',
  'Access Denied': 'Access Denied',
  'Company:Create Duplicate oosId.': 'Duplicate oosId.',
  'Company:Create OosId cannot be null.': 'OosId cannot be null.',
  'Company:Create Duplicate name.': 'Duplicate name.',
  'Company:Create Invalid currency code.': 'Invalid currency code.',
  'Company:Create Test cannot be null.': 'Test cannot be null.',
  'Company:Create Address Line1 cannot be null or empty.': 'Address Line1 cannot be null or empty.',
  'Company:Create Address Town City cannot be null or empty.': 'Address Town City cannot be null or empty.',
  'Company:Create Address Country cannot be null or empty.': 'Address Country cannot be null or empty.',
  'Company:Create Address PostalCode cannot be null or empty.': 'Address PostalCode cannot be null or empty.',
  'Company:Create Name cannot be null or empty.': 'Name cannot be null or empty.',
  'Company:Create Currency cannot be null or empty.': 'Currency cannot be null or empty.',
  'Company:Create Invalid Email.': 'Invalid Email.',
  'Company:Update Duplicate oosId': 'Duplicate oosId',
  'Company:Update OosId cannot be null.': 'OosId cannot be null.',
  'Company:Update Duplicate name.': 'Duplicate name.',
  'Company:Update Invalid currency code.': 'Invalid currency code.',
  'Company:Update Test cannot be null.': 'Test cannot be null.',
  'Company:Update Failed to update company details.': 'Failed to update company details.',
  'Company:Update Name cannot be null or empty.': 'Name cannot be null or empty.',
  'Company:Update Currency cannot be null or empty.': 'Currency cannot be null or empty.',
  'Company:Update Invalid Email.': 'Invalid Email.',
  'Company:Get Company not found.': 'Company not found.',
  'Company:Activate Failed to update company status. Invalid company id': 'Failed to update company status. Invalid company id',
  'Request method \'POST\' not supported': 'Request method \'POST\' not supported',
  'Company:Deactivate Failed to update company status. Invalid company id': 'Failed to update company status. Invalid company id'
};

/***/ }),
/* 99 */
/***/ (function(module, exports) {

module.exports = {
  projectName: 'Application name',
  eng: 'English',
  de: 'German',
  error404: 'The page you are looking for does not exist!'
};

/***/ }),
/* 100 */
/***/ (function(module, exports) {

module.exports = {
  companies: '公司',
  catalogs: '目录',
  accounts: '账户',
  printers: '打印机',
  login: '登录',
  logout: '登出'
};

/***/ }),
/* 101 */
/***/ (function(module, exports) {

module.exports = {
  username: 'Username',
  password: 'Password',
  name: 'Name',
  currency: 'Currency',
  status: 'Status',
  modified: 'Modified on',
  created: 'Created on',
  actions: 'Actions',
  filter: 'Filter for company',
  catalogFilter: 'Filter for catalogs',
  active: 'Active',
  inactive: 'Inactive',
  phone: 'Phone',
  email: 'Email',
  externalID: 'External ID',
  testMode: 'Test mode',
  addressLine: 'Address line',
  locality: 'Locality',
  townCity: 'Town/City',
  country: 'Country',
  postalcode: 'Postalcode',
  createCompany: 'Create company',
  editCompany: 'Edit company'
};

/***/ }),
/* 102 */
/***/ (function(module, exports) {

module.exports = {
  createCompany: 'Create New Company',
  createCatalog: 'Create New Catalog',
  createDomain: 'Create New Domain',
  createWebSpace: 'Create New Webspace',
  createTable: 'Create New Table',
  createLicense: 'Create New License',
  createPrinter: 'Create New Printer',
  createPrintServer: 'Create New Print Server',
  createAccount: 'Create New Account',
  createCallerId: 'Create New CallerID Server',
  createAppRes: 'Create New App Resource',
  createCorporation: 'Create New Corporation',
  createPrintTemplate: 'Create New Print Template',
  createLangMapp: 'Create New Printer Category Language Mapping',
  selectCompany: 'Select Company',
  selectCompanies: 'Select Companies',
  selectDomain: 'Select Domain',
  selectDomainType: 'Select Domain Type',
  selectPrinters: 'Select Printers',
  selectPrinterCategories: 'Select Printer Categories',
  selectPrinterCategory: 'Select Printer Category',
  selectTemplateType: 'Select Template Type',
  selectTemplate: 'Select Template',
  selectTemplateImport: 'Select template to import pre- and postfix',
  selectPrintTemplateType: 'Select Print Template Type',
  selectLanguage: 'Select Language',
  selectCategory: 'Select Table Category',
  selectDefaultPrinter: 'Select Default Printer',
  selectRoles: 'Select Roles',
  selectMonth: 'Select Month',
  selectYear: 'Select Year',
  showLogs: 'Show Logs',
  showDetails: 'Show Details',
  showUpdates: 'Show Updates',
  addProperty: 'Add Property',
  selectPropType: 'Select Property Type',
  addTableName: 'Add Table Name',
  prefixLines: 'Add Prefix Lines',
  postfixLines: 'Add Postfix Lines',
  preview: 'Preview',
  edit: 'Edit',
  delete: 'Delete',
  activate: 'Activate',
  deactivate: 'Deactivate',
  cancel: 'Cancel',
  close: 'Close',
  view: 'View',
  reset: 'Reset',
  create: 'Create',
  update: 'Update',
  submit: 'Submit',
  save: 'Save',
  generateJson: 'Generate JSON',
  ok: 'Ok',
  selectPlanet: 'Select WebShop Planet',
  selectPayment: 'Select Payment Type',
  selectOrderType: 'Select Order Type',
  selectCatalogVersion: 'Select Catalog Version',
  selectSubscription: 'Select Subscription',
  selectCatalogView: 'Select Catalog View',
  openingHours: 'Add Opening Hours',
  addVat: 'Add Vat Percentage',
  viewMiniLicense: 'View Mini License',
  copyKey: 'Copy Key',
  addLangMapp: 'Add Language Mapping',
  clone: 'Clone',
  showReports: 'Show Reports',
  createCopy: 'Create a Copy',
  generateMonthly: 'Generate Aggregated Monthly',
  generate: 'Generate',
  chargebyMiles: 'Add Charge by Miles',
  chargebyAmount: 'Add Charge by Invoice Amount',
  showAudit: 'Show Audit Logs',
  startDate: 'Select Start Date',
  endDate: 'Select End Date',
  serviceType: 'Selecte Service Type',
  pushConfUpdate: 'Push Config Update',
  selectUrl: 'Select URL',
  createDiscount: 'Create New Discount',
  selectDays: 'Select Days',
  selectOrderTypes: 'Select Order Types',
  selectPaymentMethods: 'Select Payment Methods',
  selectRules: 'Select Dicount Rules',
  resetPassword: 'Reset Password',
  checkValidation: 'Check Validation',
  populate: 'Populate',
  copy: 'copy',
  homePage: 'Return to Home Page',
  backup: 'Backup',
  backupConfirm: 'Are you sure you want to restore from this file?',
  no: 'No',
  yes: 'Yes',
  selectAppResType: 'Select Type',
  selectAppResSubModel: 'Select Subscription',
  selectResTrackingTypes: 'Select Resource Tracking Types',
  pushToCorp: 'Push to Corporation',
  createCashRegister: 'Create new register',
  registerReciept: 'Register',
  startReciept: 'Start',
  endReciept: 'End',
  nullReciept: 'Null',
  deleteHtmlHint: 'Delete selected Html Hint?',
  addImage: 'Add new image',
  selectLabel: 'Select Label',
  deleteProperty: 'Delete selected Property?',
  showPaymentOverview: 'Show Payment Overview',
  hidePaymentOverview: 'Hide Payment Overview',
  paymentTerminalCreate: 'Create Payment Terminal',
  paymentServerCreate: 'Create Payment Server',
  selectTerminals: 'Select Terminals',
  chargebyMeters: 'Add Charge by Meters',
  next: 'Next',
  back: 'Back',
  importCompany: 'Import from other company',
  changeCompany: 'Change company',
  addViews: 'Click to add views',
  addViews1: 'Add views',
  addAllergens: 'Add allergens',
  addPrinters: 'Add printers',
  removePrinters: 'Remove printers',
  addVAT: 'Add VAT',
  translate: 'Translate',
  exportCSV: 'Export CSV',
  showAllChildren: 'Show all children',
  hideAllChildren: 'Hide all children',
  copyItem: 'Copy Item',
  massAdd: 'Mass add',
  massRemove: 'Mass remove',
  paste: 'Paste',
  importFromParent: 'Import from parent',
  addlanguage: 'Add language',
  deleteitem: 'Delete item',
  editViews: 'Edit Views',
  editAllergens: 'Edit Allergens',
  editPrinterCategories: 'Edit Printer categories',
  addImage1: 'Add Image',
  overwrite: 'overwrite',
  copyEdit: 'Copy & edit',
  copyCatalog: 'Copy catalog',
  pasteCatalog: 'Paste catalog',
  pasteCatalogTurnOn: 'Turn On Paste Listener',
  pasteCatalogTurnOff: 'Turn Off Paste Listener'
};

/***/ }),
/* 103 */
/***/ (function(module, exports) {

module.exports = {
  missingCompany: 'Company is required',
  missingCompanyName: 'Company Name is required',
  missingAppResName: 'App Resource Name is required',
  errorsAppResType: 'App Resource Type is required',
  missingAppResSubModel: 'App Resource Subscription Model is required',
  missingCompanyPhone: 'Company Phone is required',
  missingCompanyCountry: 'Country is required',
  missingCompanyTown: 'Town/City is required',
  missingCompanyPostal: 'Postal Code is required',
  missingCompanyAddress: 'Address Line 1 is required',
  missingFetchConf: 'Fetch Configuration Frequency (In Min.)',
  missingLang: 'Default Language is requierd',
  missingChargeType: 'Delivery Charge Type is requierd',
  missingChargePerMile: 'Delivery Charge Per Mile is requierd',
  missingDomain: 'Domain is required',
  missingMinPersons: 'Min # of Persons is required',
  missingMaxPersons: 'Max # of Persons is required',
  missingCategory: 'Table Category is required',
  missingCurrency: 'Currency is required',
  missingCuisines: 'Cuisines are required',
  missingMaxDist: 'Max Delivery Distance is required',
  missingDomainType: 'Domain Type is required',
  missingRegisteredOn: 'Registration Date is required',
  missingTemplateType: 'Template Type is required',
  missingTemplate: 'Template is required',
  missingRequired: 'You must enter a value for required feilds!',
  missingUsername: 'Please enter your username.',
  missingPassword: 'Please enter your password.',
  missingPlanet: 'WebShop Planet is required',
  missingPayment: 'Payment Type is required',
  missingPayments: 'Payment Types are required',
  missingOrder: 'Order Type is required',
  missingCatalogVersion: 'Catalog Version is required',
  missingSubscription: 'Subscription is required',
  missingCatalogView: 'Catalog View is required',
  missingName: 'WebShop Name is required',
  missingDeliery: 'Minimum Delivery Amount is required',
  missingEmailID: 'Email ID is required',
  missingMerchantId: 'Merchant ID is required',
  missingStoreId: 'Store ID is required',
  missingPass: 'Password is required',
  missingPreSharedKey: 'Pre Shared Key is required',
  missingLicenseType: 'License Type is required',
  missingSunLicense: 'Sun License System Version is required',
  missingConcurrent: 'Number of Concurrent Users is required',
  missingActivationDate: 'Activation Date is required',
  missingExpiryDate: 'Expiry Date is required',
  missingPrinterName: 'Printer Name is required',
  missingManufacturer: 'Manufacturer is required',
  missingModel: 'Model is required',
  missingPrintServerName: 'Print Server Name is required',
  missingPrinters: 'Printers are required',
  missingHolder: 'Account Holder Name is required',
  missingDicount: 'Max Discount Percentage is required',
  missingUserName: 'Username is required',
  missingDefaultPrinter: 'Default Printer is required',
  missingCallerIdName: 'CallerID Server Name is required',
  missingCorporationName: 'Corporation Name is required',
  missingCompanies: 'Companies are required',
  missingTemplateName: 'Template Name is required',
  missingPrintTemplateType: 'Print Template Type is required',
  missingNoPrints: 'Number of Prints is required',
  missingMonth: 'Month is required',
  missingYear: 'Year is required',
  missingMainaway: 'Mainaway Template is required',
  missingUnpaidBill: 'Unpaid Bill Template is required',
  missingItemTemplate: 'Item Template is required',
  missingTaxTemplate: 'Tax Template is required',
  missingLabelTemplate: 'Label Template is required',
  missingKitchenTemplate: 'Kitchen Template is required',
  missingDriverTemplate: 'Driver Template is required',
  missingFromDate: 'From Date is required',
  missingToDate: 'To Date is required',
  missingStartDate: 'Start Date is required',
  missingEndDate: 'End Date is required',
  missingCfgUpdate: 'Configuration Update Type is required',
  missingTableMin: 'Table Idle Time In Minutes is required',
  missingOrderSubmission: 'Order Submission Allowed From is required',
  missingPricingGroups: 'Pricing Groups are required',
  wrongInterval: 'Backup Interval has wrong value',
  validTime: 'Time is not in valid format',
  validEmail: 'E-mail must be valid',
  noData: 'No data available',
  missingRuleName: 'Rule Name is required',
  serverUrl: 'Server URL is required',
  primaryCompany: 'Primary Company is required',
  timeError: 'Time value is not valid',
  required: 'Field is required',
  notValid: 'Value is not valid',
  'Web:User Login userName cannot be null or empty': 'Username cannot be null or empty',
  'Web:User Login password cannot be null or empty': 'Password cannot be null or empty',
  'Error in fields': 'Error in fields',
  'Access Denied': 'Access Denied',
  'Company:Create Duplicate oosId.': 'Duplicate oosId.',
  'Company:Create OosId cannot be null.': 'OosId cannot be null.',
  'Company:Create Duplicate name.': 'Duplicate name.',
  'Company:Create Invalid currency code.': 'Invalid currency code.',
  'Company:Create Test cannot be null.': 'Test cannot be null.',
  'Company:Create Address Line1 cannot be null or empty.': 'Address Line1 cannot be null or empty.',
  'Company:Create Address Town City cannot be null or empty.': 'Address Town City cannot be null or empty.',
  'Company:Create Address Country cannot be null or empty.': 'Address Country cannot be null or empty.',
  'Company:Create Address PostalCode cannot be null or empty.': 'Address PostalCode cannot be null or empty.',
  'Company:Create Name cannot be null or empty.': 'Name cannot be null or empty.',
  'Company:Create Currency cannot be null or empty.': 'Currency cannot be null or empty.',
  'Company:Create Invalid Email.': 'Invalid Email.',
  'Company:Update Duplicate oosId': 'Duplicate oosId',
  'Company:Update OosId cannot be null.': 'OosId cannot be null.',
  'Company:Update Duplicate name.': 'Duplicate name.',
  'Company:Update Invalid currency code.': 'Invalid currency code.',
  'Company:Update Test cannot be null.': 'Test cannot be null.',
  'Company:Update Failed to update company details.': 'Failed to update company details.',
  'Company:Update Name cannot be null or empty.': 'Name cannot be null or empty.',
  'Company:Update Currency cannot be null or empty.': 'Currency cannot be null or empty.',
  'Company:Update Invalid Email.': 'Invalid Email.',
  'Company:Get Company not found.': 'Company not found.',
  'Company:Activate Failed to update company status. Invalid company id': 'Failed to update company status. Invalid company id',
  'Request method \'POST\' not supported': 'Request method \'POST\' not supported',
  'Company:Deactivate Failed to update company status. Invalid company id': 'Failed to update company status. Invalid company id',
  noVatRates: 'You must enter at least one VAT rate',
  wrongVAT: 'VAT rates must be at least one of the following',
  missingImageName: 'Image Name is required',
  missingImageLabel: 'Image Label is required',
  missingdistanceUnit: 'Distance Unit is required',
  wrongVatUK: 'VAT rates must be at least one of the following',
  missingHint: 'Missing mandatory HtmlHint',
  missingAllHint: 'Please add the mandatory fields needed for the T&C respective data protection pages',
  wrongEmail: 'Book keeper Email for is not in good format',
  emptyValue: 'cannot be empty',
  postal: 'postal code not found!',
  validPostalOrAddress: 'Postal code or address is not valid, please change',
  notValidUrl: 'Url format is not valid!',
  missingTimezone: 'Timezone is missing!',
  missingTerminals: 'At least one Terminal is required',
  missingApiKey: 'Api Key is required',
  missingUsernameP: 'Username is required',
  validConfirmEmail: 'E-mails are not the same',
  noAvailableTemplate: 'No available template for import',
  inputOutputLangs: 'You must select Input and Output languages!',
  inputOutputLangsSame: 'Input and Output languages cannot be the same!'
};

/***/ }),
/* 104 */
/***/ (function(module, exports) {

module.exports = {
  projectName: 'Sun',
  eng: 'English',
  de: 'German',
  error404: 'The page you are looking for does not exist!'
};

/***/ }),
/* 105 */
/***/ (function(module, exports) {

module.exports = {
  apps: 'Apps',
  autoJobs: 'Auto Jobs',
  auditLog: 'Audit Log',
  companies: 'Companies',
  configUpdates: 'Config Updates',
  catalogs: 'Catalogs',
  callerId: 'CallerID Servers',
  corporations: 'Corporations',
  domains: 'Domains',
  languageMappings: 'Language Mappings',
  licenses: 'Licenses',
  licenseReports: 'License Reports',
  webshopusageReports: 'Webshopusage Reports',
  model: 'Model',
  printTemplates: 'Print Templates',
  manufacturer: 'Manufacturer',
  discounts: 'Discounts',
  domain: 'Domain',
  moonBackup: 'Moon Backup',
  moonInstances: 'Moon Instances',
  systemlog: 'System Logs',
  system: 'System',
  tables: 'Tables',
  tableName: 'Table Name',
  tableCategory: 'Table Category Name',
  tableCategories: 'Table Categories',
  webShops: 'Web Shops',
  webspace: 'Web Spaces',
  accounts: 'Accounts',
  printers: 'Printers',
  printServers: 'Print Servers',
  login: 'Login',
  logout: 'Logout',
  emailConf: 'Email Configuration Settings',
  pending: 'Pending Orders',
  lastPending: 'Last Pending Order',
  historyId: 'History ID',
  srNo: 'Sr No',
  orderIdSource: 'Order ID/Source',
  orderCode: 'Order Code',
  customerName: 'Customer Name',
  totalAmount: 'Total Amount',
  contactedOn: 'Last Contacted On',
  templateType: 'Template Type',
  templateName: 'Template Name',
  day: 'Day',
  start: 'Start',
  end: 'End',
  catalogVersion: 'Catalog Version',
  licenseType: 'License Type',
  licenseKey: 'License Key',
  moonInstName: 'Moon Instace Name',
  activationDate: 'Activation Date',
  expiryDate: 'Expiry Date',
  createdDate: 'Created Date',
  modifiedDate: 'Modified Date',
  limit: 'Limit',
  callerIdName: 'CallerID Server Name',
  webShopResourceId: 'Web Shop Resource ID',
  noOfOrders: 'No Of Orders',
  ordersSum: 'Orders Sum',
  prefixLines: 'Prefix Lines',
  postixLines: 'Postfix Lines',
  jobName: 'Job Name',
  jobDesc: 'Job Description',
  lastExec: 'Last Executed On',
  nextExec: 'Next Planned Execution On',
  fromMiles: 'From Miles',
  toMiles: 'To Miles',
  charges: 'Charges',
  defaultCharges: 'Default Charges',
  fromAmount: 'From Amount',
  toAmount: 'To Amount',
  action: 'Action',
  sourceVersion: 'Source/Version',
  createdBy: 'Created By',
  synched: 'Synched On',
  instanceName: 'Instance Name',
  conditions: 'Conditions',
  values: 'Values',
  callerIdServers: 'CallerID Servers',
  webShopResource: 'Web Shop Resources',
  catalogName: 'Catalog Name',
  emailPhone: 'Email/Phone',
  webshop: 'webshop',
  orderingApp: 'ordering app',
  pricingInvoices: 'Invoices',
  pricingGroupName: 'Pricing Group Name',
  resourceTracking: 'Resource Tracking',
  resourceType: 'Resource Type/ID',
  trackingAction: 'Tracking Action',
  closedReason: 'Closed/Reason For Closure',
  cashRegister: 'Cash Register',
  htmlHints: 'Html Hints',
  images: 'Images',
  label: 'Label',
  companyGeneralData: 'Company General Data',
  companySettings: 'Company Settings',
  companyAddress: 'Company Address',
  properties: 'Properties',
  paymentSummary: 'Payment Summary',
  paymentType: 'Payment Type',
  amount: 'Amount',
  paymentGatewaySettings: 'Payment Gateway Settings',
  paymentTerminals: 'Payment Terminals',
  paymentServers: 'Payment Servers',
  delivery: 'Delivery',
  keys: 'Keys',
  automatedPrinting: 'Automated printing',
  fromMeters: 'From Meters',
  toMeters: 'To Meters',
  companyInfo: 'Company Info',
  account: 'Account',
  roleManagement: 'Role Management',
  originalVersion: 'Original version',
  views: 'Views',
  allergens: 'Allergens',
  massAddRemove: 'Mass Add/Remove',
  items: 'Items',
  edit: 'Edit',
  add: 'Add',
  item: 'Item',
  printerCategories: 'Printer categories',
  abbreviation: 'Abbreviation',
  name: 'Name',
  description: 'Description',
  sizes: 'Sizes',
  variants: 'Variants',
  options: 'Options',
  styles: 'Styles',
  settings: 'Settings',
  color: 'Color',
  language: 'Language',
  default: 'Default',
  actions: 'Actions',
  massTranslate: 'Mass translate',
  overwriteOptions: 'To overwrite',
  abbrevation: 'Abbrevation',
  taxCategory: 'Tax category',
  courseNo: 'Course No',
  vat: 'VAT'
};

/***/ }),
/* 106 */
/***/ (function(module, exports) {

module.exports = {
  username: 'Username',
  password: 'Password',
  name: 'Name (Not visible to customers)',
  search: 'Search',
  overview: 'Overview',
  generate: 'Generate',
  currency: 'Currency',
  status: 'Status',
  modified: 'Modified On',
  created: 'Created On',
  actions: 'Actions',
  filter: 'Filter for company',
  catalogFilter: 'Filter for catalogs',
  active: 'Active',
  inactive: 'Inactive',
  phone: 'Phone',
  email: 'Email',
  externalID: 'External ID',
  externalIDres: 'External Resource ID',
  testMode: 'Enable Test Mode',
  addressLine: 'Address line',
  locality: 'Locality',
  townCity: 'Town/City',
  country: 'Country',
  postalcode: 'Postal Code',
  createCompany: 'Create company',
  editCompany: 'Edit company',
  companyDomain: 'Company Domain',
  type: 'Type',
  company: 'Company',
  companyName: 'Company Name',
  companyId: 'Company ID',
  propKey: 'Property Key',
  propValue: 'Property Value',
  fromDate: 'From Date',
  toDate: 'To Date',
  errorMessage: 'Error Message',
  language: 'Select Language',
  multipleTables: 'Do you want to create multiple tables?',
  sequenceNumber: 'Displace sequence',
  minDelivery: 'Min Delivery Amount',
  sendToMoon: 'Do you want to send web shop orders to Moon?',
  sendEmail: 'Sending Email Address',
  sendBCC: 'Order Recipients Email Addresses (separated by ,)',
  prefix: 'Prefix',
  postfix: 'Postfix',
  numberOfPrints: 'Number of Prints',
  numberOfTables: 'Number of Tables',
  payGateway: 'Payment Gateway',
  merchantId: 'Merchant ID',
  preSharedKey: 'Pre Shared Key',
  data: 'Data',
  url: 'URL',
  moonUrl: 'Moon URL',
  macAddress: 'Mac Addresses',
  queueUrl: 'Moon Queue URL',
  publicKeySun: 'Sun Public Key',
  privateKeySun: 'Sun Private Key',
  publicKeyMoon: 'Moon Public Key',
  instanceId: 'Instance ID',
  totalAmount: 'Total Amount',
  backup: 'Backup Interval (In Hours)',
  fetchConf: 'Fetch Configuration Frequency (In Min.)',
  paymentTypes: 'Payment Types',
  tipTax: 'Tip Tax Rate',
  left: 'Left',
  right: 'Right',
  defLang: 'Default Language',
  cuisines: 'Cuisines',
  maxDist: 'Max Delivery Distance',
  delPostal: 'Delivery Postal Codes (separated by ,)',
  updatePassword: 'Set/Update password',
  chargeTax: 'Delivery Charges Tax Rate',
  chargeType: 'Delivery Charge Type',
  delChargePerMile: 'Delivery Charge Per Mile',
  chargesPerMile: 'Charges Per Mile',
  noCharge: 'No Delivery Charge',
  chargeByMile: 'Charge By Miles',
  chargeByInvoice: 'Charge By Invoice Amount',
  payIntegModule: 'Activate Moon payment integration',
  orderPrint: 'Enable complete order print?',
  enquiryContact: 'Enable contact form on webpage',
  enquiryReser: 'Enable reservation form on webpage?',
  minPersons: 'Min # of Persons',
  maxPersons: 'Max # of Persons',
  sunday: 'SUNDAY',
  monday: 'MONDAY',
  tuesday: 'TUESDAY',
  wednesday: 'WEDNESDAY',
  thursday: 'THURSDAY',
  friday: 'FRIDAY',
  saturday: 'SATURDAY',
  concurrent: 'Concurrent Users',
  sunLicense: 'Sun License System Version',
  moonInstID: 'Moon Instance ID',
  printerName: 'Printer Name',
  ipAddress: 'IP Address',
  portNumber: 'Port Number',
  maxRetriesOnErrors: 'Max Retries On Errors',
  maxTransactionDuration: 'Max Transaction Duration (in sec)',
  notes: 'Notes',
  controlledByMoon: 'Do you want to assign this printer to Moon?',
  pdfPrinter: 'PDF Printer',
  printServerName: 'Print Server Name',
  key: 'Key',
  records: '# Records For Printing',
  holder: 'Account Holder Name',
  maxDiscount: 'Max Discount Percentage',
  lowerCase: 'Username should be lowercase',
  corporationName: 'Corporation Name',
  templateName: 'Template Name',
  fontHeight: 'Font Height',
  fontStyle: 'Font Style',
  mainawayTemplate: 'Mainaway Template',
  content: 'Content',
  month: 'Month',
  year: 'Year',
  january: 'January',
  february: 'February',
  march: 'March',
  april: 'April',
  may: 'May',
  june: 'June',
  july: 'July',
  august: 'August',
  september: 'September',
  october: 'October',
  november: 'November',
  december: 'December',
  unpaidBillTemplate: 'Unpaid Bill Template',
  taxTemplate: 'Tax Template',
  itemTemplate: 'Item Template',
  labelTemplate: 'Label Template',
  kitchenTemplate: 'Kitchen Template',
  driverTemplate: 'Driver Template',
  licenseSyncStatus: 'License Sync Status',
  daily: 'Daily',
  monthly: 'Monthly',
  monthlyAgg: 'Monthly Aggregate',
  noService: 'No Service Charge',
  percOfTotal: 'Charge by Percentage of Total',
  serviceTaxRate: 'Service Charge Tax Rate',
  percentage: 'Percentage',
  configUpdates: 'Config Updates',
  planetType: 'Planet Type',
  planetInstName: 'Planet Instance Name',
  companyDataUpdated: 'Company Data Updated',
  langMapforPrintCat: 'Languages Mapped For Printer Categories',
  ruleName: 'Rule Name',
  amountOfPersons: 'Amount of Persons',
  minAmount: 'Minimum Amount of',
  voucherCode: 'Voucher Code',
  startTime: 'Start Time',
  endTime: 'End Time',
  discountAmount: 'Discount Amount',
  discountPercent: 'Discount Percent',
  discountRules: 'Discount Rules',
  discountRuleNames: 'Discount Rule Names',
  refreshCatalog: 'Refresh Catalog',
  yourPassword: 'Your password is: ',
  description: 'Description',
  showActive: 'Show Active Only',
  swithcCode: 'Table Switch Code',
  swithcCodeHint: 'Table Switch Code must be 4 digits',
  auditDirection: 'Audit Direction',
  domainType: 'Domain Type',
  tableIdleTimeInMinutes: 'Table Idle Time (In Min)',
  align: 'Align',
  idForS3: 'ID for S3 Server',
  all: 'All',
  incoming: 'Incoming',
  outgoing: 'Outgoing',
  currentVersion: 'Current Version',
  previousVersion: 'Previous Version',
  printerID: 'Printer ID',
  lastLoggedinOn: 'Last Logged in on',
  orderSubmission: 'Order Submission Allowed From',
  externalId: 'External ID',
  licenseID: 'License ID',
  confirmationText: 'Do you want to deactive?',
  activationText: 'Would you like to activate this webshop?',
  catalogActivationText: 'Would you like to activate this catalog?',
  licenseActivationText: 'Would you like to activate this license?',
  default: 'Default',
  rgu: 'RGU',
  sourceSystem: 'Source System',
  orderType: 'Order Type',
  printType: 'Print Type',
  autoPrinting: 'Auto Printing',
  pricingGroups: 'Pricing Groups',
  moon: 'moon',
  webshop: 'webshop',
  buildOverview: 'Build overview',
  generateInvoice: 'Generate invoice',
  massRemoveViews: 'Are you sure you want to remove this View? Deleting it will remove it from all existing items.',
  maxDeliveryDisWarning: 'Attention: please take into account that setting max delivery distance to 0 turns on delivery without any (!) limitations.',
  accountImpactWarning: 'Attention: the local admin rights shall be carefully assigned and only to customer accounts as it will impact Sun Front-End behavior.',
  sendToMoonWarning: 'Please make sure to set up a Moon instance with an active license as otherwise orders can not be processed.',
  detailed: 'Detailed',
  noVATtax: 'no VAT tax',
  noTipTax: 'No tip tax',
  noDeliveryTax: 'No delivery tax',
  noServiceTax: 'No service tax',
  deliveryDurationFrom: 'Delivery duration from (in min)',
  deliveryDurationTo: 'Delivery duration to (in min)',
  statusCode: 'Status Code',
  activateAfterCopy: 'Activate Catalog After Copy',
  primaryCompany: 'Primary Company',
  contactServerSettings: 'Contact server',
  addressServerSettings: 'Address server',
  walletServerSettings: 'Wallet server',
  depServerSettings: 'DEP Server',
  inventoryServerSettings: 'Inventory server',
  contactServerKey: 'Contact server key',
  addressServerKey: 'Address server key',
  walletServerKey: 'Wallet server key',
  depServerKey: 'DEP Server key',
  inventoryServerKey: 'Inventory server key',
  enableDEP: 'DEP enable',
  latitude: 'Latitude',
  longitude: 'Longitude',
  dailyOrdersCounterEnabled: 'Enable daily orders counter',
  cashRegisterName: 'Cash Register Name',
  cashRegisterId: 'Cash Register ID',
  depAccessKey: 'DEP access key',
  corporation: 'Corporation',
  aesKey: 'AES key',
  aesKeyCheckSum: 'AES key checksum',
  inUseFrom: 'In use from',
  storeId: 'Store ID',
  addHtml: 'Add new Html Hint',
  imageName: 'Image Name',
  imageId: 'Image ID',
  distanceUnit: 'Distance Unit',
  en: 'English',
  de: 'German',
  zh: 'Chinese',
  registrationNumber: 'Registration number',
  registrationLocation: 'Registration location',
  bookKeeperEmails: 'Book keeper Recipients Email (separated by ,)',
  visibleToCustomer: 'Visible to customer',
  massRemoveAllergens: 'Are you sure you want to remove this Allergen? Deleting it will remove it from all existing items.',
  importHtml: 'Import Html Hints',
  enableKitchenPrintPersistence: 'Enable kitchen print persistence',
  numberOfSeats: 'Number of Seats',
  addProperty: 'Add new Property',
  importProperty: 'Import Properties',
  foreignId: 'Foreign ID',
  dailyOrderCounterPrefixes: 'Daily Order Counter Prefixes',
  delivery: "Delivery",
  collection: "Collection",
  takeaway: "Takeaway",
  card: 'Card',
  cash: 'Cash',
  amazon: 'Amazon',
  cardmanual: 'Card Manual',
  deliveroo: 'Deliveroo',
  hungryhouse: 'Hungry House',
  invoice: 'Invoice',
  justeat: 'Justeat',
  ubereats: 'Ubereats',
  voucher: 'Voucher',
  galaxycard: 'Galaxy Card',
  webshopOrderNo: 'Webshop Order #',
  appOrderNo: 'OrderApp Order #',
  webshopTotal: 'Webshop Total Amount',
  appTotal: 'OrderApp Total Amount',
  authServerSettings: 'Auth Server',
  publiclyAvailable: 'Publicly Available',
  reservationServerSettings: 'Reservation Server',
  addressLookup: 'Address Lookup',
  postalCode: 'Postal code',
  line1: 'Line 1',
  line2: 'Line 2',
  line3: 'Line 3',
  line4: 'Line 4',
  line3AT: 'Staircase/apartment/Address details',
  line2AT: 'House number',
  line1AT: 'Street',
  acceptingOrders: 'Accept orders (disable to temporary stopping accepting orders)',
  labelPrint: 'Label print',
  askDetails: 'Ask details',
  vatPrint: 'VAT print',
  noDiscount: 'No discount applicable',
  addsGalaxyCardBalance: 'Adds Galaxy Card balance',
  quantityOfIncludedOptions: 'Quantity Of Included Options',
  restaurant: "Restaurant",
  defaultPaymentType: 'Default Payment Type',
  notifyOwnerOnPaymentFailure: 'Notify Owner On Payment Failure',
  webshopUrl: 'Webshop Url',
  copy: 'Copy',
  apiKey: 'API Key',
  nfcToken: 'NFC Token',
  passwordResetPrefixText: 'Please select a payment gateway provider, enter the basic data and save the record to trigger the key generation. Please wait and refresh the screen in order to enable password entry.',
  printTemplateActivationText: 'Would you like to activate this print template?',
  activateShopFirst: 'Please activate the webshop first. Then you will be able to set up a payment gateway.',
  timezone: 'Timezone',
  upload: 'Chose file',
  predefinedViews: 'Add predefined view',
  showEmail: 'Show email',
  showPhoneNumber: 'Show phone number',
  smsConfirmationFirstOrder: 'SMS confirmation first order',
  smsUsername: 'SMS username',
  smsSettings: 'Sms Settings',
  discountSettings: 'Discount Settings',
  updateSmsPassword: 'Set/Update Sms Password',
  passwordSmaResetPrefixText: 'Please enable Sms confirmation first order, add username and save the record to enable password set. Please wait and refresh the screen in order to enable password entry.',
  generalSettings: 'General Settings',
  terminalName: 'Terminal Name',
  terminalId: 'Terminal ID',
  terminalIdentifier: 'Terminal Identifier',
  paymentServerName: 'Payment Server Name',
  depReceipts: 'Dep Receipts',
  delChargePerMeter: 'Delivery Charge Per Meter',
  publicHoliday: 'PUBLIC HOLIDAY',
  allChildren: 'All children',
  paymentTerminals: 'Payment Terminals',
  paymentServers: 'Payment Servers',
  frontEndVersion: 'Frontend',
  backendversion: 'Backend',
  webshopQr: 'Webshop QR',
  contactTrackingQr: 'Contact tracking QR',
  menuQr: 'Menu QR',
  connectEApiKey: 'Api Key',
  connectEUsername: 'Username',
  signUp: 'Sign-up',
  confirmEmail: 'Confirm Email',
  account: 'Account',
  selectedAddress: 'Selected Address',
  none: 'None',
  atUser: 'AT User',
  atLocalAdmin: 'AT Local Admin',
  merchantPrint: 'Merchant print',
  customerPrint: 'Customer print',
  automaticPrint: 'Automatic Printing',
  maxDiscountPercentage: 'Max Discount Percentage',
  merchant: 'Merchant',
  customer: 'Customer',
  switchReceiptType: 'First Receipt Type',
  selectCompany: 'Select company',
  filterCategories: 'Filter categories',
  name1: 'Name',
  printerCategories: 'Printer categories',
  settings: 'Settings',
  VAT: 'VAT',
  taxCategory: 'Tax category',
  defPrice: 'Def. price',
  choseLabelToAddImage: 'Chose label to add image',
  selectLabelFirst: 'Select label first',
  selectImage: 'Select Image',
  inputLanguage: 'Input language',
  outputLanguage: 'Output language',
  parentCopy: 'Copy all children from selected source',
  views: 'Views',
  size: 'Size',
  variant: 'Variant',
  option: 'Option',
  style: 'Style',
  parentCopyFrom: 'Parent from where the children should be copied from',
  includedQuantity: 'Included Quantity'
};

/***/ }),
/* 107 */
/***/ (function(module, exports) {

module.exports = {
  productionLicenses: 'Production Licenses',
  testLicense: 'Test License',
  totalActive: 'Total number of Active Licenses',
  totalConcurrent: 'Total number of Concurrent Users',
  registeredUsers: 'Registered Users',
  active: 'Active',
  inactive: 'Inactive',
  domains: 'Domains',
  webSpaceTypes: 'Web space types',
  premium: 'Premium',
  basic: 'Basic',
  link: 'Link',
  custom: 'Custom',
  orders: '# orders',
  totalAmount: 'Total Amount',
  webShopRes: 'WebShop Resources',
  category: 'Category',
  module: 'Module',
  users: '# of users',
  moon: 'Moon',
  paymentM: 'Payment Management',
  contactM: 'Contact Management',
  reportsM: 'Reports Management',
  ordertM: 'Order Management',
  invoiceM: 'Invoice Management',
  inventoryM: 'Inventory Management',
  drawerHandlerM: 'Drawer Handler Management',
  DBOptM: 'DB Optimization Management',
  moonBackupM: 'Moon Backup Management',
  sun: 'Sun',
  autoJobM: 'Auto Job Management',
  catalogM: 'Catalog Management',
  printerM: 'Printer Management',
  printServerM: 'Print Server Management',
  licenseM: 'License Management',
  tableM: 'Table Management',
  accountM: 'Account Management',
  companyM: 'Company Management',
  sunBackupM: 'Sun Backup Management',
  userCounts: 'User Counts By License Type',
  type: 'Type',
  companyName: 'Company Name',
  concUsers: '# of concurrent users',
  activeUsers: '# of active users',
  domainsByWSType: 'Domains By Web Space Type',
  domainNames: 'Domain Names',
  webShopResourceByType: 'Webshop Resources By Type',
  ActiveWebShopResources: 'Active Web Shop Resources',
  InactiveWebShopResources: 'Inactive Web Shop Resources',
  webShopResourceId: 'Webshop Resource ID',
  webShopResourceName: 'Webshop Resource Name'
};

/***/ }),
/* 108 */
/***/ (function(module, exports) {

module.exports = {
  emailId: 'Please ensure to use a preconfigured one',
  emailBCC: 'Email addresses that receive orders',
  companyName: 'Company Name Goes Here',
  companyEmail: 'Email contact for the compmany',
  phone: 'Phone number including country code',
  companyCountry: 'Country for the company',
  companyTown: 'Town/City for the company',
  companyLocality: 'Locality for the company',
  companyPostal: 'Postal Code for the company',
  paymentTypes: 'Select Payment Types',
  pricingGroups: 'Select Pricing Groups',
  backupInterval: 'Backup Interval should be between 3 and 168 hours'
};

/***/ }),
/* 109 */
/***/ (function(module, exports) {

module.exports = {
  createCompany: '创建公司',
  createCatalog: '创建目录',
  edit: '编辑',
  activate: '启用',
  deactivate: '关闭',
  cancel: '取消',
  create: '创建',
  update: '更新',
  submit: '提交'
};

/***/ }),
/* 110 */
/***/ (function(module, exports) {

module.exports = {
  missingRequired: 'You must enter a value for required feilds!',
  missingUsername: 'Please enter your username.',
  missingPassword: 'Please enter your password.',
  'Web:User Login userName cannot be null or empty': 'Username cannot be null or empty',
  'Web:User Login password cannot be null or empty': 'Password cannot be null or empty',
  'Error in fields': 'Error in fields',
  'Access Denied': 'Access Denied',
  'Company:Create Duplicate oosId.': 'Duplicate oosId.',
  'Company:Create OosId cannot be null.': 'OosId cannot be null.',
  'Company:Create Duplicate name.': 'Duplicate name.',
  'Company:Create Invalid currency code.': 'Invalid currency code.',
  'Company:Create Test cannot be null.': 'Test cannot be null.',
  'Company:Create Address Line1 cannot be null or empty.': 'Address Line1 cannot be null or empty.',
  'Company:Create Address Town City cannot be null or empty.': 'Address Town City cannot be null or empty.',
  'Company:Create Address Country cannot be null or empty.': 'Address Country cannot be null or empty.',
  'Company:Create Address PostalCode cannot be null or empty.': 'Address PostalCode cannot be null or empty.',
  'Company:Create Name cannot be null or empty.': 'Name cannot be null or empty.',
  'Company:Create Currency cannot be null or empty.': 'Currency cannot be null or empty.',
  'Company:Create Invalid Email.': 'Invalid Email.',
  'Company:Update Duplicate oosId': 'Duplicate oosId',
  'Company:Update OosId cannot be null.': 'OosId cannot be null.',
  'Company:Update Duplicate name.': 'Duplicate name.',
  'Company:Update Invalid currency code.': 'Invalid currency code.',
  'Company:Update Test cannot be null.': 'Test cannot be null.',
  'Company:Update Failed to update company details.': 'Failed to update company details.',
  'Company:Update Name cannot be null or empty.': 'Name cannot be null or empty.',
  'Company:Update Currency cannot be null or empty.': 'Currency cannot be null or empty.',
  'Company:Update Invalid Email.': 'Invalid Email.',
  'Company:Get Company not found.': 'Company not found.',
  'Company:Activate Failed to update company status. Invalid company id': 'Failed to update company status. Invalid company id',
  'Request method \'POST\' not supported': 'Request method \'POST\' not supported',
  'Company:Deactivate Failed to update company status. Invalid company id': 'Failed to update company status. Invalid company id'
};

/***/ }),
/* 111 */
/***/ (function(module, exports) {

module.exports = {
  projectName: 'Application name',
  eng: 'English',
  de: 'German',
  error404: 'The page you are looking for does not exist!'
};

/***/ }),
/* 112 */
/***/ (function(module, exports) {

module.exports = {
  companies: '公司',
  catalogs: '目录',
  accounts: '账户',
  printers: '打印机',
  login: '登录',
  logout: '登出'
};

/***/ }),
/* 113 */
/***/ (function(module, exports) {

module.exports = {
  username: 'Username',
  password: 'Password',
  name: 'Name',
  currency: 'Currency',
  status: 'Status',
  modified: 'Modified on',
  created: 'Created on',
  actions: 'Actions',
  filter: 'Filter for company',
  catalogFilter: 'Filter for catalogs',
  active: 'Active',
  inactive: 'Inactive',
  phone: 'Phone',
  email: 'Email',
  externalID: 'External ID',
  testMode: 'Test mode',
  addressLine: 'Address line',
  locality: 'Locality',
  townCity: 'Town/City',
  country: 'Country',
  postalcode: 'Postalcode',
  createCompany: 'Create company',
  editCompany: 'Edit company'
};

/***/ }),
/* 114 */
/***/ (function(module, exports) {

module.exports = {
  createCompany: '创建公司',
  createCatalog: '创建目录',
  edit: '编辑',
  activate: '启用',
  deactivate: '关闭',
  cancel: '取消',
  create: '创建',
  update: '更新',
  submit: '提交'
};

/***/ }),
/* 115 */
/***/ (function(module, exports) {

module.exports = {
  missingRequired: 'You must enter a value for required feilds!',
  missingUsername: 'Please enter your username.',
  missingPassword: 'Please enter your password.',
  'Web:User Login userName cannot be null or empty': 'Username cannot be null or empty',
  'Web:User Login password cannot be null or empty': 'Password cannot be null or empty',
  'Error in fields': 'Error in fields',
  'Access Denied': 'Access Denied',
  'Company:Create Duplicate oosId.': 'Duplicate oosId.',
  'Company:Create OosId cannot be null.': 'OosId cannot be null.',
  'Company:Create Duplicate name.': 'Duplicate name.',
  'Company:Create Invalid currency code.': 'Invalid currency code.',
  'Company:Create Test cannot be null.': 'Test cannot be null.',
  'Company:Create Address Line1 cannot be null or empty.': 'Address Line1 cannot be null or empty.',
  'Company:Create Address Town City cannot be null or empty.': 'Address Town City cannot be null or empty.',
  'Company:Create Address Country cannot be null or empty.': 'Address Country cannot be null or empty.',
  'Company:Create Address PostalCode cannot be null or empty.': 'Address PostalCode cannot be null or empty.',
  'Company:Create Name cannot be null or empty.': 'Name cannot be null or empty.',
  'Company:Create Currency cannot be null or empty.': 'Currency cannot be null or empty.',
  'Company:Create Invalid Email.': 'Invalid Email.',
  'Company:Update Duplicate oosId': 'Duplicate oosId',
  'Company:Update OosId cannot be null.': 'OosId cannot be null.',
  'Company:Update Duplicate name.': 'Duplicate name.',
  'Company:Update Invalid currency code.': 'Invalid currency code.',
  'Company:Update Test cannot be null.': 'Test cannot be null.',
  'Company:Update Failed to update company details.': 'Failed to update company details.',
  'Company:Update Name cannot be null or empty.': 'Name cannot be null or empty.',
  'Company:Update Currency cannot be null or empty.': 'Currency cannot be null or empty.',
  'Company:Update Invalid Email.': 'Invalid Email.',
  'Company:Get Company not found.': 'Company not found.',
  'Company:Activate Failed to update company status. Invalid company id': 'Failed to update company status. Invalid company id',
  'Request method \'POST\' not supported': 'Request method \'POST\' not supported',
  'Company:Deactivate Failed to update company status. Invalid company id': 'Failed to update company status. Invalid company id'
};

/***/ }),
/* 116 */
/***/ (function(module, exports) {

module.exports = {
  projectName: 'Application name',
  eng: 'English',
  de: 'German',
  error404: 'The page you are looking for does not exist!'
};

/***/ }),
/* 117 */
/***/ (function(module, exports) {

module.exports = {
  companies: '公司',
  catalogs: '目录',
  accounts: '账户',
  printers: '打印机',
  login: '登录',
  logout: '登出'
};

/***/ }),
/* 118 */
/***/ (function(module, exports) {

module.exports = {
  username: 'Username',
  password: 'Password',
  name: 'Name',
  currency: 'Currency',
  status: 'Status',
  modified: 'Modified on',
  created: 'Created on',
  actions: 'Actions',
  filter: 'Filter for company',
  catalogFilter: 'Filter for catalogs',
  active: 'Active',
  inactive: 'Inactive',
  phone: 'Phone',
  email: 'Email',
  externalID: 'External ID',
  testMode: 'Test mode',
  addressLine: 'Address line',
  locality: 'Locality',
  townCity: 'Town/City',
  country: 'Country',
  postalcode: 'Postalcode',
  createCompany: 'Create company',
  editCompany: 'Edit company'
};

/***/ }),
/* 119 */
/***/ (function(module, exports) {

module.exports = {
  createCompany: 'कंपनी बनाएं',
  createCatalog: 'कैटलॉग बनाएं',
  edit: 'संपादित करें',
  activate: 'सक्रिय',
  deactivate: 'निष्क्रिय करें',
  cancel: 'रद्द करना',
  create: 'सर्जन करना',
  update: 'अद्यतन करें',
  submit: 'जमा करें'
};

/***/ }),
/* 120 */
/***/ (function(module, exports) {

module.exports = {
  missingRequired: 'You must enter a value for required feilds!',
  missingUsername: 'Please enter your username.',
  missingPassword: 'Please enter your password.',
  'Web:User Login userName cannot be null or empty': 'Username cannot be null or empty',
  'Web:User Login password cannot be null or empty': 'Password cannot be null or empty',
  'Error in fields': 'Error in fields',
  'Access Denied': 'Access Denied',
  'Company:Create Duplicate oosId.': 'Duplicate oosId.',
  'Company:Create OosId cannot be null.': 'OosId cannot be null.',
  'Company:Create Duplicate name.': 'Duplicate name.',
  'Company:Create Invalid currency code.': 'Invalid currency code.',
  'Company:Create Test cannot be null.': 'Test cannot be null.',
  'Company:Create Address Line1 cannot be null or empty.': 'Address Line1 cannot be null or empty.',
  'Company:Create Address Town City cannot be null or empty.': 'Address Town City cannot be null or empty.',
  'Company:Create Address Country cannot be null or empty.': 'Address Country cannot be null or empty.',
  'Company:Create Address PostalCode cannot be null or empty.': 'Address PostalCode cannot be null or empty.',
  'Company:Create Name cannot be null or empty.': 'Name cannot be null or empty.',
  'Company:Create Currency cannot be null or empty.': 'Currency cannot be null or empty.',
  'Company:Create Invalid Email.': 'Invalid Email.',
  'Company:Update Duplicate oosId': 'Duplicate oosId',
  'Company:Update OosId cannot be null.': 'OosId cannot be null.',
  'Company:Update Duplicate name.': 'Duplicate name.',
  'Company:Update Invalid currency code.': 'Invalid currency code.',
  'Company:Update Test cannot be null.': 'Test cannot be null.',
  'Company:Update Failed to update company details.': 'Failed to update company details.',
  'Company:Update Name cannot be null or empty.': 'Name cannot be null or empty.',
  'Company:Update Currency cannot be null or empty.': 'Currency cannot be null or empty.',
  'Company:Update Invalid Email.': 'Invalid Email.',
  'Company:Get Company not found.': 'Company not found.',
  'Company:Activate Failed to update company status. Invalid company id': 'Failed to update company status. Invalid company id',
  'Request method \'POST\' not supported': 'Request method \'POST\' not supported',
  'Company:Deactivate Failed to update company status. Invalid company id': 'Failed to update company status. Invalid company id'
};

/***/ }),
/* 121 */
/***/ (function(module, exports) {

module.exports = {
  projectName: 'Application name',
  eng: 'English',
  de: 'German',
  error404: 'The page you are looking for does not exist!'
};

/***/ }),
/* 122 */
/***/ (function(module, exports) {

module.exports = {
  companies: 'कंपनियों',
  catalogs: 'कैटलॉग',
  accounts: 'हिसाब किताब',
  printers: 'प्रिंटर',
  login: 'लॉग इन करें',
  logout: 'लोग आउट'
};

/***/ }),
/* 123 */
/***/ (function(module, exports) {

module.exports = {
  username: 'Username',
  password: 'Password',
  name: 'Name',
  currency: 'Currency',
  status: 'Status',
  modified: 'Modified on',
  created: 'Created on',
  actions: 'Actions',
  filter: 'Filter for company',
  catalogFilter: 'Filter for catalogs',
  active: 'Active',
  inactive: 'Inactive',
  phone: 'Phone',
  email: 'Email',
  externalID: 'External ID',
  testMode: 'Test mode',
  addressLine: 'Address line',
  locality: 'Locality',
  townCity: 'Town/City',
  country: 'Country',
  postalcode: 'Postalcode',
  createCompany: 'Create company',
  editCompany: 'Edit company'
};

/***/ }),
/* 124 */
/***/ (function(module, exports) {

module.exports = {
  createCompany: '创建公司',
  createCatalog: '创建目录',
  edit: '编辑',
  activate: '启用',
  deactivate: '关闭',
  cancel: '取消',
  create: '创建',
  update: '更新',
  submit: '提交'
};

/***/ }),
/* 125 */
/***/ (function(module, exports) {

module.exports = {
  missingRequired: 'You must enter a value for required feilds!',
  missingUsername: 'Please enter your username.',
  missingPassword: 'Please enter your password.',
  'Web:User Login userName cannot be null or empty': 'Username cannot be null or empty',
  'Web:User Login password cannot be null or empty': 'Password cannot be null or empty',
  'Error in fields': 'Error in fields',
  'Access Denied': 'Access Denied',
  'Company:Create Duplicate oosId.': 'Duplicate oosId.',
  'Company:Create OosId cannot be null.': 'OosId cannot be null.',
  'Company:Create Duplicate name.': 'Duplicate name.',
  'Company:Create Invalid currency code.': 'Invalid currency code.',
  'Company:Create Test cannot be null.': 'Test cannot be null.',
  'Company:Create Address Line1 cannot be null or empty.': 'Address Line1 cannot be null or empty.',
  'Company:Create Address Town City cannot be null or empty.': 'Address Town City cannot be null or empty.',
  'Company:Create Address Country cannot be null or empty.': 'Address Country cannot be null or empty.',
  'Company:Create Address PostalCode cannot be null or empty.': 'Address PostalCode cannot be null or empty.',
  'Company:Create Name cannot be null or empty.': 'Name cannot be null or empty.',
  'Company:Create Currency cannot be null or empty.': 'Currency cannot be null or empty.',
  'Company:Create Invalid Email.': 'Invalid Email.',
  'Company:Update Duplicate oosId': 'Duplicate oosId',
  'Company:Update OosId cannot be null.': 'OosId cannot be null.',
  'Company:Update Duplicate name.': 'Duplicate name.',
  'Company:Update Invalid currency code.': 'Invalid currency code.',
  'Company:Update Test cannot be null.': 'Test cannot be null.',
  'Company:Update Failed to update company details.': 'Failed to update company details.',
  'Company:Update Name cannot be null or empty.': 'Name cannot be null or empty.',
  'Company:Update Currency cannot be null or empty.': 'Currency cannot be null or empty.',
  'Company:Update Invalid Email.': 'Invalid Email.',
  'Company:Get Company not found.': 'Company not found.',
  'Company:Activate Failed to update company status. Invalid company id': 'Failed to update company status. Invalid company id',
  'Request method \'POST\' not supported': 'Request method \'POST\' not supported',
  'Company:Deactivate Failed to update company status. Invalid company id': 'Failed to update company status. Invalid company id'
};

/***/ }),
/* 126 */
/***/ (function(module, exports) {

module.exports = {
  projectName: 'Application name',
  eng: 'English',
  de: 'German',
  error404: 'The page you are looking for does not exist!'
};

/***/ }),
/* 127 */
/***/ (function(module, exports) {

module.exports = {
  companies: '公司',
  catalogs: '目录',
  accounts: '账户',
  printers: '打印机',
  login: '登录',
  logout: '登出'
};

/***/ }),
/* 128 */
/***/ (function(module, exports) {

module.exports = {
  username: 'Username',
  password: 'Password',
  name: 'Name',
  currency: 'Currency',
  status: 'Status',
  modified: 'Modified on',
  created: 'Created on',
  actions: 'Actions',
  filter: 'Filter for company',
  catalogFilter: 'Filter for catalogs',
  active: 'Active',
  inactive: 'Inactive',
  phone: 'Phone',
  email: 'Email',
  externalID: 'External ID',
  testMode: 'Test mode',
  addressLine: 'Address line',
  locality: 'Locality',
  townCity: 'Town/City',
  country: 'Country',
  postalcode: 'Postalcode',
  createCompany: 'Create company',
  editCompany: 'Edit company'
};

/***/ }),
/* 129 */
/***/ (function(module, exports) {

module.exports = {
  createCompany: '会社を作る',
  createCatalog: 'カタログを作成する',
  edit: '編集',
  activate: '活性化する',
  deactivate: '非アクティブ化する',
  cancel: 'キャンセル',
  create: '作成する',
  update: '更新',
  submit: '提出する'
};

/***/ }),
/* 130 */
/***/ (function(module, exports) {

module.exports = {
  missingRequired: 'You must enter a value for required feilds!',
  missingUsername: 'Please enter your username.',
  missingPassword: 'Please enter your password.',
  'Web:User Login userName cannot be null or empty': 'Username cannot be null or empty',
  'Web:User Login password cannot be null or empty': 'Password cannot be null or empty',
  'Error in fields': 'Error in fields',
  'Access Denied': 'Access Denied',
  'Company:Create Duplicate oosId.': 'Duplicate oosId.',
  'Company:Create OosId cannot be null.': 'OosId cannot be null.',
  'Company:Create Duplicate name.': 'Duplicate name.',
  'Company:Create Invalid currency code.': 'Invalid currency code.',
  'Company:Create Test cannot be null.': 'Test cannot be null.',
  'Company:Create Address Line1 cannot be null or empty.': 'Address Line1 cannot be null or empty.',
  'Company:Create Address Town City cannot be null or empty.': 'Address Town City cannot be null or empty.',
  'Company:Create Address Country cannot be null or empty.': 'Address Country cannot be null or empty.',
  'Company:Create Address PostalCode cannot be null or empty.': 'Address PostalCode cannot be null or empty.',
  'Company:Create Name cannot be null or empty.': 'Name cannot be null or empty.',
  'Company:Create Currency cannot be null or empty.': 'Currency cannot be null or empty.',
  'Company:Create Invalid Email.': 'Invalid Email.',
  'Company:Update Duplicate oosId': 'Duplicate oosId',
  'Company:Update OosId cannot be null.': 'OosId cannot be null.',
  'Company:Update Duplicate name.': 'Duplicate name.',
  'Company:Update Invalid currency code.': 'Invalid currency code.',
  'Company:Update Test cannot be null.': 'Test cannot be null.',
  'Company:Update Failed to update company details.': 'Failed to update company details.',
  'Company:Update Name cannot be null or empty.': 'Name cannot be null or empty.',
  'Company:Update Currency cannot be null or empty.': 'Currency cannot be null or empty.',
  'Company:Update Invalid Email.': 'Invalid Email.',
  'Company:Get Company not found.': 'Company not found.',
  'Company:Activate Failed to update company status. Invalid company id': 'Failed to update company status. Invalid company id',
  'Request method \'POST\' not supported': 'Request method \'POST\' not supported',
  'Company:Deactivate Failed to update company status. Invalid company id': 'Failed to update company status. Invalid company id'
};

/***/ }),
/* 131 */
/***/ (function(module, exports) {

module.exports = {
  projectName: 'Application name',
  eng: 'English',
  de: 'German',
  error404: 'The page you are looking for does not exist!'
};

/***/ }),
/* 132 */
/***/ (function(module, exports) {

module.exports = {
  companies: '企業',
  catalogs: 'カタログ',
  accounts: 'アカウント',
  printers: 'プリンタ',
  login: 'ログイン',
  logout: 'ログアウト'
};

/***/ }),
/* 133 */
/***/ (function(module, exports) {

module.exports = {
  username: 'Username',
  password: 'Password',
  name: 'Name',
  currency: 'Currency',
  status: 'Status',
  modified: 'Modified on',
  created: 'Created on',
  actions: 'Actions',
  filter: 'Filter for company',
  catalogFilter: 'Filter for catalogs',
  active: 'Active',
  inactive: 'Inactive',
  phone: 'Phone',
  email: 'Email',
  externalID: 'External ID',
  testMode: 'Test mode',
  addressLine: 'Address line',
  locality: 'Locality',
  townCity: 'Town/City',
  country: 'Country',
  postalcode: 'Postalcode',
  createCompany: 'Create company',
  editCompany: 'Edit company'
};

/***/ }),
/* 134 */
/***/ (function(module, exports) {

module.exports = {
  createCompany: '创建公司',
  createCatalog: '创建目录',
  edit: '编辑',
  activate: '启用',
  deactivate: '关闭',
  cancel: '取消',
  create: '创建',
  update: '更新',
  submit: '提交'
};

/***/ }),
/* 135 */
/***/ (function(module, exports) {

module.exports = {
  missingRequired: 'You must enter a value for required feilds!',
  missingUsername: 'Please enter your username.',
  missingPassword: 'Please enter your password.',
  'Web:User Login userName cannot be null or empty': 'Username cannot be null or empty',
  'Web:User Login password cannot be null or empty': 'Password cannot be null or empty',
  'Error in fields': 'Error in fields',
  'Access Denied': 'Access Denied',
  'Company:Create Duplicate oosId.': 'Duplicate oosId.',
  'Company:Create OosId cannot be null.': 'OosId cannot be null.',
  'Company:Create Duplicate name.': 'Duplicate name.',
  'Company:Create Invalid currency code.': 'Invalid currency code.',
  'Company:Create Test cannot be null.': 'Test cannot be null.',
  'Company:Create Address Line1 cannot be null or empty.': 'Address Line1 cannot be null or empty.',
  'Company:Create Address Town City cannot be null or empty.': 'Address Town City cannot be null or empty.',
  'Company:Create Address Country cannot be null or empty.': 'Address Country cannot be null or empty.',
  'Company:Create Address PostalCode cannot be null or empty.': 'Address PostalCode cannot be null or empty.',
  'Company:Create Name cannot be null or empty.': 'Name cannot be null or empty.',
  'Company:Create Currency cannot be null or empty.': 'Currency cannot be null or empty.',
  'Company:Create Invalid Email.': 'Invalid Email.',
  'Company:Update Duplicate oosId': 'Duplicate oosId',
  'Company:Update OosId cannot be null.': 'OosId cannot be null.',
  'Company:Update Duplicate name.': 'Duplicate name.',
  'Company:Update Invalid currency code.': 'Invalid currency code.',
  'Company:Update Test cannot be null.': 'Test cannot be null.',
  'Company:Update Failed to update company details.': 'Failed to update company details.',
  'Company:Update Name cannot be null or empty.': 'Name cannot be null or empty.',
  'Company:Update Currency cannot be null or empty.': 'Currency cannot be null or empty.',
  'Company:Update Invalid Email.': 'Invalid Email.',
  'Company:Get Company not found.': 'Company not found.',
  'Company:Activate Failed to update company status. Invalid company id': 'Failed to update company status. Invalid company id',
  'Request method \'POST\' not supported': 'Request method \'POST\' not supported',
  'Company:Deactivate Failed to update company status. Invalid company id': 'Failed to update company status. Invalid company id'
};

/***/ }),
/* 136 */
/***/ (function(module, exports) {

module.exports = {
  projectName: 'Application name',
  eng: 'English',
  de: 'German',
  error404: 'The page you are looking for does not exist!'
};

/***/ }),
/* 137 */
/***/ (function(module, exports) {

module.exports = {
  companies: '公司',
  catalogs: '目录',
  accounts: '账户',
  printers: '打印机',
  login: '登录',
  logout: '登出'
};

/***/ }),
/* 138 */
/***/ (function(module, exports) {

module.exports = {
  username: 'Username',
  password: 'Password',
  name: 'Name',
  currency: 'Currency',
  status: 'Status',
  modified: 'Modified on',
  created: 'Created on',
  actions: 'Actions',
  filter: 'Filter for company',
  catalogFilter: 'Filter for catalogs',
  active: 'Active',
  inactive: 'Inactive',
  phone: 'Phone',
  email: 'Email',
  externalID: 'External ID',
  testMode: 'Test mode',
  addressLine: 'Address line',
  locality: 'Locality',
  townCity: 'Town/City',
  country: 'Country',
  postalcode: 'Postalcode',
  createCompany: 'Create company',
  editCompany: 'Edit company'
};

/***/ }),
/* 139 */
/***/ (function(module, exports) {

module.exports = {
  createCompany: '创建公司',
  createCatalog: '创建目录',
  edit: '编辑',
  activate: '启用',
  deactivate: '关闭',
  cancel: '取消',
  create: '创建',
  update: '更新',
  submit: '提交'
};

/***/ }),
/* 140 */
/***/ (function(module, exports) {

module.exports = {
  missingRequired: 'You must enter a value for required feilds!',
  missingUsername: 'Please enter your username.',
  missingPassword: 'Please enter your password.',
  'Web:User Login userName cannot be null or empty': 'Username cannot be null or empty',
  'Web:User Login password cannot be null or empty': 'Password cannot be null or empty',
  'Error in fields': 'Error in fields',
  'Access Denied': 'Access Denied',
  'Company:Create Duplicate oosId.': 'Duplicate oosId.',
  'Company:Create OosId cannot be null.': 'OosId cannot be null.',
  'Company:Create Duplicate name.': 'Duplicate name.',
  'Company:Create Invalid currency code.': 'Invalid currency code.',
  'Company:Create Test cannot be null.': 'Test cannot be null.',
  'Company:Create Address Line1 cannot be null or empty.': 'Address Line1 cannot be null or empty.',
  'Company:Create Address Town City cannot be null or empty.': 'Address Town City cannot be null or empty.',
  'Company:Create Address Country cannot be null or empty.': 'Address Country cannot be null or empty.',
  'Company:Create Address PostalCode cannot be null or empty.': 'Address PostalCode cannot be null or empty.',
  'Company:Create Name cannot be null or empty.': 'Name cannot be null or empty.',
  'Company:Create Currency cannot be null or empty.': 'Currency cannot be null or empty.',
  'Company:Create Invalid Email.': 'Invalid Email.',
  'Company:Update Duplicate oosId': 'Duplicate oosId',
  'Company:Update OosId cannot be null.': 'OosId cannot be null.',
  'Company:Update Duplicate name.': 'Duplicate name.',
  'Company:Update Invalid currency code.': 'Invalid currency code.',
  'Company:Update Test cannot be null.': 'Test cannot be null.',
  'Company:Update Failed to update company details.': 'Failed to update company details.',
  'Company:Update Name cannot be null or empty.': 'Name cannot be null or empty.',
  'Company:Update Currency cannot be null or empty.': 'Currency cannot be null or empty.',
  'Company:Update Invalid Email.': 'Invalid Email.',
  'Company:Get Company not found.': 'Company not found.',
  'Company:Activate Failed to update company status. Invalid company id': 'Failed to update company status. Invalid company id',
  'Request method \'POST\' not supported': 'Request method \'POST\' not supported',
  'Company:Deactivate Failed to update company status. Invalid company id': 'Failed to update company status. Invalid company id'
};

/***/ }),
/* 141 */
/***/ (function(module, exports) {

module.exports = {
  projectName: 'Application name',
  eng: 'English',
  de: 'German',
  error404: 'The page you are looking for does not exist!'
};

/***/ }),
/* 142 */
/***/ (function(module, exports) {

module.exports = {
  companies: '公司',
  catalogs: '目录',
  accounts: '账户',
  printers: '打印机',
  login: '登录',
  logout: '登出'
};

/***/ }),
/* 143 */
/***/ (function(module, exports) {

module.exports = {
  username: 'Username',
  password: 'Password',
  name: 'Name',
  currency: 'Currency',
  status: 'Status',
  modified: 'Modified on',
  created: 'Created on',
  actions: 'Actions',
  filter: 'Filter for company',
  catalogFilter: 'Filter for catalogs',
  active: 'Active',
  inactive: 'Inactive',
  phone: 'Phone',
  email: 'Email',
  externalID: 'External ID',
  testMode: 'Test mode',
  addressLine: 'Address line',
  locality: 'Locality',
  townCity: 'Town/City',
  country: 'Country',
  postalcode: 'Postalcode',
  createCompany: 'Create company',
  editCompany: 'Edit company'
};

/***/ }),
/* 144 */
/***/ (function(module, exports) {

module.exports = {
  createCompany: '创建公司',
  createCatalog: '创建目录',
  edit: '编辑',
  activate: '启用',
  deactivate: '关闭',
  cancel: '取消',
  create: '创建',
  update: '更新',
  submit: '提交'
};

/***/ }),
/* 145 */
/***/ (function(module, exports) {

module.exports = {
  missingRequired: 'You must enter a value for required feilds!',
  missingUsername: 'Please enter your username.',
  missingPassword: 'Please enter your password.',
  'Web:User Login userName cannot be null or empty': 'Username cannot be null or empty',
  'Web:User Login password cannot be null or empty': 'Password cannot be null or empty',
  'Error in fields': 'Error in fields',
  'Access Denied': 'Access Denied',
  'Company:Create Duplicate oosId.': 'Duplicate oosId.',
  'Company:Create OosId cannot be null.': 'OosId cannot be null.',
  'Company:Create Duplicate name.': 'Duplicate name.',
  'Company:Create Invalid currency code.': 'Invalid currency code.',
  'Company:Create Test cannot be null.': 'Test cannot be null.',
  'Company:Create Address Line1 cannot be null or empty.': 'Address Line1 cannot be null or empty.',
  'Company:Create Address Town City cannot be null or empty.': 'Address Town City cannot be null or empty.',
  'Company:Create Address Country cannot be null or empty.': 'Address Country cannot be null or empty.',
  'Company:Create Address PostalCode cannot be null or empty.': 'Address PostalCode cannot be null or empty.',
  'Company:Create Name cannot be null or empty.': 'Name cannot be null or empty.',
  'Company:Create Currency cannot be null or empty.': 'Currency cannot be null or empty.',
  'Company:Create Invalid Email.': 'Invalid Email.',
  'Company:Update Duplicate oosId': 'Duplicate oosId',
  'Company:Update OosId cannot be null.': 'OosId cannot be null.',
  'Company:Update Duplicate name.': 'Duplicate name.',
  'Company:Update Invalid currency code.': 'Invalid currency code.',
  'Company:Update Test cannot be null.': 'Test cannot be null.',
  'Company:Update Failed to update company details.': 'Failed to update company details.',
  'Company:Update Name cannot be null or empty.': 'Name cannot be null or empty.',
  'Company:Update Currency cannot be null or empty.': 'Currency cannot be null or empty.',
  'Company:Update Invalid Email.': 'Invalid Email.',
  'Company:Get Company not found.': 'Company not found.',
  'Company:Activate Failed to update company status. Invalid company id': 'Failed to update company status. Invalid company id',
  'Request method \'POST\' not supported': 'Request method \'POST\' not supported',
  'Company:Deactivate Failed to update company status. Invalid company id': 'Failed to update company status. Invalid company id'
};

/***/ }),
/* 146 */
/***/ (function(module, exports) {

module.exports = {
  projectName: 'Application name',
  eng: 'English',
  de: 'German',
  error404: 'The page you are looking for does not exist!'
};

/***/ }),
/* 147 */
/***/ (function(module, exports) {

module.exports = {
  companies: '公司',
  catalogs: '目录',
  accounts: '账户',
  printers: '打印机',
  login: '登录',
  logout: '登出'
};

/***/ }),
/* 148 */
/***/ (function(module, exports) {

module.exports = {
  username: 'Username',
  password: 'Password',
  name: 'Name',
  currency: 'Currency',
  status: 'Status',
  modified: 'Modified on',
  created: 'Created on',
  actions: 'Actions',
  filter: 'Filter for company',
  catalogFilter: 'Filter for catalogs',
  active: 'Active',
  inactive: 'Inactive',
  phone: 'Phone',
  email: 'Email',
  externalID: 'External ID',
  testMode: 'Test mode',
  addressLine: 'Address line',
  locality: 'Locality',
  townCity: 'Town/City',
  country: 'Country',
  postalcode: 'Postalcode',
  createCompany: 'Create company',
  editCompany: 'Edit company'
};

/***/ }),
/* 149 */
/***/ (function(module, exports) {

module.exports = {
  createCompany: '创建公司',
  createCatalog: '创建目录',
  edit: '编辑',
  activate: '启用',
  deactivate: '关闭',
  cancel: '取消',
  create: '创建',
  update: '更新',
  submit: '提交'
};

/***/ }),
/* 150 */
/***/ (function(module, exports) {

module.exports = {
  missingRequired: 'You must enter a value for required feilds!',
  missingUsername: 'Please enter your username.',
  missingPassword: 'Please enter your password.',
  'Web:User Login userName cannot be null or empty': 'Username cannot be null or empty',
  'Web:User Login password cannot be null or empty': 'Password cannot be null or empty',
  'Error in fields': 'Error in fields',
  'Access Denied': 'Access Denied',
  'Company:Create Duplicate oosId.': 'Duplicate oosId.',
  'Company:Create OosId cannot be null.': 'OosId cannot be null.',
  'Company:Create Duplicate name.': 'Duplicate name.',
  'Company:Create Invalid currency code.': 'Invalid currency code.',
  'Company:Create Test cannot be null.': 'Test cannot be null.',
  'Company:Create Address Line1 cannot be null or empty.': 'Address Line1 cannot be null or empty.',
  'Company:Create Address Town City cannot be null or empty.': 'Address Town City cannot be null or empty.',
  'Company:Create Address Country cannot be null or empty.': 'Address Country cannot be null or empty.',
  'Company:Create Address PostalCode cannot be null or empty.': 'Address PostalCode cannot be null or empty.',
  'Company:Create Name cannot be null or empty.': 'Name cannot be null or empty.',
  'Company:Create Currency cannot be null or empty.': 'Currency cannot be null or empty.',
  'Company:Create Invalid Email.': 'Invalid Email.',
  'Company:Update Duplicate oosId': 'Duplicate oosId',
  'Company:Update OosId cannot be null.': 'OosId cannot be null.',
  'Company:Update Duplicate name.': 'Duplicate name.',
  'Company:Update Invalid currency code.': 'Invalid currency code.',
  'Company:Update Test cannot be null.': 'Test cannot be null.',
  'Company:Update Failed to update company details.': 'Failed to update company details.',
  'Company:Update Name cannot be null or empty.': 'Name cannot be null or empty.',
  'Company:Update Currency cannot be null or empty.': 'Currency cannot be null or empty.',
  'Company:Update Invalid Email.': 'Invalid Email.',
  'Company:Get Company not found.': 'Company not found.',
  'Company:Activate Failed to update company status. Invalid company id': 'Failed to update company status. Invalid company id',
  'Request method \'POST\' not supported': 'Request method \'POST\' not supported',
  'Company:Deactivate Failed to update company status. Invalid company id': 'Failed to update company status. Invalid company id'
};

/***/ }),
/* 151 */
/***/ (function(module, exports) {

module.exports = {
  projectName: 'Application name',
  eng: 'English',
  de: 'German',
  error404: 'The page you are looking for does not exist!'
};

/***/ }),
/* 152 */
/***/ (function(module, exports) {

module.exports = {
  companies: '公司',
  catalogs: '目录',
  accounts: '账户',
  printers: '打印机',
  login: '登录',
  logout: '登出'
};

/***/ }),
/* 153 */
/***/ (function(module, exports) {

module.exports = {
  username: 'Username',
  password: 'Password',
  name: 'Name',
  currency: 'Currency',
  status: 'Status',
  modified: 'Modified on',
  created: 'Created on',
  actions: 'Actions',
  filter: 'Filter for company',
  catalogFilter: 'Filter for catalogs',
  active: 'Active',
  inactive: 'Inactive',
  phone: 'Phone',
  email: 'Email',
  externalID: 'External ID',
  testMode: 'Test mode',
  addressLine: 'Address line',
  locality: 'Locality',
  townCity: 'Town/City',
  country: 'Country',
  postalcode: 'Postalcode',
  createCompany: 'Create company',
  editCompany: 'Edit company'
};

/***/ }),
/* 154 */
/***/ (function(module, exports) {

module.exports = {
  createCompany: 'Şirket Oluştur',
  createCatalog: 'Katalog Oluştur',
  edit: 'Düzenle',
  activate: 'Etkinleştirmek',
  deactivate: 'Devre dışı bırakmak',
  cancel: 'iptal etmek',
  create: 'Yaratmak',
  update: 'Güncelleştirme',
  submit: 'Gönder'
};

/***/ }),
/* 155 */
/***/ (function(module, exports) {

module.exports = {
  missingRequired: 'You must enter a value for required feilds!',
  missingUsername: 'Please enter your username.',
  missingPassword: 'Please enter your password.',
  'Web:User Login userName cannot be null or empty': 'Username cannot be null or empty',
  'Web:User Login password cannot be null or empty': 'Password cannot be null or empty',
  'Error in fields': 'Error in fields',
  'Access Denied': 'Access Denied',
  'Company:Create Duplicate oosId.': 'Duplicate oosId.',
  'Company:Create OosId cannot be null.': 'OosId cannot be null.',
  'Company:Create Duplicate name.': 'Duplicate name.',
  'Company:Create Invalid currency code.': 'Invalid currency code.',
  'Company:Create Test cannot be null.': 'Test cannot be null.',
  'Company:Create Address Line1 cannot be null or empty.': 'Address Line1 cannot be null or empty.',
  'Company:Create Address Town City cannot be null or empty.': 'Address Town City cannot be null or empty.',
  'Company:Create Address Country cannot be null or empty.': 'Address Country cannot be null or empty.',
  'Company:Create Address PostalCode cannot be null or empty.': 'Address PostalCode cannot be null or empty.',
  'Company:Create Name cannot be null or empty.': 'Name cannot be null or empty.',
  'Company:Create Currency cannot be null or empty.': 'Currency cannot be null or empty.',
  'Company:Create Invalid Email.': 'Invalid Email.',
  'Company:Update Duplicate oosId': 'Duplicate oosId',
  'Company:Update OosId cannot be null.': 'OosId cannot be null.',
  'Company:Update Duplicate name.': 'Duplicate name.',
  'Company:Update Invalid currency code.': 'Invalid currency code.',
  'Company:Update Test cannot be null.': 'Test cannot be null.',
  'Company:Update Failed to update company details.': 'Failed to update company details.',
  'Company:Update Name cannot be null or empty.': 'Name cannot be null or empty.',
  'Company:Update Currency cannot be null or empty.': 'Currency cannot be null or empty.',
  'Company:Update Invalid Email.': 'Invalid Email.',
  'Company:Get Company not found.': 'Company not found.',
  'Company:Activate Failed to update company status. Invalid company id': 'Failed to update company status. Invalid company id',
  'Request method \'POST\' not supported': 'Request method \'POST\' not supported',
  'Company:Deactivate Failed to update company status. Invalid company id': 'Failed to update company status. Invalid company id'
};

/***/ }),
/* 156 */
/***/ (function(module, exports) {

module.exports = {
  projectName: 'Application name',
  eng: 'English',
  de: 'German',
  error404: 'The page you are looking for does not exist!'
};

/***/ }),
/* 157 */
/***/ (function(module, exports) {

module.exports = {
  companies: 'Şirketler',
  catalogs: 'Kataloglar',
  accounts: 'Hesaplar',
  printers: 'Yazıcılar',
  login: 'Oturum aç',
  logout: 'Çıkış Yap'
};

/***/ }),
/* 158 */
/***/ (function(module, exports) {

module.exports = {
  username: 'Username',
  password: 'Password',
  name: 'Name',
  currency: 'Currency',
  status: 'Status',
  modified: 'Modified on',
  created: 'Created on',
  actions: 'Actions',
  filter: 'Filter for company',
  catalogFilter: 'Filter for catalogs',
  active: 'Active',
  inactive: 'Inactive',
  phone: 'Phone',
  email: 'Email',
  externalID: 'External ID',
  testMode: 'Test mode',
  addressLine: 'Address line',
  locality: 'Locality',
  townCity: 'Town/City',
  country: 'Country',
  postalcode: 'Postalcode',
  createCompany: 'Create company',
  editCompany: 'Edit company'
};

/***/ }),
/* 159 */
/***/ (function(module, exports) {

module.exports = {
  createCompany: '创建公司',
  createCatalog: '创建目录',
  edit: '编辑',
  activate: '启用',
  deactivate: '关闭',
  cancel: '取消',
  create: '创建',
  update: '更新',
  submit: '提交'
};

/***/ }),
/* 160 */
/***/ (function(module, exports) {

module.exports = {
  missingRequired: 'You must enter a value for required feilds!',
  missingUsername: 'Please enter your username.',
  missingPassword: 'Please enter your password.',
  'Web:User Login userName cannot be null or empty': 'Username cannot be null or empty',
  'Web:User Login password cannot be null or empty': 'Password cannot be null or empty',
  'Error in fields': 'Error in fields',
  'Access Denied': 'Access Denied',
  'Company:Create Duplicate oosId.': 'Duplicate oosId.',
  'Company:Create OosId cannot be null.': 'OosId cannot be null.',
  'Company:Create Duplicate name.': 'Duplicate name.',
  'Company:Create Invalid currency code.': 'Invalid currency code.',
  'Company:Create Test cannot be null.': 'Test cannot be null.',
  'Company:Create Address Line1 cannot be null or empty.': 'Address Line1 cannot be null or empty.',
  'Company:Create Address Town City cannot be null or empty.': 'Address Town City cannot be null or empty.',
  'Company:Create Address Country cannot be null or empty.': 'Address Country cannot be null or empty.',
  'Company:Create Address PostalCode cannot be null or empty.': 'Address PostalCode cannot be null or empty.',
  'Company:Create Name cannot be null or empty.': 'Name cannot be null or empty.',
  'Company:Create Currency cannot be null or empty.': 'Currency cannot be null or empty.',
  'Company:Create Invalid Email.': 'Invalid Email.',
  'Company:Update Duplicate oosId': 'Duplicate oosId',
  'Company:Update OosId cannot be null.': 'OosId cannot be null.',
  'Company:Update Duplicate name.': 'Duplicate name.',
  'Company:Update Invalid currency code.': 'Invalid currency code.',
  'Company:Update Test cannot be null.': 'Test cannot be null.',
  'Company:Update Failed to update company details.': 'Failed to update company details.',
  'Company:Update Name cannot be null or empty.': 'Name cannot be null or empty.',
  'Company:Update Currency cannot be null or empty.': 'Currency cannot be null or empty.',
  'Company:Update Invalid Email.': 'Invalid Email.',
  'Company:Get Company not found.': 'Company not found.',
  'Company:Activate Failed to update company status. Invalid company id': 'Failed to update company status. Invalid company id',
  'Request method \'POST\' not supported': 'Request method \'POST\' not supported',
  'Company:Deactivate Failed to update company status. Invalid company id': 'Failed to update company status. Invalid company id'
};

/***/ }),
/* 161 */
/***/ (function(module, exports) {

module.exports = {
  projectName: 'Application name',
  eng: 'English',
  de: 'German',
  error404: 'The page you are looking for does not exist!'
};

/***/ }),
/* 162 */
/***/ (function(module, exports) {

module.exports = {
  companies: '公司',
  catalogs: '目录',
  accounts: '账户',
  printers: '打印机',
  login: '登录',
  logout: '登出'
};

/***/ }),
/* 163 */
/***/ (function(module, exports) {

module.exports = {
  username: 'Username',
  password: 'Password',
  name: 'Name',
  currency: 'Currency',
  status: 'Status',
  modified: 'Modified on',
  created: 'Created on',
  actions: 'Actions',
  filter: 'Filter for company',
  catalogFilter: 'Filter for catalogs',
  active: 'Active',
  inactive: 'Inactive',
  phone: 'Phone',
  email: 'Email',
  externalID: 'External ID',
  testMode: 'Test mode',
  addressLine: 'Address line',
  locality: 'Locality',
  townCity: 'Town/City',
  country: 'Country',
  postalcode: 'Postalcode',
  createCompany: 'Create company',
  editCompany: 'Edit company'
};

/***/ }),
/* 164 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuetify__ = __webpack_require__(74);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuetify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_vuetify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_datetime__ = __webpack_require__(69);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_datetime___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_vue_datetime__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_resource__ = __webpack_require__(72);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue_cookie__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue_cookie___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_vue_cookie__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vuejs_localization__ = __webpack_require__(73);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vue_clipboard2__ = __webpack_require__(68);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vue_clipboard2___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_vue_clipboard2__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__App__ = __webpack_require__(70);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__App___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__App__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__router__ = __webpack_require__(65);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_catalog_Item__ = __webpack_require__(71);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_catalog_Item___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__components_catalog_Item__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__auth__ = __webpack_require__(64);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_vue_datetime_dist_vue_datetime_css__ = __webpack_require__(66);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_vue_datetime_dist_vue_datetime_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_vue_datetime_dist_vue_datetime_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_vuetify_dist_vuetify_min_css__ = __webpack_require__(67);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_vuetify_dist_vuetify_min_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_vuetify_dist_vuetify_min_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_vuetify_es5_util_colors__ = __webpack_require__(75);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_vuetify_es5_util_colors___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13_vuetify_es5_util_colors__);
// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.













__WEBPACK_IMPORTED_MODULE_0_vue__["default"].config.productionTip = false;
//Date and Time Picker

__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_2_vue_datetime___default.a);
//Vuetify


__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_1_vuetify___default.a, {
  theme: {
    primary: __WEBPACK_IMPORTED_MODULE_13_vuetify_es5_util_colors___default.a.amber.darken1,
    secondary: __WEBPACK_IMPORTED_MODULE_13_vuetify_es5_util_colors___default.a.grey.darken3,
    accent: __WEBPACK_IMPORTED_MODULE_13_vuetify_es5_util_colors___default.a.amber.accent1,
    error: __WEBPACK_IMPORTED_MODULE_13_vuetify_es5_util_colors___default.a.deepOrange.darken1
  }
});

__WEBPACK_IMPORTED_MODULE_6_vue_clipboard2___default.a.config.autoSetContainer = true;
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_6_vue_clipboard2___default.a);

// Vue resource
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_3_vue_resource__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].http.options.root =  true ? '/sunbackend' : '/api/sunbackend';

// Vue cookie
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_4_vue_cookie___default.a);

// Vue localization
__WEBPACK_IMPORTED_MODULE_5_vuejs_localization__["a" /* default */].requireAll(__webpack_require__(76));
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_5_vuejs_localization__["a" /* default */]);

__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_10__auth__["a" /* default */]);
// Register global components
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].component('item', __WEBPACK_IMPORTED_MODULE_9__components_catalog_Item___default.a);

/* eslint-disable no-new */
new __WEBPACK_IMPORTED_MODULE_0_vue__["default"]({
  el: '#app',
  router: __WEBPACK_IMPORTED_MODULE_8__router__["a" /* default */],
  template: '<App/>',
  components: { App: __WEBPACK_IMPORTED_MODULE_7__App___default.a }
});

/***/ }),
/* 165 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'app',
  beforeCreate: function beforeCreate() {
    var lang = this.$route.path.split('/')[1];
    if (lang !== 'en' && lang !== 'de') {
      return;
    }
    this.$lang.setLang(lang);
    this.$cookie.set('lang', lang, { expires: '8h' });
  }
});

/***/ }),
/* 166 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'fixed-layout',
  data: function data() {
    return {
      companies: []
    };
  }
});

/***/ }),
/* 167 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_luxon__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_luxon___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_luxon__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = ({
  components: {
    subject: function subject() {
      return __webpack_require__.e/* import() */(29).then(__webpack_require__.bind(null, 473));
    }
  },
  data: function data() {
    return {
      err: '',
      radios: 'unread',
      headers: [{ text: 'subject', value: 'message', align: 'left' }, { text: this.$lang.labels.created, value: 'createdOn', align: 'left', sortable: true }, { text: this.$lang.labels.actions, value: 'actions', align: 'left', sortable: false }],
      loading: false,
      announcements: [],
      subjectData: {},
      showSubject: false,
      pagination: {
        sortBy: 'createdOn',
        descending: true
      }
    };
  },

  watch: {
    radios: {
      handler: function handler(newVal, oldVal) {
        if (newVal) {
          this.getData(newVal);
        }
      }
    }
  },
  created: function created() {
    this.getData('unread');
  },

  methods: {
    markAsRead: function markAsRead() {
      var _this = this;

      this.$http.post('announcement/markasread/' + this.subjectData.id, {}).then(function (res) {
        if (res.body.status === 'Success') {
          _this.subjectData.isRead = true;
          _this.getData(_this.radios);
        }
      }, function (err) {
        _this.err = err.body.statusText || err.body.message;
      });
    },
    formatDate: function formatDate(date) {
      return __WEBPACK_IMPORTED_MODULE_0_luxon__["DateTime"].fromISO(date).toFormat('yyyy-MM-dd HH:mm:ss');
    },
    updateData: function updateData() {
      this.showSubject = false;
      this.getData(this.radios);
    },
    showDetails: function showDetails(data) {
      this.subjectData = data;
      this.showSubject = true;
    },
    getData: function getData(type) {
      var _this2 = this;

      this.loading = true;
      this.$http.post('announcement/getall', { filter: type }).then(function (res) {
        if (res.body.status === 'Success') {
          _this2.announcements = res.body.announcements;
          _this2.subjectData = res.body.announcements[0];
          _this2.loading = false;
          return;
        }
        _this2.loading = false;
        _this2.err = res.body.statusText;
      }, function (err) {
        _this2.loading = false;
        _this2.err = err.body.statusText || err.body.message;
      });
    }
  }
});

/***/ }),
/* 168 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_luxon__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_luxon___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_luxon__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__router_role_map__ = __webpack_require__(48);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      drawer: false,
      search: '',
      menu: [{
        path: '/accounts',
        title: 'accounts'
      }, {
        path: '/app-resources',
        title: 'apps'
      }, {
        path: '/audit-log',
        title: 'auditLog'
      }, {
        path: '/auto-jobs',
        title: 'autoJobs'
      }, {
        path: '/caller-id-servers',
        title: 'callerId'
      }, {
        path: '/cash-register',
        title: 'cashRegister'
      }, {
        path: '/catalog',
        title: 'catalogs'
      }, {
        path: '/companies',
        title: 'companies'
      }, {
        path: '/config-updates',
        title: 'configUpdates'
      }, {
        path: '/corporations',
        title: 'corporations'
      }, {
        path: '/discount',
        title: 'discounts'
      }, {
        path: '/domain-dashboard',
        title: 'domains'
      }, {
        path: '/language-mappings',
        title: 'languageMappings'
      }, {
        path: '/licenses',
        title: 'licenses'
      }, {
        path: '/license-reports',
        title: 'licenseReports'
      }, {
        path: '/moon-instance-dashboard',
        title: 'moonInstances'
      }, {
        path: '/images',
        title: 'images'
      }, {
        path: '/invoices',
        title: 'pricingInvoices'
      }, {
        path: '/payment-terminals',
        title: 'paymentTerminals'
      }, {
        path: '/payment-servers',
        title: 'paymentServers'
      }, {
        path: '/printers',
        title: 'printers'
      }, {
        path: '/print-servers',
        title: 'printServers'
      }, {
        path: '/print-templates',
        title: 'printTemplates'
      }, {
        path: '/resource-tracking',
        title: 'resourceTracking'
      }, {
        path: '/tables',
        title: 'tables'
      }, {
        path: '/table-categories',
        title: 'tableCategories'
      }, {
        path: '/system-logs',
        title: 'systemlog'
      }, {
        path: '/web-shop-dashboard',
        title: 'webShops'
      }, {
        path: '/webshopusage-reports',
        title: 'webshopusageReports'
      }, {
        path: '/web-space-dashboard',
        title: 'webspace'
      }],
      openLang: false,
      language: this.$cookie.get('lang') || 'en'
    };
  },

  computed: {
    approvedLinks: function approvedLinks() {
      var _this = this;

      return this.menu.filter(function (route) {
        return !_this.shouldBlock(route.path.slice(1));
      });
    },
    filteredLinks: function filteredLinks() {
      var _this2 = this;

      return this.search.length === 0 ? this.approvedLinks : this.approvedLinks.filter(function (link) {
        return link.title.toLowerCase().includes(_this2.search.toLowerCase());
      });
    }
  },
  methods: {
    shouldBlock: function shouldBlock(route) {
      var roles = this.$auth.roles;
      var currentGuard = __WEBPACK_IMPORTED_MODULE_1__router_role_map__["a" /* default */].find(function (block) {
        return block.path === route;
      });
      if (!currentGuard) return false;
      var shouldBlock = true;
      currentGuard.roles.forEach(function (role) {
        if (roles.includes(role)) shouldBlock = false;
      });
      return shouldBlock;
    },

    // Set language and add to cookie, then change route
    changeLang: function changeLang(lang) {
      this.language = lang;
      this.$lang.setLang(lang);
      this.$cookie.set('lang', lang, { expires: '8h' });
      this.openLang = !this.openLang;
      this.$router.push({ name: this.$route.name, params: { lang: lang } });
      __WEBPACK_IMPORTED_MODULE_0_luxon__["Settings"].defaultLocale = lang;
    }
  }
});

/***/ }),
/* 169 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_cookie__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_cookie___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_vue_cookie__);


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      loginProcessStarted: false,
      formData: {
        userName: '',
        password: ''
      },
      err: '',
      fetchpaymentgatewaysDone: false,
      distanceunitsDone: false,
      timezonesDone: false,
      payments: ['cash', 'card', 'invoice', 'galaxycard', 'cheque', 'voucher', 'justeat', 'hungryhouse', 'website', 'deliveroo', 'ubereats', 'amazon', 'cardmanual'],
      languages: [],
      chargeTypes: [{ value: 'chargespermile', text: this.$lang.labels.chargesPerMile }, { value: 'nodeliverycharges', text: this.$lang.labels.noCharge }, { value: 'chargesbymiles', text: this.$lang.labels.chargeByMile }, { value: 'chargesbyinvoiceamount', text: this.$lang.labels.chargeByInvoice }],
      serviceTypes: [{ value: 'noservicecharge', text: this.$lang.labels.noService }, { value: 'percoftotal', text: this.$lang.labels.percOfTotal }],
      version: null
    };
  },

  methods: {
    submit: function submit() {
      var _this = this;

      this.loginProcessStarted = true;
      this.err = '';
      // Check if Username/Password are empty
      if (this.formData.userName.length === 0) {
        this.err = this.$lang.errors.missingUsername;
        return;
      }
      if (this.formData.password.length === 0) {
        this.err = this.$lang.errors.missingPassword;
        return;
      }
      // Authenticate user
      this.$auth.login(this.formData).then(function (err) {
        if (err) {
          _this.err = err;
          _this.loginProcessStarted = false;
          return;
        }
        localStorage.removeItem("copyItemData");
        localStorage.removeItem("configUpdates");
        _this.$http.get('system/webshop/fetchpaymentgateways').then(function (res) {
          _this.fetchpaymentgatewaysDone = true;
          localStorage.setItem('paymentGateways', __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default()(res.body.paymentGateways));
          localStorage.setItem('payments', __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default()(_this.payments));
          localStorage.setItem('chargeTypes', __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default()(_this.chargeTypes));
          localStorage.setItem('serviceTypes', __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default()(_this.serviceTypes));
          if (_this.fetchpaymentgatewaysDone && _this.distanceunitsDone && _this.timezonesDone) {
            _this.loginProcessStarted = false;
            _this.$router.push({ name: 'home' });
          }
        }).catch(function (err) {
          console.log(err);
          _this.$auth.logout();
        });
        _this.$http.get('system/languages').then(function (res) {
          var languages = res.body.languages;
          for (var lang in languages) {
            _this.languages.push({
              text: _this.$lang.labels[languages[lang]] || languages[lang],
              value: languages[lang]
            });
          }
          localStorage.setItem('languages', __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default()(_this.languages));
        }).catch(function (err) {
          console.log(err);
          _this.$auth.logout();
          _this.loginProcessStarted = false;
        });
        _this.$http.get('system/vatrates').then(function (res) {
          var at = res.body.at.map(function (vat) {
            return Number(vat);
          });
          var uk = res.body.uk.map(function (vat) {
            return Number(vat);
          });
          var allowedVatRates = {
            at: at,
            uk: uk
          };
          localStorage.setItem('allowedVatRates', __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default()(allowedVatRates));
        }).catch(function (err) {
          console.log(err);
          _this.$auth.logout();
          _this.loginProcessStarted = false;
        });
        _this.$http.get('system/distanceunits').then(function (res) {
          _this.distanceunitsDone = true;
          localStorage.setItem('distanceunits', __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default()(res.body.distanceUnits));
          if (_this.fetchpaymentgatewaysDone && _this.distanceunitsDone && _this.timezonesDone) {
            _this.loginProcessStarted = false;
            _this.$router.push({ name: 'home' });
          }
        }).catch(function (err) {
          console.log(err);
          _this.$auth.logout();
          _this.loginProcessStarted = false;
        });
        _this.$http.get('system/timezones').then(function (res) {
          _this.timezonesDone = true;
          localStorage.setItem('timezones', __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default()(res.body.timezones));
          if (_this.fetchpaymentgatewaysDone && _this.distanceunitsDone && _this.timezonesDone) {
            _this.loginProcessStarted = false;
            _this.$router.push({ name: 'home' });
          }
        }).catch(function (err) {
          console.log(err);
          _this.$auth.logout();
          _this.loginProcessStarted = false;
        });
      });
    },
    init: function init() {
      var _this2 = this;

      return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve) {
        __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.all([_this2.$http.get('system/fetchversion').then(function (res) {
          if (res.body.status === 'Success') {
            return res.body.version;
          }
          _this2.err = res.body.statusText;
        }, function (err) {
          _this2.companyLoading = false;
          _this2.err = err.body.statusText || err.body.message;
        }), _this2.$http.get('/static/version.txt').then(function (res) {
          if (res) {
            return Number(res.body);
          }
          _this2.err = 'No FE version found!';
        }, function () {
          _this2.err = 'No FE version found!';
        })]).then(function (res) {
          return resolve({ be: res[0], fe: res[1] });
        });
      });
    }
  },
  created: function created() {
    var _this3 = this;

    this.$auth.logout();
    this.init().then(function (res) {
      _this3.version = res;
    });
  }
});

/***/ }),
/* 170 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue_cookie__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue_cookie___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_vue_cookie__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_luxon__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_luxon___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_luxon__);




//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["default"] = ({
  components: {
    addressModal: function addressModal() {
      return __webpack_require__.e/* import() */(7/* duplicate */).then(__webpack_require__.bind(null, 77));
    }
  },
  data: function data() {
    var _this = this;

    return {
      show: false,
      valid1: false,
      valid2: false,
      valid3: false,
      addressSet: false,
      confirmEmail: '',
      addressDialog: false,
      timeRule: [function (v) {
        return (/^([01]\d|2[0-3]):?([0-5]\d)$/.test(v) || _this.$lang.errors.validTime
        );
      }],
      emailRules: [function (v) {
        return (/^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,3})+$/.test(v) || _this.$lang.errors.validEmail
        );
      }],
      days: [{ text: this.$lang.labels.sunday, value: 'SUNDAY' }, { text: this.$lang.labels.monday, value: 'MONDAY' }, { text: this.$lang.labels.tuesday, value: 'TUESDAY' }, { text: this.$lang.labels.wednesday, value: 'WEDNESDAY' }, { text: this.$lang.labels.thursday, value: 'THURSDAY' }, { text: this.$lang.labels.friday, value: 'FRIDAY' }, { text: this.$lang.labels.saturday, value: 'SATURDAY' }, { text: this.$lang.labels.publicHoliday, value: 'PUBLICHOLIDAY' }],
      openingTimes: [],
      tempOpening: {
        day: '',
        start: '',
        end: ''
      },
      editingHours: false,
      validHours: false,

      vatRates: [],
      tempVat: {
        vat: ''
      },
      editingVat: false,
      valid: false,
      isEdit: false,
      align: 'left',
      allowedVatRates: {},
      company: {
        name: '',
        email: '',
        phone: '',
        currency: '',
        paymentTypes: [],
        tipTaxRate: null,
        defaultLanguage: '',
        cuisines: [],
        deliveryChargesTaxRate: null,
        dailyOrdersCounterEnabled: false,
        address: {
          line1: '',
          line2: '',
          line3: '',
          line4: '',
          locality: '',
          townCity: '',
          country: '',
          postalCode: '',
          latitude: '',
          longitude: ''
        },
        registrationNumber: '',
        registrationLocation: '',
        timezone: '',
        distanceUnit: ''
      },
      err: '',
      success: '',
      language: this.$cookie.get('lang') || 'en',
      cuisines: [],
      snackbar: false,
      timeout: 0,
      noTax: true,
      noTipTax: true,
      noDeliveryTax: true,
      noServiceTax: true,
      countries: ['AT', 'UK'],
      e1: 1,
      account: {
        name: null,
        email: '',
        userName: null,
        maxDiscountPercentage: null,
        notes: null
      },
      payments: ['cash', 'card', 'invoice', 'galaxycard', 'cheque', 'voucher', 'justeat', 'hungryhouse', 'website', 'deliveroo', 'ubereats', 'amazon', 'cardmanual'],
      languages: []
    };
  },

  watch: {
    'company.address.country': {
      handler: function handler(val) {
        if (val && val === 'AT') {
          this.company.currency = 'EUR';
          this.company.align = 'right';
          this.company.distanceUnit = 'meters';
          this.company.timezone = 'Europe/Vienna';
          this.company.defaultLanguage = 'de';
        }
        if (val && val === 'UK') {
          this.company.currency = 'GBP';
          this.company.align = 'left';
          this.company.distanceUnit = 'miles';
          this.company.timezone = 'Europe/London';
          this.company.defaultLanguage = 'en';
        }
      },

      deep: true
    }
  },
  computed: {
    chargeTypesFormatted: function chargeTypesFormatted() {
      var _this2 = this;

      return this.chargeTypes.map(function (row) {
        var type = row;
        if (_this2.company.distanceUnit === 'meters') {
          type.text = type.text.replace('Miles', 'Meters');
          type.text = type.text.replace('Mile', 'Meter');
        }
        return type;
      });
    },
    openingValidation: function openingValidation() {
      var isStartValid = this.validateTime(this.tempOpening.start);
      var isEndValid = this.validateTime(this.tempOpening.end);
      if (this.tempOpening.end === '0000') {
        return isEndValid = false;
      }
      return !!this.tempOpening.day && isStartValid && isEndValid;
    },
    mappedGroups: function mappedGroups() {
      return this.allPricingGroups.map(function (group) {
        return {
          text: group.name,
          value: group.id
        };
      });
    }
  },
  methods: {
    generateAddress: function generateAddress(lines) {
      return lines.filter(function (line) {
        return !!line;
      }).join(', ');
    },
    submitAddress: function submitAddress(address) {
      this.company.address = {
        line1: address.line1.trim(),
        line2: address.line2.trim(),
        line3: address.line3.trim(),
        line4: address.line4.trim(),
        locality: address.locality.trim(),
        townCity: address.townCity.trim(),
        country: address.country.trim(),
        postalCode: address.postalCode.trim().toUpperCase(),
        latitude: address.latitude.trim(),
        longitude: address.longitude.trim()
      };
      this.addressDialog = false;
      this.addressSet = true;
    },
    moveUp: function moveUp(arr, id) {
      var y = id--;
      var origin = arr[id];
      arr.splice(id, 1, arr[y]);
      this.$set(arr, y, origin);
    },
    moveDown: function moveDown(arr, id) {
      var y = id++;
      var origin = arr[id];
      arr.splice(id, 1, arr[y]);
      this.$set(arr, y, origin);
    },
    fetchPricingGroups: function fetchPricingGroups(currency) {
      var _this3 = this;

      this.$http.post('pricinggroup/getall', { currency: currency }).then(function (res) {
        if (res.body.status === 'Success') {
          _this3.allPricingGroups = res.body.pricingGroups;
          return;
        }
        _this3.err = res.body.statusText;
      }, function (err) {
        _this3.err = err.body.statusText || err.body.message;
      });
    },
    formatDate: function formatDate(date) {
      return __WEBPACK_IMPORTED_MODULE_5_luxon__["DateTime"].fromISO(date).toFormat('yyyy-MM-dd HH:mm:ss');
    },
    validateTime: function validateTime(time) {
      if (!time) return false;
      var valid = true;
      if (parseInt(time[0], 10) > 2 || parseInt(time[0], 10) === 2 && parseInt(time[1], 10) > 3 || parseInt(time[2], 10) > 5 || !time[3]) valid = false;
      if (time.length !== 4) valid = false;
      return valid;
    },

    //Opening Hours
    addHours: function addHours() {
      this.openingTimes.push({
        day: '',
        start: '',
        end: '',
        isEdit: true
      });
      this.editingHours = true;
      this.$forceUpdate();
    },
    copyOpening: function copyOpening(time) {

      if (this.editingHours) {
        this.$set(time, 'day', this.tempOpening.day);
        this.$set(time, 'start', this.formatTime(this.tempOpening.start));
        this.$set(time, 'end', this.formatTime(this.tempOpening.end));
        this.$set(time, 'isEdit', false);
      }
      this.openingTimes.push({
        day: '',
        start: '',
        end: '',
        isEdit: true
      });
      this.tempOpening = {
        day: time.day,
        start: this.formatTimeEdit(time.start),
        end: this.formatTimeEdit(time.end)
      };
      this.editingHours = true;
    },
    editOpening: function editOpening(time) {
      this.tempOpening = {
        day: time.day,
        start: this.formatTimeEdit(time.start),
        end: this.formatTimeEdit(time.end)
      };
      this.$set(time, 'isEdit', true);
      this.editingHours = true;
    },
    deleteOpening: function deleteOpening(index) {
      this.openingTimes.splice(index, 1);
      this.$forceUpdate();
    },
    formatTime: function formatTime(time) {
      var save = time.toString().replace(':', '');
      return save.slice(0, 2) + ':' + save.slice(2);
    },
    formatTimeEdit: function formatTimeEdit(time) {
      return time.replace(':', '');
    },
    saveOpening: function saveOpening(time) {
      this.$set(time, 'day', this.tempOpening.day);
      this.$set(time, 'start', this.formatTime(this.tempOpening.start));
      this.$set(time, 'end', this.formatTime(this.tempOpening.end));
      this.closeOpening(time);
    },
    closeOpening: function closeOpening(time) {
      this.tempOpening = {
        day: '',
        start: '',
        end: ''
      };
      this.$set(time, 'isEdit', false);
      this.editingHours = false;
    },


    //Vat
    addVat: function addVat() {
      this.vatRates.push({
        vat: '',
        isEdit: true
      });
      this.editingVat = true;
      this.$forceUpdate();
    },
    editVat: function editVat(vat) {
      this.tempVat = {
        vat: vat.vat
      };
      this.$set(vat, 'isEdit', true);
      this.editingVat = true;
    },
    deleteVat: function deleteVat(index) {
      this.vatRates.splice(index, 1);
      this.$forceUpdate();
    },
    saveVatEdit: function saveVatEdit(vat) {
      this.$set(vat, 'vat', this.tempVat.vat);
      this.closeVatEdit(vat);
    },
    closeVatEdit: function closeVatEdit(vat) {
      this.tempVat = {
        vat: ''
      };
      this.$set(vat, 'isEdit', false);
      this.editingVat = false;
    },


    //Charge by Miles
    addMiles: function addMiles() {
      this.miles.push({
        fromMiles: '',
        toMiles: '',
        charges: '',
        isEdit: true
      });
      this.editingMiles = true;
      this.$forceUpdate();
    },
    editMiles: function editMiles(charge) {
      this.tempMiles = {
        fromMiles: charge.fromMiles,
        toMiles: charge.toMiles,
        charges: charge.charges
      };
      this.$set(charge, 'isEdit', true);
      this.editingMiles = true;
    },
    deleteMiles: function deleteMiles(index) {
      this.miles.splice(index, 1);
      this.$forceUpdate();
    },
    saveMilesEdit: function saveMilesEdit(charge) {
      this.$set(charge, 'fromMiles', this.tempMiles.fromMiles);
      this.$set(charge, 'toMiles', this.tempMiles.toMiles);
      this.$set(charge, 'charges', this.tempMiles.charges);
      this.closeMilesEdit(charge);
    },
    closeMilesEdit: function closeMilesEdit(charge) {
      this.tempMiles = {
        fromMiles: '',
        toMiles: '',
        charges: ''
      };
      this.$set(charge, 'isEdit', false);
      this.editingMiles = false;
    },


    //Charge by Amount
    addAmount: function addAmount() {
      this.amounts.push({
        fromAmount: '',
        toAmount: '',
        charges: '',
        isEdit: true
      });
      this.editingAmount = true;
      this.$forceUpdate();
    },
    editAmount: function editAmount(amount) {
      this.tempAmount = {
        fromAmount: amount.fromAmount,
        toAmount: amount.toAmount,
        charges: amount.charges
      };
      this.$set(amount, 'isEdit', true);
      this.editingAmount = true;
    },
    deleteAmount: function deleteAmount(index) {
      this.amounts.splice(index, 1);
      this.$forceUpdate();
    },
    saveAmountEdit: function saveAmountEdit(amount) {
      this.$set(amount, 'fromAmount', this.tempAmount.fromAmount);
      this.$set(amount, 'toAmount', this.tempAmount.toAmount);
      this.$set(amount, 'charges', this.tempAmount.charges);
      this.closeAmountEdit(amount);
    },
    closeAmountEdit: function closeAmountEdit(amount) {
      this.tempAmount = {
        fromAmount: '',
        toAmount: '',
        charges: ''
      };
      this.$set(amount, 'isEdit', false);
      this.editingAmount = false;
    },
    submit: function submit() {
      var _this4 = this;

      var company = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends___default()({}, this.company);
      if (this.openingTimes.length > 0) {
        var openingDaysAndHours = this.openingTimes.map(function (time) {
          return {
            day: time.day,
            start: time.start,
            end: time.end
          };
        });
        __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign___default()(company, { openingDaysAndHours: openingDaysAndHours });
      }
      if (!this.noTax && this.vatRates.length > 0) {
        __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign___default()(company, { vatRates: this.vatRates.map(function (rate) {
            return rate.vat;
          }) });
      } else {
        __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign___default()(company, { vatRates: null });
      }
      if (company.vatRates !== null) {
        company.vatRates = company.vatRates.map(function (vat) {
          return Number(vat);
        });
      }
      if (company.address.country === 'AT') {
        if (company.vatRates === null) {
          this.err = this.$lang.errors.noVatRates;
          return;
        } else {
          var arr = company.vatRates.filter(function (rate) {
            return !_this4.allowedVatRates.at.includes(Number(rate));
          });
          if (company.address.country === 'AT' && arr.length > 0) {
            this.err = this.$lang.errors.wrongVAT + ': ' + this.allowedVatRates.at;
            return;
          }
        }
      }
      if (company.address.country === 'UK') {
        var _arr = company.vatRates !== null ? company.vatRates.filter(function (rate) {
          return !_this4.allowedVatRates.uk.includes(Number(rate));
        }) : [];
        if (_arr.length > 0) {
          this.err = this.$lang.errors.wrongVatUK + ': ' + this.allowedVatRates.uk;
          return;
        }
      }
      company.address.postalCode = company.address.postalCode.trim().toUpperCase();
      this.company.address.postalCode = company.address.postalCode;

      var url = 'company/selfregister';

      var obj = {
        company: company,
        account: this.account
      };

      obj.company.parentCompanyId = '5d94a1d98a271ccda4fa5317';

      console.log(obj);

      this.$http.post(url, obj).then(function (res) {
        if (res.body.status === 'Success') {
          _this4.success = 'Company and User created successfully';
          console.log(res);
          setTimeout(function () {
            if (_this4.isEdit) {
              _this4.success = '';
            }
          }, 3000);
          return;
        }
        _this4.err = res.body.statusText;
      }, function (err) {
        _this4.err = err.body.statusText || err.body.message;
      });
    },
    init: function init() {
      var _this5 = this;

      return new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve) {
        __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a.all([_this5.$http.get('system/vatrates').then(function (res) {
          var at = res.body.at.map(function (vat) {
            return Number(vat);
          });
          var uk = res.body.uk.map(function (vat) {
            return Number(vat);
          });
          var allowedVatRates = {
            at: at,
            uk: uk
          };
          _this5.allowedVatRates = {
            at: at,
            uk: uk
          };
          localStorage.setItem('allowedVatRates', __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(allowedVatRates));
          return resolve();
        }).catch(function (err) {
          console.log(err);
          return resolve();
        }), _this5.$http.get('system/cuisines').then(function (res) {
          if (res.body.status === 'Success') {
            _this5.cuisines = res.body.cuisines.sort();
            return resolve();
          }
          return resolve();
        }).catch(function (err) {
          console.log(err);
          return resolve();
        })]);
      });
    }
  },
  beforeDestroy: function beforeDestroy() {
    __WEBPACK_IMPORTED_MODULE_4_vue_cookie___default.a.delete('uuid');
  },
  mounted: function mounted() {
    __WEBPACK_IMPORTED_MODULE_4_vue_cookie___default.a.set('uuid', '', { expires: '72h' });
  },
  created: function created() {
    var _this6 = this;

    __WEBPACK_IMPORTED_MODULE_4_vue_cookie___default.a.set('uuid', '', { expires: '72h' });
    this.init().then(function () {
      _this6.show = true;
    });
  }
});

/***/ }),
/* 171 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_luxon__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_luxon___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_luxon__);


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      err: '',
      success: '',
      timeout: 0,
      passSnackbar: false,
      impactSnackbar: false,
      valid: false,
      isEdit: false,
      companies: [],
      printers: [],
      roles: [], /* all roles fetched by comapny ID */
      companyLoading: true,
      printersLoading: false,
      rolesLoading: true,
      isPrinterActive: false,
      account: {
        companyId: null,
        name: null,
        email: '',
        userName: null,
        defaultPrinter: null,
        maxDiscountPercentage: null,
        notes: '',
        apiKey: '',
        nfcToken: ''
      },
      selectedRoles: [],
      lastLoggedInOn: null,
      createdOn: '',
      modifiedOn: '',
      password: null,
      isLocalAdmin: false
    };
  },
  watch: {
    'account.companyId': function accountCompanyId(val) {
      this.fetchPrinters(val);
      /* fetch roles when user select company */
      this.fetchRoles(val);
    },
    'account.defaultPrinter': function accountDefaultPrinter(val) {
      var printer = this.printers.find(function (printer) {
        return printer.id === val;
      });
      if (!printer) {
        this.isPrinterActive = false;
        return;
      }
      this.isPrinterActive = printer.printerStatus === 'acitve';
    },
    err: function err(val) {
      var _this = this;

      if (val !== '') {
        setTimeout(function () {
          _this.err = '';
        }, 5000);
      }
    },
    success: function success(val) {
      var _this2 = this;

      if (val !== '') {
        setTimeout(function () {
          _this2.success = '';
        }, 5000);
      }
    }
  },
  computed: {
    mappedPrinters: function mappedPrinters() {
      return this.printers.map(function (printer) {
        return {
          text: printer.name + ' (' + printer.printerStatus + ')',
          value: printer.id
        };
      });
    },

    /* this are :items from select role field
    all roles that are fatched by company ID get sorted alphabetically */
    sortedRoles: function sortedRoles() {
      return this.roles = this.roles.sort();
    }
  },
  methods: {
    manageRoles: function manageRoles(type) {
      this.selectedRoles = [];
      var userRoles = ['ROLE_MOON_DRAWER_HANDLER', 'ROLE_MOON_ORDER_CREATOR', 'ROLE_MOON_REPORTS_CREATOR', 'ROLE_MOON_INVOICE_REPRINT', 'ROLE_MOON_CONTACT_CREATOR'];
      var adminRoles = ['ROLE_MOON_CONTACT_CREATOR', 'ROLE_MOON_CONTACT_DELETE', 'ROLE_MOON_DRAWER_HANDLER', 'ROLE_MOON_EXPORT_ADMIN', 'ROLE_MOON_INVOICE_CANCEL', 'ROLE_MOON_INVOICE_REPRINT', 'ROLE_MOON_ORDER_CREATOR', 'ROLE_MOON_REPORTS_CREATOR', 'ROLE_SUN_LOCAL_ADMIN', 'ROLE_MOON_PAYMENT_ADMIN', 'ROLE_MOON_PAYMENT_APPROVED'];
      if (type === 'user') this.selectedRoles = [].concat(userRoles);
      if (type === 'admin') this.selectedRoles = [].concat(adminRoles);
    },
    checkMaxDiscountPercentage: function checkMaxDiscountPercentage(v) {
      return !(Number(v) < 0 || v === null || v === '' || v === undefined);
    },
    formatDate: function formatDate(date) {
      return __WEBPACK_IMPORTED_MODULE_2_luxon__["DateTime"].fromISO(date).toFormat('yyyy-MM-dd HH:mm:ss');
    },
    init: function init() {
      var _this3 = this;

      return new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve) {
        _this3.$http.get('company').then(function (res) {
          resolve();
          _this3.companyLoading = false;
          if (res.body.status === 'Success') {
            _this3.companies = res.body.companies;
            return;
          }
          _this3.err = res.body.statusText;
        }, function (err) {
          resolve();
          _this3.companyLoading = false;
          _this3.err = err.body.statusText || err.body.message;
        });
      });
    },

    /* fetch roles by company ID */
    fetchRoles: function fetchRoles(id) {
      var _this4 = this;

      if (id === null) {
        this.rolesLoading = false;
        return;
      }
      this.rolesLoading = true;
      this.$http.post('account/fetchroles', { companyId: id }).then(function (res) {
        if (res.body.status === 'Success') {
          _this4.rolesLoading = false;
          _this4.roles = res.body.roles;
          if (_this4.roles.length === 0) {
            _this4.rolesLoading = false;
          }
          return;
        }
        _this4.err = res.body.statusText;
      }, function (err) {
        _this4.rolesLoading = false;
        _this4.err = err.body.statusText || err.body.message;
      });
    },
    fetchPrinters: function fetchPrinters(id) {
      var _this5 = this;

      this.printersLoading = true;
      this.printers = [];
      this.$http.get('printer/fetchallforcompany/' + id).then(function (res) {
        _this5.printersLoading = false;
        if (res.body.status === 'Success') {
          _this5.printers = res.body.printers;
          return;
        }
        _this5.err = res.body.statusText;
      }, function (err) {
        _this5.printersLoading = false;
        _this5.err = err.body.statusText || err.body.message;
      });
    },
    resetPassword: function resetPassword() {
      var _this6 = this;

      this.$http.post('account/resetpassword/' + this.$route.params.id, {}).then(function (res) {
        if (res.body.status === 'Success') {
          _this6.passSnackbar = true;
          _this6.password = res.body.newPassword;
          return;
        }
        _this6.err = res.body.statusText;
      }, function (err) {
        _this6.err = err.body.statusText || err.body.message;
      });
    },
    submit: function submit() {
      var _this7 = this;

      this.accountUpdate().then(function (res) {
        return res ? _this7.rolesUpdate() : null;
      });
    },
    rolesUpdate: function rolesUpdate() {
      var _this8 = this;

      return new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve) {
        var roles = {
          add: [],
          delete: []
        };
        _this8.account.roles.forEach(function (role) {
          if (!_this8.selectedRoles.includes(role)) {
            roles.delete.push(role);
          }
        });
        _this8.selectedRoles.forEach(function (role) {
          if (!_this8.account.roles.includes(role)) {
            roles.add.push(role);
          }
        });
        if (roles.add.length === 0 && roles.delete.length === 0) {
          resolve(true);
          return;
        }
        _this8.$http.post('account/manageroles/' + _this8.$route.params.id, { roles: roles }).then(function (res) {
          if (res.body.status === 'Success') {
            _this8.account.roles = _this8.selectedRoles;
            var currentUser = localStorage.currentUser ? JSON.parse(localStorage.currentUser) : null;
            if (currentUser.name === _this8.account.name) _this8.$auth.rolesCookieUpdate(_this8.selectedRoles);
            resolve(true);
            return;
          }
          _this8.err = res.body.statusText;
          resolve(false);
        }).catch(function (err) {
          _this8.err = err.body.statusText || err.body.message;
          resolve(false);
        });
      });
    },
    accountUpdate: function accountUpdate() {
      var _this9 = this;

      return new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve) {
        var url = _this9.isEdit ? 'account/update/' + _this9.$route.params.id : 'account/create';
        var accountData = _this9.account;
        if (!_this9.isEdit) {
          __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()(accountData, { roles: _this9.selectedRoles });
        }
        _this9.$http.post(url, accountData).then(function (res) {
          if (res.body.status === 'Success') {
            if (res.body.password) {
              _this9.password = res.body.password;
            }
            if (_this9.passSnackbar === false) {
              _this9.passSnackbar = _this9.isEdit ? false : true;
            }
            var roles = JSON.parse(_this9.$cookie.get('roles') || '[]');
            if (roles.includes('ROLE_SUN_LOCAL_ADMIN')) {
              _this9.impactSnackbar = true;
            }
            _this9.success = _this9.isEdit ? 'Account updated successfuly' : 'Account created successfuly';
            resolve(true);
            return;
          }
          resolve(false);
          _this9.err = res.body.statusText;
        }, function (err) {
          resolve(false);
          _this9.err = err.body.statusText || err.body.message;
        });
      });
    }
  },
  created: function created() {
    var _this10 = this;

    this.init().then(function () {
      var roles = JSON.parse(_this10.$cookie.get('roles') || '[]');
      _this10.isLocalAdmin = roles.includes('ROLE_SUN_LOCAL_ADMIN');
      if (_this10.isLocalAdmin) {
        if (_this10.companies.length === 1) _this10.account.companyId = _this10.companies[0].id;
      }
      if (_this10.$route.params.id) {
        _this10.isEdit = true;
        _this10.$http.get('account/' + _this10.$route.params.id).then(function (res) {
          if (res.body.status === 'Success') {
            _this10.account = res.body.account;
            _this10.selectedRoles = _this10.account.roles.slice();
            _this10.createdOn = _this10.formatDate(_this10.account.createdOn);
            if (_this10.account.modifiedOn) {
              _this10.modifiedOn = _this10.formatDate(_this10.account.modifiedOn);
            }
            if (_this10.account.lastLoggedInOn) {
              _this10.lastLoggedInOn = _this10.formatDate(_this10.account.lastLoggedInOn);
            }
            if (_this10.isLocalAdmin) {
              if (_this10.companies.length === 1) _this10.account.companyId = _this10.companies[0].id;
            }
            return;
          }
          _this10.err = res.body.statusText;
        }, function (err) {
          _this10.err = err.body.statusText || err.body.message;
        });
      }
    });
  }
});

/***/ }),
/* 172 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      showActive: true,
      err: '',
      search: '',
      headers: [{ text: this.$lang.labels.name, value: 'name', align: 'left' }, { text: this.$lang.labels.username, value: 'userName', align: 'left' }, { text: this.$lang.labels.company, value: 'companyName', align: 'left' }, { text: this.$lang.labels.status, value: 'accountStatus', align: 'left' }, { text: this.$lang.labels.actions, value: 'actions', align: 'left', sortable: false }],
      allAccounts: []
    };
  },

  methods: {
    changeStatus: function changeStatus(account) {
      var _this = this;

      var action = account.accountStatus === 'active' ? 'deactivate' : 'activate';
      this.$http.post('account/' + action + '/' + account.id).then(function (res) {
        if (res.body.status === 'Success') {
          _this.$set(account, 'accountStatus', action === 'activate' ? 'active' : 'inactive');
          return;
        }
        _this.err = res.body.statusText;
      }, function (err) {
        _this.err = err.body.statusText || err.body.message;
      });
    }
  },
  watch: {
    err: function err(val) {
      var _this2 = this;

      if (val !== '') {
        setTimeout(function () {
          _this2.err = '';
        }, 5000);
      }
    }
  },
  computed: {
    activeAccounts: function activeAccounts() {
      var accounts = this.allAccounts;
      var activeAccounts = [];
      for (var i = 0; accounts.length > i; i++) {
        if (accounts[i].accountStatus === 'active') {
          activeAccounts.push(accounts[i]);
        }
      }
      return activeAccounts;
    }
  },
  created: function created() {
    var _this3 = this;

    this.$http.get('account').then(function (res) {
      if (res.body.status === 'Success') {
        _this3.allAccounts = res.body.accounts;
        return;
      }
      _this3.err = res.body.statusText;
    }, function (err) {
      _this3.err = err.body.statusText || err.body.message;
    });
  }
});

/***/ }),
/* 173 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_luxon__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_luxon___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_luxon__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__assets_fetch_data__ = __webpack_require__(9);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      err: '',
      search: '',
      show: false,
      loading: true,
      language: this.$cookie.get('lang') || 'en',
      companies: [],
      selectedCompany: '',
      companyLoading: true,
      headers: [{ text: this.$lang.labels.name, value: 'name', align: 'left' }, { text: this.$lang.labels.type, value: 'type', align: 'left' }, { text: this.$lang.labels.status, value: 'status', align: 'left' }, { text: this.$lang.labels.created, value: 'createdOn', align: 'left' }, { text: this.$lang.labels.actions, value: 'actions', align: 'left', sortable: false }],
      showActive: true,
      allAppResources: []
    };
  },

  watch: {
    err: function err(val) {
      var _this = this;

      if (val !== '') {
        setTimeout(function () {
          _this.err = '';
        }, 5000);
      }
    },
    selectedCompany: function selectedCompany(val) {
      this.fetchAppResourcesForCompany(val);
      this.$cookie.set('companyedit', val, { expires: '8h' });
    }
  },
  computed: {
    activeAppResources: function activeAppResources() {
      var appResources = this.allAppResources;
      var activeAppResources = [];
      for (var i = 0; appResources.length > i; i++) {
        if (appResources[i].status === 'active') {
          activeAppResources.push(appResources[i]);
        }
      }
      return activeAppResources;
    },
    mappedCompanies: function mappedCompanies() {
      return this.companies.map(function (company) {
        return {
          text: company.name + ' (' + company.companyStatus + ')',
          value: company.id
        };
      });
    }
  },
  methods: {
    formatDate: function formatDate(date) {
      return __WEBPACK_IMPORTED_MODULE_1_luxon__["DateTime"].fromISO(date).toFormat('yyyy-MM-dd HH:mm:ss');
    },
    init: function init() {
      var _this2 = this;

      return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve) {
        _this2.$http.get('company').then(function (res) {
          resolve();
          _this2.companyLoading = false;
          if (res.body.status === 'Success') {
            _this2.companies = res.body.companies;
            return;
          }
          _this2.err = res.body.statusText;
        }, function (err) {
          resolve();
          _this2.companyLoading = false;
          _this2.err = err.body.statusText || err.body.message;
        });
      });
    },
    changeStatus: function changeStatus(appRes) {
      var _this3 = this;

      var action = appRes.status === 'active' ? 'deactivate' : 'activate';
      this.$http.post('appresource/' + action + '/' + appRes.id).then(function (res) {
        if (res.body.status === 'Success') {
          _this3.$set(appRes, 'status', action === 'activate' ? 'active' : 'inactive');
          return;
        }
        _this3.err = res.body.statusText;
      }, function (err) {
        _this3.err = err.body.statusText || err.body.message;
      });
    },
    fetchAppResourcesForCompany: function fetchAppResourcesForCompany(id) {
      var _this4 = this;

      this.show = true;
      this.allAppResources = [];
      this.activeAppResource = [];
      this.$http.post('appresource/getall', { companyId: id }).then(function (res) {
        _this4.loading = false;
        if (res.body.status === 'Success') {
          _this4.allAppResources = res.body.appResources;
          return;
        }
        if (_this4.allAppResources.length === 0) {
          _this4.loading = false;
        }
        _this4.err = res.body.statusText;
      }, function (err) {
        _this4.loading = false;
        _this4.err = err.body.statusText || err.body.message;
      });
    }
  },
  created: function created() {
    var _this5 = this;

    this.init().then(function () {
      var edit = _this5.$cookie.get('companyedit');
      if (edit) _this5.selectedCompany = edit;
    });
  }
});

/***/ }),
/* 174 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_luxon__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_luxon___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_luxon__);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      err: '',
      success: '',
      valid: false,
      isEdit: false,
      companyLoading: true,
      companies: [],
      appResource: {
        companyId: null,
        name: null,
        type: null,
        subscriptionModel: null
      },
      createdOn: null,
      modifiedOn: null,
      appResourceTypes: [],
      subscriptionModels: []
    };
  },
  watch: {
    err: function err(val) {
      var _this = this;

      if (val !== '') {
        setTimeout(function () {
          _this.err = '';
        }, 5000);
      }
    }
  },
  methods: {
    formatDate: function formatDate(date) {
      return __WEBPACK_IMPORTED_MODULE_1_luxon__["DateTime"].fromISO(date).toFormat('yyyy-MM-dd HH:mm:ss');
    },
    init: function init() {
      var _this2 = this;

      return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve) {
        _this2.$http.get('company').then(function (res) {
          resolve();
          _this2.companyLoading = false;
          if (res.body.status === 'Success') {
            _this2.companies = res.body.companies;
            return;
          }
          _this2.err = res.body.statusText;
        }, function (err) {
          resolve();
          _this2.companyLoading = false;
          _this2.err = err.body.statusText || err.body.message;
        });
        _this2.$http.get('system/appresource/fetchtypes').then(function (res) {
          resolve();
          if (res.body.status === 'Success') {
            _this2.appResourceTypes = res.body.appResourceTypes;
            return;
          }
          _this2.err = res.body.statusText;
        }, function (err) {
          resolve();
          _this2.err = err.body.statusText || err.body.message;
        });
        _this2.$http.get('system/appresource/fetchsubscriptionmodels').then(function (res) {
          resolve();
          if (res.body.status === 'Success') {
            _this2.subscriptionModels = res.body.subscriptionModels;
            return;
          }
          _this2.err = res.body.statusText;
        }, function (err) {
          resolve();
          _this2.err = err.body.statusText || err.body.message;
        });
      });
    },
    submit: function submit() {
      var _this3 = this;

      var url = this.isEdit ? 'appresource/update/' + this.$route.params.id : 'appresource/create';
      this.$http.post(url, this.appResource).then(function (res) {
        if (res.body.status === 'Success') {
          _this3.success = _this3.isEdit ? 'App Resource updated successfuly' : 'App Resource created successfuly';
          setTimeout(function () {
            if (_this3.isEdit) {
              _this3.success = '';
            } else {
              _this3.$router.push({ name: 'appResources' });
            }
          }, 3000);
          return;
        }
        _this3.err = res.body.statusText;
      }, function (err) {
        _this3.err = err.body.statusText || err.body.message;
      });
    }
  },
  created: function created() {
    var _this4 = this;

    this.init().then(function () {
      if (_this4.$route.params.id) {
        _this4.isEdit = true;
        _this4.$http.get('appresource/' + _this4.$route.params.id).then(function (res) {
          if (res.body.status === 'Success') {
            _this4.appResource = res.body.appResource;
            _this4.createdOn = _this4.formatDate(_this4.appResource.createdOn);
            if (_this4.appResource.modifiedOn) {
              _this4.modifiedOn = _this4.formatDate(_this4.appResource.modifiedOn);
            }
            return;
          }
          _this4.err = res.body.statusText;
        }, function (err) {
          _this4.err = err.body.statusText || err.body.message;
        });
      }
    });
  }
});

/***/ }),
/* 175 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_luxon__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_luxon___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_luxon__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = ({
  components: {
    auditModal: function auditModal() {
      return __webpack_require__.e/* import() */(6/* duplicate */).then(__webpack_require__.bind(null, 78));
    }
  },
  data: function data() {
    return {
      err: '',
      search: '',
      menu: false,
      menu2: false,
      show: false,
      auditModal: false,
      loading: false,
      auditData: null,
      sources: ['MOON', 'SUN_WEB'],
      actions: ['AccountActivate', 'AccountCreate', 'AccountDeactivate', 'AccountFetchRoles', 'AccountGet', 'AccountGetAll', 'AccountManageRoles', 'AccountResetPassword', 'AccountRoles', 'AccountUpdate', 'AppResourceActivate', 'AppResourceCreate', 'AppResourceDeactivate', 'AppResourceGet', 'AuditGetAll', 'CallerIdServerCreate', 'CallerIdServerDeactivate', 'CallerIdServerFetchById', 'CallerIdServerGetAll', 'CatalogActivate', 'CatalogCreate', 'CatalogGet', 'CatalogGetAll', 'CatalogGetCatalogVersionsForCompany', 'CatalogGetWebShopViewsForCatalog', 'CompanyActivate', 'CompanyAddAllConfiguration', 'CompanyCreate', 'CompanyDeactivate', 'CompanyGet', 'CompanyGetAll', 'CompanyUpdate', 'CompanyValidate', 'CorporationCreate', 'CorporationDeactivate', 'CorporationGetAll', 'CorporationGetById', 'CorporationUpdate', 'DiscountRuleActivate', 'DiscountRuleCreate', 'DiscountRuleDeactivate', 'DiscountRuleGet', 'DiscountRuleGetAll', 'DiscountRuleUpdate', 'DomainResourceActivate', 'DomainResourceCreate', 'DomainResourceDeactivate', 'DomainResourceGetAll', 'DomainResourceGetAllForACompany', 'DomainResourceGetById', 'DomainResourceUpdate', 'FetchAllPrintersForACompany', 'FetchLicenseTypes', 'FetchSystemVersion', 'GenerateMonthlyAggregatedLicenseUsage', 'GenerateMonthlyLicenseUsage', 'GetAllCurrencies', 'GetSystemCurrencies', 'GetSystemFetchPrinterCategories', 'GetSystemPrintTemplateTypes', 'LicenseActivate', 'LicenseCreate', 'LicenseDeactivate', 'LicenseGet', 'LicenseGetAll', 'LicenseUsageGet', 'LicenseUsageGetAll', 'LogMigrationData', 'MarkMoonConfigAsSync', 'MonthlyLicenseUsageGetForYearAndMonth', 'MoonBackupCreate', 'MoonBackupCreateNonCompanySpecific', 'MoonConfigUpdateGetById', 'MoonInstanceGet', 'MoonInstanceGetAll', 'MoonRegister', 'MoonReRegister', 'PlanetConfigUpdateGetById', 'PricingGroupInvoiceGenerate', 'PricingGroupInvoiceGetById', 'PrinterActivate', 'PrinterCategoryGetAll', 'PrinterCreate', 'PrinterDeactivate', 'PrinterGet', 'PrinterGetAll', 'PrinterGetAllPrinterCategories', 'PrinterUpdate', 'PrintServerActivate', 'PrintServerCreate', 'PrintServerDeactivate', 'PrintServerFetchById', 'PrintServerGetAll', 'PrintServerUpdate', 'PrintTemplateActivate', 'PrintTemplateCreate', 'PrintTemplateDeactivate', 'PrintTemplateGetAll', 'PrintTemplateGetById', 'PrintTemplateGetForCompany', 'ReportGetById', 'SunUserLogin', 'SunUserLogout', 'SystemLogsGetAll', 'SystemWebSpaceFetchProperties', 'SystemWebSpaceFetchTemplates', 'SystemWebSpaceFetchTypes', 'TableActivate', 'TableCategoryActivate', 'TableCategoryCreate', 'TableCategoryDeactivate', 'TableCategoryGetAll', 'TableCategoryGetById', 'TableCategoryUpdate', 'TableCreate', 'TableCreateMultiple', 'TableDeactivate', 'TableGetAll', 'TableGetById', 'TableUpdate', 'WebShopFetchPostalCodeDistance', 'WebShopResourceActivate', 'WebShopResourceCreate', 'WebShopResourceDeactivate', 'WebShopResourceGetById', 'WebShopResourceUpdate', 'WebShopResourceUpdatePaymentGatewayPassword', 'WebShopResourceUpdatePublicKey', 'WebSpaceActivate', 'WebSpaceCreate', 'WebSpaceDeactivate', 'WebSpaceGetAll', 'WebSpaceGetById', 'WebSpaceUpdate'],
      data: {
        startDate: __WEBPACK_IMPORTED_MODULE_0_luxon__["DateTime"].local().minus({ hours: 4 }).toISO(),
        endDate: __WEBPACK_IMPORTED_MODULE_0_luxon__["DateTime"].local().plus({ hours: 2 }).toISO(),
        url: null,
        action: null,
        sourceSystem: null,
        auditDirection: null
      },
      auditLogs: [],
      pagination: {
        sortBy: 'createdOn',
        descending: true
      },
      headers: [{ text: this.$lang.labels.created, value: 'createdOn', align: 'left' }, { text: this.$lang.header.createdBy, value: 'createdByFullName', align: 'left' }, { text: this.$lang.header.sourceVersion, value: 'sourceSystem', align: 'left' }, { text: this.$lang.labels.companyId, value: 'companyId', align: 'left' }, { text: this.$lang.header.action, value: 'action', align: 'left' }, { text: this.$lang.labels.url, value: 'url', align: 'left' }, { text: this.$lang.labels.auditDirection, value: 'auditDirection', align: 'left' }, { text: this.$lang.labels.data, value: 'data', align: 'left' }]
    };
  },

  watch: {
    err: function err(val) {
      var _this = this;

      if (val !== '') {
        setTimeout(function () {
          _this.err = '';
        }, 5000);
      }
    }
  },
  methods: {
    formatDate: function formatDate(date) {
      return __WEBPACK_IMPORTED_MODULE_0_luxon__["DateTime"].fromISO(date).toFormat('yyyy-MM-dd HH:mm');
    },
    showData: function showData(data) {
      this.auditData = data;
      this.auditModal = true;
    },
    showAudit: function showAudit() {
      var _this2 = this;

      this.loading = true;
      this.show = true;
      var data = this.data;
      data.url = data.url === '' ? null : data.url;
      data.action = data.action === '' ? null : data.action;
      data.sourceSystem = data.sourceSystem === '' ? null : data.sourceSystem;
      data.auditDirection = data.auditDirection === '' ? null : data.auditDirection;
      this.$http.post('audit', data).then(function (res) {
        if (res.body.status !== 'Success') {
          _this2.err = res.body.statusText;
          return;
        }
        _this2.auditLogs = res.body.details.map(function (current) {
          var audit = current;
          audit.shortData = audit.data.slice(0, 63);
          return audit;
        });
        if (_this2.auditLogs !== 0) {
          _this2.loading = false;
        }
      }, function (err) {
        _this2.loading = false;
        _this2.err = err.body.statusText || err.body.message;
      });
    }
  }
});

/***/ }),
/* 176 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_luxon__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_luxon___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_luxon__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      err: '',
      search: '',
      headers: [{ text: this.$lang.header.jobName, value: 'jobName', align: 'left' }, { text: this.$lang.header.jobDesc, value: 'jobDesc', align: 'left' }, { text: this.$lang.header.lastExec, value: 'lastExecutedOn', align: 'left' }, { text: this.$lang.header.nextExec, value: 'nextPlannedExecutionOn', align: 'left' }, { text: this.$lang.labels.status, value: 'status', align: 'left' }, { text: this.$lang.labels.actions, value: 'actions', align: 'left', sortable: false }],
      showActive: true,
      allAutojobs: []
    };
  },

  methods: {
    formatDate: function formatDate(date) {
      return __WEBPACK_IMPORTED_MODULE_0_luxon__["DateTime"].fromISO(date).toFormat('yyyy-MM-dd HH:mm');
    },
    changeStatus: function changeStatus(autojob) {
      var _this = this;

      var action = autojob.status === 'active' ? 'deactivate' : 'activate';
      this.$http.post('autojobswitch/' + action + '/' + autojob.id).then(function (res) {
        if (res.body.status === 'Success') {
          _this.$set(autojob, 'status', action === 'activate' ? 'active' : 'inactive');
          return;
        }
        _this.err = res.body.statusText;
      }, function (err) {
        _this.err = err.body.statusText || err.body.message;
      });
    }
  },
  watch: {
    err: function err(val) {
      var _this2 = this;

      if (val !== '') {
        setTimeout(function () {
          _this2.err = '';
        }, 5000);
      }
    }
  },
  computed: {
    activeAutojobs: function activeAutojobs() {
      var autojobs = this.allAutojobs;
      var activeAutojobs = [];
      for (var i = 0; autojobs.length > i; i++) {
        if (autojobs[i].status === 'active') {
          activeAutojobs.push(autojobs[i]);
        }
      }
      return activeAutojobs;
    }
  },
  created: function created() {
    var _this3 = this;

    this.$http.get('autojobswitch/getall').then(function (res) {
      if (res.body.status === 'Success') {
        _this3.allAutojobs = res.body.autoJobs;
        return;
      }
      _this3.err = res.body.statusText;
    }, function (err) {
      _this3.err = err.body.statusText || err.body.message;
    });
  }
});

/***/ }),
/* 177 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      err: '',
      success: '',
      valid: false,
      isEdit: false,
      companyLoading: true,
      companies: [],
      callerIdServer: {
        companyId: null,
        name: null
      }
    };
  },
  watch: {
    err: function err(val) {
      var _this = this;

      if (val !== '') {
        setTimeout(function () {
          _this.err = '';
        }, 5000);
      }
    }
  },
  methods: {
    init: function init() {
      var _this2 = this;

      return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve) {
        _this2.$http.get('company').then(function (res) {
          resolve();
          _this2.companyLoading = false;
          if (res.body.status === 'Success') {
            _this2.companies = res.body.companies;
            return;
          }
          _this2.err = res.body.statusText;
        }, function (err) {
          resolve();
          _this2.companyLoading = false;
          _this2.err = err.body.statusText || err.body.message;
        });
      });
    },
    copyKey: function copyKey() {
      try {
        var copyText = document.getElementById('key');
        copyText.select();
        var success = document.execCommand('copy');
      } catch (e) {
        console.log(e);
      }
    },
    submit: function submit() {
      var _this3 = this;

      var url = this.isEdit ? 'calleridserver/update/' + this.$route.params.id : 'calleridserver/create';
      this.$http.post(url, this.callerIdServer).then(function (res) {
        if (res.body.status === 'Success') {
          _this3.success = _this3.isEdit ? 'CallerID Server updated successfuly' : 'CallerID Server created successfuly';
          setTimeout(function () {
            if (_this3.isEdit) {
              _this3.success = '';
            } else {
              _this3.$router.push({ name: 'callerIdServers' });
            }
          }, 3000);
          return;
        }
        _this3.err = res.body.statusText;
      }, function (err) {
        _this3.err = err.body.statusText || err.body.message;
      });
    }
  },
  created: function created() {
    var _this4 = this;

    this.init().then(function () {
      if (_this4.$route.params.id) {
        _this4.isEdit = true;
        _this4.$http.get('calleridserver/fetchbyid/' + _this4.$route.params.id).then(function (res) {
          if (res.body.status === 'Success') {
            _this4.callerIdServer = res.body.details;
            return;
          }
          _this4.err = res.body.statusText;
        }, function (err) {
          _this4.err = err.body.statusText || err.body.message;
        });
      }
    });
  }
});

/***/ }),
/* 178 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      err: '',
      loading: false,
      show: false,
      selectedCompany: null,
      companies: [],
      search: '',
      headers: [{ text: this.$lang.header.callerIdName, value: 'name', align: 'left' }, { text: this.$lang.labels.status, value: 'status', align: 'left' }, { text: this.$lang.labels.actions, value: 'actions', align: 'left', sortable: false }],
      showActive: true,
      allCallerIdServers: []
    };
  },

  methods: {
    changeStatus: function changeStatus(callerId) {
      var _this = this;

      var action = callerId.status === 'active' ? 'deactivate' : 'activate';
      this.$http.post('calleridserver/' + action + '/' + callerId.id).then(function (res) {
        if (res.body.status === 'Success') {
          _this.$set(callerId, 'status', action === 'activate' ? 'active' : 'inactive');
          return;
        }
        _this.err = res.body.statusText;
      }, function (err) {
        _this.err = err.body.statusText || err.body.message;
      });
    },
    fetchCallerIDforCompany: function fetchCallerIDforCompany(id) {
      var _this2 = this;

      this.loading = true;
      this.allCallerIdServers = [];
      this.activeCallerIdServers = [], this.$http.post('calleridserver', { companyId: id }).then(function (res) {
        if (res.body.status === 'Success') {
          _this2.loading = false;
          _this2.allCallerIdServers = res.body.details;
          if (_this2.allCallerIdServers.length === 0) {
            _this2.loading = false;
          }
          return;
        }
        _this2.err = res.body.statusText;
      }, function (err) {
        _this2.loading = false;
        _this2.err = err.body.statusText || err.body.message;
      });
    }
  },
  watch: {
    err: function err(val) {
      var _this3 = this;

      if (val !== '') {
        setTimeout(function () {
          _this3.err = '';
        }, 5000);
      }
    },
    selectedCompany: function selectedCompany(val) {
      this.show = true;
      this.fetchCallerIDforCompany(val);
      this.$cookie.set('companyedit', val, { expires: '8h' });
    }
  },
  computed: {
    activeCallerIdServers: function activeCallerIdServers() {
      var callerIdServers = this.allCallerIdServers;
      var activeCallerIdServers = [];
      for (var i = 0; callerIdServers.length > i; i++) {
        if (callerIdServers[i].status === 'active') {
          activeCallerIdServers.push(callerIdServers[i]);
        }
      }
      return activeCallerIdServers;
    },
    mappedCompanies: function mappedCompanies() {
      return this.companies.map(function (company) {
        return {
          text: company.name + ' (' + company.companyStatus + ')',
          value: company.id
        };
      });
    }
  },
  created: function created() {
    var _this4 = this;

    this.$http.get('company').then(function (res) {
      if (res.body.status === 'Success') {
        _this4.companies = res.body.companies;
        return;
      }
      _this4.err = res.body.statusText;
    }, function (err) {
      _this4.err = err.body.statusText || err.body.message;
    });
    var edit = this.$cookie.get('companyedit');
    if (edit) this.selectedCompany = edit;
  }
});

/***/ }),
/* 179 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_luxon__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_luxon___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_luxon__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__assets_fetch_data__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__assets_url__ = __webpack_require__(7);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      err: '',
      success: '',
      selectedCompany: null,
      isLocalAdmin: false,
      companies: [],
      loading: false,
      language: this.$cookie.get('lang') || 'en',
      headers: [{ text: this.$lang.labels.cashRegisterName, value: 'cashRegisterName', align: 'left' }, { text: this.$lang.labels.username, value: 'username', align: 'left' }, { text: this.$lang.labels.created, value: 'createdOn', align: 'left' }, { text: this.$lang.labels.inUseFrom, value: 'inUseFrom', align: 'left' }, { text: this.$lang.labels.status, value: 'status', align: 'left' }, { text: this.$lang.labels.actions, value: 'actions', align: 'left', sortable: false }],
      allRegisters: [],
      showActive: true
    };
  },

  watch: {
    selectedCompany: function selectedCompany(val) {
      this.fetchRegistersForCompany(val);
      this.$cookie.set('companyedit', val, { expires: '8h' });
    },
    err: function err(val) {
      var _this = this;

      if (val !== '') {
        setTimeout(function () {
          _this.err = '';
        }, 5000);
      }
    }
  },
  computed: {
    mappedCompanies: function mappedCompanies() {
      return this.companies.map(function (company) {
        return {
          text: company.name + ' (' + company.companyStatus + ')',
          value: company.id
        };
      });
    }
  },
  methods: {
    formatDate: function formatDate(date) {
      return __WEBPACK_IMPORTED_MODULE_0_luxon__["DateTime"].fromISO(date).toFormat('yyyy-MM-dd');
    },
    fetchRegistersForCompany: function fetchRegistersForCompany(companyId) {
      var _this2 = this;

      this.loading = true;
      this.allRegisters = [];
      this.activeRegsters = [];
      this.$http.post('cashregister', { companyId: companyId }).then(function (res) {
        if (res.body.status === 'Success') {
          _this2.loading = false;
          _this2.allRegisters = res.body.cashRegisters;
          return;
        }
        _this2.err = res.body.statusText;
      }, function (err) {
        _this2.loading = false;
        _this2.err = err.body.statusText || err.body.message;
      });
    },
    editRegister: function editRegister(id) {
      this.$router.push({ name: "cashRegisterEdit", params: { id: id } });
    },
    createRegister: function createRegister() {
      this.$router.push({ name: "cashRegisterCreate" });
    }
  },
  created: function created() {
    var _this3 = this;

    this.isLocalAdmin = this.$auth.roles && this.$auth.roles.includes('ROLE_SUN_LOCAL_ADMIN');
    if (this.isLocalAdmin) {
      this.fetchRegistersForCompany();
      return;
    }
    this.$http.get('company').then(function (res) {
      if (res.body.status === 'Success') {
        _this3.companies = res.body.companies;
        return;
      }
      _this3.err = res.body.statusText;
    }, function (err) {
      _this3.err = err.body.statusText || err.body.message;
    });
    var edit = this.$cookie.get('companyedit');
    if (edit) this.selectedCompany = edit;
  }
});

/***/ }),
/* 180 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__assets_fetch_data__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__assets_url__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_luxon__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_luxon___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_luxon__);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      err: '',
      isEdit: false,
      success: '',
      valid: false,
      companies: [],
      companyLoading: true,
      register: {
        cashRegisterName: '',
        companyId: '',
        username: '',
        password: '',
        aesKey: '',
        aesKeyCheckSum: '',
        createdOn: '',
        inUseFrom: '',
        modifiedOn: '',
        depAccessKey: '',
        status: ''
      }
    };
  },
  watch: {
    err: function err(val) {
      var _this = this;

      if (val !== '') {
        setTimeout(function () {
          _this.err = '';
        }, 5000);
      }
    }
  },
  methods: {
    formatDate: function formatDate(date) {
      return __WEBPACK_IMPORTED_MODULE_3_luxon__["DateTime"].fromISO(date).toFormat('yyyy-MM-dd');
    },
    fetchCompanies: function fetchCompanies() {
      var _this2 = this;

      this.$http.get('company').then(function (res) {
        if (res.body.status === 'Success') {
          _this2.companies = res.body.companies;
          _this2.companyLoading = false;
          return;
        }
        _this2.err = res.body.statusText;
        _this2.companyLoading = false;
      }, function (err) {
        _this2.err = err.body.statusText || err.body.message;
        _this2.companyLoading = false;
      });
      var edit = this.$cookie.get('companyedit');
      if (edit) this.register.companyId = edit;
    },
    fetchRegister: function fetchRegister(id) {
      var _this3 = this;

      this.$http.get('cashregister/' + id).then(function (res) {
        if (res.body.status === 'Success') {
          var register = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, res.body.cashRegister, {
            createdOn: _this3.formatDate(res.body.cashRegister.createdOn),
            inUseFrom: res.body.cashRegister.inUseFrom ? _this3.formatDate(res.body.cashRegister.inUseFrom) : '',
            modifiedOn: res.body.cashRegister.modifiedOn ? _this3.formatDate(res.body.cashRegister.modifiedOn) : null
          });
          _this3.register = register;
        }
      }, function (err) {
        _this3.err = err.body.statusText || err.body.message;
      });
    },
    updateReciept: function updateReciept(action) {
      var _this4 = this;

      console.log(action);
      var id = this.register.id;
      var url = '';
      switch (action) {
        case 'start':
          url = 'cashregister/startreceipt/' + id;
          break;
        case 'end':
          url = 'cashregister/endreceipt/' + id;
          break;
        case 'null':
          url = 'cashregister/nullreceipt/' + id;
          break;
        default:
          url = 'cashregister/depregistration/' + id;
      }
      this.$http.post(url).then(function (res) {
        if (res.body.status === 'Success') {
          _this4.success = res.body.statusText;
        }
      }, function (err) {
        _this4.err = err.body.statusText || err.body.message;
      });
    },
    submit: function submit() {
      var _this5 = this;

      var url = this.isEdit ? 'cashregister/update/' + this.$route.params.id : 'cashregister/create';
      var payload = this.isEdit ? {
        cashRegisterName: this.register.cashRegisterName,
        username: this.register.username,
        password: this.register.password,
        depAccessKey: this.register.depAccessKey
      } : {
        cashRegisterName: this.register.cashRegisterName,
        companyId: this.register.companyId,
        username: this.register.username,
        password: this.register.password
      };
      this.$http.post(url, payload).then(function (res) {
        if (res.body.status === 'Success') {
          _this5.success = _this5.isEdit ? 'Register updated successfuly' : 'Register created successfuly';
          return;
        }
        _this5.err = res.body.statusText;
      }, function (err) {
        _this5.err = err.body.statusText || err.body.message;
      });
    }
  },
  created: function created() {
    this.fetchCompanies();
    if (this.$route.params.id) {
      this.isEdit = true;
      this.fetchRegister(this.$route.params.id);
    }
  }
});

/***/ }),
/* 181 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  props: ['itemData', 'index', 'items', 'views', 'isEdit'],
  data: function data() {
    return {
      language: this.$cookie.get('lang') || 'en',
      selected: this.itemData.selected
    };
  },

  computed: {
    formattedViews: function formattedViews() {
      var _this = this;

      return this.views && this.views.length !== 0 && this.itemData.views.length !== 0 ? this.itemData.views.map(function (current) {
        return _this.views.find(function (view) {
          return view.viewId === current;
        }) ? _this.views.find(function (view) {
          return view.viewId === current;
        }).name[_this.language] : '';
      }).join(', ') : 'none';
    },
    formattedPrintCategories: function formattedPrintCategories() {
      return this.itemData.printerCategories && this.itemData.printerCategories.length > 0 ? this.itemData.printerCategories.join(', ') : 'none';
    },
    formattedSettings: function formattedSettings() {
      var settings = [];
      if (this.itemData.settings) {
        if (this.itemData.settings.labelPrint) {
          settings.push('Label print');
        }
        if (this.itemData.settings.askDetails) {
          settings.push('Ask details');
        }
      }
      if (this.itemData.vatPrint) {
        settings.push('VAT print');
      }
      if (this.itemData.noDiscount) {
        settings.push('No Discount');
      }
      if (this.itemData.galaxyCardBalance) {
        settings.push('Galaxy Card Balance');
      }
      return settings.join(', ');
    }
  },
  methods: {
    showCurrent: function showCurrent() {
      this.$emit('editItemPassing', this.itemData);
    },
    editItemPassing: function editItemPassing(val) {
      this.$emit('editItemPassing', val);
    },
    arraymove: function arraymove(arr, fromIndex, toIndex) {
      var element = arr[fromIndex];
      arr.splice(fromIndex, 1);
      arr.splice(toIndex, 0, element);
    },
    moveItemUp: function moveItemUp() {
      if (this.index === 0) {
        return;
      }
      var indexFrom = this.index;
      var indexTo = this.index - 1;
      if (!this.itemData.parentItem) {
        this.arraymove(this.items, indexFrom, indexTo);
      } else if (this.itemData.parentItem) {
        this.arraymove(this.items, indexFrom, indexTo);
      }
    },
    moveItemDown: function moveItemDown() {
      if (this.index === this.items.length - 1) {
        return;
      }
      var indexFrom = this.index;
      var indexTo = this.index + 1;
      if (!this.itemData.parentItem) {
        this.arraymove(this.items, indexFrom, indexTo);
      } else if (this.itemData.parentItem) {
        this.arraymove(this.items, indexFrom, indexTo);
      }
    },
    select: function select() {
      var event = {
        select: !this.itemData.selected,
        path: [this.index]
      };
      this.$emit('selected', [event, false]);
    },
    addItemTrigger: function addItemTrigger() {
      var plusOne = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

      this.selected = true;
      this.$emit('addItem', [[this.index], plusOne]);
    },
    selectFurther: function selectFurther(event, label) {
      // this.selected = !this.selected;
      var send = event;
      if (label === 'selected') {
        send[0].path.push(this.index);
      } else {
        send[0].push(this.index);
      }
      this.$emit(label, send);
    }
  }
});

/***/ }),
/* 182 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_luxon__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_luxon___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_luxon__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__assets_fetch_data__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__assets_url__ = __webpack_require__(7);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      err: '',
      success: '',
      selectedCompany: null,
      isLocalAdmin: false,
      companies: [],
      loading: false,
      language: this.$cookie.get('lang') || 'en',
      headers: [{ text: this.$lang.header.catalogVersion, value: 'catalogVersion', align: 'left' }, { text: this.$lang.header.catalogName, value: 'catalogName', align: 'left' }, { text: this.$lang.labels.created, value: 'createdOn', align: 'left' }, { text: this.$lang.labels.status, value: 'status', align: 'left' }, { text: this.$lang.labels.actions, value: 'actions', align: 'left', sortable: false }],
      allCatalogs: [],
      showActive: true,
      pagination: {
        sortBy: 'catalogVersion',
        descending: true
      },
      showActivationModal: false,
      activationData: null,
      confirmPushModal: false,
      catalogId: ''
    };
  },

  watch: {
    selectedCompany: function selectedCompany(val) {
      this.fetchCatalogsForCompany(val);
      this.$cookie.set('companyedit', val, { expires: '8h' });
    },
    err: function err(val) {
      var _this = this;

      if (val !== '') {
        setTimeout(function () {
          _this.err = '';
        }, 5000);
      }
    }
  },
  computed: {
    activeCatalogs: function activeCatalogs() {
      var catalogs = this.allCatalogs;
      var activeCatalogs = [];
      for (var i = 0; catalogs.length > i; i++) {
        if (catalogs[i].status === 'active' || catalogs[i].status === 'created') {
          activeCatalogs.push(catalogs[i]);
        }
      }
      return activeCatalogs;
    },
    mappedCompanies: function mappedCompanies() {
      return this.companies.map(function (company) {
        return {
          text: company.name + ' (' + company.companyStatus + ')',
          value: company.id
        };
      });
    }
  },
  methods: {
    pushToCorp: function pushToCorp(id) {
      console.log('clicked');
      this.catalogId = id;
      this.confirmPushModal = true;
    },
    formatDate: function formatDate(date) {
      return __WEBPACK_IMPORTED_MODULE_1_luxon__["DateTime"].fromISO(date).toFormat('yyyy-MM-dd');
    },
    formatDateWithTime: function formatDateWithTime(date) {
      return __WEBPACK_IMPORTED_MODULE_1_luxon__["DateTime"].fromISO(date).toFormat('yyyy-MM-dd HH:mm');
    },
    fetchCatalogsForCompany: function fetchCatalogsForCompany(companyId) {
      var _this2 = this;

      this.loading = true;
      this.allCatalogs = [];
      this.activeCatalogs = [];
      this.$http.post('catalog/getcatalogversions', { companyId: companyId }).then(function (res) {
        if (res.body.status === 'Success') {
          _this2.loading = false;
          _this2.allCatalogs = res.body.details.map(function (catalog) {
            return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, catalog, { activating: false });
          });
          return;
        }
        _this2.err = res.body.statusText;
      }, function (err) {
        _this2.loading = false;
        _this2.err = err.body.statusText || err.body.message;
      });
    },
    editCatalog: function editCatalog(id) {
      this.$router.push({ name: "catalogCreate", query: { id: id }, params: { id: id } });
    },
    createCatalog: function createCatalog() {
      this.$router.push({ name: "catalogCreate", params: { companies: this.companies } });
    },
    getWebshopView: function getWebshopView(views) {
      var webview = void 0;
      views.forEach(function (view) {
        if (view.name.en === 'Webshop') webview = view;
      });
      return webview;
    },
    closeActivation: function closeActivation(data) {
      this.showActivationModal = false;
      this.activationData = null;
      if (data) {
        this.fetchCatalogsForCompany(this.selectedCompany);
      }
    },
    activateCatalog: function activateCatalog(catalog) {
      var _this3 = this;

      this.activationData = {
        catalogId: catalog.catalogId,
        catalogVersion: catalog.catalogVersion,
        companyId: this.selectedCompany
      };
      this.$set(catalog, 'activating', true);
      this.$http.get('catalog/' + catalog.catalogId).then(function (res) {
        var webview = _this3.getWebshopView(res.body.catalog.views);
        if (!webview) return null;
        _this3.activationData.catalogViewId = webview.viewId;
        return _this3.$http.post('webshopresource/getall', { companyId: _this3.selectedCompany });
      }).then(function (res) {
        if (res && res.body.status === 'Success') {
          _this3.activationData.webshops = res.body.details.filter(function (webshop) {
            return webshop.status === 'active';
          });
        }
        _this3.$set(catalog, 'activating', false);
        _this3.showActivationModal = true;
      }).catch(function (e) {
        _this3.activationData = null;
        _this3.$set(catalog, 'activating', false);
        _this3.err = e.message || e.body.message;
      });
      // this.fetchCatalogsForCompany(this.selectedCompany);
    }
  },
  created: function created() {
    var _this4 = this;

    this.isLocalAdmin = this.$auth.roles && this.$auth.roles.includes('ROLE_SUN_LOCAL_ADMIN');
    if (this.isLocalAdmin) {
      this.fetchCatalogsForCompany();
      return;
    }
    this.$http.get('company').then(function (res) {
      if (res.body.status === 'Success') {
        _this4.companies = res.body.companies;
        return;
      }
      _this4.err = res.body.statusText;
    }, function (err) {
      _this4.err = err.body.statusText || err.body.message;
    });
    var edit = this.$cookie.get('companyedit');
    if (edit) this.selectedCompany = edit;
  },

  components: {
    activationModal: function activationModal() {
      return __webpack_require__.e/* import() */(9/* duplicate */).then(__webpack_require__.bind(null, 79));
    },
    confirmPush: function confirmPush() {
      return __webpack_require__.e/* import() */(30).then(__webpack_require__.bind(null, 472));
    }
  }
});

/***/ }),
/* 183 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_get_iterator__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_get_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_toConsumableArray__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_extends__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_babel_runtime_core_js_json_stringify__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_vue__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__assets_fetch_data__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__assets_url__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_lodash__ = __webpack_require__(309);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__assets_allergens__ = __webpack_require__(84);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_copy_to_clipboard__ = __webpack_require__(233);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_copy_to_clipboard___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14_copy_to_clipboard__);









//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//







function searchMaxId(item) {
  var itemId = item.itemId || 0;
  if (!item.items || item.items.length <= 0) {
    return itemId;
  } else {
    var items = item.items;
    var index = items.length;
    var _maxId = 0;
    while (index--) {
      var result = searchMaxId(items[index]);
      if (result > _maxId) {
        _maxId = result;
      }
    }
    return itemId > _maxId ? itemId : _maxId;
  }
}
/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      notLoading: true,
      err: '',
      errors: [],
      isLocalAdmin: false,
      currentItemEvent: '',
      creating: false,
      success: '',
      name: '',
      version: null,
      openCompanies: false,
      filter: '',
      items: [],
      views: [],
      parsedItemList: [],
      companies: [],
      selectedCompany: null,
      selectedCompanyInfo: {},
      initToggle: true,
      currentView: null,
      plusOne: false,
      itemModal: false,
      editViews: false,
      massAddViews: false,
      massAddPrinters: false,
      massRemovePrinters: false,
      massLangModal: false,
      massRemoveViews: false,
      vatModal: false,
      selectedItem: null,
      actionPath: null,
      pickedItem: null,
      language: this.$cookie.get('lang') || 'en',
      itemsIds: [],
      isCatalogValid: false,
      viewsIds: [],
      notUniqItemsIds: [],
      loaded: false,
      allCorporations: [],
      currentCorporation: null,
      showActivationModal: false,
      activationData: null,
      isEdit: null,
      show: false,
      copyItemData: null,
      taxCategories: [],
      massAddModal: false,
      massAddData: null,
      massRemoveModalTree: false,
      massRemoveDataTree: null,
      viewsTree: [],
      printCategoriesTree: [],
      allergens: [],
      allergensIds: [],
      currentAllergen: null,
      editAllergens: false,
      massAddAllergens: false,
      massRemoveAllergens: false,
      orderTypes: null,
      selectedOrderTypes: [],
      predefinedViews: [{ "name": { "en": "Collection", "de": "Collection" }, "orderTypes": ['collection'] }, { "name": { "en": "Webshop", "de": "Webshop" }, "orderTypes": ['delivery'] }, { "name": { "en": "Takeaway", "de": "Takeaway" }, "orderTypes": ['takeaway'] }, { "name": { "en": "Restaurant", "de": "Restaurant" }, "orderTypes": ['restaurant'] }, { "name": { "en": "Self-service", "de": "Self-service" }, "orderTypes": [] }, { "name": { "en": "Simple-inventory", "de": "Simple-inventory" }, "orderTypes": [] }, { "name": { "en": "Full-inventory", "de": "Full-inventory" }, "orderTypes": [] }],
      predefinedViewsModal: false,
      isPasteOn: false
    };
  },

  watch: {
    selectedCompany: {
      handler: function handler(val) {
        if (!val) return;
        this.fetchCompany();
      },

      immediate: true,
      deep: true
    }
  },
  computed: {
    maxItemId: function maxItemId() {
      var val = 0;
      var items = this.items;
      var index = items.length;

      while (index--) {
        var result = searchMaxId(items[index]);
        if (val < result) {
          val = result;
        }
      }
      return val;
    },
    maxViewId: function maxViewId() {
      var val = 0;
      var views = this.views;
      var index = views.length;
      while (index--) {
        var result = views[index].viewId;
        if (val < result) {
          val = result;
        }
      }
      return val;
    },
    maxAllergenId: function maxAllergenId() {
      var val = 0;
      var allergens = this.allergens;
      var index = allergens.length;
      while (index--) {
        var result = allergens[index].allergenId;
        if (val < result) {
          val = result;
        }
      }
      return val;
    },
    allowedCompanies: function allowedCompanies() {
      var _this = this;

      return this.currentCorporation ? this.companies.filter(function (company) {
        return _this.currentCorporation.companies.includes(company.id);
      }) : this.companies;
    },
    filteredCompanies: function filteredCompanies() {
      var _this2 = this;

      return this.filter.length === 0 ? this.allowedCompanies : this.allowedCompanies.filter(function (company) {
        return company.name.toLowerCase().includes(_this2.filter.toLowerCase());
      });
    },
    filteredViews: function filteredViews() {
      var addedViews = this.views.map(function (x) {
        return x.name.en;
      });
      return this.predefinedViews.filter(function (y) {
        return !addedViews.includes(y.name.en);
      });
    },
    filtereditems: function filtereditems() {
      return this.items;
    }
  },
  methods: {
    turnOnPasteListen: function turnOnPasteListen() {
      var _this3 = this;

      if (this.isPasteOn) {
        this.isPasteOn = false;
        document.removeEventListener('paste', this.pasteWholeCatalog);
        this.success = 'Not listening to Paste event';
        setTimeout(function () {
          return _this3.success = '';
        }, 6000);
      } else {
        this.isPasteOn = true;
        document.addEventListener('paste', this.pasteWholeCatalog);
        this.success = 'Listening to Paste event';
        setTimeout(function () {
          return _this3.success = '';
        }, 6000);
      }
    },
    copyWholeCatalog: function copyWholeCatalog() {
      var _this4 = this;

      var copyData = this.$data;
      delete copyData.selectedCompany;
      delete copyData.selectedCompanyInfo;
      __WEBPACK_IMPORTED_MODULE_14_copy_to_clipboard___default()(__WEBPACK_IMPORTED_MODULE_8_babel_runtime_core_js_json_stringify___default()(copyData));
      this.success = 'Catalog copied to memory';
      setTimeout(function () {
        return _this4.success = '';
      }, 6000);
    },
    pasteWholeCatalog: function pasteWholeCatalog(event) {
      if (this.isPasteOn) {
        var clipboardData = event.clipboardData || event.originalEvent.clipboardData || window.clipboardData;
        var replacedData = clipboardData.getData('text');

        var replacedSectionParsed = replacedData ? JSON.parse(replacedData) : {};
        for (var row in replacedSectionParsed) {
          // eslint-disable-next-line no-prototype-builtins
          if (replacedSectionParsed.hasOwnProperty(row)) {
            this[row] = replacedSectionParsed[row];
          }
        }
      }
    },
    addPredefinedView: function addPredefinedView(view) {
      this.views.push(__WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_extends___default()({ viewId: this.maxViewId + 1 }, view, { isDefault: false }));
      this.predefinedViewsModal = false;
    },
    formattedViews: function formattedViews(itemData) {
      var _this5 = this;

      return this.views && this.views.length !== 0 && itemData.views.length !== 0 ? itemData.views.map(function (current) {
        return _this5.views.find(function (view) {
          return view.viewId === current;
        }).name[_this5.language];
      }).join(', ') : 'none';
    },
    formattedPrintCategories: function formattedPrintCategories(itemData) {
      return itemData.printerCategories && itemData.printerCategories.length > 0 ? itemData.printerCategories.join(', ') : 'none';
    },
    formattedSettings: function formattedSettings(itemData) {
      var settings = [];
      if (itemData.settings) {
        if (itemData.settings.labelPrint) {
          settings.push('Label print');
        }
        if (itemData.settings.askDetails) {
          settings.push('Ask details');
        }
      }
      if (itemData.vatPrint) {
        settings.push('VAT print');
      }
      if (itemData.noDiscount) {
        settings.push('No Discount');
      }
      if (itemData.galaxyCardBalance) {
        settings.push('Galaxy Card Balance');
      }
      return settings.join(', ');
    },
    addVATToItems: function addVATToItems(vat) {
      var _this6 = this;

      this.vatModal = false;
      var addVat = function addVat(selectedVat, items) {
        items.forEach(function (item) {
          _this6.$set(item, 'vatRate', selectedVat);
          if (item.items) {
            addVat(selectedVat, item.items);
          }
        });
      };
      addVat(vat, this.items);
    },
    removeViewFromItems: function removeViewFromItems() {
      var _this7 = this;

      this.massRemoveViews = false;
      var removeView = function removeView(view, items) {
        items.forEach(function (item) {
          var currentViews = item.views;
          if (!currentViews) return;
          var currentIndex = currentViews.indexOf(view);
          if (currentIndex !== -1) {
            currentViews.splice(currentIndex, 1);
          }
          _this7.$set(item, 'views', currentViews);
          if (item.items) {
            removeView(view, item.items);
          }
        });
      };
      removeView(this.selectedView, this.items);
      this.views = this.views.filter(function (view) {
        return view.viewId !== _this7.selectedView;
      });
      this.viewsIds = this.viewsIds.filter(function (view) {
        return view !== _this7.selectedView;
      });
      this.selectedView = null;
    },
    addViewsToItems: function addViewsToItems(views) {
      var _this8 = this;

      this.massAddViews = false;
      var addViews = function addViews(selectedViews, items) {
        items.forEach(function (item) {
          var currentViews = item.views;
          var addedViews = [];
          if (!currentViews) {
            _this8.$set(item, 'views', selectedViews);
          } else {
            addedViews.push.apply(addedViews, __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_toConsumableArray___default()(currentViews));
            selectedViews.forEach(function (view) {
              if (!addedViews.includes(view)) {
                addedViews.push(view);
              }
            });
            _this8.$set(item, 'views', addedViews);
          }
          if (item.items) {
            addViews(selectedViews, item.items);
          }
        });
      };
      addViews(views, this.items);
    },
    removeAllergenFromItems: function removeAllergenFromItems() {
      var _this9 = this;

      this.massRemoveAllergens = false;
      var removeAllergen = function removeAllergen(allergen, items) {
        items.forEach(function (item) {
          var currentAllergens = item.allergens;
          if (!currentAllergens) return;
          var currentIndex = currentAllergens.indexOf(allergen);
          if (currentIndex !== -1) {
            currentAllergens.splice(currentIndex, 1);
          }
          _this9.$set(item, 'allergens', currentAllergens);
          if (item.items) {
            removeAllergen(allergen, item.items);
          }
        });
      };
      removeAllergen(this.selectedAllergen, this.items);
      this.allergens = this.allergens.filter(function (allergen) {
        return allergen.allergenId !== _this9.selectedAllergen;
      });
      this.allergensIds = this.allergensIds.filter(function (allergen) {
        return allergen !== _this9.selectedAllergen;
      });
      this.selectedAllergen = null;
    },
    addAllergensToItems: function addAllergensToItems(allergens) {
      var _this10 = this;

      this.massAddAllergens = false;
      var addAllergens = function addAllergens(selectedAllergens, items) {
        items.forEach(function (item) {
          var currentAllergens = item.allergens;
          var addedAllergens = [];
          if (!currentAllergens) {
            _this10.$set(item, 'allergens', selectedAllergens);
          } else {
            addedAllergens.push.apply(addedAllergens, __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_toConsumableArray___default()(currentAllergens));
            selectedAllergens.forEach(function (allergen) {
              if (!addedAllergens.includes(allergen)) {
                addedAllergens.push(allergen);
              }
            });
            _this10.$set(item, 'allergens', addedAllergens);
          }
          if (item.items) {
            addAllergens(selectedAllergens, item.items);
          }
        });
      };
      addAllergens(allergens, this.items);
    },
    addPrintersToItems: function addPrintersToItems(printers) {
      this.massAddPrinters = false;
      var addPrinters = function addPrinters(selectedPrinters, items) {
        items.forEach(function (item) {
          var currentPrinters = item.printerCategories;
          var addedPrinters = [];
          if (!currentPrinters) {
            __WEBPACK_IMPORTED_MODULE_9_vue__["default"].set(item, 'printerCategories', selectedPrinters);
          } else {
            addedPrinters.push.apply(addedPrinters, __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_toConsumableArray___default()(currentPrinters));
            selectedPrinters.forEach(function (view) {
              if (!addedPrinters.includes(view)) {
                addedPrinters.push(view);
              }
            });
            __WEBPACK_IMPORTED_MODULE_9_vue__["default"].set(item, 'printerCategories', addedPrinters);
          }
          if (item.items) {
            addPrinters(selectedPrinters, item.items);
          }
        });
      };
      addPrinters(printers, this.items);
    },
    massTranslate: function massTranslate(data) {
      this.massLangModal = false;
      var massTrans = function massTrans(transData, items) {
        items.forEach(function (item) {
          if (item.name && item.name[transData.inputLang]) {
            if (item.name[transData.outputLang] && transData.scope[1].selected) {
              item.name[transData.outputLang] = item.name[transData.inputLang];
            } else if (!item.name[transData.outputLang]) {
              item.name[transData.outputLang] = item.name[transData.inputLang];
            }
          }

          if (item.abbr && item.abbr[transData.inputLang]) {
            if (item.abbr[transData.outputLang] && transData.scope[0].selected) {
              item.abbr[transData.outputLang] = item.abbr[transData.inputLang];
            } else if (!item.abbr[transData.outputLang]) {
              item.abbr[transData.outputLang] = item.abbr[transData.inputLang];
            }
          }

          if (item.desc && item.desc[transData.inputLang]) {
            if (item.desc[transData.outputLang] && transData.scope[2].selected) {
              item.desc[transData.outputLang] = item.desc[transData.inputLang];
            } else if (!item.desc[transData.outputLang]) {
              item.desc[transData.outputLang] = item.desc[transData.inputLang];
            }
          }

          if (item.sizes) {
            item.sizes.forEach(function (size) {
              if (size.name && size.name[transData.inputLang]) {
                if (size.name[transData.outputLang] && transData.scope[3].selected) {
                  size.name[transData.outputLang] = size.name[transData.inputLang];
                } else if (!size.name[transData.outputLang]) {
                  size.name[transData.outputLang] = size.name[transData.inputLang];
                }
              }
            });
          }

          if (item.options) {
            item.options.forEach(function (option) {
              if (option.name && option.name[transData.inputLang]) {
                if (option.name[transData.outputLang] && transData.scope[4].selected) {
                  option.name[transData.outputLang] = option.name[transData.inputLang];
                } else if (!option.name[transData.outputLang]) {
                  option.name[transData.outputLang] = option.name[transData.inputLang];
                }
              }
            });
          }

          if (item.variants) {
            item.variants.forEach(function (variant) {
              if (variant.name && variant.name[transData.inputLang]) {
                if (variant.name[transData.outputLang] && transData.scope[5].selected) {
                  variant.name[transData.outputLang] = variant.name[transData.inputLang];
                } else if (!variant.name[transData.outputLang]) {
                  variant.name[transData.outputLang] = variant.name[transData.inputLang];
                }
              }
            });
          }

          if (item.styles) {
            item.styles.forEach(function (style) {
              if (style.name && style.name[transData.inputLang]) {
                if (style.name[transData.outputLang] && transData.scope[6].selected) {
                  style.name[transData.outputLang] = style.name[transData.inputLang];
                } else if (!style.name[transData.outputLang]) {
                  style.name[transData.outputLang] = style.name[transData.inputLang];
                }
              }
            });
          }
          if (item.items) {
            massTrans(data, item.items);
          }
        });
      };
      massTrans(data, this.items);
    },
    removePrintersFromItems: function removePrintersFromItems(printers) {
      this.massRemovePrinters = false;
      var removePrinters = function removePrinters(selectedPrinters, items) {
        items.forEach(function (item) {
          if (item.printerCategories) {
            var currentPrinters = item.printerCategories.slice();
            selectedPrinters.forEach(function (printer) {
              var found = currentPrinters.findIndex(function (current) {
                return current === printer;
              });
              if (found !== -1) {
                currentPrinters.splice(found, 1);
              }
            });
            __WEBPACK_IMPORTED_MODULE_9_vue__["default"].set(item, 'printerCategories', currentPrinters);
          }
          if (item.items) {
            removePrinters(selectedPrinters, item.items);
          }
        });
      };
      removePrinters(printers, this.items);
    },
    selectCompany: function selectCompany(company) {
      this.openCompanies = false;
      this.filter = '';
      this.selectedCompany = company;
      this.show = false;
    },
    setMaxItemId: function setMaxItemId(val) {
      if (this.maxItemId < val) {
        this.maxItemId = val;
      }
    },
    addItemEvent: function addItemEvent(event) {
      this.currentItemEvent = 'add';
      this.actionPath = event[0];
      this.plusOne = event[1];
      this.itemModal = true;
    },
    editItemEvent: function editItemEvent(event) {
      this.currentItemEvent = 'edit';
      this.actionPath = event[0];
      this.plusOne = event[1];
      this.itemModal = true;
    },
    addAllergen: function addAllergen(event) {
      this.allergens.push(event);
      // this.viewsIds.push(event.viewId);
    },
    editAllergenToggle: function editAllergenToggle() {
      if (this.allergens.length > 0) return;
      this.editAllergen = true;
    },
    editAllergen: function editAllergen(allergen, index) {
      this.currentAllergen = {
        allergen: allergen,
        index: index
      };
      this.editAllergens = true;
    },
    editAllergenSubmit: function editAllergenSubmit(event) {
      this.allergens[event.index] = event.allergen;
    },
    deleteAllergen: function deleteAllergen(allergenId) {
      this.selectedAllergen = allergenId;
      this.massRemoveAllergens = true;
    },
    addView: function addView(event) {
      var _selectedOrderTypes;

      this.views.push(event);
      (_selectedOrderTypes = this.selectedOrderTypes).push.apply(_selectedOrderTypes, __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_toConsumableArray___default()(event.orderTypes));
      // this.viewsIds.push(event.viewId);
    },
    editViewToggle: function editViewToggle() {
      if (this.views.length > 0) return;
      this.editViews = true;
    },
    editView: function editView(view, index) {
      this.currentView = {
        view: view,
        index: index
      };
      this.editViews = true;
    },
    editViewSubmit: function editViewSubmit(event) {
      var _selectedOrderTypes2;

      this.views = this.views.map(function (view) {
        return __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_extends___default()({}, view, {
          isDefault: false
        });
      });
      this.views[event.index] = event.view;
      (_selectedOrderTypes2 = this.selectedOrderTypes).push.apply(_selectedOrderTypes2, __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_toConsumableArray___default()(event.view.orderTypes));
    },
    changeSelectedOrderTypes: function changeSelectedOrderTypes(event) {
      var tempIndex = this.selectedOrderTypes.indexOf(event);
      if (tempIndex === -1) this.selectedOrderTypes.push(event);
      if (tempIndex > -1) this.selectedOrderTypes.splice(tempIndex, 1);
    },
    deleteView: function deleteView(viewId) {
      this.selectedView = viewId;
      this.massRemoveViews = true;
    },
    addItem: function addItem(event, itemData) {
      this.taxCategories.push(event.taxCategory);
      this.taxCategories = this.taxCategories.filter(this.onlyUnique);
      if (this.currentItemEvent === 'edit') {
        this.editItem(event);
        return;
      }
      if (this.currentItemEvent === 'add') {
        this.itemsIds.push(event.itemId);
      }
      if (this.actionPath !== null) {
        this.addItemToChild(__WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_extends___default()({}, event, { open: true }));
        return;
      }
      var goDeeper = function goDeeper(item, indexes) {
        if (indexes.length > 0) {
          var postition = indexes.length - 1;
          var index = indexes[postition];
          indexes.splice(postition, 1);
          var target = indexes.length === 0 ? item[index] : item[index].items;
          return goDeeper(target, indexes);
        }
        return item;
      };
      if (this.selectedItem === null) {
        this.items.push(__WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_extends___default()({}, event, { open: true }));
      } else {
        var indexes = this.selectedItem;
        var item = goDeeper(this.items, indexes);
        if (item.items) {
          var items = item.items;
          items.push(__WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_extends___default()({}, event, { open: true }));
          __WEBPACK_IMPORTED_MODULE_9_vue__["default"].set(item, 'items', items);
        } else {
          __WEBPACK_IMPORTED_MODULE_9_vue__["default"].set(item, 'items', [__WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_extends___default()({}, event, { open: true })]);
        }
      }
    },
    editItem: function editItem(event) {
      return;
    },
    addItemToChild: function addItemToChild(event) {
      this.select(this.actionPath);
      var addToTarget = function addToTarget(target, list, item) {
        if (list.length === 0) {
          if (!target.items) {
            __WEBPACK_IMPORTED_MODULE_9_vue__["default"].set(target, 'items', [item]);
          } else {
            var items = target.items;
            items.push(item);
            __WEBPACK_IMPORTED_MODULE_9_vue__["default"].set(target, 'items', items);
          }
          return true;
        }
        var position = list.length - 1;
        var index = list[position];
        list.splice(position, 1);
        var newTarget = target.items[index];
        return addToTarget(newTarget, list, item);
      };
      var position = this.actionPath.length - 1;
      var current = this.actionPath[position];
      this.actionPath.splice(position, 1);
      addToTarget(this.items[current], this.actionPath, event);
      this.actionPath = null;
    },
    deselectSiblings: function deselectSiblings(target, list, select) {
      if (this.initToggle) {
        __WEBPACK_IMPORTED_MODULE_9_vue__["default"].set(target, 'selected', true);
      }
      if (list.length === 1) {
        var _position = list[0];
        var deselected = target.items.map(function (current, index) {
          var item = current;
          if (select) {
            item.selected = _position === index;
            return item;
          }
          item.selected = false;
          return item;
        });
        __WEBPACK_IMPORTED_MODULE_9_vue__["default"].set(target, 'items', deselected);
        return true;
      }
      var position = list.length - 1;
      var index = list[position];
      list.splice(position, 1);
      var newTarget = target.items[index];
      return this.deselectSiblings(newTarget, list, select);
    },
    deselectAll: function deselectAll() {
      var _this11 = this;

      var items = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.items;
      var value = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

      items.forEach(function (item) {
        _this11.$set(item, 'selected', value);
        if (item.items) _this11.deselectAll(item.items, value);
      });
    },
    openAll: function openAll() {
      var _this12 = this;

      var items = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.items;
      var value = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

      items.forEach(function (item) {
        _this12.$set(item, 'open', value);
        if (item.items) _this12.openAll(item.items, value);
      });
    },
    select: function select(event) {
      var data = void 0;
      this.deselectAll();
      var eventFiltered = null;
      if (typeof event[1] === 'boolean') {
        eventFiltered = event[0];
      } else {
        eventFiltered = event;
      }
      if (!eventFiltered.path) {
        data = {
          path: JSON.parse(__WEBPACK_IMPORTED_MODULE_8_babel_runtime_core_js_json_stringify___default()(eventFiltered)),
          select: true
        };
      } else {
        data = JSON.parse(__WEBPACK_IMPORTED_MODULE_8_babel_runtime_core_js_json_stringify___default()(eventFiltered));
      }
      this.selectedItem = data.path;
      if (data.path.length === 1) {
        this.items = this.items.map(function (current, index) {
          var item = current;
          item.selected = index === data.path[0];
          return item;
        });
      } else {
        var position = this.selectedItem.length - 1;
        var current = this.selectedItem[position];
        this.selectedItem.splice(position, 1);
        this.deselectSiblings(this.items[current], this.selectedItem, data.select);
      }
      this.selectedItem = null;
    },
    copy: function copy(event) {
      delete event['itemId'];
      this.copyItemData = event;
      localStorage.copyItemData = __WEBPACK_IMPORTED_MODULE_8_babel_runtime_core_js_json_stringify___default()(event);
    },
    copyItem: function copyItem(event) {
      event[0].reverse();
      if (event[0].length === 1) {
        var tempItem = JSON.parse(__WEBPACK_IMPORTED_MODULE_8_babel_runtime_core_js_json_stringify___default()(this.items[event[0][0]]));
        if (tempItem.items) {
          delete tempItem['items'];
        }
        tempItem.itemId = this.maxItemId + 1;
        this.items.push(tempItem);
      } else {
        var parent = this.items;
        var child = {};
        for (var i = 0; i < event[0].length; i += 1) {
          if (i !== event[0].length - 1) {
            parent = parent[event[0][i]].items;
          } else {
            child = parent[event[0][i]];
          }
        }
        var tempChild = JSON.parse(__WEBPACK_IMPORTED_MODULE_8_babel_runtime_core_js_json_stringify___default()(child));
        tempChild.itemId = this.maxItemId + 1;
        if (tempChild.items) {
          delete tempChild['items'];
        }
        parent.push(tempChild);
      }
    },
    massRemoveShow: function massRemoveShow(event) {
      this.massRemoveDataTree = event[0];
      this.massRemoveDataTree.reverse();
      var startItem = this.items[this.massRemoveDataTree[0]];
      if (this.massRemoveDataTree.length > 1) {
        for (var i = 1; i < this.massRemoveDataTree.length; i += 1) {
          startItem = startItem.items[this.massRemoveDataTree[i]];
        }
      }
      var viewsInTree = [];
      var printCategoriesInTree = [];
      viewsInTree.push(startItem.views);
      printCategoriesInTree.push(startItem.printerCategories);
      var addChildrenProperties = function addChildrenProperties(items) {
        items.forEach(function (item) {
          viewsInTree.push(item.views);
          printCategoriesInTree.push(item.printerCategories);
          if (item.items && item.items.length > 0) {
            addChildrenProperties(item.items);
          }
        });
      };
      if (startItem.items && startItem.items.length > 0) addChildrenProperties(startItem.items);
      viewsInTree = viewsInTree.flat(Infinity).filter(this.onlyUnique);
      printCategoriesInTree = printCategoriesInTree.flat(Infinity).filter(this.onlyUnique);
      this.viewsTree = viewsInTree;
      this.printCategoriesTree = printCategoriesInTree;
      this.massRemoveModalTree = true;
    },
    massRemove: function massRemove(event) {
      var startItem = this.items[event.item[0]];
      if (event.item.length > 1) {
        for (var i = 1; i < event.item.length; i += 1) {
          startItem = startItem.items[event.item[i]];
        }
      }
      if (event.type === 'views' || event.type === 'printerCategories') {
        startItem[event.type] = startItem[event.type].filter(function (x) {
          return !event.value.includes(x);
        });
      }
      if (startItem.items) {
        var massUpdateChildren = function massUpdateChildren(items) {
          items.forEach(function (item) {
            if (event.type === 'views' || event.type === 'printerCategories') {
              item[event.type] = item[event.type].filter(function (x) {
                return !event.value.includes(x);
              });
            }
            if (item.items && item.items.length > 0) {
              massUpdateChildren(item.items);
            }
          });
        };
        massUpdateChildren(startItem.items);
      }
      this.massRemoveDataTree = null;
      this.massRemoveModalTree = false;
    },
    massAddShow: function massAddShow(event) {
      this.massAddData = event[0];
      this.massAddModal = true;
    },
    formatAddItemsChildren: function formatAddItemsChildren(id) {
      var found = null;
      var findItem = function findItem(items) {
        items.forEach(function (item) {
          if (item.itemId === id) found = JSON.parse(__WEBPACK_IMPORTED_MODULE_8_babel_runtime_core_js_json_stringify___default()(item));
          if (item.items && item.items.length > 0 && !found) {
            findItem(item.items);
          }
        });
      };
      findItem(this.items);
      if (found && found.items && found.items.length > 0) {
        var tempMaxId = this.maxItemId;
        var loopItems = function loopItems(items) {
          items.forEach(function (item) {
            item.itemId = tempMaxId + 1;
            tempMaxId += 1;
            if (item.items && item.items.length > 0 && !found) {
              loopItems(item.items);
            }
          });
        };
        loopItems(found.items);
        return found.items;
      } else {
        return [];
      }
    },
    massAdd: function massAdd(event) {
      var _this13 = this;

      event.item.reverse();
      var startItem = this.items[event.item[0]];
      if (event.item.length > 1) {
        for (var i = 1; i < event.item.length; i += 1) {
          startItem = startItem.items[event.item[i]];
        }
      }
      if (event.type === 'views') {
        startItem[event.type] = startItem[event.type].concat(event.value);
        startItem[event.type] = startItem[event.type].filter(this.onlyUnique);
      } else if (event.type === 'printerCategories') {
        startItem[event.type] = startItem[event.type].concat(event.value);
        startItem[event.type] = startItem[event.type].filter(this.onlyUnique);
      } else if (event.type === 'settings' && event.value.length > 0) {
        event.value.forEach(function (property) {
          if (property === 'labelPrint') {
            startItem.settings.labelPrint = true;
          }
          if (property === 'askDetails') {
            startItem.settings.askDetails = true;
          }
          if (property === 'vatPrint') {
            startItem.vatPrint = true;
          }
          if (property === 'noDiscount') {
            startItem.noDiscount = true;
          }
          if (property === 'galaxyCardBalance') {
            startItem.galaxyCardBalance = true;
          }
        });
      } else if (event.type === 'sizes') {
        var obj = {
          isDefault: event.value.isDefault,
          price: Number(event.value.price),
          name: {}
        };
        if (event.value.en) obj.name.en = event.value.en;
        if (event.value.de) obj.name.de = event.value.de;
        if (event.value.zh) obj.name.zh = event.value.zh;
        if (startItem[event.type] && startItem[event.type].length > 0) {
          var isThere = false;
          startItem[event.type].forEach(function (current) {
            if (obj.isDefault) current.isDefault = false;
            if (current.name[_this13.selectedCompanyInfo.defaultLanguage] === obj.name[_this13.selectedCompanyInfo.defaultLanguage]) {
              current = obj;
              isThere = true;
            }
          });
          if (!isThere) {
            if (startItem[event.type]) {
              startItem[event.type].push(obj);
            } else {
              startItem[event.type] = obj;
            }
          }
        } else {
          startItem[event.type] = [obj];
        }
      } else if (event.type === 'variants') {
        var _obj = {
          isDefault: event.value.isDefault,
          price: Number(event.value.price),
          name: {}
        };
        if (event.value.en) _obj.name.en = event.value.en;
        if (event.value.de) _obj.name.de = event.value.de;
        if (event.value.zh) _obj.name.zh = event.value.zh;
        if (startItem[event.type] && startItem[event.type].length > 0) {
          var _isThere = false;
          startItem[event.type].forEach(function (current) {
            if (_obj.isDefault) current.isDefault = false;
            if (current.name[_this13.selectedCompanyInfo.defaultLanguage] === _obj.name[_this13.selectedCompanyInfo.defaultLanguage]) {
              current = _obj;
              _isThere = true;
            }
          });
          if (!_isThere) {
            if (startItem[event.type]) {
              startItem[event.type].push(_obj);
            } else {
              startItem[event.type] = _obj;
            }
          }
        } else {
          startItem[event.type] = [_obj];
        }
      } else if (event.type === 'options') {
        var _obj2 = {
          isDefault: event.value.isDefault,
          price: Number(event.value.price),
          name: {}
        };
        if (event.value.en) _obj2.name.en = event.value.en;
        if (event.value.de) _obj2.name.de = event.value.de;
        if (event.value.zh) _obj2.name.zh = event.value.zh;
        if (startItem[event.type] && startItem[event.type].length > 0) {
          var _isThere2 = false;
          startItem[event.type].forEach(function (current) {
            if (_obj2.isDefault) current.isDefault = false;
            if (current.name[_this13.selectedCompanyInfo.defaultLanguage] === _obj2.name[_this13.selectedCompanyInfo.defaultLanguage]) {
              current = _obj2;
              _isThere2 = true;
            }
          });
          if (!_isThere2) {
            if (startItem[event.type]) {
              startItem[event.type].push(_obj2);
            } else {
              startItem[event.type] = _obj2;
            }
          }
        } else {
          startItem[event.type] = [_obj2];
        }
      } else if (event.type === 'styles') {
        var _obj3 = {
          isDefault: event.value.isDefault,
          name: {}
        };
        if (event.value.en) _obj3.name.en = event.value.en;
        if (event.value.de) _obj3.name.de = event.value.de;
        if (event.value.zh) _obj3.name.zh = event.value.zh;
        if (startItem[event.type] && startItem[event.type].length > 0) {
          var _isThere3 = false;
          startItem[event.type].forEach(function (current) {
            if (_obj3.isDefault) current.isDefault = false;
            if (current.name[_this13.selectedCompanyInfo.defaultLanguage] === _obj3.name[_this13.selectedCompanyInfo.defaultLanguage]) {
              current = _obj3;
              _isThere3 = true;
            }
          });
          if (!_isThere3) {
            if (startItem[event.type]) {
              startItem[event.type].push(_obj3);
            } else {
              startItem[event.type] = _obj3;
            }
          }
        } else {
          startItem[event.type] = [_obj3];
        }
      } else if (event.type === 'items') {
        var itemsFormatted = this.formatAddItemsChildren(event.value);
        if (startItem.items) {
          startItem.items = [].concat(__WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_toConsumableArray___default()(startItem.items), __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_toConsumableArray___default()(itemsFormatted));
        } else {
          startItem.items = itemsFormatted;
        }
        this.notLoading = false;
        this.items = JSON.parse(__WEBPACK_IMPORTED_MODULE_8_babel_runtime_core_js_json_stringify___default()(this.items));
        setTimeout(function () {
          _this13.notLoading = true;
        }, 500);
      } else {
        startItem[event.type] = event.value;
      }
      if (startItem.items && event.type !== 'items') {
        var massUpdateChildren = function massUpdateChildren(items) {
          items.forEach(function (item) {
            if (event.type === 'views') {
              item[event.type] = item[event.type].concat(event.value);
              item[event.type] = item[event.type].filter(_this13.onlyUnique);
            } else if (event.type === 'printerCategories') {
              item[event.type] = item[event.type].concat(event.value);
              item[event.type] = item[event.type].filter(_this13.onlyUnique);
            } else if (event.type === 'settings' && event.value.length > 0) {
              event.value.forEach(function (property) {
                if (property === 'labelPrint') {
                  item.settings.labelPrint = true;
                }
                if (property === 'askDetails') {
                  item.settings.askDetails = true;
                }
                if (property === 'vatPrint') {
                  item.vatPrint = true;
                }
                if (property === 'noDiscount') {
                  item.noDiscount = true;
                }
                if (property === 'galaxyCardBalance') {
                  item.galaxyCardBalance = true;
                }
              });
            } else if (event.type === 'sizes') {
              var _obj4 = {
                isDefault: event.value.isDefault,
                price: Number(event.value.price),
                name: {}
              };
              if (event.value.en) _obj4.name.en = event.value.en;
              if (event.value.de) _obj4.name.de = event.value.de;
              if (event.value.zh) _obj4.name.zh = event.value.zh;
              if (item[event.type] && item[event.type].length > 0) {
                var _isThere4 = false;
                item[event.type].forEach(function (current) {
                  if (_obj4.isDefault) current.isDefault = false;
                  if (current.name[_this13.selectedCompanyInfo.defaultLanguage] === _obj4.name[_this13.selectedCompanyInfo.defaultLanguage]) {
                    current = _obj4;
                    _isThere4 = true;
                  }
                });
                if (!_isThere4) {
                  if (item[event.type]) {
                    item[event.type].push(_obj4);
                  } else {
                    item[event.type] = _obj4;
                  }
                }
              } else {
                item[event.type] = [_obj4];
              }
            } else if (event.type === 'variants') {
              var _obj5 = {
                isDefault: event.value.isDefault,
                price: Number(event.value.price),
                name: {}
              };
              if (event.value.en) _obj5.name.en = event.value.en;
              if (event.value.de) _obj5.name.de = event.value.de;
              if (event.value.zh) _obj5.name.zh = event.value.zh;
              if (item[event.type] && item[event.type].length > 0) {
                var _isThere5 = false;
                item[event.type].forEach(function (current) {
                  if (_obj5.isDefault) current.isDefault = false;
                  if (current.name[_this13.selectedCompanyInfo.defaultLanguage] === _obj5.name[_this13.selectedCompanyInfo.defaultLanguage]) {
                    current = _obj5;
                    _isThere5 = true;
                  }
                });
                if (!_isThere5) {
                  if (item[event.type]) {
                    item[event.type].push(_obj5);
                  } else {
                    item[event.type] = _obj5;
                  }
                }
              } else {
                item[event.type] = [_obj5];
              }
            } else if (event.type === 'options') {
              var _obj6 = {
                isDefault: event.value.isDefault,
                price: Number(event.value.price),
                name: {}
              };
              if (event.value.en) _obj6.name.en = event.value.en;
              if (event.value.de) _obj6.name.de = event.value.de;
              if (event.value.zh) _obj6.name.zh = event.value.zh;
              if (item[event.type] && item[event.type].length > 0) {
                var _isThere6 = false;
                item[event.type].forEach(function (current) {
                  if (_obj6.isDefault) current.isDefault = false;
                  if (current.name[_this13.selectedCompanyInfo.defaultLanguage] === _obj6.name[_this13.selectedCompanyInfo.defaultLanguage]) {
                    current = _obj6;
                    _isThere6 = true;
                  }
                });
                if (!_isThere6) {
                  if (item[event.type]) {
                    item[event.type].push(_obj6);
                  } else {
                    item[event.type] = _obj6;
                  }
                }
              } else {
                item[event.type] = [_obj6];
              }
            } else if (event.type === 'styles') {
              var _obj7 = {
                isDefault: event.value.isDefault,
                name: {}
              };
              if (event.value.en) _obj7.name.en = event.value.en;
              if (event.value.de) _obj7.name.de = event.value.de;
              if (event.value.zh) _obj7.name.zh = event.value.zh;
              if (item[event.type] && item[event.type].length > 0) {
                var _isThere7 = false;
                item[event.type].forEach(function (current) {
                  if (_obj7.isDefault) current.isDefault = false;
                  if (current.name[_this13.selectedCompanyInfo.defaultLanguage] === _obj7.name[_this13.selectedCompanyInfo.defaultLanguage]) {
                    current = _obj7;
                    _isThere7 = true;
                  }
                });
                if (!_isThere7) {
                  if (item[event.type]) {
                    item[event.type].push(_obj7);
                  } else {
                    item[event.type] = _obj7;
                  }
                }
              } else {
                item[event.type] = [_obj7];
              }
            } else {
              item[event.type] = event.value;
            }
            if (item.items) {
              massUpdateChildren(item.items);
            }
          });
        };
        massUpdateChildren(startItem.items);
      }
      this.massAddData = null;
      this.massAddModal = false;
    },
    exportCsv: function exportCsv() {
      var _this14 = this;

      var csvContent = "data:text/csv;charset=utf-8,";
      var howDeep = 0;
      var buildCsv = function buildCsv(items) {
        items.forEach(function (item, index) {
          if (howDeep !== 0) {
            for (var i = 0; i < howDeep; i += 1) {
              csvContent += ';';
            }
          }
          csvContent += (item.name[_this14.$cookie.get('lang')] || item.name['en']) + '(' + item.itemId + ')' + '  -  ' + 'Views:' + _this14.formattedViews(item) + '  -  ' + 'Printer categories:' + _this14.formattedPrintCategories(item) + '  -  ' + 'Settings:' + _this14.formattedSettings(item) + '  -  ' + 'Tax category:' + item.taxCategory + "\n";
          if (item.items) {
            howDeep += 1;
            buildCsv(item.items);
          }
          if (index === items.length - 1) {
            howDeep -= 1;
          }
        });
      };

      buildCsv(this.items);

      var data = encodeURI(csvContent);
      var link = document.createElement("a");
      link.setAttribute("href", data);
      link.setAttribute("download", "export.csv");
      link.click();
    },
    deleteItem: function deleteItem(event) {
      var _this15 = this;

      var removeChildrenIDs = function removeChildrenIDs(item) {
        item.items.forEach(function (cItem) {
          if (cItem.items && cItem.items.length > 0) removeChildrenIDs(cItem);
          _this15.itemsIds = _this15.itemsIds.filter(function (id) {
            return id !== cItem.itemId;
          });
        });
      };
      var deleteItem = function deleteItem(target, list) {
        if (list.length === 1) {
          var _position2 = list[0];
          var deleted = target.items.filter(function (item, index) {
            if (index !== _position2) return item;
            if (item.items && item.items.length > 0) removeChildrenIDs(item);
            _this15.itemsIds = _this15.itemsIds.filter(function (id) {
              return id !== item.itemId;
            });
            return false;
          });
          __WEBPACK_IMPORTED_MODULE_9_vue__["default"].set(target, 'items', deleted);
          return true;
        }
        var position = list.length - 1;
        var index = list[position];
        list.splice(position, 1);
        var newTarget = target.items[index];
        return deleteItem(newTarget, list);
      };
      if (event[0].length === 1) {
        this.items = this.items.filter(function (item, index) {
          if (index !== event[0][0]) return item;
          if (item.items && item.items.length > 0) removeChildrenIDs(item);
          _this15.itemsIds = _this15.itemsIds.filter(function (id) {
            return id !== item.itemId;
          });
          return false;
        });
      } else {
        var position = event[0].length - 1;
        var current = event[0][position];
        event[0].splice(position, 1);
        deleteItem(this.items[current], event[0]);
      }
    },
    setIsDefault: function setIsDefault(items) {
      var _this16 = this;

      return __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator___default.a.mark(function _callee() {
        return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                items.forEach(function (item) {
                  ['styles', 'variants', 'sizes', 'options'].forEach(function (key) {
                    if (key === 'options' && item[key] && item[key].length > 0) {
                      item[key].forEach(function (opt) {
                        if (!opt.isDefault) _this16.$set(opt, 'isDefault', false);
                        if (opt.maxIncludedQuantity === undefined) {
                          _this16.$set(opt, 'maxIncludedQuantity', 0);
                        }
                      });
                    } else if (key === 'options' && item[key] && item[key].length === 0) {
                      delete item['options'];
                    }
                    if (item[key] && item[key].length === 1) {
                      _this16.$set(item[key][0], 'isDefault', true);
                    }
                  });
                  if (!item.taxCategory) {
                    item.taxCategory = 'none';
                  }
                  if (item.items) {
                    _this16.setIsDefault(item.items);
                  }
                  if (!item.quantityOfIncludedOptions) {
                    item.quantityOfIncludedOptions = 0;
                  }
                  if (!item.courseNo) {
                    item.courseNo = 6;
                  }
                });

              case 1:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this16);
      }))();
    },
    prepareImages: function prepareImages(items) {
      var _this17 = this;

      return __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator___default.a.mark(function _callee2() {
        var _iteratorNormalCompletion, _didIteratorError, _iteratorError, _iterator, _step, item;

        return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _iteratorNormalCompletion = true;
                _didIteratorError = false;
                _iteratorError = undefined;
                _context2.prev = 3;
                _iterator = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_get_iterator___default()(items);

              case 5:
                if (_iteratorNormalCompletion = (_step = _iterator.next()).done) {
                  _context2.next = 15;
                  break;
                }

                item = _step.value;

                if (!item.images || item.images.length === 0) delete item['images'];
                if (item.images) {
                  item.images.map(function (image) {
                    delete image["name"];
                    delete image["status"];
                    delete image["createdOn"];
                    delete image["createdBy"];
                    delete image["modifiedOn"];
                    delete image["modifiedBy"];
                    delete image["base64Image"];
                    delete image["companyId"];
                    if (image.id) {
                      image['value'] = image['id'];
                      delete image["id"];
                    }
                    return image;
                  });
                }

                if (!item.items) {
                  _context2.next = 12;
                  break;
                }

                _context2.next = 12;
                return _this17.prepareImages(item.items);

              case 12:
                _iteratorNormalCompletion = true;
                _context2.next = 5;
                break;

              case 15:
                _context2.next = 21;
                break;

              case 17:
                _context2.prev = 17;
                _context2.t0 = _context2['catch'](3);
                _didIteratorError = true;
                _iteratorError = _context2.t0;

              case 21:
                _context2.prev = 21;
                _context2.prev = 22;

                if (!_iteratorNormalCompletion && _iterator.return) {
                  _iterator.return();
                }

              case 24:
                _context2.prev = 24;

                if (!_didIteratorError) {
                  _context2.next = 27;
                  break;
                }

                throw _iteratorError;

              case 27:
                return _context2.finish(24);

              case 28:
                return _context2.finish(21);

              case 29:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, _this17, [[3, 17, 21, 29], [22,, 24, 28]]);
      }))();
    },
    createCatalog: function createCatalog() {
      var _this18 = this;

      return __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator___default.a.mark(function _callee3() {
        var data, openMoadal;
        return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _context3.next = 2;
                return _this18.removeErrors();

              case 2:
                _this18.validateBeforeCreateNewCatalog();
                _context3.next = 5;
                return _this18.setIsDefault(_this18.items);

              case 5:
                _context3.next = 7;
                return _this18.prepareImages(_this18.items);

              case 7:
                if (_this18.isCatalogValid) {
                  _context3.next = 9;
                  break;
                }

                return _context3.abrupt('return');

              case 9:
                _this18.creating = true;
                data = {
                  companyId: _this18.selectedCompany.id,
                  lastItemId: _this18.maxItemId,
                  lastViewId: _this18.maxViewId,
                  lastAllergenId: _this18.maxAllergenId,
                  itemsList: _this18.items,
                  views: _this18.views,
                  allergens: _this18.allergens
                };

                if (_this18.name) {
                  __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign___default()(data, { name: _this18.name });
                }
                if (_this18.selectedCompanyInfo && !_this18.selectedCompanyInfo.vatRates || _this18.selectedCompanyInfo.vatRates && _this18.selectedCompanyInfo.length === 0) {
                  data.itemsList = [].concat(__WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_toConsumableArray___default()(_this18.parsedItemList));
                }
                openMoadal = true;

                fetch(__WEBPACK_IMPORTED_MODULE_11__assets_url__["a" /* baseUrl */] + '/catalog/create', {
                  method: 'post',
                  credentials: 'include',
                  headers: {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json;charset=UTF-8'
                  },
                  body: __WEBPACK_IMPORTED_MODULE_8_babel_runtime_core_js_json_stringify___default()(data)
                }).then(function (response) {
                  return response.json();
                }).then(function (data) {
                  if (data.error && data.error === 'Forbidden') {
                    _this18.creating = false;
                    _this18.$router.push({ name: 'logOut' });
                    throw new Error('Failed to create catalog');
                  }
                  if (data.status === 'Failed') {
                    _this18.creating = false;
                    throw new Error(data.statusText);
                  }
                  _this18.err = '';
                  _this18.activationData = {
                    catalogId: data.catalogId,
                    companyId: _this18.selectedCompany.id
                  };
                  return _this18.$http.get('catalog/' + data.catalogId);
                }).catch(function (e) {
                  // this.$router.push({ name: "catalogList" });
                  _this18.err = 'Error ' + e;
                  openMoadal = false;
                  throw new Error('abort');
                }).then(function (res) {
                  if (res.body.status !== 'Success') {
                    throw new Error('Failed to fetch catalog');
                  }
                  var webview = _this18.getWebshopView();
                  if (!webview) return null;
                  _this18.activationData.catalogViewId = webview.viewId;
                  _this18.activationData.catalogVersion = res.body.catalog.version;
                  return _this18.$http.post('webshopresource/getall', { companyId: _this18.selectedCompany.id });
                }).then(function (res) {
                  if (res && res.body.status === 'Success') {
                    _this18.activationData.webshops = res.body.details.filter(function (webshop) {
                      return webshop.status === 'active';
                    });
                  }
                  _this18.showActivationModal = true;
                }).catch(function (err) {
                  if (openMoadal) {
                    _this18.showActivationModal = true;
                  }
                });

              case 15:
              case 'end':
                return _context3.stop();
            }
          }
        }, _callee3, _this18);
      }))();
    },
    closeActivation: function closeActivation() {
      this.showActivationModal = false;
      this.$router.push({ name: 'catalogList' });
    },
    validateBeforeCreateNewCatalog: function validateBeforeCreateNewCatalog() {
      var _this19 = this;

      //Validate for Unique Items Id
      if (!this.selectedCompany) {
        this.err = this.$lang.errors.youMustSelectCompany;
        this.isCatalogValid = false;
        return;
      } else {
        this.isCatalogValid = true;
      }
      if (__WEBPACK_IMPORTED_MODULE_12_lodash___default.a.uniq(this.itemsIds).length === this.itemsIds.length) {
        this.isCatalogValid = true;
        this.err = '';
      } else {
        this.notUniqItemsIds = __WEBPACK_IMPORTED_MODULE_12_lodash___default.a.transform(__WEBPACK_IMPORTED_MODULE_12_lodash___default.a.countBy(this.itemsIds), function (result, count, value) {
          if (count > 1) result.push(value);
        }, []);
        this.isCatalogValid = false;
        this.err = 'All item id\'s should be unique, id ' + this.notUniqItemsIds.toString() + ' is duplicated';
        return;
      }
      //Validate if View all views ids exist
      var uniqViewsId = __WEBPACK_IMPORTED_MODULE_12_lodash___default.a.uniq(this.viewsIds);
      // let uniqViewsId = uniqViewsIndexes.map((view)=> this.views[view].viewId );
      var existViewsId = this.views.map(function (view) {
        return view.viewId;
      });
      var notExistingViewsId = uniqViewsId.filter(function (e) {
        return !existViewsId.includes(e);
      });
      if (notExistingViewsId.length === 0) {
        this.isCatalogValid = true;
        this.err = '';
      } else {
        this.isCatalogValid = false;
        this.err = 'View with id ' + notExistingViewsId[0] + ' does not exist. Please remove it from items';
        return;
      }

      //Validate if View order types are used only once
      var tempViewOrderTypes = [];
      this.views = this.views.map(function (view) {
        if (view.orderTypes && view.orderTypes.length > 0) {
          view.orderTypes.forEach(function (type) {
            if (tempViewOrderTypes.includes(type)) {
              _this19.isCatalogValid = false;
              _this19.err = 'View Order Type \'' + type + '\' is duplicated in View: ' + (view.name.en || view.name.de) + ', please remove.';
            }
          });
          tempViewOrderTypes.push.apply(tempViewOrderTypes, __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_toConsumableArray___default()(view.orderTypes));
        }
        if (!view.orderTypes) view.orderTypes = [];
        return view;
      });
      if (this.err !== '') return;

      //Validate if vatRate exist in company


      //Valid current last Id is the highest
      if (Math.max.apply(Math, __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_toConsumableArray___default()(this.itemsIds)) > this.maxItemId) {
        this.isCatalogValid = false;
        this.err = 'The highest item id is not the highest';
        return;
      } else {
        this.isCatalogValid = true;
        this.err = '';
      }
      //Valid current view Id is the highest
      if (Math.max.apply(Math, __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_toConsumableArray___default()(uniqViewsId)) > this.maxViewId) {
        this.isCatalogValid = false;
        this.err = 'The highest view id is not the highest';
        return;
      } else {
        this.isCatalogValid = true;
        this.err = '';
      }

      // Valid if the last item have all required fields filled
      this.errors = [];
      this.parseAllItems(this.items);
      var sortedErrors = this.errors.sort(function (a, b) {
        if (a.itemName > b.itemName) return 1;else if (a.itemName < b.itemName) return -1;else return 0;
      });
      this.errors = sortedErrors;
    },
    fetchCatalog: function fetchCatalog() {
      var _this20 = this;

      fetch(__WEBPACK_IMPORTED_MODULE_11__assets_url__["a" /* baseUrl */] + '/catalog/' + this.$route.query.id, {
        method: 'get',
        credentials: 'include',
        headers: {
          'Accept': 'application/json',
          'Content-Type': 'application/json;charset=UTF-8'
        }
      }).then(function (response) {
        return response.json();
      }).then(function (data) {
        _this20.loaded = true;
        if (data.error && data.error === 'Forbidden') {
          _this20.$router.push({ name: 'logOut' });
          return;
        }
        if (!_this20.isLocalAdmin) {
          _this20.selectedCompany = _this20.companies.find(function (company) {
            return company.id === data.catalog.companyId;
          });
          _this20.currentCorporation = _this20.allCorporations.find(function (corporation) {
            return corporation.companies.includes(_this20.selectedCompany.id);
          });
        } else {
          _this20.selectedCompany = {
            id: data.catalog.companyId
          };
        }
        _this20.name = data.catalog.name;
        _this20.version = data.catalog.version;
        _this20.views = data.catalog.views;
        _this20.selectedOrderTypes = data.catalog.views.map(function (x) {
          return x.orderTypes;
        }).flat(Infinity).filter(_this20.onlyUnique);
        _this20.allergens = data.catalog.allergens || [];
        _this20.renderExistItems(data.catalog.itemsList);
        _this20.validateItemIds(_this20.items);
        if (!_this20.isLocalAdmin) {
          _this20.fetchCompany();
        }
      }).catch(function (err) {
        _this20.err = err.message || err.body.message;
        // this.loaded = true;
        // this.selectedCompany = this.companies.find(company => company.id === fetch_data.catalog.catalog.companyId);
        // this.views = fetch_data.catalog.catalog.views;
        // this.renderExistItems(fetch_data.catalog.catalog.itemsList);
        // this.fetchCompany()
      });
    },
    renderExistItems: function renderExistItems(itemsList) {
      var _this21 = this;

      var a = itemsList.map(function (item) {
        var itemRec = function itemRec(itemParent) {
          if (!itemParent.items) {
            var _viewsIds;

            var parentItem = itemParent;
            var updatedItem = __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_extends___default()({}, itemParent, {
              selected: false,
              parentItem: parentItem
            });
            if (itemParent.taxCategory) {
              _this21.taxCategories.push(itemParent.taxCategory);
            }
            _this21.itemsIds.push(itemParent.itemId);
            (_viewsIds = _this21.viewsIds).push.apply(_viewsIds, __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_toConsumableArray___default()(itemParent.views));
            if (itemParent.allergens) {
              var _allergensIds;

              (_allergensIds = _this21.allergensIds).push.apply(_allergensIds, __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_toConsumableArray___default()(itemParent.allergens));
            }
            return updatedItem;
          } else {
            var _viewsIds3;

            var childUpdated = itemParent.items.map(function (child) {
              if (!child.items) {
                var _viewsIds2;

                var _parentItem = itemParent;
                if (child.taxCategory) {
                  _this21.taxCategories.push(child.taxCategory);
                }
                _this21.itemsIds.push(child.itemId);
                (_viewsIds2 = _this21.viewsIds).push.apply(_viewsIds2, __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_toConsumableArray___default()(child.views));
                if (child.allergens) {
                  var _allergensIds2;

                  (_allergensIds2 = _this21.allergensIds).push.apply(_allergensIds2, __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_toConsumableArray___default()(child.allergens));
                }
                return __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_extends___default()({}, child, {
                  selected: false,
                  parentItem: _parentItem
                });
              } else {
                return itemRec(child);
              }
            });

            var _updatedItem = __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_extends___default()({}, itemParent, {
              items: [].concat(__WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_toConsumableArray___default()(childUpdated)),
              selected: false,
              parentItem: null
            });
            if (itemParent.taxCategory) {
              _this21.taxCategories.push(itemParent.taxCategory);
            }
            _this21.itemsIds.push(itemParent.itemId);
            (_viewsIds3 = _this21.viewsIds).push.apply(_viewsIds3, __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_toConsumableArray___default()(itemParent.views));
            if (itemParent.allergens) {
              var _allergensIds3;

              (_allergensIds3 = _this21.allergensIds).push.apply(_allergensIds3, __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_toConsumableArray___default()(itemParent.allergens));
            }
            return _updatedItem;
          }
        };
        var itemGood = itemRec(item);
        _this21.addItem(__WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_extends___default()({}, itemGood, { open: true }));
      });
      if (this.taxCategories.length > 0) {
        this.taxCategories = this.taxCategories.filter(this.onlyUnique);
        this.taxCategories = this.taxCategories.filter(function (el) {
          return el != null;
        });
      }
    },
    onlyUnique: function onlyUnique(value, index, self) {
      return self.indexOf(value) === index;
    },
    parentInherit: function parentInherit(childItem, parentItem, inheritProp) {
      if (!parentItem || parentItem === undefined) {
        return;
      } else {
        var _inheritFromParent2 = void 0;
        //inherit arrays
        if (inheritProp !== 'vatRate') {
          _inheritFromParent2 = function inheritFromParent(childItem, parentItem) {
            if ((!childItem[inheritProp] || childItem[inheritProp].length === 0) && parentItem[inheritProp] && parentItem[inheritProp].length !== 0) {
              childItem[inheritProp] = parentItem[inheritProp];
            } else if ((!childItem[inheritProp] || childItem[inheritProp].length === 0) && (!parentItem[inheritProp] || parentItem[inheritProp].length === 0) && parentItem.parentItem) {
              return _inheritFromParent2(childItem, parentItem.parentItem);
            }
          };
        } else {
          //inherit strings
          _inheritFromParent2 = function _inheritFromParent(childItem, parentItem) {
            if (childItem[inheritProp] || childItem[inheritProp] === 0) {
              return;
            }
            if ((!childItem[inheritProp] || childItem[inheritProp].length === 0) && parentItem[inheritProp] && parentItem[inheritProp].length !== 0) {
              childItem[inheritProp] = parentItem[inheritProp];
            } else if ((!childItem[inheritProp] || childItem[inheritProp].length === 0) && (!parentItem[inheritProp] || parentItem[inheritProp].length === 0) && parentItem.parentItem) {
              return _inheritFromParent2(childItem, parentItem.parentItem);
            }
          };
        }

        _inheritFromParent2(childItem, parentItem);
      }
    },
    parseAllItems: function parseAllItems(itemsList) {
      var _this22 = this;

      this.parsedItemList = itemsList.map(function (item) {
        var itemRec = function itemRec(itemParent) {
          if (!itemParent.items) {
            var updatedItem = __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_extends___default()({}, itemParent, {
              selected: false
            });
            if (!_this22.selectedCompanyInfo.vatRates || _this22.selectedCompanyInfo.vatRates && _this22.selectedCompanyInfo.vatRates === null) {
              updatedItem = __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_extends___default()({}, itemParent, {
                selected: false,
                vatRate: null
              });
            }
            _this22.requiredFieldsValidation(updatedItem, false);
            return updatedItem;
          } else {

            var childUpdated = itemParent.items.map(function (child) {
              if (!child.items) {
                var parsedChildItem = __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_extends___default()({}, child, {
                  selected: false
                });
                if (!_this22.selectedCompanyInfo.vatRates || _this22.selectedCompanyInfo.vatRates && _this22.selectedCompanyInfo.vatRates === null) {
                  parsedChildItem = __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_extends___default()({}, child, {
                    selected: false,
                    vatRate: null
                  });
                }
                _this22.requiredFieldsValidation(child, false);
                return parsedChildItem;
              } else {
                return itemRec(child);
              }
            });

            var _updatedItem2 = __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_extends___default()({}, itemParent, {
              items: [].concat(__WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_toConsumableArray___default()(childUpdated)),
              selected: false,
              parentItem: null
            });
            if (!_this22.selectedCompanyInfo.vatRates || _this22.selectedCompanyInfo.vatRates && _this22.selectedCompanyInfo.vatRates === null) {
              _updatedItem2 = __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_extends___default()({}, itemParent, {
                items: [].concat(__WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_toConsumableArray___default()(childUpdated)),
                selected: false,
                parentItem: null,
                vatRate: null
              });
            }
            _this22.requiredFieldsValidation(_updatedItem2, true);
            return _updatedItem2;
          }
        };
        var itemGood = itemRec(item);
        return itemGood;
      });
    },
    returnExistingName: function returnExistingName(name) {
      if (name[this.selectedCompanyInfo.defaultLanguage]) return name[this.selectedCompanyInfo.defaultLanguage];
      if (name.en) return name.en;
      if (name.de) return name.de;
      if (name.zh) return name.zh;
    },
    requiredFieldsValidation: function requiredFieldsValidation(item, all) {
      //Validate vatRate for all items
      var hasError = false;
      if (this.selectedCompanyInfo.vatRates && this.selectedCompanyInfo.vatRates.length > 0) {
        if (!item.vatRate && item.vatRate !== 0) {
          this.parentInherit(item, item.parentItem, 'vatRate');
          if (!item.vatRate && item.vatRate !== 0) {
            var errMessage = 'Item with name ' + item.name.en + ' dont have required field vatRate';
            var error = {
              itemName: item.name.en,
              message: errMessage
            };
            this.errors.push(error);
            this.isCatalogValid = false;
            hasError = true;
          }
        } else if (item.vatRate || item.vatRate === 0) {
          if (this.selectedCompanyInfo.vatRates.indexOf(+item.vatRate) === -1) {
            var _errMessage = 'Item ' + item.name.en + ' with Id ' + item.itemId + ': the vat rate ' + item.vatRate + ' is not set for the company';
            var _error = {
              itemName: item.name.en,
              message: _errMessage
            };
            this.errors.push(_error);
            this.isCatalogValid = false;
            hasError = true;
          } else if (item.vatRate > 100) {
            var _errMessage2 = 'Item ' + item.name.en + ' with Id ' + item.itemId + ': the vat rate ' + item.vatRate + ' is higher than 100';
            var _error2 = {
              itemName: item.name.en,
              message: _errMessage2
            };
            this.errors.push(_error2);
            this.isCatalogValid = false;
            hasError = true;
          } else if (item.vaRate < 0) {
            var _errMessage3 = 'Item ' + item.name.en + ' with Id ' + item.itemId + ': the vat rate ' + item.vatRate + ' is lower than 0';
            var _error3 = {
              itemName: item.name.en,
              message: _errMessage3
            };
            this.errors.push(_error3);
            this.isCatalogValid = false;
            hasError = true;
          }
        }
      }

      // Remove empty Description
      if (item.desc && __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default()(item.desc).length > 0) {
        var tempObjKeys = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default()(item.desc);
        for (var i = 0; i < tempObjKeys.length; i += 1) {
          if (item.desc[tempObjKeys[i]] === '') delete item.desc[tempObjKeys[i]];
        }
        if (__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default()(item.desc).length === 0) delete item['desc'];
      }

      // Remove empty Abbr
      if (item.abbr && __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default()(item.abbr).length > 0) {
        var _tempObjKeys = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default()(item.abbr);
        for (var _i = 0; _i < _tempObjKeys.length; _i += 1) {
          if (item.abbr[_tempObjKeys[_i]] === '') delete item.abbr[_tempObjKeys[_i]];
        }
        if (__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default()(item.abbr).length === 0) delete item['abbr'];
      }

      //Validate Default language for all items
      if (item.desc && __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default()(item.desc).length !== 0 && item.desc.constructor === Object && !item.desc[this.selectedCompanyInfo.defaultLanguage]) {
        var _errMessage4 = 'Item with name ' + this.returnExistingName(item.name) + ' (ID: ' + item.itemId + ') doesn\'t have Description in default language';
        var _error4 = {
          itemName: item.name.en,
          message: _errMessage4
        };
        this.errors.push(_error4);
        this.isCatalogValid = false;
        hasError = true;
      }
      if (item.abbr && __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default()(item.abbr).length !== 0 && item.abbr.constructor === Object && !item.abbr[this.selectedCompanyInfo.defaultLanguage]) {
        var _errMessage5 = 'Item with name ' + this.returnExistingName(item.name) + ' (ID: ' + item.itemId + ') doesn\'t have Abbreviation in default language';
        var _error5 = {
          itemName: item.name.en,
          message: _errMessage5
        };
        this.errors.push(_error5);
        this.isCatalogValid = false;
        hasError = true;
      }
      if (item.name && !item.name[this.selectedCompanyInfo.defaultLanguage]) {
        var _errMessage6 = 'Item with ID ' + item.itemId + ' doesn\'t have Name in default language';
        var _error6 = {
          itemName: item.name.en,
          message: _errMessage6
        };
        this.errors.push(_error6);
        this.isCatalogValid = false;
        hasError = true;
      }
      if (item.sizes && item.sizes.length > 0) {
        var _iteratorNormalCompletion2 = true;
        var _didIteratorError2 = false;
        var _iteratorError2 = undefined;

        try {
          for (var _iterator2 = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_get_iterator___default()(item.sizes), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
            var size = _step2.value;

            if (size.name && !size.name[this.selectedCompanyInfo.defaultLanguage]) {
              var _errMessage7 = 'Item with name ' + this.returnExistingName(item.name) + ' (ID: ' + item.itemId + ') doesn\'t have Size \'' + this.returnExistingName(size.name) + '\' name in default language';
              var _error7 = {
                itemName: item.name.en,
                message: _errMessage7
              };
              this.errors.push(_error7);
              this.isCatalogValid = false;
              hasError = true;
            }
          }
        } catch (err) {
          _didIteratorError2 = true;
          _iteratorError2 = err;
        } finally {
          try {
            if (!_iteratorNormalCompletion2 && _iterator2.return) {
              _iterator2.return();
            }
          } finally {
            if (_didIteratorError2) {
              throw _iteratorError2;
            }
          }
        }
      }
      if (item.styles && item.styles.length > 0) {
        var _iteratorNormalCompletion3 = true;
        var _didIteratorError3 = false;
        var _iteratorError3 = undefined;

        try {
          for (var _iterator3 = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_get_iterator___default()(item.styles), _step3; !(_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done); _iteratorNormalCompletion3 = true) {
            var style = _step3.value;

            if (style.name && !style.name[this.selectedCompanyInfo.defaultLanguage]) {
              var _errMessage8 = 'Item with name ' + this.returnExistingName(item.name) + ' (ID: ' + item.itemId + ') doesn\'t have Style \'' + this.returnExistingName(style.name) + '\' name in default language';
              var _error8 = {
                itemName: item.name.en,
                message: _errMessage8
              };
              this.errors.push(_error8);
              this.isCatalogValid = false;
              hasError = true;
            }
          }
        } catch (err) {
          _didIteratorError3 = true;
          _iteratorError3 = err;
        } finally {
          try {
            if (!_iteratorNormalCompletion3 && _iterator3.return) {
              _iterator3.return();
            }
          } finally {
            if (_didIteratorError3) {
              throw _iteratorError3;
            }
          }
        }
      }
      if (item.variants && item.variants.length > 0) {
        var _iteratorNormalCompletion4 = true;
        var _didIteratorError4 = false;
        var _iteratorError4 = undefined;

        try {
          for (var _iterator4 = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_get_iterator___default()(item.variants), _step4; !(_iteratorNormalCompletion4 = (_step4 = _iterator4.next()).done); _iteratorNormalCompletion4 = true) {
            var variant = _step4.value;

            if (variant.name && !variant.name[this.selectedCompanyInfo.defaultLanguage]) {
              var _errMessage9 = 'Item with name ' + this.returnExistingName(item.name) + ' (ID: ' + item.itemId + ') doesn\'t have Variant \'' + this.returnExistingName(variant.name) + '\' name in default language';
              var _error9 = {
                itemName: item.name.en,
                message: _errMessage9
              };
              this.errors.push(_error9);
              this.isCatalogValid = false;
              hasError = true;
            }
          }
        } catch (err) {
          _didIteratorError4 = true;
          _iteratorError4 = err;
        } finally {
          try {
            if (!_iteratorNormalCompletion4 && _iterator4.return) {
              _iterator4.return();
            }
          } finally {
            if (_didIteratorError4) {
              throw _iteratorError4;
            }
          }
        }
      }
      if (item.options && item.options.length > 0) {
        var _iteratorNormalCompletion5 = true;
        var _didIteratorError5 = false;
        var _iteratorError5 = undefined;

        try {
          for (var _iterator5 = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_get_iterator___default()(item.options), _step5; !(_iteratorNormalCompletion5 = (_step5 = _iterator5.next()).done); _iteratorNormalCompletion5 = true) {
            var option = _step5.value;

            if (option.name && !option.name[this.selectedCompanyInfo.defaultLanguage]) {
              var _errMessage10 = 'Item with name ' + this.returnExistingName(item.name) + ' (ID: ' + item.itemId + ') doesn\'t have Option \'' + this.returnExistingName(option.name) + '\' name in default language';
              var _error10 = {
                itemName: item.name.en,
                message: _errMessage10
              };
              this.errors.push(_error10);
              this.isCatalogValid = false;
              hasError = true;
            }
          }
        } catch (err) {
          _didIteratorError5 = true;
          _iteratorError5 = err;
        } finally {
          try {
            if (!_iteratorNormalCompletion5 && _iterator5.return) {
              _iterator5.return();
            }
          } finally {
            if (_didIteratorError5) {
              throw _iteratorError5;
            }
          }
        }
      }

      //Validate all other required items
      if (all !== true) {
        if (!item['styles'] || item['styles'].length === 0) {
          this.parentInherit(item, item.parentItem, 'styles');
          var _errMessage11 = 'Item with name ' + item.name.en + ' dont have required field styles';
          if (!item['styles'] || item['styles'].length === 0) {
            hasError = true;
            var _error11 = {
              itemName: item.name.en,
              message: _errMessage11
            };
            this.errors.push(_error11);
            this.isCatalogValid = false;
          }
        }

        if (!item['sizes'] || item['sizes'].length === 0) {
          this.parentInherit(item, item.parentItem, 'sizes');
          if (!item['sizes'] || item['sizes'].length === 0) {
            var _errMessage12 = 'Item with name ' + item.name.en + ' dont have required field sizes';
            hasError = true;
            var _error12 = {
              itemName: item.name.en,
              message: _errMessage12
            };
            this.errors.push(_error12);
            this.isCatalogValid = false;
          }
        }

        if (!item['variants'] || item['variants'].length === 0) {
          this.parentInherit(item, item.parentItem, 'variants');
          var _errMessage13 = 'Item with name ' + item.name.en + ' dont have required field variants';
          if (!item['variants'] || item['variants'].length === 0) {
            hasError = true;
            var _error13 = {
              itemName: item.name.en,
              message: _errMessage13
            };
            this.errors.push(_error13);
            this.isCatalogValid = false;
          }
        }
      }
      if (hasError) {
        __WEBPACK_IMPORTED_MODULE_9_vue__["default"].set(item, 'error', true);
      }
    },
    removeErrors: function removeErrors() {
      var _this23 = this;

      return __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator___default.a.mark(function _callee4() {
        var remove;
        return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator___default.a.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                remove = function remove(item) {
                  if (item.items) {
                    item.items.forEach(function (current) {
                      return remove(current);
                    });
                  }
                  __WEBPACK_IMPORTED_MODULE_9_vue__["default"].set(item, 'error', false);
                };

                _this23.items.forEach(function (item) {
                  return remove(item);
                });

              case 2:
              case 'end':
                return _context4.stop();
            }
          }
        }, _callee4, _this23);
      }))();
    },
    validateItemIds: function validateItemIds(itemsList) {
      var _this24 = this;

      var ids = [];
      var duplicates = [];
      var errors = [];
      var findDuplicates = function findDuplicates(list) {
        list.forEach(function (item) {
          if (ids.includes(item.itemId) && !duplicates.includes(item.itemId)) {
            duplicates.push(item.itemId);
          } else {
            ids.push(item.itemId);
          }
          if (item.items && item.items.length > 0) {
            findDuplicates(item.items);
          }
        });
      };
      var markErrors = function markErrors(list) {
        list.forEach(function (item) {
          if (duplicates.includes(item.itemId)) {
            errors.push('Item ' + item.name[_this24.language] + ' does not have a unique Id (' + item.itemId + ')!');
            _this24.$set(item, 'error', true);
          }
          if (item.items && item.items.length > 0) {
            markErrors(item.items);
          }
        });
      };
      findDuplicates(itemsList);
      markErrors(itemsList);

      if (errors.length > 0) {
        this.err = errors.join('. ');
      }
    },
    fetchCompanies: function fetchCompanies() {
      var _this25 = this;

      return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve) {
        fetch(__WEBPACK_IMPORTED_MODULE_11__assets_url__["a" /* baseUrl */] + '/company', {
          method: 'get',
          credentials: 'include',
          headers: {
            'Accept': 'application/json',
            'Content-Type': 'application/json;charset=UTF-8'
          }
        }).then(function (response) {
          return response.json();
        }).then(function (data) {
          if (data.error && data.error === 'Forbidden') {
            _this25.$router.push({ name: 'logOut' });
            resolve();
            return;
          }
          _this25.companies = data.companies;
          if (_this25.isLocalAdmin) {
            _this25.selectedCompany = _this25.companies[0];
          }
          resolve();
        }).catch(function (e) {
          _this25.companies = __WEBPACK_IMPORTED_MODULE_10__assets_fetch_data__["b" /* companies */];
          resolve();
        });
      });
    },
    fetchCompany: function fetchCompany() {
      var _this26 = this;

      fetch(__WEBPACK_IMPORTED_MODULE_11__assets_url__["a" /* baseUrl */] + '/company/' + this.selectedCompany.id, {
        method: 'get',
        credentials: 'include',
        headers: {
          'Accept': 'application/json',
          'Content-Type': 'application/json;charset=UTF-8'
        }
      }).then(function (response) {
        return response.json();
      }).then(function (data) {
        if (data.error && data.error === 'Forbidden') {
          _this26.$router.push({ name: 'logOut' });
          return;
        }
        _this26.selectedCompanyInfo = data.company;
        if (_this26.selectedCompanyInfo && _this26.selectedCompanyInfo.defaultLanguage) _this26.$cookie.set('lang', _this26.selectedCompanyInfo.defaultLanguage);
      }).catch(function (e) {
        _this26.selectedCompanyInfo = __WEBPACK_IMPORTED_MODULE_10__assets_fetch_data__["a" /* company */];
      });
    },
    initialViewsOnNewCatalog: function initialViewsOnNewCatalog() {
      this.views = [{ "viewId": 1, "name": { "en": "Collection", "de": "Collection" }, "orderTypes": ['collection'] }, { "viewId": 2, "name": { "en": "Webshop", "de": "Webshop" }, "orderTypes": ['delivery'] }, { "viewId": 3, "name": { "en": "Takeaway", "de": "Takeaway" }, "orderTypes": ['takeaway'] }, { "viewId": 4, "name": { "en": "Restaurant", "de": "Restaurant" }, "orderTypes": ['restaurant'] }, { "viewId": 5, "name": { "en": "Self-service", "de": "Self-service" }, "orderTypes": [] }, { "viewId": 6, "name": { "en": "Simple-inventory", "de": "Simple-inventory" }, "orderTypes": [] }, { "viewId": 7, "name": { "en": "Full-inventory", "de": "Full-inventory" }, "orderTypes": [] }];
      this.selectedOrderTypes = ['collection', 'delivery', 'takeaway', 'restaurant'];
    },
    getWebshopView: function getWebshopView() {
      var webview = void 0;
      this.views.forEach(function (view) {
        if (view.name.en === 'Webshop') webview = view;
      });
      return webview;
    },
    fetchCorporations: function fetchCorporations() {
      var _this27 = this;

      return __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator___default.a.mark(function _callee5() {
        var res;
        return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator___default.a.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                _context5.prev = 0;
                _context5.next = 3;
                return _this27.$http.get('corporation/getall');

              case 3:
                res = _context5.sent;

                if (!(res.body.status !== 'Success')) {
                  _context5.next = 6;
                  break;
                }

                throw new Error(res.body.statusText);

              case 6:
                _this27.allCorporations = res.body.corporations;
                _context5.next = 12;
                break;

              case 9:
                _context5.prev = 9;
                _context5.t0 = _context5['catch'](0);

                _this27.err = _context5.t0.message || _context5.t0.body.message;

              case 12:
              case 'end':
                return _context5.stop();
            }
          }
        }, _callee5, _this27, [[0, 9]]);
      }))();
    },
    getOrderTypes: function getOrderTypes() {
      var _this28 = this;

      return __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator___default.a.mark(function _callee6() {
        return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator___default.a.wrap(function _callee6$(_context6) {
          while (1) {
            switch (_context6.prev = _context6.next) {
              case 0:
                _this28.$http.get('system/ordertypes').then(function (res) {
                  if (res.body.status === 'Success') {
                    _this28.orderTypes = res.body.moon;
                    return;
                  }
                  _this28.orderTypes = ['collection', 'delivery', 'takeaway', 'restaurant'];
                  _this28.err = res.body.statusText;
                }, function (err) {
                  _this28.orderTypes = ['collection', 'delivery', 'takeaway', 'restaurant'];
                  _this28.err = err.body.statusText || err.body.message;
                });

              case 1:
              case 'end':
                return _context6.stop();
            }
          }
        }, _callee6, _this28);
      }))();
    },
    initialAllergens: function initialAllergens() {
      this.allergens = __WEBPACK_IMPORTED_MODULE_13__assets_allergens__["a" /* allergensData */];
    }
  },

  beforeDestroy: function beforeDestroy() {
    document.removeEventListener('paste', this.pasteWholeCatalog);
  },
  created: function created() {
    var _this29 = this;

    return __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator___default.a.mark(function _callee7() {
      return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator___default.a.wrap(function _callee7$(_context7) {
        while (1) {
          switch (_context7.prev = _context7.next) {
            case 0:
              _this29.isLocalAdmin = _this29.$auth.roles && _this29.$auth.roles.includes('ROLE_SUN_LOCAL_ADMIN');
              _context7.next = 3;
              return _this29.fetchCompanies();

            case 3:
              _context7.next = 5;
              return _this29.getOrderTypes();

            case 5:
              if (!_this29.isLocalAdmin) {
                _context7.next = 15;
                break;
              }

              if (!_this29.$route.query.id) {
                _context7.next = 12;
                break;
              }

              _context7.next = 9;
              return _this29.fetchCatalog();

            case 9:
              _this29.isEdit = true;
              _context7.next = 14;
              break;

            case 12:
              _this29.initialViewsOnNewCatalog();
              _this29.initialAllergens();

            case 14:
              return _context7.abrupt('return');

            case 15:
              _context7.next = 17;
              return _this29.fetchCorporations();

            case 17:
              if (!_this29.$route.query.id) {
                _context7.next = 23;
                break;
              }

              _context7.next = 20;
              return _this29.fetchCatalog();

            case 20:
              _this29.isEdit = true;
              _context7.next = 27;
              break;

            case 23:
              _this29.initialViewsOnNewCatalog();
              _this29.initialAllergens();
              _this29.selectedCompany = _this29.$cookie.get('companyedit') ? _this29.companies.find(function (company) {
                return company.id === _this29.$cookie.get('companyedit');
              }) : null;
              if (_this29.selectedCompany && _this29.selectedCompany.defaultLanguage) _this29.$cookie.set('lang', _this29.selectedCompany.defaultLanguage);

            case 27:
            case 'end':
              return _context7.stop();
          }
        }
      }, _callee7, _this29);
    }))();
  },

  components: {
    itemModal: function itemModal() {
      return __webpack_require__.e/* import() */(14).then(__webpack_require__.bind(null, 474));
    },
    viewModal: function viewModal() {
      return __webpack_require__.e/* import() */(12).then(__webpack_require__.bind(null, 476));
    },
    allergenModal: function allergenModal() {
      return __webpack_require__.e/* import() */(25).then(__webpack_require__.bind(null, 456));
    },
    vatModal: function vatModal() {
      return __webpack_require__.e/* import() */(17).then(__webpack_require__.bind(null, 468));
    },
    viewsModal: function viewsModal() {
      return __webpack_require__.e/* import() */(16).then(__webpack_require__.bind(null, 469));
    },
    allergensModal: function allergensModal() {
      return __webpack_require__.e/* import() */(20).then(__webpack_require__.bind(null, 465));
    },
    printersModal: function printersModal() {
      return __webpack_require__.e/* import() */(19).then(__webpack_require__.bind(null, 466));
    },
    langTransModal: function langTransModal() {
      return __webpack_require__.e/* import() */(21).then(__webpack_require__.bind(null, 464));
    },
    activationModal: function activationModal() {
      return __webpack_require__.e/* import() */(9).then(__webpack_require__.bind(null, 79));
    },
    confirmationModal: function confirmationModal() {
      return __webpack_require__.e/* import() */(1).then(__webpack_require__.bind(null, 24));
    },
    massAddModal: function massAddModal() {
      return __webpack_require__.e/* import() */(22).then(__webpack_require__.bind(null, 463));
    },
    massRemoveModal: function massRemoveModal() {
      return __webpack_require__.e/* import() */(18).then(__webpack_require__.bind(null, 467));
    },
    addPredefinedViews: function addPredefinedViews() {
      return __webpack_require__.e/* import() */(26).then(__webpack_require__.bind(null, 455));
    }
  }
});

/***/ }),
/* 184 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__assets_url__ = __webpack_require__(7);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = ({
  components: {
    confirmationModal: function confirmationModal() {
      return __webpack_require__.e/* import() */(0/* duplicate */).then(__webpack_require__.bind(null, 25));
    }
  },
  data: function data() {
    return {
      err: '',
      success: '',
      search: '',
      headers: [{ text: this.$lang.labels.name, value: 'name', align: 'left' }, { text: this.$lang.labels.postalcode, value: 'postalCode', align: 'left' }, { text: this.$lang.labels.companyId, value: 'id', align: 'left' }, { text: this.$lang.labels.currency, value: 'currency', align: 'left' }, { text: this.$lang.labels.status, value: 'companyStatus', align: 'left' }, { text: this.$lang.labels.actions, value: 'actions', align: 'left', sortable: false }],
      language: this.$cookie.get('lang') || 'en',
      showActive: true,
      allCompanies: [],
      confirmationModal: false,
      confirmationData: {
        id: null,
        url: 'company'
      }
    };
  },

  computed: {
    activeCompanies: function activeCompanies() {
      var companies = this.allCompanies;
      var activeCompanies = [];
      for (var i = 0; companies.length > i; i++) {
        if (companies[i].companyStatus === 'active') {
          activeCompanies.push(companies[i]);
        }
      }
      return activeCompanies;
    }
  },
  methods: {
    editCompany: function editCompany(company) {
      this.$router.push({ name: 'editCompany', params: { id: company.id } });
    },
    changeStatus: function changeStatus(company) {
      var _this = this;

      if (company.companyStatus === 'inactive') {
        this.$http.post('company/activate/' + company.id).then(function (res) {
          if (res.body.status === 'Success') {
            _this.$set(company, 'companyStatus', 'active');
            return;
          }
          _this.err = res.body.statusText;
        }, function (err) {
          _this.err = err.body.statusText || err.body.message;
        });
      } else if (company.companyStatus === "active") {
        this.confirmationData.id = company.id;
        this.confirmationModal = true;
      }
    },
    deactivate: function deactivate(id) {
      var result = this.allCompanies.find(function (data) {
        return data.id === id;
      });
      this.$set(result, 'companyStatus', 'inactive');
    }
  },

  created: function created() {
    var _this2 = this;

    // Get company list
    this.$http.get('company?detailed=true').then(function (res) {
      if (res.body.status === 'Success') {
        _this2.allCompanies = res.body.companies;
        return;
      }
      _this2.err = res.body.statusText;
    }, function (err) {
      _this2.err = err.body.statusText || err.body.message;
    });
  },


  watch: {
    err: function err(val) {
      var _this3 = this;

      if (val !== '') {
        setTimeout(function () {
          _this3.err = '';
        }, 5000);
      }
    }
  }
});

/***/ }),
/* 185 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_luxon__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_luxon___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_luxon__);



//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = ({
  components: {
    validateModal: function validateModal() {
      return __webpack_require__.e/* import() */(13).then(__webpack_require__.bind(null, 475));
    },
    ConfirmationModal: function ConfirmationModal() {
      return __webpack_require__.e/* import() */(1/* duplicate */).then(__webpack_require__.bind(null, 24));
    },
    addressModal: function addressModal() {
      return __webpack_require__.e/* import() */(7).then(__webpack_require__.bind(null, 77));
    }
  },
  data: function data() {
    var _this = this;

    return {
      showCompanies: false,
      isLocalAdmin: false,
      latitudeRule: [function (v) {
        return (/^(\+|-)?(?:90(?:(?:\.0{1,6})?)|(?:[0-9]|[1-8][0-9])(?:(?:\.[0-9]{1,20})?))$/.test(v) || _this.$lang.errors.notValid
        );
      }],
      addressDialog: false,
      distanceRule: [function (v) {
        return (/^[0-9]+(\.[0-9]+)?$/.test(v) || _this.$lang.errors.missingMaxDist
        );
      }],
      printingConfigurations: [],
      headers: [{ text: this.$lang.labels.sourceSystem, value: 'sourceSystem', align: 'left' }, { text: this.$lang.labels.orderType, value: 'orderType', align: 'left' }, { text: this.$lang.labels.printType, value: 'printType', align: 'left' }, { text: this.$lang.labels.autoPrinting, value: 'autoPrinting', align: 'left' }],
      validateModal: false,
      companyId: null,
      timeRule: [function (v) {
        return (/^([01]\d|2[0-3]):?([0-5]\d)$/.test(v) || _this.$lang.errors.validTime
        );
      }],
      emailRules: [function (v) {
        return (/^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,3})+$/.test(v) || _this.$lang.errors.validEmail
        );
      }],
      days: [{ text: this.$lang.labels.sunday, value: 'SUNDAY' }, { text: this.$lang.labels.monday, value: 'MONDAY' }, { text: this.$lang.labels.tuesday, value: 'TUESDAY' }, { text: this.$lang.labels.wednesday, value: 'WEDNESDAY' }, { text: this.$lang.labels.thursday, value: 'THURSDAY' }, { text: this.$lang.labels.friday, value: 'FRIDAY' }, { text: this.$lang.labels.saturday, value: 'SATURDAY' }, { text: this.$lang.labels.publicHoliday, value: 'PUBLICHOLIDAY' }],
      openingTimes: [],
      tempOpening: {
        day: '',
        start: '',
        end: ''
      },
      editingHours: false,
      validHours: false,

      vatRates: [],
      tempVat: {
        vat: ''
      },
      editingVat: false,

      miles: [],
      tempMiles: {
        fromMiles: '',
        toMiles: '',
        charges: ''
      },
      defaultCharges: '',
      editingMiles: false,

      amounts: [],
      tempAmount: {
        fromAmount: '',
        toMilse: '',
        charges: ''
      },
      editingAmount: false,
      valid: false,
      isEdit: false,
      payments: JSON.parse(localStorage.payments),
      paymentGateways: JSON.parse(localStorage.paymentGateways),
      languages: JSON.parse(localStorage.languages),
      align: 'left',
      chargeTypes: JSON.parse(localStorage.chargeTypes),
      serviceTypes: JSON.parse(localStorage.serviceTypes),
      allowedVatRates: JSON.parse(localStorage.allowedVatRates),
      company: {
        tableSwitchCode: null,
        oosId: null,
        name: '',
        email: '',
        phone: '',
        currency: '',
        config_update_frequency_in_minutes: 0,
        paymentTypes: [],
        tipTaxRate: null,
        defaultLanguage: '',
        cuisines: [],
        maxDeliveryDistance: null,
        deliveryPostalCodes: '',
        deliveryChargesTaxRate: null,
        paymentIntegration: 'none',
        enableContactForm: false,
        dailyOrdersCounterEnabled: false,
        persistKitchenPrint: false,
        completePrint: false,
        test: false,
        enableReservationForm: false,
        tableIdleTimeInMinutes: 5,
        pricingGroups: [],
        deliveryCharges: {
          chargesByMiles: [],
          chargesByInvoiceAmt: [],
          defaultCharges: null,
          type: '',
          chargesPerMile: null
        },
        serviceCharges: {
          type: 'noservicecharge',
          taxRate: null,
          percOfTotal: 0
        },
        minPersons: null,
        maxPersons: null,
        address: {
          line1: '',
          line2: '',
          line3: '',
          line4: '',
          locality: '',
          townCity: '',
          country: '',
          postalCode: '',
          latitude: '',
          longitude: ''
        },
        isDEPEnabled: false,
        contactServerSettings: {
          key: ''
        },
        walletServerSettings: {
          key: ''
        },
        addressServerSettings: {
          key: ''
        },
        depServerSettings: {
          key: ''
        },
        inventoryServerSettings: {
          key: ''
        },
        reservationServerSettings: {
          key: ''
        },
        distanceUnit: '',
        registrationNumber: '',
        registrationLocation: '',
        timezone: ''
      },
      timezones: [],
      bookKeeperEmails: '',
      err: '',
      success: '',
      currencies: ['EUR', 'GBP'],
      language: this.$cookie.get('lang') || 'en',
      cuisines: [],
      statuses: [{
        text: this.$lang.labels.active,
        value: 'active'
      }, {
        text: this.$lang.labels.inactive,
        value: 'inactive'
      }],
      createdOn: '',
      modifiedOn: '',
      allPricingGroups: [],
      snackbar: false,
      timeout: 0,
      noTax: true,
      noTipTax: true,
      noDeliveryTax: true,
      noServiceTax: true,
      countries: ['AT', 'UK'],
      createCorporationDialog: false,
      corporation: {
        companies: [],
        name: null,
        contactServerSettings: {
          enabled: false,
          serverUrl: ''
        },
        addressServerSettings: {
          enabled: false,
          serverUrl: ''
        },
        walletServerSettings: {
          enabled: false,
          serverUrl: ''
        },
        depServerSettings: {
          enabled: false,
          serverUrl: ''
        },
        inventoryServerSettings: {
          enabled: false,
          serverUrl: ''
        },
        authServerSettings: {
          enabled: false,
          serverUrl: ''
        },
        reservationServerSettings: {
          enabled: false,
          serverUrl: ''
        },
        primaryCompanyId: '',
        dailyOrderCounterPrefixes: {}
      },
      distanceUnits: [],
      selectedCompany: null,
      companies: []
    };
  },

  watch: {
    selectedCompany: function selectedCompany(val) {
      if (val) this.fetchSingleCompany(val, false);
    },
    noServiceTax: function noServiceTax(val) {
      if (val === true) this.company.serviceCharges.taxRate = null;
    },
    noDeliveryTax: function noDeliveryTax(val) {
      if (val === true) this.company.deliveryChargesTaxRate = null;
    },
    noTipTax: function noTipTax(val) {
      if (val === true) this.company.tipTaxRate = null;
    },
    noTax: function noTax(val) {
      if (val) {
        this.vatRates.splice(0, this.vatRates.length);
        this.editingVat = true;
        this.noServiceTax = true;
        this.noDeliveryTax = true;
        this.noTipTax = true;
      } else {
        this.editingVat = false;
        if (this.vatRates.length === 0) {
          this.noServiceTax = true;
          this.noDeliveryTax = true;
          this.noTipTax = true;
        }
      }
    },
    err: function err(val) {
      var _this2 = this;

      if (val !== '') {
        setTimeout(function () {
          _this2.err = '';
        }, 5000);
      }
    },

    'company.address.country': function companyAddressCountry(val) {
      if (val === 'UK') this.company.isDEPEnabled = false;
    },
    'company.isDEPEnabled': function companyIsDEPEnabled(val) {
      if (!val) this.company.depServerSettings.key = '';
    },
    'company.deliveryCharges.type': function companyDeliveryChargesType(newVal, oldVal) {
      immediate: false;
      deep: true;
      if (oldVal === '') {
        return;
      }
      if (newVal) {
        this.defaultCharges = '';
        this.miles = [];
        this.editingMiles = false;
        this.amounts = [];
        this.editingAmount = false;
      }
    },
    editingHours: function editingHours(val) {
      if (val === true) {
        this.valid = false;
      }
    },

    'company.currency': function companyCurrency(val) {
      this.fetchPricingGroups(val);
    }
  },
  computed: {
    mappedCompanies: function mappedCompanies() {
      return this.companies.map(function (company) {
        return {
          text: company.name + ' (' + company.companyStatus + ')',
          value: company.id
        };
      });
    },
    chargeTypesFormatted: function chargeTypesFormatted() {
      var _this3 = this;

      return this.chargeTypes.map(function (row) {
        var type = row;
        if (_this3.company.distanceUnit === 'meters') {
          type.text = type.text.replace('Miles', 'Meters');
          type.text = type.text.replace('Mile', 'Meter');
        }
        return type;
      });
    },
    openingValidation: function openingValidation() {
      var isStartValid = this.validateTime(this.tempOpening.start);
      var isEndValid = this.validateTime(this.tempOpening.end);
      if (this.tempOpening.end === '0000') {
        return isEndValid = false;
      }
      return !!this.tempOpening.day && isStartValid && isEndValid;
    },
    mappedGroups: function mappedGroups() {
      return this.allPricingGroups.map(function (group) {
        return {
          text: group.name,
          value: group.id
        };
      });
    }
  },
  methods: {
    submitAddress: function submitAddress(address) {
      this.company.address = {
        line1: address.line1.trim(),
        line2: address.line2.trim(),
        line3: address.line3.trim(),
        line4: address.line4.trim(),
        locality: address.locality.trim(),
        townCity: address.townCity.trim(),
        country: address.country.trim(),
        postalCode: address.postalCode.trim().toUpperCase(),
        latitude: address.latitude.trim(),
        longitude: address.longitude.trim()
      };
      this.addressDialog = false;
    },
    moveUp: function moveUp(arr, id) {
      var y = id--;
      var origin = arr[id];
      arr.splice(id, 1, arr[y]);
      this.$set(arr, y, origin);
    },
    moveDown: function moveDown(arr, id) {
      var y = id++;
      var origin = arr[id];
      arr.splice(id, 1, arr[y]);
      this.$set(arr, y, origin);
    },
    fetchPricingGroups: function fetchPricingGroups(currency) {
      var _this4 = this;

      this.$http.post('pricinggroup/getall', { currency: currency }).then(function (res) {
        if (res.body.status === 'Success') {
          _this4.allPricingGroups = res.body.pricingGroups;
          return;
        }
        _this4.err = res.body.statusText;
      }, function (err) {
        _this4.err = err.body.statusText || err.body.message;
      });
    },
    formatDate: function formatDate(date) {
      return __WEBPACK_IMPORTED_MODULE_3_luxon__["DateTime"].fromISO(date).toFormat('yyyy-MM-dd HH:mm:ss');
    },
    validateTime: function validateTime(time) {
      if (!time) return false;
      var valid = true;
      if (parseInt(time[0], 10) > 2 || parseInt(time[0], 10) === 2 && parseInt(time[1], 10) > 3 || parseInt(time[2], 10) > 5 || !time[3]) valid = false;
      if (time.length !== 4) valid = false;
      return valid;
    },

    //Opening Hours
    addHours: function addHours() {
      this.openingTimes.push({
        day: '',
        start: '',
        end: '',
        isEdit: true
      });
      this.editingHours = true;
      this.$forceUpdate();
    },
    copyOpening: function copyOpening(time) {

      if (this.editingHours) {
        this.$set(time, 'day', this.tempOpening.day);
        this.$set(time, 'start', this.formatTime(this.tempOpening.start));
        this.$set(time, 'end', this.formatTime(this.tempOpening.end));
        this.$set(time, 'isEdit', false);
      }
      this.openingTimes.push({
        day: '',
        start: '',
        end: '',
        isEdit: true
      });
      this.tempOpening = {
        day: time.day,
        start: this.formatTimeEdit(time.start),
        end: this.formatTimeEdit(time.end)
      };
      this.editingHours = true;
    },
    editOpening: function editOpening(time) {
      this.tempOpening = {
        day: time.day,
        start: this.formatTimeEdit(time.start),
        end: this.formatTimeEdit(time.end)
      };
      this.$set(time, 'isEdit', true);
      this.editingHours = true;
    },
    deleteOpening: function deleteOpening(index) {
      this.openingTimes.splice(index, 1);
      this.$forceUpdate();
    },
    formatTime: function formatTime(time) {
      var save = time.toString().replace(':', '');
      return save.slice(0, 2) + ':' + save.slice(2);
    },
    formatTimeEdit: function formatTimeEdit(time) {
      return time.replace(':', '');
    },
    saveOpening: function saveOpening(time) {
      this.$set(time, 'day', this.tempOpening.day);
      this.$set(time, 'start', this.formatTime(this.tempOpening.start));
      this.$set(time, 'end', this.formatTime(this.tempOpening.end));
      this.closeOpening(time);
    },
    closeOpening: function closeOpening(time) {
      this.tempOpening = {
        day: '',
        start: '',
        end: ''
      };
      this.$set(time, 'isEdit', false);
      this.editingHours = false;
    },


    //Vat
    addVat: function addVat() {
      this.vatRates.push({
        vat: '',
        isEdit: true
      });
      this.editingVat = true;
      this.$forceUpdate();
    },
    editVat: function editVat(vat) {
      this.tempVat = {
        vat: vat.vat
      };
      this.$set(vat, 'isEdit', true);
      this.editingVat = true;
    },
    deleteVat: function deleteVat(index) {
      this.vatRates.splice(index, 1);
      this.$forceUpdate();
    },
    saveVatEdit: function saveVatEdit(vat) {
      this.$set(vat, 'vat', this.tempVat.vat);
      this.closeVatEdit(vat);
    },
    closeVatEdit: function closeVatEdit(vat) {
      this.tempVat = {
        vat: ''
      };
      this.$set(vat, 'isEdit', false);
      this.editingVat = false;
    },


    //Charge by Miles
    addMiles: function addMiles() {
      this.miles.push({
        fromMiles: '',
        toMiles: '',
        charges: '',
        isEdit: true
      });
      this.editingMiles = true;
      this.$forceUpdate();
    },
    editMiles: function editMiles(charge) {
      this.tempMiles = {
        fromMiles: charge.fromMiles,
        toMiles: charge.toMiles,
        charges: charge.charges
      };
      this.$set(charge, 'isEdit', true);
      this.editingMiles = true;
    },
    deleteMiles: function deleteMiles(index) {
      this.miles.splice(index, 1);
      this.$forceUpdate();
    },
    saveMilesEdit: function saveMilesEdit(charge) {
      this.$set(charge, 'fromMiles', this.tempMiles.fromMiles);
      this.$set(charge, 'toMiles', this.tempMiles.toMiles);
      this.$set(charge, 'charges', this.tempMiles.charges);
      this.closeMilesEdit(charge);
    },
    closeMilesEdit: function closeMilesEdit(charge) {
      this.tempMiles = {
        fromMiles: '',
        toMiles: '',
        charges: ''
      };
      this.$set(charge, 'isEdit', false);
      this.editingMiles = false;
    },


    //Charge by Amount
    addAmount: function addAmount() {
      this.amounts.push({
        fromAmount: '',
        toAmount: '',
        charges: '',
        isEdit: true
      });
      this.editingAmount = true;
      this.$forceUpdate();
    },
    editAmount: function editAmount(amount) {
      this.tempAmount = {
        fromAmount: amount.fromAmount,
        toAmount: amount.toAmount,
        charges: amount.charges
      };
      this.$set(amount, 'isEdit', true);
      this.editingAmount = true;
    },
    deleteAmount: function deleteAmount(index) {
      this.amounts.splice(index, 1);
      this.$forceUpdate();
    },
    saveAmountEdit: function saveAmountEdit(amount) {
      this.$set(amount, 'fromAmount', this.tempAmount.fromAmount);
      this.$set(amount, 'toAmount', this.tempAmount.toAmount);
      this.$set(amount, 'charges', this.tempAmount.charges);
      this.closeAmountEdit(amount);
    },
    closeAmountEdit: function closeAmountEdit(amount) {
      this.tempAmount = {
        fromAmount: '',
        toAmount: '',
        charges: ''
      };
      this.$set(amount, 'isEdit', false);
      this.editingAmount = false;
    },
    init: function init() {
      var _this5 = this;

      return new __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise___default.a(function (resolve) {
        _this5.languages = _this5.languages.sort(function (a, b) {
          return a.text > b.text ? 1 : b.text > a.text ? -1 : 0;
        });
        _this5.$http.get('system/currencies').then(function (res) {
          if (res.body.status === 'Success') {
            _this5.currencies = res.body.currencies;
            return _this5.$http.get('system/cuisines');
          }
          throw new Error(res.body.statusText);
        }).then(function (res) {
          if (res.body.status === 'Success') {
            _this5.cuisines = res.body.cuisines.sort();
            resolve();
            return;
          }
          throw new Error(res.body.statusText);
        }).catch(function (err) {
          _this5.err = err.message || err.body.message;
          resolve();
        });
        _this5.$http.get('system/printingconfigurations/allowedcombinations').then(function (res) {
          resolve();
          if (res.body.status === 'Success') {
            _this5.printingConfigurations = res.body.allowedPrintingCombinations;
            return;
          }
          _this5.err = res.body.statusText;
        }, function (err) {
          resolve();
          _this5.err = err.body.statusText || err.body.message;
        });
      });
    },
    validate: function validate() {
      this.companyId = this.$route.params.id;
      this.validateModal = true;
    },
    checkEmail: function checkEmail(email) {
      return (/^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/.test(email)
      );
    },
    submit: function submit(action) {
      var _this6 = this;

      var company = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, this.company);
      if (this.bookKeeperEmails !== '') {
        var emailSplit = this.bookKeeperEmails.split(',');
        emailSplit = emailSplit.map(function (email) {
          email = email.trim();
          email = email.toLowerCase();
          if (!_this6.checkEmail(email)) return false;
          return email;
        });
        if (emailSplit.includes(false)) {
          this.err = '' + this.$lang.errors.wrongEmail;
          return;
        }
        __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()(company, { bookKeeperEmails: emailSplit });
      }
      if (this.openingTimes.length > 0) {
        var openingDaysAndHours = this.openingTimes.map(function (time) {
          return {
            day: time.day,
            start: time.start,
            end: time.end
          };
        });
        __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()(company, { openingDaysAndHours: openingDaysAndHours });
      }
      if (!this.noTax && this.vatRates.length > 0) {
        __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()(company, { vatRates: this.vatRates.map(function (rate) {
            return rate.vat;
          }) });
      } else {
        __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()(company, { vatRates: null });
      }
      if (company.vatRates !== null) {
        company.vatRates = company.vatRates.map(function (vat) {
          return Number(vat);
        });
      }
      if (company.address.country === 'AT') {
        if (company.vatRates === null) {
          this.err = this.$lang.errors.noVatRates;
          return;
        } else {
          var arr = company.vatRates.filter(function (rate) {
            return !_this6.allowedVatRates.at.includes(Number(rate));
          });
          if (company.address.country === 'AT' && arr.length > 0) {
            this.err = this.$lang.errors.wrongVAT + ': ' + this.allowedVatRates.at;
            return;
          }
        }
      }
      if (company.address.country === 'UK') {
        var _arr = company.vatRates !== null ? company.vatRates.filter(function (rate) {
          return !_this6.allowedVatRates.uk.includes(Number(rate));
        }) : [];
        if (_arr.length > 0) {
          this.err = this.$lang.errors.wrongVatUK + ': ' + this.allowedVatRates.uk;
          return;
        }
      }
      company.address.postalCode = company.address.postalCode.trim().toUpperCase();
      this.company.address.postalCode = company.address.postalCode;
      if (this.company.deliveryPostalCodes) {
        var deliveryPostalCodes = this.company.deliveryPostalCodes.split(',');
        __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()(company, { deliveryPostalCodes: deliveryPostalCodes });
      } else {
        delete company.deliveryPostalCodes;
      }
      if (company.deliveryCharges.type === 'chargesbymiles') {
        __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()(company, {
          deliveryCharges: {
            type: this.company.deliveryCharges.type,
            chargesByMiles: this.miles
          }
        });
      } else {
        delete company.deliveryCharges.chargesByMiles;
      }
      if (company.deliveryCharges.type === 'chargesbyinvoiceamount') {
        __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()(company, {
          deliveryCharges: {
            type: this.company.deliveryCharges.type,
            chargesByInvoiceAmt: this.amounts
          }
        });
      } else {
        delete company.deliveryCharges.chargesByInvoiceAmt;
      }
      if (this.defaultCharges) {
        __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()(company.deliveryCharges, {
          defaultCharges: this.defaultCharges
        });
      } else {
        delete company.deliveryCharges.defaultCharges;
      }
      if (company.deliveryCharges.type === 'chargespermile') {
        __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()(company, {
          deliveryCharges: {
            type: this.company.deliveryCharges.type,
            chargesPerMile: this.company.deliveryCharges.chargesPerMile
          }
        });
      }
      if (company.deliveryCharges.type !== 'chargespermile') {
        delete company.deliveryCharges.chargesPerMile;
      }
      if (company.enableReservationForm === false) {
        delete company.reservationFormDetails;
      }
      var url = this.isEdit ? 'company/update/' + this.$route.params.id : 'company/create';
      if (action === 'pushConfig') {
        url = 'company/addallconfigurations/' + this.$route.params.id;
      }
      __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()(company, { printingConfigurations: this.printingConfigurations });
      if (!company.contactServerSettings.key && company.contactServerSettings.key.length < 1) {
        delete company.contactServerSettings;
      }
      if (!company.walletServerSettings.key && company.walletServerSettings.key.length < 1) {
        delete company.walletServerSettings;
      }
      if (!company.addressServerSettings.key && company.addressServerSettings.key.length < 1) {
        delete company.addressServerSettings;
      }
      if (!company.depServerSettings.key && company.depServerSettings.key.length < 1 || !company.isDEPEnabled) {
        delete company.depServerSettings;
      }
      if (!company.inventoryServerSettings.key && company.inventoryServerSettings.key.length < 1) {
        delete company.inventoryServerSettings;
      }
      if (!company.reservationServerSettings.key && company.reservationServerSettings.key.length < 1) {
        delete company.reservationServerSettings;
      }
      this.$http.post(url, company).then(function (res) {
        if (res.body.status === 'Success') {
          if (company.maxDeliveryDistance == 0 || !company.maxDeliveryDistance) {
            _this6.snackbar = true;
          }
          _this6.success = _this6.isEdit ? 'Company updated successfuly' : 'Company created successfuly';
          if (!_this6.isEdit) {
            _this6.corporation.name = 'Corporation of ' + _this6.company.name;
            _this6.corporation.companies.push(res.body.companyId);
            _this6.corporation.primaryCompanyId = res.body.companyId;
            _this6.createCorporationDialog = true;
          }
          setTimeout(function () {
            if (_this6.isEdit) {
              _this6.success = '';
            }
          }, 3000);
          return;
        }
        _this6.err = res.body.statusText;
      }, function (err) {
        _this6.err = err.body.statusText || err.body.message;
      });
    },
    createCorporation: function createCorporation() {
      var _this7 = this;

      this.createCorporationDialog = false;
      var url = 'corporation/create';
      this.$http.post(url, this.corporation).then(function (res) {
        if (res.body.status === 'Success') {
          _this7.success = 'Corporation created successfully';
          setTimeout(function () {
            if (_this7.isEdit) {
              _this7.success = '';
            }
          }, 3000);
          return;
        }
        _this7.err = res.body.statusText;
      }, function (err) {
        _this7.err = err.body.statusText || err.body.message;
      });
    },
    fetchAllCompanies: function fetchAllCompanies() {
      var _this8 = this;

      if (this.showCompanies === true) {
        this.showCompanies = false;
        return;
      }
      this.$http.get('company').then(function (res) {
        if (res.body.status === 'Success') {
          _this8.companies = res.body.companies;
          _this8.showCompanies = true;
          return;
        }
        _this8.err = res.body.statusText;
      }, function (err) {
        _this8.err = err.body.statusText || err.body.message;
      });
    },
    fetchSingleCompany: function fetchSingleCompany(id, isFromStart) {
      var _this9 = this;

      this.$http.get('company/' + id).then(function (res) {
        if (res.body.status === 'Success') {
          var company = res.body.company;
          if (!isFromStart) delete company.depServerSettings;
          if (company.openingDaysAndHours) {
            _this9.openingTimes = company.openingDaysAndHours.map(function (current) {
              return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({}, current, { isEdit: false });
            });
          }
          if (company.vatRates) {
            _this9.noTax = false;
            _this9.vatRates = (company.vatRates || []).map(function (vat) {
              return {
                vat: vat,
                isEdit: false
              };
            });
          }
          if (company.deliveryCharges) {
            if (company.deliveryCharges.chargesByMiles) {
              _this9.miles = company.deliveryCharges.chargesByMiles.map(function (current) {
                return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({}, current, { isEdit: false });
              });
            }
            if (company.deliveryCharges.defaultCharges) {
              _this9.defaultCharges = company.deliveryCharges.defaultCharges;
            }
            if (company.deliveryCharges.chargesByInvoiceAmt) {
              company.deliveryCharges.chargesByInvoiceAmt.forEach(function (current) {
                _this9.amounts.push(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({}, current, { isEdit: false }));
              });
            }
          }
          if (!company.serviceCharges) {
            __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()(company, { serviceCharges: { type: 'noservicecharge' } });
          }
          if (company.deliveryPostalCodes) {
            company.deliveryPostalCodes = company.deliveryPostalCodes.join(',');
          } else {
            _this9.$set(company, 'deliveryPostalCodes', '');
          }
          if (!company.cuisines) {
            __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()(company, { cuisines: [] });
          }
          if (company.paymentTypes && company.paymentTypes.length > 0) {
            company.paymentTypes = company.paymentTypes.map(function (current) {
              return current.toLowerCase();
            });
          }
          if (company.enableReservationForm === true) {
            __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()(company, { minPersons: company.reservationFormDetails.minPersons });
            __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()(company, { maxPersons: company.reservationFormDetails.maxPersons });
          }
          _this9.createdOn = _this9.formatDate(company.createdOn);
          if (company.modifiedOn) {
            _this9.modifiedOn = _this9.formatDate(company.modifiedOn);
          }
          if (company.printingConfigurations) {
            _this9.printingConfigurations = _this9.printingConfigurations.map(function (defaultConfig) {
              var config = company.printingConfigurations.find(function (companyConfig) {
                return defaultConfig.orderType === companyConfig.orderType && defaultConfig.printType === companyConfig.printType && defaultConfig.sourceSystem === companyConfig.sourceSystem;
              });
              return config ? defaultConfig = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, defaultConfig, {
                autoPrinting: company.address.country === 'AT' && defaultConfig.printType === 'invoice' ? false : config.autoPrinting
              }) : __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, defaultConfig);
            });
          }
          if (company.tipTaxRate || company.tipTaxRate === 0) {
            _this9.noTipTax = false;
          }
          if (company.deliveryChargesTaxRate || company.deliveryChargesTaxRate === 0) {
            _this9.noDeliveryTax = false;
          }
          if (company.serviceCharges.taxRate || company.serviceCharges.taxRate === 0) {
            _this9.noServiceTax = false;
          }
          if (_this9.company.address.country !== 'AT' && _this9.company.address.country !== 'UK') {
            _this9.company.address.country = '';
          }
          if (!company.contactServerSettings) {
            __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()(company, { contactServerSettings: { key: '' } });
          }
          if (!company.addressServerSettings) {
            __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()(company, { addressServerSettings: { key: '' } });
          }
          if (!company.walletServerSettings) {
            __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()(company, { walletServerSettings: { key: '' } });
          }
          if (!company.depServerSettings) {
            __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()(company, { depServerSettings: { key: '' } });
          }
          if (!company.inventoryServerSettings) {
            __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()(company, { inventoryServerSettings: { key: '' } });
          }
          if (!company.reservationServerSettings) {
            __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()(company, { reservationServerSettings: { key: '' } });
          }
          if (localStorage.distanceunits) {
            _this9.distanceUnits = JSON.parse(localStorage.distanceunits);
          }
          if (company.bookKeeperEmails && company.bookKeeperEmails.length > 0) {
            _this9.bookKeeperEmails = company.bookKeeperEmails.join();
          }
          _this9.company = company;
          return;
        }
        _this9.err = res.body.statusText;
      }, function (err) {
        _this9.err = err.body.statusText || err.body.message;
      });
    }
  },
  created: function created() {
    var _this10 = this;

    var roles = JSON.parse(this.$cookie.get('roles') || '[]');
    this.isLocalAdmin = roles.includes('ROLE_SUN_LOCAL_ADMIN');
    this.init().then(function () {
      if (localStorage.timezones) _this10.timezones = JSON.parse(localStorage.timezones).sort();
      if (_this10.$route.params.id) {
        _this10.isEdit = true;
        _this10.fetchSingleCompany(_this10.$route.params.id, true);
      } else {
        if (localStorage.distanceunits) {
          _this10.distanceUnits = JSON.parse(localStorage.distanceunits);
        } else {
          _this10.distanceUnits = ['meters', 'miles'];
        }
      }
    });
  }
});

/***/ }),
/* 186 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_luxon__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_luxon___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_luxon__);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = ({
  components: {
    configModal: function configModal() {
      return __webpack_require__.e/* import() */(27).then(__webpack_require__.bind(null, 454));
    }
  },
  data: function data() {
    return {
      pagination: {
        sortBy: 'createdOn',
        descending: true
      },
      err: '',
      success: '',
      search: '',
      valid: false,
      show: false,
      configType: 'Moon Configuration Updates',
      configTypeShort: null,
      planetType: null,
      companyId: null,
      status: null,
      fromDate: __WEBPACK_IMPORTED_MODULE_1_luxon__["DateTime"].local().minus({ hours: 4 }).toISO(),
      toDate: __WEBPACK_IMPORTED_MODULE_1_luxon__["DateTime"].local().plus({ hours: 2 }).toISO(),
      configTypes: ['Moon Configuration Updates', 'Planet Configuration Updates'],
      planetTypes: ['webshop'],
      statuses: ['created', 'fetched', 'synched', 'invalidate'],
      companyLoading: true,
      companies: [],
      loading: true,
      headers: [{ text: this.$lang.header.instanceName, value: 'instanceName', align: 'left' }, { text: this.$lang.labels.companyName, value: 'companyName', align: 'left' }, { text: this.$lang.labels.created, value: 'createdOn', align: 'left' }, { text: this.$lang.header.synched, value: 'synchedOn', align: 'left' }, { text: this.$lang.labels.status, value: 'status', align: 'left' }, { text: this.$lang.labels.actions, value: 'actions', align: 'left', sortable: false }],
      configs: [],
      configIndex: null,
      configUpdatesView: false
    };
  },

  watch: {
    err: function err(val) {
      var _this = this;

      if (val !== '') {
        setTimeout(function () {
          _this.err = '';
        }, 5000);
      }
    },
    companyId: function companyId(val) {
      this.$cookie.set('companyedit', val, { expires: '8h' });
    }
  },
  computed: {
    mappedCompanies: function mappedCompanies() {
      return this.companies.map(function (company) {
        return {
          text: company.name + ' (' + company.companyStatus + ')',
          value: company.id
        };
      });
    }
  },
  methods: {
    showModal: function showModal(index) {
      this.setConfigShort();
      this.configIndex = index;
      this.configUpdatesView = true;
    },
    closeModal: function closeModal() {
      this.configUpdatesView = false;
      this.configIndex = null;
    },
    showPrev: function showPrev() {
      if (this.configIndex === 0) return;
      this.configIndex -= 1;
    },
    showNext: function showNext() {
      if (this.configIndex === this.configs.length - 1) return;
      this.configIndex += 1;
    },
    formatDate: function formatDate(date) {
      return __WEBPACK_IMPORTED_MODULE_1_luxon__["DateTime"].fromISO(date).toFormat('yyyy-MM-dd HH:mm');
    },
    setConfigShort: function setConfigShort() {
      if (this.configType === 'Moon Configuration Updates') {
        this.configTypeShort = 'moon';
      }
      if (this.configType === 'Planet Configuration Updates') {
        this.configTypeShort = 'planet';
      }
    },
    showUpdates: function showUpdates() {
      var _this2 = this;

      this.show = true;
      this.loading = true;
      this.configs = [];
      if (this.fromDate === null) {
        this.err = 'Please select From Date';
      }
      if (this.toDate === null) {
        this.err = 'Please select To Date';
      }
      var data = {
        configType: this.configType,
        planetType: this.planetType,
        companyId: this.companyId,
        status: this.status,
        fromDate: this.fromDate,
        toDate: this.toDate
      };
      var url = (data.configType === 'Planet Configuration Updates' ? 'planet' : 'moon') + '/configupdates/search';
      this.$http.post(url, data).then(function (res) {
        if (res.body.status === 'Success') {
          _this2.loading = false;
          _this2.configs = res.body.configs;
          localStorage.setItem('configUpdates', __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(data));
          return;
        }
        _this2.err = res.body.statusText;
      }, function (err) {
        _this2.loading = false;
        _this2.err = err.body.statusText || err.body.message;
      });
    }
  },
  created: function created() {
    var _this3 = this;

    this.$http.get('company').then(function (res) {
      _this3.companyLoading = false;
      if (res.body.status === 'Success') {
        _this3.companies = res.body.companies;
        return;
      }
      _this3.err = res.body.statusText;
    }, function (err) {
      _this3.companyLoading = false;
      _this3.err = err.body.statusText || err.body.message;
    });
    var edit = this.$cookie.get('companyedit');
    if (edit) this.companyId = edit;
    var prevConfig = localStorage.getItem('configUpdates');
    if (!prevConfig) return;
    var data = JSON.parse(prevConfig);
    this.configType = data.configType;
    this.setConfigShort();
    this.planetType = data.planetType;
    this.companyId = data.companyId;
    this.status = data.status;
    this.fromDate = data.fromDate;
    this.toDate = data.toDate;
  },
  beforeDestroy: function beforeDestroy() {
    var data = {
      configType: this.configType,
      planetType: this.planetType,
      companyId: this.companyId,
      status: this.status,
      fromDate: this.fromDate,
      toDate: this.toDate
    };
    localStorage.setItem('configUpdates', __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(data));
  }
});

/***/ }),
/* 187 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_luxon__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_luxon___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_luxon__);


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      settings: ['contactServerSettings', 'addressServerSettings', 'walletServerSettings', 'depServerSettings', 'inventoryServerSettings', 'authServerSettings', 'reservationServerSettings'],
      err: '',
      success: '',
      valid: false,
      isEdit: false,
      companyLoading: true,
      companies: [],
      filteredCompanies: [],
      corporation: {
        companies: [],
        name: null,
        contactServerSettings: {
          enabled: false,
          serverUrl: ''
        },
        addressServerSettings: {
          enabled: false,
          serverUrl: ''
        },
        walletServerSettings: {
          enabled: false,
          serverUrl: ''
        },
        depServerSettings: {
          enabled: false,
          serverUrl: ''
        },
        inventoryServerSettings: {
          enabled: false,
          serverUrl: ''
        },
        authServerSettings: {
          enabled: false,
          serverUrl: ''
        },
        reservationServerSettings: {
          enabled: false,
          serverUrl: ''
        },
        primaryCompanyId: '',
        dailyOrderCounterPrefixes: {
          delivery: '',
          collection: '',
          takeaway: ''
        }
      },
      dailyOrderCounterPrefixesInit: ['delivery', 'collection', 'takeaway'],
      dailyOrderCounterPrefixesMax: 4,
      createdOn: '',
      modifiedOn: ''
    };
  },
  watch: {
    err: function err(val) {
      var _this = this;

      if (val !== '') {
        setTimeout(function () {
          _this.err = '';
        }, 5000);
      }
    }
  },
  methods: {
    filterCompanies: function filterCompanies() {
      var _this2 = this;

      var slecectedCompanies = this.corporation.companies;
      if (slecectedCompanies.length === 0) this.corporation.primaryCompanyId = '';
      if (slecectedCompanies.length > 0) {
        this.filteredCompanies = slecectedCompanies.map(function (id) {
          var found = _this2.companies.find(function (company) {
            return company.id === id;
          });
          return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, found);
        });
        var isDefinded = this.filteredCompanies.find(function (company) {
          return company.id === _this2.corporation.primaryCompanyId;
        });
        if (!isDefinded) {
          this.corporation.primaryCompanyId = '';
        }
      }
    },
    formatDate: function formatDate(date) {
      return __WEBPACK_IMPORTED_MODULE_2_luxon__["DateTime"].fromISO(date).toFormat('yyyy-MM-dd HH:mm:ss');
    },
    init: function init() {
      var _this3 = this;

      return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve) {
        _this3.$http.get('company').then(function (res) {
          resolve();
          _this3.companyLoading = false;
          if (res.body.status === 'Success') {
            _this3.companies = res.body.companies;
            return;
          }
          _this3.err = res.body.statusText;
        }, function (err) {
          resolve();
          _this3.companyLoading = false;
          _this3.err = err.body.statusText || err.body.message;
        });
      });
    },
    submit: function submit() {
      var _this4 = this;

      var url = this.isEdit ? 'corporation/update/' + this.$route.params.id : 'corporation/create';
      this.dailyOrderCounterPrefixesInit.forEach(function (type) {
        if (_this4.corporation.dailyOrderCounterPrefixes[type] === '') delete _this4.corporation.dailyOrderCounterPrefixes[type];
      });
      this.$http.post(url, this.corporation).then(function (res) {
        if (res.body.status === 'Success') {
          _this4.success = _this4.isEdit ? 'Corporation updated successfully' : 'Corporation created successfully';
          setTimeout(function () {
            if (_this4.isEdit) {
              _this4.success = '';
            } else {
              _this4.$router.push({ name: 'corporations' });
            }
          }, 3000);
          return;
        }
        _this4.err = res.body.statusText;
      }, function (err) {
        _this4.err = err.body.statusText || err.body.message;
      });
    }
  },
  created: function created() {
    var _this5 = this;

    this.init().then(function () {
      if (_this5.$route.params.id) {
        _this5.isEdit = true;
        _this5.$http.get('corporation/' + _this5.$route.params.id).then(function (res) {
          if (res.body.status === 'Success') {
            _this5.corporation = res.body.corporation;
            _this5.filterCompanies();
            if (!_this5.corporation.dailyOrderCounterPrefixes) {
              _this5.corporation.dailyOrderCounterPrefixes = {
                delivery: '',
                collection: '',
                takeaway: ''
              };
            } else {
              _this5.dailyOrderCounterPrefixesInit.forEach(function (type) {
                if (!_this5.corporation.dailyOrderCounterPrefixes[type]) _this5.corporation.dailyOrderCounterPrefixes[type] = '';
              });
            }
            if (!_this5.corporation.authServerSettings) {
              _this5.corporation.authServerSettings = {
                enabled: false,
                serverUrl: ''
              };
            }
            if (!_this5.corporation.reservationServerSettings) {
              _this5.corporation.reservationServerSettings = {
                enabled: false,
                serverUrl: ''
              };
            }
            _this5.createdOn = _this5.formatDate(_this5.corporation.createdOn);
            if (_this5.corporation.modifiedOn) {
              _this5.modifiedOn = _this5.formatDate(_this5.corporation.modifiedOn);
            }
            return;
          }
          _this5.err = res.body.statusText;
        }, function (err) {
          _this5.err = err.body.statusText || err.body.message;
        });
      }
    });
  }
});

/***/ }),
/* 188 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_luxon__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_luxon___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_luxon__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      err: '',
      search: '',
      headers: [{ text: this.$lang.labels.name, value: 'name', align: 'left' }, { text: this.$lang.labels.created, value: 'createdOn', align: 'left' }, { text: this.$lang.labels.status, value: 'status', align: 'left' }, { text: this.$lang.labels.actions, value: 'actions', align: 'left', sortable: false }],
      allCorporations: [],
      showActive: true
    };
  },

  methods: {
    formatDate: function formatDate(date) {
      return __WEBPACK_IMPORTED_MODULE_0_luxon__["DateTime"].fromISO(date).toFormat('yyyy-MM-dd');
    },
    changeStatus: function changeStatus(corporation) {
      var _this = this;

      var action = corporation.status === 'active' ? 'deactivate' : 'activate';
      this.$http.post('corporation/' + action + '/' + corporation.id).then(function (res) {
        if (res.body.status === 'Success') {
          _this.$set(corporation, 'status', action === 'activate' ? 'active' : 'inactive');
          return;
        }
        _this.err = res.body.statusText;
      }, function (err) {
        _this.err = err.body.statusText || err.body.message;
      });
    }
  },
  watch: {
    err: function err(val) {
      var _this2 = this;

      if (val !== '') {
        setTimeout(function () {
          _this2.err = '';
        }, 5000);
      }
    }
  },
  computed: {
    activeCorporations: function activeCorporations() {
      var corporations = this.allCorporations;
      var activeCorporations = [];
      for (var i = 0; corporations.length > i; i++) {
        if (corporations[i].status === 'active') {
          activeCorporations.push(corporations[i]);
        }
      }
      return activeCorporations;
    }
  },
  created: function created() {
    var _this3 = this;

    this.$http.get('corporation/getall').then(function (res) {
      if (res.body.status === 'Success') {
        _this3.allCorporations = res.body.corporations;
        return;
      }
      _this3.err = res.body.statusText;
    }, function (err) {
      _this3.err = err.body.statusText || err.body.message;
    });
  }
});

/***/ }),
/* 189 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_luxon__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_luxon___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_luxon__);



//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    var _this = this;

    return {
      isLocalAdmin: true,
      companyLoading: true,
      search: '',
      companies: [],
      selectedCompany: null,
      err: '',
      isEdit: false,
      success: '',
      valid: false,
      loading: false,
      days: [{ text: this.$lang.labels.sunday, value: 'Sunday' }, { text: this.$lang.labels.monday, value: 'Monday' }, { text: this.$lang.labels.tuesday, value: 'Tuesday' }, { text: this.$lang.labels.wednesday, value: 'Wednesday' }, { text: this.$lang.labels.thursday, value: 'Thursday' }, { text: this.$lang.labels.friday, value: 'Friday' }, { text: this.$lang.labels.saturday, value: 'Saturday' }],
      types: ['collection', 'delivery'],
      methods: ['cash', 'card'],
      discountAmount: null,
      discountPercent: null,
      amountOfPersons: null,
      daysOfWeek: [],
      orderTypes: [],
      paymentMethods: [],
      startTime: null,
      endTime: null,
      minAmount: null,
      voucherCode: null,
      description: null,
      data: {
        companyId: '' + this.$route.params.companyId,
        ruleName: null,
        conditions: {},
        value: {}
      },
      timeRule: [function (v) {
        return (/^([01]\d|2[0-3]):?([0-5]\d)$/.test(v) || _this.$lang.errors.validTime
        );
      }],
      createdOn: '',
      modifiedOn: ''
    };
  },

  computed: {
    validation: function validation() {
      var startTime = this.startTime;
      var endTime = this.endTime;
      var valid = this.valid;
      var isValidStart = true;
      var isValidEnd = true;
      if (startTime !== null) {
        isValidStart = this.validateTime(startTime);
      }
      if (endTime !== null) {
        isValidEnd = this.validateTime(endTime);
      }
      if (isValidStart && isValidEnd && valid) {
        return true;
      }
      return false;
    }
  },
  watch: {
    selectedCompany: function selectedCompany(val) {
      if (val) {
        this.data.companyId = val;
      }
    },
    err: function err(val) {
      var _this2 = this;

      if (val !== '') {
        setTimeout(function () {
          _this2.err = '';
        }, 5000);
      }
    }
  },
  methods: {
    formatDate: function formatDate(date) {
      return __WEBPACK_IMPORTED_MODULE_3_luxon__["DateTime"].fromISO(date).toFormat('yyyy-MM-dd HH:mm:ss');
    },
    validateTime: function validateTime(time) {
      if (!time) return false;
      var valid = true;
      if (parseInt(time[0], 10) > 2 || parseInt(time[0], 10) === 2 && parseInt(time[1], 10) > 3 || parseInt(time[2], 10) > 5 || !time[3]) valid = false;
      return valid;
    },
    formatTime: function formatTime(time) {
      return [time.slice(0, 2), ':', time.slice(2)].join('');
    },
    submit: function submit() {
      var _this3 = this;

      var data = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign___default()({}, this.data);
      if (this.amountOfPersons !== null) {
        __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign___default()(data.conditions, { amountOfPersons: this.amountOfPersons });
      }
      if (this.daysOfWeek.length !== 0) {
        __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign___default()(data.conditions, { daysOfWeek: this.daysOfWeek });
      }
      if (this.orderTypes.length !== 0) {
        __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign___default()(data.conditions, { orderTypes: this.orderTypes });
      }
      if (this.paymentMethods.length !== 0) {
        __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign___default()(data.conditions, { paymentMethods: this.paymentMethods });
      }
      if (this.startTime !== null) {
        __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign___default()(data.conditions, { startTime: this.startTime });
      }
      if (this.endTime !== null) {
        __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign___default()(data.conditions, { endTime: this.endTime });
      }
      if (this.minAmount !== null) {
        __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign___default()(data.conditions, { minAmount: this.minAmount });
      }
      __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign___default()(data.conditions, { voucherCode: !this.voucherCode ? null : this.voucherCode });

      if (__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default()(data.conditions).length === 0) {
        this.err = 'You must add at least one condition';
        return;
      }
      if (this.discountAmount !== null) {
        __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign___default()(data, { value: { discountAmount: this.discountAmount } });
      }
      if (this.discountPercent !== null) {
        __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign___default()(data, { value: { discountPercent: this.discountPercent } });
      }
      if (__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default()(data.value).length === 0) {
        this.err = 'You must add value';
        return;
      }
      if (data.conditions.startTime) {
        data.conditions.startTime = this.formatTime(data.conditions.startTime);
      }
      if (data.conditions.endTime) {
        data.conditions.endTime = this.formatTime(data.conditions.endTime);
      }
      if (this.description !== null) {
        __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign___default()(data, { description: this.description });
      }
      this.loading = true;
      var url = this.isEdit ? 'discountrule/update/' + this.$route.params.id : 'discountrule/create';
      this.$http.post(url, data).then(function (res) {
        if (res.body.status === 'Success') {
          _this3.loading = false;
          _this3.success = _this3.isEdit ? 'Discount Rule updated successfuly' : 'Discount Rule created successfuly';
          setTimeout(function () {
            if (_this3.isEdit) {
              _this3.success = '';
            } else {
              _this3.$router.push({ name: 'discountRules' });
            }
          }, 3000);
          return;
        }
        _this3.err = res.body.statusText;
      }, function (err) {
        _this3.loading = false;
        _this3.err = err.body.statusText || err.body.message;
      });
    },
    init: function init() {
      var _this4 = this;

      return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve) {
        _this4.$http.get('company').then(function (res) {
          resolve();
          _this4.companyLoading = false;
          if (res.body.status === 'Success') {
            _this4.companies = res.body.companies;
            _this4.selectedCompany = _this4.$route.params.id ? res.body.companies[0].id : _this4.$route.params.companyId;
            return;
          }
          _this4.err = res.body.statusText;
        }, function (err) {
          resolve();
          _this4.companyLoading = false;
          _this4.err = err.body.statusText || err.body.message;
        });
      });
    }
  },
  created: function created() {
    var _this5 = this;

    this.isLocalAdmin = this.$auth.roles && this.$auth.roles.includes('ROLE_SUN_LOCAL_ADMIN');
    this.init().then(function () {
      if (_this5.$route.params.id) {
        _this5.isEdit = true;
        _this5.$http.get('discountrule/' + _this5.$route.params.id).then(function (res) {
          if (res.body.status === 'Success') {
            var data = res.body.discountRule;
            if (data.value.discountAmount) {
              _this5.discountAmount = data.value.discountAmount;
            }
            if (data.value.discountPercent) {
              _this5.discountPercent = data.value.discountPercent;
            }
            if (data.conditions.amountOfPersons) {
              _this5.amountOfPersons = data.conditions.amountOfPersons;
            }
            if (data.conditions.daysOfWeek) {
              _this5.daysOfWeek = data.conditions.daysOfWeek;
            }
            if (data.conditions.orderTypes) {
              _this5.orderTypes = data.conditions.orderTypes;
            }
            if (data.conditions.paymentMethods) {
              _this5.paymentMethods = data.conditions.paymentMethods;
            }
            if (data.conditions.startTime) {
              _this5.startTime = data.conditions.startTime;
            }
            if (data.conditions.endTime) {
              _this5.endTime = data.conditions.endTime;
            }
            if (data.conditions.minAmount) {
              _this5.minAmount = data.conditions.minAmount;
            }
            if (data.conditions.voucherCode) {
              _this5.voucherCode = data.conditions.voucherCode;
            }
            if (data.description) {
              _this5.description = data.description;
            }
            _this5.createdOn = _this5.formatDate(data.createdOn);
            if (data.modifiedOn) {
              _this5.modifiedOn = _this5.formatDate(data.modifiedOn);
            }
            _this5.data.ruleName = data.ruleName;
            _this5.selectedCompany = data.companyId;
          }
        }, function (err) {
          _this5.err = err.body.statusText || err.body.message;
        });
      }
    });
  }
});

/***/ }),
/* 190 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_luxon__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_luxon___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_luxon__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      err: '',
      search: '',
      show: false,
      loading: false,
      companyLoading: true,
      selectedCompany: '',
      companies: [],
      headers: [{ text: this.$lang.labels.name, value: 'ruleName', align: 'left' }, { text: this.$lang.labels.created, value: 'createdOn', align: 'left' }, { text: this.$lang.labels.status, value: 'status', align: 'left' }, { text: this.$lang.labels.actions, value: 'actions', align: 'left', sortable: false }],
      showActive: true,
      allDiscounts: []
    };
  },

  computed: {
    activeDiscounts: function activeDiscounts() {
      var discounts = this.allDiscounts;
      var activeDiscounts = [];
      for (var i = 0; discounts.length > i; i++) {
        if (discounts[i].status === 'active') {
          activeDiscounts.push(discounts[i]);
        }
      }
      return activeDiscounts;
    },
    mappedCompanies: function mappedCompanies() {
      return this.companies.map(function (company) {
        return {
          text: company.name + ' (' + company.companyStatus + ')',
          value: company.id
        };
      });
    }
  },
  methods: {
    formatDate: function formatDate(date) {
      return __WEBPACK_IMPORTED_MODULE_0_luxon__["DateTime"].fromISO(date).toFormat('yyyy-MM-dd HH:mm');
    },
    changeStatus: function changeStatus(discount) {
      var _this = this;

      var action = discount.status === 'active' ? 'deactivate' : 'activate';
      this.$http.post('discountrule/' + action + '/' + discount.id).then(function (res) {
        if (res.body.status === 'Success') {
          _this.$set(discount, 'status', action === 'activate' ? 'active' : 'inactive');
          return;
        }
        _this.err = res.body.statusText;
      }, function (err) {
        _this.err = err.body.statusText || err.body.message;
      });
    },
    fetchDiscountForCompany: function fetchDiscountForCompany(id) {
      var _this2 = this;

      this.show = true;
      this.discountRules = [];
      this.loading = true;
      this.$http.post('discountrule/getall', { companyId: id }).then(function (res) {
        _this2.loading = false;
        if (res.body.status === 'Success') {
          _this2.allDiscounts = res.body.discountRules;
          return;
        }
        if (_this2.discountRules.length === 0) {
          _this2.loading = false;
        }
        _this2.err = res.body.statusText;
      }, function (err) {
        _this2.loading = false;
        _this2.err = err.body.statusText || err.body.message;
      });
    }
  },
  watch: {
    err: function err(val) {
      var _this3 = this;

      if (val !== '') {
        setTimeout(function () {
          _this3.err = '';
        }, 5000);
      }
    },
    selectedCompany: function selectedCompany(val) {
      this.fetchDiscountForCompany(val);
      this.$cookie.set('companyedit', val, { expires: '8h' });
    }
  },
  created: function created() {
    var _this4 = this;

    this.$http.get('company').then(function (res) {
      _this4.companyLoading = false;
      if (res.body.status === 'Success') {
        _this4.companies = res.body.companies;
        var edit = _this4.$cookie.get('companyedit');
        if (edit) _this4.selectedCompany = edit;
        return;
      }
      _this4.err = res.body.statusText;
    }, function (err) {
      _this4.companyLoading = false;
      _this4.err = err.body.statusText || err.body.message;
    });
  }
});

/***/ }),
/* 191 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__assets_url__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_luxon__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_luxon___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_luxon__);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["default"] = ({
  components: {
    confirmationModal: function confirmationModal() {
      return __webpack_require__.e/* import() */(0/* duplicate */).then(__webpack_require__.bind(null, 25));
    }
  },
  data: function data() {
    return {
      err: '',
      search: '',
      headers: [{ text: this.$lang.labels.companyDomain, value: 'domain', align: 'left' }, { text: this.$lang.labels.type, value: 'type', align: 'left' }, { text: this.$lang.labels.status, value: 'status', align: 'left' }, { text: this.$lang.labels.created, value: 'createdOn', align: 'left' }, { text: this.$lang.labels.actions, value: 'actions', align: 'left', sortable: false }],
      showActive: true,
      allDomains: [],
      confirmationModal: false,
      confirmationData: {
        id: null,
        url: 'domain'
      }
    };
  },

  computed: {
    activeDomains: function activeDomains() {
      var domains = this.allDomains;
      var activeDomains = [];
      for (var i = 0; domains.length > i; i++) {
        if (domains[i].status === 'active') {
          activeDomains.push(domains[i]);
        }
      }
      return activeDomains;
    }
  },
  methods: {
    formatDate: function formatDate(date) {
      return __WEBPACK_IMPORTED_MODULE_2_luxon__["DateTime"].fromISO(date).toFormat('yyyy-MM-dd');
    },
    editDomain: function editDomain(domain) {
      this.$router.push({ name: 'editDomain', params: { id: domain.id } });
    },
    changeStatus: function changeStatus(domain) {
      var _this = this;

      if (domain.status === 'inactive') {
        this.$http.post('domain/activate/' + domain.id).then(function (res) {
          if (res.body.status === 'Success') {
            _this.$set(domain, 'status', 'active');
            return;
          }
          _this.err = res.body.statusText;
        }, function (err) {
          _this.err = err.body.statusText || err.body.message;
        });
      } else if (domain.status === "active") {
        this.confirmationData.id = domain.id;
        this.confirmationModal = true;
      }
    },
    deactivate: function deactivate(id) {
      var result = this.allDomains.find(function (data) {
        return data.id === id;
      });
      this.$set(result, 'status', 'inactive');
    },
    fetchAllDomains: function fetchAllDomains() {
      var _this2 = this;

      fetch(__WEBPACK_IMPORTED_MODULE_1__assets_url__["a" /* baseUrl */] + '/domain/getall', {
        method: 'get',
        credentials: 'include',
        headers: {
          'Accept': 'application/json',
          'Content-Type': 'application/json;charset=UTF-8'
        }
      }).then(function (response) {
        return response.json();
      }).then(function (data) {
        if (data.error & data.error === 'Forbidden') {
          _this2.$router.push({ name: 'logout' });
          return;
        }
        _this2.allDomains = data.domains;
        localStorage.setItem('domains', __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(data.domains));
      });
    }
  },
  watch: {
    err: function err(val) {
      var _this3 = this;

      if (val !== '') {
        setTimeout(function () {
          _this3.err = '';
        }, 5000);
      }
    }
  },
  created: function created() {
    this.fetchAllDomains();
  }
});

/***/ }),
/* 192 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__assets_fetch_data__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__assets_url__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_luxon__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_luxon___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_luxon__);



//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      err: '',
      isEdit: false,
      success: '',
      valid: false,
      companies: [],
      companyLoading: true,
      companyId: null,
      types: [],
      domainLoading: true,
      domainType: null,
      domainName: '',
      registeredOn: '',
      deregisteredOn: '',
      menu: false,
      menu2: false,
      createdOn: '',
      modifiedOn: ''
    };
  },
  computed: {
    filteredTypes: function filteredTypes() {
      var _this = this;

      return this.filterTypes.length === 0 ? this.types : this.types.filter(function (type) {
        return type.toLowerCase().includes(_this.filterTypes.toLowerCase());
      });
    },
    formattedRegisteredOn: function formattedRegisteredOn() {
      return !this.registeredOn ? null : __WEBPACK_IMPORTED_MODULE_5_luxon__["DateTime"].fromISO(this.registeredOn).toFormat('yyyy-MM-dd HH:mm');
    },
    formattedDeregisteredOn: function formattedDeregisteredOn() {
      return !this.deregisteredOn ? null : __WEBPACK_IMPORTED_MODULE_5_luxon__["DateTime"].fromISO(this.deregisteredOn).toFormat('yyyy-MM-dd HH:mm');
    }
  },
  watch: {
    err: function err(val) {
      var _this2 = this;

      if (val !== '') {
        setTimeout(function () {
          _this2.err = '';
        }, 5000);
      }
    }
  },
  methods: {
    formatDate: function formatDate(date) {
      return __WEBPACK_IMPORTED_MODULE_5_luxon__["DateTime"].fromISO(date).toFormat('yyyy-MM-dd HH:mm:ss');
    },
    fetchCompanies: function fetchCompanies() {
      var _this3 = this;

      return new __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise___default.a(function (resolve) {
        fetch(__WEBPACK_IMPORTED_MODULE_4__assets_url__["a" /* baseUrl */] + '/company', {
          method: 'get',
          credentials: 'include',
          headers: {
            'Accept': 'application/json',
            'Content-Type': 'application/json;charset=UTF-8'
          }
        }).then(function (response) {
          return response.json();
        }).then(function (data) {
          if (data.error & data.error === 'Forbidden') {
            _this3.$router.push({ name: 'logout' });
            return;
          }
          _this3.companyLoading = false;
          _this3.companies = data.companies;
          resolve();
        }).catch(function (e) {
          _this3.companyLoading = false;
          _this3.err = 'Failed to fetch companies';
          resolve();
        });
      });
    },
    fetchDomainById: function fetchDomainById(id) {
      var _this4 = this;

      fetch(__WEBPACK_IMPORTED_MODULE_4__assets_url__["a" /* baseUrl */] + '/domain/' + id, {
        method: 'get',
        credentials: 'include',
        headers: {
          'Accept': 'application/json',
          'Content-Type': 'application/json;charset=UTF-8'
        }
      }).then(function (response) {
        return response.json();
      }).then(function (data) {
        if (data.error & data.error === 'Forbidden') {
          _this4.$router.push({ name: 'logout' });
          return;
        }
        _this4.isEdit = true;
        _this4.companyId = data.domain.companyId;
        _this4.domainName = data.domain.domain;
        _this4.domainType = data.domain.type;
        _this4.registeredOn = data.domain.registeredOn;
        _this4.deregisteredOn = data.domain.deregisteredOn;
        _this4.createdOn = _this4.formatDate(data.domain.createdOn);
        if (data.domain.modifiedOn) {
          _this4.modifiedOn = _this4.formatDate(data.domain.modifiedOn);
        }
      }).catch(function (e) {});
    },
    fetchTypes: function fetchTypes() {
      var _this5 = this;

      fetch(__WEBPACK_IMPORTED_MODULE_4__assets_url__["a" /* baseUrl */] + '/system/domain/fetchtypes', {
        method: 'get',
        credentials: 'include',
        headers: {
          'Accept': 'application/json',
          'Content-Type': 'application/json;charset=UTF-8'
        }
      }).then(function (response) {
        return response.json();
      }).then(function (data) {
        if (data.error & data.error === 'Forbidden') {
          _this5.$router.push({ name: 'logout' });
          return;
        }
        _this5.domainLoading = false;
        _this5.types =  false ? ['.com', '.uk'] : data.types;
        localStorage.setItem('types', __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default()(data.types));
      }).catch(function (e) {
        _this5.domainLoading = false;
        _this5.err = 'Failed to fetch domain types';
      });
    },
    submit: function submit() {
      var _this6 = this;

      if (!this.companyId || !this.domainName || !this.domainType || !this.registeredOn) return;
      var data = {
        domain: this.domainName,
        type: this.domainType,
        registeredOn: this.registeredOn,
        deregisteredOn: this.deregisteredOn
      };
      if (!this.isEdit) {
        __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()(data, { companyId: this.companyId });
      }
      var url = this.isEdit ? __WEBPACK_IMPORTED_MODULE_4__assets_url__["a" /* baseUrl */] + '/domain/update/' + this.$route.params.id : __WEBPACK_IMPORTED_MODULE_4__assets_url__["a" /* baseUrl */] + '/domain/create';
      this.$http.post(url, data).then(function (res) {
        if (res.body.status === 'Success') {
          _this6.success = res.body.statusText;
          setTimeout(function () {
            _this6.success = '';
            _this6.$router.push({ name: 'domains' });
          }, 3000);
          return;
        }
      }).catch(function (e) {
        _this6.err = 'Failed to submit domain';
      });
    }
  },
  created: function created() {
    var _this7 = this;

    this.fetchTypes();
    this.fetchCompanies().then(function () {
      if (_this7.$route.params.id) {
        _this7.fetchDomainById(_this7.$route.params.id);
      }
    });
  }
});

/***/ }),
/* 193 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise__);



//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  components: {
    preview: function preview() {
      return __webpack_require__.e/* import() */(4/* duplicate */).then(__webpack_require__.bind(null, 82));
    }
  },
  name: "ImageDetails",
  data: function data() {
    return {
      err: '',
      success: '',
      valid: false,
      isEdit: false,
      companyLoading: true,
      lablesLoading: false,
      companies: [],
      labels: [],
      images: [],
      filename: '',
      image: {
        "id": "",
        "name": "",
        "companyId": "",
        "base64Image": "",
        "label": "",
        "status": "",
        "createdOn": "",
        "createdBy": "",
        "modifiedOn": "",
        "modifiedBy": "",
        "publiclyAvailable": false
      },
      previewModal: false,
      previewData: null
    };
  },
  watch: {
    err: function err(val) {
      var _this = this;

      if (val !== '') {
        setTimeout(function () {
          _this.err = '';
        }, 5000);
      }
    }
  },
  computed: {},
  methods: {
    preview: function preview() {
      this.previewModal = true;
    },
    previewValidation: function previewValidation() {
      var valid = true;
      if (this.image.base64Image.length > 0) valid = false;
      return valid;
    },
    getFormData: function getFormData(files) {
      return new __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise___default.a(function (resolve) {
        var reader = new FileReader();
        reader.readAsDataURL(files[0]);
        reader.onload = function () {
          resolve(reader.result);
        };
        reader.onerror = function (error) {
          resolve(null);
        };
      });
    },
    startInput: function startInput(name) {
      this.$refs[name].click();
    },
    onFileChange: function onFileChange(name, $event) {
      var _this2 = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
        var files, data, maxSize, img;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                files = $event.target.files || $event.dataTransfer.files;

                if (!(files && files[0])) {
                  _context.next = 19;
                  break;
                }

                _context.next = 4;
                return _this2.getFormData(files);

              case 4:
                data = _context.sent;

                if (!(data === null)) {
                  _context.next = 8;
                  break;
                }

                _this2.err = 'Failed to convert image';
                return _context.abrupt('return');

              case 8:
                maxSize = 786432;

                if (!(files[0].size > maxSize)) {
                  _context.next = 14;
                  break;
                }

                _this2.err = 'The selected images is beyond limit of ' + maxSize + ' KB.';
                _this2.filename = '';
                _this2.image.base64Image = '';
                return _context.abrupt('return');

              case 14:
                img = new Image();

                img.src = window.URL.createObjectURL(files[0]);
                img.onload = function () {
                  var width = img.naturalWidth;
                  var height = img.naturalHeight;
                  window.URL.revokeObjectURL(img.src);
                  var maxWidth = 1920;
                  var maxHeight = 1080;
                  if (Number(width) > maxWidth || Number(height) > maxHeight) {
                    _this2.err = 'The maximum allowed resolution is ' + maxWidth + ' x ' + maxHeight + '.';
                    _this2.filename = '';
                    _this2.image.base64Image = '';
                    return;
                  }
                  _this2.filename = files[0].name;
                  _this2.image.base64Image = data;
                };
                _context.next = 21;
                break;

              case 19:
                _this2.filename = '';
                _this2.image.base64Image = '';

              case 21:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this2);
      }))();
    },
    init: function init() {
      var _this3 = this;

      return new __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise___default.a(function (resolve) {
        _this3.$http.get('company').then(function (res) {
          resolve();
          _this3.companyLoading = false;
          if (res.body.status === 'Success') {
            _this3.companies = res.body.companies;
            return;
          }
          _this3.err = res.body.statusText;
        }, function (err) {
          resolve();
          _this3.companyLoading = false;
          _this3.err = err.body.statusText || err.body.message;
        });
        var edit = _this3.$cookie.get('companyedit');
        if (edit) _this3.image.companyId = edit;
      });
    },
    toggleActivate: function toggleActivate() {
      var _this4 = this;

      var action = this.image.status === 'active' ? 'deactivate' : 'activate';
      this.$http.post('imageresource/' + action + '/' + this.image.id).then(function (res) {
        if (res.body.status === 'Success') {
          _this4.image.status = action === 'activate' ? 'active' : 'inactive';
          return;
        }
        _this4.err = res.body.statusText;
      }, function (err) {
        _this4.err = err.body.statusText || err.body.message;
      });
    },
    fetchLables: function fetchLables() {
      var _this5 = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2() {
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _this5.lablesLoading = true;
                _this5.labels = [];
                _this5.$http.get('system/imageresource/fetchimageresourcelabels').then(function (res) {
                  if (res.body.status === 'Success') {
                    _this5.lablesLoading = false;
                    _this5.labels = res.body.imageResourceLabels.sort();
                    return;
                  }
                  _this5.err = res.body.statusText;
                }, function (err) {
                  _this5.err = err.body.statusText || err.body.message;
                });

              case 3:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, _this5);
      }))();
    },
    submit: function submit() {
      var _this6 = this;

      if (this.image.base64Image === '') {
        this.err = 'Please upload image to continue';
        return;
      }
      var url = this.isEdit ? 'imageresource/update/' + this.$route.params.id : 'imageresource/create';
      this.$http.post(url, this.image).then(function (res) {
        if (res.body.status === 'Success') {
          _this6.success = _this6.isEdit ? 'Image updated successfuly' : 'Image created successfuly';
          setTimeout(function () {
            if (_this6.isEdit) {
              _this6.success = '';
            } else {
              _this6.$router.push({ name: 'images' });
            }
          }, 3000);
          return;
        }
        _this6.err = res.body.statusText;
      }, function (err) {
        _this6.err = err.body.statusText || err.body.message;
      });
    }
  },
  created: function created() {
    var _this7 = this;

    this.fetchLables().then(function () {
      _this7.init().then(function () {
        if (_this7.$route.params.id) {
          _this7.isEdit = true;
          _this7.$http.get('imageresource/' + _this7.$route.params.id).then(function (res) {
            if (res.body.status === 'Success') {
              _this7.image = res.body.imageResource;
              _this7.filename = res.body.imageResource.name;
              return;
            }
            _this7.err = res.body.statusText;
          }, function (err) {
            _this7.err = err.body.statusText || err.body.message;
          });
        }
      });
    });
  }
});

/***/ }),
/* 194 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  name: "Images",
  data: function data() {
    return {
      isLocalAdmin: false,
      err: '',
      search: '',
      loading: false,
      show: false,
      selectedCompany: null,
      companies: [],
      headers: [{ text: this.$lang.labels.name, value: 'name', align: 'left' }, { text: this.$lang.header.label, value: 'label', align: 'left' }, { text: this.$lang.labels.imageId, value: 'id', align: 'left' }, { text: this.$lang.labels.publiclyAvailable, value: 'status', align: 'left' }, { text: this.$lang.labels.status, value: 'publiclyAvailable', align: 'left' }, { text: this.$lang.labels.actions, value: 'actions', align: 'left', sortable: false }],
      showActive: true,
      allImages: []
    };
  },

  methods: {
    changeStatus: function changeStatus(image) {
      var _this = this;

      var action = image.status === 'active' ? 'deactivate' : 'activate';
      this.$http.post('imageresource/' + action + '/' + image.id).then(function (res) {
        if (res.body.status === 'Success') {
          _this.$set(image, 'status', action === 'activate' ? 'active' : 'inactive');
          return;
        }
        _this.err = res.body.statusText;
      }, function (err) {
        _this.err = err.body.statusText || err.body.message;
      });
    },
    fetchImagesForCompany: function fetchImagesForCompany(id) {
      var _this2 = this;

      this.loading = true;
      this.allImages = [];
      this.$http.post('imageresource', { companyId: id }).then(function (res) {
        if (res.body.status === 'Success') {
          _this2.loading = false;
          _this2.allImages = res.body.imageResources;
          if (_this2.allImages.length === 0) {
            _this2.loading = false;
          }
          return;
        }
        _this2.err = res.body.statusText;
      }, function (err) {
        _this2.loading = false;
        _this2.err = err.body.statusText || err.body.message;
      });
    }
  },
  watch: {
    err: function err(val) {
      var _this3 = this;

      if (val !== '') {
        setTimeout(function () {
          _this3.err = '';
        }, 5000);
      }
    },
    selectedCompany: function selectedCompany(val) {
      this.show = true;
      this.fetchImagesForCompany(val);
      this.$cookie.set('companyedit', val, { expires: '8h' });
    }
  },
  computed: {
    activeImages: function activeImages() {
      var images = this.allImages;
      var activeImages = [];
      for (var i = 0; images.length > i; i++) {
        if (images[i].status === 'active') {
          activeImages.push(images[i]);
        }
      }
      return activeImages;
    },
    mappedCompanies: function mappedCompanies() {
      return this.companies.map(function (company) {
        return {
          text: company.name + ' (' + company.companyStatus + ')',
          value: company.id
        };
      });
    }
  },
  created: function created() {
    var _this4 = this;

    this.isLocalAdmin = this.$auth.roles && this.$auth.roles.includes('ROLE_SUN_LOCAL_ADMIN');
    if (this.isLocalAdmin) {
      this.fetchImagesForCompany();
      return;
    }
    this.$http.get('company').then(function (res) {
      if (res.body.status === 'Success') {
        _this4.companies = res.body.companies;
        return;
      }
      _this4.err = res.body.statusText;
    }, function (err) {
      _this4.err = err.body.statusText || err.body.message;
    });
    var edit = this.$cookie.get('companyedit');
    if (edit) this.selectedCompany = edit;
  }
});

/***/ }),
/* 195 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_luxon__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_luxon___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_luxon__);




//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = ({
  components: {
    overviewModal: function overviewModal() {
      return __webpack_require__.e/* import() */(33).then(__webpack_require__.bind(null, 460));
    },
    detailsModal: function detailsModal() {
      return __webpack_require__.e/* import() */(2).then(__webpack_require__.bind(null, 453));
    },
    buildModal: function buildModal() {
      return __webpack_require__.e/* import() */(34).then(__webpack_require__.bind(null, 459));
    }
  },
  data: function data() {
    return {
      err: '',
      search: '',
      show: false,
      language: this.$cookie.get('lang') || 'en',
      companies: [],
      valid: false,
      currency: null,
      showOverviewModal: false,
      showBuildModal: false,
      data: {
        companyId: null,
        pricingGroups: [],
        month: __WEBPACK_IMPORTED_MODULE_4_luxon__["DateTime"].local().minus({ months: 1 }).month,
        year: __WEBPACK_IMPORTED_MODULE_4_luxon__["DateTime"].local().minus({ months: 1 }).year
      },
      companyLoading: true,
      headers: [{ text: this.$lang.labels.companyName, value: 'companyName', align: 'left' }, { text: this.$lang.header.pricingGroupName, value: 'pricingGroupName', align: 'left' }, { text: this.$lang.header.totalAmount, value: 'totalAmount', align: 'right' }, { text: this.$lang.labels.created, value: 'created', align: 'left' }, { text: this.$lang.labels.actions, value: 'actions', align: 'left', sortable: false }],
      invoices: [],
      allPricingGroups: [],
      months: [{ value: 1, text: this.$lang.labels.january }, { value: 2, text: this.$lang.labels.february }, { value: 3, text: this.$lang.labels.march }, { value: 4, text: this.$lang.labels.april }, { value: 5, text: this.$lang.labels.may }, { value: 6, text: this.$lang.labels.june }, { value: 7, text: this.$lang.labels.july }, { value: 8, text: this.$lang.labels.august }, { value: 9, text: this.$lang.labels.september }, { value: 10, text: this.$lang.labels.october }, { value: 11, text: this.$lang.labels.november }, { value: 12, text: this.$lang.labels.december }],
      overviewConfig: [],
      overviewloading: false,
      detailsModal: false,
      invoiceId: null
    };
  },

  watch: {
    err: function err(val) {
      var _this = this;

      if (val !== '') {
        setTimeout(function () {
          _this.err = '';
        }, 5000);
      }
    },

    'data.companyId': function dataCompanyId(val) {
      this.$cookie.set('companyedit', val, { expires: '8h' });
      this.data.pricingGroups = [];
      var company = this.companies.find(function (company) {
        return company.id === val;
      });
      if (company.currency) {
        this.allPricingGroups = [];
        this.fetchPricingGroups(company.currency);
      }
      if (!company) return;
    }
  },
  computed: {
    years: function years() {
      var array = [];
      var x = 2018;
      for (x; x <= __WEBPACK_IMPORTED_MODULE_4_luxon__["DateTime"].local().year; x++) {
        array.push(x);
      }
      return array;
    },
    mappedGroups: function mappedGroups() {
      return this.allPricingGroups.map(function (group) {
        return {
          text: group.name,
          value: group.id
        };
      });
    },
    mappedCompanies: function mappedCompanies() {
      return this.companies.map(function (company) {
        return {
          text: company.name + ' (' + company.companyStatus + ')',
          value: company.id
        };
      });
    }
  },
  methods: {
    showDetails: function showDetails(id) {
      this.invoiceId = id;
      this.detailsModal = true;
    },
    openOverview: function openOverview() {
      var _this2 = this;

      return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee2() {
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _this2.overviewloading = true;
                _this2.overviewConfig = [];
                _context2.next = 4;
                return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise___default.a.all(_this2.companies.map(function () {
                  var _ref = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee(company) {
                    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
                      while (1) {
                        switch (_context.prev = _context.next) {
                          case 0:
                            return _context.abrupt('return', _this2.fetchPricingGroups(company.currency, true));

                          case 1:
                          case 'end':
                            return _context.stop();
                        }
                      }
                    }, _callee, _this2);
                  }));

                  return function (_x) {
                    return _ref.apply(this, arguments);
                  };
                }()));

              case 4:
                _this2.overviewloading = false;
                _this2.showOverviewModal = true;

              case 6:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, _this2);
      }))();
    },
    fetchPricingGroups: function fetchPricingGroups(currency) {
      var _this3 = this;

      var isOverview = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

      return new __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise___default.a(function (resolve) {
        _this3.$http.post('pricinggroup/getall', { currency: currency }).then(function (res) {
          if (res.body.status === 'Success') {
            if (isOverview) {
              var _overviewConfig;

              (_overviewConfig = _this3.overviewConfig).push.apply(_overviewConfig, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(res.body.pricingGroups));
            } else {
              _this3.allPricingGroups = res.body.pricingGroups;
            }
            resolve();
            return;
          }
          resolve();
          _this3.err = res.body.statusText;
        }, function (err) {
          _this3.err = err.body.statusText || err.body.message;
          resolve();
        });
      });
    },
    init: function init() {
      var _this4 = this;

      return new __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise___default.a(function (resolve) {
        _this4.$http.get('company?detailed=true').then(function (res) {
          resolve();
          _this4.companyLoading = false;
          if (res.body.status === 'Success') {
            _this4.companies = res.body.companies;
            return;
          }
          _this4.err = res.body.statusText;
        }, function (err) {
          resolve();
          _this4.companyLoading = false;
          _this4.err = err.body.statusText || err.body.message;
        });
      });
    },
    formatDate: function formatDate(date) {
      return __WEBPACK_IMPORTED_MODULE_4_luxon__["DateTime"].fromISO(date).toFormat('yyyy-MM-dd');
    },
    fetchInvoicesforCompany: function fetchInvoicesforCompany() {
      var _this5 = this;

      this.show = true;
      this.invoices = [];
      this.$http.post('pricinggroupinvoice/getall', this.data).then(function (res) {
        _this5.companyLoading = false;
        if (res.body.status === 'Success') {
          _this5.invoices = res.body.pricingGroupInvoices;
          return;
        }
        _this5.err = res.body.statusText;
      }, function (err) {
        _this5.companyLoading = false;
        _this5.err = err.body.statusText || err.body.message;
      });
    }
  },
  created: function created() {
    var _this6 = this;

    this.init().then(function () {
      var edit = _this6.$cookie.get('companyedit');
      if (edit) _this6.data.companyId = edit;
    });
  }
});

/***/ }),
/* 196 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_luxon__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_luxon___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_luxon__);


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      err: '',
      success: '',
      valid: false,
      isEdit: false,
      companyLoading: true,
      companies: [],
      printerCategories: [],
      companyId: null,
      maps: [],
      tempMapping: {
        categoryName: '',
        language: ''
      },
      editingMap: false,
      languages: JSON.parse(localStorage.languages),
      createdOn: '',
      modifiedOn: ''
    };
  },
  watch: {
    err: function err(val) {
      var _this = this;

      if (val !== '') {
        setTimeout(function () {
          _this.err = '';
        }, 5000);
      }
    }
  },
  methods: {
    formatDate: function formatDate(date) {
      return __WEBPACK_IMPORTED_MODULE_2_luxon__["DateTime"].fromISO(date).toFormat('yyyy-MM-dd HH:mm:ss');
    },
    addMapping: function addMapping() {
      this.maps.push({
        categoryName: '',
        language: '',
        isEdit: true
      });
      this.editingMap = true;
      this.$forceUpdate();
    },
    editMapping: function editMapping(map) {
      this.tempMapping = {
        categoryName: map.categoryName,
        language: map.language
      };
      this.$set(map, 'isEdit', true);
      this.editingMap = true;
    },
    deleteMapping: function deleteMapping(index) {
      this.maps.splice(index, 1);
      this.$forceUpdate();
    },
    saveMappingEdit: function saveMappingEdit(map) {
      this.$set(map, 'categoryName', this.tempMapping.categoryName);
      this.$set(map, 'language', this.tempMapping.language);
      this.closeMappingEdit(map);
    },
    closeMappingEdit: function closeMappingEdit(map) {
      this.tempMapping = {
        categoryName: '',
        language: ''
      };
      this.$set(map, 'isEdit', false);
      this.editingMap = false;
    },
    init: function init() {
      var _this2 = this;

      return new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve) {
        _this2.$http.get('company').then(function (res) {
          resolve();
          _this2.companyLoading = false;
          if (res.body.status === 'Success') {
            _this2.companies = res.body.companies;
            return;
          }
          _this2.err = res.body.statusText;
        }, function (err) {
          resolve();
          _this2.companyLoading = false;
          _this2.err = err.body.statusText || err.body.message;
        });

        _this2.$http.get('printer/fetchprintercategories').then(function (res) {
          resolve();
          if (res.body.status === 'Success') {
            _this2.printerCategories = res.body.printerCategories;
            return;
          }
          _this2.err = res.body.statusText;
        }, function (err) {
          resolve();
          _this2.err = err.body.statusText || err.body.message;
        });
      });
    },
    submit: function submit() {
      var _this3 = this;

      if (this.maps.length === 0) {
        this.err = 'You must add at least one language mapping';
        return;
      }
      var data = {
        companyId: this.companyId,
        mapping: {}
      };
      this.maps.forEach(function (map) {
        return data.mapping[map.categoryName] = map.language;
      });
      var url = this.isEdit ? 'printercategory/update/' + this.$route.params.id : 'printercategory/create';
      this.$http.post(url, data).then(function (res) {
        if (res.body.status === 'Success') {
          _this3.success = _this3.isEdit ? 'Language Mapping updated successfuly' : 'Language Mapping created successfuly';
          setTimeout(function () {
            if (_this3.isEdit) {
              _this3.success = '';
            } else {
              _this3.$router.push({ name: 'languageMappings' });
            }
          }, 3000);
          return;
        }
        _this3.err = res.body.statusText;
      }, function (err) {
        _this3.err = err.body.statusText || err.body.message;
      });
    }
  },
  created: function created() {
    var _this4 = this;

    this.init().then(function () {
      if (_this4.$route.params.id) {
        _this4.isEdit = true;
        _this4.$http.get('printercategory/' + _this4.$route.params.id).then(function (res) {
          if (res.body.status === 'Success') {
            var data = res.body.details;
            _this4.companyId = data.companyId;
            _this4.createdOn = _this4.formatDate(data.createdOn);
            if (data.modifiedOn) {
              _this4.modifiedOn = _this4.formatDate(data.modifiedOn);
            }
            _this4.maps = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(data.mapping).map(function (key) {
              return {
                categoryName: key,
                language: data.mapping[key],
                isEdit: false
              };
            });
            _this4.$forceUpdate();
            return;
          }
          _this4.err = res.body.statusText;
        }, function (err) {
          _this4.err = err.body.statusText || err.body.message;
        });
      }
    });
  }
});

/***/ }),
/* 197 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_luxon__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_luxon___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_luxon__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      err: '',
      search: '',
      headers: [{ text: this.$lang.labels.company, value: 'companyName', align: 'left' }, { text: this.$lang.labels.created, value: 'createdOn', align: 'left' }, { text: this.$lang.labels.status, value: 'status', align: 'left' }, { text: this.$lang.labels.actions, value: 'actions', align: 'left', sortable: false }],
      showActive: true,
      allPrinterCategories: []
    };
  },

  methods: {
    formatDate: function formatDate(date) {
      return __WEBPACK_IMPORTED_MODULE_0_luxon__["DateTime"].fromISO(date).toFormat('yyyy-MM-dd');
    },
    changeStatus: function changeStatus(printerCategory) {
      var _this = this;

      var action = printerCategory.status === 'active' ? 'deactivate' : 'activate';
      this.$http.post('printercategory/' + action + '/' + printerCategory.id).then(function (res) {
        if (res.body.status === 'Success') {
          _this.$set(printerCategory, 'status', action === 'activate' ? 'active' : 'inactive');
          return;
        }
        _this.err = res.body.statusText;
      }, function (err) {
        _this.err = err.body.statusText || err.body.message;
      });
    }
  },
  watch: {
    err: function err(val) {
      var _this2 = this;

      if (val !== '') {
        setTimeout(function () {
          _this2.err = '';
        }, 5000);
      }
    }
  },
  computed: {
    activePrinterCategories: function activePrinterCategories() {
      var printerCategories = this.allPrinterCategories;
      var activePrinterCategories = [];
      for (var i = 0; printerCategories.length > i; i++) {
        if (printerCategories[i].status === 'active') {
          activePrinterCategories.push(printerCategories[i]);
        }
      }
      return activePrinterCategories;
    }
  },
  created: function created() {
    var _this3 = this;

    this.$http.get('printercategory/getall').then(function (res) {
      if (res.body.status === 'Success') {
        _this3.allPrinterCategories = res.body.details;
        return;
      }
      _this3.err = res.body.statusText;
    }, function (err) {
      _this3.err = err.body.statusText || err.body.message;
    });
  }
});

/***/ }),
/* 198 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_modals_MiniLicense__ = __webpack_require__(352);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_modals_MiniLicense___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_modals_MiniLicense__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_luxon__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_luxon___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_luxon__);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["default"] = ({
  components: {
    miniLicenseModal: __WEBPACK_IMPORTED_MODULE_1__components_modals_MiniLicense___default.a,
    activationModal: function activationModal() {
      return __webpack_require__.e/* import() */(32).then(__webpack_require__.bind(null, 461));
    }
  },
  data: function data() {
    return {
      err: '',
      success: '',
      viewMiniLicense: false,
      miniLicense: null,
      valid: false,
      isView: false,
      menu: false,
      menu2: false,
      companies: [],
      licenseTypes: [],
      instances: [],
      license: {
        companyId: null,
        licenseType: null,
        moonInstanceId: null,
        licenseAttributes: {
          concurrentUsers: ''
        },
        sunLicenseSystemVersion: '',
        getsActiveOn: '',
        expiresOn: '',
        isActivateOn: ''
      },
      testLicense: false,
      createdOn: '',
      modifiedOn: '',
      showActivationModal: false,
      creating: false,
      activationData: null
    };
  },
  watch: {
    'license.licenseType': function licenseLicenseType(val) {
      immediate: false;
      deep: true;
      if (this.isView) {
        return;
      }
      if (val === 'test') {
        this.license.sunLicenseSystemVersion = '';
        this.license.getsActiveOn = __WEBPACK_IMPORTED_MODULE_2_luxon__["DateTime"].local().toFormat('yyyy-MM-dd');
        this.license.expiresOn = __WEBPACK_IMPORTED_MODULE_2_luxon__["DateTime"].local().plus({ days: 60 }).toFormat('yyyy-MM-dd');
        this.testLicense = true;
        this.license.licenseAttributes.concurrentUsers = '10';
      }
      if (val === 'production') {
        this.license.sunLicenseSystemVersion = '1';
        this.license.getsActiveOn = __WEBPACK_IMPORTED_MODULE_2_luxon__["DateTime"].local().toFormat('yyyy-MM-dd');
        this.license.expiresOn = __WEBPACK_IMPORTED_MODULE_2_luxon__["DateTime"].local().plus({ years: 99 }).toFormat('yyyy-MM-dd');;
        this.testLicense = false;
        this.license.licenseAttributes.concurrentUsers = '';
      }
    }
  },
  computed: {
    mappedCompanies: function mappedCompanies() {
      return this.companies.map(function (company) {
        return {
          text: company.name + ' (' + company.companyStatus + ')',
          value: company.id
        };
      });
    }
  },
  methods: {
    formatDate: function formatDate(date) {
      return __WEBPACK_IMPORTED_MODULE_2_luxon__["DateTime"].fromISO(date).toFormat('yyyy-MM-dd HH:mm:ss');
    },
    submit: function submit() {
      var _this = this;

      this.creating = true;
      this.license.isActiveOn = this.license.getsActiveOn;
      this.$http.post('license/create', this.license).then(function (res) {
        if (res.body.status === 'Success') {
          _this.success = 'License created successfuly';
          setTimeout(function () {
            _this.activationData = res.body.licenseId;
            _this.showActivationModal = true;
          }, 1000);
          _this.creating = false;
          return;
        }
        _this.err = res.body.statusText;
      }, function (err) {
        _this.creating = false;
        _this.err = err.body.statusText || err.body.message;
      });
    },
    init: function init() {
      var _this2 = this;

      return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve) {
        _this2.$http.get('company').then(function (res) {
          resolve();
          if (res.body.status === 'Success') {
            _this2.companies = res.body.companies;
            return;
          }
          _this2.err = res.body.statusText;
        }, function (err) {
          resolve();
          _this2.err = err.body.statusText || err.body.message;
        });

        _this2.$http.get('license/fetchlicensetypes').then(function (res) {
          resolve();
          if (res.body.status === 'Success') {
            _this2.licenseTypes = res.body.types;
            return;
          }
          _this2.err = res.body.statusText;
        }, function (err) {
          resolve();
          _this2.err = err.body.statusText || err.body.message;
        });

        _this2.$http.get('moon/instance').then(function (res) {
          resolve();
          if (res.body.status === 'Success') {
            var instances = res.body.details;
            _this2.instances = instances.sort(function (a, b) {
              var nameA = a.name.toUpperCase();
              var nameB = b.name.toUpperCase();
              if (nameA < nameB) {
                return -1;
              }
              if (nameA > nameB) {
                return 1;
              }
              return 0;
            }).filter(function (instance) {
              return instance.status === 'active';
            });
            return;
          }
          _this2.err = res.body.statusText;
        }, function (err) {
          resolve();
          _this2.err = err.body.statusText || err.body.message;
        });
      });
    }
  },
  created: function created() {
    var _this3 = this;

    this.init().then(function () {
      if (_this3.$route.params.id) {
        _this3.isView = true;
        _this3.$http.get('license/' + _this3.$route.params.id).then(function (res) {
          if (res.body.status === 'Success') {
            var license = res.body.license;
            license.getsActiveOn = _this3.formatDate(license.getsActiveOn);
            license.expiresOn = _this3.formatDate(license.expiresOn);
            _this3.createdOn = _this3.formatDate(license.createdOn);
            if (license.modifiedOn) {
              _this3.modifiedOn = _this3.formatDate(license.modifiedOn);
            }
            _this3.license = license;
            return;
          }
          _this3.err = res.body.statusText;
        }, function (err) {
          _this3.err = err.body.statusText || err.body.message;
        });
      }
    });
  }
});

/***/ }),
/* 199 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_luxon__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_luxon___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_luxon__);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = ({
  components: {
    licenseReportDetailsModal: function licenseReportDetailsModal() {
      return __webpack_require__.e/* import() */(10).then(__webpack_require__.bind(null, 462));
    }
  },
  data: function data() {
    return {
      err: '',
      success: '',
      search: '',
      show: false,
      loading: true,
      valid: false,
      generateValid: false,
      generate: false,
      reports: [],
      companies: [],
      selectedCompany: '',
      companyLoading: true,
      headers: [{ text: this.$lang.labels.company, value: 'companyName', align: 'left' }, { text: this.$lang.labels.type, value: 'type', align: 'left', sortable: false }, { text: this.$lang.labels.created, value: 'createdOn', align: 'left' }, { text: this.$lang.labels.actions, value: 'actions', align: 'left', sortable: false }],
      aggrHeaders: [{ text: this.$lang.labels.type, value: 'type', align: 'left', sortable: false }, { text: this.$lang.labels.year, value: 'year', align: 'left' }, { text: this.$lang.labels.month, value: 'month', align: 'left' }, { text: this.$lang.labels.created, value: 'createdOn', align: 'left' }, { text: this.$lang.labels.actions, value: 'actions', align: 'left', sortable: false }],
      types: [{ text: this.$lang.labels.daily, value: 'daily' }, { text: this.$lang.labels.monthly, value: 'monthly' }, { text: this.$lang.labels.monthlyAgg, value: 'monthlyaggregated' }],
      pagination: {
        sortBy: 'createdOn',
        descending: true
      },
      menu: false,
      menu2: false,
      fromDate: '',
      toDate: '',
      licenseType: '',
      year: __WEBPACK_IMPORTED_MODULE_1_luxon__["DateTime"].local().year,
      month: __WEBPACK_IMPORTED_MODULE_1_luxon__["DateTime"].local().month,
      months: [{ value: 1, text: this.$lang.labels.january }, { value: 2, text: this.$lang.labels.february }, { value: 3, text: this.$lang.labels.march }, { value: 4, text: this.$lang.labels.april }, { value: 5, text: this.$lang.labels.may }, { value: 6, text: this.$lang.labels.june }, { value: 7, text: this.$lang.labels.july }, { value: 8, text: this.$lang.labels.august }, { value: 9, text: this.$lang.labels.september }, { value: 10, text: this.$lang.labels.october }, { value: 11, text: this.$lang.labels.november }, { value: 12, text: this.$lang.labels.december }],
      generateLoading: false,
      licenseReportDetailsModal: false,
      licenseReportDetails: null
    };
  },

  watch: {
    licenseType: function licenseType(newVal, oldVal) {
      if (newVal) {
        this.fromDate = __WEBPACK_IMPORTED_MODULE_1_luxon__["DateTime"].local().plus({ days: -1 }).toFormat('yyyy-MM-dd');
        this.toDate = __WEBPACK_IMPORTED_MODULE_1_luxon__["DateTime"].local().toFormat('yyyy-MM-dd');
        this.year = __WEBPACK_IMPORTED_MODULE_1_luxon__["DateTime"].local().year;
        this.month = __WEBPACK_IMPORTED_MODULE_1_luxon__["DateTime"].local().month;
      }
    },
    err: function err(val) {
      var _this = this;

      if (val !== '') {
        setTimeout(function () {
          _this.err = '';
        }, 5000);
      }
    }
  },
  computed: {
    years: function years() {
      var array = [];
      var x = 2018;
      for (x; x <= __WEBPACK_IMPORTED_MODULE_1_luxon__["DateTime"].local().year; x++) {
        array.push(x);
      }
      return array;
    }
  },
  methods: {
    showGenerate: function showGenerate() {
      this.generate = true;
    },
    close: function close() {
      this.year = __WEBPACK_IMPORTED_MODULE_1_luxon__["DateTime"].local().year;
      this.month = __WEBPACK_IMPORTED_MODULE_1_luxon__["DateTime"].local().month;
      this.generate = false;
    },
    formatDateForSubmit: function formatDateForSubmit(date) {
      var correctDate = new Date(date);
      correctDate.setUTCHours(0, 0, 0, 0);
      return correctDate.toISOString();
    },
    generateReport: function generateReport() {
      var _this2 = this;

      this.generateLoading = true;
      var data = {
        month: this.month,
        year: this.year
      };
      this.$http.post('licenseusage/generatemonthlyaggregate', data).then(function (res) {
        _this2.generateLoading = false;
        if (res.body.status === 'Success') {
          _this2.success = 'License Report generated successfuly';
          setTimeout(function () {
            _this2.success = '';
          }, 5000);
          return;
        }
        _this2.err = res.body.statusText;
      }, function (err) {
        _this2.generateLoading = false;
        _this2.err = err.body.statusText || err.body.message;
      });
    },
    formatDate: function formatDate(date) {
      return __WEBPACK_IMPORTED_MODULE_1_luxon__["DateTime"].fromISO(date).toFormat('yyyy-MM-dd HH:mm');
    },
    viewLicense: function viewLicense(license) {
      this.licenseReportDetails = {
        id: license.id,
        type: license.type
      };
      this.licenseReportDetailsModal = true;
    },
    showReports: function showReports() {
      var _this3 = this;

      this.show = true;
      this.loading = true;
      this.reports = [];
      if (this.licenseType === 'daily') {
        var data = {
          type: this.licenseType,
          fromDate: this.formatDateForSubmit(this.fromDate),
          toDate: this.formatDateForSubmit(this.toDate)
        };
        if (this.selectedCompany) {
          __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()(data, { companyId: this.selectedCompany });
        }
        this.$http.post('licenseusage/getall', data).then(function (res) {
          if (res.body.status !== 'Success') {
            _this3.err = res.body.statusText;
            return;
          }
          _this3.reports = res.body.licencesUsages;
          if (_this3.reports !== 0) {
            _this3.loading = false;
          }
        }, function (err) {
          _this3.show = false;
          _this3.err = err.body.statusText || err.body.message;
        });
      }
      if (this.licenseType === 'monthly' || this.licenseType === 'monthlyaggregated') {
        var _data = {
          month: this.month,
          type: this.licenseType,
          year: this.year
        };
        this.$http.post('licenseusage/getforyearandmonth', _data).then(function (res) {
          if (res.body.status !== 'Success') {
            _this3.err = res.body.statusText;
            return;
          }
          _this3.reports = res.body.licencesUsages;
          if (_this3.reports !== 0) {
            _this3.loading = false;
          }
        }, function (err) {
          _this3.show = false;
          _this3.err = err.body.statusText || err.body.message;
        });
      }
    }
  },
  created: function created() {
    var _this4 = this;

    this.$http.get('company').then(function (res) {
      _this4.companyLoading = false;
      if (res.body.status === 'Success') {
        _this4.companies = res.body.companies;
        return;
      }
      _this4.err = res.body.statusText;
    }, function (err) {
      _this4.companyLoading = false;
      _this4.err = err.body.statusText || err.body.message;
    });
  }
});

/***/ }),
/* 200 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_luxon__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_luxon___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_luxon__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = ({
  components: {
    confirmationModal: function confirmationModal() {
      return __webpack_require__.e/* import() */(0/* duplicate */).then(__webpack_require__.bind(null, 25));
    }
  },
  data: function data() {
    return {
      err: '',
      success: '',
      search: '',
      headers: [{ text: this.$lang.labels.company, value: 'companyName', align: 'left' }, { text: this.$lang.labels.licenseID, value: 'id', align: 'left' }, { text: this.$lang.header.licenseType, value: 'licenseType', align: 'left' }, { text: this.$lang.header.moonInstName, value: 'moonInstanceName', align: 'left' }, { text: this.$lang.header.activationDate, value: 'getsActiveOn', align: 'left' }, { text: this.$lang.header.expiryDate, value: 'expiresOn', align: 'left' }, { text: this.$lang.labels.status, value: 'status', align: 'left' }, { text: this.$lang.labels.actions, value: 'actions', align: 'left', sortable: false }],
      showActive: true,
      allLicenses: [],
      confirmationModal: false,
      confirmationData: {
        id: null,
        url: 'license'
      }
    };
  },

  methods: {
    formatDate: function formatDate(date) {
      return __WEBPACK_IMPORTED_MODULE_0_luxon__["DateTime"].fromISO(date).toFormat('yyyy-MM-dd');
    },
    viewLicense: function viewLicense(license) {
      this.$router.push({ name: 'license', params: { id: license.id } });
    },
    changeStatus: function changeStatus(license) {
      var _this = this;

      if (license.status === 'inactive' || license.status === 'draft') {
        this.$http.post('license/activate/' + license.id).then(function (res) {
          if (res.body.status === 'Success') {
            _this.$set(license, 'status', 'active');
            return;
          }
          _this.err = res.body.statusText;
        }, function (err) {
          _this.err = err.body.statusText || err.body.message;
        });
      } else if (license.status === "active") {
        this.confirmationData.id = license.id;
        this.confirmationModal = true;
      }
    },
    deactivate: function deactivate(id) {
      var result = this.allLicenses.find(function (data) {
        return data.id === id;
      });
      this.$set(result, 'status', 'inactive');
    }
  },
  computed: {
    activeLicenses: function activeLicenses() {
      var licenses = this.allLicenses;
      var activeLicenses = [];
      for (var i = 0; licenses.length > i; i++) {
        if (licenses[i].status === 'active' || licenses[i].status === 'draft') {
          activeLicenses.push(licenses[i]);
        }
      }
      return activeLicenses;
    }
  },
  created: function created() {
    var _this2 = this;

    this.$http.get('license').then(function (res) {
      if (res.body.status === 'Success') {
        _this2.allLicenses = res.body.licenses;
        return;
      }
      _this2.err = res.body.statusText;
    }, function (err) {
      _this2.err = err.body.statusText || err.body.message;
    });
  }
});

/***/ }),
/* 201 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_luxon__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_luxon___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_luxon__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = ({
  props: ['license'],
  data: function data() {
    return {
      search: '',
      headers: [{ text: this.$lang.header.licenseKey, value: 'licenseKey', align: 'left' }, { text: this.$lang.header.createdDate, value: 'createdOn', align: 'left' }, { text: this.$lang.header.activationDate, value: 'getsActiveOn', align: 'left' }, { text: this.$lang.header.expiryDate, value: 'expiresOn', align: 'left' }, { text: this.$lang.labels.status, value: 'status', align: 'left' }],
      pagination: {
        sortBy: 'createdOn',
        descending: true
      }
    };
  },

  methods: {
    formatDate: function formatDate(date) {
      return __WEBPACK_IMPORTED_MODULE_0_luxon__["DateTime"].fromISO(date).toFormat('yyyy-MM-dd');
    }
  }
});

/***/ }),
/* 202 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_luxon__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_luxon___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_luxon__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = ({
  props: ['log'],
  data: function data() {
    return {
      log: '',
      createdOn: ''
    };
  },
  created: function created() {
    var _this = this;

    this.$http.get('system/logs/' + this.log.id).then(function (res) {
      if (res.body.status === 'Success') {
        _this.log = res.body.log;
        _this.createdOn = _this.formatDate(_this.log.createdOn);
        return;
      }
      _this.err = res.body.statusText;
    }, function (err) {
      _this.err = res.body.statusText || err.body.message;
    });
  },

  methods: {
    formatDate: function formatDate(date) {
      return __WEBPACK_IMPORTED_MODULE_0_luxon__["DateTime"].fromISO(date).toFormat('yyyy-MM-dd HH:mm:ss');
    }
  }
});

/***/ }),
/* 203 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_luxon__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_luxon___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_luxon__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      valid: false,
      instance: '',
      err: '',
      success: ''
    };
  },
  watch: {
    err: function err(val) {
      var _this = this;

      if (val !== '') {
        setTimeout(function () {
          _this.err = '';
        }, 6000);
      }
    },
    success: function success(val) {
      var _this2 = this;

      if (val !== '') {
        setTimeout(function () {
          _this2.success = '';
        }, 6000);
      }
    }
  },
  methods: {
    validURL: function validURL(str) {
      var pattern = new RegExp('^(https?:\\/\\/)?' + // protocol
      '((([a-z\\d]([a-z\\d-]*[a-z\\d])*)\\.)+[a-z]{2,}|' + // domain name
      '((\\d{1,3}\\.){3}\\d{1,3}))' + // OR ip (v4) address
      '(\\:\\d+)?(\\/[-a-z\\d%_.~+]*)*' + // port and path
      '(\\?[;&a-z\\d%_.~+=-]*)?' + // query string
      '(\\#[-a-z\\d_]*)?$', 'i'); // fragment locator
      return !!pattern.test(str);
    },
    checkIsJustHostname: function checkIsJustHostname(url) {
      var a = document.createElement('a');
      a.href = url;

      if (a.pathname !== '/' && a.pathname !== '/moonbackend') return false;
      if (a.search) return false;
      if (a.hash) return false;
      if (url.substr(url.length - 1) === '/') return false;
      return true;
    },
    formatDate: function formatDate(date) {
      return __WEBPACK_IMPORTED_MODULE_0_luxon__["DateTime"].fromISO(date).toFormat('yyyy-MM-dd HH:mm');
    },
    copyKey: function copyKey() {
      try {
        var copyText = document.getElementById('instanceId');
        copyText.select();
        var success = document.execCommand('copy');
      } catch (e) {
        console.log(e);
      }
    },
    submit: function submit() {
      var _this3 = this;

      this.$http.post('moon/instance/update/' + this.$route.params.id, {
        moonUrl: this.instance.moonUrl
      }).then(function (res) {
        if (res.body.status === 'Success') {
          _this3.success = 'Moon Instance updated successfully';
          return;
        }
        _this3.err = res.body.statusText;
      }, function (err) {
        _this3.err = err.body.statusText || err.body.message;
      });
    }
  },
  created: function created() {
    var _this4 = this;

    this.$http.get('moon/instance/' + this.$route.params.id).then(function (res) {
      if (res.body.status === 'Success') {
        var instance = res.body.details;
        instance.createdOn = _this4.formatDate(instance.createdOn);
        instance.lastContactOn = _this4.formatDate(instance.lastContactOn);
        _this4.instance = instance;
        return;
      }
      _this4.err = res.body.statusText;
    }, function (err) {
      _this4.err = err.body.statusText || err.body.message;
    });
  }
});

/***/ }),
/* 204 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_luxon__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_luxon___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_luxon__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      search: '',
      headers: [{ text: this.$lang.labels.name, value: 'name', align: 'left' }, { text: this.$lang.labels.currentVersion, value: 'currentVersion', align: 'left' }, { text: this.$lang.labels.created, value: 'createdOn', align: 'left' }, { text: this.$lang.header.contactedOn, value: 'lastContactOn', align: 'left' }, { text: this.$lang.labels.status, value: 'status', align: 'left' }, { text: this.$lang.labels.actions, value: 'actions', align: 'left', sortable: false }],
      showActive: true,
      allInstances: []
    };
  },

  computed: {
    activeInstances: function activeInstances() {
      var instances = this.allInstances;
      var activeInstances = [];
      for (var i = 0; instances.length > i; i++) {
        if (instances[i].status === 'active') {
          activeInstances.push(instances[i]);
        }
      }
      return activeInstances;
    }
  },
  methods: {
    formatDate: function formatDate(date) {
      return __WEBPACK_IMPORTED_MODULE_0_luxon__["DateTime"].fromISO(date).toFormat('yyyy-MM-dd HH:mm');
    },
    moonInstance: function moonInstance(instance) {
      this.$router.push({ name: 'moonInstanceDetails', params: { id: instance.id } });
    }
  },
  created: function created() {
    var _this = this;

    this.$http.get('moon/instance').then(function (res) {
      if (res.body.status === 'Success') {
        _this.allInstances = res.body.details;
        return;
      }
      _this.err = res.body.statusText;
    }, function (err) {
      _this.err = err.body.statusText || err.body.message;
    });
  }
});

/***/ }),
/* 205 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_luxon__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_luxon___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_luxon__);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      err: '',
      success: '',
      valid: false,
      isEdit: false,
      companyLoading: true,
      terminalsLoading: false,
      companies: [],
      terminals: [],
      paymentServer: {
        companyId: null,
        name: null,
        paymentTerminals: [],
        status: '',
        id: ''
      },
      createdOn: '',
      modifiedOn: '',
      isLocalAdmin: false
    };
  },
  watch: {
    'paymentServer.companyId': function paymentServerCompanyId(val) {
      this.fetchTerminals(val);
    },
    err: function err(val) {
      var _this = this;

      if (val !== '') {
        setTimeout(function () {
          _this.err = '';
        }, 5000);
      }
    }
  },
  computed: {
    mappedTerminals: function mappedTerminals() {
      return this.terminals.map(function (terminal) {
        return {
          text: terminal.name + ' (' + terminal.status + ')',
          value: terminal.id
        };
      });
    }
  },
  methods: {
    changeStatus: function changeStatus() {
      var _this2 = this;

      var action = this.paymentServer.status === 'active' ? 'deactivate' : 'activate';
      this.$http.post('paymentserver/' + action + '/' + this.paymentServer.id + '?companyId=' + localStorage.selectedPaymentServer).then(function (res) {
        if (res.body.status === 'Success') {
          _this2.$set(_this2.paymentServer, 'status', action === 'activate' ? 'active' : 'inactive');
          return;
        }
        _this2.err = res.body.statusText;
      }, function (err) {
        _this2.err = err.body.statusText || err.body.message;
      });
    },
    formatDate: function formatDate(date) {
      return __WEBPACK_IMPORTED_MODULE_1_luxon__["DateTime"].fromISO(date).toFormat('yyyy-MM-dd HH:mm:ss');
    },
    init: function init() {
      var _this3 = this;

      var roles = JSON.parse(this.$cookie.get('roles') || '[]');
      this.isLocalAdmin = roles.includes('ROLE_SUN_LOCAL_ADMIN');
      return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve) {
        _this3.$http.get('company').then(function (res) {
          resolve();
          _this3.companyLoading = false;
          if (res.body.status === 'Success') {
            _this3.companies = res.body.companies;
            if (_this3.isLocalAdmin && _this3.companies.length === 1) _this3.paymentServer.companyId = _this3.companies[0].id;
            return;
          }
          _this3.err = res.body.statusText;
        }, function (err) {
          resolve();
          _this3.companyLoading = false;
          _this3.err = err.body.statusText || err.body.message;
        });
      });
    },
    copyKey: function copyKey() {
      try {
        var copyText = document.getElementById('key');
        copyText.select();
        var success = document.execCommand('copy');
      } catch (e) {
        console.log(e);
      }
    },
    fetchTerminals: function fetchTerminals(id) {
      var _this4 = this;

      this.terminalsLoading = true;
      this.terminals = [];
      this.$http.get('paymentterminal/list?companyId=' + id).then(function (res) {
        if (res.body.status === 'Success') {
          _this4.terminalsLoading = false;
          _this4.terminals = res.body.terminals;
          return;
        }
        _this4.err = res.body.statusText;
      }, function (err) {
        _this4.err = err.body.statusText || err.body.message;
      });
    },
    submit: function submit() {
      var _this5 = this;

      var url = this.isEdit ? 'paymentserver/update/' + this.$route.params.id : 'paymentserver/create';
      delete this.paymentServer.createdOn;
      this.$http.post(url, this.paymentServer).then(function (res) {
        if (res.body.status === 'Success') {
          _this5.success = _this5.isEdit ? 'Payment Server updated successfully' : 'Payment Server created successfully';
          setTimeout(function () {
            if (_this5.isEdit) {
              _this5.success = '';
            } else {
              _this5.$router.push({ name: 'paymentServers' });
            }
          }, 3000);
          return;
        }
        _this5.err = res.body.statusText;
      }, function (err) {
        _this5.err = err.body.statusText || err.body.message;
      });
    }
  },
  created: function created() {
    var _this6 = this;

    this.init().then(function () {
      if (_this6.$route.params.id) {
        _this6.isEdit = true;
        _this6.$http.get('paymentserver/' + _this6.$route.params.id + '?companyId=' + localStorage.selectedPaymentServer).then(function (res) {
          if (res.body.status === 'Success') {
            _this6.paymentServer = res.body.server;
            _this6.createdOn = _this6.formatDate(_this6.paymentServer.createdOn);
            if (_this6.paymentServer.modifiedOn) {
              _this6.modifiedOn = _this6.formatDate(_this6.paymentServer.modifiedOn);
            }
            return;
          }
          _this6.err = res.body.statusText;
        }, function (err) {
          _this6.err = err.body.statusText || err.body.message;
        });
      }
    });
  }
});

/***/ }),
/* 206 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_luxon__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_luxon___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_luxon__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      err: '',
      search: '',
      loading: false,
      show: false,
      selectedCompany: null,
      companies: [],
      headers: [{ text: this.$lang.labels.name, value: 'name', align: 'left' }, { text: this.$lang.labels.status, value: 'status', align: 'left' }, { text: this.$lang.labels.actions, value: 'actions', align: 'left', sortable: false }],
      showActive: true,
      allPaymentServers: [],
      isLocalAdmin: true
    };
  },

  methods: {
    formatDate: function formatDate(date) {
      return __WEBPACK_IMPORTED_MODULE_0_luxon__["DateTime"].fromISO(date).toFormat('yyyy-MM-dd HH:mm:ss');
    },
    goToServer: function goToServer(server) {
      localStorage.selectedPaymentServer = server.companyId;
      this.$router.push({ name: 'paymentServer', params: { id: server.id } });
    },
    changeStatus: function changeStatus(server) {
      var _this = this;

      var action = server.status === 'active' ? 'deactivate' : 'activate';
      this.$http.post('paymentserver/' + action + '/' + server.id + '?companyId=' + server.companyId).then(function (res) {
        if (res.body.status === 'Success') {
          _this.$set(server, 'status', action === 'activate' ? 'active' : 'inactive');
          return;
        }
        _this.err = res.body.statusText;
      }, function (err) {
        _this.err = err.body.statusText || err.body.message;
      });
    },
    fetchPaymentServersforCompany: function fetchPaymentServersforCompany(id) {
      var _this2 = this;

      this.loading = true;
      this.allPaymentServers = [];
      this.$http.get('paymentserver/list?companyId=' + id).then(function (res) {
        if (res.body.status === 'Success') {
          _this2.loading = false;
          _this2.allPaymentServers = res.body.servers;
          if (_this2.allPaymentServers.length === 0) {
            _this2.loading = false;
          }
          return;
        }
        _this2.err = res.body.statusText;
      }, function (err) {
        _this2.loading = false;
        _this2.err = err.body.statusText || err.body.message;
      });
    }
  },
  watch: {
    err: function err(val) {
      var _this3 = this;

      if (val !== '') {
        setTimeout(function () {
          _this3.err = '';
        }, 5000);
      }
    },
    selectedCompany: function selectedCompany(val) {
      this.show = true;
      this.fetchPaymentServersforCompany(val);
      this.$cookie.set('companyedit', val, { expires: '8h' });
    }
  },
  computed: {
    activePaymentServers: function activePaymentServers() {
      var paymentServers = this.allPaymentServers;
      var activePaymentServers = [];
      for (var i = 0; paymentServers.length > i; i++) {
        if (paymentServers[i].status === 'active') {
          activePaymentServers.push(paymentServers[i]);
        }
      }
      return activePaymentServers;
    },
    mappedCompanies: function mappedCompanies() {
      return this.companies.map(function (company) {
        return {
          text: company.name + ' (' + company.companyStatus + ')',
          value: company.id
        };
      });
    }
  },
  created: function created() {
    var _this4 = this;

    this.isLocalAdmin = this.$auth.roles && this.$auth.roles.includes('ROLE_SUN_LOCAL_ADMIN');
    this.$http.get('company').then(function (res) {
      if (res.body.status === 'Success') {
        _this4.companies = res.body.companies;
        if (_this4.isLocalAdmin) {
          _this4.show = true;
          _this4.fetchPaymentServersforCompany(_this4.companies[0].id);
        }
        return;
      }
      _this4.err = res.body.statusText;
    }, function (err) {
      _this4.err = err.body.statusText || err.body.message;
    });
    var edit = this.$cookie.get('companyedit');
    if (edit) this.selectedCompany = edit;
  }
});

/***/ }),
/* 207 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_luxon__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_luxon___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_luxon__);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = ({
  components: {
    changePassword: function changePassword() {
      return __webpack_require__.e/* import() */(8/* duplicate */).then(__webpack_require__.bind(null, 80));
    }
  },
  data: function data() {
    return {
      isLocalAdmin: false,
      err: '',
      success: '',
      valid: false,
      isEdit: false,
      companyLoading: true,
      companies: [],
      terminal: {
        id: '',
        companyId: '',
        name: '',
        ipAddress: '',
        port: '',
        maxRetriesOnErrors: '3',
        status: '',
        passwordMask: '',
        automaticPrintMerchantReceipt: false,
        automaticPrintCustomerReceipt: false,
        automaticPrint: false,
        switchReceiptType: 'merchant'
      },
      createdOn: '',
      modifiedOn: '',
      hasPublicKeyBE: false,
      updatePassword: false
    };
  },
  watch: {},
  computed: {},
  methods: {
    checkPort: function checkPort(val) {
      if (Number(val) < 0 || Number(val) > 65535) return 'Port outside valid range';
      return true;
    },
    checkMaxRetries: function checkMaxRetries(val) {
      if (Number(val) < 1 || Number(val) > 32) return 'Max retries outside valid range';
      return true;
    },
    formatDate: function formatDate(date) {
      return __WEBPACK_IMPORTED_MODULE_1_luxon__["DateTime"].fromISO(date).toFormat('yyyy-MM-dd HH:mm:ss');
    },
    init: function init() {
      var _this = this;

      return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve) {
        var roles = JSON.parse(_this.$cookie.get('roles') || '[]');
        _this.isLocalAdmin = roles.includes('ROLE_SUN_LOCAL_ADMIN');
        _this.$http.get('company').then(function (res) {
          resolve();
          _this.companyLoading = false;
          if (res.body.status === 'Success') {
            _this.companies = res.body.companies;
            if (_this.isLocalAdmin && _this.companies.length === 1) _this.terminal.companyId = _this.companies[0].id;
            return;
          }
          _this.err = res.body.statusText;
        }, function (err) {
          resolve();
          _this.companyLoading = false;
          _this.err = err.body.statusText || err.body.message;
        });
      });
    },
    submit: function submit() {
      var _this2 = this;

      var url = this.isEdit ? 'paymentterminal/update/' + this.$route.params.id : 'paymentterminal/create';
      delete this.terminal.id;
      delete this.terminal.status;
      delete this.terminal.createdOn;
      this.$http.post(url, this.terminal).then(function (res) {
        if (res.body.status === 'Success') {
          _this2.success = _this2.isEdit ? 'Terminal updated successfully' : 'Terminal created successfully';
          setTimeout(function () {
            if (_this2.isEdit) {
              _this2.success = '';
            } else {
              _this2.$router.push({ name: 'paymentTerminals' });
            }
          }, 3000);
          return;
        }
        _this2.err = res.body.statusText;
      }, function (err) {
        _this2.err = err.body.statusText || err.body.message;
      });
    }
  },
  created: function created() {
    var _this3 = this;

    this.init().then(function () {
      if (_this3.$route.params.id) {
        _this3.isEdit = true;
        if (!localStorage.selectedTerminal) {
          _this3.$router.push({ name: 'paymentTerminals' });
          return;
        }
        _this3.$http.get('paymentterminal/' + _this3.$route.params.id + '?companyId=' + localStorage.selectedTerminal).then(function (res) {
          if (res.body.status === 'Success') {
            _this3.terminal = res.body.terminal;
            _this3.hasPublicKeyBE = res.body.terminal.hasPublicKey;
            _this3.createdOn = _this3.formatDate(_this3.terminal.createdOn);
            if (_this3.terminal.modifiedOn) {
              _this3.modifiedOn = _this3.formatDate(_this3.terminal.modifiedOn);
            }
            return;
          }
          _this3.err = res.body.statusText;
        }, function (err) {
          _this3.err = err.body.statusText || err.body.message;
        });
      }
    });
  }
});

/***/ }),
/* 208 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_luxon__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_luxon___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_luxon__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      err: '',
      search: '',
      loading: false,
      show: false,
      selectedCompany: null,
      companies: [],
      headers: [{ text: this.$lang.labels.name, value: 'name', align: 'left' }, { text: this.$lang.labels.status, value: 'status', align: 'left' }, { text: this.$lang.labels.actions, value: 'actions', align: 'left', sortable: false }],
      showActive: true,
      allTerminals: [],
      isLocalAdmin: true
    };
  },

  methods: {
    goToTerminal: function goToTerminal(terminal) {
      localStorage.selectedTerminal = terminal.companyId;
      this.$router.push({ name: 'paymentTerminal', params: { id: terminal.id } });
    },
    changeStatus: function changeStatus(terminal) {
      var _this = this;

      var action = terminal.status === 'active' ? 'deactivate' : 'activate';
      this.$http.post('paymentterminal/' + action + '/' + terminal.id + '?companyId=' + terminal.companyId).then(function (res) {
        if (res.body.status === 'Success') {
          _this.$set(terminal, 'status', action === 'activate' ? 'active' : 'inactive');
          return;
        }
        _this.err = res.body.statusText;
      }, function (err) {
        _this.err = err.body.statusText || err.body.message;
      });
    },
    fetchTerminalsForCompany: function fetchTerminalsForCompany(id) {
      var _this2 = this;

      this.loading = true;
      this.allTerminals = [];
      this.$http.get('paymentterminal/list?companyId=' + id).then(function (res) {
        if (res.body.status === 'Success') {
          _this2.loading = false;
          _this2.allTerminals = res.body.terminals;
          if (_this2.allTerminals.length === 0) {
            _this2.loading = false;
          }
          return;
        }
        _this2.err = res.body.statusText;
      }, function (err) {
        _this2.loading = false;
        _this2.err = err.body.statusText || err.body.message;
      });
    }
  },
  watch: {
    err: function err(val) {
      var _this3 = this;

      if (val !== '') {
        setTimeout(function () {
          _this3.err = '';
        }, 5000);
      }
    },
    selectedCompany: function selectedCompany(val) {
      this.show = true;
      this.fetchTerminalsForCompany(val);
      this.$cookie.set('companyedit', val, { expires: '8h' });
    }
  },
  computed: {
    activeTerminals: function activeTerminals() {
      var terminals = this.allTerminals;
      var activeTerminals = [];
      for (var i = 0; terminals.length > i; i++) {
        if (terminals[i].status === 'active') {
          activeTerminals.push(terminals[i]);
        }
      }
      return activeTerminals;
    },
    mappedCompanies: function mappedCompanies() {
      return this.companies.map(function (company) {
        return {
          text: company.name + ' (' + company.companyStatus + ')',
          value: company.id
        };
      });
    }
  },
  created: function created() {
    var _this4 = this;

    this.isLocalAdmin = this.$auth.roles && this.$auth.roles.includes('ROLE_SUN_LOCAL_ADMIN');
    this.$http.get('company').then(function (res) {
      if (res.body.status === 'Success') {
        _this4.companies = res.body.companies;
        if (_this4.isLocalAdmin) {
          _this4.show = true;
          _this4.fetchTerminalsForCompany(_this4.companies[0].id);
        }
        return;
      }
      _this4.err = res.body.statusText;
    }, function (err) {
      _this4.err = err.body.statusText || err.body.message;
    });
    var edit = this.$cookie.get('companyedit');
    if (edit) this.selectedCompany = edit;
  }
});

/***/ }),
/* 209 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      err: '',
      success: '',
      valid: false,
      isEdit: false,
      companyLoading: true,
      printersLoading: false,
      companies: [],
      printers: [],
      printServer: {
        companyId: null,
        name: null,
        printers: [],
        fetchRecordsLimit: 10
      },
      isLocalAdmin: false
    };
  },
  watch: {
    'printServer.companyId': function printServerCompanyId(val) {
      this.fetchPrinters(val);
    },
    err: function err(val) {
      var _this = this;

      if (val !== '') {
        setTimeout(function () {
          _this.err = '';
        }, 5000);
      }
    }
  },
  computed: {
    mappedPrinters: function mappedPrinters() {
      return this.printers.map(function (printer) {
        return {
          text: printer.name + ' (' + printer.printerStatus + ')',
          value: printer.id
        };
      });
    }
  },
  methods: {
    init: function init() {
      var _this2 = this;

      var roles = JSON.parse(this.$cookie.get('roles') || '[]');
      this.isLocalAdmin = roles.includes('ROLE_SUN_LOCAL_ADMIN');
      return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve) {
        _this2.$http.get('company').then(function (res) {
          resolve();
          _this2.companyLoading = false;
          if (res.body.status === 'Success') {
            _this2.companies = res.body.companies;
            if (_this2.isLocalAdmin && _this2.companies.length === 1) _this2.printServer.companyId = _this2.companies[0].id;
            return;
          }
          _this2.err = res.body.statusText;
        }, function (err) {
          resolve();
          _this2.companyLoading = false;
          _this2.err = err.body.statusText || err.body.message;
        });
      });
    },
    copyKey: function copyKey() {
      try {
        var copyText = document.getElementById('key');
        copyText.select();
        var success = document.execCommand('copy');
      } catch (e) {
        console.log(e);
      }
    },
    fetchPrinters: function fetchPrinters(id) {
      var _this3 = this;

      this.printersLoading = true;
      this.printers = [];
      this.$http.get('printer/fetchallforcompany/' + id).then(function (res) {
        if (res.body.status === 'Success') {
          _this3.printersLoading = false;
          _this3.printers = res.body.printers;
          return;
        }
        _this3.err = res.body.statusText;
      }, function (err) {
        _this3.err = err.body.statusText || err.body.message;
      });
    },
    submit: function submit() {
      var _this4 = this;

      if (!this.printServer.fetchRecordsLimit || this.printServer.fetchRecordsLimit < 1 || this.printServer.fetchRecordsLimit > 128) {
        this.err = 'Records for printing must be between 1 and 128.';
        return;
      }
      var url = this.isEdit ? 'printserver/update/' + this.$route.params.id : 'printserver/create';
      this.$http.post(url, this.printServer).then(function (res) {
        if (res.body.status === 'Success') {
          _this4.success = _this4.isEdit ? 'Print Server updated successfuly' : 'Print Server created successfuly';
          setTimeout(function () {
            if (_this4.isEdit) {
              _this4.success = '';
            } else {
              _this4.$router.push({ name: 'printServers' });
            }
          }, 3000);
          return;
        }
        _this4.err = res.body.statusText;
      }, function (err) {
        _this4.err = err.body.statusText || err.body.message;
      });
    }
  },
  created: function created() {
    var _this5 = this;

    this.init().then(function () {
      if (_this5.$route.params.id) {
        _this5.isEdit = true;
        _this5.$http.get('printserver/fetchbyid/' + _this5.$route.params.id).then(function (res) {
          if (res.body.status === 'Success') {
            _this5.printServer = res.body.printServers;
            return;
          }
          _this5.err = res.body.statusText;
        }, function (err) {
          _this5.err = err.body.statusText || err.body.message;
        });
      }
    });
  }
});

/***/ }),
/* 210 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      err: '',
      search: '',
      loading: false,
      show: false,
      selectedCompany: null,
      companies: [],
      headers: [{ text: this.$lang.labels.name, value: 'name', align: 'left' }, { text: this.$lang.header.limit, value: 'fetchRecordsLimit', align: 'left' }, { text: this.$lang.labels.status, value: 'status', align: 'left' }, { text: this.$lang.labels.actions, value: 'actions', align: 'left', sortable: false }],
      showActive: true,
      allPrintServers: [],
      isLocalAdmin: true
    };
  },

  methods: {
    changeStatus: function changeStatus(server) {
      var _this = this;

      var action = server.status === 'active' ? 'deactivate' : 'activate';
      this.$http.post('printserver/' + action + '/' + server.printServerId).then(function (res) {
        if (res.body.status === 'Success') {
          _this.$set(server, 'status', action === 'activate' ? 'active' : 'inactive');
          return;
        }
        _this.err = res.body.statusText;
      }, function (err) {
        _this.err = err.body.statusText || err.body.message;
      });
    },
    fetchPrintServersforCompany: function fetchPrintServersforCompany(id) {
      var _this2 = this;

      this.loading = true;
      this.allPrintServers = [];
      this.$http.post('printserver', { companyId: id }).then(function (res) {
        if (res.body.status === 'Success') {
          _this2.loading = false;
          _this2.allPrintServers = res.body.printServers;
          return;
        }
        _this2.err = res.body.statusText;
      }, function (err) {
        _this2.loading = false;
        _this2.err = err.body.statusText || err.body.message;
      });
    }
  },
  watch: {
    err: function err(val) {
      var _this3 = this;

      if (val !== '') {
        setTimeout(function () {
          _this3.err = '';
        }, 5000);
      }
    },
    selectedCompany: function selectedCompany(val) {
      this.show = true;
      this.fetchPrintServersforCompany(val);
      this.$cookie.set('companyedit', val, { expires: '8h' });
    }
  },
  computed: {
    activePrintServers: function activePrintServers() {
      var printServers = this.allPrintServers;
      var activePrintServers = [];
      for (var i = 0; printServers.length > i; i++) {
        if (printServers[i].status === 'active') {
          activePrintServers.push(printServers[i]);
        }
      }
      return activePrintServers;
    },
    mappedCompanies: function mappedCompanies() {
      return this.companies.map(function (company) {
        return {
          text: company.name + ' (' + company.companyStatus + ')',
          value: company.id
        };
      });
    }
  },
  created: function created() {
    var _this4 = this;

    this.isLocalAdmin = this.$auth.roles && this.$auth.roles.includes('ROLE_SUN_LOCAL_ADMIN');
    this.$http.get('company').then(function (res) {
      if (res.body.status === 'Success') {
        _this4.companies = res.body.companies;
        if (_this4.isLocalAdmin) {
          _this4.selectedCompany = _this4.companies[0].id;
        }
        return;
      }
      _this4.err = res.body.statusText;
    }, function (err) {
      _this4.err = err.body.statusText || err.body.message;
    });
    var edit = this.$cookie.get('companyedit');
    if (edit) this.selectedCompany = edit;
  }
});

/***/ }),
/* 211 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray__ = __webpack_require__(231);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_promise__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_toConsumableArray__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_luxon__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_luxon___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_luxon__);






//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = ({
  components: {
    preview: function preview() {
      return __webpack_require__.e/* import() */(4).then(__webpack_require__.bind(null, 82));
    },
    activate: function activate() {
      return __webpack_require__.e/* import() */(31).then(__webpack_require__.bind(null, 470));
    },
    import: function _import() {
      return __webpack_require__.e/* import() */(15).then(__webpack_require__.bind(null, 471));
    }
  },
  data: function data() {
    return {
      err: '',
      success: '',
      activationModal: false,
      valid: false,
      isView: false,
      isClone: false,
      companyLoading: true,
      companies: [],
      templates: [],
      templateId: null,
      typesLoading: true,
      types: [],
      mainaway: [],
      unpaidBill: [],
      item: [],
      tex: [],
      taxContent: '',
      label: [],
      kitchen: [],
      driver: [],
      companyId: null,
      type: '',
      contents: null,
      templateName: '',
      content: ['text', 'emptyline', 'lineseparator', 'equalseparator', 'opencashdrawer', 'cut', 'beep', 'pagebreak', 'image'],
      fontStyles: ['plain', 'bold', 'italic'],
      editPrefix: false,
      prefixLines: [],
      tempPrefix: {
        fontHeight: '',
        fontStyle: '',
        content: '',
        filename: '',
        data: ''
      },
      editPostfix: false,
      postfixLines: [],
      tempPostfix: {
        fontHeight: '',
        fontStyle: '',
        content: '',
        filename: '',
        data: ''
      },
      createdOn: '',
      noOfPrints: 1,
      modifiedOn: '',
      previewModal: false,
      previewData: null,
      disablePrefixes: false,
      disablePostfixes: false,
      activateId: '',
      isLocalAdmin: false,
      showImportModal: false,
      initDone: false
    };
  },
  watch: {
    err: function err(val) {
      var _this = this;

      if (val !== '') {
        setTimeout(function () {
          _this.err = '';
        }, 5000);
      }
    },
    companyId: function companyId(newVal, oldVal) {
      if (oldVal) {
        return;
      }
      if (newVal) {
        this.fetchTemplateForCompany(newVal);
      }
    },

    'tempPostfix.content': function tempPostfixContent(val) {
      if (['cut', 'beep', 'pagebreak', 'opencashdrawer'].includes(val)) {
        this.tempPostfix.fontHeight = 6;
        this.tempPostfix.fontStyle = 'plain';
      }
    },
    'tempPrefix.content': function tempPrefixContent(val) {
      if (['cut', 'beep', 'pagebreak', 'opencashdrawer'].includes(val)) {
        this.tempPrefix.fontHeight = 6;
        this.tempPrefix.fontStyle = 'plain';
      }
    }
  },
  computed: {
    mappedCompanies: function mappedCompanies() {
      return this.companies.map(function (company) {
        return {
          text: company.name + ' (' + company.companyStatus + ')',
          value: company.id
        };
      });
    },
    numberOfImages: function numberOfImages() {
      return [].concat(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_toConsumableArray___default()(this.prefixLines), __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_toConsumableArray___default()(this.postfixLines)).reduce(function (acc, curr) {
        return curr.content === 'image' ? acc + 1 : acc;
      }, 0);
    },
    lineChoices: function lineChoices() {
      return this.numberOfImages <= 3 ? this.content : this.content.slice(0, this.content.length - 1);
    },
    previewValidation: function previewValidation() {
      var valid = false;
      if (this.prefixLines.length > 0 || this.postfixLines.length > 0) valid = true;
      if (this.editPrefix) valid = false;
      if (this.editPostfix) valid = false;
      return valid;
    }
  },
  methods: {
    activate: function activate(what) {
      var _this2 = this;

      if (what) {
        this.$http.post('printtemplate/activate/' + this.activateId).then(function (res) {
          if (res.body.status === 'Success') {
            _this2.activationModal = false;
            _this2.$router.push({ name: 'printTemplates' });
            return;
          }
          _this2.activationModal = false;
          _this2.err = res.body.statusText;
        }, function (err) {
          _this2.activationModal = false;
          _this2.err = err.body.statusText || err.body.message;
        });
      } else {
        this.activationModal = false;
        this.$router.push({ name: 'printTemplates' });
      }
    },
    preview: function preview() {
      this.previewData = {
        prefixLines: this.prefixLines,
        postfixLines: this.postfixLines
      };
      this.previewModal = true;
    },
    getFormData: function getFormData(files) {
      return new __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_promise___default.a(function (resolve) {
        var reader = new FileReader();
        reader.readAsDataURL(files[0]);
        reader.onload = function () {
          resolve(reader.result);
        };
        reader.onerror = function (error) {
          resolve(null);
        };
      });
    },
    onFileChange: function onFileChange(name, $event) {
      var _this3 = this;

      return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.mark(function _callee() {
        var files, data, img;
        return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                files = $event.target.files || $event.dataTransfer.files;

                if (!(files && files[0])) {
                  _context.next = 18;
                  break;
                }

                _context.next = 4;
                return _this3.getFormData(files);

              case 4:
                data = _context.sent;

                if (!(data === null)) {
                  _context.next = 8;
                  break;
                }

                _this3.err = 'Failed to convert image';
                return _context.abrupt('return');

              case 8:
                if (!(files[0].size > 512000)) {
                  _context.next = 13;
                  break;
                }

                _this3.err = 'The selected images is beyond limit of 512 KB.';
                _this3.$set(_this3[name], 'filename', '');
                _this3.$set(_this3[name], 'data', '');
                return _context.abrupt('return');

              case 13:
                img = new Image();

                img.src = window.URL.createObjectURL(files[0]);
                img.onload = function () {
                  var width = img.naturalWidth;
                  var height = img.naturalHeight;
                  window.URL.revokeObjectURL(img.src);
                  if (width > 800 || height > 600) {
                    _this3.err = 'The maximum allowed resolution is 800 x 600.';
                    _this3.$set(_this3[name], 'filename', '');
                    _this3.$set(_this3[name], 'data', '');
                    return;
                  }
                  _this3.$set(_this3[name], 'filename', files[0].name);
                  _this3.$set(_this3[name], 'data', data);
                };
                _context.next = 20;
                break;

              case 18:
                _this3.$set(_this3[name], 'filename', '');
                _this3.$set(_this3[name], 'data', '');

              case 20:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this3);
      }))();
    },
    startInput: function startInput(name) {
      this.$refs[name][0].click();
    },
    moveUp: function moveUp(arr, id) {
      var y = id--;
      var origin = arr[id];
      arr.splice(id, 1, arr[y]);
      this.$set(arr, y, origin);
    },
    moveDown: function moveDown(arr, id) {
      var y = id++;
      var origin = arr[id];
      arr.splice(id, 1, arr[y]);
      this.$set(arr, y, origin);
    },
    populate: function populate() {
      var _this4 = this;

      var template = this.templates.find(function (e) {
        return e.id === _this4.templateId;
      });
      this.prefixLines = template.printPrefix;
      this.postfixLines = template.printPostfix;
    },
    formatDate: function formatDate(date) {
      return __WEBPACK_IMPORTED_MODULE_6_luxon__["DateTime"].fromISO(date).toFormat('yyyy-MM-dd HH:mm:ss');
    },

    //PREFIX
    addPrefix: function addPrefix() {
      this.prefixLines.push({
        fontHeight: '',
        fontStyle: '',
        content: '',
        filename: '',
        data: '',
        isEdit: true
      });
      this.disablePrefixes = true;
      this.editPrefix = true;
      this.$forceUpdate();
    },
    editingPrefix: function editingPrefix(prefix) {
      this.disablePrefixes = true;
      this.tempPrefix = {
        fontHeight: prefix.fontHeight,
        fontStyle: prefix.fontStyle,
        content: prefix.content,
        filename: prefix.filename,
        data: prefix.data
      };
      this.$set(prefix, 'isEdit', true);
      this.editPrefix = true;
    },
    deletePrefix: function deletePrefix(index) {
      this.prefixLines.splice(index, 1);
      this.$forceUpdate();
    },
    savePrefixEdit: function savePrefixEdit(prefix) {
      this.disablePrefixes = false;
      this.$set(prefix, 'fontHeight', ['image', 'beep', 'pagebreak', 'opencashdrawer'].includes(this.tempPrefix.content) ? 6 : this.tempPrefix.fontHeight);
      this.$set(prefix, 'fontStyle', ['image', 'beep', 'pagebreak', 'opencashdrawer'].includes(this.tempPrefix.content) ? 'plain' : this.tempPrefix.fontStyle);
      this.$set(prefix, 'content', this.tempPrefix.content);
      this.$set(prefix, 'filename', this.tempPrefix.filename);
      this.$set(prefix, 'data', this.tempPrefix.data);
      this.closePrefixEdit(prefix);
    },
    closePrefixEdit: function closePrefixEdit(prefix) {
      this.tempPrefix = {
        fontHeight: '',
        fontStyle: '',
        content: '',
        filename: '',
        data: ''
      };
      this.$set(prefix, 'isEdit', false);
      this.disablePrefixes = false;
      this.editPrefix = false;
    },

    //POSTFIX
    addPostfix: function addPostfix() {
      this.postfixLines.push({
        fontHeight: '',
        fontStyle: '',
        content: '',
        filename: '',
        data: '',
        isEdit: true
      });
      this.disablePostfixes = true;
      this.editPostfix = true;
      this.$forceUpdate();
    },
    editingPostfix: function editingPostfix(postfix) {
      this.disablePostfixes = true;
      this.tempPostfix = {
        fontHeight: postfix.fontHeight,
        fontStyle: postfix.fontStyle,
        content: postfix.content,
        filename: postfix.filename,
        data: postfix.data
      };
      this.$set(postfix, 'isEdit', true);
      this.editPostfix = true;
    },
    deletePostfix: function deletePostfix(index) {
      this.postfixLines.splice(index, 1);
      this.$forceUpdate();
    },
    savePostfixEdit: function savePostfixEdit(postfix) {
      this.disablePostfixes = false;
      this.$set(postfix, 'fontHeight', ['image', 'beep', 'pagebreak', 'opencashdrawer'].includes(this.tempPostfix.content) ? 6 : this.tempPostfix.fontHeight);
      this.$set(postfix, 'fontStyle', ['image', 'beep', 'pagebreak', 'opencashdrawer'].includes(this.tempPostfix.content) ? 'plain' : this.tempPostfix.fontStyle);
      this.$set(postfix, 'content', this.tempPostfix.content);
      this.$set(postfix, 'filename', this.tempPostfix.filename);
      this.$set(postfix, 'data', this.tempPostfix.data);
      this.closePostfixEdit(postfix);
    },
    closePostfixEdit: function closePostfixEdit(postfix) {
      this.tempPostfix = {
        fontHeight: '',
        fontStyle: '',
        content: '',
        filename: '',
        data: ''
      };
      this.disablePostfixes = false;
      this.$set(postfix, 'isEdit', false);
      this.editPostfix = false;
    },
    init: function init() {
      var _this5 = this;

      return new __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_promise___default.a(function (resolve) {
        _this5.$http.get('company').then(function (res) {
          resolve();
          _this5.companyLoading = false;
          if (res.body.status === 'Success') {
            _this5.companies = res.body.companies;
            return;
          }
          _this5.err = res.body.statusText;
        }, function (err) {
          resolve();
          _this5.companyLoading = false;
          _this5.err = err.body.statusText || err.body.message;
        });

        _this5.$http.get('system/printtemplatetypes').then(function (res) {
          resolve();
          _this5.typesLoading = false;
          if (res.body.status === 'Success') {
            _this5.types = res.body.printTemplateTypes;
            return;
          }
          _this5.err = res.body.statusText;
        }, function (err) {
          resolve();
          _this5.typesLoading = false;
          _this5.err = err.body.statusText || err.body.message;
        });
        _this5.$http.get('printtemplate/fetchalltemplatecontents/mainaway').then(function (res) {
          resolve();
          if (res.body.status === 'Success') {
            _this5.mainaway = res.body.details;
            return;
          }
          _this5.err = res.body.statusText;
        }, function (err) {
          resolve();
          _this5.err = err.body.statusText || err.body.message;
        });
        _this5.$http.get('printtemplate/fetchalltemplatecontents/unpaidbill').then(function (res) {
          resolve();
          if (res.body.status === 'Success') {
            _this5.unpaidBill = res.body.details;
            return;
          }
          _this5.err = res.body.statusText;
        }, function (err) {
          resolve();
          _this5.err = err.body.statusText || err.body.message;
        });
        _this5.$http.get('printtemplate/fetchalltemplatecontents/item').then(function (res) {
          resolve();
          if (res.body.status === 'Success') {
            _this5.item = res.body.details;
            return;
          }
          _this5.err = res.body.statusText;
        }, function (err) {
          resolve();
          _this5.err = err.body.statusText || err.body.message;
        });
        _this5.$http.get('printtemplate/fetchalltemplatecontents/tax').then(function (res) {
          resolve();
          if (res.body.status === 'Success') {
            _this5.tax = res.body.details;
            return;
          }
          _this5.err = res.body.statusText;
        }, function (err) {
          resolve();
          _this5.err = err.body.statusText || err.body.message;
        });
        _this5.$http.get('printtemplate/fetchalltemplatecontents/label').then(function (res) {
          resolve();
          if (res.body.status === 'Success') {
            _this5.label = res.body.details;
            return;
          }
          _this5.err = res.body.statusText;
        }, function (err) {
          resolve();
          _this5.err = err.body.statusText || err.body.message;
        });
        _this5.$http.get('printtemplate/fetchalltemplatecontents/kitchen').then(function (res) {
          resolve();
          if (res.body.status === 'Success') {
            _this5.kitchen = res.body.details;
            return;
          }
          _this5.err = res.body.statusText;
        }, function (err) {
          resolve();
          _this5.err = err.body.statusText || err.body.message;
        });
        _this5.$http.get('printtemplate/fetchalltemplatecontents/driver').then(function (res) {
          resolve();
          if (res.body.status === 'Success') {
            _this5.driver = res.body.details;
            return;
          }
          _this5.err = res.body.statusText;
        }, function (err) {
          resolve();
          _this5.err = err.body.statusText || err.body.message;
        });
      });
    },
    submit: function submit() {
      var _this6 = this;

      var data = {
        companyId: this.companyId,
        type: this.type,
        contents: [this.contents],
        templateName: this.templateName,
        printPostfixArray: this.postfixLines,
        printPrefixArray: this.prefixLines,
        printPrefix: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default()({}, this.prefixLines),
        printPostfix: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default()({}, this.postfixLines),
        noOfPrints: this.noOfPrints
      };
      if (this.type === 'invoice') {
        data.contents.push(this.taxContent);
      }
      this.$http.post('printtemplate/create', data).then(function (res) {
        if (res.body.status === 'Success') {
          _this6.success = 'Print Template created successfuly';
          setTimeout(function () {
            if (_this6.isView) {
              _this6.success = '';
            } else {
              _this6.activateId = res.body.printTemplateId;
              _this6.activationModal = true;
            }
          }, 500);
          return;
        }
        _this6.err = res.body.statusText;
      }, function (err) {
        _this6.err = err.body.statusText || err.body.message;
      });
    },
    fetchTemplateForCompany: function fetchTemplateForCompany(id) {
      var _this7 = this;

      var forImport = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

      if (!forImport) this.templates = [];
      this.$http.post('printtemplate/fetchall', { companyId: id }).then(function (res) {
        if (res.body.status === 'Success') {
          if (forImport) {
            _this7.templatesForImport = res.body.details;
            return;
          }
          _this7.templates = res.body.details;
          return;
        }
        _this7.err = res.body.statusText;
      }, function (err) {
        _this7.err = err.body.statusText || err.body.message;
      });
    },
    setTemplate: function setTemplate(findPrintTemplate) {
      if (findPrintTemplate) {
        this.type = findPrintTemplate.type;
        var contents = findPrintTemplate.contents;
        var taxTemplate = findPrintTemplate.contents.findIndex(function (template) {
          return template.includes('tax');
        });
        if (taxTemplate !== -1) {
          this.taxContent = contents[taxTemplate];
          contents.splice(taxTemplate, 1);
        }

        var _contents = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray___default()(contents, 1);

        this.contents = _contents[0];

        this.templateName = findPrintTemplate.templateName;
        this.prefixLines = findPrintTemplate.printPrefix;
        this.postfixLines = findPrintTemplate.printPostfix;
        this.noOfPrints = findPrintTemplate.noOfPrints || 1;
        this.showImportModal = false;
      }
    }
  },
  created: function created() {
    var _this8 = this;

    var roles = JSON.parse(this.$cookie.get('roles') || '[]');
    this.isLocalAdmin = roles.includes('ROLE_SUN_LOCAL_ADMIN');
    this.init().then(function () {
      _this8.initDone = true;
      if (_this8.$route.params.id && _this8.$route.params.view) {
        _this8.isView = true;
      }
      if (_this8.$route.params.id) {
        _this8.isClone = true;
        _this8.$http.get('printtemplate/getbyid/' + _this8.$route.params.id).then(function (res) {
          if (res.body.status === 'Success') {
            var data = res.body.templateDetails;
            _this8.companyId = data.companyId;
            _this8.type = data.type;
            var contents = data.contents;
            var taxTemplate = data.contents.findIndex(function (template) {
              return template.includes('tax');
            });
            if (taxTemplate !== -1) {
              _this8.taxContent = contents[taxTemplate];
              contents.splice(taxTemplate, 1);
            }

            var _contents2 = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray___default()(contents, 1);

            _this8.contents = _contents2[0];

            _this8.templateName = data.templateName;
            _this8.prefixLines = data.printPrefix;
            _this8.postfixLines = data.printPostfix;
            _this8.noOfPrints = data.noOfPrints || 1;
            _this8.createdOn = _this8.formatDate(data.createdOn);
            if (data.modifiedOn) {
              _this8.modifiedOn = _this8.formatDate(data.modifiedOn);
            }
            return;
          }
          _this8.err = res.body.statusText;
        }, function (err) {
          _this8.err = err.body.statusText || err.body.message;
        });
      }
    });
  }
});

/***/ }),
/* 212 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      err: '',
      search: '',
      show: false,
      companyLoading: true,
      selectedCompany: '',
      companies: [],
      loading: true,
      headers: [{ text: this.$lang.labels.name, value: 'templateName', align: 'left' }, { text: this.$lang.labels.type, value: 'type', align: 'left' }, { text: this.$lang.labels.status, value: 'status', align: 'left' }, { text: this.$lang.labels.actions, value: 'actions', align: 'left', sortable: false }],
      showActive: true,
      allTemplates: []
    };
  },

  watch: {
    err: function err(val) {
      var _this = this;

      if (val !== '') {
        setTimeout(function () {
          _this.err = '';
        }, 5000);
      }
    },
    selectedCompany: function selectedCompany(val) {
      this.fetchTemplateforCompany(val);
      this.$cookie.set('companyedit', val, { expires: '8h' });
    }
  },
  computed: {
    activeTemplates: function activeTemplates() {
      var templates = this.allTemplates;
      var activeTemplates = [];
      for (var i = 0; templates.length > i; i++) {
        if (templates[i].status === 'active' || templates[i].status === 'draft') {
          activeTemplates.push(templates[i]);
        }
      }
      return activeTemplates;
    },
    mappedCompanies: function mappedCompanies() {
      return this.companies.map(function (company) {
        return {
          text: company.name + ' (' + company.companyStatus + ')',
          value: company.id
        };
      });
    }
  },
  methods: {
    changeStatus: function changeStatus(template) {
      var _this2 = this;

      var action = template.status === 'active' ? 'deactivate' : 'activate';
      this.$http.post('printtemplate/' + action + '/' + template.id).then(function (res) {
        if (res.body.status === 'Success') {
          _this2.$set(template, 'status', action === 'activate' ? 'active' : 'inactive');
          return;
        }
        _this2.err = res.body.statusText;
      }, function (err) {
        _this2.err = err.body.statusText || err.body.message;
      });
    },
    fetchTemplateforCompany: function fetchTemplateforCompany(id) {
      var _this3 = this;

      this.show = true;
      this.templates = [];
      this.loading = true;
      this.$http.post('printtemplate/fetchall', { companyId: id }).then(function (res) {
        _this3.loading = false;
        if (res.body.status === 'Success') {
          _this3.allTemplates = res.body.details;
          return;
        }
        if (_this3.templates.length === 0) {
          _this3.loading = false;
        }
        _this3.err = res.body.statusText;
      }, function (err) {
        _this3.loading = false;
        _this3.err = err.body.statusText || err.body.message;
      });
    }
  },
  created: function created() {
    var _this4 = this;

    this.$http.get('company').then(function (res) {
      _this4.companyLoading = false;
      if (res.body.status === 'Success') {
        _this4.companies = res.body.companies;
        var edit = _this4.$cookie.get('companyedit');
        if (edit) _this4.selectedCompany = edit;
        return;
      }
      _this4.err = res.body.statusText;
    }, function (err) {
      _this4.companyLoading = false;
      _this4.err = err.body.statusText || err.body.message;
    });
  }
});

/***/ }),
/* 213 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_luxon__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_luxon___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_luxon__);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      err: '',
      success: '',
      valid: false,
      isEdit: false,
      companyLoading: true,
      pdfPrinter: false,
      companies: [],
      printerCategories: [],
      printer: {
        companyId: null,
        name: null,
        manufacturer: null,
        model: null,
        ipAddress: null,
        portNumber: null,
        printerCategories: []
      },
      createdOn: '',
      modifiedOn: '',
      isLocalAdmin: false
    };
  },
  watch: {
    pdfPrinter: function pdfPrinter(val) {
      this.printer.manufacturer = val ? 'PDF' : '';
      this.printer.model = val ? 'PDF' : '';
      this.printer.controlledByMoon = val ? true : false;
    }
  },
  computed: {
    sortedCategories: function sortedCategories() {
      return this.printerCategories.sort();
    }
  },
  methods: {
    checkPort: function checkPort(val) {
      if (Number(val) < 0 || Number(val) > 65535) return 'Port outside valid range';
      return true;
    },
    formatDate: function formatDate(date) {
      return __WEBPACK_IMPORTED_MODULE_1_luxon__["DateTime"].fromISO(date).toFormat('yyyy-MM-dd HH:mm:ss');
    },
    init: function init() {
      var _this = this;

      var roles = JSON.parse(this.$cookie.get('roles') || '[]');
      this.isLocalAdmin = roles.includes('ROLE_SUN_LOCAL_ADMIN');
      return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve) {
        _this.$http.get('company').then(function (res) {
          resolve();
          _this.companyLoading = false;
          if (res.body.status === 'Success') {
            _this.companies = res.body.companies;
            if (_this.isLocalAdmin && _this.companies.length === 1) _this.printer.companyId = _this.companies[0].id;
            return;
          }
          _this.err = res.body.statusText;
        }, function (err) {
          resolve();
          _this.companyLoading = false;
          _this.err = err.body.statusText || err.body.message;
        });
        _this.$http.get('system/fetchprintercategories').then(function (res) {
          resolve();
          if (res.body.status === 'Success') {
            _this.printerCategories = res.body.printerCategories;
            return;
          }
          _this.err = res.body.statusText;
        }, function (err) {
          resolve();
          _this.err = err.body.statusText || err.body.message;
        });
      });
    },
    submit: function submit() {
      var _this2 = this;

      var url = this.isEdit ? 'printer/update/' + this.$route.params.id : 'printer/create';
      this.$http.post(url, this.printer).then(function (res) {
        if (res.body.status === 'Success') {
          _this2.success = _this2.isEdit ? 'Printer updated successfuly' : 'Printer created successfuly';
          setTimeout(function () {
            if (_this2.isEdit) {
              _this2.success = '';
            } else {
              _this2.$router.push({ name: 'printers' });
            }
          }, 3000);
          return;
        }
        _this2.err = res.body.statusText;
      }, function (err) {
        _this2.err = err.body.statusText || err.body.message;
      });
    }
  },
  created: function created() {
    var _this3 = this;

    this.init().then(function () {
      if (_this3.$route.params.id) {
        _this3.isEdit = true;
        _this3.$http.get('printer/' + _this3.$route.params.id).then(function (res) {
          if (res.body.status === 'Success') {
            _this3.printer = res.body.printer;
            _this3.createdOn = _this3.formatDate(_this3.printer.createdOn);
            if (_this3.printer.modifiedOn) {
              _this3.modifiedOn = _this3.formatDate(_this3.printer.modifiedOn);
            }
            if (_this3.printer.manufacturer === 'PDF' && _this3.printer.model === 'PDF') {
              _this3.pdfPrinter = true;
            }
            return;
          }
          _this3.err = res.body.statusText;
        }, function (err) {
          _this3.err = err.body.statusText || err.body.message;
        });
      }
    });
  }
});

/***/ }),
/* 214 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_luxon__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_luxon___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_luxon__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      err: '',
      search: '',
      loading: false,
      show: false,
      selectedCompany: null,
      companies: [],
      headers: [{ text: this.$lang.labels.name, value: 'name', align: 'left' }, { text: this.$lang.labels.printerID, value: 'id', align: 'left' }, { text: this.$lang.header.manufacturer, value: 'manufacturer', align: 'left' }, { text: this.$lang.header.model, value: 'model', align: 'left' }, { text: this.$lang.labels.status, value: 'printerStatus', align: 'left' }, { text: this.$lang.labels.actions, value: 'actions', align: 'left', sortable: false }],
      showActive: true,
      allPrinters: [],
      isLocalAdmin: true
    };
  },

  methods: {
    changeStatus: function changeStatus(printer) {
      var _this = this;

      var action = printer.printerStatus === 'active' ? 'deactivate' : 'activate';
      this.$http.post('printer/' + action + '/' + printer.id).then(function (res) {
        if (res.body.status === 'Success') {
          _this.$set(printer, 'printerStatus', action === 'activate' ? 'active' : 'inactive');
          return;
        }
        _this.err = res.body.statusText;
      }, function (err) {
        _this.err = err.body.statusText || err.body.message;
      });
    },
    fetchPrintersforCompany: function fetchPrintersforCompany(id) {
      var _this2 = this;

      this.loading = true;
      this.allPrinters = [];
      this.$http.post('printer', { companyId: id }).then(function (res) {
        if (res.body.status === 'Success') {
          _this2.loading = false;
          _this2.allPrinters = res.body.printers;
          return;
        }
        _this2.err = res.body.statusText;
      }, function (err) {
        _this2.loading = false;
        _this2.err = err.body.statusText || err.body.message;
      });
    }
  },
  watch: {
    err: function err(val) {
      var _this3 = this;

      if (val !== '') {
        setTimeout(function () {
          _this3.err = '';
        }, 5000);
      }
    },
    selectedCompany: function selectedCompany(val) {
      this.show = true;
      this.fetchPrintersforCompany(val);
      this.$cookie.set('companyedit', val, { expires: '8h' });
    }
  },
  computed: {
    activePrinters: function activePrinters() {
      var printers = this.allPrinters;
      var activePrinters = [];
      for (var i = 0; printers.length > i; i++) {
        if (printers[i].printerStatus === 'active') {
          activePrinters.push(printers[i]);
        }
      }
      return activePrinters;
    },
    mappedCompanies: function mappedCompanies() {
      return this.companies.map(function (company) {
        return {
          text: company.name + ' (' + company.companyStatus + ')',
          value: company.id
        };
      });
    }
  },
  created: function created() {
    var _this4 = this;

    this.isLocalAdmin = this.$auth.roles && this.$auth.roles.includes('ROLE_SUN_LOCAL_ADMIN');
    this.$http.get('company').then(function (res) {
      if (res.body.status === 'Success') {
        _this4.companies = res.body.companies;
        if (_this4.isLocalAdmin) {
          _this4.selectedCompany = _this4.companies[0].id;
        }
        return;
      }
      _this4.err = res.body.statusText;
    }, function (err) {
      _this4.err = err.body.statusText || err.body.message;
    });
    var edit = this.$cookie.get('companyedit');
    if (edit) this.selectedCompany = edit;
  }
});

/***/ }),
/* 215 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_luxon__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_luxon___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_luxon__);


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = ({
  components: {
    resourceModal: function resourceModal() {
      return __webpack_require__.e/* import() */(6).then(__webpack_require__.bind(null, 78));
    }
  },
  data: function data() {
    return {
      err: '',
      success: '',
      search: '',
      show: false,
      loading: true,
      valid: false,
      companies: [],
      menu: false,
      menu2: false,
      trackingTypes: [{ text: 'Moon License', value: 'moonlicense' }, { text: 'WebShop Resource', value: 'webshopresource' }, { text: 'WebSpace', value: 'webspace' }, { text: 'Domain', value: 'domain' }, { text: 'App Resource', value: 'appresource' }, { text: 'WebShop Resource Add Revenue', value: 'webshopresourceaddrevenue' }],
      data: {
        companyId: null,
        fromDate: __WEBPACK_IMPORTED_MODULE_2_luxon__["DateTime"].local().startOf('month').toFormat('yyyy-MM-dd'),
        toDate: __WEBPACK_IMPORTED_MODULE_2_luxon__["DateTime"].local().toFormat('yyyy-MM-dd'),
        resourceTrackingTypes: ['moonlicense', 'webshopresource', 'webspace', 'domain', 'appresource', 'webshopresourceaddrevenue']
      },
      companyLoading: true,
      headers: [{ text: this.$lang.header.resourceType, value: 'resourceType', align: 'left' }, { text: this.$lang.header.trackingAction, value: 'resourceTrackingAction', align: 'left' }, { text: this.$lang.labels.status, value: 'status', align: 'left' }, { text: this.$lang.labels.fromDate, value: 'fromDate', align: 'left' }, { text: this.$lang.labels.toDate, value: 'toDate', align: 'left' }, { text: this.$lang.header.closedReason, value: 'closedOn', align: 'left', sortable: false }, { text: this.$lang.labels.data, value: 'data', align: 'left', sortable: false }],
      resources: [],
      resourceData: null,
      resourceModal: false
    };
  },

  computed: {
    mappedCompanies: function mappedCompanies() {
      return this.companies.map(function (company) {
        return {
          text: company.name + ' (' + company.companyStatus + ')',
          value: company.id
        };
      });
    }
  },
  methods: {
    showData: function showData(data) {
      this.resourceData = data;
      this.resourceModal = true;
    },
    formatDate: function formatDate(date) {
      return __WEBPACK_IMPORTED_MODULE_2_luxon__["DateTime"].fromISO(date).toFormat('yyyy-MM-dd HH:mm');
    },
    init: function init() {
      var _this = this;

      return new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve) {
        _this.$http.get('company').then(function (res) {
          resolve();
          _this.companyLoading = false;
          if (res.body.status === 'Success') {
            _this.companies = res.body.companies;
            return;
          }
          _this.err = res.body.statusText;
        }, function (err) {
          resolve();
          _this.companyLoading = false;
          _this.err = err.body.statusText || err.body.message;
        });
      });
    },
    serachResources: function serachResources() {
      var _this2 = this;

      this.show = true;
      this.$http.post('resourcetracking/getall', this.data).then(function (res) {
        if (res.body.status === 'Success') {
          var resources = [];
          if (res.body.moonLicenses.length > 0) {
            res.body.moonLicenses.map(function (data) {
              resources.push(data);
            });
          }
          if (res.body.webShopResources.length > 0) {
            res.body.webShopResources.map(function (data) {
              resources.push(data);
            });
          }
          if (res.body.wsrRevenueEntries.length > 0) {
            res.body.wsrRevenueEntries.map(function (data) {
              resources.push(data);
            });
          }
          if (res.body.webSpaces.length > 0) {
            res.body.webSpaces.map(function (data) {
              resources.push(data);
            });
          }
          if (res.body.domains.length > 0) {
            res.body.domains.map(function (data) {
              resources.push(data);
            });
          }
          if (res.body.appResources.length > 0) {
            res.body.appResources.map(function (data) {
              resources.push(data);
            });
          }
          resources.map(function (resource) {
            if (resource.data) {
              var data = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(resource.data);
              return data = data.slice(0, 63);
            }
          });
          return _this2.resources = resources;
        }
        _this2.err = res.body.statusText;
      }, function (err) {
        _this2.err = err.body.statusText || err.body.message;
      });
    }
  },
  created: function created() {
    var _this3 = this;

    this.init().then(function () {
      var edit = _this3.$cookie.get('companyedit');
      if (edit) _this3.data.companyId = edit;
    });
  }
});

/***/ }),
/* 216 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_modals_viewLog__ = __webpack_require__(353);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_modals_viewLog___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_modals_viewLog__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_luxon__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_luxon___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_luxon__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["default"] = ({
  components: {
    ViewLogModal: __WEBPACK_IMPORTED_MODULE_0__components_modals_viewLog___default.a
  },
  data: function data() {
    return {
      err: '',
      show: false,
      loading: false,
      viewLogModal: false,
      log: null,
      fromDate: __WEBPACK_IMPORTED_MODULE_1_luxon__["DateTime"].local().minus({ hours: 4 }).toISO(),
      toDate: __WEBPACK_IMPORTED_MODULE_1_luxon__["DateTime"].local().plus({ hours: 2 }).toISO(),
      search: '',
      headers: [{ text: this.$lang.labels.created, value: 'createdOn', align: 'left' }, { text: this.$lang.labels.errorMessage, value: 'errorMessage', align: 'left' }, { text: this.$lang.labels.actions, value: 'action', align: 'left', sortable: false }],
      logs: []
    };
  },

  methods: {
    showModal: function showModal(log) {
      this.log = {
        id: log.id
      };
      this.viewLogModal = true;
    },
    formatDate: function formatDate(date) {
      return __WEBPACK_IMPORTED_MODULE_1_luxon__["DateTime"].fromISO(date).toFormat('yyyy-MM-dd HH:mm:ss');
    },
    showLogs: function showLogs() {
      var _this = this;

      this.loading = true;
      this.show = true;
      var data = {
        fromDate: this.fromDate,
        toDate: this.toDate
      };
      this.$http.post('system/logs/getall', data).then(function (res) {
        _this.loading = false;
        if (res.body.status !== 'Success') {
          _this.err = res.body.statusText;
          return;
        }
        _this.logs = res.body.logs;
      }, function (err) {
        _this.loading = false;
        _this.err = err.body.statusText || err.body.message;
      });
    },
    viewLog: function viewLog(log) {
      this.$router.push({ name: 'logDetail', params: { id: log.id } });
    }
  },
  watch: {
    err: function err(val) {
      var _this2 = this;

      if (val !== '') {
        setTimeout(function () {
          _this2.err = '';
        }, 5000);
      }
    }
  },
  created: function created() {
    this.showLogs();
  }
});

/***/ }),
/* 217 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_luxon__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_luxon___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_luxon__);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      err: '',
      search: '',
      show: false,
      loading: true,
      language: this.$cookie.get('lang') || 'en',
      companies: [],
      selectedCompany: '',
      companyLoading: true,
      headers: [{ text: this.$lang.labels.name, value: 'name', align: 'left' }, { text: this.$lang.labels.sequenceNumber, value: 'sequenceNumber', align: 'left' }, { text: this.$lang.labels.status, value: 'status', align: 'left' }, { text: this.$lang.labels.actions, value: 'actions', align: 'left', sortable: false }],
      showActive: true,
      allTableCategories: [],
      isLocalAdmin: false
    };
  },

  watch: {
    err: function err(val) {
      var _this = this;

      if (val !== '') {
        setTimeout(function () {
          _this.err = '';
        }, 5000);
      }
    },
    selectedCompany: function selectedCompany(val) {
      this.fetchTableCategoriesforCompany(val);
      this.$cookie.set('companyedit', val, { expires: '8h' });
    }
  },
  computed: {
    activeTableCategories: function activeTableCategories() {
      var tableCategories = this.allTableCategories;
      var activeTableCategories = [];
      for (var i = 0; tableCategories.length > i; i++) {
        if (tableCategories[i].status === 'active') {
          activeTableCategories.push(tableCategories[i]);
        }
      }
      return activeTableCategories;
    },
    mappedCompanies: function mappedCompanies() {
      return this.companies.map(function (company) {
        return {
          text: company.name + ' (' + company.companyStatus + ')',
          value: company.id
        };
      });
    }
  },
  methods: {
    init: function init() {
      var _this2 = this;

      return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve) {
        _this2.$http.get('company').then(function (res) {
          resolve();
          _this2.companyLoading = false;
          if (res.body.status === 'Success') {
            _this2.companies = res.body.companies;
            if (_this2.isLocalAdmin) _this2.selectedCompany = res.body.companies[0].id;
            return;
          }
          _this2.err = res.body.statusText;
        }, function (err) {
          resolve();
          _this2.companyLoading = false;
          _this2.err = err.body.statusText || err.body.message;
        });
      });
    },
    formatDate: function formatDate(date) {
      return __WEBPACK_IMPORTED_MODULE_1_luxon__["DateTime"].fromISO(date).toFormat('yyyy-MM-dd');
    },
    changeStatus: function changeStatus(category) {
      var _this3 = this;

      var action = category.status === 'active' ? 'deactivate' : 'activate';
      this.$http.post('tablecategory/' + action + '/' + category.id).then(function (res) {
        if (res.body.status === 'Success') {
          _this3.$set(category, 'status', action === 'activate' ? 'active' : 'inactive');
          return;
        }
        _this3.err = res.body.statusText;
      }, function (err) {
        _this3.err = err.body.statusText || err.body.message;
      });
    },
    fetchTableCategoriesforCompany: function fetchTableCategoriesforCompany(id) {
      var _this4 = this;

      this.show = true;
      this.allTableCategories = [];
      this.activeTableCategories = [];
      this.$http.post('tablecategory/getall', { companyId: id }).then(function (res) {
        _this4.loading = false;
        if (res.body.status === 'Success') {
          _this4.allTableCategories = res.body.details;
          return;
        }
        if (_this4.tableCategories.length === 0) {
          _this4.loading = false;
        }
        _this4.err = res.body.statusText;
      }, function (err) {
        _this4.loading = false;
        _this4.err = err.body.statusText || err.body.message;
      });
    }
  },
  created: function created() {
    var _this5 = this;

    this.isLocalAdmin = this.$auth.roles && this.$auth.roles.includes('ROLE_SUN_LOCAL_ADMIN');
    if (this.isLocalAdmin) {
      this.fetchTableCategoriesforCompany();
      return;
    }

    this.init().then(function () {
      var edit = _this5.$cookie.get('companyedit');
      if (edit) _this5.selectedCompany = edit;
    });
  }
});

/***/ }),
/* 218 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_promise__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_luxon__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_luxon___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_luxon__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__assets_url__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__assets_fetch_data__ = __webpack_require__(9);




//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["default"] = ({
  components: {
    propertiesModal: function propertiesModal() {
      return __webpack_require__.e/* import() */(3).then(__webpack_require__.bind(null, 83));
    },
    confirmationModal: function confirmationModal() {
      return __webpack_require__.e/* import() */(1/* duplicate */).then(__webpack_require__.bind(null, 24));
    }
  },
  data: function data() {
    return {
      err: '',
      success: '',
      valid: false,
      companyLoading: true,
      categoriesLoading: false,
      search: '',
      companies: [],
      selectedCompany: null,
      selectedCompanyInfo: {},
      sequenceNumber: null,
      isEdit: false,
      language: this.$cookie.get('lang') || 'en',
      tempName: {
        language: '',
        name: ''
      },
      names: [],
      editingName: false,
      languages: JSON.parse(localStorage.languages),
      createdOn: '',
      modifiedOn: '',
      properties: null,
      isPropertyEdit: false,
      propertyModal: false,
      propertyCodeToEdit: null,
      confirmationModal: false,
      tempIndex: null,
      propertiesKeysList: ['desktop.image', 'tablet.image'],
      headers: [{
        text: 'Name',
        value: 'name',
        align: 'left',
        sortable: true,
        width: '20%'
      }, {
        text: 'Value',
        value: 'value',
        align: 'left',
        sortable: true,
        width: '60%'
      }, {
        text: 'Actions',
        value: 'actions',
        align: 'left',
        sortable: false,
        width: '20%'
      }]
    };
  },

  watch: {
    err: function err(val) {
      var _this = this;

      if (val !== '') {
        setTimeout(function () {
          _this.err = '';
        }, 5000);
      }
    },

    selectedCompany: {
      handler: function handler(val) {
        if (!val) return;
        this.fetchCompany();
      }
    }
  },
  computed: {
    mappedCompanies: function mappedCompanies() {
      return this.companies.map(function (company) {
        return {
          text: company.name + " (" + company.companyStatus + ")",
          value: company.id
        };
      });
    },
    propertiesKeysListFiltered: function propertiesKeysListFiltered() {
      if (this.properties) {
        var tempPropertiesHintsKeys = this.properties.map(function (item) {
          return item.name;
        });
        return this.propertiesKeysList.filter(function (item) {
          return !tempPropertiesHintsKeys.includes(item);
        });
      }
      return this.propertiesKeysList;
    }
  },
  methods: {
    addPropertyCode: function addPropertyCode() {
      this.isPropertyEdit = false;
      this.propertyModal = true;
    },
    savePropertiesCode: function savePropertiesCode(item) {
      if (this.tempIndex !== null) {
        this.properties[this.tempIndex] = item;
      } else {
        if (!this.properties) {
          this.properties = [];
        }
        this.properties.push(item);
      }
      this.tempIndex = null;
      this.propertyCodeToEdit = null;
      this.isPropertyEdit = false;
      this.propertyModal = false;
    },
    editPropertyCode: function editPropertyCode(item) {
      this.tempIndex = this.properties.indexOf(item);
      this.propertyCodeToEdit = item;
      this.isPropertyEdit = true;
      this.propertyModal = true;
    },
    confirmDeletePropertyCode: function confirmDeletePropertyCode(item) {
      this.tempIndex = this.properties.indexOf(item);
      this.confirmationModal = true;
    },
    deletePropertyCode: function deletePropertyCode() {
      this.confirmationModal = false;
      this.properties.splice(this.tempIndex, 1);
      this.tempIndex = null;
    },
    formatDate: function formatDate(date) {
      return __WEBPACK_IMPORTED_MODULE_4_luxon__["DateTime"].fromISO(date).toFormat('yyyy-MM-dd HH:mm:ss');
    },
    init: function init() {
      var _this2 = this;

      return new __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_promise___default.a(function (resolve) {
        _this2.$http.get('company').then(function (res) {
          resolve();
          _this2.companyLoading = false;
          if (res.body.status === 'Success') {
            _this2.companies = res.body.companies;
            if (_this2.isLocalAdmin) _this2.selectedCompany = res.body.companies[0].id;
            return;
          }
          _this2.err = res.body.statusText;
        }, function (err) {
          resolve();
          _this2.companyLoading = false;
          _this2.err = err.body.statusText || err.body.message;
        });
      });
    },
    addName: function addName() {
      this.names.push({
        name: '',
        language: '',
        isEdit: true
      });
      this.editingName = true;
      this.$forceUpdate();
    },
    editName: function editName(name) {
      this.tempName = {
        name: name.name,
        language: name.language
      };
      this.$set(name, 'isEdit', true);
      this.editingName = true;
    },
    deleteName: function deleteName(index) {
      this.names.splice(index, 1);
      this.$forceUpdate();
    },
    saveNameEdit: function saveNameEdit(name) {
      this.$set(name, 'name', this.tempName.name);
      this.$set(name, 'language', this.tempName.language);
      this.closeNameEdit(name);
    },
    closeNameEdit: function closeNameEdit(name) {
      this.tempName = {
        name: '',
        language: ''
      };
      this.$set(name, 'isEdit', false);
      this.editingName = false;
    },
    requiredFieldsValidation: function requiredFieldsValidation(data) {
      return data.hasOwnProperty(this.selectedCompanyInfo.defaultLanguage);
    },
    submit: function submit() {
      var _this3 = this;

      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee() {
        var url, data, isDefaultLangOk;
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                if (!(_this3.names.length === 0)) {
                  _context.next = 3;
                  break;
                }

                _this3.err = 'You must add name in at least one language';
                return _context.abrupt("return");

              case 3:
                url = _this3.isEdit ? "tablecategory/update/" + _this3.$route.params.id : 'tablecategory/create';
                data = {
                  name: {}
                };

                if (!_this3.isEdit) {
                  data.companyId = _this3.selectedCompany;
                }
                _this3.names.forEach(function (name) {
                  return data.name[name.language] = name.name;
                });
                if (_this3.properties) {
                  data.properties = _this3.properties;
                }
                if (_this3.sequenceNumber) {
                  data.sequenceNumber = Number(_this3.sequenceNumber);
                }
                _context.next = 11;
                return _this3.requiredFieldsValidation(data.name);

              case 11:
                isDefaultLangOk = _context.sent;

                if (isDefaultLangOk) {
                  _context.next = 15;
                  break;
                }

                _this3.err = "You must add name in Default language - " + _this3.selectedCompanyInfo.defaultLanguage;
                return _context.abrupt("return");

              case 15:
                _this3.$http.post(url, data).then(function (res) {
                  if (res.body.status === 'Success') {
                    _this3.success = _this3.isEdit ? 'Table Category updated successfuly' : 'Table Category created successfuly';
                    setTimeout(function () {
                      if (_this3.isEdit) {
                        _this3.success = '';
                      } else {
                        _this3.$router.push({ name: 'tableCategories' });
                      }
                    }, 3000);
                    return;
                  }
                  _this3.err = res.body.statusText;
                }, function (err) {
                  _this3.err = err.body.statusText || err.body.message;
                });

              case 16:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, _this3);
      }))();
    },
    fetchCompany: function fetchCompany() {
      var _this4 = this;

      fetch(__WEBPACK_IMPORTED_MODULE_5__assets_url__["a" /* baseUrl */] + "/company/" + this.selectedCompany, {
        method: 'get',
        credentials: 'include',
        headers: {
          'Accept': 'application/json',
          'Content-Type': 'application/json;charset=UTF-8'
        }
      }).then(function (response) {
        return response.json();
      }).then(function (data) {
        if (data.error && data.error === 'Forbidden') {
          _this4.$router.push({ name: 'logOut' });
          return;
        }
        _this4.selectedCompanyInfo = data.company;
      }).catch(function (e) {
        _this4.selectedCompanyInfo = __WEBPACK_IMPORTED_MODULE_6__assets_fetch_data__["a" /* company */];
      });
    }
  },
  created: function created() {
    var _this5 = this;

    this.isLocalAdmin = this.$auth.roles && this.$auth.roles.includes('ROLE_SUN_LOCAL_ADMIN');
    this.init().then(function () {
      if (_this5.$route.params.id) {
        _this5.isEdit = true;
        _this5.$http.get("tablecategory/" + _this5.$route.params.id).then(function (res) {
          if (res.body.status === 'Success') {
            _this5.selectedCompany = res.body.category.companyId;
            _this5.createdOn = _this5.formatDate(res.body.category.createdOn);
            if (res.body.category.modifiedOn) {
              _this5.modifiedOn = _this5.formatDate(res.body.category.modifiedOn);
            }
            _this5.names = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(res.body.category.name).map(function (lang) {
              return {
                language: lang,
                name: res.body.category.name[lang],
                isEdit: false
              };
            });
            if (res.body.category.properties) {
              _this5.properties = res.body.category.properties;
            }
            if (res.body.category.sequenceNumber) {
              _this5.sequenceNumber = res.body.category.sequenceNumber;
            }
            _this5.$forceUpdate();
            return;
          }
          _this5.err = res.body.statusText;
        }, function (err) {
          _this5.err = err.body.statusText || err.body.message;
        });
      }
    });
  }
});

/***/ }),
/* 219 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_promise__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_luxon__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_luxon___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_luxon__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__assets_url__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__assets_fetch_data__ = __webpack_require__(9);




//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["default"] = ({
  components: {
    propertiesModal: function propertiesModal() {
      return __webpack_require__.e/* import() */(3/* duplicate */).then(__webpack_require__.bind(null, 83));
    },
    confirmationModal: function confirmationModal() {
      return __webpack_require__.e/* import() */(1/* duplicate */).then(__webpack_require__.bind(null, 24));
    }
  },
  data: function data() {
    return {
      err: '',
      success: '',
      valid: false,
      companyLoading: true,
      categoriesLoading: false,
      search: '',
      companies: [],
      selectedCompany: null,
      categories: [],
      selectedCategory: null,
      selectedCompanyInfo: {},
      multipleTables: false,
      isEdit: false,
      language: this.$cookie.get('lang') || 'en',
      sequenceNumber: null,
      numberOfTables: null,
      seats: null,
      tempName: {
        language: '',
        name: ''
      },
      names: [],
      editingName: false,
      languages: JSON.parse(localStorage.languages),
      createdOn: '',
      modifiedOn: '',
      isLocalAdmin: true,
      rules: {
        required: function required(value) {
          return !!value || 'Required.';
        },
        counter: function counter(value) {
          return value >= 1 && value <= 99 || 'Min is 1, max is 99';
        },
        email: function email(value) {
          var pattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
          return pattern.test(value) || 'Invalid e-mail.';
        }
      },
      properties: null,
      isPropertyEdit: false,
      propertyModal: false,
      propertyCodeToEdit: null,
      confirmationModal: false,
      tempIndex: null,
      propertiesKeysList: ['desktop.image', 'desktop.x', 'desktop.y', 'desktop.sizePercentage', 'tablet.image', 'tablet.x', 'tablet.y', 'tablet.sizePercentage'],
      headers: [{
        text: 'Name',
        value: 'name',
        align: 'left',
        sortable: true,
        width: '20%'
      }, {
        text: 'Value',
        value: 'value',
        align: 'left',
        sortable: true,
        width: '60%'
      }, {
        text: 'Actions',
        value: 'actions',
        align: 'left',
        sortable: false,
        width: '20%'
      }],
      foreignId: null
    };
  },

  computed: {
    propertiesKeysListFiltered: function propertiesKeysListFiltered() {
      if (this.properties) {
        var tempPropertiesHintsKeys = this.properties.map(function (item) {
          return item.name;
        });
        return this.propertiesKeysList.filter(function (item) {
          return !tempPropertiesHintsKeys.includes(item);
        });
      }
      return this.propertiesKeysList;
    }
  },
  watch: {
    selectedCompany: function selectedCompany(val) {
      if (val) {
        this.fetchCompany();
      }
      this.fetchCategoriesforCompany(val);
    },
    err: function err(val) {
      var _this = this;

      if (val !== '') {
        setTimeout(function () {
          _this.err = '';
        }, 5000);
      }
    }
  },
  methods: {
    addPropertyCode: function addPropertyCode() {
      this.isPropertyEdit = false;
      this.propertyModal = true;
    },
    savePropertiesCode: function savePropertiesCode(item) {
      if (this.tempIndex !== null) {
        this.properties[this.tempIndex] = item;
      } else {
        if (!this.properties) {
          this.properties = [];
        }
        this.properties.push(item);
      }
      this.tempIndex = null;
      this.propertyCodeToEdit = null;
      this.isPropertyEdit = false;
      this.propertyModal = false;
    },
    editPropertyCode: function editPropertyCode(item) {
      this.tempIndex = this.properties.indexOf(item);
      this.propertyCodeToEdit = item;
      this.isPropertyEdit = true;
      this.propertyModal = true;
    },
    confirmDeletePropertyCode: function confirmDeletePropertyCode(item) {
      this.tempIndex = this.properties.indexOf(item);
      this.confirmationModal = true;
    },
    deletePropertyCode: function deletePropertyCode() {
      this.confirmationModal = false;
      this.properties.splice(this.tempIndex, 1);
      this.tempIndex = null;
    },
    formatDate: function formatDate(date) {
      return __WEBPACK_IMPORTED_MODULE_4_luxon__["DateTime"].fromISO(date).toFormat('yyyy-MM-dd HH:mm:ss');
    },
    init: function init() {
      var _this2 = this;

      return new __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_promise___default.a(function (resolve) {
        _this2.$http.get('company').then(function (res) {
          resolve();
          _this2.companyLoading = false;
          if (res.body.status === 'Success') {
            _this2.companies = res.body.companies;
            if (_this2.isLocalAdmin) _this2.selectedCompany = res.body.companies[0].id;
            return;
          }
          _this2.err = res.body.statusText;
        }, function (err) {
          resolve();
          _this2.companyLoading = false;
          _this2.err = err.body.statusText || err.body.message;
        });
      });
    },
    fetchCategoriesforCompany: function fetchCategoriesforCompany(id) {
      var _this3 = this;

      this.categoriesLoading = true;
      this.categories = [];
      this.$http.post('tablecategory/getall', { companyId: id }).then(function (res) {
        _this3.categoriesLoading = false;
        if (res.body.status === 'Success') {
          _this3.categories = res.body.details;
          return;
        }
        _this3.err = res.body.statusText;
      }, function (err) {
        _this3.categoriesLoading = false;
        _this3.err = err.body.statusText || err.body.message;
      });
    },
    addName: function addName() {
      this.names.push({
        name: '',
        language: '',
        isEdit: true
      });
      this.editingName = true;
      this.$forceUpdate();
    },
    editName: function editName(name) {
      this.tempName = {
        name: name.name,
        language: name.language
      };
      this.$set(name, 'isEdit', true);
      this.editingName = true;
    },
    deleteName: function deleteName(index) {
      this.names.splice(index, 1);
      this.$forceUpdate();
    },
    saveNameEdit: function saveNameEdit(name) {
      this.$set(name, 'name', this.tempName.name);
      this.$set(name, 'language', this.tempName.language);
      this.closeNameEdit(name);
    },
    closeNameEdit: function closeNameEdit(name) {
      this.tempName = {
        name: '',
        language: ''
      };
      this.$set(name, 'isEdit', false);
      this.editingName = false;
    },
    requiredFieldsValidation: function requiredFieldsValidation(data) {
      return data.hasOwnProperty(this.selectedCompanyInfo.defaultLanguage);
    },
    submit: function submit() {
      var _this4 = this;

      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee() {
        var data, url, isDefaultLangOk;
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                if (!(_this4.names.length === 0)) {
                  _context.next = 3;
                  break;
                }

                _this4.err = 'You must add name in at least one language';
                return _context.abrupt("return");

              case 3:
                data = {
                  categoryId: _this4.selectedCategory,
                  name: {}
                };
                url = _this4.isEdit ? "table/update/" + _this4.$route.params.id : 'table/create';

                if (!_this4.isEdit) {
                  data.companyId = _this4.selectedCompany;
                }

                if (!(!_this4.isEdit && _this4.multipleTables)) {
                  _context.next = 14;
                  break;
                }

                if (_this4.numberOfTables) {
                  _context.next = 10;
                  break;
                }

                _this4.err = 'Number of tables is required';
                return _context.abrupt("return");

              case 10:
                data.quantity = _this4.numberOfTables;
                url = 'table/createmultiple';
                _context.next = 15;
                break;

              case 14:
                data.sequenceNumber = _this4.sequenceNumber;

              case 15:
                data.seats = _this4.seats;
                if (_this4.properties) {
                  data.properties = _this4.properties;
                }
                if (_this4.foreignId) {
                  data.foreignId = _this4.foreignId;
                }
                _this4.names.forEach(function (name) {
                  return data.name[name.language] = name.name;
                });
                _context.next = 21;
                return _this4.requiredFieldsValidation(data.name);

              case 21:
                isDefaultLangOk = _context.sent;

                if (isDefaultLangOk) {
                  _context.next = 25;
                  break;
                }

                _this4.err = "You must add name in Default language - " + _this4.selectedCompanyInfo.defaultLanguage;
                return _context.abrupt("return");

              case 25:
                _this4.$http.post(url, data).then(function (res) {
                  if (res.body.status === 'Success') {
                    _this4.success = _this4.isEdit ? 'Table updated successfuly' : 'Table created successfuly';
                    setTimeout(function () {
                      if (_this4.isEdit) {
                        _this4.success = '';
                      } else {
                        _this4.$router.push({ name: 'tables' });
                      }
                    }, 3000);
                    return;
                  }
                  _this4.err = res.body.statusText;
                }, function (err) {
                  _this4.err = err.body.statusText || err.body.message;
                });

              case 26:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, _this4);
      }))();
    },
    fetchCompany: function fetchCompany() {
      var _this5 = this;

      fetch(__WEBPACK_IMPORTED_MODULE_5__assets_url__["a" /* baseUrl */] + "/company/" + this.selectedCompany, {
        method: 'get',
        credentials: 'include',
        headers: {
          'Accept': 'application/json',
          'Content-Type': 'application/json;charset=UTF-8'
        }
      }).then(function (response) {
        return response.json();
      }).then(function (data) {
        if (data.error && data.error === 'Forbidden') {
          _this5.$router.push({ name: 'logOut' });
          return;
        }
        _this5.selectedCompanyInfo = data.company;
      }).catch(function (e) {
        _this5.selectedCompanyInfo = __WEBPACK_IMPORTED_MODULE_6__assets_fetch_data__["a" /* company */];
      });
    }
  },
  created: function created() {
    var _this6 = this;

    this.isLocalAdmin = this.$auth.roles && this.$auth.roles.includes('ROLE_SUN_LOCAL_ADMIN');
    this.init().then(function () {
      if (_this6.$route.params.id) {
        _this6.isEdit = true;
        _this6.$http.get("table/" + _this6.$route.params.id).then(function (res) {
          if (res.body.status === 'Success') {
            var table = res.body.table;
            _this6.selectedCompany = table.companyId;
            _this6.selectedCategory = table.categoryId;
            _this6.createdOn = _this6.formatDate(table.createdOn);
            if (table.modifiedOn) {
              _this6.modifiedOn = _this6.formatDate(table.modifiedOn);
            }
            _this6.names = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(table.name).map(function (lang) {
              return {
                language: lang,
                name: table.name[lang],
                isEdit: false
              };
            });
            _this6.sequenceNumber = table.sequenceNumber;
            _this6.seats = table.seats;
            if (table.properties) {
              _this6.properties = table.properties;
            }
            _this6.foreignId = table.foreignId;
            _this6.$forceUpdate();
            return;
          }
          _this6.err = res.body.statusText;
        }, function (err) {
          _this6.err = err.body.statusText || err.body.message;
        });
      }
    });
  }
});

/***/ }),
/* 220 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_luxon__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_luxon___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_luxon__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__assets_url__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__assets_fetch_data__ = __webpack_require__(9);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      err: '',
      search: '',
      show: false,
      language: this.$cookie.get('lang') || 'en',
      companies: [],
      selectedCompany: '',
      companyLoading: true,
      headers: [{ text: this.$lang.header.tableCategory, value: 'categoryName', align: 'left' }, { text: this.$lang.labels.sequenceNumber, value: 'sequenceNumber', align: 'left' }, { text: this.$lang.header.tableName, value: 'name', align: 'left' }, { text: this.$lang.labels.status, value: 'status', align: 'left' }, { text: this.$lang.labels.actions, value: 'actions', align: 'left', sortable: false }],
      showActive: true,
      allTables: [],
      isLocalAdmin: true
    };
  },

  watch: {
    err: function err(val) {
      var _this = this;

      if (val !== '') {
        setTimeout(function () {
          _this.err = '';
        }, 5000);
      }
    },
    selectedCompany: function selectedCompany(val) {
      this.fetchTablesforCompany(val);
      this.$cookie.set('companyedit', val, { expires: '8h' });
    }
  },
  computed: {
    activeTables: function activeTables() {
      var tables = this.allTables;
      var activeTables = [];
      for (var i = 0; tables.length > i; i++) {
        if (tables[i].status === 'active') {
          activeTables.push(tables[i]);
        }
      }
      return activeTables;
    },
    mappedCompanies: function mappedCompanies() {
      return this.companies.map(function (company) {
        return {
          text: company.name + " (" + company.companyStatus + ")",
          value: company.id
        };
      });
    }
  },
  methods: {
    init: function init() {
      var _this2 = this;

      return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve) {
        _this2.$http.get('company').then(function (res) {
          resolve();
          _this2.companyLoading = false;
          if (res.body.status === 'Success') {
            _this2.companies = res.body.companies;
            return;
          }
          _this2.err = res.body.statusText;
        }, function (err) {
          resolve();
          _this2.companyLoading = false;
          _this2.err = err.body.statusText || err.body.message;
        });
      });
    },
    formatDate: function formatDate(date) {
      return __WEBPACK_IMPORTED_MODULE_1_luxon__["DateTime"].fromISO(date).toFormat('yyyy-MM-dd');
    },
    changeStatus: function changeStatus(table) {
      var _this3 = this;

      var action = table.status === 'active' ? 'deactivate' : 'activate';
      this.$http.post("table/" + action + "/" + table.id).then(function (res) {
        if (res.body.status === 'Success') {
          _this3.$set(table, 'status', action === 'activate' ? 'active' : 'inactive');
          return;
        }
        _this3.err = res.body.statusText;
      }, function (err) {
        _this3.err = err.body.statusText || err.body.message;
      });
    },
    fetchTablesforCompany: function fetchTablesforCompany(id) {
      var _this4 = this;

      this.show = true;
      this.allTables = [];
      this.activeTables = [];
      this.$http.post('table/getall', { companyId: id }).then(function (res) {
        if (res.body.status === 'Success') {
          _this4.allTables = res.body.details.map(function (table) {
            table.name = table.name[_this4.language];
            table.createdOn = _this4.formatDate(table.createdOn);
            return table;
          });
          return;
        }
        _this4.err = res.body.statusText;
      }, function (err) {
        _this4.err = err.body.statusText || err.body.message;
      });
    }
  },
  created: function created() {
    var _this5 = this;

    this.isLocalAdmin = this.$auth.roles && this.$auth.roles.includes('ROLE_SUN_LOCAL_ADMIN');
    if (this.isLocalAdmin) {
      this.fetchTablesforCompany();
      return;
    }

    this.init().then(function () {
      var edit = _this5.$cookie.get('companyedit');
      if (edit) _this5.selectedCompany = edit;
    });
  }
});

/***/ }),
/* 221 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_luxon__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_luxon___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_luxon__);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = ({
  components: {
    lastOrderModal: function lastOrderModal() {
      return __webpack_require__.e/* import() */(5/* duplicate */).then(__webpack_require__.bind(null, 81));
    },
    confirmationModal: function confirmationModal() {
      return __webpack_require__.e/* import() */(0/* duplicate */).then(__webpack_require__.bind(null, 25));
    }
  },
  data: function data() {
    return {
      err: '',
      lastOrderModal: false,
      search: '',
      lastOrder: null,
      show: false,
      loading: true,
      companies: [],
      selectedCompany: '',
      companyLoading: true,
      headers: [{ text: this.$lang.labels.name, value: 'name', align: 'left' }, { text: this.$lang.labels.externalId, value: 'webShopResourceExternalId', align: 'left' }, { text: this.$lang.labels.company, value: 'companyName', align: 'left' }, { text: this.$lang.header.pending, value: 'pendingOrders', align: 'left' }, { text: this.$lang.header.lastPending, value: 'lastPendingShortOrderId', align: 'left' }, { text: this.$lang.labels.status, value: 'status', align: 'left' }, { text: this.$lang.labels.created, value: 'createdOn', align: 'left' }, { text: this.$lang.labels.actions, value: 'actions', align: 'left', sortable: false }],
      showActive: true,
      allWebShops: [],
      confirmationModal: false,
      confirmationData: {
        id: null,
        url: 'webshopresource'
      },
      isLocalAdmin: false
    };
  },

  watch: {
    err: function err(val) {
      var _this = this;

      if (val !== '') {
        setTimeout(function () {
          _this.err = '';
        }, 5000);
      }
    },
    selectedCompany: function selectedCompany(val) {
      this.fetchWebShopsforCompany(val);
      this.$cookie.set('companyedit', val, { expires: '8h' });
    }
  },
  computed: {
    activeWebShops: function activeWebShops() {
      var webShops = this.allWebShops;
      var activeWebShops = [];
      for (var i = 0; webShops.length > i; i++) {
        if (webShops[i].status === 'active' || webShops[i].status === 'created') {
          activeWebShops.push(webShops[i]);
        }
      }
      return activeWebShops;
    },
    mappedCompanies: function mappedCompanies() {
      return this.companies.map(function (company) {
        return {
          text: company.name + ' (' + company.companyStatus + ')',
          value: company.id
        };
      });
    }
  },
  methods: {
    formatDate: function formatDate(date) {
      return __WEBPACK_IMPORTED_MODULE_1_luxon__["DateTime"].fromISO(date).toFormat('yyyy-MM-dd');
    },
    showOrder: function showOrder(webshop) {
      this.$router.push({ name: 'webShopOrder', params: { id: webshop.webShopResourceExternalId } });
    },
    showModal: function showModal(webshop) {
      this.lastOrder = {
        id: webshop.lastPendingOrderId,
        short: webshop.lastPendingShortOrderId
      };
      this.lastOrderModal = true;
    },
    changeStatus: function changeStatus(webshop) {
      var _this2 = this;

      if (webshop.status === 'inactive' || webshop.status === 'created') {
        this.$http.post('webshopresource/activate/' + webshop.id).then(function (res) {
          if (res.body.status === 'Success') {
            _this2.$set(webshop, 'status', 'active');
            return;
          }
          _this2.err = res.body.statusText;
        }, function (err) {
          _this2.err = err.body.statusText || err.body.message;
        });
      } else if (webshop.status === "active") {
        this.confirmationData.id = webshop.id;
        this.confirmationModal = true;
      }
    },
    deactivate: function deactivate(id) {
      var result = this.allWebShops.find(function (data) {
        return data.id === id;
      });
      this.$set(result, 'status', 'inactive');
    },
    init: function init() {
      var _this3 = this;

      return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve) {
        _this3.$http.get('company').then(function (res) {
          resolve();
          _this3.companyLoading = false;
          if (res.body.status === 'Success') {
            _this3.companies = res.body.companies;
            if (_this3.isLocalAdmin) _this3.selectedCompany = _this3.mappedCompanies[0].value;
            return;
          }
          _this3.err = res.body.statusText;
        }, function (err) {
          resolve();
          _this3.companyLoading = false;
          _this3.err = err.body.statusText || err.body.message;
        });
      });
    },
    fetchWebShopsforCompany: function fetchWebShopsforCompany(id) {
      var _this4 = this;

      this.show = true;
      this.allWebShops = [];
      this.$http.post('webshopresource/getall', { companyId: id }).then(function (res) {
        _this4.loading = false;
        if (res.body.status === 'Success') {
          _this4.allWebShops = res.body.details;
          return;
        }
        if (_this4.allWebShops.length === 0) {
          _this4.loading = false;
        }
        _this4.err = res.body.statusText;
      }, function (err) {
        _this4.loading = false;
        _this4.err = err.body.statusText || err.body.message;
      });
    }
  },
  created: function created() {
    var _this5 = this;

    this.isLocalAdmin = this.$auth.roles && this.$auth.roles.includes('ROLE_SUN_LOCAL_ADMIN');
    this.init().then(function () {
      var edit = _this5.$cookie.get('companyedit');
      if (edit) _this5.selectedCompany = edit;
    });
  }
});

/***/ }),
/* 222 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_promise__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_luxon__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_luxon___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_luxon__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue_cookie__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue_cookie___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_vue_cookie__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_qrcode_vue__ = __webpack_require__(311);




//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["default"] = ({
  components: {
    activationModal: function activationModal() {
      return __webpack_require__.e/* import() */(28).then(__webpack_require__.bind(null, 477));
    },
    changePassword: function changePassword() {
      return __webpack_require__.e/* import() */(8).then(__webpack_require__.bind(null, 80));
    },
    confirmationModal: function confirmationModal() {
      return __webpack_require__.e/* import() */(1/* duplicate */).then(__webpack_require__.bind(null, 24));
    },
    htmlHintsModal: function htmlHintsModal() {
      return __webpack_require__.e/* import() */(23).then(__webpack_require__.bind(null, 458));
    },
    htmlHintsImportModal: function htmlHintsImportModal() {
      return __webpack_require__.e/* import() */(24).then(__webpack_require__.bind(null, 457));
    },
    QrcodeVue: __WEBPACK_IMPORTED_MODULE_6_qrcode_vue__["a" /* default */]
  },
  data: function data() {
    return {
      isEdit: false,
      err: '',
      valid: false,
      discLoading: false,
      sendToMoon: false,
      companyLoading: true,
      planetLoading: true,
      catalogVersionsLoading: false,
      catalogViewsLoading: false,
      success: '',
      selectedPlanet: '',
      selectedCompany: '',
      selectedPayment: '',
      selectedOrder: '',
      selectedCatalogVersion: null,
      selectedSubscription: null,
      selectedCatalogView: null,
      webshopStatus: null,
      name: '',
      minDelivery: null,
      planets: [],
      companies: [],
      payments: ['card', 'cash'],
      orderTypes: [],
      catalogVersions: [],
      subscriptions: [],
      catalogViews: [],
      rules: [],
      discountRules: [],
      sendEmail: '',
      bccEmail: '',
      prefix: '',
      postfix: '',
      externalResID: '',
      gateways: [],
      selectedGateway: '',
      merchantId: '',
      connectEApiKey: '',
      connectEUsername: '',
      preSharedKey: '',
      firstDataStoreId: '',
      firstDataSharedSecret: '',
      gateway: false,
      firstPassword: false,
      updatePassword: false,
      orderSubmissionAllowedFrom: [],
      ordersFrom: [],
      orderSubmissionLoading: true,
      activationModal: false,
      activationData: null,
      snackbar: false,
      snackbarTimeout: 0,
      createdOn: undefined,
      modifiedOn: undefined,
      deliveryDurationTo: 0,
      deliveryDurationFrom: 45,
      htmlHints: null,
      isHtmlEdit: false,
      htmlModal: false,
      htmlCodeToEdit: null,
      confirmationModal: false,
      tempIndex: null,
      htmlKeysList: ['webshop.logo', 'webshop.headerImage.mobile', 'webshop.page1.prefix.de', 'webshop.page1.postfix.de', 'webshop.page2.prefix.de', 'webshop.page2.postfix.de', 'webshop.page1.prefix.en', 'webshop.page1.postfix.en', 'webshop.page2.prefix.en', 'webshop.page2.postfix.en', 'webshop.footer.copyright-html', 'webshop.footer.privacy-and-cookies-policy-link', 'webshop.footer.termins-and-conditions-link', 'webshop.partner.company-name', 'webshop.partner.vat-number', 'webshop.partner.registration-number', 'webshop.partner.postall-address', 'webshop.partner.email-address', 'webshop.deactivation.de', 'webshop.deactivation.en'],
      headers: [{
        text: 'Name',
        value: 'name',
        align: 'left',
        sortable: true,
        width: '20%'
      }, {
        text: 'Value',
        value: 'value',
        align: 'left',
        sortable: true,
        width: '60%'
      }, {
        text: 'Actions',
        value: 'actions',
        align: 'left',
        sortable: false,
        width: '20%'
      }],
      htmlImportModal: false,
      acceptingOrders: true,
      defaultPaymentType: '',
      notifyOwnerOnPaymentFailure: true,
      webshopUrl: '',
      merchantIdBe: null,
      preSharedKeyBe: null,
      firstDataStoreIdBe: null,
      connectEApiKeyBe: null,
      connectEUsernameBe: null,
      showEmail: true,
      showPhoneNumber: true,
      smsConfirmationFirstOrder: false,
      smsUsername: '',
      smsUsernameBe: '',
      isSms: false,
      isLocalAdmin: false
    };
  },
  watch: {
    selectedCompany: function selectedCompany(val) {
      this.fetchCatalogVersions(val);
      this.fetchDiscountRulesForCompany(val);
    },
    selectedCatalogVersion: function selectedCatalogVersion(val) {
      this.fetchCatalogViews(val);
    },
    err: function err(val) {
      var _this = this;

      if (val !== '') {
        setTimeout(function () {
          _this.err = '';
        }, 5000);
      }
    },
    selectedPayment: function selectedPayment(val) {
      if (!val.includes(this.defaultPaymentType)) this.defaultPaymentType = '';
    }
  },
  computed: {
    webshopQrCode: function webshopQrCode() {
      var urlArr = this.webshopUrl.split('.');
      if (urlArr.includes('onmapos')) return this.webshopUrl + '/id/' + this.externalResID;
      if (urlArr.includes('acepos')) return this.webshopUrl + '/id/' + this.externalResID;
      return this.webshopUrl;
    },
    contactTrackingQrCode: function contactTrackingQrCode() {
      return this.webshopUrl + '/contact-tracking/' + this.externalResID;
    },
    menuQrCode: function menuQrCode() {
      return this.webshopUrl + '/menu?webShopResourceId=' + this.externalResID;
    },
    htmlKeysListFiltered: function htmlKeysListFiltered() {
      if (this.htmlHints) {
        var tempHtmlHintsKeys = this.htmlHints.map(function (item) {
          return item.name;
        });
        return this.htmlKeysList.filter(function (item) {
          return !tempHtmlHintsKeys.includes(item);
        });
      }
      return this.htmlKeysList;
    },
    mappedCatalogVersions: function mappedCatalogVersions() {
      return this.catalogVersions.sort(function (a, b) {
        return Number(a.catalogVersion) < Number(b.catalogVersion) ? 1 : -1;
      }).map(function (version) {
        return {
          text: version.catalogVersion + ' ' + (version.catalogName ? ' - ' + version.catalogName : '') + ' (' + version.status + ')',
          value: version.catalogId
        };
      });
    },
    mappedCatalogViews: function mappedCatalogViews() {
      return this.catalogViews.map(function (view) {
        return {
          text: view.viewId + ' - ' + view.name.en,
          value: view.viewId
        };
      });
    },
    mappedDiscountRules: function mappedDiscountRules() {
      return this.discountRules.map(function (rule) {
        return {
          text: rule.ruleName + ' (' + rule.status + ')',
          value: rule.id
        };
      });
    },
    mappedPlanets: function mappedPlanets() {
      return this.planets.map(function (planet) {
        return {
          text: planet.name + ' (' + planet.status + ')',
          value: planet.instanceId
        };
      });
    },
    mappedCompanies: function mappedCompanies() {
      return this.companies.map(function (company) {
        return {
          text: company.name + ' (' + company.companyStatus + ')',
          value: company.id
        };
      });
    },
    passwordButtonDisabled: function passwordButtonDisabled() {
      if (this.selectedGateway === 'paymentsense') {
        return !(this.merchantIdBe && this.preSharedKeyBe && this.merchantIdBe === this.merchantId && this.preSharedKeyBe === this.preSharedKey);
      }
      if (this.selectedGateway === 'firstdata') {
        return !(this.firstDataStoreIdBe && this.firstDataStoreIdBe === this.firstDataStoreId);
      }
      if (this.selectedGateway === 'tecs') {
        return !(this.merchantIdBe && this.merchantIdBe === this.merchantId);
      }
      if (this.selectedGateway === 'connect-e') {
        return !(this.connectEApiKeyBe && this.connectEUsernameBe && this.connectEApiKeyBe === this.connectEApiKey && this.connectEUsernameBe === this.connectEUsername);
      }
      return true;
    },
    passwordSmsButtonDisabled: function passwordSmsButtonDisabled() {
      return !(this.smsConfirmationFirstOrder && !!this.smsUsernameBe);
    }
  },
  methods: {
    validURL: function validURL(str) {
      var pattern = new RegExp('^(https?:\\/\\/)?' + // protocol
      '((([a-z\\d]([a-z\\d-]*[a-z\\d])*)\\.)+[a-z]{2,}|' + // domain name
      '((\\d{1,3}\\.){3}\\d{1,3}))' + // OR ip (v4) address
      '(\\:\\d+)?(\\/[-a-z\\d%_.~+]*)*' + // port and path
      '(\\?[;&a-z\\d%_.~+=-]*)?' + // query string
      '(\\#[-a-z\\d_]*)?$', 'i'); // fragment locator
      return !!pattern.test(str);
    },
    checkIsJustHostname: function checkIsJustHostname(url) {
      var a = document.createElement('a');
      a.href = url;

      if (a.pathname !== '/') return false;
      if (a.search) return false;
      if (a.hash) return false;
      if (url.substr(url.length - 1) === '/') return false;
      return true;
    },
    formatDate: function formatDate(date) {
      return __WEBPACK_IMPORTED_MODULE_4_luxon__["DateTime"].fromISO(date).toFormat('yyyy-MM-dd HH:mm:ss');
    },
    redirectBack: function redirectBack() {
      this.activationModal = false;
      this.$router.push({ name: 'webShop' });
    },
    fetchDiscountRulesForCompany: function fetchDiscountRulesForCompany(id) {
      var _this2 = this;

      this.discLoading = true;
      this.discountRules = [];
      this.$http.post('discountrule/getall', { companyId: id }).then(function (res) {
        if (res.body.status === 'Success') {
          _this2.discLoading = false;
          _this2.discountRules = res.body.discountRules;
          if (_this2.discountRules.lenght === 0) {
            _this2.discLoading = false;
          }
          return;
        }
        _this2.err = res.body.statusText;
      }, function (err) {
        _this2.discLoading = false;
        _this2.err = err.body.statusText || err.body.message;
      });
    },
    fetchCatalogVersions: function fetchCatalogVersions(companyId) {
      var _this3 = this;

      this.catalogVersionsLoading = true;
      this.catalogVersions = [];
      this.$http.post('catalog/getcatalogversions', { companyId: companyId }).then(function (res) {
        _this3.catalogVersionsLoading = false;
        if (res.body.status === 'Success') {
          _this3.catalogVersions = res.body.details;
          return;
        }
        _this3.err = res.body.statusText;
      }, function (err) {
        _this3.catalogVersionsLoading = false;
        _this3.err = err.body.statusText || err.body.message;
      });
    },
    fetchCatalogViews: function fetchCatalogViews(id) {
      var _this4 = this;

      this.catalogViewsLoading = true;
      this.catalogViews = [];
      this.$http.get('catalog/getwebshopviews/' + id).then(function (res) {
        _this4.catalogViewsLoading = false;
        if (res.body.status === 'Success') {
          _this4.catalogViews = res.body.details;
          return;
        }
        _this4.err = res.body.statusText;
      }, function (err) {
        _this4.catalogViewsLoading = false;
        _this4.err = err.body.statusText || err.body.message;
      });
    },
    init: function init() {
      var _this5 = this;

      return new __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_promise___default.a(function (resolve) {
        var roles = JSON.parse(_this5.$cookie.get('roles') || '[]');
        _this5.isLocalAdmin = roles.includes('ROLE_SUN_LOCAL_ADMIN');
        __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_promise___default.a.all([_this5.$http.get('company').then(function (res) {
          _this5.companyLoading = false;
          if (res.body.status === 'Success') {
            _this5.companies = res.body.companies;
            if (_this5.isLocalAdmin && _this5.companies.length === 1) _this5.selectedCompany = _this5.companies[0].id;
            return;
          }
          _this5.err = res.body.statusText;
        }, function (err) {
          _this5.companyLoading = false;
          _this5.err = err.body.statusText || err.body.message;
        }), _this5.$http.get('system/webshop/fetchsubscriptionmodels').then(function (res) {
          if (res.body.status === 'Success') {
            _this5.subscriptions = res.body.subscriptionModels;
            return;
          }
          _this5.err = res.body.statusText;
        }, function (err) {
          _this5.err = err.body.statusText || err.body.message;
        }), _this5.isLocalAdmin ? true : _this5.$http.get('planetinstances/getallfortype/webshop').then(function (res) {
          _this5.planetLoading = false;
          if (res.body.status === 'Success') {
            _this5.planets = res.body.details;
            return;
          }
          _this5.err = res.body.statusText;
        }, function (err) {
          _this5.planetLoading = false;
          _this5.err = err.body.statusText || err.body.message;
        }), _this5.$http.get('system/webshop/getordersubmissionallowedfrom').then(function (res) {
          _this5.orderSubmissionLoading = false;
          if (res.body.status === 'Success') {
            _this5.ordersFrom = res.body.orderSubmissionAllowedFrom;
            return;
          }
          _this5.err = res.body.statusText;
        }, function (err) {
          _this5.orderSubmissionLoading = false;
          _this5.err = err.body.statusText || err.body.message;
        }), _this5.$http.get('system/ordertypes').then(function (res) {
          _this5.orderSubmissionLoading = false;
          if (res.body.status === 'Success') {
            _this5.orderTypes = res.body.webshop;
            return;
          }
          _this5.orderTypes = ['collection', 'delivery'];
          _this5.err = res.body.statusText;
        }, function (err) {
          _this5.orderSubmissionLoading = false;
          _this5.orderTypes = ['collection', 'delivery'];
          _this5.err = err.body.statusText || err.body.message;
        })]).then(function () {
          return resolve();
        });
      });
    },

    timeout: function timeout(ms) {
      return new __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_promise___default.a(function (resolve) {
        return setTimeout(resolve, ms);
      });
    },
    waitForFinish: function waitForFinish(val) {
      var _this6 = this;

      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee() {
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return _this6.timeout(100);

              case 2:
                if (!_this6[val]) {
                  _context.next = 4;
                  break;
                }

                return _context.abrupt('return', _this6.waitForFinish(val));

              case 4:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this6);
      }))();
    },
    checkHtmlHints: function checkHtmlHints() {
      var _this7 = this;

      if (!this.htmlHints) return this.$lang.errors.missingAllHint;
      var tempHtmlHints = this.htmlHints.map(function (hint) {
        return hint.name;
      });
      var errors = '';
      var mandatoryHtmlHints = ['webshop.partner.company-name', 'webshop.partner.vat-number', 'webshop.partner.registration-number', 'webshop.partner.postall-address', 'webshop.partner.email-address'];
      var _iteratorNormalCompletion = true;
      var _didIteratorError = false;
      var _iteratorError = undefined;

      try {
        for (var _iterator = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default()(mandatoryHtmlHints), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
          var hint = _step.value;

          if (!tempHtmlHints.includes(hint)) {
            errors = errors + (this.$lang.errors.missingHint + ': \'' + hint + '\'') + '<br>';
          }
        }
      } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion && _iterator.return) {
            _iterator.return();
          }
        } finally {
          if (_didIteratorError) {
            throw _iteratorError;
          }
        }
      }

      this.htmlHints.forEach(function (hint) {
        if (hint.value === '') {
          errors = errors + ('\'' + hint.name + '\' ' + _this7.$lang.errors.emptyValue) + '<br>';
        }
      });
      return errors;
    },
    submit: function submit() {
      var _this8 = this;

      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee2() {
        var selectedVersion, areHtmlHintsOk, data, url;
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                selectedVersion = _this8.catalogVersions.find(function (catalog) {
                  return catalog.catalogId === _this8.selectedCatalogVersion;
                });
                _context2.next = 3;
                return _this8.checkHtmlHints();

              case 3:
                areHtmlHintsOk = _context2.sent;

                if (!(areHtmlHintsOk !== '')) {
                  _context2.next = 7;
                  break;
                }

                _this8.err = areHtmlHintsOk;
                return _context2.abrupt('return');

              case 7:
                data = {
                  name: _this8.name,
                  planetInstanceId: _this8.selectedPlanet,
                  email: _this8.sendEmail,
                  subscriptionModel: _this8.selectedSubscription,
                  catalogViewId: _this8.selectedCatalogView,
                  catalogVersion: selectedVersion.catalogVersion,
                  paymentTypes: _this8.selectedPayment,
                  orderTypes: _this8.selectedOrder,
                  sendToMoon: _this8.sendToMoon,
                  minDeliveryAmount: _this8.minDelivery,
                  rules: _this8.rules,
                  confirmationEmailPrefix: _this8.prefix || null,
                  confirmationEmailPostFix: _this8.postfix || null,
                  bccEmail: _this8.bccEmail || null,
                  orderSubmissionAllowedFrom: _this8.orderSubmissionAllowedFrom,
                  deliveryDurationTo: _this8.deliveryDurationTo,
                  deliveryDurationFrom: _this8.deliveryDurationFrom,
                  htmlHints: _this8.htmlHints,
                  acceptingOrders: _this8.acceptingOrders,
                  defaultPaymentType: _this8.defaultPaymentType,
                  notifyOwnerOnPaymentFailure: _this8.notifyOwnerOnPaymentFailure,
                  webshopUrl: _this8.webshopUrl,
                  showEmail: _this8.showEmail,
                  showPhoneNumber: _this8.showPhoneNumber,
                  smsConfirmationFirstOrder: _this8.smsConfirmationFirstOrder,
                  smsPassword: ''
                };

                if (_this8.smsUsername) data.smsUsername = _this8.smsUsername;
                if (!_this8.isEdit) {
                  data.companyId = _this8.selectedCompany;
                } else if (_this8.selectedGateway) {
                  data.paymentGateway = _this8.selectedGateway;
                  if (_this8.selectedGateway === 'paymentsense') {
                    data.merchantId = _this8.merchantId;
                    data.preSharedKey = _this8.preSharedKey;
                  } else if (_this8.selectedGateway === 'firstdata') {
                    data.firstDataStoreId = _this8.firstDataStoreId;
                  } else if (_this8.selectedGateway === 'tecs') {
                    data.merchantId = _this8.merchantId;
                  } else if (_this8.selectedGateway === 'connect-e') {
                    data.connectEApiKey = _this8.connectEApiKey;
                    data.connectEUsername = _this8.connectEUsername;
                  }
                }
                url = _this8.isEdit ? 'webshopresource/update/' + _this8.$route.params.id : 'webshopresource/create';

                _this8.$http.post(url, data).then(function (res) {
                  if (res.body.status === 'Success') {
                    _this8.success = _this8.isEdit ? 'Webshop updated successfully.' : 'Webshop created successfully.';
                    console.log(data.sendToMoon);
                    if (data.sendToMoon === true) {
                      _this8.snackbar = true;
                    }
                    if (!_this8.isEdit) {
                      _this8.activationModal = true;
                      _this8.activationData = res.body.webShopResourceId;
                    }
                    return null;
                  }
                  _this8.err = res.body.statusText;
                  return null;
                }).then(function (res) {
                  if (res === null) return;
                  if (res.body.status === 'Success') {
                    _this8.success = 'Webshop updated successfully.';
                    if (data.sendToMoon === true) {
                      _this8.snackbar = true;
                    }
                    return;
                  }
                  _this8.err = res.body.statusText;
                }).catch(function (err) {
                  _this8.err = err.body.statusText || err.body.message;
                });

              case 12:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, _this8);
      }))();
    },
    addHtmlCode: function addHtmlCode() {
      this.isHtmlEdit = false;
      this.htmlModal = true;
    },
    saveHtmlCode: function saveHtmlCode(item) {
      if (this.tempIndex !== null) {
        this.htmlHints[this.tempIndex] = item;
      } else {
        if (!this.htmlHints) {
          this.htmlHints = [];
        }
        this.htmlHints.push(item);
      }
      this.tempIndex = null;
      this.htmlCodeToEdit = null;
      this.isHtmlEdit = false;
      this.htmlModal = false;
    },
    editHtmlCode: function editHtmlCode(item) {
      this.tempIndex = this.htmlHints.indexOf(item);
      this.htmlCodeToEdit = item;
      this.isHtmlEdit = true;
      this.htmlModal = true;
    },
    confirmDeleteHtmlCode: function confirmDeleteHtmlCode(item) {
      this.tempIndex = this.htmlHints.indexOf(item);
      this.confirmationModal = true;
    },
    deleteHtmlCode: function deleteHtmlCode() {
      this.confirmationModal = false;
      this.htmlHints.splice(this.tempIndex, 1);
      this.tempIndex = null;
    },
    importHtmlCode: function importHtmlCode(htmlCode) {
      this.htmlImportModal = false;
      if (this.htmlHints && this.htmlHints.length > 0) {
        var newNames = htmlCode.map(function (x) {
          return x.name;
        });
        for (var i = 0, l = this.htmlHints.length; i < l; i++) {
          for (var j = 0, ll = htmlCode.length; j < ll; j++) {
            var oldNames = this.htmlHints.map(function (x) {
              return x.name;
            });
            if (!oldNames.includes(newNames[j])) {
              this.htmlHints.push(htmlCode[j]);
            } else {
              if (this.htmlHints[i].name === htmlCode[j].name) {
                this.htmlHints.splice(i, 1, htmlCode[j]);
                break;
              }
            }
          }
        }
      } else {
        this.htmlHints = htmlCode;
      }
    }
  },
  created: function created() {
    var _this9 = this;

    this.gateways = JSON.parse(localStorage.getItem('paymentGateways'));
    this.init().then(function () {
      if (_this9.$route.params.id) {
        var webshop = void 0;
        _this9.$http.get('webshopresource/' + _this9.$route.params.id).then(function (res) {
          return new __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_promise___default.a(function (resolve) {
            if (res.body.status === 'Success') {
              _this9.isEdit = true;
              webshop = res.body.webShopResource;
              _this9.acceptingOrders = webshop.acceptingOrders;
              _this9.webshopStatus = webshop.status;
              _this9.selectedCompany = webshop.companyId;
              _this9.selectedPlanet = webshop.planetInstanceId;
              _this9.selectedPayment = webshop.paymentTypes;
              _this9.selectedOrder = webshop.orderTypes;
              _this9.selectedSubscription = webshop.subscriptionModel;
              _this9.name = webshop.name;
              _this9.minDelivery = webshop.minDeliveryAmount;
              _this9.sendToMoon = webshop.sendToMoon;
              _this9.externalResID = webshop.webShopResourceExternalId;
              _this9.sendEmail = webshop.email;
              _this9.bccEmail = webshop.confirmationEmailSettingsDetails ? webshop.confirmationEmailSettingsDetails.bccEmail : null;
              _this9.prefix = webshop.confirmationEmailSettingsDetails ? webshop.confirmationEmailSettingsDetails.prefix : null;
              _this9.postfix = webshop.confirmationEmailSettingsDetails ? webshop.confirmationEmailSettingsDetails.postfix : null;
              _this9.orderSubmissionAllowedFrom = webshop.orderSubmissionAllowedFrom;
              _this9.deliveryDurationTo = webshop.deliveryDurationTo;
              _this9.deliveryDurationFrom = webshop.deliveryDurationFrom;
              _this9.htmlHints = webshop.htmlHints;
              _this9.notifyOwnerOnPaymentFailure = webshop.notifyOwnerOnPaymentFailure;
              _this9.defaultPaymentType = webshop.defaultPaymentType || '';
              _this9.webshopUrl = webshop.webshopUrl || '';
              _this9.showEmail = webshop.showEmail;
              _this9.showPhoneNumber = webshop.showPhoneNumber;
              _this9.smsConfirmationFirstOrder = webshop.smsConfirmationFirstOrder;
              _this9.smsUsername = webshop.smsUsername || '';
              _this9.smsUsernameBe = webshop.smsUsername || '';
              if (webshop.createdOn) {
                _this9.createdOn = _this9.formatDate(webshop.createdOn);
              }
              if (webshop.modifiedOn) {
                _this9.modifiedOn = _this9.formatDate(webshop.modifiedOn);
              }
              _this9.catalogVersionsLoading = true;
              if (webshop.rules !== null) {
                _this9.rules = webshop.rules;
              }
              if (webshop.paymentGatewaySettingDetails) {
                _this9.selectedGateway = webshop.paymentGatewaySettingDetails.paymentGateway;
                _this9.merchantId = webshop.paymentGatewaySettingDetails.merchantId;
                _this9.preSharedKey = webshop.paymentGatewaySettingDetails.preSharedKey;
                _this9.firstDataStoreId = webshop.paymentGatewaySettingDetails.firstDataStoreId;
                _this9.firstDataSharedSecret = webshop.paymentGatewaySettingDetails.firstDataSharedSecret;
                _this9.connectEApiKey = webshop.paymentGatewaySettingDetails.connectEApiKey;
                _this9.connectEUsername = webshop.paymentGatewaySettingDetails.connectEUsername;
                _this9.password = webshop.paymentGatewaySettingDetails.password;
                _this9.merchantIdBe = webshop.paymentGatewaySettingDetails.merchantId;
                _this9.preSharedKeyBe = webshop.paymentGatewaySettingDetails.preSharedKey;
                _this9.firstDataStoreIdBe = webshop.paymentGatewaySettingDetails.firstDataStoreId;
                _this9.connectEApiKeyBe = webshop.paymentGatewaySettingDetails.connectEApiKey;
                _this9.connectEUsernameBe = webshop.paymentGatewaySettingDetails.connectEUsername;
                if (!_this9.password) {
                  _this9.firstPassword = true;
                }
              } else {
                _this9.firstPassword = true;
              }
              _this9.waitForFinish('catalogVersionsLoading').then(function () {
                return resolve();
              });
              return;
            }
            _this9.err = res.body.statusText;
            resolve();
          });
        }).then(function () {
          if (!webshop) return;
          var selectedVersion = _this9.catalogVersions.find(function (catalog) {
            return '' + catalog.catalogVersion === '' + webshop.catalogVersion;
          });
          _this9.selectedCatalogVersion = '' + selectedVersion.catalogId;
          _this9.selectedCatalogView = webshop.catalogViewId;
        }).catch(function (err) {
          _this9.err = err.body.statusText || err.body.message;
        });
      } else {
        _this9.htmlHints = [{ name: 'webshop.partner.company-name', value: '' }, { name: 'webshop.partner.vat-number', value: '' }, { name: 'webshop.partner.registration-number', value: '' }, { name: 'webshop.partner.postall-address', value: '' }, { name: 'webshop.partner.email-address', value: '' }];
      }
    });
  }
});

/***/ }),
/* 223 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_luxon__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_luxon___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_luxon__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = ({
  components: {
    lastOrderModal: function lastOrderModal() {
      return __webpack_require__.e/* import() */(5).then(__webpack_require__.bind(null, 81));
    }
  },
  data: function data() {
    return {
      err: '',
      search: '',
      fromDate: __WEBPACK_IMPORTED_MODULE_0_luxon__["DateTime"].local().minus({ hours: 12 }).toISO(),
      toDate: __WEBPACK_IMPORTED_MODULE_0_luxon__["DateTime"].local().plus({ hours: 4 }).toISO(),
      statuses: ['pending', 'complete'],
      selectedStatuses: ['pending'],
      ordersLoading: false,
      lastOrderModal: false,
      lastOrder: null,
      orders: [],
      headers: [{ text: this.$lang.header.orderIdSource, value: 'webShopOrderId', align: 'left', sortable: false }, { text: this.$lang.header.orderCode, value: 'orderId', align: 'left', sortable: false }, { text: this.$lang.labels.totalAmount, value: 'totalAmoun', align: 'left', sortable: false }, { text: this.$lang.labels.status, value: 'status', align: 'left', sortable: false }, { text: this.$lang.header.customerName, value: 'name', align: 'left', sortable: false }, { text: this.$lang.header.emailPhone, value: 'email', align: 'left', sortable: false }, { text: this.$lang.labels.created, value: 'createdOn', align: 'left', sortable: false }]
    };
  },

  methods: {
    showModal: function showModal(orderId) {
      this.lastOrder = {
        id: orderId
      };
      this.lastOrderModal = true;
    },
    formatDate: function formatDate(date) {
      return __WEBPACK_IMPORTED_MODULE_0_luxon__["DateTime"].fromISO(date).toFormat('yyyy-MM-dd HH:mm');
    },
    showDetails: function showDetails() {
      var _this = this;

      this.ordersLoading = true;
      this.orders = [];
      var data = {};
      if (this.selectedStatuses.length > 0) {
        data.statuses = this.selectedStatuses;
      }
      if (this.fromDate) {
        data.fromDate = this.fromDate;
      }
      if (this.toDate) {
        data.toDate = this.toDate;
      }
      this.$http.post('webshoporder/getallforwebshopresource/' + this.$route.params.id, data).then(function (res) {
        _this.ordersLoading = false;
        if (res.body.status === 'Success') {
          _this.orders = res.body.orders;
          return;
        }
        _this.err = res.body.statusText;
      }).catch(function (err) {
        _this.ordersLoading = false;
        _this.err = err.body.statusText || err.body.message;
      });
    }
  },
  created: function created() {
    this.showDetails();
  }
});

/***/ }),
/* 224 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_luxon__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_luxon___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_luxon__);



//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      err: '',
      success: '',
      isEdit: false,
      valid: false,
      companyLoading: true,
      typesLoading: true,
      templatesLoading: true,
      domainLoading: false,
      companies: [],
      selectedCompany: '',
      domains: [],
      selectedDomains: [],
      templateTypes: [],
      selectedType: null,
      templates: null,
      selectedTemplate: null,
      domainDescription: '',
      properties: [],
      propertiesAll: [],
      propertyTypes: ['TEXT', 'URL'],
      urlTypes: [],
      textTypes: [],
      editingProp: false,
      tempProp: {
        type: '',
        name: '',
        value: ''
      },
      generatedJSON: '',
      createdOn: '',
      modifiedOn: ''
    };
  },
  watch: {
    selectedCompany: function selectedCompany(val) {
      this.fetchDomainforCompany(val);
    },
    err: function err(val) {
      var _this = this;

      if (val !== '') {
        setTimeout(function () {
          _this.err = '';
        }, 5000);
      }
    }
  },
  computed: {
    filteredTempaltes: function filteredTempaltes() {
      var _this2 = this;

      return this.selectedType === null || this.templates === null ? [] : __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys___default()(this.templates).filter(function (key) {
        return _this2.templates[key] === _this2.selectedType;
      }).sort();
    },
    mappedDomains: function mappedDomains() {
      return this.domains.map(function (domain) {
        return {
          text: domain.domain + ' (' + domain.status + ')',
          value: domain.id
        };
      });
    },
    sortedTemplateTypes: function sortedTemplateTypes() {
      return this.templateTypes = this.templateTypes.sort();
    },
    sortedUrlTypes: function sortedUrlTypes() {
      for (var i = 0; i < this.propertiesAll.length; i++) {
        if (this.propertiesAll[i].type === 'URL') this.urlTypes.push(this.propertiesAll[i].name);
      }
      return this.urlTypes = this.urlTypes.sort();
    },
    sortedTextTypes: function sortedTextTypes() {
      for (var i = 0; i < this.propertiesAll.length; i++) {
        if (this.propertiesAll[i].type === 'TEXT') this.textTypes.push(this.propertiesAll[i].name);
      }
      return this.textTypes = this.textTypes.sort();
    }
  },
  methods: {
    formatDate: function formatDate(date) {
      return __WEBPACK_IMPORTED_MODULE_3_luxon__["DateTime"].fromISO(date).toFormat('yyyy-MM-dd HH:mm:ss');
    },
    init: function init() {
      var _this3 = this;

      return new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve) {
        __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a.all([_this3.$http.get('company').then(function (res) {
          _this3.companyLoading = false;
          if (res.body.status === 'Success') {
            _this3.companies = res.body.companies;
            return;
          }
          _this3.err = res.body.statusText;
        }, function (err) {
          _this3.companyLoading = false;
          _this3.err = err.body.statusText || err.body.message;
        }), _this3.$http.get('system/webspace/fetchtypes').then(function (res) {
          _this3.typesLoading = false;
          if (res.body.status === 'Success') {
            _this3.templateTypes = res.body.types;
            return;
          }
          _this3.err = res.body.statusText;
        }, function (err) {
          _this3.typesLoading = false;
          _this3.err = err.body.statusText || err.body.message;
        }), _this3.$http.get('system/webspace/fetchtemplates').then(function (res) {
          if (res.body.status === 'Success') {
            _this3.templatesLoading = false;
            _this3.templates = res.body.templates;
            return;
          }
          _this3.err = res.body.statusText;
        }, function (err) {
          _this3.templatesLoading = false;
          _this3.err = err.body.statusText || err.body.message;
        }), _this3.$http.get('system/webspace/fetchproperties').then(function (res) {
          if (res.body.status === 'Success') {
            _this3.propertiesAll = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys___default()(res.body.properties).map(function (key) {
              return {
                type: res.body.properties[key],
                name: key,
                value: '',
                isEdit: false
              };
            });
            return;
          }
          _this3.err = res.body.statusText;
        }, function (err) {
          _this3.err = err.body.statusText || err.body.message;
        })]).then(function () {
          return resolve();
        });
      });
    },
    fetchDomainforCompany: function fetchDomainforCompany(id) {
      var _this4 = this;

      this.domainLoading = true;
      this.domains = [];
      this.$http.get('domain/fetchallforcompany/' + id).then(function (res) {
        _this4.domainLoading = false;
        if (res.body.status === 'Success') {
          _this4.domains = res.body.domains;
          return;
        }
        _this4.err = res.body.statusText;
      }, function (err) {
        _this4.domainLoading = false;
        _this4.err = err.body.statusText || err.body.message;
      });
    },
    addProperty: function addProperty() {
      this.properties.push({
        type: '',
        name: '',
        value: '',
        isEdit: true
      });
      this.editingProp = true;
    },
    editProp: function editProp(property) {
      this.tempProp = {
        type: property.type,
        name: property.name,
        value: property.value
      };
      this.$set(property, 'isEdit', true);
      this.editingProp = true;
    },
    savePropEdit: function savePropEdit(property) {
      this.$set(property, 'type', this.tempProp.type);
      this.$set(property, 'name', this.tempProp.name);
      this.$set(property, 'value', this.tempProp.value);
      this.closePropEdit(property);
    },
    closePropEdit: function closePropEdit(property, index) {
      this.tempProp = {
        type: '',
        name: '',
        value: ''
      };
      if (property.type === '' && property.name === '' && property.value === '') {
        this.properties.splice(index, 1);
      } else {
        this.$set(property, 'isEdit', false);
      }
      this.editingProp = false;
    },
    generateJSON: function generateJSON() {
      var _this5 = this;

      var data = [];
      this.$http.get('company/' + this.selectedCompany).then(function (res) {
        _this5.typesLoading = false;
        if (res.body.status === 'Success') {
          var company = res.body.company;
          data.push({
            name: 'companyId',
            value: _this5.selectedCompany || null
          }, {
            name: 'description',
            value: _this5.domainDescription || null
          }, {
            name: 'type',
            value: _this5.selectedType || null
          }, {
            name: 'domains',
            value: _this5.selectedDomains || null
          }, {
            name: 'template',
            value: _this5.selectedTemplate || null
          }, {
            name: 'properties',
            value: _this5.props || null
          }, {
            name: 'companyName',
            value: company.name || null
          }, {
            name: 'companyAddressLine1',
            value: company.address.line1 || null
          }, {
            name: 'companyAddressLine2',
            value: company.address.line2 || null
          }, {
            name: 'companyAddressLine3',
            value: company.address.line3 || null
          }, {
            name: 'companyAddressLine4',
            value: company.address.line4 || null
          }, {
            name: 'companyLocality',
            value: company.address.locality || null
          }, {
            name: 'companyPostalCode',
            value: company.address.postalCode || null
          }, {
            name: 'companyTownCity',
            value: company.address.townCity || null
          }, {
            name: 'companyPhone',
            value: company.phone || null
          }, {
            name: 'companyPhone',
            value: company.phone || null
          }, {
            name: 'companyCuisines',
            value: company.cuisines || null
          }, {
            name: 'companyOpeningDaysAndHours',
            value: company.openingDaysAndHours || null
          }, {
            name: 'companyS3ID',
            value: company.companyRandomId || null
          }, {
            name: 'companyEnableContactForm',
            value: company.enableContactForm || false
          }, {
            name: 'companyEnableReservationForm',
            value: company.enableReservationForm || false
          });
          return _this5.$http.get('webshopresource/getall');
        }
        _this5.err = res.body.statusText;
      }, function (err) {
        _this5.err = err.body.statusText || err.body.message;
      }).then(function (res) {
        if (res.body.status === 'Success') {
          var webshopInstance = res.body.details.find(function (webshop) {
            return webshop.companyId === _this5.selectedCompany;
          });
          data.push({
            name: 'companyWebshopResourceId',
            value: webshopInstance ? webshopInstance.webShopResourceExternalId : null
          });
          _this5.generatedJSON = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(data);
        }
        _this5.err = res.body.statusText;
      }, function (err) {
        _this5.err = err.body.statusText || err.body.message;
      });
    },
    copyJSON: function copyJSON() {
      try {
        var copyText = document.getElementById('json-field');
        copyText.select();
        var success = document.execCommand('copy');
      } catch (e) {
        console.log(e);
      }
    },
    submit: function submit() {
      var _this6 = this;

      var props = this.properties.filter(function (prop) {
        return prop.value.length !== 0;
      });
      var data = {
        companyId: this.selectedCompany,
        description: this.domainDescription,
        type: this.selectedType,
        domains: this.selectedDomains,
        template: this.selectedTemplate,
        properties: props
      };
      this.$http.post(this.isEdit ? 'webspace/update/' + this.$route.params.id : 'webspace/create', data).then(function (res) {
        if (res.body.status === 'Success') {
          _this6.success = _this6.isEdit ? 'Webspace updated successfuly' : 'Webspace created successfuly';
          setTimeout(function () {
            if (_this6.isEdit) {
              _this6.success = '';
              _this6.properties = props;
            } else {
              _this6.$router.push({ name: 'webSpaces' });
            }
          }, 3000);
          return;
        }
        _this6.err = res.body.statusText;
      }, function (err) {
        _this6.err = err.body.statusText || err.body.message;
      });
    }
  },
  created: function created() {
    var _this7 = this;

    this.init().then(function () {
      if (_this7.$route.params.id) {
        _this7.isEdit = true;
        _this7.$http.get('webspace/' + _this7.$route.params.id).then(function (res) {
          if (res.body.status === 'Success') {
            var webspace = res.body.webSpace;
            _this7.selectedDomains = webspace.domains || [];
            _this7.selectedCompany = webspace.companyId;
            _this7.selectedType = webspace.type;
            _this7.selectedTemplate = webspace.template;
            _this7.properties = webspace.properties || _this7.propertiesAll;
            _this7.domainDescription = webspace.description;
            _this7.createdOn = _this7.formatDate(webspace.createdOn);
            if (webspace.modifiedOn) {
              _this7.modifiedOn = _this7.formatDate(webspace.modifiedOn);
            }
            return;
          }
          _this7.err = res.body.statusText;
        }).catch(function (err) {
          _this7.err = err.body.statusText || err.body.message;
        });
      } else {
        _this7.properties = _this7.propertiesAll;
      }
    });
  }
});

/***/ }),
/* 225 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_luxon__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_luxon___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_luxon__);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = ({
  components: {
    confirmationModal: function confirmationModal() {
      return __webpack_require__.e/* import() */(0).then(__webpack_require__.bind(null, 25));
    }
  },
  data: function data() {
    return {
      err: '',
      search: '',
      show: false,
      loading: true,
      companies: [],
      selectedCompany: '',
      companyLoading: true,
      headers: [{ text: this.$lang.header.domain, value: 'domainNameType', align: 'left' }, { text: this.$lang.labels.company, value: 'companyName', align: 'left' }, { text: this.$lang.header.templateType, value: 'type', align: 'left' }, { text: this.$lang.header.templateName, value: 'template', align: 'left' }, { text: this.$lang.labels.status, value: 'status', align: 'left' }, { text: this.$lang.labels.created, value: 'createdOn', align: 'left' }, { text: this.$lang.labels.actions, value: 'actions', align: 'left', sortable: false }],
      showActive: true,
      allWebSpaces: [],
      confirmationModal: false,
      confirmationData: {
        id: null,
        url: 'webspace'
      }
    };
  },

  watch: {
    err: function err(val) {
      var _this = this;

      if (val !== '') {
        setTimeout(function () {
          _this.err = '';
        }, 5000);
      }
    },
    selectedCompany: function selectedCompany(val) {
      this.fetchWebSpacesforCompany(val);
      this.$cookie.set('companyedit', val, { expires: '8h' });
    }
  },
  computed: {
    activeWebSpaces: function activeWebSpaces() {
      var webSpaces = this.allWebSpaces;
      var activeWebSpaces = [];
      for (var i = 0; webSpaces.length > i; i++) {
        if (webSpaces[i].status === 'active') {
          activeWebSpaces.push(webSpaces[i]);
        }
      }
      return activeWebSpaces;
    },
    mappedCompanies: function mappedCompanies() {
      return this.companies.map(function (company) {
        return {
          text: company.name + ' (' + company.companyStatus + ')',
          value: company.id
        };
      });
    }
  },
  methods: {
    formatDate: function formatDate(date) {
      return __WEBPACK_IMPORTED_MODULE_1_luxon__["DateTime"].fromISO(date).toFormat('yyyy-MM-dd');
    },
    editWebSpace: function editWebSpace(webspace) {
      this.$router.push({ name: 'editWebSpace', params: { id: webspace.id } });
    },
    changeStatus: function changeStatus(webspace) {
      var _this2 = this;

      if (webspace.status === 'inactive') {
        this.$http.post('webspace/activate/' + webspace.id).then(function (res) {
          if (res.body.status === 'Success') {
            _this2.$set(webspace, 'status', 'active');
            return;
          }
          _this2.err = res.body.statusText;
        }, function (err) {
          _this2.err = err.body.statusText || err.body.message;
        });
      } else if (webspace.status === "active") {
        this.confirmationData.id = webspace.id;
        this.confirmationModal = true;
      }
    },
    deactivate: function deactivate(id) {
      var result = this.allWebSpaces.find(function (data) {
        return data.id === id;
      });
      this.$set(result, 'status', 'inactive');
    },
    init: function init() {
      var _this3 = this;

      return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve) {
        _this3.$http.get('company').then(function (res) {
          resolve();
          _this3.companyLoading = false;
          if (res.body.status === 'Success') {
            _this3.companies = res.body.companies;
            return;
          }
          _this3.err = res.body.statusText;
        }, function (err) {
          resolve();
          _this3.companyLoading = false;
          _this3.err = err.body.statusText || err.body.message;
        });
      });
    },
    fetchWebSpacesforCompany: function fetchWebSpacesforCompany(id) {
      var _this4 = this;

      this.show = true;
      this.allWebSpaces = [];
      this.activeWebSpaces = [];
      this.$http.post('webspace/getall', { companyId: id }).then(function (res) {
        _this4.loading = false;
        if (res.body.status === 'Success') {
          _this4.allWebSpaces = res.body.webSpaces;
          return;
        }
        if (_this4.allWebSpaces.length === 0) {
          _this4.loading = false;
        }
        _this4.err = res.body.statusText;
      }, function (err) {
        _this4.loading = false;
        _this4.err = err.body.statusText || err.body.message;
      });
    }
  },
  created: function created() {
    var _this5 = this;

    this.init().then(function () {
      var edit = _this5.$cookie.get('companyedit');
      if (edit) _this5.selectedCompany = edit;
    });
  }
});

/***/ }),
/* 226 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_luxon__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_luxon___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_luxon__);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = ({
  components: {
    reportDetailsModal: function reportDetailsModal() {
      return __webpack_require__.e/* import() */(11).then(__webpack_require__.bind(null, 478));
    }
  },
  data: function data() {
    return {
      err: '',
      search: '',
      valid: false,
      show: false,
      loading: false,
      reports: [],
      headers: [{ text: this.$lang.labels.type, value: 'type', align: 'left' }, { text: this.$lang.labels.name, value: 'companyName', align: 'left' }, { text: this.$lang.labels.created, value: 'createdOn', align: 'left' }, { text: this.$lang.labels.month, value: 'month', align: 'left' }, { text: this.$lang.labels.year, value: 'year', align: 'left' }, { text: this.$lang.labels.actions, value: 'action', align: 'left', sortable: false }],
      time: {
        month: __WEBPACK_IMPORTED_MODULE_1_luxon__["DateTime"].local().month.toString(),
        year: __WEBPACK_IMPORTED_MODULE_1_luxon__["DateTime"].local().year.toString()
      },
      years: [],
      months: [{ value: '1', text: this.$lang.labels.january }, { value: '2', text: this.$lang.labels.february }, { value: '3', text: this.$lang.labels.march }, { value: '4', text: this.$lang.labels.april }, { value: '5', text: this.$lang.labels.may }, { value: '6', text: this.$lang.labels.june }, { value: '7', text: this.$lang.labels.july }, { value: '8', text: this.$lang.labels.august }, { value: '9', text: this.$lang.labels.september }, { value: '10', text: this.$lang.labels.october }, { value: '11', text: this.$lang.labels.november }, { value: '12', text: this.$lang.labels.december }],
      reportDetailsModal: false,
      reportDetails: null,
      showOverviewData: false
    };
  },

  watch: {
    err: function err(val) {
      var _this = this;

      if (val !== '') {
        setTimeout(function () {
          _this.err = '';
        }, 5000);
      }
    }
  },
  created: function created() {
    var yearNow = new Date().getFullYear();
    for (var i = 2018; i <= yearNow; i += 1) {
      this.years.push(i.toString());
    }
  },

  methods: {
    formatDate: function formatDate(date) {
      return __WEBPACK_IMPORTED_MODULE_1_luxon__["DateTime"].fromISO(date).toFormat('yyyy-MM-dd');
    },
    showOverview: function showOverview() {
      if (!this.showOverviewData) {
        this.headers.splice(5, 0, { text: this.$lang.header.paymentSummary, value: 'paymentOverview', align: 'left' });
        this.showOverviewData = true;
      } else {
        this.headers.splice(5, 1);
        this.showOverviewData = false;
      }
    },
    calculatePaymentSummary: function calculatePaymentSummary(report) {
      var helper = {};
      return report.reduce(function (r, o) {
        var key = o.paymentType;

        if (!helper[key]) {
          helper[key] = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({}, o);
          r.push(helper[key]);
        } else {
          helper[key].amount += o.amount;
        }

        return r;
      }, []);
    },
    calculateOrderData: function calculateOrderData(report, type) {
      var reportMap = report.map(function (x) {
        if (x.ordersData && x.ordersData[type]) return x.ordersData[type];
        return { noOfOrders: 0, ordersSum: 0 };
      });
      return reportMap.reduce(function (a, b) {
        for (var k in b) {
          if (b.hasOwnProperty(k)) a[k] = (a[k] || 0) + b[k];
        }
        return a;
      }, {});
    },
    showReportDetails: function showReportDetails(report) {
      this.reportDetails = {
        id: report.id
      };
      this.reportDetailsModal = true;
    },
    showReports: function showReports() {
      var _this2 = this;

      this.loading = true;
      this.show = true;
      this.$http.post('report/getall', this.time).then(function (res) {
        _this2.loading = false;
        if (res.body.status !== 'Success') {
          _this2.err = res.body.statusText;
          return;
        }
        _this2.reports = res.body.reports;
      }, function (err) {
        _this2.loading = false;
        _this2.err = err.body.statusText || err.body.message;
      });
    }
  }
});

/***/ }),
/* 227 */,
/* 228 */,
/* 229 */,
/* 230 */,
/* 231 */,
/* 232 */,
/* 233 */,
/* 234 */,
/* 235 */,
/* 236 */,
/* 237 */,
/* 238 */,
/* 239 */,
/* 240 */,
/* 241 */,
/* 242 */,
/* 243 */,
/* 244 */,
/* 245 */,
/* 246 */,
/* 247 */,
/* 248 */,
/* 249 */,
/* 250 */,
/* 251 */,
/* 252 */,
/* 253 */,
/* 254 */,
/* 255 */,
/* 256 */,
/* 257 */,
/* 258 */,
/* 259 */,
/* 260 */,
/* 261 */,
/* 262 */,
/* 263 */,
/* 264 */,
/* 265 */,
/* 266 */,
/* 267 */,
/* 268 */,
/* 269 */,
/* 270 */,
/* 271 */,
/* 272 */,
/* 273 */,
/* 274 */,
/* 275 */,
/* 276 */,
/* 277 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 278 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 279 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 280 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 281 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 282 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 283 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 284 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 285 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 286 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 287 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 288 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 289 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 290 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 291 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 292 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 293 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 294 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 295 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 296 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 297 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 298 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 299 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 300 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 301 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 302 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 303 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 304 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 305 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 306 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 307 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 308 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 309 */,
/* 310 */,
/* 311 */,
/* 312 */,
/* 313 */,
/* 314 */,
/* 315 */,
/* 316 */,
/* 317 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  null,
  /* template */
  __webpack_require__(384),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 318 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(166),
  /* template */
  __webpack_require__(396),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 319 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(280)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(167),
  /* template */
  __webpack_require__(388),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-13da116e",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 320 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(302)
  __webpack_require__(303)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(168),
  /* template */
  __webpack_require__(431),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-b9090f0e",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 321 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(291)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(169),
  /* template */
  __webpack_require__(407),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-4eb1ef0a",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 322 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(284)
  __webpack_require__(283)
  __webpack_require__(285)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(170),
  /* template */
  __webpack_require__(399),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-3a123387",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 323 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(287)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(171),
  /* template */
  __webpack_require__(401),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 324 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(172),
  /* template */
  __webpack_require__(425),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 325 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(173),
  /* template */
  __webpack_require__(430),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 326 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(174),
  /* template */
  __webpack_require__(379),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 327 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(296)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(175),
  /* template */
  __webpack_require__(416),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-65d865ec",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 328 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(176),
  /* template */
  __webpack_require__(422),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 329 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(177),
  /* template */
  __webpack_require__(408),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 330 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(178),
  /* template */
  __webpack_require__(435),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 331 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(179),
  /* template */
  __webpack_require__(382),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 332 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(180),
  /* template */
  __webpack_require__(405),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 333 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(182),
  /* template */
  __webpack_require__(428),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 334 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(294)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(183),
  /* template */
  __webpack_require__(412),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-5aef5966",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 335 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(184),
  /* template */
  __webpack_require__(387),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 336 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(299)
  __webpack_require__(300)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(185),
  /* template */
  __webpack_require__(427),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-a604f8b4",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 337 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(307)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(186),
  /* template */
  __webpack_require__(438),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-e9f6517c",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 338 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(187),
  /* template */
  __webpack_require__(414),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 339 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(188),
  /* template */
  __webpack_require__(413),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 340 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(295)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(189),
  /* template */
  __webpack_require__(415),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-633f02cd",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 341 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(190),
  /* template */
  __webpack_require__(409),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 342 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(191),
  /* template */
  __webpack_require__(440),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 343 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(192),
  /* template */
  __webpack_require__(403),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 344 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(297)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(193),
  /* template */
  __webpack_require__(423),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-84964fc2",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 345 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(289)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(194),
  /* template */
  __webpack_require__(404),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-49efa4a0",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 346 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(195),
  /* template */
  __webpack_require__(390),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 347 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(279)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(196),
  /* template */
  __webpack_require__(386),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-10d0e77f",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 348 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(197),
  /* template */
  __webpack_require__(419),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 349 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(198),
  /* template */
  __webpack_require__(434),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 350 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(278)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(199),
  /* template */
  __webpack_require__(381),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-0864b01c",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 351 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(200),
  /* template */
  __webpack_require__(383),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 352 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(301)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(201),
  /* template */
  __webpack_require__(429),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-b25edc60",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 353 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(281)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(202),
  /* template */
  __webpack_require__(393),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-27c00e36",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 354 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(308)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(203),
  /* template */
  __webpack_require__(439),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-ead15cca",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 355 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(204),
  /* template */
  __webpack_require__(424),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 356 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(277)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(205),
  /* template */
  __webpack_require__(378),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 357 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(206),
  /* template */
  __webpack_require__(420),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 358 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(207),
  /* template */
  __webpack_require__(391),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 359 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(208),
  /* template */
  __webpack_require__(395),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 360 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(282)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(209),
  /* template */
  __webpack_require__(397),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 361 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(210),
  /* template */
  __webpack_require__(389),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 362 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(286)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(211),
  /* template */
  __webpack_require__(400),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-3a28c49f",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 363 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(212),
  /* template */
  __webpack_require__(380),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 364 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(213),
  /* template */
  __webpack_require__(437),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 365 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(214),
  /* template */
  __webpack_require__(394),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 366 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(215),
  /* template */
  __webpack_require__(417),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 367 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(216),
  /* template */
  __webpack_require__(392),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 368 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(217),
  /* template */
  __webpack_require__(398),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 369 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(288)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(218),
  /* template */
  __webpack_require__(402),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-3cf3a2c2",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 370 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(292)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(219),
  /* template */
  __webpack_require__(410),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-54429a24",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 371 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(220),
  /* template */
  __webpack_require__(421),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 372 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(290)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(221),
  /* template */
  __webpack_require__(406),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-4df44a06",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 373 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(222),
  /* template */
  __webpack_require__(418),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 374 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(306)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(223),
  /* template */
  __webpack_require__(436),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-c8703fd0",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 375 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(298)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(224),
  /* template */
  __webpack_require__(426),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-a1996ab8",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 376 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(305)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(225),
  /* template */
  __webpack_require__(433),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 377 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(226),
  /* template */
  __webpack_require__(385),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 378 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-flex', {
    attrs: {
      "xs12": "",
      "sm10": "",
      "md8": "",
      "lg6": ""
    }
  }, [_c('v-card', {
    staticClass: "pa-4"
  }, [(_vm.err) ? _c('v-flex', {
    attrs: {
      "xs12": "",
      "pb-3": ""
    }
  }, [_c('v-alert', {
    attrs: {
      "value": true,
      "type": "error"
    }
  }, [_vm._v(_vm._s(_vm.err))])], 1) : _vm._e(), _vm._v(" "), (_vm.success) ? _c('v-flex', {
    attrs: {
      "xs12": "",
      "pb-3": ""
    }
  }, [_c('v-alert', {
    attrs: {
      "value": true,
      "type": "success"
    }
  }, [_vm._v(_vm._s(_vm.success))])], 1) : _vm._e(), _vm._v(" "), _c('v-form', {
    model: {
      value: (_vm.valid),
      callback: function($$v) {
        _vm.valid = $$v
      },
      expression: "valid"
    }
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": "",
      "justify-space-between": "",
      "align-center": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [(!_vm.isLocalAdmin) ? _c('v-autocomplete', {
    attrs: {
      "items": _vm.companies,
      "label": _vm.$lang.actions.selectCompany,
      "item-text": "name",
      "item-value": "id",
      "required": "",
      "readonly": _vm.isEdit,
      "loading": _vm.companyLoading,
      "rules": [function (v) { return !!v || ("" + (_vm.$lang.errors.missingCompany)); }]
    },
    model: {
      value: (_vm.paymentServer.companyId),
      callback: function($$v) {
        _vm.$set(_vm.paymentServer, "companyId", $$v)
      },
      expression: "paymentServer.companyId"
    }
  }) : _vm._e()], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": _vm.$lang.labels.paymentServerName,
      "required": "",
      "rules": [function (v) { return !!v || 'Required'; }]
    },
    model: {
      value: (_vm.paymentServer.name),
      callback: function($$v) {
        _vm.$set(_vm.paymentServer, "name", $$v)
      },
      expression: "paymentServer.name"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "pb-1": ""
    }
  }, [_c('v-autocomplete', {
    attrs: {
      "chips": "",
      "deletable-chips": "",
      "multiple": "",
      "items": _vm.mappedTerminals,
      "label": _vm.$lang.actions.selectTerminals,
      "required": "",
      "disabled": _vm.mappedTerminals.length === 0,
      "loading": _vm.terminalsLoading,
      "rules": [function () { return _vm.paymentServer.paymentTerminals.length > 0 || ("" + (_vm.$lang.errors.missingTerminals)); }]
    },
    model: {
      value: (_vm.paymentServer.paymentTerminals),
      callback: function($$v) {
        _vm.$set(_vm.paymentServer, "paymentTerminals", $$v)
      },
      expression: "paymentServer.paymentTerminals"
    }
  })], 1), _vm._v(" "), (_vm.isEdit) ? _c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-textarea', {
    attrs: {
      "id": "key",
      "label": _vm.$lang.labels.key,
      "auto-grow": "",
      "rows": "1",
      "readonly": _vm.isEdit
    },
    model: {
      value: (_vm.paymentServer.key),
      callback: function($$v) {
        _vm.$set(_vm.paymentServer, "key", $$v)
      },
      expression: "paymentServer.key"
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.isEdit) ? _c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-btn', {
    staticClass: "primary mr-3 ml-0",
    on: {
      "click": function($event) {
        return _vm.changeStatus()
      }
    }
  }, [_vm._v("\n            " + _vm._s(_vm.paymentServer.status === 'active' ? _vm.$lang.actions.deactivate : _vm.$lang.actions.activate) + "\n          ")])], 1) : _vm._e()], 1), _vm._v(" "), _c('v-layout', {
    staticClass: "mt-3 px-2",
    attrs: {
      "row": "",
      "wrap": "",
      "justify-space-between": ""
    }
  }, [(_vm.isEdit && _vm.createdOn) ? _c('v-text-field', {
    staticClass: "min-w max-w mx-3",
    attrs: {
      "label": _vm.$lang.labels.created,
      "readonly": ""
    },
    model: {
      value: (_vm.createdOn),
      callback: function($$v) {
        _vm.createdOn = $$v
      },
      expression: "createdOn"
    }
  }) : _vm._e(), _vm._v(" "), (_vm.isEdit && _vm.modifiedOn) ? _c('v-text-field', {
    staticClass: "min-w max-w mx-3",
    attrs: {
      "label": _vm.$lang.labels.modified,
      "readonly": ""
    },
    model: {
      value: (_vm.modifiedOn),
      callback: function($$v) {
        _vm.modifiedOn = $$v
      },
      expression: "modifiedOn"
    }
  }) : _vm._e()], 1), _vm._v(" "), _c('v-layout', {
    staticClass: "mt-3",
    attrs: {
      "row": "",
      "wrap": "",
      "justify-space-between": "",
      "align-content-center": ""
    }
  }, [_c('v-btn', {
    staticClass: "ml-0",
    attrs: {
      "flat": ""
    },
    on: {
      "click": function($event) {
        return _vm.$router.push({
          name: 'paymentServers'
        })
      }
    }
  }, [_c('v-icon', [_vm._v("keyboard_arrow_left")]), _vm._v("\n          " + _vm._s(_vm.$lang.actions.close) + "\n        ")], 1), _vm._v(" "), _c('div', [(_vm.isEdit) ? _c('v-btn', {
    staticClass: "primary",
    on: {
      "click": _vm.copyKey
    }
  }, [_vm._v("\n            " + _vm._s(_vm.$lang.actions.copyKey) + "\n          ")]) : _vm._e(), _vm._v(" "), _c('v-btn', {
    staticClass: "primary mx-0",
    attrs: {
      "disabled": !_vm.valid
    },
    on: {
      "click": _vm.submit
    }
  }, [_vm._v("\n            " + _vm._s(_vm.isEdit ? _vm.$lang.actions.update : _vm.$lang.actions.create) + "\n          ")])], 1)], 1)], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 379 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-flex', {
    attrs: {
      "xs12": "",
      "sm10": "",
      "md8": "",
      "lg7": ""
    }
  }, [_c('v-card', {
    staticClass: "py-4"
  }, [(_vm.err) ? _c('v-flex', {
    attrs: {
      "xs12": "",
      "pb-3": "",
      "px-4": ""
    }
  }, [_c('v-alert', {
    attrs: {
      "value": true,
      "type": "error"
    }
  }, [_vm._v(_vm._s(_vm.err))])], 1) : _vm._e(), _vm._v(" "), (_vm.success) ? _c('v-flex', {
    attrs: {
      "xs12": "",
      "pb-3": "",
      "px-4": ""
    }
  }, [_c('v-alert', {
    attrs: {
      "value": true,
      "type": "success"
    }
  }, [_vm._v(_vm._s(_vm.success))])], 1) : _vm._e(), _vm._v(" "), _c('v-form', {
    model: {
      value: (_vm.valid),
      callback: function($$v) {
        _vm.valid = $$v
      },
      expression: "valid"
    }
  }, [_c('v-layout', {
    staticClass: "px-2",
    attrs: {
      "row": "",
      "wrap": "",
      "justify-space-between": "",
      "align-center": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": "",
      "sm6": "",
      "px-3": ""
    }
  }, [_c('v-autocomplete', {
    attrs: {
      "items": _vm.companies,
      "label": _vm.$lang.actions.selectCompany,
      "item-text": "name",
      "item-value": "id",
      "required": "",
      "readonly": _vm.isEdit,
      "loading": _vm.companyLoading,
      "rules": [function (v) { return !!v || ("" + (_vm.$lang.errors.missingCompany)); }]
    },
    model: {
      value: (_vm.appResource.companyId),
      callback: function($$v) {
        _vm.$set(_vm.appResource, "companyId", $$v)
      },
      expression: "appResource.companyId"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "sm6": "",
      "px-3": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": _vm.$lang.labels.name,
      "required": "",
      "rules": [function (v) { return !!v || ("" + (_vm.$lang.errors.missingAppResName)); }]
    },
    model: {
      value: (_vm.appResource.name),
      callback: function($$v) {
        _vm.$set(_vm.appResource, "name", $$v)
      },
      expression: "appResource.name"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "sm6": "",
      "px-3": ""
    }
  }, [_c('v-autocomplete', {
    attrs: {
      "items": _vm.appResourceTypes,
      "label": _vm.$lang.actions.selectAppResType,
      "readonly": _vm.isEdit,
      "required": "",
      "rules": [function () { return _vm.appResource.type.length > 0 || ("" + (_vm.$lang.errorsAppResType)); }]
    },
    model: {
      value: (_vm.appResource.type),
      callback: function($$v) {
        _vm.$set(_vm.appResource, "type", $$v)
      },
      expression: "appResource.type"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "sm6": "",
      "px-3": ""
    }
  }, [_c('v-autocomplete', {
    attrs: {
      "items": _vm.subscriptionModels,
      "label": _vm.$lang.actions.selectAppResSubModel,
      "required": "",
      "rules": [function () { return _vm.appResource.subscriptionModel.length > 0 || ("" + (_vm.$lang.errors.missingAppResSubModel)); }]
    },
    model: {
      value: (_vm.appResource.subscriptionModel),
      callback: function($$v) {
        _vm.$set(_vm.appResource, "subscriptionModel", $$v)
      },
      expression: "appResource.subscriptionModel"
    }
  })], 1)], 1), _vm._v(" "), _c('v-layout', {
    staticClass: "px-2",
    attrs: {
      "row": "",
      "wrap": "",
      "justify-space-between": ""
    }
  }, [(_vm.isEdit && _vm.createdOn) ? _c('v-text-field', {
    staticClass: "min-w max-w mx-3",
    attrs: {
      "label": _vm.$lang.labels.created,
      "readonly": ""
    },
    model: {
      value: (_vm.createdOn),
      callback: function($$v) {
        _vm.createdOn = $$v
      },
      expression: "createdOn"
    }
  }) : _vm._e(), _vm._v(" "), (_vm.isEdit && _vm.modifiedOn) ? _c('v-text-field', {
    staticClass: "min-w max-w mx-3",
    attrs: {
      "label": _vm.$lang.labels.modified,
      "readonly": ""
    },
    model: {
      value: (_vm.modifiedOn),
      callback: function($$v) {
        _vm.modifiedOn = $$v
      },
      expression: "modifiedOn"
    }
  }) : _vm._e()], 1), _vm._v(" "), _c('v-layout', {
    staticClass: "mt-2 px-4",
    attrs: {
      "row": "",
      "wrap": "",
      "justify-space-between": "",
      "align-content-center": ""
    }
  }, [_c('v-btn', {
    staticClass: "ml-0",
    attrs: {
      "flat": ""
    },
    on: {
      "click": function($event) {
        return _vm.$router.push({
          name: 'appResources'
        })
      }
    }
  }, [_c('v-icon', [_vm._v("keyboard_arrow_left")]), _vm._v("\n          " + _vm._s(_vm.$lang.actions.close) + "\n        ")], 1), _vm._v(" "), _c('v-btn', {
    staticClass: "primary mx-0",
    attrs: {
      "disabled": !_vm.valid
    },
    on: {
      "click": _vm.submit
    }
  }, [_vm._v("\n          " + _vm._s(_vm.isEdit ? _vm.$lang.actions.update : _vm.$lang.actions.create) + "\n        ")])], 1)], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 380 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-card', [(_vm.err) ? _c('v-flex', {
    attrs: {
      "xs12": "",
      "pt-4": "",
      "px-4": ""
    }
  }, [_c('v-alert', {
    attrs: {
      "value": true,
      "type": "error"
    }
  }, [_vm._v(_vm._s(_vm.err))])], 1) : _vm._e(), _vm._v(" "), _c('v-card-title', {
    staticClass: "pb-3 px-2 layout row wrap"
  }, [_c('v-btn', {
    staticClass: "primary my-0 mx-3",
    on: {
      "click": function($event) {
        return _vm.$router.push({
          name: "printTemplateCreate"
        })
      }
    }
  }, [_vm._v(_vm._s(_vm.$lang.actions.createPrintTemplate))]), _vm._v(" "), _c('v-checkbox', {
    staticClass: "mx-1 mt-0",
    attrs: {
      "color": "primary",
      "label": _vm.$lang.labels.showActive,
      "hide-details": ""
    },
    model: {
      value: (_vm.showActive),
      callback: function($$v) {
        _vm.showActive = $$v
      },
      expression: "showActive"
    }
  }), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('v-autocomplete', {
    staticClass: "min-w max-w mx-3 pb-2",
    attrs: {
      "label": _vm.$lang.actions.selectCompany,
      "items": _vm.mappedCompanies,
      "loading": _vm.companyLoading,
      "hide-details": ""
    },
    model: {
      value: (_vm.selectedCompany),
      callback: function($$v) {
        _vm.selectedCompany = $$v
      },
      expression: "selectedCompany"
    }
  }), _vm._v(" "), (_vm.show) ? _c('v-text-field', {
    staticClass: "min-w max-w mx-3 pb-2",
    attrs: {
      "append-icon": "search",
      "label": _vm.$lang.labels.search,
      "hide-details": ""
    },
    model: {
      value: (_vm.search),
      callback: function($$v) {
        _vm.search = $$v
      },
      expression: "search"
    }
  }) : _vm._e()], 1), _vm._v(" "), (_vm.show) ? _c('v-data-table', {
    attrs: {
      "headers": _vm.headers,
      "items": _vm.showActive ? _vm.activeTemplates : _vm.allTemplates,
      "search": _vm.search,
      "loading": _vm.loading,
      "rows-per-page-items": [50, 100, 250, 500, {
        text: 'All',
        value: -1
      }]
    },
    scopedSlots: _vm._u([{
      key: "items",
      fn: function(props) {
        return [_c('td', [_vm._v(_vm._s(props.item.templateName))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(props.item.type))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(props.item.status))]), _vm._v(" "), _c('td', {
          staticClass: "min-w-lg"
        }, [_c('v-btn', {
          staticClass: "primary mx-0 elevation-1",
          on: {
            "click": function($event) {
              return _vm.$router.push({
                name: 'printTemplateClone',
                params: {
                  id: props.item.id
                }
              })
            }
          }
        }, [_vm._v(_vm._s(_vm.$lang.actions.clone))]), _vm._v(" "), _c('v-btn', {
          staticClass: "primary elevation-1",
          on: {
            "click": function($event) {
              return _vm.$router.push({
                name: 'printTemplate',
                params: {
                  id: props.item.id,
                  view: true
                }
              })
            }
          }
        }, [_vm._v(_vm._s(_vm.$lang.actions.view))]), _vm._v(" "), _c('v-btn', {
          staticClass: "primary mx-0 elevation-1",
          on: {
            "click": function($event) {
              return _vm.changeStatus(props.item)
            }
          }
        }, [_vm._v(_vm._s(props.item.status === 'active' ? _vm.$lang.actions.deactivate : _vm.$lang.actions.activate))])], 1)]
      }
    }], null, false, 748261711)
  }, [_c('v-progress-linear', {
    attrs: {
      "slot": "progress",
      "height": "6",
      "color": "primary",
      "indeterminate": ""
    },
    slot: "progress"
  }), _vm._v(" "), _vm._v(" "), _c('v-alert', {
    attrs: {
      "slot": "no-results",
      "value": true,
      "color": "warning",
      "icon": "warning"
    },
    slot: "no-results"
  }, [_vm._v("\n        Your search for \"" + _vm._s(_vm.search) + "\" found no results.\n      ")])], 1) : _vm._e()], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 381 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-card', [(_vm.generateLoading) ? _c('v-progress-linear', {
    staticClass: "loading",
    attrs: {
      "indeterminate": true
    }
  }) : _vm._e(), _vm._v(" "), (_vm.err) ? _c('v-flex', {
    attrs: {
      "xs12": "",
      "px-4": "",
      "py-3": ""
    }
  }, [_c('v-alert', {
    attrs: {
      "value": true,
      "type": "error"
    }
  }, [_vm._v(_vm._s(_vm.err))])], 1) : _vm._e(), _vm._v(" "), (_vm.success) ? _c('v-flex', {
    attrs: {
      "xs12": "",
      "px-4": "",
      "py-3": ""
    }
  }, [_c('v-alert', {
    attrs: {
      "value": true,
      "type": "success"
    }
  }, [_vm._v(_vm._s(_vm.success))])], 1) : _vm._e(), _vm._v(" "), (!_vm.generate) ? _c('v-form', {
    staticClass: "pt-3",
    model: {
      value: (_vm.valid),
      callback: function($$v) {
        _vm.valid = $$v
      },
      expression: "valid"
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": "",
      "sm7": "",
      "md5": "",
      "lg4": "",
      "px-4": ""
    }
  }, [_c('v-select', {
    attrs: {
      "label": _vm.$lang.header.licenseType,
      "items": _vm.types,
      "rules": [function (v) { return !!v || ("" + (_vm.$lang.errors.missingLicenseType)); }],
      "required": ""
    },
    model: {
      value: (_vm.licenseType),
      callback: function($$v) {
        _vm.licenseType = $$v
      },
      expression: "licenseType"
    }
  })], 1), _vm._v(" "), (_vm.licenseType === 'daily') ? [_c('v-flex', {
    attrs: {
      "xs12": "",
      "sm7": "",
      "md5": "",
      "lg4": "",
      "px-4": ""
    }
  }, [_c('v-menu', {
    ref: "menu",
    attrs: {
      "return-value": _vm.fromDate,
      "lazy": "",
      "transition": "scale-transition",
      "full-width": "",
      "min-width": "290px"
    },
    on: {
      "update:returnValue": function($event) {
        _vm.fromDate = $event
      },
      "update:return-value": function($event) {
        _vm.fromDate = $event
      }
    },
    model: {
      value: (_vm.menu),
      callback: function($$v) {
        _vm.menu = $$v
      },
      expression: "menu"
    }
  }, [_c('v-text-field', {
    attrs: {
      "slot": "activator",
      "label": _vm.$lang.labels.fromDate,
      "prepend-icon": "event",
      "required": "",
      "rules": [function (v) { return !!v || ("" + (_vm.$lang.errors.missingFromDate)); }],
      "readonly": ""
    },
    slot: "activator",
    model: {
      value: (_vm.fromDate),
      callback: function($$v) {
        _vm.fromDate = $$v
      },
      expression: "fromDate"
    }
  }), _vm._v(" "), _c('v-date-picker', {
    attrs: {
      "color": "primary",
      "no-title": "",
      "scrollable": ""
    },
    on: {
      "input": function($event) {
        return _vm.$refs.menu.save(_vm.fromDate)
      }
    },
    model: {
      value: (_vm.fromDate),
      callback: function($$v) {
        _vm.fromDate = $$v
      },
      expression: "fromDate"
    }
  })], 1), _vm._v(" "), _c('v-menu', {
    ref: "menu2",
    attrs: {
      "return-value": _vm.toDate,
      "lazy": "",
      "transition": "scale-transition",
      "full-width": "",
      "min-width": "290px"
    },
    on: {
      "update:returnValue": function($event) {
        _vm.toDate = $event
      },
      "update:return-value": function($event) {
        _vm.toDate = $event
      }
    },
    model: {
      value: (_vm.menu2),
      callback: function($$v) {
        _vm.menu2 = $$v
      },
      expression: "menu2"
    }
  }, [_c('v-text-field', {
    attrs: {
      "slot": "activator",
      "label": _vm.$lang.labels.toDate,
      "prepend-icon": "event",
      "required": "",
      "rules": [function (v) { return !!v || ("" + (_vm.$lang.errors.missingToDate)); }],
      "readonly": ""
    },
    slot: "activator",
    model: {
      value: (_vm.toDate),
      callback: function($$v) {
        _vm.toDate = $$v
      },
      expression: "toDate"
    }
  }), _vm._v(" "), _c('v-date-picker', {
    attrs: {
      "color": "primary",
      "no-title": "",
      "scrollable": ""
    },
    on: {
      "input": function($event) {
        return _vm.$refs.menu2.save(_vm.toDate)
      }
    },
    model: {
      value: (_vm.toDate),
      callback: function($$v) {
        _vm.toDate = $$v
      },
      expression: "toDate"
    }
  })], 1), _vm._v(" "), _c('v-autocomplete', {
    staticClass: "min-w max-w mx-2 mb-4",
    attrs: {
      "label": _vm.$lang.actions.selectCompany,
      "items": _vm.companies,
      "loading": _vm.companyLoading,
      "item-text": "name",
      "item-value": "id",
      "hide-details": "",
      "clearable": ""
    },
    model: {
      value: (_vm.selectedCompany),
      callback: function($$v) {
        _vm.selectedCompany = $$v
      },
      expression: "selectedCompany"
    }
  })], 1)] : _vm._e(), _vm._v(" "), (_vm.licenseType === 'monthly' || _vm.licenseType === 'monthlyaggregated') ? [_c('v-layout', {
    staticClass: "px-2",
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": "",
      "sm7": "",
      "md5": "",
      "lg4": "",
      "px-3": ""
    }
  }, [_c('v-select', {
    attrs: {
      "items": _vm.years,
      "label": _vm.$lang.actions.selectYear,
      "required": "",
      "rules": [function (v) { return !!v || ("" + (_vm.$lang.errors.missingYear)); }]
    },
    model: {
      value: (_vm.year),
      callback: function($$v) {
        _vm.year = $$v
      },
      expression: "year"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "sm7": "",
      "md5": "",
      "lg4": "",
      "px-3": ""
    }
  }, [_c('v-select', {
    attrs: {
      "items": _vm.months,
      "label": _vm.$lang.actions.selectMonth,
      "required": "",
      "rules": [function (v) { return !!v || ("" + (_vm.$lang.errors.missingMonth)); }]
    },
    model: {
      value: (_vm.month),
      callback: function($$v) {
        _vm.month = $$v
      },
      expression: "month"
    }
  })], 1)], 1)] : _vm._e(), _vm._v(" "), _c('v-layout', {
    staticClass: "px-4 pb-3",
    attrs: {
      "row": "",
      "wrap": "",
      "align-center": "",
      "justify-space-between": ""
    }
  }, [_c('div', [_c('v-btn', {
    staticClass: "primary ml-0",
    attrs: {
      "disabled": !_vm.valid
    },
    on: {
      "click": _vm.showReports
    }
  }, [_vm._v(_vm._s(_vm.$lang.actions.showReports))]), _vm._v(" "), _c('v-btn', {
    staticClass: "primary mx-0",
    on: {
      "click": function($event) {
        return _vm.showGenerate()
      }
    }
  }, [_vm._v(_vm._s(_vm.$lang.actions.generateMonthly))])], 1), _vm._v(" "), (_vm.reports.length !== 0) ? _c('v-text-field', {
    staticClass: "min-w max-w",
    attrs: {
      "append-icon": "search",
      "label": _vm.$lang.labels.search,
      "hide-details": ""
    },
    model: {
      value: (_vm.search),
      callback: function($$v) {
        _vm.search = $$v
      },
      expression: "search"
    }
  }) : _vm._e()], 1)], 2) : _vm._e(), _vm._v(" "), (_vm.generate) ? _c('v-form', {
    staticClass: "pt-3",
    model: {
      value: (_vm.generateValid),
      callback: function($$v) {
        _vm.generateValid = $$v
      },
      expression: "generateValid"
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": "",
      "sm7": "",
      "md5": "",
      "lg4": "",
      "px-4": ""
    }
  }, [_c('v-select', {
    attrs: {
      "items": _vm.years,
      "label": _vm.$lang.actions.selectYear,
      "required": "",
      "rules": [function (v) { return !!v || ("" + (_vm.$lang.errors.missingYear)); }]
    },
    model: {
      value: (_vm.year),
      callback: function($$v) {
        _vm.year = $$v
      },
      expression: "year"
    }
  }), _vm._v(" "), _c('v-select', {
    attrs: {
      "items": _vm.months,
      "label": _vm.$lang.actions.selectMonth,
      "required": "",
      "rules": [function (v) { return !!v || ("" + (_vm.$lang.errors.missingMonth)); }]
    },
    model: {
      value: (_vm.month),
      callback: function($$v) {
        _vm.month = $$v
      },
      expression: "month"
    }
  })], 1), _vm._v(" "), _c('v-layout', {
    staticClass: "pb-4",
    attrs: {
      "row": "",
      "wrap": "",
      "align-center": ""
    }
  }, [_c('v-btn', {
    staticClass: "primary mx-4",
    attrs: {
      "disabled": !_vm.generateValid || _vm.generateLoading
    },
    on: {
      "click": function($event) {
        return _vm.generateReport()
      }
    }
  }, [_vm._v(_vm._s(_vm.$lang.actions.generate))]), _vm._v(" "), _c('v-btn', {
    staticClass: "mx-4",
    attrs: {
      "flat": ""
    },
    on: {
      "click": function($event) {
        return _vm.close()
      }
    }
  }, [_vm._v(_vm._s(_vm.$lang.actions.close))])], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.show && !_vm.generate) ? _c('v-data-table', {
    attrs: {
      "headers": (_vm.licenseType === 'monthlyaggregated' ? _vm.aggrHeaders : _vm.headers),
      "items": _vm.reports,
      "search": _vm.search,
      "loading": _vm.loading,
      "pagination": _vm.pagination,
      "rows-per-page-items": [50, 100, 250, 500, {
        text: 'All',
        value: -1
      }]
    },
    on: {
      "update:pagination": function($event) {
        _vm.pagination = $event
      }
    },
    scopedSlots: _vm._u([{
      key: "items",
      fn: function(props) {
        return [(_vm.licenseType !== 'monthlyaggregated') ? _c('td', [_vm._v(_vm._s(props.item.companyName))]) : _vm._e(), _vm._v(" "), _c('td', [_vm._v(_vm._s(props.item.type))]), _vm._v(" "), (_vm.licenseType === 'monthlyaggregated') ? _c('td', [_vm._v(_vm._s(props.item.year))]) : _vm._e(), _vm._v(" "), (_vm.licenseType === 'monthlyaggregated') ? _c('td', [_vm._v(_vm._s(_vm.months[parseInt(props.item.month, 10) - 1].text))]) : _vm._e(), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.formatDate(props.item.createdOn)))]), _vm._v(" "), _c('td', [_c('v-btn', {
          staticClass: "primary mx-0 elevation-1",
          on: {
            "click": function($event) {
              return _vm.viewLicense(props.item)
            }
          }
        }, [_vm._v("\n            " + _vm._s(_vm.$lang.actions.view) + "\n          ")])], 1)]
      }
    }], null, false, 239183871)
  }, [_c('v-progress-linear', {
    attrs: {
      "slot": "progress",
      "height": "6",
      "color": "primary",
      "indeterminate": ""
    },
    slot: "progress"
  }), _vm._v(" "), _vm._v(" "), _c('v-alert', {
    attrs: {
      "slot": "no-results",
      "value": true,
      "type": "warning"
    },
    slot: "no-results"
  }, [_vm._v("\n        Your search for \"" + _vm._s(_vm.search) + "\" found no results.\n      ")])], 1) : _vm._e()], 1), _vm._v(" "), (_vm.licenseReportDetailsModal) ? _c('v-dialog', {
    attrs: {
      "max-width": "1880"
    },
    model: {
      value: (_vm.licenseReportDetailsModal),
      callback: function($$v) {
        _vm.licenseReportDetailsModal = $$v
      },
      expression: "licenseReportDetailsModal"
    }
  }, [_c('license-report-details-modal', {
    attrs: {
      "licenseReportDetails": _vm.licenseReportDetails
    },
    on: {
      "close": function($event) {
        _vm.licenseReportDetailsModal = false
      }
    }
  })], 1) : _vm._e()], 1)
},staticRenderFns: []}

/***/ }),
/* 382 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-card', [(_vm.err) ? _c('v-flex', {
    attrs: {
      "xs12": "",
      "pt-4": "",
      "pb-2": "",
      "px-4": ""
    }
  }, [_c('v-alert', {
    attrs: {
      "value": true,
      "type": "error"
    }
  }, [_vm._v(" " + _vm._s(_vm.err))])], 1) : _vm._e(), _vm._v(" "), (_vm.success) ? _c('v-flex', {
    attrs: {
      "xs12": "",
      "pt-4": "",
      "pb-2": "",
      "px-4": ""
    }
  }, [_c('v-alert', {
    attrs: {
      "type": "success",
      "value": true
    }
  }, [_vm._v(_vm._s(_vm.success))])], 1) : _vm._e(), _vm._v(" "), _c('v-card-title', {
    staticClass: "pb-3 px-2 layout row wrap"
  }, [_c('v-btn', {
    staticClass: "primary my-0 mx-3",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.createRegister()
      }
    }
  }, [_vm._v("\n        " + _vm._s(_vm.$lang.actions.createCashRegister) + "\n      ")]), _vm._v(" "), _c('v-spacer'), _vm._v(" "), (!_vm.isLocalAdmin) ? _c('v-autocomplete', {
    staticClass: "min-w max-w mx-3 pb-2",
    attrs: {
      "label": _vm.$lang.actions.selectCompany,
      "items": _vm.mappedCompanies,
      "hide-details": ""
    },
    model: {
      value: (_vm.selectedCompany),
      callback: function($$v) {
        _vm.selectedCompany = $$v
      },
      expression: "selectedCompany"
    }
  }) : _vm._e()], 1), _vm._v(" "), (_vm.selectedCompany || (_vm.isLocalAdmin && _vm.allRegisters)) ? _c('div', [_c('transition', {
    attrs: {
      "name": "fade"
    }
  }, [_c('v-data-table', {
    attrs: {
      "items": _vm.allRegisters,
      "headers": _vm.headers,
      "loading": _vm.loading,
      "rows-per-page-items": [50, 100, 250, 500, {
        text: 'All',
        value: -1
      }]
    },
    scopedSlots: _vm._u([{
      key: "items",
      fn: function(props) {
        return [_c('td', [_vm._v(_vm._s(props.item.cashRegisterName))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(props.item.username))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.formatDate(props.item.createdOn)))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(props.item.inUseFrom ? _vm.formatDate(props.item.inUseFrom) : ''))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(props.item.status))]), _vm._v(" "), _c('td', [_c('v-btn', {
          attrs: {
            "color": "primary"
          },
          on: {
            "click": function($event) {
              return _vm.editRegister(props.item.id)
            }
          }
        }, [_vm._v(_vm._s(_vm.$lang.actions.edit))])], 1)]
      }
    }], null, false, 3758158573)
  }, [_c('v-progress-linear', {
    attrs: {
      "slot": "progress",
      "height": "6",
      "color": "primary",
      "indeterminate": ""
    },
    slot: "progress"
  })], 1)], 1)], 1) : _vm._e()], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 383 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-card', [(_vm.err) ? _c('v-flex', {
    attrs: {
      "xs12": "",
      "pt-4": "",
      "pb-2": "",
      "px-4": ""
    }
  }, [_c('v-alert', {
    attrs: {
      "value": true,
      "type": "error"
    }
  }, [_vm._v(" " + _vm._s(_vm.err))])], 1) : _vm._e(), _vm._v(" "), (_vm.success) ? _c('v-flex', {
    attrs: {
      "xs12": "",
      "pt-4": "",
      "pb-2": "",
      "px-4": ""
    }
  }, [_c('v-alert', {
    attrs: {
      "type": "success",
      "value": true
    }
  }, [_vm._v(_vm._s(_vm.success))])], 1) : _vm._e(), _vm._v(" "), _c('v-card-title', {
    staticClass: "py- px-4 layout row wrap"
  }, [_c('v-btn', {
    staticClass: "primary ma-0",
    on: {
      "click": function($event) {
        return _vm.$router.push({
          name: "licenseCreate"
        })
      }
    }
  }, [_vm._v(_vm._s(_vm.$lang.actions.createLicense))]), _vm._v(" "), _c('v-checkbox', {
    staticClass: "ml-3 mt-0",
    attrs: {
      "color": "primary",
      "label": _vm.$lang.labels.showActive,
      "hide-details": ""
    },
    model: {
      value: (_vm.showActive),
      callback: function($$v) {
        _vm.showActive = $$v
      },
      expression: "showActive"
    }
  }), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('v-text-field', {
    staticClass: "min-w max-w",
    attrs: {
      "append-icon": "search",
      "label": _vm.$lang.labels.search,
      "hide-details": ""
    },
    model: {
      value: (_vm.search),
      callback: function($$v) {
        _vm.search = $$v
      },
      expression: "search"
    }
  })], 1), _vm._v(" "), _c('v-data-table', {
    attrs: {
      "headers": _vm.headers,
      "items": _vm.showActive ? _vm.activeLicenses : _vm.allLicenses,
      "search": _vm.search,
      "loading": _vm.allLicenses.length === 0,
      "rows-per-page-items": [50, 100, 250, 500, {
        text: 'All',
        value: -1
      }]
    },
    scopedSlots: _vm._u([{
      key: "items",
      fn: function(props) {
        return [_c('td', {
          staticClass: "min-w-lg"
        }, [_vm._v(_vm._s(props.item.companyName))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(props.item.id))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(props.item.licenseType))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(props.item.moonInstanceName))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.formatDate(props.item.getsActiveOn)))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.formatDate(props.item.expiresOn)))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(props.item.status))]), _vm._v(" "), _c('td', {
          staticClass: "min-w-lg"
        }, [_c('v-btn', {
          staticClass: "primary mx-0 elevation-1",
          on: {
            "click": function($event) {
              return _vm.viewLicense(props.item)
            }
          }
        }, [_vm._v("\n            " + _vm._s(_vm.$lang.actions.view) + "\n          ")]), _vm._v(" "), _c('v-btn', {
          staticClass: "primary elevation-1",
          on: {
            "click": function($event) {
              return _vm.changeStatus(props.item)
            }
          }
        }, [_vm._v("\n            " + _vm._s(props.item.status === 'active' ? _vm.$lang.actions.deactivate : _vm.$lang.actions.activate) + "\n          ")])], 1)]
      }
    }])
  }, [_c('v-progress-linear', {
    attrs: {
      "slot": "progress",
      "height": "6",
      "color": "primary",
      "indeterminate": ""
    },
    slot: "progress"
  }), _vm._v(" "), _vm._v(" "), _c('v-alert', {
    attrs: {
      "slot": "no-results",
      "value": true,
      "type": "warning"
    },
    slot: "no-results"
  }, [_vm._v("\n        Your search for \"" + _vm._s(_vm.search) + "\" found no results.\n      ")])], 1)], 1), _vm._v(" "), (_vm.confirmationModal) ? _c('v-dialog', {
    attrs: {
      "max-width": "500"
    },
    model: {
      value: (_vm.confirmationModal),
      callback: function($$v) {
        _vm.confirmationModal = $$v
      },
      expression: "confirmationModal"
    }
  }, [_c('confirmation-modal', {
    attrs: {
      "data": _vm.confirmationData
    },
    on: {
      "close": function($event) {
        _vm.confirmationModal = false
      },
      "change": function($event) {
        return _vm.deactivate($event)
      }
    }
  })], 1) : _vm._e()], 1)
},staticRenderFns: []}

/***/ }),
/* 384 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-layout', {
    attrs: {
      "justify-space-around": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": "",
      "sm10": "",
      "md8": "",
      "lg6": ""
    }
  }, [_c('v-card', {
    staticClass: "red--text ma-4 pa-4"
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_vm._v("\n        " + _vm._s(_vm.$lang.global.error404) + "\n      ")])], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 385 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-card', [_c('v-layout', {
    staticClass: "px-2 pt-3",
    attrs: {
      "row": "",
      "wrap": "",
      "justify-space-between": ""
    }
  }, [_c('v-form', {
    model: {
      value: (_vm.valid),
      callback: function($$v) {
        _vm.valid = $$v
      },
      expression: "valid"
    }
  }, [_c('div', {
    staticClass: "layout row wrap"
  }, [_c('v-select', {
    staticClass: "min-w mx-3",
    attrs: {
      "items": _vm.months,
      "label": _vm.$lang.actions.selectMonth,
      "required": "",
      "rules": [function (v) { return !!v || ("" + (_vm.$lang.errors.missingMonth)); }]
    },
    model: {
      value: (_vm.time.month),
      callback: function($$v) {
        _vm.$set(_vm.time, "month", $$v)
      },
      expression: "time.month"
    }
  }), _vm._v(" "), _c('v-select', {
    staticClass: "min-w mx-3",
    attrs: {
      "items": _vm.years,
      "label": _vm.$lang.actions.selectYear,
      "required": "",
      "rules": [function (v) { return !!v || ("" + (_vm.$lang.errors.missingYear)); }]
    },
    model: {
      value: (_vm.time.year),
      callback: function($$v) {
        _vm.$set(_vm.time, "year", $$v)
      },
      expression: "time.year"
    }
  }), _vm._v(" "), _c('v-btn', {
    staticClass: "primary mx-2 my-2",
    attrs: {
      "disabled": !_vm.valid
    },
    on: {
      "click": function($event) {
        return _vm.showReports()
      }
    }
  }, [_vm._v(_vm._s(_vm.$lang.actions.showReports))]), _vm._v(" "), _c('v-btn', {
    staticClass: "primary mx-2 my-2",
    attrs: {
      "disabled": _vm.reports.length === 0
    },
    on: {
      "click": function($event) {
        return _vm.showOverview()
      }
    }
  }, [_vm._v(_vm._s(!_vm.showOverviewData ? _vm.$lang.actions.showPaymentOverview : _vm.$lang.actions.hidePaymentOverview))])], 1)]), _vm._v(" "), (_vm.show) ? _c('v-text-field', {
    staticClass: "min-w max-w mx-3",
    attrs: {
      "append-icon": "search",
      "label": _vm.$lang.labels.search
    },
    model: {
      value: (_vm.search),
      callback: function($$v) {
        _vm.search = $$v
      },
      expression: "search"
    }
  }) : _vm._e()], 1), _vm._v(" "), (_vm.err) ? _c('v-flex', {
    attrs: {
      "xs12": "",
      "px-4": "",
      "pb-3": ""
    }
  }, [_c('v-alert', {
    staticClass: "my-0",
    attrs: {
      "type": "error",
      "value": true
    }
  }, [_vm._v(_vm._s(_vm.err))])], 1) : _vm._e(), _vm._v(" "), (_vm.show) ? _c('v-data-table', {
    attrs: {
      "headers": _vm.headers,
      "items": _vm.reports,
      "search": _vm.search,
      "loading": _vm.loading,
      "rows-per-page-items": [50, 100, 250, 500, {
        text: 'All',
        value: -1
      }]
    },
    scopedSlots: _vm._u([{
      key: "items",
      fn: function(props) {
        return [_c('td', [_vm._v(_vm._s(props.item.type))]), _vm._v(" "), _c('td', {
          staticClass: "min-w"
        }, [_vm._v(_vm._s(props.item.companyName))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.formatDate(props.item.createdOn)))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.months[parseInt(props.item.month, 10) - 1].text))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(props.item.year))]), _vm._v(" "), (_vm.showOverviewData) ? _c('td', [_c('v-layout', {
          attrs: {
            "row": "",
            "wrap": ""
          }
        }, [_c('v-flex', {
          attrs: {
            "xs6": ""
          }
        }, [_c('span', {
          staticClass: "text-xs-left"
        }, [_vm._v(_vm._s(_vm.$lang.labels.webshopOrderNo) + ": " + _vm._s((_vm.calculateOrderData(props.item.webShopResources, 'webshop')).noOfOrders))]), _vm._v(" "), _c('br'), _vm._v(" "), _c('span', {
          staticClass: "text-xs-left"
        }, [_vm._v(_vm._s(_vm.$lang.labels.appOrderNo) + ": " + _vm._s((_vm.calculateOrderData(props.item.webShopResources, 'ordering app')).noOfOrders))])]), _vm._v(" "), _c('v-flex', {
          attrs: {
            "xs6": ""
          }
        }, [_vm._l((_vm.calculatePaymentSummary(props.item.webShopResources.map(function (x) { return x.paymentSummary; }).flat(Infinity))), function(type) {
          return [_c('span', {
            staticClass: "text-xs-left"
          }, [_vm._v(_vm._s(_vm.$lang.labels[type.paymentType]) + ": " + _vm._s(type.amount))]), _c('br')]
        }), _vm._v(" "), _c('span', {
          staticClass: "text-xs-left"
        }, [_vm._v(_vm._s(_vm.$lang.labels.webshopTotal) + ": " + _vm._s((_vm.calculateOrderData(props.item.webShopResources, 'webshop')).ordersSum))]), _vm._v(" "), _c('br'), _vm._v(" "), _c('span', {
          staticClass: "text-xs-left"
        }, [_vm._v(_vm._s(_vm.$lang.labels.appTotal) + ": " + _vm._s((_vm.calculateOrderData(props.item.webShopResources, 'ordering app')).ordersSum))])], 2)], 1)], 1) : _vm._e(), _vm._v(" "), _c('td', [_c('v-btn', {
          staticClass: "primary mx-0",
          on: {
            "click": function($event) {
              return _vm.showReportDetails(props.item)
            }
          }
        }, [_vm._v(_vm._s(_vm.$lang.actions.view))])], 1)]
      }
    }], null, false, 1509858075)
  }, [_c('v-progress-linear', {
    attrs: {
      "slot": "progress",
      "height": "6",
      "color": "primary",
      "indeterminate": ""
    },
    slot: "progress"
  }), _vm._v(" "), _vm._v(" "), _c('v-alert', {
    attrs: {
      "slot": "no-results",
      "value": true,
      "color": "warning",
      "icon": "warning"
    },
    slot: "no-results"
  }, [_vm._v("\n        Your search for \"" + _vm._s(_vm.search) + "\" found no results.\n      ")])], 1) : _vm._e()], 1), _vm._v(" "), (_vm.reportDetailsModal) ? _c('v-dialog', {
    attrs: {
      "max-width": "1200"
    },
    model: {
      value: (_vm.reportDetailsModal),
      callback: function($$v) {
        _vm.reportDetailsModal = $$v
      },
      expression: "reportDetailsModal"
    }
  }, [_c('report-details-modal', {
    attrs: {
      "reportDetails": _vm.reportDetails
    },
    on: {
      "close": function($event) {
        _vm.reportDetailsModal = false
      }
    }
  })], 1) : _vm._e()], 1)
},staticRenderFns: []}

/***/ }),
/* 386 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-card', {
    staticClass: "py-4"
  }, [(_vm.err) ? _c('v-flex', {
    attrs: {
      "xs12": "",
      "pb-3": "",
      "px-4": ""
    }
  }, [_c('v-alert', {
    attrs: {
      "value": true,
      "type": "error"
    }
  }, [_vm._v(_vm._s(_vm.err))])], 1) : _vm._e(), _vm._v(" "), (_vm.success) ? _c('v-flex', {
    attrs: {
      "xs12": "",
      "pb-3": "",
      "px-4": ""
    }
  }, [_c('v-alert', {
    attrs: {
      "value": true,
      "type": "success"
    }
  }, [_vm._v(_vm._s(_vm.success))])], 1) : _vm._e(), _vm._v(" "), _c('v-form', {
    model: {
      value: (_vm.valid),
      callback: function($$v) {
        _vm.valid = $$v
      },
      expression: "valid"
    }
  }, [_c('v-flex', {
    staticClass: "px-4",
    attrs: {
      "xs12": "",
      "sm10": "",
      "md7": "",
      "lg5": ""
    }
  }, [_c('v-autocomplete', {
    attrs: {
      "items": _vm.companies,
      "label": _vm.$lang.actions.selectCompany,
      "readonly": _vm.isEdit,
      "item-text": "name",
      "item-value": "id",
      "required": "",
      "loading": _vm.companyLoading,
      "rules": [function (v) { return !!v || ("" + (_vm.$lang.errors.missingCompany)); }]
    },
    model: {
      value: (_vm.companyId),
      callback: function($$v) {
        _vm.companyId = $$v
      },
      expression: "companyId"
    }
  })], 1), _vm._v(" "), _c('v-btn', {
    staticClass: "primary mx-4",
    attrs: {
      "disabled": _vm.editingMap
    },
    on: {
      "click": _vm.addMapping
    }
  }, [_vm._v(_vm._s(_vm.$lang.actions.addLangMapp))]), _vm._v(" "), _c('div', {
    staticClass: "v-table__overflow my-3 px-4"
  }, [_c('table', {
    staticClass: "v-datatable v-table theme--light"
  }, [_c('tbody', _vm._l((_vm.maps), function(map, index) {
    return _c('tr', {
      key: index
    }, [(map.isEdit) ? [_c('td', [_c('v-select', {
      staticClass: "min-w",
      attrs: {
        "required": "",
        "items": _vm.printerCategories,
        "label": _vm.$lang.actions.selectPrinterCategory
      },
      model: {
        value: (_vm.tempMapping.categoryName),
        callback: function($$v) {
          _vm.$set(_vm.tempMapping, "categoryName", $$v)
        },
        expression: "tempMapping.categoryName"
      }
    })], 1), _vm._v(" "), _c('td', [_c('v-select', {
      staticClass: "min-w",
      attrs: {
        "required": "",
        "items": _vm.languages,
        "item-text": "text",
        "item-value": "value",
        "label": _vm.$lang.actions.selectLanguage
      },
      model: {
        value: (_vm.tempMapping.language),
        callback: function($$v) {
          _vm.$set(_vm.tempMapping, "language", $$v)
        },
        expression: "tempMapping.language"
      }
    })], 1), _vm._v(" "), _c('td', {
      staticClass: "min-w-lg px-0"
    }, [_c('v-btn', {
      staticClass: "primary elevation-1",
      attrs: {
        "disabled": !_vm.tempMapping.language || !_vm.tempMapping.categoryName
      },
      on: {
        "click": function($event) {
          return _vm.saveMappingEdit(map)
        }
      }
    }, [_vm._v(_vm._s(_vm.$lang.actions.save))]), _vm._v(" "), _c('v-btn', {
      staticClass: "error ml-0 elevation-1",
      on: {
        "click": function($event) {
          return _vm.closeMappingEdit(map)
        }
      }
    }, [_vm._v(_vm._s(_vm.$lang.actions.cancel))])], 1)] : [_c('td', [_vm._v(_vm._s(map.categoryName))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(map.language))]), _vm._v(" "), _c('td', {
      staticClass: "actions px-0"
    }, [_c('v-btn', {
      staticClass: "primary elevation-1",
      on: {
        "click": function($event) {
          return _vm.editMapping(map)
        }
      }
    }, [_vm._v(_vm._s(_vm.$lang.actions.edit))]), _vm._v(" "), _c('v-btn', {
      staticClass: "error ml-0 elevation-1",
      on: {
        "click": function($event) {
          return _vm.deleteMapping(index)
        }
      }
    }, [_vm._v(_vm._s(_vm.$lang.actions.delete))])], 1)]], 2)
  }), 0)])]), _vm._v(" "), _c('v-layout', {
    staticClass: "px-2",
    attrs: {
      "row": "",
      "wrap": "",
      "justify-space-between": ""
    }
  }, [(_vm.isEdit && _vm.createdOn) ? _c('v-text-field', {
    staticClass: "min-w max-w mx-3",
    attrs: {
      "label": _vm.$lang.labels.created,
      "readonly": ""
    },
    model: {
      value: (_vm.createdOn),
      callback: function($$v) {
        _vm.createdOn = $$v
      },
      expression: "createdOn"
    }
  }) : _vm._e(), _vm._v(" "), (_vm.isEdit && _vm.modifiedOn) ? _c('v-text-field', {
    staticClass: "min-w max-w mx-3",
    attrs: {
      "label": _vm.$lang.labels.modified,
      "readonly": ""
    },
    model: {
      value: (_vm.modifiedOn),
      callback: function($$v) {
        _vm.modifiedOn = $$v
      },
      expression: "modifiedOn"
    }
  }) : _vm._e()], 1), _vm._v(" "), _c('v-layout', {
    staticClass: "px-2",
    attrs: {
      "row": "",
      "wrap": "",
      "justify-space-between": "",
      "align-content-center": ""
    }
  }, [_c('v-btn', {
    staticClass: "mx-3",
    attrs: {
      "flat": ""
    },
    on: {
      "click": function($event) {
        return _vm.$router.push({
          name: 'languageMappings'
        })
      }
    }
  }, [_c('v-icon', [_vm._v("keyboard_arrow_left")]), _vm._v("\n          " + _vm._s(_vm.$lang.actions.close) + "\n        ")], 1), _vm._v(" "), _c('v-btn', {
    staticClass: "primary mx-3",
    attrs: {
      "disabled": !_vm.valid
    },
    on: {
      "click": _vm.submit
    }
  }, [_vm._v("\n          " + _vm._s(_vm.isEdit ? _vm.$lang.actions.update : _vm.$lang.actions.create) + "\n        ")])], 1)], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 387 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-card', [(_vm.err) ? _c('v-flex', {
    attrs: {
      "xs12": "",
      "px-4": "",
      "pt-4": ""
    }
  }, [_c('v-alert', {
    attrs: {
      "value": true,
      "type": "error"
    }
  }, [_vm._v(_vm._s(_vm.err))])], 1) : _vm._e(), _vm._v(" "), (_vm.success) ? _c('v-flex', {
    attrs: {
      "xs12": "",
      "pa-4": ""
    }
  }, [_c('v-alert', {
    attrs: {
      "value": true,
      "type": "success"
    }
  }, [_vm._v(_vm._s(_vm.success))])], 1) : _vm._e(), _vm._v(" "), _c('v-card-title', {
    staticClass: "pb-3 px-2 layout row wrap"
  }, [_c('v-btn', {
    staticClass: "primary my-0 mx-3",
    on: {
      "click": function($event) {
        return _vm.$router.push({
          name: 'createCompany'
        })
      }
    }
  }, [_vm._v("\n        " + _vm._s(_vm.$lang.actions.createCompany) + "\n      ")]), _vm._v(" "), _c('v-checkbox', {
    staticClass: "mx-1 mt-0",
    attrs: {
      "color": "primary",
      "label": _vm.$lang.labels.showActive,
      "hide-details": ""
    },
    model: {
      value: (_vm.showActive),
      callback: function($$v) {
        _vm.showActive = $$v
      },
      expression: "showActive"
    }
  }), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('v-text-field', {
    staticClass: "min-w max-w mx-3 pb-2",
    attrs: {
      "append-icon": "search",
      "label": _vm.$lang.labels.search,
      "hide-details": ""
    },
    model: {
      value: (_vm.search),
      callback: function($$v) {
        _vm.search = $$v
      },
      expression: "search"
    }
  })], 1), _vm._v(" "), _c('v-data-table', {
    attrs: {
      "headers": _vm.headers,
      "items": _vm.showActive ? _vm.activeCompanies : _vm.allCompanies,
      "search": _vm.search,
      "loading": _vm.allCompanies.length === 0,
      "rows-per-page-items": [50, 100, 250, 500, {
        text: 'All',
        value: -1
      }]
    },
    scopedSlots: _vm._u([{
      key: "items",
      fn: function(props) {
        return [_c('td', {
          staticClass: "min-w"
        }, [_vm._v(_vm._s(props.item.name))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(props.item.postalCode))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(props.item.id))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(props.item.currency))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(props.item.companyStatus))]), _vm._v(" "), _c('td', {
          staticClass: "min-w-lg"
        }, [_c('v-btn', {
          staticClass: "primary mx-0 elevation-1",
          on: {
            "click": function($event) {
              return _vm.editCompany(props.item)
            }
          }
        }, [_vm._v(_vm._s(_vm.$lang.actions.edit))]), _vm._v(" "), _c('v-btn', {
          staticClass: "primary elevation-1",
          on: {
            "click": function($event) {
              return _vm.changeStatus(props.item)
            }
          }
        }, [_vm._v("\n            " + _vm._s(props.item.companyStatus === 'active' ? _vm.$lang.actions.deactivate : _vm.$lang.actions.activate) + "\n          ")])], 1)]
      }
    }])
  }, [_c('v-progress-linear', {
    attrs: {
      "slot": "progress",
      "height": "6",
      "color": "primary",
      "indeterminate": ""
    },
    slot: "progress"
  }), _vm._v(" "), _vm._v(" "), _c('v-alert', {
    attrs: {
      "slot": "no-results",
      "value": true,
      "type": "warning"
    },
    slot: "no-results"
  }, [_vm._v("\n        Your search for \"" + _vm._s(_vm.search) + "\" found no results.\n      ")])], 1)], 1), _vm._v(" "), (_vm.confirmationModal) ? _c('v-dialog', {
    attrs: {
      "max-width": "500"
    },
    model: {
      value: (_vm.confirmationModal),
      callback: function($$v) {
        _vm.confirmationModal = $$v
      },
      expression: "confirmationModal"
    }
  }, [_c('confirmation-modal', {
    attrs: {
      "data": _vm.confirmationData
    },
    on: {
      "close": function($event) {
        _vm.confirmationModal = false
      },
      "change": function($event) {
        return _vm.deactivate($event)
      }
    }
  })], 1) : _vm._e()], 1)
},staticRenderFns: []}

/***/ }),
/* 388 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-layout', {
    staticStyle: {
      "min-height": "86vh"
    },
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('div', {
    staticClass: "home"
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(63),
      "alt": ""
    }
  })]), _vm._v(" "), _c('v-flex', {
    attrs: {
      "sm12": "",
      "md6": "",
      "pr-1": _vm.$vuetify.breakpoint.mdAndUp,
      "pb-1": _vm.$vuetify.breakpoint.smAndDown
    }
  }, [_c('v-card', {
    staticClass: "fill-height"
  }, [_c('v-radio-group', {
    staticClass: "px-4 pt-4",
    attrs: {
      "mandatory": false,
      "row": ""
    },
    model: {
      value: (_vm.radios),
      callback: function($$v) {
        _vm.radios = $$v
      },
      expression: "radios"
    }
  }, [_c('v-radio', {
    attrs: {
      "color": "primary",
      "label": "Unread",
      "value": "unread"
    }
  }), _vm._v(" "), _c('v-radio', {
    attrs: {
      "color": "primary",
      "label": "Read",
      "value": "read"
    }
  })], 1), _vm._v(" "), _c('v-data-table', {
    attrs: {
      "headers": _vm.headers,
      "items": _vm.announcements,
      "loading": _vm.loading,
      "pagination": _vm.pagination,
      "rows-per-page-items": [50, 100, 250, 500, {
        text: 'All',
        value: -1
      }]
    },
    on: {
      "update:pagination": function($event) {
        _vm.pagination = $event
      }
    },
    scopedSlots: _vm._u([{
      key: "items",
      fn: function(props) {
        return [_c('tr', {
          style: (("cursor: pointer; " + (_vm.subjectData.id === props.item.id ? 'background-color: #E0E0E0' : ''))),
          on: {
            "click": function($event) {
              return _vm.showDetails(props.item)
            }
          }
        }, [_c('td', {
          style: (_vm.subjectData.id === props.item.id ? 'font-weight: 900 !important' : '')
        }, [_vm._v(_vm._s(props.item.subject))]), _vm._v(" "), _c('td', {
          style: (_vm.subjectData.id === props.item.id ? 'font-weight: 900 !important' : '')
        }, [_vm._v(_vm._s(_vm.formatDate(props.item.createdOn)))]), _vm._v(" "), _c('td', {
          staticStyle: {
            "width": "180px"
          }
        }, [_c('v-btn', {
          staticClass: "primary elevation-1 mx-0",
          on: {
            "click": function($event) {
              return _vm.showDetails(props.item)
            }
          }
        }, [_vm._v("\n              show\n            ")])], 1)])]
      }
    }])
  }, [_c('v-progress-linear', {
    attrs: {
      "slot": "progress",
      "height": "6",
      "color": "primary",
      "indeterminate": ""
    },
    slot: "progress"
  })], 1)], 1)], 1), _vm._v(" "), (_vm.announcements && _vm.announcements.length > 0) ? _c('v-flex', {
    attrs: {
      "sm12": "",
      "md6": "",
      "pl-1": _vm.$vuetify.breakpoint.mdAndUp,
      "pt-1": _vm.$vuetify.breakpoint.smAndDown
    }
  }, [_c('v-card', {
    staticClass: "py-3 px-4 fill-height"
  }, [_c('v-layout', {
    staticStyle: {
      "border-bottom": "1px solid #E0E0E0"
    },
    attrs: {
      "row": "",
      "wrap": "",
      "justify-space-between": "",
      "align-center": ""
    }
  }, [_c('h2', [_vm._v(_vm._s(_vm.subjectData.subject || ''))]), _vm._v(" "), _c('div', [_c('span', {
    staticClass: "pr-2"
  }, [_c('small', [_vm._v(_vm._s(_vm.formatDate(_vm.subjectData.createdOn)))])]), _vm._v(" "), _c('v-btn', {
    staticClass: "elevation-0 mx-0",
    attrs: {
      "disabled": _vm.subjectData.isRead,
      "small": "",
      "color": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.markAsRead()
      }
    }
  }, [_vm._v("\n            Mark as read\n          ")])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "pt-4",
    domProps: {
      "innerHTML": _vm._s(_vm.subjectData.message)
    }
  })], 1)], 1) : _vm._e()], 1)
},staticRenderFns: []}

/***/ }),
/* 389 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-card', [(_vm.err) ? _c('v-flex', {
    attrs: {
      "xs12": "",
      "px-4": ""
    }
  }, [_c('v-alert', {
    attrs: {
      "value": true,
      "type": "error"
    }
  }, [_vm._v(_vm._s(_vm.err))])], 1) : _vm._e(), _vm._v(" "), _c('v-card-title', {
    staticClass: "py-3 px-2 layout row wrap"
  }, [_c('v-btn', {
    staticClass: "primary my-0 mx-3",
    on: {
      "click": function($event) {
        return _vm.$router.push({
          name: "printServerCreate"
        })
      }
    }
  }, [_vm._v(_vm._s(_vm.$lang.actions.createPrintServer))]), _vm._v(" "), _c('v-checkbox', {
    staticClass: "mx-1 mt-0",
    attrs: {
      "color": "primary",
      "label": _vm.$lang.labels.showActive,
      "hide-details": ""
    },
    model: {
      value: (_vm.showActive),
      callback: function($$v) {
        _vm.showActive = $$v
      },
      expression: "showActive"
    }
  }), _vm._v(" "), _c('v-spacer'), _vm._v(" "), (!_vm.isLocalAdmin) ? _c('v-autocomplete', {
    staticClass: "min-w max-w mx-3 pb-2",
    attrs: {
      "label": _vm.$lang.actions.selectCompany,
      "items": _vm.mappedCompanies,
      "hide-details": ""
    },
    model: {
      value: (_vm.selectedCompany),
      callback: function($$v) {
        _vm.selectedCompany = $$v
      },
      expression: "selectedCompany"
    }
  }) : _vm._e(), _vm._v(" "), (_vm.show) ? _c('v-text-field', {
    staticClass: "min-w max-w mx-3 pb-2",
    attrs: {
      "append-icon": "search",
      "label": _vm.$lang.labels.search,
      "hide-details": ""
    },
    model: {
      value: (_vm.search),
      callback: function($$v) {
        _vm.search = $$v
      },
      expression: "search"
    }
  }) : _vm._e()], 1), _vm._v(" "), (_vm.show) ? _c('v-data-table', {
    attrs: {
      "headers": _vm.headers,
      "items": _vm.showActive ? _vm.activePrintServers : _vm.allPrintServers,
      "search": _vm.search,
      "loading": _vm.loading,
      "rows-per-page-items": [50, 100, 250, 500, {
        text: 'All',
        value: -1
      }]
    },
    scopedSlots: _vm._u([{
      key: "items",
      fn: function(props) {
        return [_c('td', [_vm._v(_vm._s(props.item.name))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(props.item.fetchRecordsLimit))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(props.item.status))]), _vm._v(" "), _c('td', {
          staticClass: "min-w-lg"
        }, [_c('v-btn', {
          staticClass: "primary mx-0 elevation-1",
          on: {
            "click": function($event) {
              return _vm.$router.push({
                name: 'printServer',
                params: {
                  id: props.item.printServerId
                }
              })
            }
          }
        }, [_vm._v(_vm._s(_vm.$lang.actions.edit))]), _vm._v(" "), _c('v-btn', {
          staticClass: "primary elevation-1",
          on: {
            "click": function($event) {
              return _vm.changeStatus(props.item)
            }
          }
        }, [_vm._v(_vm._s(props.item.status === 'active' ? _vm.$lang.actions.deactivate : _vm.$lang.actions.activate))])], 1)]
      }
    }], null, false, 3335343403)
  }, [_c('v-progress-linear', {
    attrs: {
      "slot": "progress",
      "height": "6",
      "color": "primary",
      "indeterminate": ""
    },
    slot: "progress"
  }), _vm._v(" "), _vm._v(" "), _c('v-alert', {
    attrs: {
      "slot": "no-results",
      "value": true,
      "color": "warning",
      "icon": "warning"
    },
    slot: "no-results"
  }, [_vm._v("\n        Your search for \"" + _vm._s(_vm.search) + "\" found no results.\n      ")])], 1) : _vm._e()], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 390 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-card', [(_vm.err) ? _c('v-flex', {
    attrs: {
      "xs12": "",
      "px-4": "",
      "py-4": ""
    }
  }, [_c('v-alert', {
    attrs: {
      "value": true,
      "type": "error"
    }
  }, [_vm._v(_vm._s(_vm.err))])], 1) : _vm._e(), _vm._v(" "), _c('v-form', {
    model: {
      value: (_vm.valid),
      callback: function($$v) {
        _vm.valid = $$v
      },
      expression: "valid"
    }
  }, [_c('v-layout', {
    staticClass: "pt-3 px-2",
    attrs: {
      "row": "",
      "wrap": "",
      "align-center": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": "",
      "md4": "",
      "lg3": "",
      "px-3": ""
    }
  }, [_c('v-autocomplete', {
    attrs: {
      "label": _vm.$lang.actions.selectCompany,
      "items": _vm.mappedCompanies,
      "loading": _vm.companyLoading,
      "required": "",
      "rules": [function (v) { return !!v || ("" + (_vm.$lang.errors.missingCompany)); }]
    },
    model: {
      value: (_vm.data.companyId),
      callback: function($$v) {
        _vm.$set(_vm.data, "companyId", $$v)
      },
      expression: "data.companyId"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "md8": "",
      "lg9": "",
      "px-3": ""
    }
  }, [_c('v-select', {
    attrs: {
      "label": _vm.$lang.labels.pricingGroups,
      "placeholder": _vm.$lang.placeholders.pricingGroups,
      "multiple": "",
      "clearable": "",
      "items": _vm.mappedGroups,
      "disabled": _vm.mappedGroups.length <= 0,
      "required": "",
      "rules": [_vm.data.pricingGroups.length > 0 || ("" + (_vm.$lang.errors.missingPricingGroups))]
    },
    model: {
      value: (_vm.data.pricingGroups),
      callback: function($$v) {
        _vm.$set(_vm.data, "pricingGroups", $$v)
      },
      expression: "data.pricingGroups"
    }
  })], 1)], 1), _vm._v(" "), _c('v-layout', {
    staticClass: "py-1 px-2",
    attrs: {
      "row": "",
      "wrap": "",
      "align-end": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": "",
      "sm6": "",
      "md4": "",
      "lg3": "",
      "px-3": ""
    }
  }, [_c('v-select', {
    attrs: {
      "items": _vm.years,
      "label": _vm.$lang.actions.selectYear,
      "required": "",
      "rules": [function (v) { return !!v || ("" + (_vm.$lang.errors.missingYear)); }]
    },
    model: {
      value: (_vm.data.year),
      callback: function($$v) {
        _vm.$set(_vm.data, "year", $$v)
      },
      expression: "data.year"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "sm6": "",
      "md4": "",
      "lg3": "",
      "px-3": ""
    }
  }, [_c('v-select', {
    attrs: {
      "clearable": "",
      "items": _vm.months,
      "label": _vm.$lang.actions.selectMonth
    },
    model: {
      value: (_vm.data.month),
      callback: function($$v) {
        _vm.$set(_vm.data, "month", $$v)
      },
      expression: "data.month"
    }
  })], 1)], 1), _vm._v(" "), _c('v-layout', {
    staticClass: "px-3",
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-btn', {
    staticClass: "mb-2 mt-0 mx-2",
    attrs: {
      "color": "primary",
      "disabled": !_vm.valid
    },
    on: {
      "click": function($event) {
        return _vm.fetchInvoicesforCompany()
      }
    }
  }, [_vm._v(_vm._s(_vm.$lang.labels.search))]), _vm._v(" "), _c('v-btn', {
    staticClass: "mb-2 mt-0 mx-2",
    attrs: {
      "color": "primary",
      "loading": _vm.overviewloading
    },
    on: {
      "click": function($event) {
        return _vm.openOverview()
      }
    }
  }, [_vm._v(_vm._s(_vm.$lang.labels.buildOverview))]), _vm._v(" "), _c('v-btn', {
    staticClass: "mb-2 mt-0 mx-2",
    attrs: {
      "color": "primary"
    },
    on: {
      "click": function($event) {
        _vm.showBuildModal = true
      }
    }
  }, [_vm._v(_vm._s(_vm.$lang.labels.generateInvoice))])], 1), _vm._v(" "), _c('v-card-title', {
    staticClass: "pb-2 pt-0 px-0 layout row wrap"
  }, [_c('v-spacer'), _vm._v(" "), (_vm.show) ? _c('v-text-field', {
    staticClass: "min-w max-w mx-4 pb-2",
    attrs: {
      "append-icon": "search",
      "label": _vm.$lang.labels.search,
      "hide-details": ""
    },
    model: {
      value: (_vm.search),
      callback: function($$v) {
        _vm.search = $$v
      },
      expression: "search"
    }
  }) : _vm._e()], 1)], 1), _vm._v(" "), (_vm.show) ? _c('v-data-table', {
    attrs: {
      "headers": _vm.headers,
      "items": _vm.invoices,
      "search": _vm.search,
      "loading": _vm.invoices.length === 0,
      "rows-per-page-items": [50, 100, 250, 500, {
        text: 'All',
        value: -1
      }]
    },
    scopedSlots: _vm._u([{
      key: "items",
      fn: function(props) {
        return [_c('td', {
          staticClass: "text-xs-left"
        }, [_vm._v(_vm._s(props.item.companyName))]), _vm._v(" "), _c('td', {
          staticClass: "text-xs-left"
        }, [_vm._v(_vm._s(props.item.pricingGroupName))]), _vm._v(" "), _c('td', {
          staticClass: "text-xs-right"
        }, [_vm._v(_vm._s(props.item.totalAmount))]), _vm._v(" "), _c('td', {
          staticClass: "text-xs-left"
        }, [_vm._v(_vm._s(_vm.formatDate(props.item.createdOn)))]), _vm._v(" "), _c('td', {
          staticClass: "text-xs-left"
        }, [_c('v-btn', {
          staticClass: "mx-0",
          attrs: {
            "color": "primary"
          },
          on: {
            "click": function($event) {
              return _vm.showDetails(props.item.id)
            }
          }
        }, [_vm._v("\n            " + _vm._s(_vm.$lang.actions.view) + "\n          ")])], 1)]
      }
    }], null, false, 695685986)
  }, [_c('v-progress-linear', {
    attrs: {
      "slot": "progress",
      "height": "6",
      "color": "primary",
      "indeterminate": ""
    },
    slot: "progress"
  }), _vm._v(" "), _vm._v(" "), _c('v-alert', {
    attrs: {
      "slot": "no-results",
      "value": true,
      "color": "warning",
      "icon": "warning"
    },
    slot: "no-results"
  }, [_vm._v("\n        Your search for \"" + _vm._s(_vm.search) + "\" found no results.\n      ")])], 1) : _vm._e()], 1), _vm._v(" "), (_vm.showOverviewModal) ? _c('v-dialog', {
    attrs: {
      "max-width": "992"
    },
    model: {
      value: (_vm.showOverviewModal),
      callback: function($$v) {
        _vm.showOverviewModal = $$v
      },
      expression: "showOverviewModal"
    }
  }, [_c('overview-modal', {
    attrs: {
      "companies": _vm.companies,
      "pricingGroups": _vm.overviewConfig,
      "months": _vm.months,
      "years": _vm.years,
      "selectedMonth": _vm.data.month,
      "selectedYear": _vm.data.year
    },
    on: {
      "close": function($event) {
        _vm.showOverviewModal = false
      }
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.showBuildModal) ? _c('v-dialog', {
    attrs: {
      "max-width": "450"
    },
    model: {
      value: (_vm.showBuildModal),
      callback: function($$v) {
        _vm.showBuildModal = $$v
      },
      expression: "showBuildModal"
    }
  }, [_c('build-modal', {
    attrs: {
      "months": _vm.months,
      "years": _vm.years,
      "selectedMonth": _vm.data.month,
      "selectedYear": _vm.data.year
    },
    on: {
      "close": function($event) {
        _vm.showBuildModal = false
      }
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.detailsModal) ? _c('v-dialog', {
    attrs: {
      "max-width": "992"
    },
    model: {
      value: (_vm.detailsModal),
      callback: function($$v) {
        _vm.detailsModal = $$v
      },
      expression: "detailsModal"
    }
  }, [_c('details-modal', {
    attrs: {
      "invoiceId": _vm.invoiceId
    },
    on: {
      "close": function($event) {
        _vm.detailsModal = false
      }
    }
  })], 1) : _vm._e()], 1)
},staticRenderFns: []}

/***/ }),
/* 391 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-flex', {
    attrs: {
      "xs12": "",
      "lg9": ""
    }
  }, [_c('v-card', {
    staticClass: "py-4"
  }, [(_vm.err) ? _c('v-flex', {
    attrs: {
      "xs12": "",
      "px-4": "",
      "py-2": ""
    }
  }, [_c('v-alert', {
    attrs: {
      "value": true,
      "type": "error"
    }
  }, [_vm._v(_vm._s(_vm.err))])], 1) : _vm._e(), _vm._v(" "), (_vm.success) ? _c('v-flex', {
    attrs: {
      "xs12": "",
      "px-4": "",
      "py-2": ""
    }
  }, [_c('v-alert', {
    attrs: {
      "value": true,
      "type": "success"
    }
  }, [_vm._v(_vm._s(_vm.success))])], 1) : _vm._e(), _vm._v(" "), _c('v-form', {
    model: {
      value: (_vm.valid),
      callback: function($$v) {
        _vm.valid = $$v
      },
      expression: "valid"
    }
  }, [_c('v-layout', {
    staticClass: "px-2",
    attrs: {
      "row": "",
      "wrap": "",
      "justify-space-between": "",
      "align-start": ""
    }
  }, [(!_vm.isLocalAdmin) ? _c('v-flex', {
    attrs: {
      "xs12": "",
      "sm6": "",
      "px-3": ""
    }
  }, [_c('v-autocomplete', {
    attrs: {
      "items": _vm.companies,
      "label": _vm.$lang.actions.selectCompany,
      "item-text": "name",
      "item-value": "id",
      "required": "",
      "readonly": _vm.isEdit,
      "loading": _vm.companyLoading,
      "rules": [function (v) { return !!v || ("" + (_vm.$lang.errors.missingCompany)); }]
    },
    model: {
      value: (_vm.terminal.companyId),
      callback: function($$v) {
        _vm.$set(_vm.terminal, "companyId", $$v)
      },
      expression: "terminal.companyId"
    }
  })], 1) : _vm._e(), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "sm6": "",
      "px-3": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": _vm.$lang.labels.terminalName,
      "required": "",
      "rules": [function (v) { return !!v || 'Required'; }]
    },
    model: {
      value: (_vm.terminal.name),
      callback: function($$v) {
        _vm.$set(_vm.terminal, "name", $$v)
      },
      expression: "terminal.name"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "sm6": "",
      "px-3": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": _vm.$lang.labels.terminalIdentifier
    },
    model: {
      value: (_vm.terminal.terminalIdentifier),
      callback: function($$v) {
        _vm.$set(_vm.terminal, "terminalIdentifier", $$v)
      },
      expression: "terminal.terminalIdentifier"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "sm6": "",
      "px-3": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": _vm.$lang.labels.ipAddress,
      "required": "",
      "rules": [function (v) { return !!v || 'Required'; }]
    },
    model: {
      value: (_vm.terminal.ipAddress),
      callback: function($$v) {
        _vm.$set(_vm.terminal, "ipAddress", $$v)
      },
      expression: "terminal.ipAddress"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "sm6": "",
      "px-3": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": _vm.$lang.labels.portNumber,
      "rules": [function (v) { return _vm.checkPort(v); }, function (v) { return !!v || 'Required'; }],
      "required": ""
    },
    model: {
      value: (_vm.terminal.port),
      callback: function($$v) {
        _vm.$set(_vm.terminal, "port", $$v)
      },
      expression: "terminal.port"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "sm6": "",
      "px-3": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": _vm.$lang.labels.maxRetriesOnErrors,
      "rules": [function (v) { return _vm.checkMaxRetries(v); }, function (v) { return !!v || 'Required'; }],
      "required": ""
    },
    model: {
      value: (_vm.terminal.maxRetriesOnErrors),
      callback: function($$v) {
        _vm.$set(_vm.terminal, "maxRetriesOnErrors", $$v)
      },
      expression: "terminal.maxRetriesOnErrors"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs6": "",
      "px-3": ""
    }
  }, [_c('v-btn', {
    attrs: {
      "disabled": !_vm.hasPublicKeyBE,
      "color": "primary mx-0"
    },
    on: {
      "click": function($event) {
        _vm.isTerminal = true;
        _vm.updatePassword = true
      }
    }
  }, [_vm._v("\n            " + _vm._s(_vm.$lang.labels.updatePassword) + "\n          ")])], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs3": "",
      "px-3": ""
    }
  }, [_c('h3', [_vm._v(_vm._s(_vm.$lang.labels.automaticPrint))]), _vm._v(" "), _c('v-checkbox', {
    attrs: {
      "label": _vm.$lang.labels.merchantPrint,
      "color": "primary",
      "hide-details": ""
    },
    model: {
      value: (_vm.terminal.automaticPrintMerchantReceipt),
      callback: function($$v) {
        _vm.$set(_vm.terminal, "automaticPrintMerchantReceipt", $$v)
      },
      expression: "terminal.automaticPrintMerchantReceipt"
    }
  }), _vm._v(" "), _c('v-checkbox', {
    attrs: {
      "label": _vm.$lang.labels.customerPrint,
      "color": "primary",
      "hide-details": ""
    },
    model: {
      value: (_vm.terminal.automaticPrintCustomerReceipt),
      callback: function($$v) {
        _vm.$set(_vm.terminal, "automaticPrintCustomerReceipt", $$v)
      },
      expression: "terminal.automaticPrintCustomerReceipt"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs3": "",
      "px-3": ""
    }
  }, [_c('h3', [_vm._v(_vm._s(_vm.$lang.labels.switchReceiptType))]), _vm._v(" "), _c('v-radio-group', {
    model: {
      value: (_vm.terminal.switchReceiptType),
      callback: function($$v) {
        _vm.$set(_vm.terminal, "switchReceiptType", $$v)
      },
      expression: "terminal.switchReceiptType"
    }
  }, [_c('v-radio', {
    attrs: {
      "color": "primary",
      "label": _vm.$lang.labels.merchant,
      "value": "merchant"
    }
  }), _vm._v(" "), _c('v-radio', {
    attrs: {
      "color": "primary",
      "label": _vm.$lang.labels.customer,
      "value": "customer"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('v-layout', {
    staticClass: "mt-3 px-2",
    attrs: {
      "row": "",
      "wrap": "",
      "justify-space-between": ""
    }
  }, [(_vm.isEdit && _vm.createdOn) ? _c('v-text-field', {
    staticClass: "min-w max-w mx-3",
    attrs: {
      "label": _vm.$lang.labels.created,
      "readonly": ""
    },
    model: {
      value: (_vm.createdOn),
      callback: function($$v) {
        _vm.createdOn = $$v
      },
      expression: "createdOn"
    }
  }) : _vm._e(), _vm._v(" "), (_vm.isEdit && _vm.modifiedOn) ? _c('v-text-field', {
    staticClass: "min-w max-w mx-3",
    attrs: {
      "label": _vm.$lang.labels.modified,
      "readonly": ""
    },
    model: {
      value: (_vm.modifiedOn),
      callback: function($$v) {
        _vm.modifiedOn = $$v
      },
      expression: "modifiedOn"
    }
  }) : _vm._e()], 1), _vm._v(" "), _c('v-layout', {
    staticClass: "px-2",
    attrs: {
      "row": "",
      "wrap": "",
      "justify-space-between": "",
      "align-content-center": ""
    }
  }, [_c('v-btn', {
    staticClass: "mx-3",
    attrs: {
      "flat": ""
    },
    on: {
      "click": function($event) {
        return _vm.$router.push({
          name: 'paymentTerminals'
        })
      }
    }
  }, [_c('v-icon', [_vm._v("keyboard_arrow_left")]), _vm._v("\n          " + _vm._s(_vm.$lang.actions.close) + "\n        ")], 1), _vm._v(" "), _c('v-btn', {
    staticClass: "primary mx-3",
    attrs: {
      "disabled": !_vm.valid
    },
    on: {
      "click": _vm.submit
    }
  }, [_vm._v("\n          " + _vm._s(_vm.isEdit ? _vm.$lang.actions.update : _vm.$lang.actions.create) + "\n        ")])], 1)], 1), _vm._v(" "), (_vm.updatePassword) ? _c('v-dialog', {
    attrs: {
      "persistent": "",
      "max-width": "500"
    },
    model: {
      value: (_vm.updatePassword),
      callback: function($$v) {
        _vm.updatePassword = $$v
      },
      expression: "updatePassword"
    }
  }, [_c('change-password', {
    attrs: {
      "isTerminal": _vm.isTerminal
    },
    on: {
      "close": function($event) {
        _vm.updatePassword = false;
        _vm.isTerminal = false;
      }
    }
  })], 1) : _vm._e()], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 392 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-card', {
    staticClass: "pt-3"
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": "",
      "align-center": "",
      "justify-space-between": "",
      "pb-3": "",
      "px-3": ""
    }
  }, [_c('div', {
    staticClass: "layout row wrap"
  }, [_c('div', {
    staticClass: "pa-2"
  }, [_c('datetime', {
    staticClass: "datetime-btn primary--text",
    attrs: {
      "phrases": {
        ok: _vm.$lang.actions.ok,
        cancel: _vm.$lang.actions.cancel
      },
      "type": "datetime",
      "placeholder": _vm.$lang.labels.fromDate
    },
    model: {
      value: (_vm.fromDate),
      callback: function($$v) {
        _vm.fromDate = $$v
      },
      expression: "fromDate"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "pa-2"
  }, [_c('datetime', {
    staticClass: "datetime-btn primary--text",
    attrs: {
      "phrases": {
        ok: _vm.$lang.actions.ok,
        cancel: _vm.$lang.actions.cancel
      },
      "type": "datetime",
      "placeholder": _vm.$lang.labels.toDate
    },
    model: {
      value: (_vm.toDate),
      callback: function($$v) {
        _vm.toDate = $$v
      },
      expression: "toDate"
    }
  })], 1), _vm._v(" "), _c('v-btn', {
    staticClass: "primary mx-2 my-2",
    on: {
      "click": function($event) {
        return _vm.showLogs()
      }
    }
  }, [_vm._v(_vm._s(_vm.$lang.actions.showLogs))])], 1), _vm._v(" "), _c('v-text-field', {
    staticClass: "min-w max-w mx-2",
    attrs: {
      "append-icon": "search",
      "label": _vm.$lang.labels.search,
      "hide-details": ""
    },
    model: {
      value: (_vm.search),
      callback: function($$v) {
        _vm.search = $$v
      },
      expression: "search"
    }
  })], 1), _vm._v(" "), (_vm.err) ? _c('v-flex', {
    attrs: {
      "xs12": "",
      "px-4": "",
      "pb-3": ""
    }
  }, [_c('v-alert', {
    staticClass: "my-0",
    attrs: {
      "type": "error",
      "value": true
    }
  }, [_vm._v(_vm._s(_vm.err))])], 1) : _vm._e(), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "fade"
    }
  }, [(_vm.show) ? _c('div', [_c('v-data-table', {
    attrs: {
      "headers": _vm.headers,
      "items": _vm.logs,
      "search": _vm.search,
      "loading": _vm.loading,
      "rows-per-page-items": [50, 100, 250, 500, {
        text: 'All',
        value: -1
      }]
    },
    scopedSlots: _vm._u([{
      key: "items",
      fn: function(props) {
        return [_c('td', {
          staticClass: "text-xs-left"
        }, [_vm._v(_vm._s(_vm.formatDate(props.item.createdOn)))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(props.item.errorMessage))]), _vm._v(" "), _c('td', {
          staticClass: "text-xs-left"
        }, [_c('v-btn', {
          staticClass: "primary mx-0",
          on: {
            "click": function($event) {
              return _vm.showModal(props.item)
            }
          }
        }, [_vm._v(_vm._s(_vm.$lang.actions.view))])], 1)]
      }
    }], null, false, 3518210434)
  }, [_c('v-progress-linear', {
    attrs: {
      "slot": "progress",
      "height": "6",
      "color": "primary",
      "indeterminate": ""
    },
    slot: "progress"
  }), _vm._v(" "), _vm._v(" "), _c('v-alert', {
    attrs: {
      "slot": "no-results",
      "value": true,
      "color": "warning",
      "icon": "warning"
    },
    slot: "no-results"
  }, [_vm._v("\n            Your search for \"" + _vm._s(_vm.search) + "\" found no results.\n          ")])], 1)], 1) : _vm._e()])], 1), _vm._v(" "), (_vm.viewLogModal) ? _c('v-dialog', {
    attrs: {
      "max-width": "700"
    },
    model: {
      value: (_vm.viewLogModal),
      callback: function($$v) {
        _vm.viewLogModal = $$v
      },
      expression: "viewLogModal"
    }
  }, [_c('view-log-modal', {
    attrs: {
      "log": _vm.log
    },
    on: {
      "close": function($event) {
        _vm.viewLogModal = false
      }
    }
  })], 1) : _vm._e()], 1)
},staticRenderFns: []}

/***/ }),
/* 393 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-card', {
    staticClass: "pa-4"
  }, [_c('v-textarea', {
    attrs: {
      "label": _vm.$lang.labels.url,
      "readonly": "",
      "auto-grow": "",
      "rows": "1"
    },
    model: {
      value: (_vm.log.url),
      callback: function($$v) {
        _vm.$set(_vm.log, "url", $$v)
      },
      expression: "log.url"
    }
  }), _vm._v(" "), _c('v-textarea', {
    attrs: {
      "label": _vm.$lang.labels.errorMessage,
      "readonly": "",
      "auto-grow": "",
      "rows": "1"
    },
    model: {
      value: (_vm.log.errorMessage),
      callback: function($$v) {
        _vm.$set(_vm.log, "errorMessage", $$v)
      },
      expression: "log.errorMessage"
    }
  }), _vm._v(" "), _c('v-textarea', {
    attrs: {
      "label": _vm.$lang.labels.data,
      "readonly": "",
      "auto-grow": "",
      "rows": "1"
    },
    model: {
      value: (_vm.log.data),
      callback: function($$v) {
        _vm.$set(_vm.log, "data", $$v)
      },
      expression: "log.data"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "mt-3"
  }, [_vm._v(_vm._s(_vm.$lang.labels.statusCode) + ": " + _vm._s(_vm.log.statusCode) + " ")]), _vm._v(" "), _c('p', {
    staticClass: "mt-3"
  }, [_vm._v(_vm._s(_vm.$lang.labels.created) + ": " + _vm._s(_vm.createdOn) + " ")]), _vm._v(" "), _c('v-layout', [_c('v-btn', {
    staticClass: "mx-0",
    attrs: {
      "flat": ""
    },
    on: {
      "click": function($event) {
        return _vm.$emit('close')
      }
    }
  }, [_c('v-icon', [_vm._v("keyboard_arrow_left")]), _vm._v("\n        " + _vm._s(_vm.$lang.actions.close) + "\n      ")], 1)], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 394 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-card', [(_vm.err) ? _c('v-flex', {
    attrs: {
      "xs12": "",
      "px-4": ""
    }
  }, [_c('v-alert', {
    attrs: {
      "value": true,
      "type": "error"
    }
  }, [_vm._v(_vm._s(_vm.err))])], 1) : _vm._e(), _vm._v(" "), _c('v-card-title', {
    staticClass: "py-3 px-2 layout row wrap"
  }, [_c('v-btn', {
    staticClass: "primary my-0 mx-3",
    on: {
      "click": function($event) {
        return _vm.$router.push({
          name: "printerCreate"
        })
      }
    }
  }, [_vm._v(_vm._s(_vm.$lang.actions.createPrinter))]), _vm._v(" "), _c('v-checkbox', {
    staticClass: "mx-1 mt-0",
    attrs: {
      "color": "primary",
      "label": _vm.$lang.labels.showActive,
      "hide-details": ""
    },
    model: {
      value: (_vm.showActive),
      callback: function($$v) {
        _vm.showActive = $$v
      },
      expression: "showActive"
    }
  }), _vm._v(" "), _c('v-spacer'), _vm._v(" "), (!_vm.isLocalAdmin) ? _c('v-autocomplete', {
    staticClass: "min-w max-w mx-3 pb-2",
    attrs: {
      "label": _vm.$lang.actions.selectCompany,
      "items": _vm.mappedCompanies,
      "hide-details": ""
    },
    model: {
      value: (_vm.selectedCompany),
      callback: function($$v) {
        _vm.selectedCompany = $$v
      },
      expression: "selectedCompany"
    }
  }) : _vm._e(), _vm._v(" "), (_vm.show) ? _c('v-text-field', {
    staticClass: "min-w max-w mx-3 pb-2",
    attrs: {
      "append-icon": "search",
      "label": _vm.$lang.labels.search,
      "hide-details": ""
    },
    model: {
      value: (_vm.search),
      callback: function($$v) {
        _vm.search = $$v
      },
      expression: "search"
    }
  }) : _vm._e()], 1), _vm._v(" "), (_vm.show) ? _c('v-data-table', {
    attrs: {
      "headers": _vm.headers,
      "items": _vm.showActive ? _vm.activePrinters : _vm.allPrinters,
      "search": _vm.search,
      "loading": _vm.loading,
      "rows-per-page-items": [50, 100, 250, 500, {
        text: 'All',
        value: -1
      }]
    },
    scopedSlots: _vm._u([{
      key: "items",
      fn: function(props) {
        return [_c('td', [_vm._v(_vm._s(props.item.name))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(props.item.id))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(props.item.manufacturer))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(props.item.model))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(props.item.printerStatus))]), _vm._v(" "), _c('td', {
          staticClass: "min-w-lg"
        }, [_c('v-btn', {
          staticClass: "primary mx-0 elevation-1",
          on: {
            "click": function($event) {
              return _vm.$router.push({
                name: 'printer',
                params: {
                  id: props.item.id
                }
              })
            }
          }
        }, [_vm._v(_vm._s(_vm.$lang.actions.edit))]), _vm._v(" "), _c('v-btn', {
          staticClass: "primary elevation-1",
          on: {
            "click": function($event) {
              return _vm.changeStatus(props.item)
            }
          }
        }, [_vm._v(_vm._s(props.item.printerStatus === 'active' ? _vm.$lang.actions.deactivate : _vm.$lang.actions.activate))])], 1)]
      }
    }], null, false, 829921007)
  }, [_c('v-progress-linear', {
    attrs: {
      "slot": "progress",
      "height": "6",
      "color": "primary",
      "indeterminate": ""
    },
    slot: "progress"
  }), _vm._v(" "), _vm._v(" "), _c('v-alert', {
    attrs: {
      "slot": "no-results",
      "value": true,
      "color": "warning",
      "icon": "warning"
    },
    slot: "no-results"
  }, [_vm._v("\n        Your search for \"" + _vm._s(_vm.search) + "\" found no results.\n      ")])], 1) : _vm._e()], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 395 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-card', [(_vm.err) ? _c('v-flex', {
    attrs: {
      "xs12": "",
      "px-4": ""
    }
  }, [_c('v-alert', {
    attrs: {
      "value": true,
      "type": "error"
    }
  }, [_vm._v(_vm._s(_vm.err))])], 1) : _vm._e(), _vm._v(" "), _c('v-card-title', {
    staticClass: "py-3 px-2 layout row wrap"
  }, [_c('v-btn', {
    staticClass: "primary my-0 mx-3",
    on: {
      "click": function($event) {
        return _vm.$router.push({
          name: "paymentTerminalCreate"
        })
      }
    }
  }, [_vm._v(_vm._s(_vm.$lang.actions.paymentTerminalCreate))]), _vm._v(" "), _c('v-checkbox', {
    staticClass: "mx-1 mt-0",
    attrs: {
      "color": "primary",
      "label": _vm.$lang.labels.showActive,
      "hide-details": ""
    },
    model: {
      value: (_vm.showActive),
      callback: function($$v) {
        _vm.showActive = $$v
      },
      expression: "showActive"
    }
  }), _vm._v(" "), _c('v-spacer'), _vm._v(" "), (!_vm.isLocalAdmin) ? _c('v-autocomplete', {
    staticClass: "min-w max-w mx-3 pb-2",
    attrs: {
      "label": _vm.$lang.actions.selectCompany,
      "items": _vm.mappedCompanies,
      "hide-details": ""
    },
    model: {
      value: (_vm.selectedCompany),
      callback: function($$v) {
        _vm.selectedCompany = $$v
      },
      expression: "selectedCompany"
    }
  }) : _vm._e(), _vm._v(" "), (_vm.show) ? _c('v-text-field', {
    staticClass: "min-w max-w mx-3 pb-2",
    attrs: {
      "append-icon": "search",
      "label": _vm.$lang.labels.search,
      "hide-details": ""
    },
    model: {
      value: (_vm.search),
      callback: function($$v) {
        _vm.search = $$v
      },
      expression: "search"
    }
  }) : _vm._e()], 1), _vm._v(" "), (_vm.show) ? _c('v-data-table', {
    attrs: {
      "headers": _vm.headers,
      "items": _vm.showActive ? _vm.activeTerminals : _vm.allTerminals,
      "search": _vm.search,
      "loading": _vm.loading,
      "rows-per-page-items": [50, 100, 250, 500, {
        text: 'All',
        value: -1
      }]
    },
    scopedSlots: _vm._u([{
      key: "items",
      fn: function(props) {
        return [_c('td', [_vm._v(_vm._s(props.item.name))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(props.item.status))]), _vm._v(" "), _c('td', {
          staticClass: "min-w-lg"
        }, [_c('v-btn', {
          staticClass: "primary mx-0 elevation-1",
          on: {
            "click": function($event) {
              return _vm.goToTerminal(props.item)
            }
          }
        }, [_vm._v(_vm._s(_vm.$lang.actions.edit))]), _vm._v(" "), _c('v-btn', {
          staticClass: "primary elevation-1",
          on: {
            "click": function($event) {
              return _vm.changeStatus(props.item)
            }
          }
        }, [_vm._v(_vm._s(props.item.status === 'active' ? _vm.$lang.actions.deactivate : _vm.$lang.actions.activate))])], 1)]
      }
    }], null, false, 2645678758)
  }, [_c('v-progress-linear', {
    attrs: {
      "slot": "progress",
      "height": "6",
      "color": "primary",
      "indeterminate": ""
    },
    slot: "progress"
  }), _vm._v(" "), _vm._v(" "), _c('v-alert', {
    attrs: {
      "slot": "no-results",
      "value": true,
      "color": "warning",
      "icon": "warning"
    },
    slot: "no-results"
  }, [_vm._v("\n        Your search for \"" + _vm._s(_vm.search) + "\" found no results.\n      ")])], 1) : _vm._e()], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 396 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('router-view', {
    attrs: {
      "companies": _vm.companies
    }
  })
},staticRenderFns: []}

/***/ }),
/* 397 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-flex', {
    attrs: {
      "xs12": "",
      "sm10": "",
      "md8": "",
      "lg6": ""
    }
  }, [_c('v-card', {
    staticClass: "pa-4"
  }, [(_vm.err) ? _c('v-flex', {
    attrs: {
      "xs12": "",
      "pb-3": ""
    }
  }, [_c('v-alert', {
    attrs: {
      "value": true,
      "type": "error"
    }
  }, [_vm._v(_vm._s(_vm.err))])], 1) : _vm._e(), _vm._v(" "), (_vm.success) ? _c('v-flex', {
    attrs: {
      "xs12": "",
      "pb-3": ""
    }
  }, [_c('v-alert', {
    attrs: {
      "value": true,
      "type": "success"
    }
  }, [_vm._v(_vm._s(_vm.success))])], 1) : _vm._e(), _vm._v(" "), _c('v-form', {
    model: {
      value: (_vm.valid),
      callback: function($$v) {
        _vm.valid = $$v
      },
      expression: "valid"
    }
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": "",
      "justify-space-between": "",
      "align-center": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [(!_vm.isLocalAdmin) ? _c('v-autocomplete', {
    attrs: {
      "items": _vm.companies,
      "label": _vm.$lang.actions.selectCompany,
      "item-text": "name",
      "item-value": "id",
      "required": "",
      "readonly": _vm.isEdit,
      "loading": _vm.companyLoading,
      "rules": [function (v) { return !!v || ("" + (_vm.$lang.errors.missingCompany)); }]
    },
    model: {
      value: (_vm.printServer.companyId),
      callback: function($$v) {
        _vm.$set(_vm.printServer, "companyId", $$v)
      },
      expression: "printServer.companyId"
    }
  }) : _vm._e()], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": _vm.$lang.labels.printServerName,
      "required": "",
      "rules": [function (v) { return !!v || ("" + (_vm.$lang.errors.missingPrintServerName)); }]
    },
    model: {
      value: (_vm.printServer.name),
      callback: function($$v) {
        _vm.$set(_vm.printServer, "name", $$v)
      },
      expression: "printServer.name"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-autocomplete', {
    attrs: {
      "chips": "",
      "deletable-chips": "",
      "multiple": "",
      "items": _vm.mappedPrinters,
      "label": _vm.$lang.actions.selectPrinters,
      "required": "",
      "disabled": _vm.mappedPrinters.length === 0,
      "loading": _vm.printersLoading,
      "rules": [function () { return _vm.printServer.printers.length > 0 || ("" + (_vm.$lang.errors.missingPrinters)); }]
    },
    model: {
      value: (_vm.printServer.printers),
      callback: function($$v) {
        _vm.$set(_vm.printServer, "printers", $$v)
      },
      expression: "printServer.printers"
    }
  })], 1), _vm._v(" "), (_vm.isEdit) ? _c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-textarea', {
    attrs: {
      "id": "key",
      "label": _vm.$lang.labels.key,
      "auto-grow": "",
      "rows": "1",
      "readonly": _vm.isEdit
    },
    model: {
      value: (_vm.printServer.printServerKey),
      callback: function($$v) {
        _vm.$set(_vm.printServer, "printServerKey", $$v)
      },
      expression: "printServer.printServerKey"
    }
  })], 1) : _vm._e(), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": _vm.$lang.labels.records,
      "type": "number",
      "min": "1",
      "max": "128"
    },
    model: {
      value: (_vm.printServer.fetchRecordsLimit),
      callback: function($$v) {
        _vm.$set(_vm.printServer, "fetchRecordsLimit", _vm._n($$v))
      },
      expression: "printServer.fetchRecordsLimit"
    }
  })], 1)], 1), _vm._v(" "), _c('v-layout', {
    staticClass: "mt-3",
    attrs: {
      "row": "",
      "wrap": "",
      "justify-space-between": "",
      "align-content-center": ""
    }
  }, [_c('v-btn', {
    staticClass: "ml-0",
    attrs: {
      "flat": ""
    },
    on: {
      "click": function($event) {
        return _vm.$router.push({
          name: 'printServers'
        })
      }
    }
  }, [_c('v-icon', [_vm._v("keyboard_arrow_left")]), _vm._v("\n          " + _vm._s(_vm.$lang.actions.close) + "\n        ")], 1), _vm._v(" "), _c('div', [(_vm.isEdit) ? _c('v-btn', {
    staticClass: "primary",
    on: {
      "click": _vm.copyKey
    }
  }, [_vm._v("\n            " + _vm._s(_vm.$lang.actions.copyKey) + "\n          ")]) : _vm._e(), _vm._v(" "), _c('v-btn', {
    staticClass: "primary mx-0",
    attrs: {
      "disabled": !_vm.valid
    },
    on: {
      "click": _vm.submit
    }
  }, [_vm._v("\n            " + _vm._s(_vm.isEdit ? _vm.$lang.actions.update : _vm.$lang.actions.create) + "\n          ")])], 1)], 1)], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 398 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-card', [(_vm.err) ? _c('v-flex', {
    attrs: {
      "xs12": "",
      "px-4": "",
      "pt-4": ""
    }
  }, [_c('v-alert', {
    attrs: {
      "value": true,
      "type": "error"
    }
  }, [_vm._v(_vm._s(_vm.err))])], 1) : _vm._e(), _vm._v(" "), _c('v-card-title', {
    staticClass: "pb-3 px-2 layout row wrap"
  }, [_c('v-btn', {
    staticClass: "primary my-0 mx-3",
    on: {
      "click": function($event) {
        return _vm.$router.push({
          name: "tableCategoryCreate"
        })
      }
    }
  }, [_vm._v("Create New Table Category")]), _vm._v(" "), _c('v-checkbox', {
    staticClass: "mx-1 mt-0",
    attrs: {
      "color": "primary",
      "label": _vm.$lang.labels.showActive,
      "hide-details": ""
    },
    model: {
      value: (_vm.showActive),
      callback: function($$v) {
        _vm.showActive = $$v
      },
      expression: "showActive"
    }
  }), _vm._v(" "), _c('v-spacer'), _vm._v(" "), (!_vm.isLocalAdmin) ? _c('v-autocomplete', {
    staticClass: "min-w max-w mx-3 pb-2",
    attrs: {
      "label": _vm.$lang.actions.selectCompany,
      "items": _vm.mappedCompanies,
      "loading": _vm.companyLoading,
      "hide-details": ""
    },
    model: {
      value: (_vm.selectedCompany),
      callback: function($$v) {
        _vm.selectedCompany = $$v
      },
      expression: "selectedCompany"
    }
  }) : _vm._e(), _vm._v(" "), (_vm.show) ? _c('v-text-field', {
    staticClass: "min-w max-w mx-3 pb-2",
    attrs: {
      "append-icon": "search",
      "label": _vm.$lang.labels.search,
      "hide-details": ""
    },
    model: {
      value: (_vm.search),
      callback: function($$v) {
        _vm.search = $$v
      },
      expression: "search"
    }
  }) : _vm._e()], 1), _vm._v(" "), (_vm.show) ? _c('v-data-table', {
    attrs: {
      "headers": _vm.headers,
      "items": _vm.showActive ? _vm.activeTableCategories : _vm.allTableCategories,
      "search": _vm.search,
      "loading": _vm.loading,
      "rows-per-page-items": [50, 100, 250, 500, {
        text: 'All',
        value: -1
      }]
    },
    scopedSlots: _vm._u([{
      key: "items",
      fn: function(props) {
        return [_c('td', [_vm._v(_vm._s(props.item.name[_vm.language]))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(props.item.sequenceNumber))]), _vm._v(" "), _c('td', {
          staticClass: "text-xs-left"
        }, [_vm._v(_vm._s(props.item.status))]), _vm._v(" "), _c('td', {
          staticClass: "text-xs-left min-w-lg"
        }, [_c('v-btn', {
          staticClass: "primary mx-0 elevation-1",
          on: {
            "click": function($event) {
              return _vm.$router.push({
                name: 'tableCategoryUpdate',
                params: {
                  id: props.item.id
                }
              })
            }
          }
        }, [_vm._v(_vm._s(_vm.$lang.actions.edit))]), _vm._v(" "), _c('v-btn', {
          staticClass: "primary elevation-1",
          on: {
            "click": function($event) {
              return _vm.changeStatus(props.item)
            }
          }
        }, [_vm._v(_vm._s(props.item.status === 'active' ? _vm.$lang.actions.deactivate : _vm.$lang.actions.activate))])], 1)]
      }
    }], null, false, 3300775757)
  }, [_c('v-progress-linear', {
    attrs: {
      "slot": "progress",
      "height": "6",
      "color": "primary",
      "indeterminate": ""
    },
    slot: "progress"
  }), _vm._v(" "), _vm._v(" "), _c('v-alert', {
    attrs: {
      "slot": "no-results",
      "value": true,
      "color": "warning",
      "icon": "warning"
    },
    slot: "no-results"
  }, [_vm._v("\n        Your search for \"" + _vm._s(_vm.search) + "\" found no results.\n      ")])], 1) : _vm._e()], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 399 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.show) ? _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": "",
      "justify-center": "",
      "pa-4": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": "",
      "lg8": ""
    }
  }, [(_vm.err) ? _c('v-alert', {
    staticClass: "err",
    attrs: {
      "color": "error",
      "value": true,
      "icon": "warning",
      "type": "error"
    }
  }, [_vm._v("\n      " + _vm._s(_vm.err) + "\n    ")]) : _vm._e(), _vm._v(" "), _c('v-card', {
    staticClass: "mb-4",
    attrs: {
      "flat": ""
    }
  }, [_c('v-stepper', {
    model: {
      value: (_vm.e1),
      callback: function($$v) {
        _vm.e1 = $$v
      },
      expression: "e1"
    }
  }, [_c('v-stepper-header', [_c('v-stepper-step', {
    attrs: {
      "complete": _vm.e1 > 1,
      "step": "1"
    }
  }, [_vm._v(_vm._s(_vm.$lang.header.companyInfo))]), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('v-stepper-step', {
    attrs: {
      "complete": _vm.e1 > 2,
      "step": "2"
    }
  }, [_vm._v(_vm._s(_vm.$lang.header.companySettings))]), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('v-stepper-step', {
    attrs: {
      "step": "3"
    }
  }, [_vm._v(_vm._s(_vm.$lang.header.account))])], 1), _vm._v(" "), _c('v-stepper-items', [_c('v-stepper-content', {
    attrs: {
      "step": "1"
    }
  }, [_c('v-card', {
    staticClass: "mb-5",
    attrs: {
      "flat": ""
    }
  }, [_c('v-form', {
    model: {
      value: (_vm.valid1),
      callback: function($$v) {
        _vm.valid1 = $$v
      },
      expression: "valid1"
    }
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": "",
      "justify-space-between": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('h2', {
    staticClass: "px-3 pb-3"
  }, [_vm._v("\n                      " + _vm._s(_vm.$lang.header.companyGeneralData) + "\n                    ")])]), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "sm6": "",
      "md4": "",
      "px-3": ""
    }
  }, [_c('v-text-field', {
    staticClass: "required",
    attrs: {
      "label": _vm.$lang.labels.name,
      "placeholder": _vm.$lang.placeholders.companyName,
      "rules": [function (v) { return !!v || ("" + (_vm.$lang.errors.missingCompanyName)); }],
      "type": "text",
      "id": "name",
      "required": "",
      "hint": _vm.company.name.length > 12 ? 'Name will be shortened on webshop in mobile view' : '',
      "persistent-hint": ""
    },
    model: {
      value: (_vm.company.name),
      callback: function($$v) {
        _vm.$set(_vm.company, "name", $$v)
      },
      expression: "company.name"
    }
  }), _vm._v(" "), _c('v-text-field', {
    staticClass: "required",
    attrs: {
      "label": _vm.$lang.labels.email,
      "placeholder": _vm.$lang.placeholders.companyEmail,
      "type": "email",
      "id": "email",
      "required": "",
      "rules": _vm.emailRules
    },
    model: {
      value: (_vm.company.email),
      callback: function($$v) {
        _vm.$set(_vm.company, "email", $$v)
      },
      expression: "company.email"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "sm6": "",
      "md4": "",
      "px-3": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": _vm.$lang.labels.registrationNumber,
      "type": "text",
      "id": "registrationNumber"
    },
    model: {
      value: (_vm.company.registrationNumber),
      callback: function($$v) {
        _vm.$set(_vm.company, "registrationNumber", $$v)
      },
      expression: "company.registrationNumber"
    }
  }), _vm._v(" "), _c('v-text-field', {
    staticClass: "required",
    attrs: {
      "label": _vm.$lang.labels.phone,
      "placeholder": _vm.$lang.placeholders.phone,
      "rules": [function (v) { return !!v || ("" + (_vm.$lang.errors.missingCompanyPhone)); }],
      "required": "",
      "type": "text",
      "id": "phone"
    },
    model: {
      value: (_vm.company.phone),
      callback: function($$v) {
        _vm.$set(_vm.company, "phone", $$v)
      },
      expression: "company.phone"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "sm6": "",
      "md4": "",
      "px-3": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": _vm.$lang.labels.registrationLocation,
      "type": "text",
      "id": "registrationLocation"
    },
    model: {
      value: (_vm.company.registrationLocation),
      callback: function($$v) {
        _vm.$set(_vm.company, "registrationLocation", $$v)
      },
      expression: "company.registrationLocation"
    }
  }), _vm._v(" "), _c('v-select', {
    staticClass: "required",
    attrs: {
      "rules": [_vm.company.cuisines.length !== 0 || ("" + (_vm.$lang.errors.missingCuisines))],
      "required": "",
      "multiple": "",
      "small-chips": "",
      "deletable-chips": "",
      "items": _vm.cuisines,
      "label": _vm.$lang.labels.cuisines
    },
    model: {
      value: (_vm.company.cuisines),
      callback: function($$v) {
        _vm.$set(_vm.company, "cuisines", $$v)
      },
      expression: "company.cuisines"
    }
  })], 1)], 1), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": "",
      "justify-space-between": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('h2', {
    staticClass: "px-3 pb-3"
  }, [_vm._v("\n                      " + _vm._s(_vm.$lang.header.companyAddress) + "\n                    ")])]), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "sm6": "",
      "px-3": ""
    }
  }, [_c('v-select', {
    staticClass: "required",
    attrs: {
      "label": _vm.$lang.labels.country,
      "placeholder": _vm.$lang.placeholders.companyCountry,
      "rules": [function (v) { return !!v || ("" + (_vm.$lang.errors.missingCompanyCountry)); }],
      "items": _vm.countries,
      "type": "text",
      "id": "country",
      "required": ""
    },
    model: {
      value: (_vm.company.address.country),
      callback: function($$v) {
        _vm.$set(_vm.company.address, "country", $$v)
      },
      expression: "company.address.country"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "sm6": "",
      "px-3": ""
    }
  }, [_c('v-btn', {
    staticClass: "primary mx-0 mb-4",
    attrs: {
      "block": "",
      "disabled": _vm.company.address.country === ''
    },
    on: {
      "click": function($event) {
        _vm.addressDialog = true
      }
    }
  }, [_vm._v(_vm._s(_vm.$lang.labels.addressLookup) + "\n                    ")])], 1), _vm._v(" "), (_vm.company.address.latitude && _vm.company.address.longitude) ? _c('v-flex', {
    attrs: {
      "xs12": "",
      "px-3": ""
    }
  }, [_c('div', {
    staticClass: "rest-desc text-xs-left"
  }, [_c('h3', [_vm._v(_vm._s(_vm.$lang.labels.selectedAddress) + ":")]), _vm._v(" "), _c('p', {
    staticClass: "mb-0"
  }, [_vm._v("\n                        " + _vm._s(_vm.generateAddress([
    _vm.company.address.line1,
    _vm.company.address.line2,
    _vm.company.address.line3,
    _vm.company.address.line4 ])))]), _vm._v(" "), _c('p', {
    staticClass: "mb-0"
  }, [_vm._v("\n                        " + _vm._s(_vm.company.address.locality ? _vm.company.address.locality + ', ' : '') + "\n                        " + _vm._s(_vm.company.address.country === 'UK' ? _vm.company.address.townCity : _vm.company.address.postalCode) + ",\n                        " + _vm._s(_vm.company.address.country === 'UK' ? _vm.company.address.postalCode : _vm.company.address.townCity) + "\n                      ")])])]) : _vm._e()], 1)], 1)], 1), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": "",
      "justify-space-between": ""
    }
  }, [_c('v-btn', {
    attrs: {
      "flat": "",
      "to": {
        name: 'logIn'
      }
    }
  }, [_vm._v(_vm._s(_vm.$lang.actions.cancel))]), _vm._v(" "), _c('v-btn', {
    attrs: {
      "disabled": !_vm.valid1 || !_vm.addressSet,
      "color": "primary"
    },
    on: {
      "click": function($event) {
        _vm.e1 = 2
      }
    }
  }, [_vm._v("\n                " + _vm._s(_vm.$lang.actions.next) + "\n              ")])], 1)], 1), _vm._v(" "), _c('v-stepper-content', {
    attrs: {
      "step": "2"
    }
  }, [_c('v-card', {
    staticClass: "mb-5",
    attrs: {
      "flat": ""
    }
  }, [_c('v-form', {
    model: {
      value: (_vm.valid2),
      callback: function($$v) {
        _vm.valid2 = $$v
      },
      expression: "valid2"
    }
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": "",
      "justify-space-between": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('h2', {
    staticClass: "px-3 pb-3"
  }, [_vm._v("\n                      " + _vm._s(_vm.$lang.header.companySettings) + "\n                    ")])]), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "sm6": "",
      "px-3": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": "",
      "sm6": ""
    }
  }, [_c('v-checkbox', {
    staticClass: "option",
    attrs: {
      "hide-details": "",
      "color": "primary",
      "label": _vm.$lang.labels.dailyOrdersCounterEnabled
    },
    model: {
      value: (_vm.company.dailyOrdersCounterEnabled),
      callback: function($$v) {
        _vm.$set(_vm.company, "dailyOrdersCounterEnabled", $$v)
      },
      expression: "company.dailyOrdersCounterEnabled"
    }
  })], 1)], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "px-3": "",
      "pt-4": ""
    }
  }, [_c('v-autocomplete', {
    staticClass: "required",
    attrs: {
      "label": _vm.$lang.labels.paymentTypes,
      "placeholder": _vm.$lang.placeholders.paymentTypes,
      "multiple": "",
      "chips": "",
      "deletable-chips": "",
      "items": _vm.payments,
      "required": "",
      "rules": [_vm.company.paymentTypes.length > 0 || ("" + (_vm.$lang.errors.missingPayments))]
    },
    model: {
      value: (_vm.company.paymentTypes),
      callback: function($$v) {
        _vm.$set(_vm.company, "paymentTypes", $$v)
      },
      expression: "company.paymentTypes"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "px-3": ""
    }
  }, [_c('v-btn', {
    staticClass: "primary mx-0",
    attrs: {
      "disabled": _vm.editingHours
    },
    on: {
      "click": _vm.addHours
    }
  }, [_vm._v("\n                      " + _vm._s(_vm.$lang.actions.openingHours) + "\n                    ")]), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "fade"
    }
  }, [_c('div', {
    staticClass: "v-table__overflow custom-table"
  }, [_c('table', {
    staticClass: "v-datatable v-table theme--light"
  }, [(_vm.openingTimes.length !== 0) ? _c('thead', [_c('tr', [_c('td', {
    staticClass: "move-row"
  }), _vm._v(" "), _c('th', {
    staticClass: "text-xs-left"
  }, [_c('div', {
    staticClass: "th-adj"
  }, [_vm._v(_vm._s(_vm.$lang.header.day)), _c('span', {
    staticClass: "error--text"
  }, [_vm._v("*")])])]), _vm._v(" "), _c('th', {
    staticClass: "text-xs-left"
  }, [_c('div', {
    staticClass: "th-adj"
  }, [_vm._v(_vm._s(_vm.$lang.header.start)), _c('span', {
    staticClass: "error--text"
  }, [_vm._v("*")])])]), _vm._v(" "), _c('th', {
    staticClass: "text-xs-left"
  }, [_c('div', {
    staticClass: "th-adj"
  }, [_vm._v(_vm._s(_vm.$lang.header.end)), _c('span', {
    staticClass: "error--text"
  }, [_vm._v("*")])])])])]) : _vm._e(), _vm._v(" "), _c('tbody', _vm._l((_vm.openingTimes), function(time, index) {
    return _c('tr', {
      key: index
    }, [(time.isEdit) ? [_c('td', {
      staticClass: "move-row"
    }), _vm._v(" "), _c('td', [_c('v-select', {
      staticClass: "min-w",
      attrs: {
        "items": _vm.days
      },
      model: {
        value: (_vm.tempOpening.day),
        callback: function($$v) {
          _vm.$set(_vm.tempOpening, "day", $$v)
        },
        expression: "tempOpening.day"
      }
    })], 1), _vm._v(" "), _c('td', [_c('v-text-field', {
      staticClass: "required",
      attrs: {
        "type": "text",
        "mask": "##:##",
        "placeholder": "HH:mm",
        "required": "",
        "rules": _vm.timeRule
      },
      model: {
        value: (_vm.tempOpening.start),
        callback: function($$v) {
          _vm.$set(_vm.tempOpening, "start", $$v)
        },
        expression: "tempOpening.start"
      }
    })], 1), _vm._v(" "), _c('td', [_c('v-text-field', {
      staticClass: "required",
      attrs: {
        "type": "text",
        "mask": "##:##",
        "placeholder": "HH:mm",
        "required": "",
        "rules": _vm.timeRule
      },
      model: {
        value: (_vm.tempOpening.end),
        callback: function($$v) {
          _vm.$set(_vm.tempOpening, "end", $$v)
        },
        expression: "tempOpening.end"
      }
    })], 1), _vm._v(" "), _c('td', {
      staticClass: "px-0",
      staticStyle: {
        "min-width": "314px"
      }
    }, [_c('v-btn', {
      staticClass: "primary elevation-1 mx-0",
      attrs: {
        "disabled": !_vm.openingValidation
      },
      on: {
        "click": function($event) {
          return _vm.saveOpening(time)
        }
      }
    }, [_vm._v("\n                                  " + _vm._s(_vm.$lang.actions.save) + "\n                                ")]), _vm._v(" "), _c('v-btn', {
      staticClass: "primary elevation-1",
      attrs: {
        "disabled": !_vm.openingValidation
      },
      on: {
        "click": function($event) {
          return _vm.copyOpening(time)
        }
      }
    }, [_vm._v("\n                                  " + _vm._s(_vm.$lang.actions.copy) + "\n                                ")]), _vm._v(" "), _c('v-btn', {
      staticClass: "error mx-0 elevation-1",
      on: {
        "click": function($event) {
          return _vm.closeOpening(time)
        }
      }
    }, [_vm._v("\n                                  " + _vm._s(_vm.$lang.actions.cancel) + "\n                                ")])], 1)] : [_c('td', {
      staticClass: "move-row"
    }, [(_vm.openingTimes.length >= 2) ? _c('div', [(index !== 0) ? _c('v-icon', {
      on: {
        "click": function($event) {
          return _vm.moveUp(_vm.openingTimes, index)
        }
      }
    }, [_vm._v("keyboard_arrow_up\n                                  ")]) : _vm._e(), _vm._v(" "), (index != _vm.openingTimes.length - 1) ? _c('v-icon', {
      on: {
        "click": function($event) {
          return _vm.moveDown(_vm.openingTimes, index)
        }
      }
    }, [_vm._v("keyboard_arrow_down\n                                  ")]) : _vm._e()], 1) : _vm._e()]), _vm._v(" "), _c('td', [_vm._v(_vm._s(time.day))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(time.start))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(time.end))]), _vm._v(" "), _c('td', {
      staticClass: "px-0",
      staticStyle: {
        "min-width": "314px"
      }
    }, [_c('v-btn', {
      staticClass: "primary elevation-1 mx-0",
      attrs: {
        "disabled": _vm.editingHours
      },
      on: {
        "click": function($event) {
          return _vm.editOpening(time)
        }
      }
    }, [_vm._v("\n                                  " + _vm._s(_vm.$lang.actions.edit) + "\n                                ")]), _vm._v(" "), _c('v-btn', {
      staticClass: "primary elevation-1",
      on: {
        "click": function($event) {
          return _vm.copyOpening(time)
        }
      }
    }, [_vm._v("\n                                  " + _vm._s(_vm.$lang.actions.copy) + "\n                                ")]), _vm._v(" "), _c('v-btn', {
      staticClass: "error mx-0 elevation-1",
      on: {
        "click": function($event) {
          return _vm.deleteOpening(index)
        }
      }
    }, [_vm._v("\n                                  " + _vm._s(_vm.$lang.actions.delete) + "\n                                ")])], 1)]], 2)
  }), 0)])])])], 1)], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "px-3": "",
      "pb-2": "",
      "mt-3": ""
    }
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "align-center": ""
    }
  }, [_c('v-btn', {
    staticClass: "primary ml-0 mr-3",
    attrs: {
      "disabled": _vm.editingVat || _vm.noTax
    },
    on: {
      "click": _vm.addVat
    }
  }, [_vm._v("\n                      " + _vm._s(_vm.$lang.actions.addVat) + "\n                    ")]), _vm._v(" "), _c('v-checkbox', {
    attrs: {
      "label": _vm.$lang.labels.noVATtax,
      "hide-details": "",
      "color": "primary"
    },
    model: {
      value: (_vm.noTax),
      callback: function($$v) {
        _vm.noTax = $$v
      },
      expression: "noTax"
    }
  })], 1), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "fade"
    }
  }, [_c('div', {
    staticClass: "v-table__overflow custom-table"
  }, [_c('table', {
    staticClass: "v-datatable v-table theme--light"
  }, [_c('tbody', _vm._l((_vm.vatRates), function(vat, index) {
    return _c('tr', {
      key: index
    }, [(vat.isEdit) ? [_c('td', [_c('v-text-field', {
      staticClass: "min-w mb-2 required",
      attrs: {
        "type": "number",
        "min": "0",
        "step": "0.01",
        "required": "",
        "hide-details": "",
        "label": _vm.$lang.actions.addVat
      },
      model: {
        value: (_vm.tempVat.vat),
        callback: function($$v) {
          _vm.$set(_vm.tempVat, "vat", $$v)
        },
        expression: "tempVat.vat"
      }
    })], 1), _vm._v(" "), _c('td', {
      staticClass: "min-w-lg px-0"
    }, [_c('v-btn', {
      staticClass: "primary elevation-1",
      attrs: {
        "disabled": !_vm.tempVat.vat
      },
      on: {
        "click": function($event) {
          return _vm.saveVatEdit(vat)
        }
      }
    }, [_vm._v("\n                                " + _vm._s(_vm.$lang.actions.save) + "\n                              ")]), _vm._v(" "), _c('v-btn', {
      staticClass: "error ml-0 elevation-1",
      on: {
        "click": function($event) {
          return _vm.closeVatEdit(vat)
        }
      }
    }, [_vm._v("\n                                " + _vm._s(_vm.$lang.actions.cancel) + "\n                              ")])], 1)] : [_c('td', [_vm._v(_vm._s(vat.vat))]), _vm._v(" "), _c('td', {
      staticClass: "actions px-0"
    }, [_c('v-btn', {
      staticClass: "primary elevation-1",
      on: {
        "click": function($event) {
          return _vm.editVat(vat)
        }
      }
    }, [_vm._v(_vm._s(_vm.$lang.actions.edit) + "\n                              ")]), _vm._v(" "), _c('v-btn', {
      staticClass: "error ml-0 elevation-1",
      on: {
        "click": function($event) {
          return _vm.deleteVat(index)
        }
      }
    }, [_vm._v("\n                                " + _vm._s(_vm.$lang.actions.delete) + "\n                              ")])], 1)]], 2)
  }), 0)])])]), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": "",
      "pt-2": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs10": "",
      "px-1": ""
    }
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "align-center": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "grow": ""
    }
  }, [_c('v-select', {
    attrs: {
      "label": _vm.$lang.labels.tipTax,
      "items": _vm.vatRates,
      "type": "number",
      "step": "0.5",
      "min": "0",
      "disabled": _vm.noTipTax,
      "item-text": "vat",
      "item-value": "vat"
    },
    model: {
      value: (_vm.company.tipTaxRate),
      callback: function($$v) {
        _vm.$set(_vm.company, "tipTaxRate", $$v)
      },
      expression: "company.tipTaxRate"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "shrink": ""
    }
  }, [_c('v-checkbox', {
    staticClass: "ml-3",
    attrs: {
      "label": _vm.$lang.labels.noTipTax,
      "hide-details": "",
      "disabled": this.vatRates.length === 0,
      "color": "primary"
    },
    model: {
      value: (_vm.noTipTax),
      callback: function($$v) {
        _vm.noTipTax = $$v
      },
      expression: "noTipTax"
    }
  })], 1)], 1)], 1)], 1), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs10": "",
      "px-1": ""
    }
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "align-center": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "grow": ""
    }
  }, [_c('v-select', {
    attrs: {
      "label": _vm.$lang.labels.chargeTax,
      "items": _vm.vatRates,
      "disabled": _vm.noDeliveryTax,
      "item-text": "vat",
      "item-value": "vat"
    },
    model: {
      value: (_vm.company.deliveryChargesTaxRate),
      callback: function($$v) {
        _vm.$set(_vm.company, "deliveryChargesTaxRate", $$v)
      },
      expression: "company.deliveryChargesTaxRate"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "shrink": ""
    }
  }, [_c('v-checkbox', {
    staticClass: "ml-3",
    attrs: {
      "label": _vm.$lang.labels.noDeliveryTax,
      "hide-details": "",
      "disabled": this.vatRates.length === 0,
      "color": "primary"
    },
    model: {
      value: (_vm.noDeliveryTax),
      callback: function($$v) {
        _vm.noDeliveryTax = $$v
      },
      expression: "noDeliveryTax"
    }
  })], 1)], 1)], 1)], 1)], 1)], 1)], 1), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": "",
      "justify-space-between": ""
    }
  }, [_c('v-btn', {
    attrs: {
      "flat": ""
    },
    on: {
      "click": function($event) {
        _vm.e1 = 1
      }
    }
  }, [_vm._v(_vm._s(_vm.$lang.actions.back))]), _vm._v(" "), _c('v-btn', {
    attrs: {
      "disabled": _vm.company.address.country === 'AT' ? !_vm.valid2 || !_vm.vatRates || (_vm.vatRates && _vm.vatRates.length === 0) : !_vm.valid2,
      "color": "primary"
    },
    on: {
      "click": function($event) {
        _vm.e1 = 3
      }
    }
  }, [_vm._v("\n                " + _vm._s(_vm.$lang.actions.next) + "\n              ")])], 1)], 1), _vm._v(" "), _c('v-stepper-content', {
    attrs: {
      "step": "3"
    }
  }, [_c('v-card', {
    staticClass: "mb-5",
    attrs: {
      "flat": ""
    }
  }, [_c('v-form', {
    model: {
      value: (_vm.valid3),
      callback: function($$v) {
        _vm.valid3 = $$v
      },
      expression: "valid3"
    }
  }, [_c('v-layout', {
    staticClass: "px-2",
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('h2', {
    staticClass: "px-3 pb-3"
  }, [_vm._v("\n                      " + _vm._s(_vm.$lang.labels.account) + "\n                    ")])]), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "md6": "",
      "px-3": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": _vm.$lang.labels.holder,
      "required": "",
      "rules": [function (v) { return !!v || ("" + (_vm.$lang.errors.missingHolder)); }]
    },
    model: {
      value: (_vm.account.name),
      callback: function($$v) {
        _vm.$set(_vm.account, "name", $$v)
      },
      expression: "account.name"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "md6": "",
      "px-3": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": _vm.$lang.labels.username,
      "hint": _vm.$lang.labels.lowerCase,
      "required": "",
      "rules": [function (v) { return !!v || ("" + (_vm.$lang.errors.missingUserName)); }]
    },
    on: {
      "blur": function($event) {
        _vm.account.userName ? _vm.account.userName = _vm.account.userName.toLowerCase().trim() : ''
      }
    },
    model: {
      value: (_vm.account.userName),
      callback: function($$v) {
        _vm.$set(_vm.account, "userName", $$v)
      },
      expression: "account.userName"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "md6": "",
      "px-3": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": _vm.$lang.labels.email,
      "type": "email",
      "rules": _vm.emailRules
    },
    model: {
      value: (_vm.account.email),
      callback: function($$v) {
        _vm.$set(_vm.account, "email", $$v)
      },
      expression: "account.email"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "md6": "",
      "px-3": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": _vm.$lang.labels.confirmEmail,
      "type": "email",
      "rules": [function (v) { return (!!v && v === _vm.account.email) || ("" + (_vm.$lang.errors.validConfirmEmail)); }]
    },
    model: {
      value: (_vm.confirmEmail),
      callback: function($$v) {
        _vm.confirmEmail = $$v
      },
      expression: "confirmEmail"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "md6": "",
      "px-3": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": _vm.$lang.labels.maxDiscountPercentage
    },
    model: {
      value: (_vm.account.maxDiscountPercentage),
      callback: function($$v) {
        _vm.$set(_vm.account, "maxDiscountPercentage", $$v)
      },
      expression: "account.maxDiscountPercentage"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "px-3": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": _vm.$lang.labels.notes
    },
    model: {
      value: (_vm.account.notes),
      callback: function($$v) {
        _vm.$set(_vm.account, "notes", $$v)
      },
      expression: "account.notes"
    }
  })], 1)], 1)], 1)], 1), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": "",
      "justify-space-between": ""
    }
  }, [_c('v-btn', {
    attrs: {
      "flat": ""
    },
    on: {
      "click": function($event) {
        _vm.e1 = 2
      }
    }
  }, [_vm._v(_vm._s(_vm.$lang.actions.back))]), _vm._v(" "), _c('v-btn', {
    attrs: {
      "disabled": !_vm.valid3,
      "color": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.submit()
      }
    }
  }, [_vm._v("\n                " + _vm._s(_vm.$lang.actions.submit) + "\n              ")])], 1)], 1)], 1)], 1)], 1)], 1), _vm._v(" "), (_vm.addressDialog) ? _c('v-dialog', {
    attrs: {
      "scrollable": "",
      "fullscreen": _vm.$vuetify.breakpoint.smAndDown,
      "max-width": "600px"
    },
    model: {
      value: (_vm.addressDialog),
      callback: function($$v) {
        _vm.addressDialog = $$v
      },
      expression: "addressDialog"
    }
  }, [_c('address-modal', {
    attrs: {
      "country": _vm.company.address.country,
      "address": _vm.company.address,
      "postal": _vm.company.address.postalcode
    },
    on: {
      "close": function($event) {
        _vm.addressDialog = false
      },
      "submit": _vm.submitAddress
    }
  })], 1) : _vm._e()], 1) : _vm._e()
},staticRenderFns: []}

/***/ }),
/* 400 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-card', {
    staticClass: "py-4 px-2"
  }, [(!_vm.isView && !_vm.isLocalAdmin && _vm.initDone) ? _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": "",
      "justify-end": ""
    }
  }, [_c('div', {
    staticClass: "d-inline-flex"
  }, [_c('div', {
    staticClass: "pr-3"
  }, [_c('v-btn', {
    staticClass: "primary mx-0 mb-4",
    on: {
      "click": function($event) {
        _vm.showImportModal = !_vm.showImportModal
      }
    }
  }, [_vm._v(_vm._s(_vm.$lang.actions.importCompany))])], 1)])]) : _vm._e(), _vm._v(" "), (!_vm.isView && !_vm.isLocalAdmin && _vm.initDone) ? _c('v-flex', {
    attrs: {
      "px-3": "",
      "pt-2": "",
      "pb-4": ""
    }
  }, [_c('hr')]) : _vm._e(), _vm._v(" "), (_vm.err) ? _c('v-flex', {
    attrs: {
      "xs12": "",
      "pb-3": "",
      "px-3": ""
    }
  }, [_c('v-alert', {
    attrs: {
      "value": true,
      "type": "error"
    }
  }, [_vm._v(_vm._s(_vm.err))])], 1) : _vm._e(), _vm._v(" "), (_vm.success) ? _c('v-flex', {
    attrs: {
      "xs12": "",
      "pb-3": "",
      "px-3": ""
    }
  }, [_c('v-alert', {
    attrs: {
      "value": true,
      "type": "success"
    }
  }, [_vm._v(_vm._s(_vm.success))])], 1) : _vm._e(), _vm._v(" "), _c('v-form', {
    model: {
      value: (_vm.valid),
      callback: function($$v) {
        _vm.valid = $$v
      },
      expression: "valid"
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": "",
      "sm10": "",
      "md7": "",
      "mx-3": ""
    }
  }, [_c('v-autocomplete', {
    attrs: {
      "items": _vm.companies,
      "label": _vm.$lang.actions.selectCompany,
      "readonly": _vm.isView,
      "item-text": "name",
      "item-value": "id",
      "required": "",
      "loading": _vm.companyLoading,
      "rules": [function (v) { return !!v || ("" + (_vm.$lang.errors.missingCompany)); }]
    },
    model: {
      value: (_vm.companyId),
      callback: function($$v) {
        _vm.companyId = $$v
      },
      expression: "companyId"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "sm10": "",
      "md7": "",
      "mx-3": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "required": "",
      "readonly": _vm.isView,
      "label": _vm.$lang.labels.templateName,
      "rules": [function (v) { return !!v || ("" + (_vm.$lang.errors.missingTemplateName)); }]
    },
    model: {
      value: (_vm.templateName),
      callback: function($$v) {
        _vm.templateName = $$v
      },
      expression: "templateName"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "md7": "",
      "mx-3": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": _vm.$lang.labels.numberOfPrints,
      "readonly": _vm.isView,
      "required": "",
      "rules": [function (v) { return !!v || ("" + (_vm.$lang.errors.missingNoPrints)); }]
    },
    model: {
      value: (_vm.noOfPrints),
      callback: function($$v) {
        _vm.noOfPrints = $$v
      },
      expression: "noOfPrints"
    }
  })], 1), _vm._v(" "), (!_vm.isView && !_vm.isClone) ? _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": "",
      "justify-space-between": "",
      "align-center": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": "",
      "md7": "",
      "mx-3": ""
    }
  }, [_c('v-autocomplete', {
    attrs: {
      "items": Object.keys(_vm.types),
      "label": _vm.$lang.actions.selectPrintTemplateType,
      "readonly": _vm.isView,
      "required": "",
      "loading": _vm.typesLoading,
      "rules": [function (v) { return !!v || ("" + (_vm.$lang.errors.missingPrintTemplateType)); }]
    },
    model: {
      value: (_vm.type),
      callback: function($$v) {
        _vm.type = $$v
      },
      expression: "type"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "mx-3": ""
    }
  }, [_c('v-autocomplete', {
    attrs: {
      "items": _vm.templates,
      "label": _vm.$lang.actions.selectTemplateImport,
      "item-text": "templateName",
      "item-value": "id",
      "disabled": _vm.templates.length === 0
    },
    model: {
      value: (_vm.templateId),
      callback: function($$v) {
        _vm.templateId = $$v
      },
      expression: "templateId"
    }
  }), _vm._v(" "), _c('v-btn', {
    staticClass: "primary mx-3 my-0",
    attrs: {
      "disabled": _vm.templateId === null
    },
    on: {
      "click": _vm.populate
    }
  }, [_vm._v(_vm._s(_vm.$lang.actions.populate))])], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.type === 'mainaway') ? _c('v-flex', {
    attrs: {
      "xs12": "",
      "md7": "",
      "mx-3": ""
    }
  }, [_c('v-autocomplete', {
    attrs: {
      "label": _vm.$lang.labels.mainawayTemplate,
      "items": _vm.mainaway,
      "item-text": "name",
      "item-value": "name",
      "required": "",
      "readonly": _vm.isView,
      "rules": [function () { return _vm.contents !== null || ("" + (_vm.$lang.errors.missingMainaway)); }]
    },
    model: {
      value: (_vm.contents),
      callback: function($$v) {
        _vm.contents = $$v
      },
      expression: "contents"
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.type === 'unpaidbill') ? _c('v-flex', {
    attrs: {
      "xs12": "",
      "md7": "",
      "mx-3": ""
    }
  }, [_c('v-autocomplete', {
    attrs: {
      "label": _vm.$lang.labels.unpaidBillTemplate,
      "items": _vm.unpaidBill,
      "item-text": "name",
      "item-value": "name",
      "required": "",
      "readonly": _vm.isView,
      "rules": [function () { return _vm.contents !== null || ("" + (_vm.$lang.errors.missingUnpaidBill)); }]
    },
    model: {
      value: (_vm.contents),
      callback: function($$v) {
        _vm.contents = $$v
      },
      expression: "contents"
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.type === 'invoice') ? _c('v-flex', {
    attrs: {
      "xs12": "",
      "md7": "",
      "mx-3": ""
    }
  }, [_c('v-autocomplete', {
    attrs: {
      "label": _vm.$lang.labels.itemTemplate,
      "items": _vm.item,
      "item-text": "name",
      "item-value": "name",
      "required": "",
      "readonly": _vm.isView,
      "rules": [function () { return _vm.contents !== null || ("" + (_vm.$lang.errors.missingItemTemplate)); }]
    },
    model: {
      value: (_vm.contents),
      callback: function($$v) {
        _vm.contents = $$v
      },
      expression: "contents"
    }
  })], 1) : _vm._e(), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [(_vm.type === 'invoice') ? _c('v-flex', {
    attrs: {
      "xs12": "",
      "md7": "",
      "mx-3": ""
    }
  }, [_c('v-autocomplete', {
    attrs: {
      "label": _vm.$lang.labels.taxTemplate,
      "items": _vm.tax,
      "item-text": "name",
      "item-value": "name",
      "required": "",
      "readonly": _vm.isView,
      "rules": [function () { return _vm.contents !== null || ("" + (_vm.$lang.errors.missingTaxTemplate)); }]
    },
    model: {
      value: (_vm.taxContent),
      callback: function($$v) {
        _vm.taxContent = $$v
      },
      expression: "taxContent"
    }
  })], 1) : _vm._e()], 1), _vm._v(" "), (_vm.type === 'label') ? _c('v-flex', {
    attrs: {
      "xs12": "",
      "md7": "",
      "mx-3": ""
    }
  }, [_c('v-autocomplete', {
    attrs: {
      "label": _vm.$lang.labels.labelTemplate,
      "items": _vm.label,
      "item-text": "name",
      "item-value": "name",
      "required": "",
      "readonly": _vm.isView,
      "rules": [function () { return _vm.contents !== null || ("" + (_vm.$lang.errors.missingLabelTemplate)); }]
    },
    model: {
      value: (_vm.contents),
      callback: function($$v) {
        _vm.contents = $$v
      },
      expression: "contents"
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.type === 'kitchen') ? _c('v-flex', {
    attrs: {
      "xs12": "",
      "md7": "",
      "mx-3": ""
    }
  }, [_c('v-autocomplete', {
    attrs: {
      "label": _vm.$lang.labels.kitchenTemplate,
      "items": _vm.kitchen,
      "item-text": "name",
      "item-value": "name",
      "required": "",
      "readonly": _vm.isView,
      "rules": [function () { return _vm.contents !== null || ("" + (_vm.$lang.errors.missingKitchenTemplate)); }]
    },
    model: {
      value: (_vm.contents),
      callback: function($$v) {
        _vm.contents = $$v
      },
      expression: "contents"
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.type === 'driver') ? _c('v-flex', {
    attrs: {
      "xs12": "",
      "md7": "",
      "mx-3": ""
    }
  }, [_c('v-autocomplete', {
    attrs: {
      "label": _vm.$lang.labels.driverTemplate,
      "items": _vm.driver,
      "item-text": "name",
      "item-value": "name",
      "required": "",
      "readonly": _vm.isView,
      "rules": [function () { return _vm.contents !== null || ("" + (_vm.$lang.errors.missingDriverTemplate)); }]
    },
    model: {
      value: (_vm.contents),
      callback: function($$v) {
        _vm.contents = $$v
      },
      expression: "contents"
    }
  })], 1) : _vm._e(), _vm._v(" "), (!_vm.isView) ? _c('v-btn', {
    staticClass: "primary mx-4 mb-2",
    attrs: {
      "disabled": _vm.editPrefix
    },
    on: {
      "click": _vm.addPrefix
    }
  }, [_vm._v(_vm._s(_vm.$lang.actions.prefixLines))]) : _vm._e(), _vm._v(" "), (_vm.isView && _vm.prefixLines.length !== 0) ? _c('h3', {
    staticClass: "mx-4"
  }, [_vm._v(_vm._s(_vm.$lang.header.prefixLines) + ":")]) : _vm._e(), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "px-3": ""
    }
  }, [_c('div', {
    staticClass: "v-table__overflow"
  }, [_c('table', {
    staticClass: "v-datatable v-table theme--light"
  }, [_c('tbody', _vm._l((_vm.prefixLines), function(prefix, index) {
    return _c('tr', {
      key: index
    }, [(prefix.isEdit) ? [(!_vm.isView) ? _c('td', {
      staticClass: "move-row"
    }) : _vm._e(), _vm._v(" "), _c('td', {
      staticClass: "pb-2"
    }, [(_vm.tempPrefix.content !== 'image') ? _c('v-text-field', {
      staticClass: "min-w",
      attrs: {
        "disabled": ['cut', 'beep', 'pagebreak', 'opencashdrawer'].includes(_vm.tempPrefix.content),
        "label": _vm.$lang.labels.fontHeight,
        "min": "0",
        "type": "number",
        "required": "",
        "hide-details": ""
      },
      model: {
        value: (_vm.tempPrefix.fontHeight),
        callback: function($$v) {
          _vm.$set(_vm.tempPrefix, "fontHeight", $$v)
        },
        expression: "tempPrefix.fontHeight"
      }
    }) : _vm._e()], 1), _vm._v(" "), _c('td', {
      staticClass: "pb-2"
    }, [(_vm.tempPrefix.content !== 'image') ? _c('v-select', {
      staticClass: "min-w",
      attrs: {
        "items": _vm.fontStyles,
        "disabled": ['cut', 'beep', 'pagebreak', 'opencashdrawer'].includes(_vm.tempPrefix.content),
        "label": _vm.$lang.labels.fontStyle,
        "required": "",
        "hide-details": ""
      },
      model: {
        value: (_vm.tempPrefix.fontStyle),
        callback: function($$v) {
          _vm.$set(_vm.tempPrefix, "fontStyle", $$v)
        },
        expression: "tempPrefix.fontStyle"
      }
    }) : [_c('v-text-field', {
      ref: "fileTextField",
      refInFor: true,
      staticClass: "min-w",
      attrs: {
        "label": "choose_file",
        "prepend-icon": "attach_file",
        "single-line": "",
        "hide-details": "",
        "required": ""
      },
      on: {
        "click": function($event) {
          return _vm.startInput('prefixFileInput')
        }
      },
      model: {
        value: (_vm.tempPrefix.filename),
        callback: function($$v) {
          _vm.$set(_vm.tempPrefix, "filename", $$v)
        },
        expression: "tempPrefix.filename"
      }
    }), _vm._v(" "), _c('input', {
      ref: "prefixFileInput",
      refInFor: true,
      staticStyle: {
        "display": "none"
      },
      attrs: {
        "type": "file",
        "accept": "image/*"
      },
      on: {
        "change": function($event) {
          return _vm.onFileChange('tempPrefix', $event)
        }
      }
    })]], 2), _vm._v(" "), _c('td', {
      staticClass: "pb-2"
    }, [_c('v-combobox', {
      staticClass: "min-w",
      attrs: {
        "label": _vm.$lang.labels.content,
        "items": _vm.lineChoices,
        "search-input": _vm.tempPrefix.content,
        "required": "",
        "hide-details": ""
      },
      on: {
        "update:searchInput": function($event) {
          return _vm.$set(_vm.tempPrefix, "content", $event)
        },
        "update:search-input": function($event) {
          return _vm.$set(_vm.tempPrefix, "content", $event)
        }
      },
      model: {
        value: (_vm.tempPrefix.content),
        callback: function($$v) {
          _vm.$set(_vm.tempPrefix, "content", $$v)
        },
        expression: "tempPrefix.content"
      }
    })], 1), _vm._v(" "), _c('td', {
      staticClass: "actions px-0"
    }, [_c('v-btn', {
      staticClass: "primary elevation-1",
      attrs: {
        "disabled": !_vm.tempPrefix.content ||
          (_vm.tempPrefix.content !== 'image' && (!_vm.tempPrefix.fontHeight || !_vm.tempPrefix.fontStyle)) ||
          (_vm.tempPrefix.content === 'image' && !_vm.tempPrefix.filename)
      },
      on: {
        "click": function($event) {
          return _vm.savePrefixEdit(prefix)
        }
      }
    }, [_vm._v(_vm._s(_vm.$lang.actions.save))]), _vm._v(" "), _c('v-btn', {
      staticClass: "error ml-0 elevation-1",
      on: {
        "click": function($event) {
          return _vm.closePrefixEdit(prefix)
        }
      }
    }, [_vm._v(_vm._s(_vm.$lang.actions.cancel))])], 1)] : [(!_vm.isView) ? _c('td', {
      staticClass: "move-row"
    }, [(_vm.prefixLines.length >= 2) ? _c('div', [(index !== 0) ? _c('v-icon', {
      on: {
        "click": function($event) {
          return _vm.moveUp(_vm.prefixLines, index)
        }
      }
    }, [_vm._v("keyboard_arrow_up")]) : _vm._e(), _vm._v(" "), (index != _vm.prefixLines.length - 1) ? _c('v-icon', {
      on: {
        "click": function($event) {
          return _vm.moveDown(_vm.prefixLines, index)
        }
      }
    }, [_vm._v("keyboard_arrow_down")]) : _vm._e()], 1) : _vm._e()]) : _vm._e(), _vm._v(" "), (prefix.content !== 'image') ? _c('td', [_vm._v(_vm._s(prefix.fontHeight))]) : _vm._e(), _vm._v(" "), _c('td', {
      attrs: {
        "colspan": prefix.content !== 'image' ? 1 : 2
      }
    }, [_vm._v(_vm._s(prefix.content !== 'image' ? prefix.fontStyle : prefix.filename))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(prefix.content))]), _vm._v(" "), (!_vm.isView) ? _c('td', {
      staticClass: "actions px-0"
    }, [_c('v-btn', {
      staticClass: "primary elevation-1",
      attrs: {
        "disabled": _vm.disablePrefixes
      },
      on: {
        "click": function($event) {
          return _vm.editingPrefix(prefix)
        }
      }
    }, [_vm._v("\n                      " + _vm._s(_vm.$lang.actions.edit) + "\n                    ")]), _vm._v(" "), _c('v-btn', {
      staticClass: "error ml-0 elevation-1",
      on: {
        "click": function($event) {
          return _vm.deletePrefix(index)
        }
      }
    }, [_vm._v(_vm._s(_vm.$lang.actions.delete))])], 1) : _vm._e()]], 2)
  }), 0)])])]), _vm._v(" "), (!_vm.isView) ? _c('v-btn', {
    staticClass: "primary mx-4 mt-4 mb-2",
    attrs: {
      "disabled": _vm.editPostfix
    },
    on: {
      "click": _vm.addPostfix
    }
  }, [_vm._v(_vm._s(_vm.$lang.actions.postfixLines))]) : _vm._e(), _vm._v(" "), (_vm.isView && _vm.postfixLines.length !== 0) ? _c('h3', {
    staticClass: "mt-4 mx-4"
  }, [_vm._v(_vm._s(_vm.$lang.header.postixLines) + ":")]) : _vm._e(), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "px-3": ""
    }
  }, [_c('div', {
    staticClass: "v-table__overflow"
  }, [_c('table', {
    staticClass: "v-datatable v-table theme--light"
  }, [_c('tbody', _vm._l((_vm.postfixLines), function(postfix, index) {
    return _c('tr', {
      key: index
    }, [(postfix.isEdit) ? [(!_vm.isView) ? _c('td', {
      staticClass: "move-row"
    }) : _vm._e(), _vm._v(" "), _c('td', {
      staticClass: "pb-2"
    }, [(_vm.tempPostfix.content !== 'image') ? _c('v-text-field', {
      staticClass: "min-w",
      attrs: {
        "disabled": ['cut', 'beep', 'pagebreak', 'opencashdrawer'].includes(_vm.tempPostfix.content),
        "label": _vm.$lang.labels.fontHeight,
        "min": "0",
        "type": "number",
        "required": "",
        "hide-details": ""
      },
      model: {
        value: (_vm.tempPostfix.fontHeight),
        callback: function($$v) {
          _vm.$set(_vm.tempPostfix, "fontHeight", $$v)
        },
        expression: "tempPostfix.fontHeight"
      }
    }) : _vm._e()], 1), _vm._v(" "), _c('td', {
      staticClass: "pb-2"
    }, [(_vm.tempPostfix.content !== 'image') ? _c('v-select', {
      staticClass: "min-w",
      attrs: {
        "disabled": ['cut', 'beep', 'pagebreak', 'opencashdrawer'].includes(_vm.tempPostfix.content),
        "items": _vm.fontStyles,
        "label": _vm.$lang.labels.fontStyle,
        "required": "",
        "hide-details": ""
      },
      model: {
        value: (_vm.tempPostfix.fontStyle),
        callback: function($$v) {
          _vm.$set(_vm.tempPostfix, "fontStyle", $$v)
        },
        expression: "tempPostfix.fontStyle"
      }
    }) : [_c('v-text-field', {
      ref: "fileTextField",
      refInFor: true,
      staticClass: "min-w",
      attrs: {
        "prepend-icon": "attach_file",
        "single-line": "",
        "hide-details": "",
        "label": "choose_file",
        "required": ""
      },
      on: {
        "click": function($event) {
          return _vm.startInput('postfixFileInput')
        }
      },
      model: {
        value: (_vm.tempPostfix.filename),
        callback: function($$v) {
          _vm.$set(_vm.tempPostfix, "filename", $$v)
        },
        expression: "tempPostfix.filename"
      }
    }), _vm._v(" "), _c('input', {
      ref: "postfixFileInput",
      refInFor: true,
      staticStyle: {
        "display": "none"
      },
      attrs: {
        "type": "file",
        "accept": "image/*"
      },
      on: {
        "change": function($event) {
          return _vm.onFileChange('tempPostfix', $event)
        }
      }
    })]], 2), _vm._v(" "), _c('td', {
      staticClass: "pb-2"
    }, [_c('v-combobox', {
      staticClass: "min-w",
      attrs: {
        "label": _vm.$lang.labels.content,
        "items": _vm.lineChoices,
        "required": "",
        "search-input": _vm.tempPostfix.content,
        "hide-details": ""
      },
      on: {
        "update:searchInput": function($event) {
          return _vm.$set(_vm.tempPostfix, "content", $event)
        },
        "update:search-input": function($event) {
          return _vm.$set(_vm.tempPostfix, "content", $event)
        }
      },
      model: {
        value: (_vm.tempPostfix.content),
        callback: function($$v) {
          _vm.$set(_vm.tempPostfix, "content", $$v)
        },
        expression: "tempPostfix.content"
      }
    })], 1), _vm._v(" "), _c('td', {
      staticClass: "actions px-0"
    }, [_c('v-btn', {
      staticClass: "primary elevation-1",
      attrs: {
        "disabled": !_vm.tempPostfix.content ||
          (_vm.tempPostfix.content !== 'image' && (!_vm.tempPostfix.fontHeight || !_vm.tempPostfix.fontStyle)) ||
          (_vm.tempPostfix.content === 'image' && !_vm.tempPostfix.filename)
      },
      on: {
        "click": function($event) {
          return _vm.savePostfixEdit(postfix)
        }
      }
    }, [_vm._v(_vm._s(_vm.$lang.actions.save))]), _vm._v(" "), _c('v-btn', {
      staticClass: "error ml-0 elevation-1",
      on: {
        "click": function($event) {
          return _vm.closePostfixEdit(postfix)
        }
      }
    }, [_vm._v(_vm._s(_vm.$lang.actions.cancel))])], 1)] : [(!_vm.isView) ? _c('td', {
      staticClass: "move-row"
    }, [(_vm.postfixLines.length >= 2) ? _c('div', [(index !== 0) ? _c('v-icon', {
      on: {
        "click": function($event) {
          return _vm.moveUp(_vm.postfixLines, index)
        }
      }
    }, [_vm._v("keyboard_arrow_up")]) : _vm._e(), _vm._v(" "), (index != _vm.postfixLines.length - 1) ? _c('v-icon', {
      on: {
        "click": function($event) {
          return _vm.moveDown(_vm.postfixLines, index)
        }
      }
    }, [_vm._v("keyboard_arrow_down")]) : _vm._e()], 1) : _vm._e()]) : _vm._e(), _vm._v(" "), (postfix.content !== 'image') ? _c('td', [_vm._v(_vm._s(postfix.fontHeight))]) : _vm._e(), _vm._v(" "), _c('td', {
      attrs: {
        "colspan": postfix.content !== 'image' ? 1 : 2
      }
    }, [_vm._v(_vm._s(postfix.content !== 'image' ? postfix.fontStyle : postfix.filename))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(postfix.content))]), _vm._v(" "), (!_vm.isView) ? _c('td', {
      staticClass: "actions px-0"
    }, [_c('v-btn', {
      staticClass: "primary elevation-1",
      attrs: {
        "disabled": _vm.disablePostfixes
      },
      on: {
        "click": function($event) {
          return _vm.editingPostfix(postfix)
        }
      }
    }, [_vm._v(_vm._s(_vm.$lang.actions.edit))]), _vm._v(" "), _c('v-btn', {
      staticClass: "error ml-0 elevation-1",
      on: {
        "click": function($event) {
          return _vm.deletePostfix(index)
        }
      }
    }, [_vm._v(_vm._s(_vm.$lang.actions.delete))])], 1) : _vm._e()]], 2)
  }), 0)])]), _vm._v(" "), _c('v-btn', {
    staticClass: "mx-0 mt-4",
    attrs: {
      "disabled": !_vm.previewValidation,
      "color": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.preview()
      }
    }
  }, [_vm._v("\n          " + _vm._s(_vm.$lang.actions.preview) + "\n        ")])], 1), _vm._v(" "), _c('v-layout', {
    staticClass: "px-2 mt-3",
    attrs: {
      "row": "",
      "wrap": "",
      "justify-space-between": ""
    }
  }, [(_vm.isView && _vm.createdOn) ? _c('v-text-field', {
    staticClass: "min-w max-w mx-3",
    attrs: {
      "label": _vm.$lang.labels.created,
      "readonly": "",
      "hide-details": ""
    },
    model: {
      value: (_vm.createdOn),
      callback: function($$v) {
        _vm.createdOn = $$v
      },
      expression: "createdOn"
    }
  }) : _vm._e(), _vm._v(" "), (_vm.isView && _vm.modifiedOn) ? _c('v-text-field', {
    staticClass: "min-w max-w mx-3",
    attrs: {
      "label": _vm.$lang.labels.modified,
      "readonly": "",
      "hide-details": ""
    },
    model: {
      value: (_vm.modifiedOn),
      callback: function($$v) {
        _vm.modifiedOn = $$v
      },
      expression: "modifiedOn"
    }
  }) : _vm._e()], 1), _vm._v(" "), _c('v-layout', {
    staticClass: "mt-3 px-3",
    attrs: {
      "row": "",
      "wrap": "",
      "justify-space-between": "",
      "align-content-center": ""
    }
  }, [_c('v-btn', {
    staticClass: "ml-0",
    attrs: {
      "flat": ""
    },
    on: {
      "click": function($event) {
        return _vm.$router.push({
          name: 'printTemplates'
        })
      }
    }
  }, [_c('v-icon', [_vm._v("keyboard_arrow_left")]), _vm._v("\n          " + _vm._s(_vm.$lang.actions.close) + "\n        ")], 1), _vm._v(" "), (!_vm.isView) ? _c('v-btn', {
    staticClass: "primary mx-0",
    attrs: {
      "disabled": !_vm.valid
    },
    on: {
      "click": _vm.submit
    }
  }, [_vm._v("\n          " + _vm._s(_vm.isClone ? _vm.$lang.actions.createCopy : _vm.$lang.actions.create) + "\n        ")]) : _vm._e()], 1)], 1)], 1), _vm._v(" "), (_vm.previewModal) ? _c('v-dialog', {
    attrs: {
      "max-width": "800"
    },
    model: {
      value: (_vm.previewModal),
      callback: function($$v) {
        _vm.previewModal = $$v
      },
      expression: "previewModal"
    }
  }, [_c('preview', {
    attrs: {
      "data": _vm.previewData
    },
    on: {
      "close": function($event) {
        _vm.previewModal = false
      }
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.activationModal) ? _c('v-dialog', {
    attrs: {
      "max-width": "390"
    },
    model: {
      value: (_vm.activationModal),
      callback: function($$v) {
        _vm.activationModal = $$v
      },
      expression: "activationModal"
    }
  }, [_c('activate', {
    on: {
      "activate": _vm.activate
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.showImportModal) ? _c('v-dialog', {
    attrs: {
      "max-width": "390"
    },
    model: {
      value: (_vm.showImportModal),
      callback: function($$v) {
        _vm.showImportModal = $$v
      },
      expression: "showImportModal"
    }
  }, [_c('import', {
    attrs: {
      "companies": _vm.companies,
      "types": _vm.types
    },
    on: {
      "submit": _vm.setTemplate,
      "close": function($event) {
        _vm.showImportModal = false
      }
    }
  })], 1) : _vm._e()], 1)
},staticRenderFns: []}

/***/ }),
/* 401 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-flex', {
    attrs: {
      "xs12": "",
      "sm10": "",
      "md8": ""
    }
  }, [_c('v-card', {
    staticClass: "py-4"
  }, [(_vm.err) ? _c('v-flex', {
    attrs: {
      "xs12": "",
      "pb-3": "",
      "px-4": ""
    }
  }, [_c('v-alert', {
    attrs: {
      "value": true,
      "type": "error"
    }
  }, [_vm._v(_vm._s(_vm.err))])], 1) : _vm._e(), _vm._v(" "), (_vm.success) ? _c('v-flex', {
    attrs: {
      "xs12": "",
      "pb-3": "",
      "px-4": ""
    }
  }, [_c('v-alert', {
    attrs: {
      "value": true,
      "type": "success"
    }
  }, [_vm._v(_vm._s(_vm.success))])], 1) : _vm._e(), _vm._v(" "), _c('v-form', {
    model: {
      value: (_vm.valid),
      callback: function($$v) {
        _vm.valid = $$v
      },
      expression: "valid"
    }
  }, [(!_vm.isLocalAdmin) ? _c('v-flex', {
    attrs: {
      "xs12": "",
      "md6": "",
      "px-4": ""
    }
  }, [_c('v-autocomplete', {
    attrs: {
      "items": _vm.companies,
      "label": _vm.$lang.actions.selectCompany,
      "item-text": "name",
      "item-value": "id",
      "required": "",
      "readonly": _vm.isEdit,
      "loading": _vm.companyLoading,
      "rules": [function (v) { return !!v || ("" + (_vm.$lang.errors.missingCompany)); }]
    },
    model: {
      value: (_vm.account.companyId),
      callback: function($$v) {
        _vm.$set(_vm.account, "companyId", $$v)
      },
      expression: "account.companyId"
    }
  })], 1) : _vm._e(), _vm._v(" "), _c('v-layout', {
    staticClass: "px-2",
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": "",
      "md6": "",
      "px-3": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": _vm.$lang.labels.holder,
      "required": "",
      "rules": [function (v) { return !!v || ("" + (_vm.$lang.errors.missingHolder)); }]
    },
    model: {
      value: (_vm.account.name),
      callback: function($$v) {
        _vm.$set(_vm.account, "name", $$v)
      },
      expression: "account.name"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "md6": "",
      "px-3": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": _vm.$lang.labels.username,
      "hint": _vm.$lang.labels.lowerCase,
      "required": "",
      "rules": [function (v) { return !!v || ("" + (_vm.$lang.errors.missingUserName)); }]
    },
    on: {
      "blur": function($event) {
        _vm.account.userName = _vm.account.userName.toLowerCase().trim()
      }
    },
    model: {
      value: (_vm.account.userName),
      callback: function($$v) {
        _vm.$set(_vm.account, "userName", $$v)
      },
      expression: "account.userName"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "md6": "",
      "px-3": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": _vm.$lang.labels.email,
      "type": "email"
    },
    model: {
      value: (_vm.account.email),
      callback: function($$v) {
        _vm.$set(_vm.account, "email", $$v)
      },
      expression: "account.email"
    }
  })], 1), _vm._v(" "), (_vm.lastLoggedInOn) ? _c('v-flex', {
    attrs: {
      "xs12": "",
      "md6": "",
      "px-3": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": _vm.$lang.labels.lastLoggedinOn,
      "readonly": ""
    },
    model: {
      value: (_vm.lastLoggedInOn),
      callback: function($$v) {
        _vm.lastLoggedInOn = $$v
      },
      expression: "lastLoggedInOn"
    }
  })], 1) : _vm._e()], 1), _vm._v(" "), _c('v-layout', {
    staticClass: "px-2",
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": "",
      "md6": "",
      "px-3": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": _vm.$lang.labels.maxDiscount,
      "type": "number",
      "min": "0",
      "step": "0.05",
      "required": "",
      "rules": [function (v) { return _vm.checkMaxDiscountPercentage(v) || ("" + (_vm.$lang.errors.missingDicount)); }]
    },
    model: {
      value: (_vm.account.maxDiscountPercentage),
      callback: function($$v) {
        _vm.$set(_vm.account, "maxDiscountPercentage", $$v)
      },
      expression: "account.maxDiscountPercentage"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "md6": "",
      "px-3": ""
    }
  }, [_c('v-autocomplete', {
    attrs: {
      "items": _vm.mappedPrinters,
      "label": _vm.$lang.actions.selectDefaultPrinter,
      "required": "",
      "disabled": _vm.mappedPrinters.lenght === 0,
      "loading": _vm.printersLoading,
      "rules": [function (v) { return !!v || ("" + (_vm.$lang.errors.missingDefaultPrinter)); }]
    },
    model: {
      value: (_vm.account.defaultPrinter),
      callback: function($$v) {
        _vm.$set(_vm.account, "defaultPrinter", $$v)
      },
      expression: "account.defaultPrinter"
    }
  })], 1)], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "px-3": "",
      "mb-3": ""
    }
  }, [_c('p', {
    staticClass: "pl-2 mb-0 pb-0"
  }, [_vm._v(_vm._s(_vm.$lang.header.roleManagement) + ":")]), _vm._v(" "), _c('div', {
    staticClass: "d-inline-flex"
  }, [_c('v-btn', {
    staticClass: "primary mx-2",
    on: {
      "click": function($event) {
        return _vm.manageRoles('none')
      }
    }
  }, [_vm._v("\n            " + _vm._s(_vm.$lang.labels.none) + "\n          ")]), _vm._v(" "), _c('v-btn', {
    staticClass: "primary mx-2",
    on: {
      "click": function($event) {
        return _vm.manageRoles('user')
      }
    }
  }, [_vm._v("\n            " + _vm._s(_vm.$lang.labels.atUser) + "\n          ")]), _vm._v(" "), _c('v-btn', {
    staticClass: "primary mx-2",
    on: {
      "click": function($event) {
        return _vm.manageRoles('admin')
      }
    }
  }, [_vm._v("\n            " + _vm._s(_vm.$lang.labels.atLocalAdmin) + "\n          ")])], 1)]), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "px-4": ""
    }
  }, [_c('v-select', {
    attrs: {
      "small-chips": "",
      "deletable-chips": "",
      "multiple": "",
      "label": _vm.$lang.actions.selectRoles,
      "loading": _vm.rolesLoading,
      "items": _vm.sortedRoles
    },
    model: {
      value: (_vm.selectedRoles),
      callback: function($$v) {
        _vm.selectedRoles = $$v
      },
      expression: "selectedRoles"
    }
  })], 1), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs6": "",
      "px-4": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": _vm.$lang.labels.apiKey
    },
    model: {
      value: (_vm.account.apiKey),
      callback: function($$v) {
        _vm.$set(_vm.account, "apiKey", $$v)
      },
      expression: "account.apiKey"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs6": "",
      "px-4": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": _vm.$lang.labels.nfcToken
    },
    model: {
      value: (_vm.account.nfcToken),
      callback: function($$v) {
        _vm.$set(_vm.account, "nfcToken", $$v)
      },
      expression: "account.nfcToken"
    }
  })], 1)], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "px-4": ""
    }
  }, [_c('v-textarea', {
    attrs: {
      "label": _vm.$lang.labels.notes,
      "auto-grow": "",
      "rows": "1"
    },
    model: {
      value: (_vm.account.notes),
      callback: function($$v) {
        _vm.$set(_vm.account, "notes", $$v)
      },
      expression: "account.notes"
    }
  })], 1), _vm._v(" "), _c('v-layout', {
    staticClass: "px-2",
    attrs: {
      "row": "",
      "wrap": "",
      "justify-space-between": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": "",
      "md6": "",
      "px-3": ""
    }
  }, [(_vm.isEdit && _vm.createdOn) ? _c('v-text-field', {
    attrs: {
      "label": _vm.$lang.labels.created,
      "readonly": ""
    },
    model: {
      value: (_vm.createdOn),
      callback: function($$v) {
        _vm.createdOn = $$v
      },
      expression: "createdOn"
    }
  }) : _vm._e()], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "md6": "",
      "px-3": ""
    }
  }, [(_vm.isEdit && _vm.modifiedOn) ? _c('v-text-field', {
    attrs: {
      "label": _vm.$lang.labels.modified,
      "readonly": ""
    },
    model: {
      value: (_vm.modifiedOn),
      callback: function($$v) {
        _vm.modifiedOn = $$v
      },
      expression: "modifiedOn"
    }
  }) : _vm._e()], 1)], 1), _vm._v(" "), _c('v-layout', {
    staticClass: "px-2",
    attrs: {
      "row": "",
      "wrap": "",
      "justify-space-between": "",
      "align-center": ""
    }
  }, [_c('v-btn', {
    staticClass: "mx-3",
    attrs: {
      "flat": ""
    },
    on: {
      "click": function($event) {
        return _vm.$router.push({
          name: 'accounts'
        })
      }
    }
  }, [_c('v-icon', [_vm._v("keyboard_arrow_left")]), _vm._v("\n          " + _vm._s(_vm.$lang.actions.close) + "\n        ")], 1), _vm._v(" "), _c('div', [(_vm.isEdit) ? _c('v-btn', {
    staticClass: "primary mx-2",
    attrs: {
      "disabled": _vm.passSnackbar || _vm.account.accountStatus === 'inactive'
    },
    on: {
      "click": _vm.resetPassword
    }
  }, [_vm._v("\n            " + _vm._s(_vm.$lang.actions.resetPassword) + "\n          ")]) : _vm._e(), _vm._v(" "), _c('v-btn', {
    staticClass: "primary mx-3",
    attrs: {
      "disabled": !_vm.valid || _vm.isPrinterActive || _vm.impactSnackbar
    },
    on: {
      "click": function($event) {
        return _vm.submit()
      }
    }
  }, [_vm._v("\n            " + _vm._s(_vm.isEdit ? _vm.$lang.actions.update : _vm.$lang.actions.create) + "\n          ")])], 1)], 1)], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "snackbar-wrap"
  }, [_c('v-snackbar', {
    staticClass: "mx-3",
    attrs: {
      "bottom": "",
      "timeout": _vm.timeout,
      "color": "success",
      "multi-line": ""
    },
    model: {
      value: (_vm.passSnackbar),
      callback: function($$v) {
        _vm.passSnackbar = $$v
      },
      expression: "passSnackbar"
    }
  }, [_vm._v("\n      " + _vm._s(_vm.$lang.labels.yourPassword) + _vm._s(_vm.password) + "\n      "), _c('v-btn', {
    attrs: {
      "flat": ""
    },
    on: {
      "click": function($event) {
        _vm.passSnackbar = false
      }
    }
  }, [_vm._v("\n        " + _vm._s(_vm.$lang.actions.close) + "\n      ")])], 1), _vm._v(" "), _c('v-snackbar', {
    staticClass: "mx-3",
    attrs: {
      "bottom": "",
      "timeout": _vm.timeout,
      "color": "error",
      "multi-line": ""
    },
    model: {
      value: (_vm.impactSnackbar),
      callback: function($$v) {
        _vm.impactSnackbar = $$v
      },
      expression: "impactSnackbar"
    }
  }, [_vm._v("\n      " + _vm._s(_vm.$lang.labels.accountImpactWarning) + "\n      "), _c('v-btn', {
    attrs: {
      "flat": ""
    },
    on: {
      "click": function($event) {
        _vm.impactSnackbar = false
      }
    }
  }, [_vm._v("\n        " + _vm._s(_vm.$lang.actions.close) + "\n      ")])], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 402 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-card', {
    staticClass: "py-4"
  }, [(_vm.err) ? _c('v-flex', {
    attrs: {
      "xs12": "",
      "px-4": ""
    }
  }, [_c('v-alert', {
    attrs: {
      "value": true,
      "type": "error"
    }
  }, [_vm._v(_vm._s(_vm.err))])], 1) : _vm._e(), _vm._v(" "), (_vm.success) ? _c('v-flex', {
    attrs: {
      "xs12": "",
      "px-4": ""
    }
  }, [_c('v-alert', {
    attrs: {
      "value": true,
      "type": "success"
    }
  }, [_vm._v(_vm._s(_vm.success))])], 1) : _vm._e(), _vm._v(" "), _c('v-form', {
    model: {
      value: (_vm.valid),
      callback: function($$v) {
        _vm.valid = $$v
      },
      expression: "valid"
    }
  }, [_c('v-layout', {
    attrs: {
      "rpw": "",
      "wrap": "",
      "pb-4": _vm.$vuetify.breakpoint.smAndDown
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": "",
      "sm8": "",
      "md6": "",
      "lg4": "",
      "px-4": ""
    }
  }, [(!_vm.isLocalAdmin) ? _c('v-autocomplete', {
    attrs: {
      "required": "",
      "disabled": _vm.isEdit,
      "loading": _vm.companyLoading,
      "rules": [function (v) { return !!v || ("" + (_vm.$lang.errors.missingCompany)); }],
      "items": _vm.mappedCompanies,
      "label": _vm.$lang.actions.selectCompany
    },
    model: {
      value: (_vm.selectedCompany),
      callback: function($$v) {
        _vm.selectedCompany = $$v
      },
      expression: "selectedCompany"
    }
  }) : _vm._e()], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "sm8": "",
      "md6": "",
      "lg4": "",
      "px-4": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "hide-details": "",
      "label": _vm.$lang.labels.sequenceNumber
    },
    model: {
      value: (_vm.sequenceNumber),
      callback: function($$v) {
        _vm.sequenceNumber = $$v
      },
      expression: "sequenceNumber"
    }
  })], 1)], 1), _vm._v(" "), _c('v-btn', {
    staticClass: "mx-4 primary",
    attrs: {
      "disabled": _vm.editingName
    },
    on: {
      "click": _vm.addName
    }
  }, [_vm._v(_vm._s(_vm.$lang.actions.addTableName))]), _vm._v(" "), _c('div', {
    staticClass: "nameTable v-table__overflow px-4"
  }, [_c('table', {
    staticClass: "v-datatable v-table theme--light"
  }, [_c('tbody', _vm._l((_vm.names), function(name, index) {
    return _c('tr', {
      key: index
    }, [(name.isEdit) ? [_c('td', [_c('v-select', {
      staticClass: "min-w",
      attrs: {
        "items": _vm.languages,
        "item-text": "text",
        "item-value": "value",
        "label": _vm.$lang.actions.selectLanguage
      },
      model: {
        value: (_vm.tempName.language),
        callback: function($$v) {
          _vm.$set(_vm.tempName, "language", $$v)
        },
        expression: "tempName.language"
      }
    })], 1), _vm._v(" "), _c('td', [_c('v-text-field', {
      staticClass: "min-w",
      attrs: {
        "placeholder": _vm.$lang.labels.name
      },
      model: {
        value: (_vm.tempName.name),
        callback: function($$v) {
          _vm.$set(_vm.tempName, "name", $$v)
        },
        expression: "tempName.name"
      }
    })], 1), _vm._v(" "), _c('td', {
      staticClass: "min-w-lg px-0"
    }, [_c('v-btn', {
      staticClass: "primary elevation-1",
      attrs: {
        "disabled": !_vm.tempName.language || !_vm.tempName.name
      },
      on: {
        "click": function($event) {
          return _vm.saveNameEdit(name)
        }
      }
    }, [_vm._v(_vm._s(_vm.$lang.actions.save) + "\n                ")]), _vm._v(" "), _c('v-btn', {
      staticClass: "error ml-0 elevation-1",
      on: {
        "click": function($event) {
          return _vm.closeNameEdit(name)
        }
      }
    }, [_vm._v(_vm._s(_vm.$lang.actions.cancel))])], 1)] : [_c('td', [_vm._v(_vm._s(name.language))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(name.name))]), _vm._v(" "), _c('td', {
      staticClass: "actions px-0"
    }, [_c('v-btn', {
      staticClass: "primary elevation-1",
      on: {
        "click": function($event) {
          return _vm.editName(name)
        }
      }
    }, [_vm._v(_vm._s(_vm.$lang.actions.edit))]), _vm._v(" "), _c('v-btn', {
      staticClass: "error ml-0 elevation-1",
      on: {
        "click": function($event) {
          return _vm.deleteName(index)
        }
      }
    }, [_vm._v(_vm._s(_vm.$lang.actions.delete))])], 1)]], 2)
  }), 0)])]), _vm._v(" "), _c('v-layout', {
    staticClass: "px-2",
    attrs: {
      "row": "",
      "wrap": "",
      "justify-space-between": "",
      "align-center": ""
    }
  }, [_c('h3', {
    staticClass: "pa-3"
  }, [_vm._v(_vm._s(_vm.$lang.header.properties))]), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "px-3": ""
    }
  }, [_c('v-btn', {
    attrs: {
      "color": "primary mx-0"
    },
    on: {
      "click": function($event) {
        return _vm.addPropertyCode()
      }
    }
  }, [_vm._v("\n            " + _vm._s(_vm.$lang.labels.addProperty) + "\n          ")])], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "px-3": "",
      "pb-3": ""
    }
  }, [(_vm.properties) ? _c('v-data-table', {
    staticClass: "elevation-0 mt-2",
    attrs: {
      "headers": _vm.headers,
      "items": _vm.properties,
      "hide-actions": ""
    },
    scopedSlots: _vm._u([{
      key: "items",
      fn: function(props) {
        return [_c('td', [_vm._v(_vm._s(props.item.name))]), _vm._v(" "), (['desktop.image', 'tablet.image'].includes(props.item.name)) ? _c('td', [_c('v-img', {
          attrs: {
            "src": props.item.value,
            "contain": "",
            "height": "100"
          }
        })], 1) : _c('td', [_vm._v(_vm._s(props.item.value))]), _vm._v(" "), _c('td', [_c('v-btn', {
          staticClass: "primary mx-0",
          on: {
            "click": function($event) {
              return _vm.editPropertyCode(props.item)
            }
          }
        }, [_vm._v("\n                  " + _vm._s(_vm.$lang.actions.edit) + "\n                ")]), _vm._v(" "), _c('v-btn', {
          staticClass: "error mx-0",
          on: {
            "click": function($event) {
              return _vm.confirmDeletePropertyCode(props.item)
            }
          }
        }, [_vm._v("\n                  " + _vm._s(_vm.$lang.actions.delete) + "\n                ")])], 1)]
      }
    }], null, false, 2694922300)
  }) : _vm._e()], 1)], 1), _vm._v(" "), _c('v-layout', {
    staticClass: "px-2",
    attrs: {
      "row": "",
      "wrap": "",
      "justify-space-between": ""
    }
  }, [(_vm.isEdit && _vm.createdOn) ? _c('v-text-field', {
    staticClass: "min-w max-w mx-3",
    attrs: {
      "label": _vm.$lang.labels.created,
      "readonly": ""
    },
    model: {
      value: (_vm.createdOn),
      callback: function($$v) {
        _vm.createdOn = $$v
      },
      expression: "createdOn"
    }
  }) : _vm._e(), _vm._v(" "), (_vm.isEdit && _vm.modifiedOn) ? _c('v-text-field', {
    staticClass: "min-w max-w mx-3",
    attrs: {
      "label": _vm.$lang.labels.modified,
      "readonly": ""
    },
    model: {
      value: (_vm.modifiedOn),
      callback: function($$v) {
        _vm.modifiedOn = $$v
      },
      expression: "modifiedOn"
    }
  }) : _vm._e()], 1), _vm._v(" "), _c('v-layout', {
    staticClass: "mt-3 px-2",
    attrs: {
      "row": "",
      "wrap": "",
      "justify-space-between": "",
      "align-content-center": ""
    }
  }, [_c('v-btn', {
    staticClass: "mx-3",
    attrs: {
      "flat": ""
    },
    on: {
      "click": function($event) {
        return _vm.$router.push({
          name: 'tableCategories'
        })
      }
    }
  }, [_c('v-icon', [_vm._v("keyboard_arrow_left")]), _vm._v("\n          " + _vm._s(_vm.$lang.actions.close) + "\n        ")], 1), _vm._v(" "), _c('v-btn', {
    staticClass: "primary mx-3",
    attrs: {
      "disabled": !_vm.valid
    },
    on: {
      "click": _vm.submit
    }
  }, [_vm._v("\n          " + _vm._s(_vm.$lang.actions.submit) + "\n        ")])], 1)], 1)], 1), _vm._v(" "), (_vm.propertyModal) ? _c('v-dialog', {
    attrs: {
      "persistent": "",
      "max-width": "1200"
    },
    model: {
      value: (_vm.propertyModal),
      callback: function($$v) {
        _vm.propertyModal = $$v
      },
      expression: "propertyModal"
    }
  }, [_c('properties-modal', {
    attrs: {
      "title": _vm.isPropertyEdit ? 'Edit Property' : 'Add Property',
      "htmlCode": _vm.propertyCodeToEdit,
      "isHtmlEdit": _vm.isPropertyEdit,
      "htmlKeysListFiltered": _vm.propertiesKeysListFiltered
    },
    on: {
      "submit": function($event) {
        return _vm.savePropertiesCode($event)
      },
      "close": function($event) {
        _vm.propertyModal = false, _vm.propertyCodeToEdit = null, _vm.tempIndex = null
      }
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.confirmationModal) ? _c('v-dialog', {
    attrs: {
      "persistent": "",
      "max-width": "500"
    },
    model: {
      value: (_vm.confirmationModal),
      callback: function($$v) {
        _vm.confirmationModal = $$v
      },
      expression: "confirmationModal"
    }
  }, [_c('confirmation-modal', {
    attrs: {
      "text": _vm.$lang.actions.deleteProperty
    },
    on: {
      "submit": function($event) {
        return _vm.deletePropertyCode()
      },
      "close": function($event) {
        _vm.confirmationModal = false;
        _vm.tempIndex = null
      }
    }
  })], 1) : _vm._e()], 1)
},staticRenderFns: []}

/***/ }),
/* 403 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-flex', {
    attrs: {
      "xs12": "",
      "sm10": "",
      "md8": ""
    }
  }, [_c('v-card', {
    staticClass: "py-4"
  }, [(_vm.err) ? _c('v-flex', {
    attrs: {
      "xs12": "",
      "px-4": ""
    }
  }, [_c('v-alert', {
    attrs: {
      "type": "error",
      "value": true
    }
  }, [_vm._v(_vm._s(_vm.err))])], 1) : _vm._e(), _vm._v(" "), (_vm.success) ? _c('v-flex', {
    attrs: {
      "xs12": "",
      "px-4": ""
    }
  }, [_c('v-alert', {
    attrs: {
      "type": "success",
      "value": true
    }
  }, [_vm._v(_vm._s(_vm.success))])], 1) : _vm._e(), _vm._v(" "), _c('v-form', {
    model: {
      value: (_vm.valid),
      callback: function($$v) {
        _vm.valid = $$v
      },
      expression: "valid"
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": "",
      "md6": "",
      "px-4": ""
    }
  }, [_c('v-autocomplete', {
    attrs: {
      "items": _vm.companies,
      "label": _vm.$lang.actions.selectCompany,
      "readonly": _vm.isEdit,
      "item-text": "name",
      "item-value": "id",
      "required": "",
      "loading": _vm.companyLoading,
      "rules": [function (v) { return !!v || ("" + (_vm.$lang.errors.missingCompany)); }]
    },
    model: {
      value: (_vm.companyId),
      callback: function($$v) {
        _vm.companyId = $$v
      },
      expression: "companyId"
    }
  })], 1), _vm._v(" "), _c('v-layout', {
    staticClass: "px-2",
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": "",
      "md6": "",
      "px-3": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "Domain Name",
      "rules": [function (v) { return !!v || ("" + (_vm.$lang.errors.missingDomain)); }],
      "required": ""
    },
    model: {
      value: (_vm.domainName),
      callback: function($$v) {
        _vm.domainName = $$v
      },
      expression: "domainName"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "md6": "",
      "px-3": ""
    }
  }, [_c('v-autocomplete', {
    attrs: {
      "items": _vm.types,
      "label": _vm.$lang.labels.domainType,
      "loading": _vm.domainLoading,
      "rules": [function (v) { return !!v || ("" + (_vm.$lang.errors.missingDomainType)); }],
      "required": ""
    },
    model: {
      value: (_vm.domainType),
      callback: function($$v) {
        _vm.domainType = $$v
      },
      expression: "domainType"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "md6": "",
      "px-3": ""
    }
  }, [_c('v-menu', {
    ref: "menu",
    attrs: {
      "close-on-content-click": false,
      "nudge-right": 40,
      "return-value": _vm.registeredOn,
      "lazy": "",
      "transition": "scale-transition",
      "offset-y": "",
      "full-width": "",
      "min-width": "290px"
    },
    on: {
      "update:returnValue": function($event) {
        _vm.registeredOn = $event
      },
      "update:return-value": function($event) {
        _vm.registeredOn = $event
      }
    },
    model: {
      value: (_vm.menu),
      callback: function($$v) {
        _vm.menu = $$v
      },
      expression: "menu"
    }
  }, [_c('v-text-field', {
    attrs: {
      "slot": "activator",
      "required": "",
      "rules": [function (v) { return !!v || ("" + (_vm.$lang.errors.missingRegisteredOn)); }],
      "label": "Registration Date",
      "prepend-icon": "event",
      "readonly": ""
    },
    slot: "activator",
    model: {
      value: (_vm.formattedRegisteredOn),
      callback: function($$v) {
        _vm.formattedRegisteredOn = $$v
      },
      expression: "formattedRegisteredOn"
    }
  }), _vm._v(" "), _c('v-date-picker', {
    attrs: {
      "no-title": "",
      "scrollable": "",
      "color": "primary"
    },
    on: {
      "input": function($event) {
        return _vm.$refs.menu.save(_vm.registeredOn)
      }
    },
    model: {
      value: (_vm.registeredOn),
      callback: function($$v) {
        _vm.registeredOn = $$v
      },
      expression: "registeredOn"
    }
  })], 1)], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "md6": "",
      "px-3": ""
    }
  }, [_c('v-menu', {
    ref: "menu2",
    attrs: {
      "close-on-content-click": false,
      "nudge-right": 40,
      "return-value": _vm.deregisteredOn,
      "lazy": "",
      "transition": "scale-transition",
      "offset-y": "",
      "full-width": "",
      "min-width": "290px"
    },
    on: {
      "update:returnValue": function($event) {
        _vm.deregisteredOn = $event
      },
      "update:return-value": function($event) {
        _vm.deregisteredOn = $event
      }
    },
    model: {
      value: (_vm.menu2),
      callback: function($$v) {
        _vm.menu2 = $$v
      },
      expression: "menu2"
    }
  }, [_c('v-text-field', {
    attrs: {
      "slot": "activator",
      "label": "Deregistration Date",
      "prepend-icon": "event",
      "readonly": ""
    },
    slot: "activator",
    model: {
      value: (_vm.formattedDeregisteredOn),
      callback: function($$v) {
        _vm.formattedDeregisteredOn = $$v
      },
      expression: "formattedDeregisteredOn"
    }
  }), _vm._v(" "), _c('v-date-picker', {
    attrs: {
      "no-title": "",
      "scrollable": "",
      "color": "primary"
    },
    on: {
      "input": function($event) {
        return _vm.$refs.menu2.save(_vm.deregisteredOn)
      }
    },
    model: {
      value: (_vm.deregisteredOn),
      callback: function($$v) {
        _vm.deregisteredOn = $$v
      },
      expression: "deregisteredOn"
    }
  })], 1)], 1)], 1)], 1), _vm._v(" "), _c('v-layout', {
    staticClass: "px-2",
    attrs: {
      "row": "",
      "wrap": "",
      "justify-space-between": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": "",
      "md6": "",
      "px-3": ""
    }
  }, [(_vm.isEdit && _vm.createdOn) ? _c('v-text-field', {
    attrs: {
      "label": _vm.$lang.labels.created,
      "readonly": ""
    },
    model: {
      value: (_vm.createdOn),
      callback: function($$v) {
        _vm.createdOn = $$v
      },
      expression: "createdOn"
    }
  }) : _vm._e()], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "md6": "",
      "px-3": ""
    }
  }, [(_vm.isEdit && _vm.modifiedOn) ? _c('v-text-field', {
    attrs: {
      "label": _vm.$lang.labels.modified,
      "readonly": ""
    },
    model: {
      value: (_vm.modifiedOn),
      callback: function($$v) {
        _vm.modifiedOn = $$v
      },
      expression: "modifiedOn"
    }
  }) : _vm._e()], 1)], 1), _vm._v(" "), _c('v-layout', {
    staticClass: "px-2",
    attrs: {
      "row": "",
      "justify-space-between": ""
    }
  }, [_c('v-btn', {
    staticClass: "mx-3",
    attrs: {
      "flat": ""
    },
    on: {
      "click": function($event) {
        return _vm.$router.push({
          name: 'domains'
        })
      }
    }
  }, [_c('v-icon', [_vm._v("keyboard_arrow_left")]), _vm._v(" Close")], 1), _vm._v(" "), _c('v-btn', {
    staticClass: "primary mx-3",
    attrs: {
      "disabled": !_vm.valid
    },
    on: {
      "click": function($event) {
        return _vm.submit()
      }
    }
  }, [_vm._v(_vm._s(_vm.isEdit ? _vm.$lang.actions.update : _vm.$lang.actions.create))])], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 404 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-card', [(_vm.err) ? _c('v-flex', {
    attrs: {
      "xs12": "",
      "px-4": ""
    }
  }, [_c('v-alert', {
    attrs: {
      "value": true,
      "type": "error"
    }
  }, [_vm._v(_vm._s(_vm.err))])], 1) : _vm._e(), _vm._v(" "), _c('v-card-title', {
    staticClass: "py-3 px-2 layout row wrap"
  }, [_c('v-btn', {
    staticClass: "primary my-0 mx-3",
    on: {
      "click": function($event) {
        return _vm.$router.push({
          name: "imageCreate"
        })
      }
    }
  }, [_vm._v(_vm._s(_vm.$lang.actions.addImage))]), _vm._v(" "), _c('v-checkbox', {
    staticClass: "mx-1 mt-0",
    attrs: {
      "color": "primary",
      "label": _vm.$lang.labels.showActive,
      "hide-details": ""
    },
    model: {
      value: (_vm.showActive),
      callback: function($$v) {
        _vm.showActive = $$v
      },
      expression: "showActive"
    }
  }), _vm._v(" "), _c('v-spacer'), _vm._v(" "), (!_vm.isLocalAdmin) ? _c('v-autocomplete', {
    staticClass: "min-w max-w mx-3 pb-2",
    attrs: {
      "label": _vm.$lang.actions.selectCompany,
      "items": _vm.mappedCompanies,
      "hide-details": ""
    },
    model: {
      value: (_vm.selectedCompany),
      callback: function($$v) {
        _vm.selectedCompany = $$v
      },
      expression: "selectedCompany"
    }
  }) : _vm._e(), _vm._v(" "), (_vm.show) ? _c('v-text-field', {
    staticClass: "min-w max-w mx-3 pb-2",
    attrs: {
      "append-icon": "search",
      "label": _vm.$lang.labels.search,
      "hide-details": ""
    },
    model: {
      value: (_vm.search),
      callback: function($$v) {
        _vm.search = $$v
      },
      expression: "search"
    }
  }) : _vm._e()], 1), _vm._v(" "), (_vm.show) ? _c('v-data-table', {
    attrs: {
      "headers": _vm.headers,
      "items": _vm.showActive ? _vm.activeImages : _vm.allImages,
      "search": _vm.search,
      "loading": _vm.loading,
      "rows-per-page-items": [50, 100, 250, 500, {
        text: 'All',
        value: -1
      }]
    },
    scopedSlots: _vm._u([{
      key: "items",
      fn: function(props) {
        return [_c('td', [_vm._v(_vm._s(props.item.name))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(props.item.label))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(props.item.id))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(props.item.publiclyAvailable ? 'Yes' : 'No'))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.$lang.labels[props.item.status]))]), _vm._v(" "), _c('td', {
          staticClass: "min-w-lg"
        }, [_c('v-btn', {
          staticClass: "primary mx-0 elevation-1",
          on: {
            "click": function($event) {
              return _vm.$router.push({
                name: 'image',
                params: {
                  id: props.item.id
                }
              })
            }
          }
        }, [_vm._v(_vm._s(_vm.$lang.actions.edit))]), _vm._v(" "), _c('v-btn', {
          staticClass: "primary elevation-1",
          on: {
            "click": function($event) {
              return _vm.changeStatus(props.item)
            }
          }
        }, [_vm._v(_vm._s(props.item.status === 'active' ? _vm.$lang.actions.deactivate : _vm.$lang.actions.activate))])], 1)]
      }
    }], null, false, 3208712619)
  }, [_c('v-progress-linear', {
    attrs: {
      "slot": "progress",
      "height": "6",
      "color": "primary",
      "indeterminate": ""
    },
    slot: "progress"
  }), _vm._v(" "), _vm._v(" "), _c('v-alert', {
    attrs: {
      "slot": "no-results",
      "value": true,
      "color": "warning",
      "icon": "warning"
    },
    slot: "no-results"
  }, [_vm._v("\n        Your search for \"" + _vm._s(_vm.search) + "\" found no results.\n      ")])], 1) : _vm._e()], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 405 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-flex', {
    attrs: {
      "xs12": "",
      "sm10": "",
      "md8": ""
    }
  }, [_c('v-card', {
    staticClass: "py-4"
  }, [(_vm.err) ? _c('v-flex', {
    attrs: {
      "xs12": "",
      "px-4": "",
      "pb-4": ""
    }
  }, [_c('v-alert', {
    attrs: {
      "type": "error",
      "value": true
    }
  }, [_vm._v(_vm._s(_vm.err))])], 1) : _vm._e(), _vm._v(" "), (_vm.success) ? _c('v-flex', {
    attrs: {
      "xs12": "",
      "px-4": "",
      "pb-4": ""
    }
  }, [_c('v-alert', {
    attrs: {
      "type": "success",
      "value": true
    }
  }, [_vm._v(_vm._s(_vm.success))])], 1) : _vm._e(), _vm._v(" "), _c('v-form', {
    model: {
      value: (_vm.valid),
      callback: function($$v) {
        _vm.valid = $$v
      },
      expression: "valid"
    }
  }, [_c('v-layout', {
    staticClass: "px-2",
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": "",
      "md6": "",
      "px-3": ""
    }
  }, [_c('v-autocomplete', {
    attrs: {
      "items": _vm.companies,
      "label": _vm.$lang.actions.selectCompany,
      "readonly": _vm.isEdit,
      "item-text": "name",
      "item-value": "id",
      "required": "",
      "loading": _vm.companyLoading,
      "rules": [function (v) { return !!v || ("" + (_vm.$lang.errors.missingCompany)); }]
    },
    model: {
      value: (_vm.register.companyId),
      callback: function($$v) {
        _vm.$set(_vm.register, "companyId", $$v)
      },
      expression: "register.companyId"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "md6": "",
      "px-3": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": _vm.$lang.labels.cashRegisterName,
      "readonly": _vm.isEdit,
      "rules": [function (v) { return !!v || ("" + (_vm.$lang.errors.required)); }],
      "required": ""
    },
    model: {
      value: (_vm.register.cashRegisterName),
      callback: function($$v) {
        _vm.$set(_vm.register, "cashRegisterName", $$v)
      },
      expression: "register.cashRegisterName"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "md6": "",
      "px-3": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": _vm.$lang.labels.username,
      "readonly": _vm.register.status !== 'NEWENTRY' && _vm.isEdit,
      "rules": [function (v) { return !!v || ("" + (_vm.$lang.errors.required)); }],
      "required": ""
    },
    model: {
      value: (_vm.register.username),
      callback: function($$v) {
        _vm.$set(_vm.register, "username", $$v)
      },
      expression: "register.username"
    }
  })], 1), _vm._v(" "), (_vm.register.status === 'NEWENTRY' || !_vm.isEdit) ? _c('v-flex', {
    attrs: {
      "xs12": "",
      "md6": "",
      "px-3": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": _vm.$lang.labels.password,
      "rules": [function (v) { return !!v || ("" + (_vm.$lang.errors.required)); }],
      "required": ""
    },
    model: {
      value: (_vm.register.password),
      callback: function($$v) {
        _vm.$set(_vm.register, "password", $$v)
      },
      expression: "register.password"
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.isEdit) ? _c('v-flex', {
    attrs: {
      "xs12": "",
      "md6": "",
      "px-3": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": _vm.$lang.labels.aesKey,
      "readonly": ""
    },
    model: {
      value: (_vm.register.aesKey),
      callback: function($$v) {
        _vm.$set(_vm.register, "aesKey", $$v)
      },
      expression: "register.aesKey"
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.isEdit) ? _c('v-flex', {
    attrs: {
      "xs12": "",
      "md6": "",
      "px-3": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": _vm.$lang.labels.aesKeyCheckSum,
      "readonly": ""
    },
    model: {
      value: (_vm.register.aesKeyCheckSum),
      callback: function($$v) {
        _vm.$set(_vm.register, "aesKeyCheckSum", $$v)
      },
      expression: "register.aesKeyCheckSum"
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.isEdit) ? _c('v-flex', {
    attrs: {
      "xs12": "",
      "md6": "",
      "px-3": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": _vm.$lang.labels.depAccessKey,
      "readonly": ""
    },
    model: {
      value: (_vm.register.depAccessKey),
      callback: function($$v) {
        _vm.$set(_vm.register, "depAccessKey", $$v)
      },
      expression: "register.depAccessKey"
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.isEdit) ? _c('v-flex', {
    attrs: {
      "xs12": "",
      "md6": "",
      "px-3": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": _vm.$lang.labels.status,
      "readonly": ""
    },
    model: {
      value: (_vm.register.status),
      callback: function($$v) {
        _vm.$set(_vm.register, "status", $$v)
      },
      expression: "register.status"
    }
  })], 1) : _vm._e()], 1)], 1), _vm._v(" "), (_vm.isEdit && _vm.register.status !== 'CLOSED') ? _c('v-flex', {
    attrs: {
      "mx-3": ""
    }
  }, [_c('h3', {
    staticClass: "mt-3 mx-2"
  }, [_vm._v(_vm._s(_vm.$lang.labels.actions) + ":")]), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [(_vm.register.status !== 'CLOSED' && _vm.register.status === 'NEWENTRY') ? _c('v-btn', {
    attrs: {
      "color": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.updateReciept('register')
      }
    }
  }, [_vm._v(_vm._s(_vm.$lang.actions.registerReciept))]) : _vm._e(), _vm._v(" "), (_vm.register.status !== 'CLOSED' && _vm.register.status === 'REGISTERED') ? _c('v-btn', {
    attrs: {
      "color": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.updateReciept('start')
      }
    }
  }, [_vm._v(_vm._s(_vm.$lang.actions.startReciept))]) : _vm._e(), _vm._v(" "), (_vm.register.status !== 'CLOSED' && _vm.register.status === 'INUSE') ? _c('v-btn', {
    attrs: {
      "color": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.updateReciept('null')
      }
    }
  }, [_vm._v(_vm._s(_vm.$lang.actions.nullReciept))]) : _vm._e(), _vm._v(" "), (_vm.register.status !== 'CLOSED' && _vm.register.status === 'INUSE') ? _c('v-btn', {
    attrs: {
      "color": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.updateReciept('end')
      }
    }
  }, [_vm._v(_vm._s(_vm.$lang.actions.endReciept))]) : _vm._e()], 1)], 1) : _vm._e(), _vm._v(" "), _c('v-layout', {
    staticClass: "px-2",
    attrs: {
      "row": "",
      "wrap": "",
      "justify-space-between": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": "",
      "md6": "",
      "px-3": ""
    }
  }, [(_vm.isEdit && _vm.register.createdOn) ? _c('v-text-field', {
    attrs: {
      "label": _vm.$lang.labels.created,
      "readonly": ""
    },
    model: {
      value: (_vm.register.createdOn),
      callback: function($$v) {
        _vm.$set(_vm.register, "createdOn", $$v)
      },
      expression: "register.createdOn"
    }
  }) : _vm._e()], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "md6": "",
      "px-3": ""
    }
  }, [(_vm.isEdit && _vm.register.inUseFrom) ? _c('v-text-field', {
    attrs: {
      "label": _vm.$lang.labels.inUseFrom,
      "readonly": ""
    },
    model: {
      value: (_vm.register.inUseFrom),
      callback: function($$v) {
        _vm.$set(_vm.register, "inUseFrom", $$v)
      },
      expression: "register.inUseFrom"
    }
  }) : _vm._e()], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "md6": "",
      "px-3": ""
    }
  }, [(_vm.isEdit && _vm.register.modifiedOn) ? _c('v-text-field', {
    attrs: {
      "label": _vm.$lang.labels.modified,
      "readonly": ""
    },
    model: {
      value: (_vm.register.modifiedOn),
      callback: function($$v) {
        _vm.$set(_vm.register, "modifiedOn", $$v)
      },
      expression: "register.modifiedOn"
    }
  }) : _vm._e()], 1)], 1), _vm._v(" "), _c('v-layout', {
    staticClass: "px-2",
    attrs: {
      "row": "",
      "justify-space-between": ""
    }
  }, [_c('v-btn', {
    staticClass: "mx-3",
    attrs: {
      "flat": ""
    },
    on: {
      "click": function($event) {
        return _vm.$router.push({
          name: 'cashRegister'
        })
      }
    }
  }, [_c('v-icon', [_vm._v("keyboard_arrow_left")]), _vm._v(" Close")], 1), _vm._v(" "), _c('v-btn', {
    staticClass: "primary mx-3",
    attrs: {
      "disabled": !_vm.valid && _vm.register.status !== 'NEWENTRY'
    },
    on: {
      "click": function($event) {
        return _vm.submit()
      }
    }
  }, [_vm._v(_vm._s(_vm.isEdit ? _vm.$lang.actions.update : _vm.$lang.actions.create))])], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 406 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-card', [(_vm.err) ? _c('v-flex', {
    attrs: {
      "xs12": "",
      "pt-4": "",
      "px-4": ""
    }
  }, [_c('v-alert', {
    attrs: {
      "type": "error",
      "value": true
    }
  }, [_vm._v(_vm._s(_vm.err))])], 1) : _vm._e(), _vm._v(" "), _c('v-card-title', {
    staticClass: "pb-3 px-2 layout row wrap"
  }, [(!_vm.isLocalAdmin) ? _c('v-btn', {
    staticClass: "primary my-0 mx-3",
    on: {
      "click": function($event) {
        return _vm.$router.push({
          name: "webShopDetail"
        })
      }
    }
  }, [_vm._v("Create New Web Shop Resource")]) : _vm._e(), _vm._v(" "), _c('v-checkbox', {
    staticClass: "mx-1 mt-0",
    attrs: {
      "color": "primary",
      "label": _vm.$lang.labels.showActive,
      "hide-details": ""
    },
    model: {
      value: (_vm.showActive),
      callback: function($$v) {
        _vm.showActive = $$v
      },
      expression: "showActive"
    }
  }), _vm._v(" "), _c('v-spacer'), _vm._v(" "), (!_vm.isLocalAdmin) ? _c('v-autocomplete', {
    staticClass: "min-w max-w mx-3 pb-2",
    attrs: {
      "label": _vm.$lang.actions.selectCompany,
      "items": _vm.mappedCompanies,
      "loading": _vm.companyLoading,
      "hide-details": ""
    },
    model: {
      value: (_vm.selectedCompany),
      callback: function($$v) {
        _vm.selectedCompany = $$v
      },
      expression: "selectedCompany"
    }
  }) : _vm._e(), _vm._v(" "), (_vm.show) ? _c('v-text-field', {
    staticClass: "min-w max-w mx-3 pb-2",
    attrs: {
      "append-icon": "search",
      "label": _vm.$lang.labels.search,
      "hide-details": ""
    },
    model: {
      value: (_vm.search),
      callback: function($$v) {
        _vm.search = $$v
      },
      expression: "search"
    }
  }) : _vm._e()], 1), _vm._v(" "), (_vm.show) ? _c('v-data-table', {
    attrs: {
      "headers": _vm.headers,
      "items": _vm.showActive ? _vm.activeWebShops : _vm.allWebShops,
      "search": _vm.search,
      "loading": _vm.loading,
      "rows-per-page-items": [50, 100, 250, 500, {
        text: 'All',
        value: -1
      }]
    },
    scopedSlots: _vm._u([{
      key: "items",
      fn: function(props) {
        return [_c('td', {
          staticClass: "min-w"
        }, [_vm._v(_vm._s(props.item.name))]), _vm._v(" "), _c('td', {
          staticClass: "min-w"
        }, [_vm._v(_vm._s(props.item.webShopResourceExternalId))]), _vm._v(" "), _c('td', {
          staticClass: "text-xs-left min-w"
        }, [_vm._v(_vm._s(props.item.companyName))]), _vm._v(" "), _c('td', {
          staticClass: "text-xs-left"
        }, [_vm._v("\n          " + _vm._s(props.item.pendingOrders) + "\n          "), _c('v-btn', {
          staticClass: "primary",
          attrs: {
            "fab": "",
            "small": "",
            "outline": ""
          },
          on: {
            "click": function($event) {
              return _vm.showOrder(props.item)
            }
          }
        }, [_c('v-icon', {
          staticClass: "primary--text"
        }, [_vm._v("arrow_forward")])], 1)], 1), _vm._v(" "), _c('td', {
          staticClass: "text-xs-left"
        }, [(props.item.lastPendingShortOrderId || props.item.lastPendingOrderId) ? _c('v-btn', {
          staticClass: "primary--text mx-0",
          attrs: {
            "flat": ""
          },
          on: {
            "click": function($event) {
              return _vm.showModal(props.item)
            }
          }
        }, [_vm._v("\n            " + _vm._s(props.item.lastPendingShortOrderId || props.item.lastPendingOrderId) + "\n          ")]) : _vm._e()], 1), _vm._v(" "), _c('td', {
          staticClass: "text-xs-left"
        }, [_vm._v(_vm._s(props.item.status))]), _vm._v(" "), _c('td', {
          staticClass: "text-xs-left"
        }, [_vm._v(_vm._s(_vm.formatDate(props.item.createdOn)))]), _vm._v(" "), _c('td', {
          staticClass: "text-xs-left min-w-lg"
        }, [_c('v-btn', {
          staticClass: "primary mx-0 elevation-1",
          on: {
            "click": function($event) {
              return _vm.$router.push({
                name: 'webShopEdit',
                params: {
                  id: props.item.id
                }
              })
            }
          }
        }, [_vm._v(_vm._s(_vm.$lang.actions.edit))]), _vm._v(" "), _c('v-btn', {
          staticClass: "primary elevation-1",
          on: {
            "click": function($event) {
              return _vm.changeStatus(props.item)
            }
          }
        }, [_vm._v("\n          " + _vm._s(props.item.status === 'active' ? _vm.$lang.actions.deactivate : _vm.$lang.actions.activate) + "\n        ")])], 1)]
      }
    }], null, false, 3604374684)
  }, [_c('v-progress-linear', {
    attrs: {
      "slot": "progress",
      "height": "6",
      "color": "primary",
      "indeterminate": ""
    },
    slot: "progress"
  }), _vm._v(" "), _vm._v(" "), _c('v-alert', {
    attrs: {
      "slot": "no-results",
      "value": true,
      "color": "warning",
      "icon": "warning"
    },
    slot: "no-results"
  }, [_vm._v("\n        Your search for \"" + _vm._s(_vm.search) + "\" found no results.\n      ")])], 1) : _vm._e()], 1), _vm._v(" "), (_vm.lastOrderModal) ? _c('v-dialog', {
    attrs: {
      "max-width": "1200"
    },
    model: {
      value: (_vm.lastOrderModal),
      callback: function($$v) {
        _vm.lastOrderModal = $$v
      },
      expression: "lastOrderModal"
    }
  }, [_c('last-order-modal', {
    attrs: {
      "lastOrder": _vm.lastOrder
    },
    on: {
      "close": function($event) {
        _vm.lastOrderModal = false
      }
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.confirmationModal) ? _c('v-dialog', {
    attrs: {
      "max-width": "500"
    },
    model: {
      value: (_vm.confirmationModal),
      callback: function($$v) {
        _vm.confirmationModal = $$v
      },
      expression: "confirmationModal"
    }
  }, [_c('confirmation-modal', {
    attrs: {
      "data": _vm.confirmationData
    },
    on: {
      "close": function($event) {
        _vm.confirmationModal = false
      },
      "change": function($event) {
        return _vm.deactivate($event)
      }
    }
  })], 1) : _vm._e()], 1)
},staticRenderFns: []}

/***/ }),
/* 407 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    staticClass: "login-image hidden-sm-and-down",
    attrs: {
      "xs12": "",
      "sm6": ""
    }
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(63),
      "alt": ""
    }
  })]), _vm._v(" "), _c('v-layout', {
    staticClass: "pa-3 sign-up",
    attrs: {
      "justify-center": "",
      "align-center": ""
    }
  }, [_c('router-link', {
    attrs: {
      "to": {
        name: 'signUp'
      }
    }
  }, [_vm._v(_vm._s(_vm.$lang.labels.signUp))])], 1), _vm._v(" "), _c('v-layout', {
    staticClass: "pa-4",
    attrs: {
      "justify-center": "",
      "align-center": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": "",
      "sm6": ""
    }
  }, [_c('h1', {
    staticClass: "mb-4"
  }, [_vm._v(_vm._s(_vm.$lang.global.projectName))]), _vm._v(" "), (_vm.err) ? _c('v-alert', {
    staticClass: "err",
    attrs: {
      "color": "error",
      "value": true,
      "icon": "warning",
      "type": "error"
    }
  }, [_vm._v("\n        " + _vm._s(_vm.err) + "\n      ")]) : _vm._e(), _vm._v(" "), _c('v-form', [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "color": "primary",
      "type": "text",
      "name": "userName",
      "label": _vm.$lang.labels.username,
      "required": ""
    },
    model: {
      value: (_vm.formData.userName),
      callback: function($$v) {
        _vm.$set(_vm.formData, "userName", $$v)
      },
      expression: "formData.userName"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "color": "primary",
      "type": "password",
      "name": "password",
      "label": _vm.$lang.labels.password,
      "required": ""
    },
    model: {
      value: (_vm.formData.password),
      callback: function($$v) {
        _vm.$set(_vm.formData, "password", $$v)
      },
      expression: "formData.password"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "text-xs-left": ""
    }
  }, [_c('v-btn', {
    staticClass: "mx-0",
    attrs: {
      "disabled": _vm.loginProcessStarted,
      "color": "primary",
      "type": "submit"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.submit($event)
      }
    }
  }, [_vm._v(_vm._s(_vm.$lang.actions.submit))])], 1), _vm._v(" "), (_vm.version) ? _c('v-layout', {
    staticClass: "justify-space-between",
    attrs: {
      "pt-3": "",
      "px-1": ""
    }
  }, [(_vm.version.fe) ? _c('span', {
    staticClass: "info-text"
  }, [_c('small', [_vm._v(_vm._s(_vm.$lang.labels.frontEndVersion) + ": " + _vm._s(_vm.version.fe))])]) : _vm._e(), _vm._v(" "), (_vm.version.be) ? _c('span', {
    staticClass: "info-text"
  }, [_c('small', [_vm._v(_vm._s(_vm.$lang.labels.backendversion) + ": " + _vm._s(_vm.version.be))])]) : _vm._e()]) : _vm._e()], 1)], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 408 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-flex', {
    attrs: {
      "xs12": "",
      "sm10": "",
      "md8": "",
      "lg6": ""
    }
  }, [_c('v-card', {
    staticClass: "pa-4"
  }, [(_vm.err) ? _c('v-flex', {
    attrs: {
      "xs12": "",
      "pb-3": ""
    }
  }, [_c('v-alert', {
    attrs: {
      "value": true,
      "type": "error"
    }
  }, [_vm._v(_vm._s(_vm.err))])], 1) : _vm._e(), _vm._v(" "), (_vm.success) ? _c('v-flex', {
    attrs: {
      "xs12": "",
      "pb-3": ""
    }
  }, [_c('v-alert', {
    attrs: {
      "value": true,
      "type": "success"
    }
  }, [_vm._v(_vm._s(_vm.success))])], 1) : _vm._e(), _vm._v(" "), _c('v-form', {
    model: {
      value: (_vm.valid),
      callback: function($$v) {
        _vm.valid = $$v
      },
      expression: "valid"
    }
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": "",
      "justify-space-between": "",
      "align-center": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-autocomplete', {
    attrs: {
      "items": _vm.companies,
      "label": _vm.$lang.actions.selectCompany,
      "item-text": "name",
      "item-value": "id",
      "required": "",
      "readonly": _vm.isEdit,
      "loading": _vm.companyLoading,
      "rules": [function (v) { return !!v || ("" + (_vm.$lang.errors.missingCompany)); }]
    },
    model: {
      value: (_vm.callerIdServer.companyId),
      callback: function($$v) {
        _vm.$set(_vm.callerIdServer, "companyId", $$v)
      },
      expression: "callerIdServer.companyId"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": _vm.$lang.labels.name,
      "required": "",
      "rules": [function (v) { return !!v || ("" + (_vm.$lang.errors.missingCallerIdName)); }]
    },
    model: {
      value: (_vm.callerIdServer.name),
      callback: function($$v) {
        _vm.$set(_vm.callerIdServer, "name", $$v)
      },
      expression: "callerIdServer.name"
    }
  })], 1), _vm._v(" "), (_vm.isEdit) ? _c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-textarea', {
    attrs: {
      "id": "key",
      "label": _vm.$lang.labels.key,
      "auto-grow": "",
      "rows": "1",
      "readonly": _vm.isEdit
    },
    model: {
      value: (_vm.callerIdServer.callerIdKey),
      callback: function($$v) {
        _vm.$set(_vm.callerIdServer, "callerIdKey", $$v)
      },
      expression: "callerIdServer.callerIdKey"
    }
  })], 1) : _vm._e()], 1), _vm._v(" "), _c('v-layout', {
    staticClass: "mt-3",
    attrs: {
      "row": "",
      "wrap": "",
      "justify-space-between": "",
      "align-content-center": ""
    }
  }, [_c('v-btn', {
    staticClass: "ml-0",
    attrs: {
      "flat": ""
    },
    on: {
      "click": function($event) {
        return _vm.$router.push({
          name: 'callerIdServers'
        })
      }
    }
  }, [_c('v-icon', [_vm._v("keyboard_arrow_left")]), _vm._v("\n          " + _vm._s(_vm.$lang.actions.close) + "\n        ")], 1), _vm._v(" "), _c('div', [(_vm.isEdit) ? _c('v-btn', {
    staticClass: "primary",
    on: {
      "click": _vm.copyKey
    }
  }, [_vm._v("\n            " + _vm._s(_vm.$lang.actions.copyKey) + "\n          ")]) : _vm._e(), _vm._v(" "), _c('v-btn', {
    staticClass: "primary mx-0",
    attrs: {
      "disabled": !_vm.valid
    },
    on: {
      "click": _vm.submit
    }
  }, [_vm._v("\n            " + _vm._s(_vm.isEdit ? _vm.$lang.actions.update : _vm.$lang.actions.create) + "\n          ")])], 1)], 1)], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 409 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-card', [(_vm.err) ? _c('v-flex', {
    attrs: {
      "xs12": "",
      "px-4": ""
    }
  }, [_c('v-alert', {
    attrs: {
      "value": true,
      "type": "error"
    }
  }, [_vm._v(_vm._s(_vm.err))])], 1) : _vm._e(), _vm._v(" "), _c('v-card-title', {
    staticClass: "pb-4 px-3 layout row wrap"
  }, [_c('v-btn', {
    staticClass: "primary ma-0",
    attrs: {
      "disabled": !_vm.selectedCompany
    },
    on: {
      "click": function($event) {
        return _vm.$router.push({
          name: "discountCreate",
          params: {
            companyId: _vm.selectedCompany
          }
        })
      }
    }
  }, [_vm._v("\n        " + _vm._s(_vm.$lang.actions.createDiscount) + "\n      ")]), _vm._v(" "), _c('v-checkbox', {
    staticClass: "ml-3 mt-0",
    attrs: {
      "color": "primary",
      "label": _vm.$lang.labels.showActive,
      "hide-details": ""
    },
    model: {
      value: (_vm.showActive),
      callback: function($$v) {
        _vm.showActive = $$v
      },
      expression: "showActive"
    }
  }), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('v-autocomplete', {
    staticClass: "min-w max-w mx-2",
    attrs: {
      "label": _vm.$lang.actions.selectCompany,
      "items": _vm.mappedCompanies,
      "loading": _vm.companyLoading,
      "hide-details": ""
    },
    model: {
      value: (_vm.selectedCompany),
      callback: function($$v) {
        _vm.selectedCompany = $$v
      },
      expression: "selectedCompany"
    }
  }), _vm._v(" "), (_vm.show) ? _c('v-text-field', {
    staticClass: "min-w max-w mx-2",
    attrs: {
      "append-icon": "search",
      "label": _vm.$lang.labels.search,
      "hide-details": ""
    },
    model: {
      value: (_vm.search),
      callback: function($$v) {
        _vm.search = $$v
      },
      expression: "search"
    }
  }) : _vm._e()], 1), _vm._v(" "), (_vm.show) ? _c('v-data-table', {
    attrs: {
      "headers": _vm.headers,
      "items": _vm.showActive ? _vm.activeDiscounts : _vm.allDiscounts,
      "search": _vm.search,
      "loading": _vm.loading,
      "rows-per-page-items": [50, 100, 250, 500, {
        text: 'All',
        value: -1
      }]
    },
    scopedSlots: _vm._u([{
      key: "items",
      fn: function(props) {
        return [_c('td', {
          staticClass: "min-w"
        }, [_vm._v(_vm._s(props.item.ruleName))]), _vm._v(" "), _c('td', {
          staticClass: "min-w"
        }, [_vm._v(_vm._s(_vm.formatDate(props.item.createdOn)))]), _vm._v(" "), _c('td', {
          staticClass: "max-w"
        }, [_vm._v(_vm._s(props.item.status))]), _vm._v(" "), _c('td', {
          staticClass: "min-w-lg"
        }, [_c('v-btn', {
          staticClass: "primary mx-0 elevation-1",
          on: {
            "click": function($event) {
              return _vm.$router.push({
                name: 'discountEdit',
                params: {
                  id: props.item.id
                }
              })
            }
          }
        }, [_vm._v(_vm._s(_vm.$lang.actions.edit))]), _vm._v(" "), _c('v-btn', {
          staticClass: "primary elevation-1",
          on: {
            "click": function($event) {
              return _vm.changeStatus(props.item)
            }
          }
        }, [_vm._v(_vm._s(props.item.status === 'active' ? _vm.$lang.actions.deactivate : _vm.$lang.actions.activate))])], 1)]
      }
    }], null, false, 1669056556)
  }, [_c('v-progress-linear', {
    attrs: {
      "slot": "progress",
      "height": "6",
      "color": "primary",
      "indeterminate": ""
    },
    slot: "progress"
  }), _vm._v(" "), _vm._v(" "), _c('v-alert', {
    attrs: {
      "slot": "no-results",
      "value": true,
      "color": "warning",
      "icon": "warning"
    },
    slot: "no-results"
  }, [_vm._v("\n        Your search for \"" + _vm._s(_vm.search) + "\" found no results.\n      ")])], 1) : _vm._e()], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 410 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-card', {
    staticClass: "py-4"
  }, [(_vm.err) ? _c('v-flex', {
    attrs: {
      "xs12": "",
      "px-4": ""
    }
  }, [_c('v-alert', {
    attrs: {
      "value": true,
      "type": "error"
    }
  }, [_vm._v(_vm._s(_vm.err))])], 1) : _vm._e(), _vm._v(" "), (_vm.success) ? _c('v-flex', {
    attrs: {
      "xs12": "",
      "px-4": ""
    }
  }, [_c('v-alert', {
    attrs: {
      "value": true,
      "type": "success"
    }
  }, [_vm._v(_vm._s(_vm.success))])], 1) : _vm._e(), _vm._v(" "), _c('v-form', {
    model: {
      value: (_vm.valid),
      callback: function($$v) {
        _vm.valid = $$v
      },
      expression: "valid"
    }
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": "",
      "sm8": "",
      "md6": "",
      "lg4": "",
      "px-4": ""
    }
  }, [(!_vm.isLocalAdmin) ? _c('v-autocomplete', {
    attrs: {
      "required": "",
      "disabled": _vm.isEdit,
      "loading": _vm.companyLoading,
      "rules": [function (v) { return !!v || ("" + (_vm.$lang.errors.missingCompany)); }],
      "items": _vm.companies,
      "item-text": "name",
      "item-value": "id",
      "label": _vm.$lang.actions.selectCompany
    },
    model: {
      value: (_vm.selectedCompany),
      callback: function($$v) {
        _vm.selectedCompany = $$v
      },
      expression: "selectedCompany"
    }
  }) : _vm._e(), _vm._v(" "), _c('v-autocomplete', {
    attrs: {
      "required": "",
      "disabled": _vm.categories.length === 0,
      "loading": _vm.categoriesLoading,
      "rules": [function (v) { return !!v || ("" + (_vm.$lang.errors.missingCategory)); }],
      "items": _vm.categories,
      "item-text": ("name[" + _vm.language + "]"),
      "item-value": "id",
      "label": _vm.$lang.actions.selectCategory
    },
    model: {
      value: (_vm.selectedCategory),
      callback: function($$v) {
        _vm.selectedCategory = $$v
      },
      expression: "selectedCategory"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "sm8": "",
      "md6": "",
      "lg4": "",
      "mt-2": "",
      "px-4": ""
    }
  }, [(!_vm.isEdit) ? _c('v-checkbox', {
    staticClass: "mt-1",
    attrs: {
      "color": "primary",
      "label": _vm.$lang.labels.multipleTables
    },
    model: {
      value: (_vm.multipleTables),
      callback: function($$v) {
        _vm.multipleTables = $$v
      },
      expression: "multipleTables"
    }
  }) : _vm._e(), _vm._v(" "), (!_vm.multipleTables) ? _c('v-text-field', {
    attrs: {
      "hide-details": "",
      "label": _vm.$lang.labels.sequenceNumber
    },
    model: {
      value: (_vm.sequenceNumber),
      callback: function($$v) {
        _vm.sequenceNumber = $$v
      },
      expression: "sequenceNumber"
    }
  }) : _c('v-text-field', {
    attrs: {
      "hide-details": "",
      "label": _vm.$lang.labels.numberOfTables
    },
    model: {
      value: (_vm.numberOfTables),
      callback: function($$v) {
        _vm.numberOfTables = $$v
      },
      expression: "numberOfTables"
    }
  }), _vm._v(" "), _c('v-text-field', {
    staticClass: "pt-4",
    attrs: {
      "type": "number",
      "min": "1",
      "max": "99",
      "rules": [_vm.rules.counter],
      "label": _vm.$lang.labels.numberOfSeats
    },
    model: {
      value: (_vm.seats),
      callback: function($$v) {
        _vm.seats = $$v
      },
      expression: "seats"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "sm8": "",
      "md6": "",
      "lg4": "",
      "mt-2": "",
      "px-4": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "hide-details": "",
      "label": _vm.$lang.labels.foreignId
    },
    model: {
      value: (_vm.foreignId),
      callback: function($$v) {
        _vm.foreignId = $$v
      },
      expression: "foreignId"
    }
  })], 1)], 1), _vm._v(" "), _c('v-btn', {
    staticClass: "mx-4 primary",
    attrs: {
      "disabled": _vm.editingName
    },
    on: {
      "click": _vm.addName
    }
  }, [_vm._v(_vm._s(_vm.$lang.actions.addTableName))]), _vm._v(" "), _c('div', {
    staticClass: "nameTable v-table__overflow px-4"
  }, [_c('table', {
    staticClass: "v-datatable v-table theme--light"
  }, [_c('tbody', _vm._l((_vm.names), function(name, index) {
    return _c('tr', {
      key: index
    }, [(name.isEdit) ? [_c('td', [_c('v-select', {
      staticClass: "min-w",
      attrs: {
        "items": _vm.languages,
        "item-text": "text",
        "item-value": "value",
        "label": _vm.$lang.actions.selectLanguage
      },
      model: {
        value: (_vm.tempName.language),
        callback: function($$v) {
          _vm.$set(_vm.tempName, "language", $$v)
        },
        expression: "tempName.language"
      }
    })], 1), _vm._v(" "), _c('td', [_c('v-text-field', {
      attrs: {
        "placeholder": _vm.$lang.labels.name
      },
      model: {
        value: (_vm.tempName.name),
        callback: function($$v) {
          _vm.$set(_vm.tempName, "name", $$v)
        },
        expression: "tempName.name"
      }
    })], 1), _vm._v(" "), _c('td', {
      staticClass: "min-w-lg px-0"
    }, [_c('v-btn', {
      staticClass: "primary elevation-1",
      attrs: {
        "disabled": !_vm.tempName.language || !_vm.tempName.name
      },
      on: {
        "click": function($event) {
          return _vm.saveNameEdit(name)
        }
      }
    }, [_vm._v(_vm._s(_vm.$lang.actions.save))]), _vm._v(" "), _c('v-btn', {
      staticClass: "error ml-0 elevation-1",
      on: {
        "click": function($event) {
          return _vm.closeNameEdit(name)
        }
      }
    }, [_vm._v(_vm._s(_vm.$lang.actions.cancel))])], 1)] : [_c('td', [_vm._v(_vm._s(name.language))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(name.name))]), _vm._v(" "), _c('td', {
      staticClass: "actions px-0"
    }, [_c('v-btn', {
      staticClass: "primary elevation-1",
      on: {
        "click": function($event) {
          return _vm.editName(name)
        }
      }
    }, [_vm._v(_vm._s(_vm.$lang.actions.edit))]), _vm._v(" "), _c('v-btn', {
      staticClass: "error ml-0 elevation-1",
      on: {
        "click": function($event) {
          return _vm.deleteName(index)
        }
      }
    }, [_vm._v(_vm._s(_vm.$lang.actions.delete))])], 1)]], 2)
  }), 0)])]), _vm._v(" "), _c('v-layout', {
    staticClass: "px-2",
    attrs: {
      "row": "",
      "wrap": "",
      "justify-space-between": "",
      "align-center": ""
    }
  }, [_c('h3', {
    staticClass: "pa-3"
  }, [_vm._v(_vm._s(_vm.$lang.header.properties))]), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "px-3": ""
    }
  }, [_c('v-btn', {
    attrs: {
      "color": "primary mx-0"
    },
    on: {
      "click": function($event) {
        return _vm.addPropertyCode()
      }
    }
  }, [_vm._v("\n            " + _vm._s(_vm.$lang.labels.addProperty) + "\n          ")])], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "px-3": "",
      "pb-3": ""
    }
  }, [(_vm.properties) ? _c('v-data-table', {
    staticClass: "elevation-0 mt-2",
    attrs: {
      "headers": _vm.headers,
      "items": _vm.properties,
      "hide-actions": ""
    },
    scopedSlots: _vm._u([{
      key: "items",
      fn: function(props) {
        return [_c('td', [_vm._v(_vm._s(props.item.name))]), _vm._v(" "), (['desktop.image', 'tablet.image'].includes(props.item.name)) ? _c('td', [_c('v-img', {
          attrs: {
            "src": props.item.value,
            "contain": "",
            "height": "100"
          }
        })], 1) : _c('td', [_vm._v(_vm._s(props.item.value))]), _vm._v(" "), _c('td', [_c('v-btn', {
          staticClass: "primary mx-0",
          on: {
            "click": function($event) {
              return _vm.editPropertyCode(props.item)
            }
          }
        }, [_vm._v("\n                " + _vm._s(_vm.$lang.actions.edit) + "\n              ")]), _vm._v(" "), _c('v-btn', {
          staticClass: "error mx-0",
          on: {
            "click": function($event) {
              return _vm.confirmDeletePropertyCode(props.item)
            }
          }
        }, [_vm._v("\n                  " + _vm._s(_vm.$lang.actions.delete) + "\n                ")])], 1)]
      }
    }], null, false, 3921525948)
  }) : _vm._e()], 1)], 1), _vm._v(" "), _c('v-layout', {
    staticClass: "px-2 mt-3",
    attrs: {
      "row": "",
      "wrap": "",
      "justify-space-between": ""
    }
  }, [(_vm.isEdit && _vm.createdOn) ? _c('v-text-field', {
    staticClass: "min-w max-w mx-3",
    attrs: {
      "label": _vm.$lang.labels.created,
      "readonly": ""
    },
    model: {
      value: (_vm.createdOn),
      callback: function($$v) {
        _vm.createdOn = $$v
      },
      expression: "createdOn"
    }
  }) : _vm._e(), _vm._v(" "), (_vm.isEdit && _vm.modifiedOn) ? _c('v-text-field', {
    staticClass: "min-w max-w mx-3",
    attrs: {
      "label": _vm.$lang.labels.modified,
      "readonly": ""
    },
    model: {
      value: (_vm.modifiedOn),
      callback: function($$v) {
        _vm.modifiedOn = $$v
      },
      expression: "modifiedOn"
    }
  }) : _vm._e()], 1), _vm._v(" "), _c('v-layout', {
    staticClass: "px-2",
    attrs: {
      "row": "",
      "wrap": "",
      "justify-space-between": "",
      "align-content-center": ""
    }
  }, [_c('v-btn', {
    staticClass: "mx-3",
    attrs: {
      "flat": ""
    },
    on: {
      "click": function($event) {
        return _vm.$router.push({
          name: 'tables'
        })
      }
    }
  }, [_c('v-icon', [_vm._v("keyboard_arrow_left")]), _vm._v("\n          " + _vm._s(_vm.$lang.actions.close) + "\n        ")], 1), _vm._v(" "), _c('v-btn', {
    staticClass: "primary mx-3",
    attrs: {
      "disabled": !_vm.valid
    },
    on: {
      "click": _vm.submit
    }
  }, [_vm._v("\n          " + _vm._s(_vm.$lang.actions.submit) + "\n        ")])], 1)], 1)], 1), _vm._v(" "), (_vm.propertyModal) ? _c('v-dialog', {
    attrs: {
      "persistent": "",
      "max-width": "1200"
    },
    model: {
      value: (_vm.propertyModal),
      callback: function($$v) {
        _vm.propertyModal = $$v
      },
      expression: "propertyModal"
    }
  }, [_c('properties-modal', {
    attrs: {
      "title": _vm.isPropertyEdit ? 'Edit Property' : 'Add Property',
      "htmlCode": _vm.propertyCodeToEdit,
      "isHtmlEdit": _vm.isPropertyEdit,
      "htmlKeysListFiltered": _vm.propertiesKeysListFiltered
    },
    on: {
      "submit": function($event) {
        return _vm.savePropertiesCode($event)
      },
      "close": function($event) {
        _vm.propertyModal = false, _vm.propertyCodeToEdit = null, _vm.tempIndex = null
      }
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.confirmationModal) ? _c('v-dialog', {
    attrs: {
      "persistent": "",
      "max-width": "500"
    },
    model: {
      value: (_vm.confirmationModal),
      callback: function($$v) {
        _vm.confirmationModal = $$v
      },
      expression: "confirmationModal"
    }
  }, [_c('confirmation-modal', {
    attrs: {
      "text": _vm.$lang.actions.deleteProperty
    },
    on: {
      "submit": function($event) {
        return _vm.deletePropertyCode()
      },
      "close": function($event) {
        _vm.confirmationModal = false;
        _vm.tempIndex = null
      }
    }
  })], 1) : _vm._e()], 1)
},staticRenderFns: []}

/***/ }),
/* 411 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-app', [_c('router-view')], 1)
},staticRenderFns: []}

/***/ }),
/* 412 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-layout', {
    attrs: {
      "row": "",
      "align-center": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-card', {
    staticClass: "pa-4"
  }, [(_vm.err) ? _c('v-alert', {
    staticClass: "err",
    attrs: {
      "color": "error",
      "value": true,
      "icon": "warning",
      "type": "error"
    }
  }, [_vm._v("\n        " + _vm._s(_vm.err) + "\n      ")]) : _vm._e(), _vm._v(" "), (_vm.errors.length > 0) ? _c('v-alert', {
    staticClass: "err",
    attrs: {
      "color": "error",
      "value": true,
      "icon": "warning",
      "type": "error"
    }
  }, _vm._l((_vm.errors), function(err) {
    return _c('span', [_vm._v(_vm._s(err.message) + "."), _c('br')])
  }), 0) : _vm._e(), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "fade"
    }
  }, [(_vm.success) ? _c('v-alert', {
    attrs: {
      "type": "success",
      "value": true
    }
  }, [_vm._v("\n          " + _vm._s(_vm.success) + "\n        ")]) : _vm._e()], 1), _vm._v(" "), ((this.$route.query.id) && !_vm.loaded) ? _c('v-flex', {
    attrs: {
      "text-xs-center": ""
    }
  }, [_c('v-progress-circular', {
    attrs: {
      "indeterminate": "",
      "color": "primary"
    }
  })], 1) : _c('div', [(!_vm.isLocalAdmin) ? [_c('h2', [_vm._v(_vm._s(_vm.$lang.labels.company))]), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": ""
    }
  }, [(_vm.companies.length > 0) ? _c('v-flex', {
    staticClass: "text-xs-center",
    staticStyle: {
      "z-index": "5"
    },
    attrs: {
      "grow": ""
    }
  }, [_c('v-btn', {
    staticClass: "elevation-0 ",
    class: {
      'v-btn--disabled': _vm.$route.query.id && !_vm.currentCorporation
    },
    attrs: {
      "flat": "",
      "block": "",
      "disabled": !!_vm.$route.query.id && !_vm.currentCorporation,
      "outline": "",
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.show = !_vm.show
      }
    }
  }, [_vm._v("\n                " + _vm._s(_vm.selectedCompany ? _vm.selectedCompany.name : _vm.$lang.labels.selectCompany) + "\n              ")]), _vm._v(" "), _c('v-list', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.show),
      expression: "show"
    }],
    staticStyle: {
      "box-shadow": "0 2px 1px -1px rgba(0,0,0,.2), 0 1px 1px 0 rgba(0,0,0,.14), 0 1px 3px 0 rgba(0,0,0,.12)",
      "margin-top": "-6px"
    }
  }, [_c('v-list-tile', {
    staticClass: "search pt-0",
    on: {
      "click": function($event) {
        $event.stopPropagation();
      }
    }
  }, [_c('v-text-field', {
    attrs: {
      "type": "text",
      "label": _vm.$lang.labels.filterCategories
    },
    model: {
      value: (_vm.filter),
      callback: function($$v) {
        _vm.filter = $$v
      },
      expression: "filter"
    }
  })], 1), _vm._v(" "), _vm._l((_vm.filteredCompanies), function(company) {
    return (!_vm.selectedCompany || _vm.selectedCompany.id !== company.id) ? _c('v-list-tile', {
      key: company.id,
      on: {
        "click": function($event) {
          return _vm.selectCompany(company)
        }
      }
    }, [_c('v-list-tile-title', [_vm._v(_vm._s(company.name) + " (" + _vm._s(company.companyStatus) + ")")])], 1) : _vm._e()
  })], 2)], 1) : _vm._e(), _vm._v(" "), _c('v-btn', {
    staticClass: "elevation-0 ",
    attrs: {
      "color": "primary"
    },
    on: {
      "click": function($event) {
        _vm.show = !_vm.show
      }
    }
  }, [_vm._v("\n              " + _vm._s(_vm.$lang.actions.changeCompany) + "\n            ")])], 1)] : _vm._e(), _vm._v(" "), _c('v-layout', {
    staticClass: "my-4",
    attrs: {
      "row": "",
      "wrap": "",
      "align-start": "",
      "justify-space-between": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": "",
      "sm4": ""
    }
  }, [_c('h2', {
    staticClass: "mr-3"
  }, [_vm._v(_vm._s(_vm.$lang.header.catalogName))]), _vm._v(" "), _c('v-text-field', {
    attrs: {
      "placeholder": _vm.$lang.labels.name1,
      "type": "text"
    },
    on: {
      "blur": function($event) {
        _vm.name = _vm.name.trim()
      }
    },
    model: {
      value: (_vm.name),
      callback: function($$v) {
        _vm.name = $$v
      },
      expression: "name"
    }
  })], 1), _vm._v(" "), (_vm.version) ? _c('v-flex', {
    attrs: {
      "xs12": "",
      "sm4": "",
      "pl-4": ""
    }
  }, [_c('h2', {
    staticClass: "mb-3"
  }, [_vm._v(_vm._s(_vm.$lang.header.originalVersion))]), _vm._v(" "), _c('p', {
    staticClass: "ma-0"
  }, [_vm._v(_vm._s(_vm.version))])]) : _vm._e(), _vm._v(" "), _c('v-flex', {
    staticClass: "d-inline-flex",
    attrs: {
      "xs12": "",
      "sm4": ""
    }
  }, [_c('v-btn', {
    attrs: {
      "color": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.copyWholeCatalog()
      }
    }
  }, [_vm._v("\n              " + _vm._s(_vm.$lang.actions.copyCatalog) + "\n            ")]), _vm._v(" "), _c('v-btn', {
    attrs: {
      "color": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.turnOnPasteListen()
      }
    }
  }, [_vm._v("\n              " + _vm._s(_vm.isPasteOn ? _vm.$lang.actions.pasteCatalogTurnOff : _vm.$lang.actions.pasteCatalogTurnOn) + "\n            ")])], 1)], 1), _vm._v(" "), _c('v-layout', {
    staticClass: "my-4",
    attrs: {
      "row": "",
      "align-center": "",
      "justify-space-between": ""
    }
  }, [_c('div', {
    staticClass: "d-inline-flex"
  }, [_c('h2', {
    staticClass: "mr-3 pt-1 mt-2"
  }, [_vm._v(_vm._s(_vm.$lang.header.views))]), _vm._v(" "), _c('v-btn', {
    attrs: {
      "fab": "",
      "dark": "",
      "small": "",
      "color": "primary"
    },
    on: {
      "click": function($event) {
        _vm.editViews = true;
        _vm.currentView = null
      }
    }
  }, [_c('v-icon', [_vm._v("add")])], 1)], 1), _vm._v(" "), _c('v-btn', {
    attrs: {
      "dark": "",
      "color": "primary"
    },
    on: {
      "click": function($event) {
        _vm.predefinedViewsModal = true
      }
    }
  }, [_vm._v("\n            " + _vm._s(_vm.$lang.labels.predefinedViews) + "\n          ")])], 1), _vm._v(" "), _c('v-layout', {
    staticClass: "views pa-3",
    attrs: {
      "row": "",
      "wrap": ""
    },
    on: {
      "click": _vm.editViewToggle
    }
  }, [(_vm.views.length === 0) ? _c('p', {
    staticClass: "m-0"
  }, [_vm._v(_vm._s(_vm.$lang.actions.addViews))]) : _vm._e(), _vm._v(" "), _vm._l((_vm.views), function(view, index) {
    return _c('div', {
      key: index,
      staticClass: "py-1 px-3 ma-0 my-1 mr-2 views--item"
    }, [_vm._v("\n            " + _vm._s(view.name[_vm.language]) + "\n            "), (typeof view.viewId !== 'undefined') ? _c('small', [_vm._v("(" + _vm._s(view.viewId) + ")")]) : _vm._e(), _vm._v(" "), (view.isDefault) ? _c('small', {
      domProps: {
        "textContent": _vm._s('<Default>')
      }
    }) : _vm._e(), _vm._v(" "), _c('v-icon', {
      staticClass: "ml-2",
      on: {
        "click": function($event) {
          $event.stopPropagation();
          return _vm.editView(view, index)
        }
      }
    }, [_vm._v("edit")]), _vm._v(" "), _c('v-icon', {
      on: {
        "click": function($event) {
          $event.stopPropagation();
          return _vm.deleteView(view.viewId)
        }
      }
    }, [_vm._v("delete")])], 1)
  })], 2), _vm._v(" "), _c('v-layout', {
    staticClass: "my-4",
    attrs: {
      "row": "",
      "align-center": ""
    }
  }, [_c('h2', {
    staticClass: "mr-3"
  }, [_vm._v(_vm._s(_vm.$lang.header.allergens))]), _vm._v(" "), _c('v-btn', {
    attrs: {
      "fab": "",
      "dark": "",
      "small": "",
      "color": "primary"
    },
    on: {
      "click": function($event) {
        _vm.editAllergens = true;
        _vm.currentAllergen = null
      }
    }
  }, [_c('v-icon', [_vm._v("add")])], 1)], 1), _vm._v(" "), _c('v-layout', {
    staticClass: "views pa-3",
    attrs: {
      "row": "",
      "wrap": ""
    },
    on: {
      "click": _vm.editAllergenToggle
    }
  }, [(_vm.allergens.length === 0) ? _c('p', {
    staticClass: "m-0"
  }, [_vm._v("Click to add allergens")]) : _vm._e(), _vm._v(" "), _vm._l((_vm.allergens), function(allergen, index) {
    return _c('div', {
      key: index,
      staticClass: "py-1 px-3 ma-0 my-1 mr-2 views--item"
    }, [_vm._v("\n            " + _vm._s(allergen.name[_vm.language]) + "\n            "), (typeof allergen.allergenId !== 'undefined') ? _c('small', [_vm._v("(" + _vm._s(allergen.allergenId) + ")")]) : _vm._e(), _vm._v(" "), _c('v-icon', {
      staticClass: "ml-2",
      on: {
        "click": function($event) {
          $event.stopPropagation();
          return _vm.editAllergen(allergen, index)
        }
      }
    }, [_vm._v("edit")]), _vm._v(" "), _c('v-icon', {
      on: {
        "click": function($event) {
          $event.stopPropagation();
          return _vm.deleteAllergen(allergen.allergenId)
        }
      }
    }, [_vm._v("delete")])], 1)
  })], 2), _vm._v(" "), _c('v-layout', {
    staticClass: "mt-4 mb-2",
    attrs: {
      "row": "",
      "align-center": ""
    }
  }, [_c('h2', {
    staticClass: "mr-3"
  }, [_vm._v(_vm._s(_vm.$lang.header.massAddRemove))])]), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-btn', {
    attrs: {
      "color": "primary"
    },
    on: {
      "click": function($event) {
        _vm.massAddViews = true
      }
    }
  }, [_vm._v(_vm._s(_vm.$lang.actions.addViews1))]), _vm._v(" "), _c('v-btn', {
    attrs: {
      "color": "primary"
    },
    on: {
      "click": function($event) {
        _vm.massAddAllergens = true
      }
    }
  }, [_vm._v(_vm._s(_vm.$lang.actions.addAllergens))]), _vm._v(" "), _c('v-btn', {
    attrs: {
      "color": "primary"
    },
    on: {
      "click": function($event) {
        _vm.massAddPrinters = true
      }
    }
  }, [_vm._v(_vm._s(_vm.$lang.actions.addPrinters))]), _vm._v(" "), _c('v-btn', {
    attrs: {
      "color": "primary"
    },
    on: {
      "click": function($event) {
        _vm.massRemovePrinters = true
      }
    }
  }, [_vm._v(_vm._s(_vm.$lang.actions.removePrinters))]), _vm._v(" "), _c('v-btn', {
    attrs: {
      "color": "primary",
      "disabled": !_vm.selectedCompany || !_vm.selectedCompanyInfo.vatRates || _vm.selectedCompanyInfo.vatRates.length === 0
    },
    on: {
      "click": function($event) {
        _vm.vatModal = true
      }
    }
  }, [_vm._v(_vm._s(_vm.$lang.actions.addVAT))]), _vm._v(" "), _c('v-btn', {
    attrs: {
      "color": "primary"
    },
    on: {
      "click": function($event) {
        _vm.massLangModal = true
      }
    }
  }, [_vm._v(_vm._s(_vm.$lang.actions.translate))]), _vm._v(" "), _c('v-btn', {
    attrs: {
      "color": "secondary"
    },
    on: {
      "click": function($event) {
        return _vm.exportCsv()
      }
    }
  }, [_vm._v(_vm._s(_vm.$lang.actions.exportCSV))])], 1), _vm._v(" "), _c('v-layout', {
    staticClass: "my-4",
    attrs: {
      "row": "",
      "align-center": ""
    }
  }, [_c('h2', {
    staticClass: "d-inline-block m-0"
  }, [_vm._v(_vm._s(_vm.$lang.header.items))]), _vm._v(" "), _c('v-btn', {
    staticClass: "item-actions d-inline-block",
    attrs: {
      "fab": "",
      "small": "",
      "flat": ""
    },
    on: {
      "click": function($event) {
        _vm.actionPath = null;
        _vm.itemModal = true;
        _vm.currentItemEvent = 'add'
      }
    }
  }, [_c('v-icon', [_vm._v("add")])], 1), _vm._v(" "), _c('v-btn', {
    staticClass: "show-buttons",
    attrs: {
      "flat": ""
    },
    on: {
      "click": function($event) {
        return _vm.openAll(_vm.items, true)
      }
    }
  }, [_vm._v(_vm._s(_vm.$lang.actions.showAllChildren))]), _vm._v(" "), _c('v-btn', {
    staticClass: "show-buttons",
    attrs: {
      "flat": ""
    },
    on: {
      "click": function($event) {
        return _vm.openAll(_vm.items, false)
      }
    }
  }, [_vm._v(_vm._s(_vm.$lang.actions.hideAllChildren))])], 1), _vm._v(" "), _c('v-layout', {
    staticClass: "my-4",
    attrs: {
      "row": "",
      "align-center": ""
    }
  }, [(!_vm.notLoading) ? _c('v-flex', {
    attrs: {
      "text-xs-center": ""
    }
  }, [_c('v-progress-circular', {
    attrs: {
      "indeterminate": "",
      "color": "primary"
    }
  })], 1) : _vm._e()], 1), _vm._v(" "), (_vm.notLoading) ? _c('ul', _vm._l((_vm.filtereditems), function(item, index) {
    return _c('item', {
      key: index,
      attrs: {
        "index": index,
        "items": _vm.filtereditems,
        "views": _vm.views,
        "isEdit": _vm.isEdit,
        "itemData": item
      },
      on: {
        "click": function($event) {
          $event.stopPropagation();
          $event.preventDefault();
        },
        "selected": _vm.select,
        "setMaxItemId": _vm.setMaxItemId,
        "deleted": _vm.deleteItem,
        "copyItem": _vm.copyItem,
        "massAdd": _vm.massAddShow,
        "massRemove": _vm.massRemoveShow,
        "addItem": _vm.addItemEvent,
        "editItem": _vm.editItemEvent
      }
    })
  }), 1) : _vm._e(), _vm._v(" "), (_vm.err || _vm.errors.length > 0 || _vm.success) ? _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": "",
      "pb-2": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [(_vm.err) ? _c('v-alert', {
    staticClass: "err",
    attrs: {
      "color": "error",
      "value": true,
      "icon": "warning",
      "type": "error"
    }
  }, [_vm._v("\n            " + _vm._s(_vm.err) + "\n          ")]) : _vm._e(), _vm._v(" "), (_vm.errors.length > 0) ? _c('v-alert', {
    staticClass: "err",
    attrs: {
      "color": "error",
      "value": true,
      "icon": "warning",
      "type": "error"
    }
  }, _vm._l((_vm.errors), function(err) {
    return _c('span', [_vm._v(_vm._s(err.message) + "."), _c('br')])
  }), 0) : _vm._e(), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "fade"
    }
  }, [(_vm.success) ? _c('v-alert', {
    attrs: {
      "type": "success",
      "value": true
    }
  }, [_vm._v("\n              " + _vm._s(_vm.success) + "\n            ")]) : _vm._e()], 1)], 1)], 1) : _vm._e(), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": "",
      "justify-space-between": ""
    }
  }, [_c('router-link', {
    staticClass: "mx-0 v-btn--flat",
    attrs: {
      "tag": "v-btn",
      "to": {
        path: 'list'
      }
    }
  }, [_c('v-icon', {
    attrs: {
      "dark": ""
    }
  }, [_vm._v("keyboard_arrow_left")]), _vm._v("\n            cancel\n          ")], 1), _vm._v(" "), _c('v-btn', {
    staticClass: "mx-0",
    attrs: {
      "color": "primary",
      "disabled": _vm.creating
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.createCatalog($event)
      }
    }
  }, [_vm._v(_vm._s(_vm.$lang.actions.create))])], 1)], 2)], 1)], 1), _vm._v(" "), (_vm.itemModal) ? _c('v-dialog', {
    attrs: {
      "max-width": "1600px"
    },
    model: {
      value: (_vm.itemModal),
      callback: function($$v) {
        _vm.itemModal = $$v
      },
      expression: "itemModal"
    }
  }, [_c('item-modal', {
    attrs: {
      "plusOne": _vm.plusOne,
      "currentItemEvent": _vm.currentItemEvent,
      "copyData": _vm.copyItemData ? _vm.copyItemData : null,
      "taxCategories": _vm.taxCategories,
      "editItem": _vm.editItem,
      "actionPath": _vm.actionPath,
      "selectedCompanyInfo": _vm.selectedCompanyInfo,
      "views": _vm.views,
      "allergens": _vm.allergens,
      "maxItemId": _vm.maxItemId,
      "items": _vm.items
    },
    on: {
      "copy": function($event) {
        return _vm.copy($event)
      },
      "submit": _vm.addItem,
      "close": function($event) {
        _vm.itemModal = false;
      }
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.vatModal) ? _c('v-dialog', {
    attrs: {
      "max-width": "1200px"
    },
    model: {
      value: (_vm.vatModal),
      callback: function($$v) {
        _vm.vatModal = $$v
      },
      expression: "vatModal"
    }
  }, [_c('vat-modal', {
    attrs: {
      "selectedCompanyInfo": _vm.selectedCompanyInfo
    },
    on: {
      "submit": _vm.addVATToItems,
      "close": function($event) {
        _vm.vatModal = false;
      }
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.massAddViews) ? _c('v-dialog', {
    attrs: {
      "max-width": "1200px"
    },
    model: {
      value: (_vm.massAddViews),
      callback: function($$v) {
        _vm.massAddViews = $$v
      },
      expression: "massAddViews"
    }
  }, [_c('views-modal', {
    attrs: {
      "views": _vm.views
    },
    on: {
      "submit": _vm.addViewsToItems,
      "close": function($event) {
        _vm.massAddViews = false;
      }
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.massAddAllergens) ? _c('v-dialog', {
    attrs: {
      "max-width": "1200px"
    },
    model: {
      value: (_vm.massAddAllergens),
      callback: function($$v) {
        _vm.massAddAllergens = $$v
      },
      expression: "massAddAllergens"
    }
  }, [_c('allergens-modal', {
    attrs: {
      "allergens": _vm.allergens
    },
    on: {
      "submit": _vm.addAllergensToItems,
      "close": function($event) {
        _vm.massAddAllergens = false;
      }
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.massAddPrinters) ? _c('v-dialog', {
    attrs: {
      "max-width": "1200px"
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        $event.preventDefault();
      }
    },
    model: {
      value: (_vm.massAddPrinters),
      callback: function($$v) {
        _vm.massAddPrinters = $$v
      },
      expression: "massAddPrinters"
    }
  }, [_c('printers-modal', {
    on: {
      "submit": _vm.addPrintersToItems,
      "close": function($event) {
        _vm.massAddPrinters = false;
      }
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.massRemovePrinters) ? _c('v-dialog', {
    attrs: {
      "max-width": "1200px"
    },
    model: {
      value: (_vm.massRemovePrinters),
      callback: function($$v) {
        _vm.massRemovePrinters = $$v
      },
      expression: "massRemovePrinters"
    }
  }, [_c('printers-modal', {
    attrs: {
      "remove": true
    },
    on: {
      "submit": _vm.removePrintersFromItems,
      "close": function($event) {
        _vm.massRemovePrinters = false;
      }
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.massLangModal) ? _c('v-dialog', {
    attrs: {
      "max-width": "800px"
    },
    model: {
      value: (_vm.massLangModal),
      callback: function($$v) {
        _vm.massLangModal = $$v
      },
      expression: "massLangModal"
    }
  }, [_c('lang-trans-modal', {
    on: {
      "submit": function($event) {
        return _vm.massTranslate($event)
      },
      "close": function($event) {
        _vm.massLangModal = false;
      }
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.editViews) ? _c('v-dialog', {
    attrs: {
      "max-width": "700px"
    },
    model: {
      value: (_vm.editViews),
      callback: function($$v) {
        _vm.editViews = $$v
      },
      expression: "editViews"
    }
  }, [_c('view-modal', {
    attrs: {
      "edit": _vm.currentView,
      "orderTypes": _vm.orderTypes,
      "selectedOrderTypes": _vm.selectedOrderTypes,
      "maxViewId": _vm.maxViewId
    },
    on: {
      "submit": _vm.addView,
      "update": _vm.editViewSubmit,
      "changeSelectedOrderTypes": _vm.changeSelectedOrderTypes,
      "close": function($event) {
        _vm.editViews = false;
      }
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.editAllergens) ? _c('v-dialog', {
    attrs: {
      "max-width": "1200px"
    },
    model: {
      value: (_vm.editAllergens),
      callback: function($$v) {
        _vm.editAllergens = $$v
      },
      expression: "editAllergens"
    }
  }, [_c('allergen-modal', {
    attrs: {
      "edit": _vm.currentAllergen,
      "maxAllergenId": _vm.maxAllergenId
    },
    on: {
      "submit": _vm.addAllergen,
      "update": _vm.editAllergenSubmit,
      "close": function($event) {
        _vm.editAllergens = false;
      }
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.showActivationModal) ? _c('v-dialog', {
    attrs: {
      "persistent": "",
      "max-width": "500"
    },
    model: {
      value: (_vm.showActivationModal),
      callback: function($$v) {
        _vm.showActivationModal = $$v
      },
      expression: "showActivationModal"
    }
  }, [_c('activation-modal', {
    attrs: {
      "data": _vm.activationData
    },
    on: {
      "close": function($event) {
        return _vm.closeActivation()
      }
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.massRemoveViews) ? _c('v-dialog', {
    attrs: {
      "persistent": "",
      "max-width": "500"
    },
    model: {
      value: (_vm.massRemoveViews),
      callback: function($$v) {
        _vm.massRemoveViews = $$v
      },
      expression: "massRemoveViews"
    }
  }, [_c('confirmation-modal', {
    attrs: {
      "text": _vm.$lang.labels.massRemoveViews
    },
    on: {
      "submit": function($event) {
        return _vm.removeViewFromItems()
      },
      "close": function($event) {
        _vm.massRemoveViews = false;
      }
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.massRemoveAllergens) ? _c('v-dialog', {
    attrs: {
      "persistent": "",
      "max-width": "500"
    },
    model: {
      value: (_vm.massRemoveAllergens),
      callback: function($$v) {
        _vm.massRemoveAllergens = $$v
      },
      expression: "massRemoveAllergens"
    }
  }, [_c('confirmation-modal', {
    attrs: {
      "text": _vm.$lang.labels.massRemoveAllergens
    },
    on: {
      "submit": function($event) {
        return _vm.removeAllergenFromItems()
      },
      "close": function($event) {
        _vm.massRemoveAllergens = false;
      }
    }
  })], 1) : _vm._e(), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "fade"
    }
  }, [(_vm.massAddModal) ? _c('v-dialog', {
    attrs: {
      "persistent": "",
      "max-width": "800"
    },
    model: {
      value: (_vm.massAddModal),
      callback: function($$v) {
        _vm.massAddModal = $$v
      },
      expression: "massAddModal"
    }
  }, [_c('mass-add-modal', {
    attrs: {
      "catalog": _vm.items,
      "data": _vm.massAddData,
      "views": _vm.views,
      "taxCategories": _vm.taxCategories,
      "selectedCompanyInfo": _vm.selectedCompanyInfo
    },
    on: {
      "submit": function($event) {
        return _vm.massAdd($event)
      },
      "close": function($event) {
        _vm.massAddModal = false
      }
    }
  })], 1) : _vm._e()], 1), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "fade"
    }
  }, [(_vm.massRemoveModalTree) ? _c('v-dialog', {
    attrs: {
      "persistent": "",
      "max-width": "800"
    },
    model: {
      value: (_vm.massRemoveModalTree),
      callback: function($$v) {
        _vm.massRemoveModalTree = $$v
      },
      expression: "massRemoveModalTree"
    }
  }, [_c('mass-remove-modal', {
    attrs: {
      "data": _vm.massRemoveDataTree,
      "viewsTree": _vm.viewsTree,
      "printCategoriesTree": _vm.printCategoriesTree,
      "views": _vm.views,
      "taxCategories": _vm.taxCategories,
      "selectedCompanyInfo": _vm.selectedCompanyInfo
    },
    on: {
      "submit": function($event) {
        return _vm.massRemove($event)
      },
      "close": function($event) {
        _vm.massRemoveModalTree = false
      }
    }
  })], 1) : _vm._e()], 1), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "fade"
    }
  }, [(_vm.predefinedViewsModal) ? _c('v-dialog', {
    attrs: {
      "max-width": "800"
    },
    model: {
      value: (_vm.predefinedViewsModal),
      callback: function($$v) {
        _vm.predefinedViewsModal = $$v
      },
      expression: "predefinedViewsModal"
    }
  }, [_c('add-predefined-views', {
    attrs: {
      "filteredViews": _vm.filteredViews
    },
    on: {
      "submit": function($event) {
        return _vm.addPredefinedView($event)
      },
      "close": function($event) {
        _vm.predefinedViewsModal = false
      }
    }
  })], 1) : _vm._e()], 1), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.show),
      expression: "show"
    }],
    staticClass: "overlay",
    on: {
      "click": function($event) {
        _vm.show = false
      }
    }
  })], 1)
},staticRenderFns: []}

/***/ }),
/* 413 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-card', [(_vm.err) ? _c('v-flex', {
    attrs: {
      "xs12": "",
      "px-4": ""
    }
  }, [_c('v-alert', {
    attrs: {
      "value": true,
      "type": "error"
    }
  }, [_vm._v(_vm._s(_vm.err))])], 1) : _vm._e(), _vm._v(" "), _c('v-card-title', {
    staticClass: "pb-0 px-4 layout row wrap"
  }, [_c('v-btn', {
    staticClass: "primary ma-0",
    on: {
      "click": function($event) {
        return _vm.$router.push({
          name: "corporationCreate"
        })
      }
    }
  }, [_vm._v(_vm._s(_vm.$lang.actions.createCorporation))]), _vm._v(" "), _c('v-checkbox', {
    staticClass: "ml-3 mt-0",
    attrs: {
      "color": "primary",
      "label": _vm.$lang.labels.showActive,
      "hide-details": ""
    },
    model: {
      value: (_vm.showActive),
      callback: function($$v) {
        _vm.showActive = $$v
      },
      expression: "showActive"
    }
  }), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('v-text-field', {
    staticClass: "min-w max-w",
    attrs: {
      "append-icon": "search",
      "label": _vm.$lang.labels.search,
      "hide-details": ""
    },
    model: {
      value: (_vm.search),
      callback: function($$v) {
        _vm.search = $$v
      },
      expression: "search"
    }
  })], 1), _vm._v(" "), _c('v-data-table', {
    attrs: {
      "headers": _vm.headers,
      "items": _vm.showActive ? _vm.activeCorporations : _vm.allCorporations,
      "search": _vm.search,
      "loading": _vm.allCorporations.length === 0,
      "rows-per-page-items": [50, 100, 250, 500, {
        text: 'All',
        value: -1
      }]
    },
    scopedSlots: _vm._u([{
      key: "items",
      fn: function(props) {
        return [_c('td', [_vm._v(_vm._s(props.item.name))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.formatDate(props.item.createdOn)))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(props.item.status))]), _vm._v(" "), _c('td', {
          staticClass: "min-w-lg"
        }, [_c('v-btn', {
          staticClass: "primary mx-0 elevation-1",
          on: {
            "click": function($event) {
              return _vm.$router.push({
                name: 'corporationEdit',
                params: {
                  id: props.item.id
                }
              })
            }
          }
        }, [_vm._v(_vm._s(_vm.$lang.actions.edit))]), _vm._v(" "), _c('v-btn', {
          staticClass: "primary elevation-1",
          on: {
            "click": function($event) {
              return _vm.changeStatus(props.item)
            }
          }
        }, [_vm._v(_vm._s(props.item.status === 'active' ? _vm.$lang.actions.deactivate : _vm.$lang.actions.activate))])], 1)]
      }
    }])
  }, [_c('v-progress-linear', {
    attrs: {
      "slot": "progress",
      "height": "6",
      "color": "primary",
      "indeterminate": ""
    },
    slot: "progress"
  }), _vm._v(" "), _vm._v(" "), _c('v-alert', {
    attrs: {
      "slot": "no-results",
      "value": true,
      "color": "warning",
      "icon": "warning"
    },
    slot: "no-results"
  }, [_vm._v("\n        Your search for \"" + _vm._s(_vm.search) + "\" found no results.\n      ")])], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 414 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-flex', {
    attrs: {
      "xs12": "",
      "sm10": "",
      "md8": "",
      "lg6": ""
    }
  }, [_c('v-card', {
    staticClass: "py-4"
  }, [(_vm.err) ? _c('v-flex', {
    attrs: {
      "xs12": "",
      "pb-3": "",
      "px-4": ""
    }
  }, [_c('v-alert', {
    attrs: {
      "value": true,
      "type": "error"
    }
  }, [_vm._v(_vm._s(_vm.err))])], 1) : _vm._e(), _vm._v(" "), (_vm.success) ? _c('v-flex', {
    attrs: {
      "xs12": "",
      "pb-3": "",
      "px-4": ""
    }
  }, [_c('v-alert', {
    attrs: {
      "value": true,
      "type": "success"
    }
  }, [_vm._v(_vm._s(_vm.success))])], 1) : _vm._e(), _vm._v(" "), _c('v-form', {
    model: {
      value: (_vm.valid),
      callback: function($$v) {
        _vm.valid = $$v
      },
      expression: "valid"
    }
  }, [_c('v-layout', {
    staticClass: "px-4",
    attrs: {
      "row": "",
      "wrap": "",
      "justify-space-between": "",
      "align-center": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": _vm.$lang.labels.corporationName,
      "required": "",
      "rules": [function (v) { return !!v || ("" + (_vm.$lang.errors.missingCorporationName)); }]
    },
    model: {
      value: (_vm.corporation.name),
      callback: function($$v) {
        _vm.$set(_vm.corporation, "name", $$v)
      },
      expression: "corporation.name"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-autocomplete', {
    attrs: {
      "items": _vm.companies,
      "label": _vm.$lang.actions.selectCompanies,
      "rules": [function () { return _vm.corporation.companies.length !== 0 || ("" + (_vm.$lang.errors.missingCompanies)); }],
      "loading": _vm.companyLoading,
      "chips": "",
      "deletable-chips": "",
      "multiple": "",
      "item-text": "name",
      "item-value": "id"
    },
    on: {
      "change": function($event) {
        return _vm.filterCompanies()
      }
    },
    model: {
      value: (_vm.corporation.companies),
      callback: function($$v) {
        _vm.$set(_vm.corporation, "companies", $$v)
      },
      expression: "corporation.companies"
    }
  })], 1), _vm._v(" "), (_vm.corporation.companies.length > 0) ? _c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-autocomplete', {
    attrs: {
      "items": _vm.filteredCompanies,
      "label": _vm.$lang.labels.primaryCompany,
      "rules": [function (v) { return !!v || ("" + (_vm.$lang.errors.primaryCompany)); }],
      "required": "",
      "item-text": "name",
      "item-value": "id"
    },
    model: {
      value: (_vm.corporation.primaryCompanyId),
      callback: function($$v) {
        _vm.$set(_vm.corporation, "primaryCompanyId", $$v)
      },
      expression: "corporation.primaryCompanyId"
    }
  })], 1) : _vm._e()], 1), _vm._v(" "), _vm._l((_vm.settings), function(setting, index) {
    return _c('v-layout', {
      key: index,
      attrs: {
        "align-center": "",
        "wrap": "",
        "pa-2": "",
        "row": ""
      }
    }, [_c('v-flex', {
      staticStyle: {
        "min-width": "200px"
      },
      attrs: {
        "shrink": "",
        "px-3": ""
      }
    }, [_c('v-checkbox', {
      attrs: {
        "label": _vm.$lang.labels[setting],
        "hide-details": "",
        "color": "primary"
      },
      model: {
        value: (_vm.corporation[setting].enabled),
        callback: function($$v) {
          _vm.$set(_vm.corporation[setting], "enabled", $$v)
        },
        expression: "corporation[setting].enabled"
      }
    })], 1), _vm._v(" "), _c('v-flex', {
      attrs: {
        "grow": "",
        "px-3": "",
        "pt-2": ""
      }
    }, [_c('v-text-field', {
      attrs: {
        "label": ((_vm.$lang.labels[setting]) + " URL"),
        "rules": [
          (_vm.corporation[setting].serverUrl && _vm.corporation[setting].enabled) ||
          !_vm.corporation[setting].enabled ||
          _vm.$lang.errors.serverUrl
        ],
        "type": "text",
        "color": "primary"
      },
      model: {
        value: (_vm.corporation[setting].serverUrl),
        callback: function($$v) {
          _vm.$set(_vm.corporation[setting], "serverUrl", $$v)
        },
        expression: "corporation[setting].serverUrl"
      }
    })], 1)], 1)
  }), _vm._v(" "), _c('v-layout', {
    staticClass: "px-2 pb-4",
    attrs: {
      "row": "",
      "wrap": "",
      "justify-space-between": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": "",
      "px-3": "",
      "pt-2": ""
    }
  }, [_c('h3', [_vm._v(_vm._s(_vm.$lang.labels.dailyOrderCounterPrefixes))])]), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "px-2": ""
    }
  }, [_c('v-layout', {
    attrs: {
      "align-center": "",
      "wrap": "",
      "pa-2": "",
      "row": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": "",
      "sm4": "",
      "pr-1": "",
      "pt-2": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": _vm.$lang.labels.delivery,
      "type": "text",
      "color": "primary",
      "maxlength": _vm.dailyOrderCounterPrefixesMax
    },
    model: {
      value: (_vm.corporation.dailyOrderCounterPrefixes.delivery),
      callback: function($$v) {
        _vm.$set(_vm.corporation.dailyOrderCounterPrefixes, "delivery", $$v)
      },
      expression: "corporation.dailyOrderCounterPrefixes.delivery"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "sm4": "",
      "px-1": "",
      "pt-2": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": _vm.$lang.labels.collection,
      "type": "text",
      "color": "primary",
      "maxlength": _vm.dailyOrderCounterPrefixesMax
    },
    model: {
      value: (_vm.corporation.dailyOrderCounterPrefixes.collection),
      callback: function($$v) {
        _vm.$set(_vm.corporation.dailyOrderCounterPrefixes, "collection", $$v)
      },
      expression: "corporation.dailyOrderCounterPrefixes.collection"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "sm4": "",
      "pl-1": "",
      "pt-2": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": _vm.$lang.labels.takeaway,
      "type": "text",
      "color": "primary",
      "maxlength": _vm.dailyOrderCounterPrefixesMax
    },
    model: {
      value: (_vm.corporation.dailyOrderCounterPrefixes.takeaway),
      callback: function($$v) {
        _vm.$set(_vm.corporation.dailyOrderCounterPrefixes, "takeaway", $$v)
      },
      expression: "corporation.dailyOrderCounterPrefixes.takeaway"
    }
  })], 1)], 1)], 1)], 1), _vm._v(" "), _c('v-layout', {
    staticClass: "px-2",
    attrs: {
      "row": "",
      "wrap": "",
      "justify-space-between": ""
    }
  }, [(_vm.isEdit && _vm.createdOn) ? _c('v-text-field', {
    staticClass: "min-w max-w mx-3",
    attrs: {
      "label": _vm.$lang.labels.created,
      "readonly": ""
    },
    model: {
      value: (_vm.createdOn),
      callback: function($$v) {
        _vm.createdOn = $$v
      },
      expression: "createdOn"
    }
  }) : _vm._e(), _vm._v(" "), (_vm.isEdit && _vm.modifiedOn) ? _c('v-text-field', {
    staticClass: "min-w max-w mx-3",
    attrs: {
      "label": _vm.$lang.labels.modified,
      "readonly": ""
    },
    model: {
      value: (_vm.modifiedOn),
      callback: function($$v) {
        _vm.modifiedOn = $$v
      },
      expression: "modifiedOn"
    }
  }) : _vm._e()], 1), _vm._v(" "), _c('v-layout', {
    staticClass: "mt-3 px-4",
    attrs: {
      "row": "",
      "wrap": "",
      "justify-space-between": "",
      "align-content-center": ""
    }
  }, [_c('v-btn', {
    staticClass: "ml-0",
    attrs: {
      "flat": ""
    },
    on: {
      "click": function($event) {
        return _vm.$router.push({
          name: 'corporations'
        })
      }
    }
  }, [_c('v-icon', [_vm._v("keyboard_arrow_left")]), _vm._v("\n          " + _vm._s(_vm.$lang.actions.close) + "\n        ")], 1), _vm._v(" "), _c('v-btn', {
    staticClass: "primary mx-0",
    attrs: {
      "disabled": !_vm.valid
    },
    on: {
      "click": _vm.submit
    }
  }, [_vm._v("\n          " + _vm._s(_vm.isEdit ? _vm.$lang.actions.update : _vm.$lang.actions.create) + "\n        ")])], 1)], 2)], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 415 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-flex', {
    attrs: {
      "xs12": "",
      "sm10": "",
      "md8": "",
      "lg6": ""
    }
  }, [_c('v-card', {
    staticClass: "px-2 py-4"
  }, [(_vm.loading) ? _c('v-progress-linear', {
    staticClass: "loading",
    attrs: {
      "indeterminate": true
    }
  }) : _vm._e(), _vm._v(" "), (_vm.err) ? _c('v-flex', {
    attrs: {
      "xs12": "",
      "px-3": "",
      "pb-3": ""
    }
  }, [_c('v-alert', {
    attrs: {
      "type": "error",
      "value": true
    }
  }, [_vm._v(_vm._s(_vm.err))])], 1) : _vm._e(), _vm._v(" "), (_vm.success) ? _c('v-flex', {
    attrs: {
      "xs12": "",
      "px-3": "",
      "pb-3": ""
    }
  }, [_c('v-alert', {
    attrs: {
      "type": "success",
      "value": true
    }
  }, [_vm._v(_vm._s(_vm.success))])], 1) : _vm._e(), _vm._v(" "), _c('v-form', {
    model: {
      value: (_vm.valid),
      callback: function($$v) {
        _vm.valid = $$v
      },
      expression: "valid"
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": "",
      "px-3": ""
    }
  }, [(!_vm.isLocalAdmin) ? _c('v-autocomplete', {
    attrs: {
      "required": "",
      "disabled": _vm.isEdit,
      "loading": _vm.companyLoading,
      "rules": [function (v) { return !!v || ("" + (_vm.$lang.errors.missingCompany)); }],
      "items": _vm.companies,
      "item-text": "name",
      "item-value": "id",
      "label": _vm.$lang.actions.selectCompany
    },
    model: {
      value: (_vm.selectedCompany),
      callback: function($$v) {
        _vm.selectedCompany = $$v
      },
      expression: "selectedCompany"
    }
  }) : _vm._e()], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "px-3": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "required": "",
      "rules": [function (v) { return !!v || ("" + (_vm.$lang.errors.missingRuleName)); }]
    },
    model: {
      value: (_vm.data.ruleName),
      callback: function($$v) {
        _vm.$set(_vm.data, "ruleName", $$v)
      },
      expression: "data.ruleName"
    }
  }, [_c('template', {
    slot: "label"
  }, [_vm._v("\n            " + _vm._s(_vm.$lang.labels.ruleName) + " - Visible to customer"), _c('span', {
    staticClass: "error--text"
  }, [_vm._v(" *")])])], 2), _vm._v(" "), _c('v-textarea', {
    attrs: {
      "auto-grow": "",
      "rows": "1"
    },
    model: {
      value: (_vm.description),
      callback: function($$v) {
        _vm.description = $$v
      },
      expression: "description"
    }
  }, [_c('template', {
    slot: "label"
  }, [_vm._v("\n            " + _vm._s(_vm.$lang.labels.description) + " - " + _vm._s(_vm.$lang.labels.visibleToCustomer) + "\n          ")])], 2), _vm._v(" "), _c('h3', [_vm._v(_vm._s(_vm.$lang.header.conditions))]), _vm._v(" "), _c('v-text-field', {
    attrs: {
      "label": _vm.$lang.labels.amountOfPersons,
      "type": "number",
      "min": "0",
      "max": "50"
    },
    model: {
      value: (_vm.amountOfPersons),
      callback: function($$v) {
        _vm.amountOfPersons = $$v
      },
      expression: "amountOfPersons"
    }
  }), _vm._v(" "), _c('v-autocomplete', {
    attrs: {
      "multiple": "",
      "items": _vm.days,
      "clearable": ""
    },
    model: {
      value: (_vm.daysOfWeek),
      callback: function($$v) {
        _vm.daysOfWeek = $$v
      },
      expression: "daysOfWeek"
    }
  }, [_c('template', {
    slot: "label"
  }, [_vm._v("\n            " + _vm._s(_vm.$lang.actions.selectDays)), _c('span', {
    staticClass: "error--text"
  }, [_vm._v(" *")])])], 2), _vm._v(" "), _c('v-autocomplete', {
    attrs: {
      "multiple": "",
      "items": _vm.types,
      "clearable": ""
    },
    model: {
      value: (_vm.orderTypes),
      callback: function($$v) {
        _vm.orderTypes = $$v
      },
      expression: "orderTypes"
    }
  }, [_c('template', {
    slot: "label"
  }, [_vm._v("\n            " + _vm._s(_vm.$lang.actions.selectOrderTypes)), _c('span', {
    staticClass: "error--text"
  }, [_vm._v(" *")])])], 2), _vm._v(" "), _c('v-autocomplete', {
    attrs: {
      "multiple": "",
      "items": _vm.methods,
      "clearable": ""
    },
    model: {
      value: (_vm.paymentMethods),
      callback: function($$v) {
        _vm.paymentMethods = $$v
      },
      expression: "paymentMethods"
    }
  }, [_c('template', {
    slot: "label"
  }, [_vm._v("\n            " + _vm._s(_vm.$lang.actions.selectPaymentMethods)), _c('span', {
    staticClass: "error--text"
  }, [_vm._v(" *")])])], 2)], 1), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": "",
      "align-center": "",
      "justify-space-between": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": "",
      "sm6": "",
      "px-3": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "type": "text",
      "mask": "##:##",
      "placeholder": "HH:mm",
      "rules": _vm.timeRule
    },
    model: {
      value: (_vm.startTime),
      callback: function($$v) {
        _vm.startTime = $$v
      },
      expression: "startTime"
    }
  }, [_c('template', {
    slot: "label"
  }, [_vm._v("\n              " + _vm._s(_vm.$lang.labels.startTime)), _c('span', {
    staticClass: "error--text"
  }, [_vm._v(" *")])])], 2)], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "sm6": "",
      "px-3": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "type": "text",
      "mask": "##:##",
      "placeholder": "HH:mm",
      "rules": _vm.timeRule
    },
    model: {
      value: (_vm.endTime),
      callback: function($$v) {
        _vm.endTime = $$v
      },
      expression: "endTime"
    }
  }, [_c('template', {
    slot: "label"
  }, [_vm._v("\n              " + _vm._s(_vm.$lang.labels.endTime)), _c('span', {
    staticClass: "error--text"
  }, [_vm._v(" *")])])], 2)], 1)], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "px-3": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": _vm.$lang.labels.minAmount,
      "type": "number",
      "max": "100",
      "min": "0"
    },
    model: {
      value: (_vm.minAmount),
      callback: function($$v) {
        _vm.minAmount = $$v
      },
      expression: "minAmount"
    }
  }), _vm._v(" "), _c('v-text-field', {
    attrs: {
      "label": _vm.$lang.labels.voucherCode
    },
    model: {
      value: (_vm.voucherCode),
      callback: function($$v) {
        _vm.voucherCode = $$v
      },
      expression: "voucherCode"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "px-3": ""
    }
  }, [_c('h3', [_vm._v(_vm._s(_vm.$lang.header.values))]), _vm._v(" "), _c('v-text-field', {
    attrs: {
      "label": _vm.$lang.labels.discountAmount,
      "type": "number",
      "max": "100",
      "min": "0",
      "clearable": "",
      "disabled": _vm.discountPercent !== null
    },
    model: {
      value: (_vm.discountAmount),
      callback: function($$v) {
        _vm.discountAmount = $$v
      },
      expression: "discountAmount"
    }
  }), _vm._v(" "), _c('v-text-field', {
    attrs: {
      "label": _vm.$lang.labels.discountPercent,
      "type": "number",
      "max": "100",
      "min": "0",
      "suffix": "%",
      "disabled": _vm.discountAmount !== null,
      "clearable": ""
    },
    model: {
      value: (_vm.discountPercent),
      callback: function($$v) {
        _vm.discountPercent = $$v
      },
      expression: "discountPercent"
    }
  })], 1)], 1), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": "",
      "justify-space-between": ""
    }
  }, [(_vm.isEdit && _vm.createdOn) ? _c('v-text-field', {
    staticClass: "min-w max-w mx-3",
    attrs: {
      "label": _vm.$lang.labels.created,
      "readonly": ""
    },
    model: {
      value: (_vm.createdOn),
      callback: function($$v) {
        _vm.createdOn = $$v
      },
      expression: "createdOn"
    }
  }) : _vm._e(), _vm._v(" "), (_vm.isEdit && _vm.modifiedOn) ? _c('v-text-field', {
    staticClass: "min-w max-w mx-3",
    attrs: {
      "label": _vm.$lang.labels.modified,
      "readonly": ""
    },
    model: {
      value: (_vm.modifiedOn),
      callback: function($$v) {
        _vm.modifiedOn = $$v
      },
      expression: "modifiedOn"
    }
  }) : _vm._e()], 1), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": "",
      "justify-space-between": ""
    }
  }, [_c('v-btn', {
    staticClass: "ml-0",
    attrs: {
      "flat": ""
    },
    on: {
      "click": function($event) {
        return _vm.$router.push({
          name: 'discountRules'
        })
      }
    }
  }, [_c('v-icon', [_vm._v("keyboard_arrow_left")]), _vm._v(" Close")], 1), _vm._v(" "), _c('v-btn', {
    staticClass: "primary",
    attrs: {
      "disabled": !_vm.validation
    },
    on: {
      "click": function($event) {
        return _vm.submit()
      }
    }
  }, [_vm._v(_vm._s(_vm.isEdit ? _vm.$lang.actions.update : _vm.$lang.actions.create))])], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 416 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-card', [(_vm.err) ? _c('v-flex', {
    attrs: {
      "xs12": "",
      "px-4": "",
      "pt-4": "",
      "pb-2": ""
    }
  }, [_c('v-alert', {
    attrs: {
      "type": "error",
      "value": true
    }
  }, [_vm._v(_vm._s(_vm.err))])], 1) : _vm._e(), _vm._v(" "), _c('v-layout', {
    staticClass: "px-3 pt-3 pb-3",
    attrs: {
      "row": "",
      "wrap": "",
      "align-center": "",
      "justify-space-between": ""
    }
  }, [_c('div', [_c('datetime', {
    staticClass: "datetime-btn primary--text mx-2",
    attrs: {
      "phrases": {
        ok: _vm.$lang.actions.ok,
        cancel: _vm.$lang.actions.cancel
      },
      "type": "datetime",
      "placeholder": _vm.$lang.actions.startDate
    },
    model: {
      value: (_vm.data.startDate),
      callback: function($$v) {
        _vm.$set(_vm.data, "startDate", $$v)
      },
      expression: "data.startDate"
    }
  }), _vm._v(" "), _c('datetime', {
    staticClass: "datetime-btn primary--text mx-2",
    attrs: {
      "phrases": {
        ok: _vm.$lang.actions.ok,
        cancel: _vm.$lang.actions.cancel
      },
      "type": "datetime",
      "placeholder": _vm.$lang.actions.endDate
    },
    model: {
      value: (_vm.data.endDate),
      callback: function($$v) {
        _vm.$set(_vm.data, "endDate", $$v)
      },
      expression: "data.endDate"
    }
  })], 1), _vm._v(" "), (_vm.show) ? _c('v-text-field', {
    staticClass: "min-w max-w mx-2",
    attrs: {
      "append-icon": "search",
      "label": _vm.$lang.labels.search,
      "hide-details": ""
    },
    model: {
      value: (_vm.search),
      callback: function($$v) {
        _vm.search = $$v
      },
      expression: "search"
    }
  }) : _vm._e()], 1), _vm._v(" "), _c('v-layout', {
    staticClass: "px-2",
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": "",
      "sm6": "",
      "md4": "",
      "lg3": "",
      "px-3": ""
    }
  }, [_c('v-autocomplete', {
    attrs: {
      "items": _vm.sources,
      "label": _vm.$lang.labels.sourceSystem,
      "clearable": "",
      "hide-details": ""
    },
    model: {
      value: (_vm.data.sourceSystem),
      callback: function($$v) {
        _vm.$set(_vm.data, "sourceSystem", $$v)
      },
      expression: "data.sourceSystem"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "sm6": "",
      "md4": "",
      "lg3": "",
      "px-3": ""
    }
  }, [_c('v-autocomplete', {
    attrs: {
      "items": _vm.actions,
      "label": _vm.$lang.header.action,
      "clearable": "",
      "hide-details": ""
    },
    model: {
      value: (_vm.data.action),
      callback: function($$v) {
        _vm.$set(_vm.data, "action", $$v)
      },
      expression: "data.action"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "sm6": "",
      "md4": "",
      "lg3": "",
      "px-3": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": _vm.$lang.labels.url,
      "clearable": "",
      "hide-details": ""
    },
    model: {
      value: (_vm.data.url),
      callback: function($$v) {
        _vm.$set(_vm.data, "url", $$v)
      },
      expression: "data.url"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    staticClass: "radio-input",
    attrs: {
      "xs12": "",
      "sm6": "",
      "md4": "",
      "lg3": "",
      "px-3": ""
    }
  }, [_c('p', [_vm._v(_vm._s(_vm.$lang.labels.auditDirection) + ":")]), _vm._v(" "), _c('v-radio-group', {
    attrs: {
      "row": "",
      "hide-details": ""
    },
    model: {
      value: (_vm.data.auditDirection),
      callback: function($$v) {
        _vm.$set(_vm.data, "auditDirection", $$v)
      },
      expression: "data.auditDirection"
    }
  }, [_c('v-radio', {
    attrs: {
      "label": _vm.$lang.labels.all,
      "value": null,
      "color": "primary"
    }
  }), _vm._v(" "), _c('v-radio', {
    attrs: {
      "label": _vm.$lang.labels.incoming,
      "value": "incoming",
      "color": "primary"
    }
  }), _vm._v(" "), _c('v-radio', {
    attrs: {
      "label": _vm.$lang.labels.outgoing,
      "value": "outgoing",
      "color": "primary"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('v-layout', {
    staticClass: "px-3 pb-3",
    attrs: {
      "row": "",
      "wrap": "",
      "align-end": ""
    }
  }, [_c('v-btn', {
    staticClass: "primary mx-2 my-0",
    on: {
      "click": function($event) {
        return _vm.showAudit()
      }
    }
  }, [_vm._v(_vm._s(_vm.$lang.actions.showAudit))])], 1), _vm._v(" "), (_vm.show) ? _c('v-data-table', {
    attrs: {
      "headers": _vm.headers,
      "items": _vm.auditLogs,
      "search": _vm.search,
      "loading": _vm.loading,
      "pagination": _vm.pagination,
      "rows-per-page-items": [50, 100, 250, 500, {
        text: 'All',
        value: -1
      }]
    },
    on: {
      "update:pagination": function($event) {
        _vm.pagination = $event
      }
    },
    scopedSlots: _vm._u([{
      key: "items",
      fn: function(props) {
        return [_c('td', {
          staticClass: "min-w"
        }, [_vm._v(_vm._s(_vm.formatDate(props.item.createdOn)))]), _vm._v(" "), _c('td', {
          staticClass: "min-w-lg"
        }, [_vm._v("\n          " + _vm._s(props.item.createdByFullName) + " \n          "), _c('small', {
          staticClass: "d-block"
        }, [_vm._v(_vm._s(props.item.createdBy))])]), _vm._v(" "), _c('td', [_vm._v("\n          " + _vm._s(props.item.sourceSystem) + "\n          "), _c('small', {
          staticClass: "d-block"
        }, [_vm._v(_vm._s(props.item.systemVersion))])]), _vm._v(" "), _c('td', [_vm._v(_vm._s(props.item.companyId))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(props.item.action))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(props.item.url))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(props.item.auditDirection))]), _vm._v(" "), _c('td', {
          staticClass: "min-w-lg"
        }, [_vm._v("\n          " + _vm._s(props.item.shortData) + "\n          "), (props.item.shortData) ? _c('v-btn', {
          staticClass: "mx-0",
          attrs: {
            "flat": "",
            "small": ""
          },
          on: {
            "click": function($event) {
              return _vm.showData(props.item.data)
            }
          }
        }, [_vm._v("\n            ...\n          ")]) : _vm._e()], 1)]
      }
    }], null, false, 2722042322)
  }, [_c('v-progress-linear', {
    attrs: {
      "slot": "progress",
      "height": "6",
      "color": "primary",
      "indeterminate": ""
    },
    slot: "progress"
  }), _vm._v(" "), _vm._v(" "), _c('v-alert', {
    attrs: {
      "slot": "no-results",
      "value": true,
      "color": "warning",
      "icon": "warning"
    },
    slot: "no-results"
  }, [_vm._v("\n        Your search for \"" + _vm._s(_vm.search) + "\" found no results.\n      ")])], 1) : _vm._e()], 1), _vm._v(" "), (_vm.auditModal) ? _c('v-dialog', {
    attrs: {
      "max-width": "1200"
    },
    model: {
      value: (_vm.auditModal),
      callback: function($$v) {
        _vm.auditModal = $$v
      },
      expression: "auditModal"
    }
  }, [_c('audit-modal', {
    attrs: {
      "auditData": _vm.auditData
    },
    on: {
      "close": function($event) {
        _vm.auditModal = false
      }
    }
  })], 1) : _vm._e()], 1)
},staticRenderFns: []}

/***/ }),
/* 417 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-card', [(_vm.err) ? _c('v-flex', {
    attrs: {
      "xs12": "",
      "px-4": "",
      "py-3": ""
    }
  }, [_c('v-alert', {
    attrs: {
      "value": true,
      "type": "error"
    }
  }, [_vm._v(_vm._s(_vm.err))])], 1) : _vm._e(), _vm._v(" "), (_vm.success) ? _c('v-flex', {
    attrs: {
      "xs12": "",
      "px-4": "",
      "py-3": ""
    }
  }, [_c('v-alert', {
    attrs: {
      "value": true,
      "type": "success"
    }
  }, [_vm._v(_vm._s(_vm.success))])], 1) : _vm._e(), _vm._v(" "), _c('v-form', {
    staticClass: "pt-3",
    model: {
      value: (_vm.valid),
      callback: function($$v) {
        _vm.valid = $$v
      },
      expression: "valid"
    }
  }, [_c('v-layout', {
    staticClass: "px-2 pb-2",
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": "",
      "sm6": "",
      "md4": "",
      "lg3": "",
      "px-3": ""
    }
  }, [_c('v-autocomplete', {
    attrs: {
      "label": _vm.$lang.actions.selectCompany,
      "items": _vm.mappedCompanies,
      "loading": _vm.companyLoading,
      "required": "",
      "rules": [function (v) { return !!v || ("" + (_vm.$lang.errors.missingCompany)); }]
    },
    model: {
      value: (_vm.data.companyId),
      callback: function($$v) {
        _vm.$set(_vm.data, "companyId", $$v)
      },
      expression: "data.companyId"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "sm12": "",
      "md8": "",
      "lg7": "",
      "px-4": ""
    }
  }, [_c('v-autocomplete', {
    attrs: {
      "multiple": "",
      "clearable": "",
      "label": _vm.$lang.actions.selectResTrackingTypes,
      "items": _vm.trackingTypes,
      "item-text": "text",
      "item-value": "value",
      "hide-details": ""
    },
    model: {
      value: (_vm.data.resourceTrackingTypes),
      callback: function($$v) {
        _vm.$set(_vm.data, "resourceTrackingTypes", $$v)
      },
      expression: "data.resourceTrackingTypes"
    }
  })], 1)], 1), _vm._v(" "), _c('v-layout', {
    staticClass: "px-2 pb-3",
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": "",
      "sm6": "",
      "md4": "",
      "lg3": "",
      "px-3": ""
    }
  }, [_c('v-menu', {
    ref: "menu",
    attrs: {
      "return-value": _vm.data.fromDate,
      "lazy": "",
      "transition": "scale-transition",
      "full-width": "",
      "min-width": "290px"
    },
    on: {
      "update:returnValue": function($event) {
        return _vm.$set(_vm.data, "fromDate", $event)
      },
      "update:return-value": function($event) {
        return _vm.$set(_vm.data, "fromDate", $event)
      }
    },
    model: {
      value: (_vm.menu),
      callback: function($$v) {
        _vm.menu = $$v
      },
      expression: "menu"
    }
  }, [_c('v-text-field', {
    attrs: {
      "slot": "activator",
      "label": _vm.$lang.labels.fromDate,
      "prepend-icon": "event",
      "required": "",
      "rules": [function (v) { return !!v || ("" + (_vm.$lang.errors.missingFromDate)); }],
      "readonly": ""
    },
    slot: "activator",
    model: {
      value: (_vm.data.fromDate),
      callback: function($$v) {
        _vm.$set(_vm.data, "fromDate", $$v)
      },
      expression: "data.fromDate"
    }
  }), _vm._v(" "), _c('v-date-picker', {
    attrs: {
      "color": "primary",
      "no-title": "",
      "scrollable": ""
    },
    on: {
      "input": function($event) {
        return _vm.$refs.menu.save(_vm.data.fromDate)
      }
    },
    model: {
      value: (_vm.data.fromDate),
      callback: function($$v) {
        _vm.$set(_vm.data, "fromDate", $$v)
      },
      expression: "data.fromDate"
    }
  })], 1)], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "sm6": "",
      "md4": "",
      "lg3": "",
      "px-3": ""
    }
  }, [_c('v-menu', {
    ref: "menu2",
    attrs: {
      "return-value": _vm.data.toDate,
      "lazy": "",
      "transition": "scale-transition",
      "full-width": "",
      "min-width": "290px"
    },
    on: {
      "update:returnValue": function($event) {
        return _vm.$set(_vm.data, "toDate", $event)
      },
      "update:return-value": function($event) {
        return _vm.$set(_vm.data, "toDate", $event)
      }
    },
    model: {
      value: (_vm.menu2),
      callback: function($$v) {
        _vm.menu2 = $$v
      },
      expression: "menu2"
    }
  }, [_c('v-text-field', {
    attrs: {
      "slot": "activator",
      "label": _vm.$lang.labels.toDate,
      "prepend-icon": "event",
      "required": "",
      "rules": [function (v) { return !!v || ("" + (_vm.$lang.errors.missingToDate)); }],
      "readonly": ""
    },
    slot: "activator",
    model: {
      value: (_vm.data.toDate),
      callback: function($$v) {
        _vm.$set(_vm.data, "toDate", $$v)
      },
      expression: "data.toDate"
    }
  }), _vm._v(" "), _c('v-date-picker', {
    attrs: {
      "color": "primary",
      "no-title": "",
      "scrollable": ""
    },
    on: {
      "input": function($event) {
        return _vm.$refs.menu2.save(_vm.data.toDate)
      }
    },
    model: {
      value: (_vm.data.toDate),
      callback: function($$v) {
        _vm.$set(_vm.data, "toDate", $$v)
      },
      expression: "data.toDate"
    }
  })], 1)], 1), _vm._v(" "), _c('v-btn', {
    staticClass: "mx-3",
    attrs: {
      "disabled": !_vm.valid,
      "color": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.serachResources()
      }
    }
  }, [_vm._v(_vm._s(_vm.$lang.labels.search))])], 1)], 1), _vm._v(" "), (_vm.show) ? _c('v-data-table', {
    attrs: {
      "headers": _vm.headers,
      "items": _vm.resources,
      "rows-per-page-items": [50, 100, 250, 500, {
        text: 'All',
        value: -1
      }]
    },
    scopedSlots: _vm._u([{
      key: "items",
      fn: function(props) {
        return [_c('td', [_vm._v("\n          " + _vm._s(props.item.resourceType) + "\n          "), _c('small', {
          staticClass: "d-block"
        }, [_vm._v(_vm._s(props.item.id))])]), _vm._v(" "), _c('td', [_vm._v(_vm._s(props.item.resourceTrackingAction))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(props.item.status))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(props.item.fromDate ? _vm.formatDate(props.item.fromDate) : '-'))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(props.item.toDate ? _vm.formatDate(props.item.toDate) : '-'))]), _vm._v(" "), (props.item.closedOn) ? _c('td', [_vm._v("\n          " + _vm._s(_vm.formatDate(props.item.closedOn)) + "\n          "), _c('div', {
          staticClass: "d-block"
        }, [_vm._v(_vm._s(props.item.reasonForClosure))])]) : _c('td', [_vm._v("-")]), _vm._v(" "), (props.item.data != null) ? _c('td', [_vm._v("\n          " + _vm._s(props.item.data) + "\n          "), _c('v-btn', {
          staticClass: "mx-0",
          attrs: {
            "flat": "",
            "small": ""
          },
          on: {
            "click": function($event) {
              return _vm.showData(props.item.data)
            }
          }
        }, [_vm._v("\n            ...\n          ")])], 1) : _c('td', [_vm._v("-")])]
      }
    }], null, false, 2018504809)
  }, [_c('v-progress-linear', {
    attrs: {
      "slot": "progress",
      "height": "6",
      "color": "primary",
      "indeterminate": ""
    },
    slot: "progress"
  }), _vm._v(" "), _vm._v(" "), _c('v-alert', {
    attrs: {
      "slot": "no-results",
      "value": true,
      "type": "warning"
    },
    slot: "no-results"
  }, [_vm._v("\n        Your search for \"" + _vm._s(_vm.search) + "\" found no results.\n      ")])], 1) : _vm._e()], 1), _vm._v(" "), (_vm.resourceModal) ? _c('v-dialog', {
    attrs: {
      "max-width": "1200"
    },
    model: {
      value: (_vm.resourceModal),
      callback: function($$v) {
        _vm.resourceModal = $$v
      },
      expression: "resourceModal"
    }
  }, [_c('resource-modal', {
    attrs: {
      "data": _vm.resourceData
    },
    on: {
      "close": function($event) {
        _vm.resourceModal = false
      }
    }
  })], 1) : _vm._e()], 1)
},staticRenderFns: []}

/***/ }),
/* 418 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-card', {
    staticClass: "px-3 py-2"
  }, [(_vm.err) ? _c('v-flex', {
    attrs: {
      "xs12": "",
      "px-3": "",
      "py-2": ""
    }
  }, [_c('v-alert', {
    attrs: {
      "value": true,
      "type": "error"
    },
    domProps: {
      "innerHTML": _vm._s(_vm.err)
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.success) ? _c('v-flex', {
    attrs: {
      "xs12": "",
      "px-3": "",
      "py-2": ""
    }
  }, [_c('v-alert', {
    attrs: {
      "value": true,
      "type": "success"
    }
  }, [_vm._v(_vm._s(_vm.success))])], 1) : _vm._e(), _vm._v(" "), _c('v-form', {
    model: {
      value: (_vm.valid),
      callback: function($$v) {
        _vm.valid = $$v
      },
      expression: "valid"
    }
  }, [_c('h3', {
    staticClass: "pa-3"
  }, [_vm._v(_vm._s(_vm.$lang.labels.generalSettings))]), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": "",
      "justify-space-between": "",
      "align-center": ""
    }
  }, [(!_vm.isLocalAdmin) ? _c('v-flex', {
    attrs: {
      "xs12": "",
      "md6": "",
      "px-3": "",
      "py-2": ""
    }
  }, [_c('v-autocomplete', {
    attrs: {
      "required": "",
      "rules": [function () { return _vm.selectedPlanet.length > 0 || ("" + (_vm.$lang.errors.missingPlanet)); }],
      "label": _vm.$lang.actions.selectPlanet,
      "items": _vm.mappedPlanets,
      "loading": _vm.planetLoading,
      "readonly": _vm.isEdit,
      "disabled": _vm.planets.length === 0
    },
    model: {
      value: (_vm.selectedPlanet),
      callback: function($$v) {
        _vm.selectedPlanet = $$v
      },
      expression: "selectedPlanet"
    }
  })], 1) : _vm._e(), _vm._v(" "), (!_vm.isLocalAdmin) ? _c('v-flex', {
    attrs: {
      "xs12": "",
      "md6": "",
      "px-3": "",
      "py-2": ""
    }
  }, [_c('v-autocomplete', {
    attrs: {
      "required": "",
      "rules": [function () { return _vm.selectedCompany.length > 0 || ("" + (_vm.$lang.errors.missingCompany)); }],
      "label": _vm.$lang.actions.selectCompany,
      "items": _vm.mappedCompanies,
      "loading": _vm.companyLoading,
      "readonly": _vm.isEdit,
      "disabled": _vm.companies.length === 0
    },
    model: {
      value: (_vm.selectedCompany),
      callback: function($$v) {
        _vm.selectedCompany = $$v
      },
      expression: "selectedCompany"
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.isEdit) ? _c('v-flex', {
    attrs: {
      "xs12": "",
      "md2": "",
      "py-2": "",
      "px-3": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": _vm.$lang.labels.externalIDres,
      "readonly": ""
    },
    model: {
      value: (_vm.externalResID),
      callback: function($$v) {
        _vm.externalResID = $$v
      },
      expression: "externalResID"
    }
  })], 1) : _vm._e(), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "md4": _vm.isEdit,
      "md7": !_vm.isEdit,
      "py-2": "",
      "px-3": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": _vm.$lang.labels.webshopUrl,
      "rules": [function (v) { return _vm.validURL(v) || ("" + (_vm.$lang.errors.notValidUrl)); }, function (v) { return _vm.checkIsJustHostname(v) || ("" + (_vm.$lang.errors.notValidUrl)); }]
    },
    model: {
      value: (_vm.webshopUrl),
      callback: function($$v) {
        _vm.webshopUrl = $$v
      },
      expression: "webshopUrl"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "md3": "",
      "px-3": "",
      "py-2": ""
    }
  }, [_c('v-autocomplete', {
    attrs: {
      "multiple": "",
      "required": "",
      "rules": [function () { return _vm.orderSubmissionAllowedFrom.length > 0 || ("" + (_vm.$lang.errors.missingOrderSubmission)); }],
      "label": _vm.$lang.labels.orderSubmission,
      "items": _vm.ordersFrom,
      "loading": _vm.orderSubmissionLoading,
      "chips": "",
      "deletable-chips": ""
    },
    model: {
      value: (_vm.orderSubmissionAllowedFrom),
      callback: function($$v) {
        _vm.orderSubmissionAllowedFrom = $$v
      },
      expression: "orderSubmissionAllowedFrom"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "md3": "",
      "px-3": "",
      "py-2": ""
    }
  }, [_c('v-autocomplete', {
    attrs: {
      "required": "",
      "rules": [function () { return _vm.selectedOrder.length > 0 || ("" + (_vm.$lang.errors.missingOrder)); }],
      "label": _vm.$lang.actions.selectOrderType,
      "chips": "",
      "deletable-chips": "",
      "multiple": "",
      "items": _vm.orderTypes
    },
    model: {
      value: (_vm.selectedOrder),
      callback: function($$v) {
        _vm.selectedOrder = $$v
      },
      expression: "selectedOrder"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "md4": "",
      "px-3": "",
      "py-2": ""
    }
  }, [_c('v-autocomplete', {
    attrs: {
      "required": "",
      "rules": [function () { return _vm.selectedPayment.length > 0 || ("" + (_vm.$lang.errors.missingPayment)); }],
      "label": _vm.$lang.actions.selectPayment,
      "chips": "",
      "deletable-chips": "",
      "multiple": "",
      "items": _vm.payments
    },
    model: {
      value: (_vm.selectedPayment),
      callback: function($$v) {
        _vm.selectedPayment = $$v
      },
      expression: "selectedPayment"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "md2": "",
      "px-3": "",
      "pb-0": "",
      "pt-2": ""
    }
  }, [_c('v-select', {
    attrs: {
      "required": "",
      "disabled": _vm.selectedPayment.length === 0,
      "rules": [function (value) { return !!value || 'Required'; }],
      "label": _vm.$lang.labels.defaultPaymentType,
      "items": _vm.selectedPayment.length === 0 ? [] : _vm.selectedPayment
    },
    model: {
      value: (_vm.defaultPaymentType),
      callback: function($$v) {
        _vm.defaultPaymentType = $$v
      },
      expression: "defaultPaymentType"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "md2": "",
      "px-3": ""
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.$lang.labels.webshopQr))]), _vm._v(" "), (_vm.webshopUrl && _vm.externalResID) ? _c('qrcode-vue', {
    staticStyle: {
      "margin-top": "4px"
    },
    attrs: {
      "value": _vm.webshopQrCode,
      "level": "Q"
    }
  }) : _vm._e()], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "md2": "",
      "px-3": ""
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.$lang.labels.contactTrackingQr))]), _vm._v(" "), (_vm.webshopUrl) ? _c('qrcode-vue', {
    staticStyle: {
      "margin-top": "4px"
    },
    attrs: {
      "value": _vm.contactTrackingQrCode,
      "level": "Q"
    }
  }) : _vm._e()], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "md2": "",
      "px-3": ""
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.$lang.labels.menuQr))]), _vm._v(" "), (_vm.webshopUrl) ? _c('qrcode-vue', {
    staticStyle: {
      "margin-top": "4px"
    },
    attrs: {
      "value": _vm.menuQrCode,
      "level": "Q"
    }
  }) : _vm._e()], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "md6": "",
      "px-3": "",
      "py-2": ""
    }
  }, [_c('v-autocomplete', {
    attrs: {
      "required": "",
      "rules": [function () { return _vm.selectedCatalogVersion !== null || ("" + (_vm.$lang.errors.missingCatalogVersion)); }],
      "label": _vm.$lang.actions.selectCatalogVersion,
      "items": _vm.mappedCatalogVersions,
      "disabled": _vm.catalogVersions.length === 0,
      "loading": _vm.catalogVersionsLoading
    },
    model: {
      value: (_vm.selectedCatalogVersion),
      callback: function($$v) {
        _vm.selectedCatalogVersion = $$v
      },
      expression: "selectedCatalogVersion"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "md6": "",
      "px-3": "",
      "py-2": ""
    }
  }, [_c('v-autocomplete', {
    attrs: {
      "required": "",
      "rules": [function () { return _vm.selectedSubscription !== null || ("" + (_vm.$lang.errors.missingSubscription)); }],
      "label": _vm.$lang.actions.selectSubscription,
      "items": _vm.subscriptions
    },
    model: {
      value: (_vm.selectedSubscription),
      callback: function($$v) {
        _vm.selectedSubscription = $$v
      },
      expression: "selectedSubscription"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "md6": "",
      "px-3": "",
      "py-2": ""
    }
  }, [_c('v-autocomplete', {
    attrs: {
      "required": "",
      "rules": [function () { return _vm.selectedCatalogView !== null || ("" + (_vm.$lang.errors.missingCatalogView)); }],
      "label": _vm.$lang.actions.selectCatalogView,
      "items": _vm.mappedCatalogViews,
      "disabled": _vm.catalogViews.length === 0,
      "loading": _vm.catalogViewsLoading
    },
    model: {
      value: (_vm.selectedCatalogView),
      callback: function($$v) {
        _vm.selectedCatalogView = $$v
      },
      expression: "selectedCatalogView"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "md6": "",
      "px-3": "",
      "py-2": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "required": "",
      "rules": [function () { return _vm.name.length > 0 || ("" + (_vm.$lang.errors.missingName)); }],
      "label": _vm.$lang.labels.name
    },
    model: {
      value: (_vm.name),
      callback: function($$v) {
        _vm.name = $$v
      },
      expression: "name"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "md6": "",
      "px-3": "",
      "py-2": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "required": "",
      "rules": [function () { return _vm.minDelivery != null || ("" + (_vm.$lang.errors.missingDeliery)); }],
      "label": _vm.$lang.labels.minDelivery,
      "type": "number",
      "min": "0"
    },
    model: {
      value: (_vm.minDelivery),
      callback: function($$v) {
        _vm.minDelivery = $$v
      },
      expression: "minDelivery"
    }
  })], 1), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": "",
      "md6": "",
      "px-3": "",
      "py-2": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": _vm.$lang.labels.deliveryDurationFrom,
      "type": "number",
      "required": "",
      "rules": [function (v) { return v >= 0 && v <= 120 || ("" + (_vm.$lang.errors.timeError)); }],
      "min": "0",
      "max": "120"
    },
    model: {
      value: (_vm.deliveryDurationFrom),
      callback: function($$v) {
        _vm.deliveryDurationFrom = $$v
      },
      expression: "deliveryDurationFrom"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "md6": "",
      "px-3": "",
      "py-2": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": _vm.$lang.labels.deliveryDurationTo,
      "type": "number",
      "required": "",
      "rules": [function (v) { return v >= 0 && v <= 120 || ("" + (_vm.$lang.errors.timeError)); }],
      "min": "0",
      "max": "120"
    },
    model: {
      value: (_vm.deliveryDurationTo),
      callback: function($$v) {
        _vm.deliveryDurationTo = $$v
      },
      expression: "deliveryDurationTo"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": "",
      "md6": "",
      "px-3": "",
      "py-2": ""
    }
  }, [_c('v-checkbox', {
    staticClass: "mx-0",
    attrs: {
      "hide-details": "",
      "color": "primary",
      "label": _vm.$lang.labels.sendToMoon
    },
    model: {
      value: (_vm.sendToMoon),
      callback: function($$v) {
        _vm.sendToMoon = $$v
      },
      expression: "sendToMoon"
    }
  }), _vm._v(" "), _c('v-checkbox', {
    staticClass: "mx-0",
    attrs: {
      "hide-details": "",
      "color": "primary",
      "label": _vm.$lang.labels.notifyOwnerOnPaymentFailure
    },
    model: {
      value: (_vm.notifyOwnerOnPaymentFailure),
      callback: function($$v) {
        _vm.notifyOwnerOnPaymentFailure = $$v
      },
      expression: "notifyOwnerOnPaymentFailure"
    }
  }), _vm._v(" "), _c('v-checkbox', {
    staticClass: "mx-0",
    attrs: {
      "hide-details": "",
      "color": "primary",
      "label": _vm.$lang.labels.acceptingOrders
    },
    model: {
      value: (_vm.acceptingOrders),
      callback: function($$v) {
        _vm.acceptingOrders = $$v
      },
      expression: "acceptingOrders"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "md6": "",
      "px-3": "",
      "py-2": ""
    }
  }, [_c('v-checkbox', {
    staticClass: "mx-0",
    attrs: {
      "hide-details": "",
      "color": "primary",
      "label": _vm.$lang.labels.showEmail
    },
    model: {
      value: (_vm.showEmail),
      callback: function($$v) {
        _vm.showEmail = $$v
      },
      expression: "showEmail"
    }
  }), _vm._v(" "), _c('v-checkbox', {
    staticClass: "mx-0",
    attrs: {
      "hide-details": "",
      "color": "primary",
      "label": _vm.$lang.labels.showPhoneNumber
    },
    model: {
      value: (_vm.showPhoneNumber),
      callback: function($$v) {
        _vm.showPhoneNumber = $$v
      },
      expression: "showPhoneNumber"
    }
  })], 1)], 1), _vm._v(" "), _c('hr', {
    staticClass: "my-3"
  }), _vm._v(" "), _c('h3', {
    staticClass: "pa-3"
  }, [_vm._v(_vm._s(_vm.$lang.labels.smsSettings))]), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": "",
      "md6": "",
      "px-3": "",
      "py-2": ""
    }
  }, [_c('v-checkbox', {
    staticClass: "mx-0 pb-2",
    attrs: {
      "hide-details": "",
      "color": "primary",
      "label": _vm.$lang.labels.smsConfirmationFirstOrder
    },
    model: {
      value: (_vm.smsConfirmationFirstOrder),
      callback: function($$v) {
        _vm.smsConfirmationFirstOrder = $$v
      },
      expression: "smsConfirmationFirstOrder"
    }
  }), _vm._v(" "), _c('v-text-field', {
    attrs: {
      "placeholder": _vm.$lang.placeholders.smsUsername,
      "label": _vm.$lang.labels.smsUsername
    },
    model: {
      value: (_vm.smsUsername),
      callback: function($$v) {
        _vm.smsUsername = $$v
      },
      expression: "smsUsername"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "px-3": "",
      "pt-2": ""
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.$lang.labels.passwordSmaResetPrefixText))])]), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "px-3": ""
    }
  }, [_c('v-btn', {
    attrs: {
      "disabled": _vm.passwordSmsButtonDisabled,
      "color": "primary mx-0"
    },
    on: {
      "click": function($event) {
        _vm.isSms = true;
        _vm.updatePassword = true
      }
    }
  }, [_vm._v("\n            " + _vm._s(_vm.$lang.labels.updateSmsPassword) + "\n          ")])], 1)], 1), _vm._v(" "), _c('hr', {
    staticClass: "my-3"
  }), _vm._v(" "), _c('h3', {
    staticClass: "pa-3"
  }, [_vm._v(_vm._s(_vm.$lang.labels.discountSettings))]), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "px-3": "",
      "py-2": ""
    }
  }, [_c('v-autocomplete', {
    attrs: {
      "label": _vm.$lang.actions.selectRules,
      "chips": "",
      "deletable-chips": "",
      "multiple": "",
      "items": _vm.mappedDiscountRules,
      "disabled": _vm.mappedDiscountRules.length === 0
    },
    model: {
      value: (_vm.rules),
      callback: function($$v) {
        _vm.rules = $$v
      },
      expression: "rules"
    }
  })], 1), _vm._v(" "), _c('hr', {
    staticClass: "my-3"
  }), _vm._v(" "), _c('h3', {
    staticClass: "pa-3"
  }, [_vm._v(_vm._s(_vm.$lang.header.emailConf))]), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": "",
      "justify-space-between": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": "",
      "md6": "",
      "px-3": "",
      "py-2": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "required": "",
      "placeholder": _vm.$lang.placeholders.emailId,
      "rules": [function () { return _vm.sendEmail.length > 0 || ("" + (_vm.$lang.errors.missingEmailID)); }],
      "label": _vm.$lang.labels.sendEmail
    },
    model: {
      value: (_vm.sendEmail),
      callback: function($$v) {
        _vm.sendEmail = $$v
      },
      expression: "sendEmail"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "md6": "",
      "px-3": "",
      "py-2": ""
    }
  }, [_c('v-textarea', {
    attrs: {
      "auto-grow": "",
      "rows": "1",
      "placeholder": _vm.$lang.placeholders.bccEmail,
      "label": _vm.$lang.labels.sendBCC
    },
    model: {
      value: (_vm.bccEmail),
      callback: function($$v) {
        _vm.bccEmail = $$v
      },
      expression: "bccEmail"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "md6": "",
      "px-3": ""
    }
  }, [_c('v-textarea', {
    attrs: {
      "auto-grow": "",
      "rows": "3",
      "label": _vm.$lang.labels.prefix
    },
    model: {
      value: (_vm.prefix),
      callback: function($$v) {
        _vm.prefix = $$v
      },
      expression: "prefix"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "md6": "",
      "px-3": ""
    }
  }, [_c('v-textarea', {
    attrs: {
      "auto-grow": "",
      "rows": "3",
      "label": _vm.$lang.labels.postfix
    },
    model: {
      value: (_vm.postfix),
      callback: function($$v) {
        _vm.postfix = $$v
      },
      expression: "postfix"
    }
  })], 1), _vm._v(" "), _c('hr', {
    staticClass: "my-3"
  }), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('h3', {
    staticClass: "pa-3"
  }, [_vm._v(_vm._s(_vm.$lang.header.paymentGatewaySettings))])]), _vm._v(" "), (_vm.isEdit && _vm.webshopStatus !== 'created') ? _c('v-flex', {
    attrs: {
      "xs12": "",
      "md6": "",
      "px-3": ""
    }
  }, [_c('v-select', {
    attrs: {
      "label": _vm.$lang.labels.payGateway,
      "items": _vm.gateways
    },
    model: {
      value: (_vm.selectedGateway),
      callback: function($$v) {
        _vm.selectedGateway = $$v
      },
      expression: "selectedGateway"
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.isEdit && _vm.webshopStatus === 'created') ? _c('v-flex', {
    attrs: {
      "xs12": "",
      "md12": "",
      "px-3": ""
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.$lang.labels.activateShopFirst))])]) : _vm._e()], 1), _vm._v(" "), (['paymentsense', 'firstdata', 'connect-e', 'tecs'].includes(_vm.selectedGateway) && _vm.webshopStatus !== 'created') ? _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": "",
      "justify-space-between": "",
      "align-center": ""
    }
  }, [(_vm.selectedGateway === 'paymentsense' || _vm.selectedGateway === 'tecs') ? _c('v-flex', {
    attrs: {
      "xs12": "",
      "md6": "",
      "px-3": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": _vm.$lang.labels.merchantId,
      "rules": [function (v) { return !!v || ("" + (_vm.$lang.errors.missingMerchantId)); }],
      "required": ""
    },
    model: {
      value: (_vm.merchantId),
      callback: function($$v) {
        _vm.merchantId = $$v
      },
      expression: "merchantId"
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.selectedGateway === 'paymentsense') ? _c('v-flex', {
    attrs: {
      "xs12": "",
      "md6": "",
      "px-3": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": _vm.$lang.labels.preSharedKey,
      "rules": [function (v) { return !!v || ("" + (_vm.$lang.errors.missingPreSharedKey)); }],
      "required": ""
    },
    model: {
      value: (_vm.preSharedKey),
      callback: function($$v) {
        _vm.preSharedKey = $$v
      },
      expression: "preSharedKey"
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.selectedGateway === 'firstdata') ? _c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": "",
      "md6": "",
      "px-3": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": _vm.$lang.labels.storeId,
      "rules": [function (v) { return !!v || ("" + (_vm.$lang.errors.missingStoreId)); }],
      "required": ""
    },
    model: {
      value: (_vm.firstDataStoreId),
      callback: function($$v) {
        _vm.firstDataStoreId = $$v
      },
      expression: "firstDataStoreId"
    }
  })], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.selectedGateway === 'connect-e') ? _c('v-flex', {
    attrs: {
      "xs12": "",
      "md6": "",
      "px-3": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": _vm.$lang.labels.connectEApiKey,
      "rules": [function (v) { return !!v || ("" + (_vm.$lang.errors.missingApiKey)); }],
      "required": ""
    },
    model: {
      value: (_vm.connectEApiKey),
      callback: function($$v) {
        _vm.connectEApiKey = $$v
      },
      expression: "connectEApiKey"
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.selectedGateway === 'connect-e') ? _c('v-flex', {
    attrs: {
      "xs12": "",
      "md6": "",
      "px-3": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": _vm.$lang.labels.connectEUsername,
      "rules": [function (v) { return !!v || ("" + (_vm.$lang.errors.missingUsernameP)); }],
      "required": ""
    },
    model: {
      value: (_vm.connectEUsername),
      callback: function($$v) {
        _vm.connectEUsername = $$v
      },
      expression: "connectEUsername"
    }
  })], 1) : _vm._e(), _vm._v(" "), [_c('v-flex', {
    attrs: {
      "xs12": "",
      "px-3": "",
      "pt-2": ""
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.$lang.labels.passwordResetPrefixText))])]), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "px-3": ""
    }
  }, [_c('v-btn', {
    attrs: {
      "disabled": _vm.passwordButtonDisabled,
      "color": "primary mx-0"
    },
    on: {
      "click": function($event) {
        _vm.updatePassword = true
      }
    }
  }, [_vm._v("\n              " + _vm._s(_vm.$lang.labels.updatePassword) + "\n            ")])], 1)]], 2) : _vm._e(), _vm._v(" "), _c('hr', {
    staticClass: "my-3"
  }), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": "",
      "justify-space-between": "",
      "align-center": ""
    }
  }, [_c('h3', {
    staticClass: "pa-3"
  }, [_vm._v(_vm._s(_vm.$lang.header.htmlHints))]), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "px-3": ""
    }
  }, [_c('v-btn', {
    attrs: {
      "color": "primary mx-0"
    },
    on: {
      "click": function($event) {
        return _vm.addHtmlCode()
      }
    }
  }, [_vm._v("\n            " + _vm._s(_vm.$lang.labels.addHtml) + "\n          ")]), _vm._v(" "), _c('v-btn', {
    attrs: {
      "color": "primary mx-0"
    },
    on: {
      "click": function($event) {
        _vm.htmlImportModal = true
      }
    }
  }, [_vm._v("\n            " + _vm._s(_vm.$lang.labels.importHtml) + "\n          ")])], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "px-3": "",
      "pb-3": ""
    }
  }, [(_vm.htmlHints) ? _c('v-data-table', {
    staticClass: "elevation-0 mt-2",
    attrs: {
      "headers": _vm.headers,
      "items": _vm.htmlHints,
      "hide-actions": ""
    },
    scopedSlots: _vm._u([{
      key: "items",
      fn: function(props) {
        return [_c('td', [_vm._v(_vm._s(props.item.name))]), _vm._v(" "), (props.item.name !== 'webshop.logo' && props.item.name !== 'webshop.headerImage.mobile') ? _c('td', [_vm._v("\n                " + _vm._s(props.item.value) + "\n              ")]) : _c('td', [_c('v-img', {
          attrs: {
            "src": props.item.value,
            "contain": "",
            "max-height": "60"
          }
        })], 1), _vm._v(" "), _c('td', [_c('v-btn', {
          staticClass: "primary mx-0",
          on: {
            "click": function($event) {
              return _vm.editHtmlCode(props.item)
            }
          }
        }, [_vm._v("\n                  " + _vm._s(_vm.$lang.actions.edit) + "\n                ")]), _vm._v(" "), _c('v-btn', {
          staticClass: "error mx-0",
          on: {
            "click": function($event) {
              return _vm.confirmDeleteHtmlCode(props.item)
            }
          }
        }, [_vm._v("\n                  " + _vm._s(_vm.$lang.actions.delete) + "\n                ")])], 1)]
      }
    }], null, false, 3541464929)
  }) : _vm._e()], 1)], 1), _vm._v(" "), (_vm.isEdit) ? [_c('hr', {
    staticClass: "my-3"
  }), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": "",
      "justify-space-between": "",
      "align-center": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": "",
      "sm6": "",
      "px-3": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": _vm.$lang.labels.created,
      "type": "text"
    },
    model: {
      value: (_vm.createdOn),
      callback: function($$v) {
        _vm.createdOn = $$v
      },
      expression: "createdOn"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "sm6": "",
      "px-3": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": _vm.$lang.labels.modified,
      "type": "text"
    },
    model: {
      value: (_vm.modifiedOn),
      callback: function($$v) {
        _vm.modifiedOn = $$v
      },
      expression: "modifiedOn"
    }
  })], 1)], 1)] : _vm._e(), _vm._v(" "), (_vm.err) ? _c('v-flex', {
    attrs: {
      "xs12": "",
      "px-3": "",
      "py-2": ""
    }
  }, [_c('v-alert', {
    attrs: {
      "value": true,
      "type": "error"
    },
    domProps: {
      "innerHTML": _vm._s(_vm.err)
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.success) ? _c('v-flex', {
    attrs: {
      "xs12": "",
      "px-3": "",
      "py-2": ""
    }
  }, [_c('v-alert', {
    attrs: {
      "value": true,
      "type": "success"
    }
  }, [_vm._v(_vm._s(_vm.success))])], 1) : _vm._e(), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": "",
      "justify-space-between": "",
      "align-center": "",
      "py-2": ""
    }
  }, [_c('v-btn', {
    staticClass: "ml-0",
    attrs: {
      "flat": ""
    },
    on: {
      "click": function($event) {
        return _vm.$router.push({
          name: 'webShop'
        })
      }
    }
  }, [_c('v-icon', [_vm._v("keyboard_arrow_left")]), _vm._v("\n          " + _vm._s(_vm.$lang.actions.close) + "\n        ")], 1), _vm._v(" "), _c('v-btn', {
    staticClass: "primary mx-0",
    attrs: {
      "disabled": !_vm.valid
    },
    on: {
      "click": _vm.submit
    }
  }, [_vm._v("\n          " + _vm._s(_vm.$lang.actions.submit) + "\n        ")])], 1)], 2)], 1), _vm._v(" "), _c('v-snackbar', {
    attrs: {
      "bottom": "",
      "timeout": _vm.snackbarTimeout,
      "color": "error",
      "multi-line": ""
    },
    model: {
      value: (_vm.snackbar),
      callback: function($$v) {
        _vm.snackbar = $$v
      },
      expression: "snackbar"
    }
  }, [_vm._v("\n    " + _vm._s(_vm.$lang.labels.sendToMoonWarning) + "\n    "), _c('v-btn', {
    attrs: {
      "flat": ""
    },
    on: {
      "click": function($event) {
        _vm.snackbar = false
      }
    }
  }, [_vm._v("\n      " + _vm._s(_vm.$lang.actions.close) + "\n    ")])], 1), _vm._v(" "), (_vm.activationModal) ? _c('v-dialog', {
    attrs: {
      "persistent": "",
      "max-width": "500"
    },
    model: {
      value: (_vm.activationModal),
      callback: function($$v) {
        _vm.activationModal = $$v
      },
      expression: "activationModal"
    }
  }, [_c('activation-modal', {
    attrs: {
      "data": _vm.activationData
    },
    on: {
      "close": function($event) {
        return _vm.redirectBack()
      }
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.updatePassword) ? _c('v-dialog', {
    attrs: {
      "persistent": "",
      "max-width": "500"
    },
    model: {
      value: (_vm.updatePassword),
      callback: function($$v) {
        _vm.updatePassword = $$v
      },
      expression: "updatePassword"
    }
  }, [_c('change-password', {
    attrs: {
      "isSms": _vm.isSms
    },
    on: {
      "close": function($event) {
        _vm.updatePassword = false;
        _vm.isSms = false;
      }
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.confirmationModal) ? _c('v-dialog', {
    attrs: {
      "persistent": "",
      "max-width": "500"
    },
    model: {
      value: (_vm.confirmationModal),
      callback: function($$v) {
        _vm.confirmationModal = $$v
      },
      expression: "confirmationModal"
    }
  }, [_c('confirmation-modal', {
    attrs: {
      "text": _vm.$lang.actions.deleteHtmlHint
    },
    on: {
      "submit": function($event) {
        return _vm.deleteHtmlCode()
      },
      "close": function($event) {
        _vm.confirmationModal = false;
        _vm.tempIndex = null
      }
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.htmlModal) ? _c('v-dialog', {
    attrs: {
      "persistent": "",
      "max-width": "1200"
    },
    model: {
      value: (_vm.htmlModal),
      callback: function($$v) {
        _vm.htmlModal = $$v
      },
      expression: "htmlModal"
    }
  }, [_c('html-hints-modal', {
    attrs: {
      "htmlCode": _vm.htmlCodeToEdit,
      "isHtmlEdit": _vm.isHtmlEdit,
      "htmlKeysListFiltered": _vm.htmlKeysListFiltered
    },
    on: {
      "submit": function($event) {
        return _vm.saveHtmlCode($event)
      },
      "close": function($event) {
        _vm.htmlModal = false, _vm.htmlCodeToEdit = null, _vm.tempIndex = null
      }
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.htmlImportModal) ? _c('v-dialog', {
    attrs: {
      "persistent": "",
      "max-width": "1200"
    },
    model: {
      value: (_vm.htmlImportModal),
      callback: function($$v) {
        _vm.htmlImportModal = $$v
      },
      expression: "htmlImportModal"
    }
  }, [_c('html-hints-import-modal', {
    on: {
      "submit": function($event) {
        return _vm.importHtmlCode($event)
      },
      "close": function($event) {
        _vm.htmlImportModal = false
      }
    }
  })], 1) : _vm._e()], 1)
},staticRenderFns: []}

/***/ }),
/* 419 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-card', [(_vm.err) ? _c('v-flex', {
    attrs: {
      "xs12": "",
      "px-4": ""
    }
  }, [_c('v-alert', {
    attrs: {
      "value": true,
      "type": "error"
    }
  }, [_vm._v(_vm._s(_vm.err))])], 1) : _vm._e(), _vm._v(" "), _c('v-card-title', {
    staticClass: "pb-0 px-4 layout row wrap"
  }, [_c('v-btn', {
    staticClass: "primary ma-0",
    on: {
      "click": function($event) {
        return _vm.$router.push({
          name: "languageMappingCreate"
        })
      }
    }
  }, [_vm._v(_vm._s(_vm.$lang.actions.createLangMapp))]), _vm._v(" "), _c('v-checkbox', {
    staticClass: "ml-3 mt-0",
    attrs: {
      "color": "primary",
      "label": _vm.$lang.labels.showActive,
      "hide-details": ""
    },
    model: {
      value: (_vm.showActive),
      callback: function($$v) {
        _vm.showActive = $$v
      },
      expression: "showActive"
    }
  }), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('v-text-field', {
    staticClass: "min-w max-w",
    attrs: {
      "append-icon": "search",
      "label": _vm.$lang.labels.search,
      "hide-details": ""
    },
    model: {
      value: (_vm.search),
      callback: function($$v) {
        _vm.search = $$v
      },
      expression: "search"
    }
  })], 1), _vm._v(" "), _c('v-data-table', {
    attrs: {
      "headers": _vm.headers,
      "items": _vm.showActive ? _vm.activePrinterCategories : _vm.allPrinterCategories,
      "search": _vm.search,
      "loading": _vm.allPrinterCategories.length === 0,
      "rows-per-page-items": [50, 100, 250, 500, {
        text: 'All',
        value: -1
      }]
    },
    scopedSlots: _vm._u([{
      key: "items",
      fn: function(props) {
        return [_c('td', [_vm._v(_vm._s(props.item.companyName))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.formatDate(props.item.createdOn)))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(props.item.status))]), _vm._v(" "), _c('td', {
          staticClass: "min-w-lg"
        }, [_c('v-btn', {
          staticClass: "primary mx-0 elevation-1",
          on: {
            "click": function($event) {
              return _vm.$router.push({
                name: 'languageMappingEdit',
                params: {
                  id: props.item.id
                }
              })
            }
          }
        }, [_vm._v(_vm._s(_vm.$lang.actions.edit))]), _vm._v(" "), _c('v-btn', {
          staticClass: "primary elevation-1",
          on: {
            "click": function($event) {
              return _vm.changeStatus(props.item)
            }
          }
        }, [_vm._v(_vm._s(props.item.status === 'active' ? _vm.$lang.actions.deactivate : _vm.$lang.actions.activate))])], 1)]
      }
    }])
  }, [_c('v-progress-linear', {
    attrs: {
      "slot": "progress",
      "height": "6",
      "color": "primary",
      "indeterminate": ""
    },
    slot: "progress"
  }), _vm._v(" "), _vm._v(" "), _c('v-alert', {
    attrs: {
      "slot": "no-results",
      "value": true,
      "color": "warning",
      "icon": "warning"
    },
    slot: "no-results"
  }, [_vm._v("\n        Your search for \"" + _vm._s(_vm.search) + "\" found no results.\n      ")])], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 420 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-card', [(_vm.err) ? _c('v-flex', {
    attrs: {
      "xs12": "",
      "px-4": ""
    }
  }, [_c('v-alert', {
    attrs: {
      "value": true,
      "type": "error"
    }
  }, [_vm._v(_vm._s(_vm.err))])], 1) : _vm._e(), _vm._v(" "), _c('v-card-title', {
    staticClass: "py-3 px-2 layout row wrap"
  }, [_c('v-btn', {
    staticClass: "primary my-0 mx-3",
    on: {
      "click": function($event) {
        return _vm.$router.push({
          name: "paymentServerCreate"
        })
      }
    }
  }, [_vm._v(_vm._s(_vm.$lang.actions.paymentServerCreate))]), _vm._v(" "), _c('v-checkbox', {
    staticClass: "mx-1 mt-0",
    attrs: {
      "color": "primary",
      "label": _vm.$lang.labels.showActive,
      "hide-details": ""
    },
    model: {
      value: (_vm.showActive),
      callback: function($$v) {
        _vm.showActive = $$v
      },
      expression: "showActive"
    }
  }), _vm._v(" "), _c('v-spacer'), _vm._v(" "), (!_vm.isLocalAdmin) ? _c('v-autocomplete', {
    staticClass: "min-w max-w mx-3 pb-2",
    attrs: {
      "label": _vm.$lang.actions.selectCompany,
      "items": _vm.mappedCompanies,
      "hide-details": ""
    },
    model: {
      value: (_vm.selectedCompany),
      callback: function($$v) {
        _vm.selectedCompany = $$v
      },
      expression: "selectedCompany"
    }
  }) : _vm._e(), _vm._v(" "), (_vm.show) ? _c('v-text-field', {
    staticClass: "min-w max-w mx-3 pb-2",
    attrs: {
      "append-icon": "search",
      "label": _vm.$lang.labels.search,
      "hide-details": ""
    },
    model: {
      value: (_vm.search),
      callback: function($$v) {
        _vm.search = $$v
      },
      expression: "search"
    }
  }) : _vm._e()], 1), _vm._v(" "), (_vm.show) ? _c('v-data-table', {
    attrs: {
      "headers": _vm.headers,
      "items": _vm.showActive ? _vm.activePaymentServers : _vm.allPaymentServers,
      "search": _vm.search,
      "loading": _vm.loading,
      "rows-per-page-items": [50, 100, 250, 500, {
        text: 'All',
        value: -1
      }]
    },
    scopedSlots: _vm._u([{
      key: "items",
      fn: function(props) {
        return [_c('td', [_vm._v(_vm._s(props.item.name))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(props.item.status))]), _vm._v(" "), _c('td', {
          staticClass: "min-w-lg"
        }, [_c('v-btn', {
          staticClass: "primary mx-0 elevation-1",
          on: {
            "click": function($event) {
              return _vm.goToServer(props.item)
            }
          }
        }, [_vm._v(_vm._s(_vm.$lang.actions.edit))]), _vm._v(" "), _c('v-btn', {
          staticClass: "primary elevation-1",
          on: {
            "click": function($event) {
              return _vm.changeStatus(props.item)
            }
          }
        }, [_vm._v(_vm._s(props.item.status === 'active' ? _vm.$lang.actions.deactivate : _vm.$lang.actions.activate))])], 1)]
      }
    }], null, false, 2353444647)
  }, [_c('v-progress-linear', {
    attrs: {
      "slot": "progress",
      "height": "6",
      "color": "primary",
      "indeterminate": ""
    },
    slot: "progress"
  }), _vm._v(" "), _vm._v(" "), _c('v-alert', {
    attrs: {
      "slot": "no-results",
      "value": true,
      "color": "warning",
      "icon": "warning"
    },
    slot: "no-results"
  }, [_vm._v("\n        Your search for \"" + _vm._s(_vm.search) + "\" found no results.\n      ")])], 1) : _vm._e()], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 421 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-card', [(_vm.err) ? _c('v-flex', {
    attrs: {
      "xs12": "",
      "px-4": "",
      "py-4": ""
    }
  }, [_c('v-alert', {
    attrs: {
      "value": true,
      "type": "error"
    }
  }, [_vm._v(_vm._s(_vm.err))])], 1) : _vm._e(), _vm._v(" "), _c('v-card-title', {
    staticClass: "pb-3 px-2 layout row wrap"
  }, [_c('v-btn', {
    staticClass: "primary my-0 mx-3",
    on: {
      "click": function($event) {
        return _vm.$router.push({
          name: "tableDetailsCreate"
        })
      }
    }
  }, [_vm._v(_vm._s(_vm.$lang.actions.createTable))]), _vm._v(" "), _c('v-checkbox', {
    staticClass: "mx-1 mt-0",
    attrs: {
      "color": "primary",
      "label": _vm.$lang.labels.showActive,
      "hide-details": ""
    },
    model: {
      value: (_vm.showActive),
      callback: function($$v) {
        _vm.showActive = $$v
      },
      expression: "showActive"
    }
  }), _vm._v(" "), _c('v-spacer'), _vm._v(" "), (!_vm.isLocalAdmin) ? _c('v-autocomplete', {
    staticClass: "min-w max-w mx-2 pb-2",
    attrs: {
      "label": _vm.$lang.actions.selectCompany,
      "items": _vm.mappedCompanies,
      "loading": _vm.companyLoading,
      "hide-details": ""
    },
    model: {
      value: (_vm.selectedCompany),
      callback: function($$v) {
        _vm.selectedCompany = $$v
      },
      expression: "selectedCompany"
    }
  }) : _vm._e(), _vm._v(" "), (_vm.show) ? _c('v-text-field', {
    staticClass: "min-w max-w mx-3 pb-2",
    attrs: {
      "append-icon": "search",
      "label": _vm.$lang.labels.search,
      "hide-details": ""
    },
    model: {
      value: (_vm.search),
      callback: function($$v) {
        _vm.search = $$v
      },
      expression: "search"
    }
  }) : _vm._e()], 1), _vm._v(" "), (_vm.show) ? _c('v-data-table', {
    attrs: {
      "headers": _vm.headers,
      "items": _vm.showActive ? _vm.activeTables : _vm.allTables,
      "search": _vm.search,
      "loading": _vm.allTables.length === 0,
      "rows-per-page-items": [50, 100, 250, 500, {
        text: 'All',
        value: -1
      }]
    },
    scopedSlots: _vm._u([{
      key: "items",
      fn: function(props) {
        return [_c('td', {
          staticClass: "text-xs-left"
        }, [_vm._v(_vm._s(props.item.categoryName))]), _vm._v(" "), _c('td', {
          staticClass: "text-xs-left"
        }, [_vm._v(_vm._s(props.item.sequenceNumber))]), _vm._v(" "), _c('td', {
          staticClass: "text-xs-left"
        }, [_vm._v(_vm._s(props.item.name))]), _vm._v(" "), _c('td', {
          staticClass: "text-xs-left"
        }, [_vm._v(_vm._s(props.item.status))]), _vm._v(" "), _c('td', {
          staticClass: "text-xs-left min-w-lg"
        }, [_c('v-btn', {
          staticClass: "primary mx-0 elevation-1",
          on: {
            "click": function($event) {
              return _vm.$router.push({
                name: 'tableDetails',
                params: {
                  id: props.item.id
                }
              })
            }
          }
        }, [_vm._v(_vm._s(_vm.$lang.actions.edit))]), _vm._v(" "), _c('v-btn', {
          staticClass: "primary elevation-1",
          on: {
            "click": function($event) {
              return _vm.changeStatus(props.item)
            }
          }
        }, [_vm._v(_vm._s(props.item.status === 'active' ? _vm.$lang.actions.deactivate : _vm.$lang.actions.activate))])], 1)]
      }
    }], null, false, 1834440695)
  }, [_c('v-progress-linear', {
    attrs: {
      "slot": "progress",
      "height": "6",
      "color": "primary",
      "indeterminate": ""
    },
    slot: "progress"
  }), _vm._v(" "), _vm._v(" "), _c('v-alert', {
    attrs: {
      "slot": "no-results",
      "value": true,
      "color": "warning",
      "icon": "warning"
    },
    slot: "no-results"
  }, [_vm._v("\n        Your search for \"" + _vm._s(_vm.search) + "\" found no results.\n      ")])], 1) : _vm._e()], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 422 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-card', [(_vm.err) ? _c('v-flex', {
    attrs: {
      "xs12": "",
      "px-4": ""
    }
  }, [_c('v-alert', {
    attrs: {
      "value": true,
      "type": "error"
    }
  }, [_vm._v(_vm._s(_vm.err))])], 1) : _vm._e(), _vm._v(" "), _c('v-card-title', {
    staticClass: "pb-0 px-4 layout row wrap"
  }, [_c('h3', [_vm._v(_vm._s(_vm.$lang.header.autoJobs))]), _vm._v(" "), _c('v-checkbox', {
    staticClass: "ml-3 mt-0",
    attrs: {
      "color": "primary",
      "label": _vm.$lang.labels.showActive,
      "hide-details": ""
    },
    model: {
      value: (_vm.showActive),
      callback: function($$v) {
        _vm.showActive = $$v
      },
      expression: "showActive"
    }
  }), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('v-text-field', {
    staticClass: "min-w max-w",
    attrs: {
      "append-icon": "search",
      "label": _vm.$lang.labels.search,
      "hide-details": ""
    },
    model: {
      value: (_vm.search),
      callback: function($$v) {
        _vm.search = $$v
      },
      expression: "search"
    }
  })], 1), _vm._v(" "), _c('v-data-table', {
    attrs: {
      "headers": _vm.headers,
      "items": _vm.showActive ? _vm.activeAutojobs : _vm.allAutojobs,
      "search": _vm.search,
      "loading": _vm.allAutojobs.length === 0,
      "rows-per-page-items": [50, 100, 250, 500, {
        text: 'All',
        value: -1
      }]
    },
    scopedSlots: _vm._u([{
      key: "items",
      fn: function(props) {
        return [_c('td', [_vm._v(_vm._s(props.item.jobName))]), _vm._v(" "), _c('td', {
          staticClass: "min-w"
        }, [_vm._v(_vm._s(props.item.jobDesc))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.formatDate(props.item.lastExecutedOn)))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.formatDate(props.item.nextPlannedExecutionOn)))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(props.item.status))]), _vm._v(" "), _c('td', [_c('v-btn', {
          staticClass: "primary elevation-1",
          on: {
            "click": function($event) {
              return _vm.changeStatus(props.item)
            }
          }
        }, [_vm._v(_vm._s(props.item.status === 'active' ? _vm.$lang.actions.deactivate : _vm.$lang.actions.activate))])], 1)]
      }
    }])
  }, [_c('v-progress-linear', {
    attrs: {
      "slot": "progress",
      "height": "6",
      "color": "primary",
      "indeterminate": ""
    },
    slot: "progress"
  }), _vm._v(" "), _vm._v(" "), _c('v-alert', {
    attrs: {
      "slot": "no-results",
      "value": true,
      "color": "warning",
      "icon": "warning"
    },
    slot: "no-results"
  }, [_vm._v("\n        Your search for \"" + _vm._s(_vm.search) + "\" found no results.\n      ")])], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 423 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": "",
      "md6": "",
      "px-2": "",
      "pb-2": ""
    }
  }, [_c('v-card', {
    staticClass: "pa-4"
  }, [(_vm.err) ? _c('v-flex', {
    attrs: {
      "xs12": "",
      "pb-3": ""
    }
  }, [_c('v-alert', {
    attrs: {
      "value": true,
      "type": "error"
    }
  }, [_vm._v(_vm._s(_vm.err))])], 1) : _vm._e(), _vm._v(" "), (_vm.success) ? _c('v-flex', {
    attrs: {
      "xs12": "",
      "pb-3": ""
    }
  }, [_c('v-alert', {
    attrs: {
      "value": true,
      "type": "success"
    }
  }, [_vm._v(_vm._s(_vm.success))])], 1) : _vm._e(), _vm._v(" "), _c('v-form', {
    model: {
      value: (_vm.valid),
      callback: function($$v) {
        _vm.valid = $$v
      },
      expression: "valid"
    }
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": "",
      "justify-space-between": "",
      "align-center": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-autocomplete', {
    attrs: {
      "items": _vm.companies,
      "label": _vm.$lang.actions.selectCompany,
      "item-text": "name",
      "item-value": "id",
      "required": "",
      "readonly": _vm.isEdit,
      "loading": _vm.companyLoading,
      "rules": [function (v) { return !!v || ("" + (_vm.$lang.errors.missingCompany)); }]
    },
    model: {
      value: (_vm.image.companyId),
      callback: function($$v) {
        _vm.$set(_vm.image, "companyId", $$v)
      },
      expression: "image.companyId"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": _vm.$lang.labels.imageName,
      "required": "",
      "rules": [function (v) { return !!v || ("" + (_vm.$lang.errors.missingImageName)); }]
    },
    model: {
      value: (_vm.image.name),
      callback: function($$v) {
        _vm.$set(_vm.image, "name", $$v)
      },
      expression: "image.name"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-select', {
    attrs: {
      "items": _vm.labels,
      "label": _vm.$lang.actions.selectLabel,
      "required": "",
      "loading": _vm.lablesLoading,
      "rules": [function (v) { return !!v || ("" + (_vm.$lang.errors.missingImageLabel)); }]
    },
    model: {
      value: (_vm.image.label),
      callback: function($$v) {
        _vm.$set(_vm.image, "label", $$v)
      },
      expression: "image.label"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-text-field', {
    ref: "fileTextField",
    staticClass: "min-w",
    attrs: {
      "prepend-icon": "attach_file",
      "single-line": "",
      "hide-details": "",
      "label": "choose_file",
      "required": ""
    },
    on: {
      "click": function($event) {
        return _vm.startInput('imageInput')
      }
    },
    model: {
      value: (_vm.filename),
      callback: function($$v) {
        _vm.filename = $$v
      },
      expression: "filename"
    }
  }), _vm._v(" "), _c('input', {
    ref: "imageInput",
    staticStyle: {
      "display": "none"
    },
    attrs: {
      "type": "file",
      "accept": "image/*"
    },
    on: {
      "change": function($event) {
        return _vm.onFileChange('imageInput', $event)
      }
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs6": ""
    }
  }, [_c('v-btn', {
    staticClass: "mx-0 mt-4",
    attrs: {
      "disabled": _vm.previewValidation(),
      "color": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.preview()
      }
    }
  }, [_vm._v("\n            " + _vm._s(_vm.$lang.actions.preview) + "\n          ")])], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs6": ""
    }
  }, [_c('v-checkbox', {
    staticClass: "ml-3 mt-0",
    attrs: {
      "color": "primary",
      "label": _vm.$lang.labels.publiclyAvailable,
      "hide-details": ""
    },
    model: {
      value: (_vm.image.publiclyAvailable),
      callback: function($$v) {
        _vm.$set(_vm.image, "publiclyAvailable", $$v)
      },
      expression: "image.publiclyAvailable"
    }
  })], 1)], 1), _vm._v(" "), _c('v-layout', {
    staticClass: "mt-3",
    attrs: {
      "row": "",
      "wrap": "",
      "justify-space-between": "",
      "align-content-center": ""
    }
  }, [_c('v-btn', {
    staticClass: "ml-0",
    attrs: {
      "flat": ""
    },
    on: {
      "click": function($event) {
        return _vm.$router.push({
          name: 'images'
        })
      }
    }
  }, [_c('v-icon', [_vm._v("keyboard_arrow_left")]), _vm._v("\n          " + _vm._s(_vm.$lang.actions.close) + "\n        ")], 1), _vm._v(" "), _c('div', [(_vm.isEdit) ? _c('v-btn', {
    staticClass: "primary",
    on: {
      "click": function($event) {
        return _vm.toggleActivate()
      }
    }
  }, [_vm._v("\n            " + _vm._s(_vm.image.status === 'active' ? _vm.$lang.actions.deactivate : _vm.$lang.actions.activate) + "\n          ")]) : _vm._e(), _vm._v(" "), _c('v-btn', {
    staticClass: "primary mx-0",
    attrs: {
      "disabled": !_vm.valid
    },
    on: {
      "click": _vm.submit
    }
  }, [_vm._v("\n            " + _vm._s(_vm.isEdit ? _vm.$lang.actions.update : _vm.$lang.actions.create) + "\n          ")])], 1)], 1)], 1)], 1), _vm._v(" "), (_vm.previewModal) ? _c('v-dialog', {
    attrs: {
      "max-width": "800"
    },
    model: {
      value: (_vm.previewModal),
      callback: function($$v) {
        _vm.previewModal = $$v
      },
      expression: "previewModal"
    }
  }, [_c('preview', {
    attrs: {
      "data": _vm.previewData,
      "image": _vm.image
    },
    on: {
      "close": function($event) {
        _vm.previewModal = false
      }
    }
  })], 1) : _vm._e()], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "md6": "",
      "px-2": ""
    }
  }, [(_vm.image.base64Image !== '') ? _c('v-card', {
    staticClass: "pa-4"
  }, [_c('v-img', {
    staticStyle: {
      "width": "50% !important",
      "height": "50% !important"
    },
    attrs: {
      "contain": "",
      "src": _vm.image.base64Image
    }
  })], 1) : _vm._e()], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 424 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [(_vm.moonInstance.length === 0) ? _c('v-flex', {
    staticClass: "my-4 text-xs-center"
  }, [_c('v-progress-circular', {
    attrs: {
      "indeterminate": "",
      "color": "primary"
    }
  })], 1) : _vm._e(), _vm._v(" "), _c('v-card', [_c('v-card-title', {
    staticClass: "pb-3 px-2 layout row wrap"
  }, [_c('h3', {
    staticClass: "mx-3"
  }, [_vm._v(_vm._s(_vm.$lang.header.moonInstances))]), _vm._v(" "), _c('v-checkbox', {
    staticClass: "mx-1 mt-0",
    attrs: {
      "color": "primary",
      "label": _vm.$lang.labels.showActive,
      "hide-details": ""
    },
    model: {
      value: (_vm.showActive),
      callback: function($$v) {
        _vm.showActive = $$v
      },
      expression: "showActive"
    }
  }), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('v-text-field', {
    staticClass: "min-w max-w mx-3 pb-2",
    attrs: {
      "append-icon": "search",
      "label": _vm.$lang.labels.search,
      "hide-details": ""
    },
    model: {
      value: (_vm.search),
      callback: function($$v) {
        _vm.search = $$v
      },
      expression: "search"
    }
  })], 1), _vm._v(" "), _c('v-data-table', {
    attrs: {
      "headers": _vm.headers,
      "items": _vm.showActive ? _vm.activeInstances : _vm.allInstances,
      "search": _vm.search,
      "loading": _vm.allInstances.length === 0,
      "rows-per-page-items": [50, 100, 250, 500, {
        text: 'All',
        value: -1
      }]
    },
    scopedSlots: _vm._u([{
      key: "items",
      fn: function(props) {
        return [_c('td', [_vm._v(_vm._s(props.item.name))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(props.item.currentVersion))]), _vm._v(" "), _c('td', {
          staticClass: "text-xs-left"
        }, [_vm._v(_vm._s(_vm.formatDate(props.item.createdOn)))]), _vm._v(" "), _c('td', {
          staticClass: "text-xs-left"
        }, [_vm._v(_vm._s(_vm.formatDate(props.item.lastContactOn)))]), _vm._v(" "), _c('td', {
          staticClass: "text-xs-left"
        }, [_vm._v(_vm._s(props.item.status))]), _vm._v(" "), _c('td', {
          staticClass: "text-xs-left"
        }, [_c('v-btn', {
          staticClass: "primary mx-0 elevation-1",
          on: {
            "click": function($event) {
              return _vm.moonInstance(props.item)
            }
          }
        }, [_vm._v(_vm._s(_vm.$lang.actions.edit))])], 1)]
      }
    }])
  }, [_c('v-progress-linear', {
    attrs: {
      "slot": "progress",
      "height": "6",
      "color": "primary",
      "indeterminate": ""
    },
    slot: "progress"
  }), _vm._v(" "), _vm._v(" "), _c('v-alert', {
    attrs: {
      "slot": "no-results",
      "value": true,
      "color": "warning",
      "icon": "warning"
    },
    slot: "no-results"
  }, [_vm._v("\n        Your search for \"" + _vm._s(_vm.search) + "\" found no results.\n      ")])], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 425 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-card', [(_vm.err) ? _c('v-flex', {
    attrs: {
      "xs12": "",
      "px-4": ""
    }
  }, [_c('v-alert', {
    attrs: {
      "value": true,
      "type": "error"
    }
  }, [_vm._v(_vm._s(_vm.err))])], 1) : _vm._e(), _vm._v(" "), _c('v-card-title', {
    staticClass: "pb-0 px-4 layout row wrap"
  }, [_c('v-btn', {
    staticClass: "primary ma-0",
    on: {
      "click": function($event) {
        return _vm.$router.push({
          name: "createAccount"
        })
      }
    }
  }, [_vm._v(_vm._s(_vm.$lang.actions.createAccount))]), _vm._v(" "), _c('v-checkbox', {
    staticClass: "ml-3 mt-0",
    attrs: {
      "color": "primary",
      "label": _vm.$lang.labels.showActive,
      "hide-details": ""
    },
    model: {
      value: (_vm.showActive),
      callback: function($$v) {
        _vm.showActive = $$v
      },
      expression: "showActive"
    }
  }), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('v-text-field', {
    staticClass: "min-w max-w",
    attrs: {
      "append-icon": "search",
      "label": _vm.$lang.labels.search,
      "hide-details": ""
    },
    model: {
      value: (_vm.search),
      callback: function($$v) {
        _vm.search = $$v
      },
      expression: "search"
    }
  })], 1), _vm._v(" "), _c('v-data-table', {
    attrs: {
      "headers": _vm.headers,
      "items": _vm.showActive ? _vm.activeAccounts : _vm.allAccounts,
      "search": _vm.search,
      "loading": _vm.allAccounts.length === 0,
      "rows-per-page-items": [50, 100, 250, 500, {
        text: 'All',
        value: -1
      }]
    },
    scopedSlots: _vm._u([{
      key: "items",
      fn: function(props) {
        return [_c('td', [_vm._v(_vm._s(props.item.name))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(props.item.userName))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(props.item.companyName))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(props.item.accountStatus))]), _vm._v(" "), _c('td', {
          staticClass: "min-w-lg"
        }, [_c('v-btn', {
          staticClass: "primary mx-0 elevation-1",
          on: {
            "click": function($event) {
              return _vm.$router.push({
                name: 'editAccunt',
                params: {
                  id: props.item.id
                }
              })
            }
          }
        }, [_vm._v(_vm._s(_vm.$lang.actions.edit))]), _vm._v(" "), _c('v-btn', {
          staticClass: "primary elevation-1",
          on: {
            "click": function($event) {
              return _vm.changeStatus(props.item)
            }
          }
        }, [_vm._v(_vm._s(props.item.accountStatus === 'active' ? _vm.$lang.actions.deactivate : _vm.$lang.actions.activate))])], 1)]
      }
    }])
  }, [_c('v-progress-linear', {
    attrs: {
      "slot": "progress",
      "height": "6",
      "color": "primary",
      "indeterminate": ""
    },
    slot: "progress"
  }), _vm._v(" "), _vm._v(" "), _c('v-alert', {
    attrs: {
      "slot": "no-results",
      "value": true,
      "color": "warning",
      "icon": "warning"
    },
    slot: "no-results"
  }, [_vm._v("\n        Your search for \"" + _vm._s(_vm.search) + "\" found no results.\n      ")])], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 426 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-container', [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [(_vm.generatedJSON) ? _c('v-card', {
    staticClass: "pa-4 mb-4"
  }, [_c('v-layout', {
    attrs: {
      "align-center": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('div', {
    staticClass: "json-field pa-3"
  }, [_vm._v(_vm._s(_vm.generatedJSON))]), _vm._v(" "), _c('input', {
    attrs: {
      "type": "text",
      "id": "json-field"
    },
    domProps: {
      "value": _vm.generatedJSON
    }
  })]), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "text-xs-right": ""
    }
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": "",
      "justify-space-between": "",
      "align-center": ""
    }
  }, [_c('v-btn', {
    staticClass: "mx-0",
    attrs: {
      "color": "primary"
    },
    on: {
      "click": _vm.copyJSON
    }
  }, [_vm._v("Copy")]), _vm._v(" "), _c('v-btn', {
    staticClass: "mx-0",
    attrs: {
      "color": "error"
    },
    on: {
      "click": function($event) {
        _vm.generatedJSON = ''
      }
    }
  }, [_vm._v("Close")])], 1)], 1)], 1)], 1) : _vm._e(), _vm._v(" "), _c('v-card', {
    staticClass: "py-4"
  }, [(_vm.err) ? _c('v-flex', {
    attrs: {
      "xs12": "",
      "pb-3": "",
      "px-4": ""
    }
  }, [_c('v-alert', {
    attrs: {
      "type": "error",
      "value": true
    }
  }, [_vm._v(_vm._s(_vm.err))])], 1) : _vm._e(), _vm._v(" "), (_vm.success) ? _c('v-flex', {
    attrs: {
      "xs12": "",
      "pb-3": "",
      "px-4": ""
    }
  }, [_c('v-alert', {
    attrs: {
      "type": "success",
      "value": true
    }
  }, [_vm._v(_vm._s(_vm.success))])], 1) : _vm._e(), _vm._v(" "), _c('v-form', {
    model: {
      value: (_vm.valid),
      callback: function($$v) {
        _vm.valid = $$v
      },
      expression: "valid"
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": "",
      "sm8": "",
      "md6": "",
      "lg4": "",
      "px-4": ""
    }
  }, [_c('v-autocomplete', {
    attrs: {
      "required": "",
      "loading": _vm.companyLoading,
      "rules": [function (v) { return !!v || ("" + (_vm.$lang.errors.missingCompany)); }],
      "disabled": _vm.isEdit || _vm.companies.length === 0,
      "items": _vm.companies,
      "item-text": "name",
      "item-value": "id",
      "label": _vm.$lang.actions.selectCompany
    },
    model: {
      value: (_vm.selectedCompany),
      callback: function($$v) {
        _vm.selectedCompany = $$v
      },
      expression: "selectedCompany"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "sm8": "",
      "md6": "",
      "lg4": "",
      "px-4": ""
    }
  }, [_c('v-autocomplete', {
    attrs: {
      "required": "",
      "rules": [function () { return _vm.selectedDomains.length > 0 || ("" + (_vm.$lang.errors.missingDomain)); }],
      "loading": _vm.domainLoading,
      "multiple": "",
      "chips": "",
      "disabled": _vm.mappedDomains.length === 0,
      "deletable-chips": "",
      "items": _vm.mappedDomains,
      "label": _vm.$lang.actions.selectDomain
    },
    model: {
      value: (_vm.selectedDomains),
      callback: function($$v) {
        _vm.selectedDomains = $$v
      },
      expression: "selectedDomains"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "sm8": "",
      "md6": "",
      "lg4": "",
      "px-4": ""
    }
  }, [_c('v-autocomplete', {
    attrs: {
      "required": "",
      "rules": [function (v) { return !!v || ("" + (_vm.$lang.errors.missingTemplateType)); }],
      "loading": _vm.typesLoading,
      "disabled": _vm.templateTypes.length === 0,
      "items": _vm.sortedTemplateTypes,
      "label": _vm.$lang.actions.selectTemplateType
    },
    model: {
      value: (_vm.selectedType),
      callback: function($$v) {
        _vm.selectedType = $$v
      },
      expression: "selectedType"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "sm8": "",
      "md6": "",
      "lg4": "",
      "px-4": ""
    }
  }, [_c('v-autocomplete', {
    attrs: {
      "required": "",
      "rules": [function (v) { return !!v || ("" + (_vm.$lang.errors.missingTemplate)); }],
      "disabled": _vm.filteredTempaltes.length === 0,
      "loading": _vm.templatesLoading,
      "items": _vm.filteredTempaltes,
      "label": _vm.$lang.actions.selectTemplate
    },
    model: {
      value: (_vm.selectedTemplate),
      callback: function($$v) {
        _vm.selectedTemplate = $$v
      },
      expression: "selectedTemplate"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "sm8": "",
      "md6": "",
      "lg4": "",
      "px-4": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "Description",
      "placeholder": "Description of the domain"
    },
    model: {
      value: (_vm.domainDescription),
      callback: function($$v) {
        _vm.domainDescription = $$v
      },
      expression: "domainDescription"
    }
  })], 1), _vm._v(" "), _c('v-btn', {
    staticClass: "primary mx-4",
    attrs: {
      "disabled": _vm.editingProp
    },
    on: {
      "click": function($event) {
        return _vm.addProperty()
      }
    }
  }, [_vm._v(_vm._s(_vm.$lang.actions.addProperty))]), _vm._v(" "), _c('div', {
    staticClass: "v-table__overflow my-3 px-4"
  }, [_c('table', {
    staticClass: "v-datatable v-table theme--light"
  }, [_c('tbody', _vm._l((_vm.properties), function(property, index) {
    return _c('tr', {
      key: index
    }, [(property.isEdit) ? [_c('td', {
      staticClass: "min-w-lg pb-2"
    }, [_c('v-select', {
      attrs: {
        "required": "",
        "items": _vm.propertyTypes,
        "label": _vm.$lang.actions.selectPropType,
        "hide-details": ""
      },
      model: {
        value: (_vm.tempProp.type),
        callback: function($$v) {
          _vm.$set(_vm.tempProp, "type", $$v)
        },
        expression: "tempProp.type"
      }
    })], 1), _vm._v(" "), _c('td', {
      staticClass: "pb-2 min-w-lg"
    }, [(_vm.tempProp.type === 'TEXT') ? _c('v-select', {
      attrs: {
        "items": _vm.sortedTextTypes,
        "label": _vm.$lang.labels.propKey,
        "hide-details": ""
      },
      model: {
        value: (_vm.tempProp.name),
        callback: function($$v) {
          _vm.$set(_vm.tempProp, "name", $$v)
        },
        expression: "tempProp.name"
      }
    }) : _vm._e(), _vm._v(" "), (_vm.tempProp.type === 'URL') ? _c('v-select', {
      attrs: {
        "label": _vm.$lang.actions.selectUrl,
        "items": _vm.sortedUrlTypes,
        "hide-details": ""
      },
      model: {
        value: (_vm.tempProp.name),
        callback: function($$v) {
          _vm.$set(_vm.tempProp, "name", $$v)
        },
        expression: "tempProp.name"
      }
    }) : _vm._e()], 1), _vm._v(" "), _c('td', {
      staticClass: "pb-2"
    }, [_c('v-text-field', {
      attrs: {
        "label": _vm.$lang.labels.propValue,
        "hide-details": ""
      },
      model: {
        value: (_vm.tempProp.value),
        callback: function($$v) {
          _vm.$set(_vm.tempProp, "value", $$v)
        },
        expression: "tempProp.value"
      }
    })], 1), _vm._v(" "), _c('td', {
      staticClass: "min-w-lg px-0"
    }, [_c('v-btn', {
      staticClass: "primary elevation-1",
      attrs: {
        "disabled": !_vm.tempProp.type || !_vm.tempProp.name || !_vm.tempProp.value
      },
      on: {
        "click": function($event) {
          return _vm.savePropEdit(property)
        }
      }
    }, [_vm._v(_vm._s(_vm.$lang.actions.save))]), _vm._v(" "), _c('v-btn', {
      staticClass: "error ml-0 elevation-1",
      on: {
        "click": function($event) {
          return _vm.closePropEdit(property, index)
        }
      }
    }, [_vm._v(_vm._s(_vm.$lang.actions.cancel))])], 1)] : [_c('td', [_vm._v(_vm._s(property.type))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(property.name))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(property.value))]), _vm._v(" "), _c('td', {
      staticClass: "actions px-0"
    }, [_c('v-btn', {
      staticClass: "primary elevation-1",
      on: {
        "click": function($event) {
          return _vm.editProp(property)
        }
      }
    }, [_vm._v(_vm._s(_vm.$lang.actions.edit))]), _vm._v(" "), _c('v-btn', {
      staticClass: "error ml-0 elevation-1",
      on: {
        "click": function($event) {
          return _vm.properties.splice(index, 1)
        }
      }
    }, [_vm._v(_vm._s(_vm.$lang.actions.delete))])], 1)]], 2)
  }), 0)])]), _vm._v(" "), _c('v-layout', {
    staticClass: "px-2",
    attrs: {
      "row": "",
      "wrap": "",
      "justify-space-between": ""
    }
  }, [(_vm.isEdit && _vm.createdOn) ? _c('v-text-field', {
    staticClass: "min-w max-w mx-3",
    attrs: {
      "label": _vm.$lang.labels.created,
      "readonly": ""
    },
    model: {
      value: (_vm.createdOn),
      callback: function($$v) {
        _vm.createdOn = $$v
      },
      expression: "createdOn"
    }
  }) : _vm._e(), _vm._v(" "), (_vm.isEdit && _vm.modifiedOn) ? _c('v-text-field', {
    staticClass: "min-w max-w mx-3",
    attrs: {
      "label": _vm.$lang.labels.modified,
      "readonly": ""
    },
    model: {
      value: (_vm.modifiedOn),
      callback: function($$v) {
        _vm.modifiedOn = $$v
      },
      expression: "modifiedOn"
    }
  }) : _vm._e()], 1), _vm._v(" "), _c('v-layout', {
    staticClass: "px-4",
    attrs: {
      "justify-space-between": ""
    }
  }, [_c('v-btn', {
    staticClass: "ml-0",
    attrs: {
      "flat": ""
    },
    on: {
      "click": function($event) {
        return _vm.$router.push({
          name: 'webSpaces'
        })
      }
    }
  }, [_c('v-icon', [_vm._v("keyboard_arrow_left")]), _vm._v(_vm._s(_vm.$lang.actions.close))], 1), _vm._v(" "), _c('div', [(_vm.isEdit) ? _c('v-btn', {
    staticClass: "primary",
    attrs: {
      "disabled": !_vm.valid
    },
    on: {
      "click": _vm.generateJSON
    }
  }, [_vm._v(_vm._s(_vm.$lang.actions.generateJson))]) : _vm._e(), _vm._v(" "), _c('v-btn', {
    staticClass: "primary mx-0",
    attrs: {
      "disabled": !_vm.valid
    },
    on: {
      "click": _vm.submit
    }
  }, [_vm._v(_vm._s(_vm.$lang.actions.submit))])], 1)], 1)], 1)], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 427 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-card', {
    staticClass: "px-2 py-3"
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": "",
      "justify-space-between": ""
    }
  }, [_c('h1', {
    staticClass: "px-3 pb-3"
  }, [_vm._v("\n        " + _vm._s(_vm.isEdit ? ((_vm.$lang.actions.edit) + " " + (_vm.company.name)) :
    _vm.$lang.labels.createCompany) + "\n      ")]), _vm._v(" "), (!_vm.isEdit && !_vm.isLocalAdmin) ? _c('div', {
    staticClass: "d-inline-flex"
  }, [(_vm.showCompanies) ? _c('v-autocomplete', {
    staticClass: "min-w max-w mx-3 pb-2",
    attrs: {
      "label": _vm.$lang.actions.selectCompany,
      "items": _vm.mappedCompanies,
      "hide-details": ""
    },
    model: {
      value: (_vm.selectedCompany),
      callback: function($$v) {
        _vm.selectedCompany = $$v
      },
      expression: "selectedCompany"
    }
  }) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "pr-3"
  }, [_c('v-btn', {
    staticClass: "primary mx-0 mb-4",
    on: {
      "click": function($event) {
        return _vm.fetchAllCompanies()
      }
    }
  }, [_vm._v(_vm._s(_vm.$lang.actions.importCompany))])], 1)], 1) : _vm._e()]), _vm._v(" "), _c('v-flex', {
    attrs: {
      "px-3": "",
      "pt-2": "",
      "pb-4": ""
    }
  }, [_c('hr')]), _vm._v(" "), _c('v-form', {
    model: {
      value: (_vm.valid),
      callback: function($$v) {
        _vm.valid = $$v
      },
      expression: "valid"
    }
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": "",
      "justify-space-between": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('h2', {
    staticClass: "px-3 pb-3"
  }, [_vm._v("\n          " + _vm._s(_vm.$lang.header.companyGeneralData) + "\n        ")])]), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "sm6": "",
      "md4": "",
      "px-3": ""
    }
  }, [_c('v-text-field', {
    staticClass: "required",
    attrs: {
      "label": _vm.$lang.labels.name,
      "placeholder": _vm.$lang.placeholders.companyName,
      "rules": [function (v) { return !!v || ("" + (_vm.$lang.errors.missingCompanyName)); }],
      "type": "text",
      "id": "name",
      "required": "",
      "hint": _vm.company.name.length > 12 ? 'Name will be shortened on webshop in mobile view' : '',
      "persistent-hint": ""
    },
    model: {
      value: (_vm.company.name),
      callback: function($$v) {
        _vm.$set(_vm.company, "name", $$v)
      },
      expression: "company.name"
    }
  }), _vm._v(" "), _c('v-text-field', {
    staticClass: "required",
    attrs: {
      "label": _vm.$lang.labels.email,
      "placeholder": _vm.$lang.placeholders.companyEmail,
      "type": "email",
      "id": "email",
      "required": "",
      "rules": _vm.emailRules
    },
    model: {
      value: (_vm.company.email),
      callback: function($$v) {
        _vm.$set(_vm.company, "email", $$v)
      },
      expression: "company.email"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "sm6": "",
      "md4": "",
      "px-3": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": _vm.$lang.labels.registrationNumber,
      "type": "text",
      "id": "registrationNumber"
    },
    model: {
      value: (_vm.company.registrationNumber),
      callback: function($$v) {
        _vm.$set(_vm.company, "registrationNumber", $$v)
      },
      expression: "company.registrationNumber"
    }
  }), _vm._v(" "), _c('v-text-field', {
    staticClass: "required",
    attrs: {
      "label": _vm.$lang.labels.phone,
      "placeholder": _vm.$lang.placeholders.phone,
      "rules": [function (v) { return !!v || ("" + (_vm.$lang.errors.missingCompanyPhone)); }],
      "required": "",
      "type": "text",
      "id": "phone"
    },
    model: {
      value: (_vm.company.phone),
      callback: function($$v) {
        _vm.$set(_vm.company, "phone", $$v)
      },
      expression: "company.phone"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "sm6": "",
      "md4": "",
      "px-3": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": _vm.$lang.labels.registrationLocation,
      "type": "text",
      "id": "registrationLocation"
    },
    model: {
      value: (_vm.company.registrationLocation),
      callback: function($$v) {
        _vm.$set(_vm.company, "registrationLocation", $$v)
      },
      expression: "company.registrationLocation"
    }
  }), _vm._v(" "), _c('v-select', {
    staticClass: "required",
    attrs: {
      "rules": [_vm.company.cuisines.length !== 0 || ("" + (_vm.$lang.errors.missingCuisines))],
      "required": "",
      "multiple": "",
      "small-chips": "",
      "deletable-chips": "",
      "items": _vm.cuisines,
      "label": _vm.$lang.labels.cuisines
    },
    model: {
      value: (_vm.company.cuisines),
      callback: function($$v) {
        _vm.$set(_vm.company, "cuisines", $$v)
      },
      expression: "company.cuisines"
    }
  })], 1)], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "px-3": "",
      "pt-2": "",
      "pb-4": ""
    }
  }, [_c('hr')]), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": "",
      "justify-space-between": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('h2', {
    staticClass: "px-3 pb-3"
  }, [_vm._v("\n            " + _vm._s(_vm.$lang.header.companySettings) + "\n          ")])]), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "sm6": "",
      "md4": "",
      "px-3": ""
    }
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": "",
      "justify-space-between": ""
    }
  }, [_c('v-flex', {
    staticClass: "currency-wrap",
    attrs: {
      "xs12": "",
      "md6": ""
    }
  }, [_c('v-select', {
    staticClass: "required pb-2 mb-1",
    attrs: {
      "label": _vm.$lang.labels.currency,
      "items": _vm.currencies,
      "name": "currency",
      "id": "currency",
      "rules": [function (v) { return !!v || ("" + (_vm.$lang.errors.missingCurrency)); }],
      "required": ""
    },
    model: {
      value: (_vm.company.currency),
      callback: function($$v) {
        _vm.$set(_vm.company, "currency", $$v)
      },
      expression: "company.currency"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    staticClass: "radio-input",
    staticStyle: {
      "min-width": "180px"
    },
    attrs: {
      "xs12": "",
      "md6": ""
    }
  }, [_c('p', [_vm._v(_vm._s(_vm.$lang.labels.align) + ":")]), _vm._v(" "), _c('v-radio-group', {
    attrs: {
      "row": "",
      "hide-details": ""
    },
    model: {
      value: (_vm.align),
      callback: function($$v) {
        _vm.align = $$v
      },
      expression: "align"
    }
  }, [_c('v-radio', {
    attrs: {
      "label": _vm.$lang.labels.left,
      "value": "left",
      "color": "primary"
    }
  }), _vm._v(" "), _c('v-radio', {
    attrs: {
      "label": _vm.$lang.labels.right,
      "value": "right",
      "color": "primary"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('v-select', {
    staticClass: "required",
    attrs: {
      "label": _vm.$lang.labels.defLang,
      "items": _vm.languages,
      "item-text": "text",
      "item-value": "value",
      "required": "",
      "rules": [function (v) { return !!v || ("" + (_vm.$lang.errors.missingLang)); }]
    },
    model: {
      value: (_vm.company.defaultLanguage),
      callback: function($$v) {
        _vm.$set(_vm.company, "defaultLanguage", $$v)
      },
      expression: "company.defaultLanguage"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "sm6": "",
      "md4": "",
      "px-3": ""
    }
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": "",
      "sm6": "",
      "pr-2": ""
    }
  }, [_c('v-select', {
    staticClass: "required pb-2 mb-1",
    attrs: {
      "label": _vm.$lang.labels.distanceUnit,
      "placeholder": _vm.$lang.placeholders.distanceUnit,
      "items": _vm.distanceUnits,
      "disabled": _vm.distanceUnits.length <= 0,
      "required": "",
      "rules": [function (v) { return !!v || ("" + (_vm.$lang.errors.missingdistanceUnit)); }]
    },
    model: {
      value: (_vm.company.distanceUnit),
      callback: function($$v) {
        _vm.$set(_vm.company, "distanceUnit", $$v)
      },
      expression: "company.distanceUnit"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "sm6": "",
      "pl-2": ""
    }
  }, [_c('v-autocomplete', {
    staticClass: "required",
    attrs: {
      "label": _vm.$lang.labels.timezone,
      "placeholder": _vm.$lang.labels.timezone,
      "items": _vm.timezones,
      "required": "",
      "rules": [function (v) { return !!v || ("" + (_vm.$lang.errors.missingTimezone)); }]
    },
    model: {
      value: (_vm.company.timezone),
      callback: function($$v) {
        _vm.$set(_vm.company, "timezone", $$v)
      },
      expression: "company.timezone"
    }
  })], 1)], 1), _vm._v(" "), _c('v-text-field', {
    attrs: {
      "label": _vm.$lang.labels.bookKeeperEmails,
      "type": "text",
      "id": "bookKeeperEmails"
    },
    model: {
      value: (_vm.bookKeeperEmails),
      callback: function($$v) {
        _vm.bookKeeperEmails = $$v
      },
      expression: "bookKeeperEmails"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "sm6": "",
      "md4": "",
      "px-3": ""
    }
  }, [_c('v-select', {
    staticClass: "required",
    attrs: {
      "label": _vm.$lang.labels.pricingGroups,
      "placeholder": _vm.$lang.placeholders.pricingGroups,
      "multiple": "",
      "chips": "",
      "deletable-chips": "",
      "items": _vm.mappedGroups,
      "disabled": _vm.mappedGroups.length <= 0,
      "required": "",
      "rules": [_vm.company.pricingGroups.length > 0 || ("" + (_vm.$lang.errors.missingPricingGroups))]
    },
    model: {
      value: (_vm.company.pricingGroups),
      callback: function($$v) {
        _vm.$set(_vm.company, "pricingGroups", $$v)
      },
      expression: "company.pricingGroups"
    }
  }), _vm._v(" "), _c('v-text-field', {
    staticClass: "required",
    attrs: {
      "label": _vm.$lang.labels.fetchConf,
      "rules": [function (v) { return _vm.company.config_update_frequency_in_minutes.toString().length > 0 || ("" + (_vm.$lang.errors.missingFetchConf)); }],
      "required": "",
      "type": "number",
      "min": "0"
    },
    model: {
      value: (_vm.company.config_update_frequency_in_minutes),
      callback: function($$v) {
        _vm.$set(_vm.company, "config_update_frequency_in_minutes", $$v)
      },
      expression: "company.config_update_frequency_in_minutes"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [(_vm.company.companyRandomId) ? _c('p', {
    staticClass: "px-3 pb-3 id-for-s3"
  }, [_vm._v(_vm._s(_vm.$lang.labels.idForS3) + ": " + _vm._s(_vm.company.companyRandomId))]) : _vm._e()]), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "sm6": "",
      "md4": "",
      "px-3": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": "",
      "sm6": "",
      "md4": "",
      "pb-2": ""
    }
  }, [_c('v-checkbox', {
    staticClass: "option",
    attrs: {
      "hide-details": "",
      "color": "primary",
      "label": _vm.$lang.labels.testMode
    },
    model: {
      value: (_vm.company.test),
      callback: function($$v) {
        _vm.$set(_vm.company, "test", $$v)
      },
      expression: "company.test"
    }
  }), _vm._v(" "), _c('v-checkbox', {
    staticClass: "option",
    attrs: {
      "hide-details": "",
      "color": "primary",
      "label": _vm.$lang.labels.dailyOrdersCounterEnabled
    },
    model: {
      value: (_vm.company.dailyOrdersCounterEnabled),
      callback: function($$v) {
        _vm.$set(_vm.company, "dailyOrdersCounterEnabled", $$v)
      },
      expression: "company.dailyOrdersCounterEnabled"
    }
  }), _vm._v(" "), _c('v-checkbox', {
    staticClass: "option",
    attrs: {
      "hide-details": "",
      "color": "primary",
      "label": _vm.$lang.labels.enquiryReser
    },
    model: {
      value: (_vm.company.enableReservationForm),
      callback: function($$v) {
        _vm.$set(_vm.company, "enableReservationForm", $$v)
      },
      expression: "company.enableReservationForm"
    }
  })], 1)], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "sm6": "",
      "md4": "",
      "px-3": ""
    }
  }, [_c('v-select', {
    attrs: {
      "label": _vm.$lang.labels.payIntegModule,
      "placeholder": _vm.$lang.placeholders.payIntegModule,
      "items": _vm.paymentGateways,
      "disabled": _vm.paymentGateways.length <= 0
    },
    model: {
      value: (_vm.company.paymentIntegration),
      callback: function($$v) {
        _vm.$set(_vm.company, "paymentIntegration", $$v)
      },
      expression: "company.paymentIntegration"
    }
  }), _vm._v(" "), _c('v-checkbox', {
    staticClass: "option",
    attrs: {
      "hide-details": "",
      "color": "primary",
      "label": _vm.$lang.labels.enquiryContact
    },
    model: {
      value: (_vm.company.enableContactForm),
      callback: function($$v) {
        _vm.$set(_vm.company, "enableContactForm", $$v)
      },
      expression: "company.enableContactForm"
    }
  }), _vm._v(" "), (_vm.company.enableReservationForm) ? _c('v-text-field', {
    staticClass: "required",
    attrs: {
      "type": "number",
      "min": "1",
      "required": "",
      "rules": [function (v) { return !!v || ("" + (_vm.$lang.errors.missingMinPersons)); }],
      "label": _vm.$lang.labels.minPersons
    },
    model: {
      value: (_vm.company.minPersons),
      callback: function($$v) {
        _vm.$set(_vm.company, "minPersons", $$v)
      },
      expression: "company.minPersons"
    }
  }) : _vm._e()], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "sm6": "",
      "md4": "",
      "px-3": ""
    }
  }, [_c('v-checkbox', {
    staticClass: "option",
    attrs: {
      "hide-details": "",
      "color": "primary",
      "label": _vm.$lang.labels.orderPrint
    },
    model: {
      value: (_vm.company.completePrint),
      callback: function($$v) {
        _vm.$set(_vm.company, "completePrint", $$v)
      },
      expression: "company.completePrint"
    }
  }), _vm._v(" "), _c('v-checkbox', {
    staticClass: "option",
    attrs: {
      "hide-details": "",
      "color": "primary",
      "label": _vm.$lang.labels.enableKitchenPrintPersistence
    },
    model: {
      value: (_vm.company.persistKitchenPrint),
      callback: function($$v) {
        _vm.$set(_vm.company, "persistKitchenPrint", $$v)
      },
      expression: "company.persistKitchenPrint"
    }
  }), _vm._v(" "), (_vm.company.enableReservationForm) ? _c('v-text-field', {
    staticClass: "required",
    attrs: {
      "type": "number",
      "min": "1",
      "required": "",
      "rules": [function (v) { return !!v || ("" + (_vm.$lang.errors.missingMaxPersons)); }],
      "label": _vm.$lang.labels.maxPersons
    },
    model: {
      value: (_vm.company.maxPersons),
      callback: function($$v) {
        _vm.$set(_vm.company, "maxPersons", $$v)
      },
      expression: "company.maxPersons"
    }
  }) : _vm._e()], 1)], 1), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": "",
      "pt-2": ""
    }
  }, [(_vm.isEdit) ? _c('v-flex', {
    attrs: {
      "xs12": "",
      "sm6": "",
      "md4": "",
      "px-3": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": _vm.$lang.labels.swithcCode,
      "type": "number",
      "min": "0",
      "max": "9999",
      "mask": "####",
      "hint": _vm.$lang.labels.swithcCodeHint
    },
    model: {
      value: (_vm.company.tableSwitchCode),
      callback: function($$v) {
        _vm.$set(_vm.company, "tableSwitchCode", $$v)
      },
      expression: "company.tableSwitchCode"
    }
  })], 1) : _vm._e(), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "sm6": "",
      "md4": "",
      "px-3": ""
    }
  }, [_c('v-text-field', {
    staticClass: "required",
    attrs: {
      "label": _vm.$lang.labels.tableIdleTimeInMinutes,
      "type": "number",
      "min": "0",
      "max": "120",
      "required": "",
      "rules": [function (v) { return (_vm.company.tableIdleTimeInMinutes !== null && _vm.company.tableIdleTimeInMinutes.toString().length > 0) ||
        ("" + (_vm.$lang.errors.missingTableMin)); }
      ]
    },
    model: {
      value: (_vm.company.tableIdleTimeInMinutes),
      callback: function($$v) {
        _vm.$set(_vm.company, "tableIdleTimeInMinutes", $$v)
      },
      expression: "company.tableIdleTimeInMinutes"
    }
  })], 1)], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "px-3": ""
    }
  }, [_c('v-autocomplete', {
    staticClass: "required",
    attrs: {
      "label": _vm.$lang.labels.paymentTypes,
      "placeholder": _vm.$lang.placeholders.paymentTypes,
      "multiple": "",
      "chips": "",
      "deletable-chips": "",
      "items": _vm.payments,
      "required": "",
      "rules": [_vm.company.paymentTypes.length > 0 || ("" + (_vm.$lang.errors.missingPayments))]
    },
    model: {
      value: (_vm.company.paymentTypes),
      callback: function($$v) {
        _vm.$set(_vm.company, "paymentTypes", $$v)
      },
      expression: "company.paymentTypes"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "px-3": "",
      "pt-2": "",
      "pb-4": ""
    }
  }, [_c('hr')]), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": "",
      "justify-space-between": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('h2', {
    staticClass: "px-3 pb-3"
  }, [_vm._v("\n            " + _vm._s(_vm.$lang.header.companyAddress) + "\n          ")])]), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "sm6": "",
      "md4": "",
      "px-3": ""
    }
  }, [_c('v-select', {
    staticClass: "required",
    attrs: {
      "label": _vm.$lang.labels.country,
      "placeholder": _vm.$lang.placeholders.companyCountry,
      "rules": [function (v) { return !!v || ("" + (_vm.$lang.errors.missingCompanyCountry)); }],
      "items": _vm.countries,
      "type": "text",
      "id": "country",
      "required": ""
    },
    model: {
      value: (_vm.company.address.country),
      callback: function($$v) {
        _vm.$set(_vm.company.address, "country", $$v)
      },
      expression: "company.address.country"
    }
  }), _vm._v(" "), _c('v-text-field', {
    staticClass: "required",
    attrs: {
      "label": _vm.$lang.labels.postalcode,
      "placeholder": _vm.$lang.placeholders.companyPostal,
      "rules": [function (v) { return !!v || ("" + (_vm.$lang.errors.missingCompanyPostal)); }],
      "type": "text",
      "id": "postalcode",
      "required": ""
    },
    model: {
      value: (_vm.company.address.postalCode),
      callback: function($$v) {
        _vm.$set(_vm.company.address, "postalCode", $$v)
      },
      expression: "company.address.postalCode"
    }
  }), _vm._v(" "), _c('v-text-field', {
    staticClass: "required",
    attrs: {
      "label": _vm.$lang.labels.townCity,
      "placeholder": _vm.$lang.placeholders.companyTown,
      "rules": [function (v) { return !!v || ("" + (_vm.$lang.errors.missingCompanyTown)); }],
      "type": "text",
      "id": "town",
      "required": ""
    },
    model: {
      value: (_vm.company.address.townCity),
      callback: function($$v) {
        _vm.$set(_vm.company.address, "townCity", $$v)
      },
      expression: "company.address.townCity"
    }
  }), _vm._v(" "), _c('v-text-field', {
    attrs: {
      "label": _vm.$lang.labels.locality,
      "placeholder": _vm.$lang.placeholders.companyLocality,
      "type": "text",
      "id": "locality"
    },
    model: {
      value: (_vm.company.address.locality),
      callback: function($$v) {
        _vm.$set(_vm.company.address, "locality", $$v)
      },
      expression: "company.address.locality"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "sm6": "",
      "md4": "",
      "px-3": ""
    }
  }, [_c('v-btn', {
    staticClass: "primary mx-0 mb-4",
    attrs: {
      "disabled": _vm.company.address.country === ''
    },
    on: {
      "click": function($event) {
        _vm.addressDialog = true
      }
    }
  }, [_vm._v(_vm._s(_vm.$lang.labels.addressLookup))]), _vm._v(" "), _c('v-text-field', {
    staticClass: "required",
    attrs: {
      "label": _vm.$lang.labels.latitude,
      "rules": _vm.latitudeRule,
      "type": "text",
      "required": ""
    },
    model: {
      value: (_vm.company.address.latitude),
      callback: function($$v) {
        _vm.$set(_vm.company.address, "latitude", $$v)
      },
      expression: "company.address.latitude"
    }
  }), _vm._v(" "), _c('v-text-field', {
    staticClass: "required",
    attrs: {
      "label": _vm.$lang.labels.longitude,
      "rules": _vm.latitudeRule,
      "type": "text"
    },
    model: {
      value: (_vm.company.address.longitude),
      callback: function($$v) {
        _vm.$set(_vm.company.address, "longitude", $$v)
      },
      expression: "company.address.longitude"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "sm6": "",
      "md4": "",
      "px-3": ""
    }
  }, [_c('v-text-field', {
    staticClass: "required",
    attrs: {
      "label": _vm.$lang.labels.addressLine + ' 1',
      "rules": [function (v) { return !!v || ("" + (_vm.$lang.errors.missingCompanyAddress)); }],
      "type": "text",
      "id": "address1",
      "required": ""
    },
    model: {
      value: (_vm.company.address.line1),
      callback: function($$v) {
        _vm.$set(_vm.company.address, "line1", $$v)
      },
      expression: "company.address.line1"
    }
  }), _vm._v(" "), _c('v-text-field', {
    attrs: {
      "label": _vm.$lang.labels.addressLine + ' 2',
      "type": "text",
      "id": "address2"
    },
    model: {
      value: (_vm.company.address.line2),
      callback: function($$v) {
        _vm.$set(_vm.company.address, "line2", $$v)
      },
      expression: "company.address.line2"
    }
  }), _vm._v(" "), _c('v-text-field', {
    attrs: {
      "label": _vm.$lang.labels.addressLine + ' 3',
      "type": "text",
      "id": "address3"
    },
    model: {
      value: (_vm.company.address.line3),
      callback: function($$v) {
        _vm.$set(_vm.company.address, "line3", $$v)
      },
      expression: "company.address.line3"
    }
  }), _vm._v(" "), _c('v-text-field', {
    attrs: {
      "label": _vm.$lang.labels.addressLine + ' 4',
      "type": "text",
      "id": "address4"
    },
    model: {
      value: (_vm.company.address.line4),
      callback: function($$v) {
        _vm.$set(_vm.company.address, "line4", $$v)
      },
      expression: "company.address.line4"
    }
  })], 1)], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "px-3": "",
      "pt-2": "",
      "pb-4": ""
    }
  }, [_c('hr')]), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "px-3": ""
    }
  }, [_c('v-btn', {
    staticClass: "primary mx-0",
    attrs: {
      "disabled": _vm.editingHours
    },
    on: {
      "click": _vm.addHours
    }
  }, [_vm._v(_vm._s(_vm.$lang.actions.openingHours))]), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "fade"
    }
  }, [_c('div', {
    staticClass: "v-table__overflow custom-table"
  }, [_c('table', {
    staticClass: "v-datatable v-table theme--light"
  }, [(_vm.openingTimes.length !== 0) ? _c('thead', [_c('tr', [_c('td', {
    staticClass: "move-row"
  }), _vm._v(" "), _c('th', {
    staticClass: "text-xs-left"
  }, [_c('div', {
    staticClass: "th-adj"
  }, [_vm._v(_vm._s(_vm.$lang.header.day)), _c('span', {
    staticClass: "error--text"
  }, [_vm._v("*")])])]), _vm._v(" "), _c('th', {
    staticClass: "text-xs-left"
  }, [_c('div', {
    staticClass: "th-adj"
  }, [_vm._v(_vm._s(_vm.$lang.header.start)), _c('span', {
    staticClass: "error--text"
  }, [_vm._v("*")])])]), _vm._v(" "), _c('th', {
    staticClass: "text-xs-left"
  }, [_c('div', {
    staticClass: "th-adj"
  }, [_vm._v(_vm._s(_vm.$lang.header.end)), _c('span', {
    staticClass: "error--text"
  }, [_vm._v("*")])])])])]) : _vm._e(), _vm._v(" "), _c('tbody', _vm._l((_vm.openingTimes), function(time, index) {
    return _c('tr', {
      key: index
    }, [(time.isEdit) ? [_c('td', {
      staticClass: "move-row"
    }), _vm._v(" "), _c('td', [_c('v-select', {
      staticClass: "min-w",
      attrs: {
        "items": _vm.days
      },
      model: {
        value: (_vm.tempOpening.day),
        callback: function($$v) {
          _vm.$set(_vm.tempOpening, "day", $$v)
        },
        expression: "tempOpening.day"
      }
    })], 1), _vm._v(" "), _c('td', [_c('v-text-field', {
      staticClass: "required",
      attrs: {
        "type": "text",
        "mask": "##:##",
        "placeholder": "HH:mm",
        "required": "",
        "rules": _vm.timeRule
      },
      model: {
        value: (_vm.tempOpening.start),
        callback: function($$v) {
          _vm.$set(_vm.tempOpening, "start", $$v)
        },
        expression: "tempOpening.start"
      }
    })], 1), _vm._v(" "), _c('td', [_c('v-text-field', {
      staticClass: "required",
      attrs: {
        "type": "text",
        "mask": "##:##",
        "placeholder": "HH:mm",
        "required": "",
        "rules": _vm.timeRule
      },
      model: {
        value: (_vm.tempOpening.end),
        callback: function($$v) {
          _vm.$set(_vm.tempOpening, "end", $$v)
        },
        expression: "tempOpening.end"
      }
    })], 1), _vm._v(" "), _c('td', {
      staticClass: "px-0",
      staticStyle: {
        "min-width": "314px"
      }
    }, [_c('v-btn', {
      staticClass: "primary elevation-1 mx-0",
      attrs: {
        "disabled": !_vm.openingValidation
      },
      on: {
        "click": function($event) {
          return _vm.saveOpening(time)
        }
      }
    }, [_vm._v("\n                        " + _vm._s(_vm.$lang.actions.save) + "\n                      ")]), _vm._v(" "), _c('v-btn', {
      staticClass: "primary elevation-1",
      attrs: {
        "disabled": !_vm.openingValidation
      },
      on: {
        "click": function($event) {
          return _vm.copyOpening(time)
        }
      }
    }, [_vm._v("\n                        " + _vm._s(_vm.$lang.actions.copy) + "\n                      ")]), _vm._v(" "), _c('v-btn', {
      staticClass: "error mx-0 elevation-1",
      on: {
        "click": function($event) {
          return _vm.closeOpening(time)
        }
      }
    }, [_vm._v("\n                        " + _vm._s(_vm.$lang.actions.cancel) + "\n                      ")])], 1)] : [_c('td', {
      staticClass: "move-row"
    }, [(_vm.openingTimes.length >= 2) ? _c('div', [(index !== 0) ? _c('v-icon', {
      on: {
        "click": function($event) {
          return _vm.moveUp(_vm.openingTimes, index)
        }
      }
    }, [_vm._v("keyboard_arrow_up")]) : _vm._e(), _vm._v(" "), (index != _vm.openingTimes.length - 1) ? _c('v-icon', {
      on: {
        "click": function($event) {
          return _vm.moveDown(_vm.openingTimes, index)
        }
      }
    }, [_vm._v("keyboard_arrow_down")]) : _vm._e()], 1) : _vm._e()]), _vm._v(" "), _c('td', [_vm._v(_vm._s(time.day))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(time.start))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(time.end))]), _vm._v(" "), _c('td', {
      staticClass: "px-0",
      staticStyle: {
        "min-width": "314px"
      }
    }, [_c('v-btn', {
      staticClass: "primary elevation-1 mx-0",
      attrs: {
        "disabled": _vm.editingHours
      },
      on: {
        "click": function($event) {
          return _vm.editOpening(time)
        }
      }
    }, [_vm._v("\n                        " + _vm._s(_vm.$lang.actions.edit) + "\n                      ")]), _vm._v(" "), _c('v-btn', {
      staticClass: "primary elevation-1",
      on: {
        "click": function($event) {
          return _vm.copyOpening(time)
        }
      }
    }, [_vm._v("\n                        " + _vm._s(_vm.$lang.actions.copy) + "\n                      ")]), _vm._v(" "), _c('v-btn', {
      staticClass: "error mx-0 elevation-1",
      on: {
        "click": function($event) {
          return _vm.deleteOpening(index)
        }
      }
    }, [_vm._v("\n                        " + _vm._s(_vm.$lang.actions.delete) + "\n                      ")])], 1)]], 2)
  }), 0)])])])], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "px-3": "",
      "pb-2": "",
      "mt-3": ""
    }
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "align-center": ""
    }
  }, [_c('v-btn', {
    staticClass: "primary ml-0 mr-3",
    attrs: {
      "disabled": _vm.editingVat || _vm.noTax
    },
    on: {
      "click": _vm.addVat
    }
  }, [_vm._v("\n            " + _vm._s(_vm.$lang.actions.addVat) + "\n          ")]), _vm._v(" "), _c('v-checkbox', {
    attrs: {
      "label": _vm.$lang.labels.noVATtax,
      "hide-details": "",
      "color": "primary"
    },
    model: {
      value: (_vm.noTax),
      callback: function($$v) {
        _vm.noTax = $$v
      },
      expression: "noTax"
    }
  })], 1), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "fade"
    }
  }, [_c('div', {
    staticClass: "v-table__overflow custom-table"
  }, [_c('table', {
    staticClass: "v-datatable v-table theme--light"
  }, [_c('tbody', _vm._l((_vm.vatRates), function(vat, index) {
    return _c('tr', {
      key: index
    }, [(vat.isEdit) ? [_c('td', [_c('v-text-field', {
      staticClass: "min-w mb-2 required",
      attrs: {
        "type": "number",
        "min": "0",
        "step": "0.01",
        "required": "",
        "hide-details": "",
        "label": _vm.$lang.actions.addVat
      },
      model: {
        value: (_vm.tempVat.vat),
        callback: function($$v) {
          _vm.$set(_vm.tempVat, "vat", $$v)
        },
        expression: "tempVat.vat"
      }
    })], 1), _vm._v(" "), _c('td', {
      staticClass: "min-w-lg px-0"
    }, [_c('v-btn', {
      staticClass: "primary elevation-1",
      attrs: {
        "disabled": !_vm.tempVat.vat
      },
      on: {
        "click": function($event) {
          return _vm.saveVatEdit(vat)
        }
      }
    }, [_vm._v(_vm._s(_vm.$lang.actions.save))]), _vm._v(" "), _c('v-btn', {
      staticClass: "error ml-0 elevation-1",
      on: {
        "click": function($event) {
          return _vm.closeVatEdit(vat)
        }
      }
    }, [_vm._v(_vm._s(_vm.$lang.actions.cancel))])], 1)] : [_c('td', [_vm._v(_vm._s(vat.vat))]), _vm._v(" "), _c('td', {
      staticClass: "actions px-0"
    }, [_c('v-btn', {
      staticClass: "primary elevation-1",
      on: {
        "click": function($event) {
          return _vm.editVat(vat)
        }
      }
    }, [_vm._v(_vm._s(_vm.$lang.actions.edit))]), _vm._v(" "), _c('v-btn', {
      staticClass: "error ml-0 elevation-1",
      on: {
        "click": function($event) {
          return _vm.deleteVat(index)
        }
      }
    }, [_vm._v(_vm._s(_vm.$lang.actions.delete))])], 1)]], 2)
  }), 0)])])]), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": "",
      "pt-2": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": "",
      "sm6": "",
      "px-1": ""
    }
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "align-center": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "grow": ""
    }
  }, [_c('v-select', {
    attrs: {
      "label": _vm.$lang.labels.tipTax,
      "items": _vm.vatRates,
      "type": "number",
      "step": "0.5",
      "min": "0",
      "disabled": _vm.noTipTax,
      "item-text": "vat",
      "item-value": "vat"
    },
    model: {
      value: (_vm.company.tipTaxRate),
      callback: function($$v) {
        _vm.$set(_vm.company, "tipTaxRate", $$v)
      },
      expression: "company.tipTaxRate"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "shrink": ""
    }
  }, [_c('v-checkbox', {
    staticClass: "ml-3",
    attrs: {
      "label": _vm.$lang.labels.noTipTax,
      "hide-details": "",
      "disabled": this.vatRates.length === 0,
      "color": "primary"
    },
    model: {
      value: (_vm.noTipTax),
      callback: function($$v) {
        _vm.noTipTax = $$v
      },
      expression: "noTipTax"
    }
  })], 1)], 1)], 1)], 1), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": "",
      "sm6": "",
      "px-1": ""
    }
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "align-center": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "grow": ""
    }
  }, [_c('v-select', {
    attrs: {
      "label": _vm.$lang.labels.chargeTax,
      "items": _vm.vatRates,
      "disabled": _vm.noDeliveryTax,
      "item-text": "vat",
      "item-value": "vat"
    },
    model: {
      value: (_vm.company.deliveryChargesTaxRate),
      callback: function($$v) {
        _vm.$set(_vm.company, "deliveryChargesTaxRate", $$v)
      },
      expression: "company.deliveryChargesTaxRate"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "shrink": ""
    }
  }, [_c('v-checkbox', {
    staticClass: "ml-3",
    attrs: {
      "label": _vm.$lang.labels.noDeliveryTax,
      "hide-details": "",
      "disabled": this.vatRates.length === 0,
      "color": "primary"
    },
    model: {
      value: (_vm.noDeliveryTax),
      callback: function($$v) {
        _vm.noDeliveryTax = $$v
      },
      expression: "noDeliveryTax"
    }
  })], 1)], 1)], 1)], 1)], 1), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": "",
      "justify-space-between": "",
      "align-center": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": "",
      "sm6": "",
      "md4": "",
      "px-3": ""
    }
  }, [_c('v-select', {
    attrs: {
      "label": _vm.$lang.actions.serviceType,
      "items": _vm.serviceTypes,
      "item-text": "text",
      "item-value": "value"
    },
    model: {
      value: (_vm.company.serviceCharges.type),
      callback: function($$v) {
        _vm.$set(_vm.company.serviceCharges, "type", $$v)
      },
      expression: "company.serviceCharges.type"
    }
  })], 1), _vm._v(" "), (_vm.company.serviceCharges.type === 'percoftotal') ? [_c('v-flex', {
    attrs: {
      "xs12": "",
      "sm6": "",
      "md4": "",
      "px-2": ""
    }
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "align-center": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "grow": ""
    }
  }, [_c('v-select', {
    attrs: {
      "label": _vm.$lang.labels.serviceTaxRate,
      "items": _vm.vatRates,
      "disabled": _vm.noServiceTax,
      "item-text": "vat",
      "item-value": "vat"
    },
    model: {
      value: (_vm.company.serviceCharges.taxRate),
      callback: function($$v) {
        _vm.$set(_vm.company.serviceCharges, "taxRate", $$v)
      },
      expression: "company.serviceCharges.taxRate"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "shrink": ""
    }
  }, [_c('v-checkbox', {
    staticClass: "ml-3",
    attrs: {
      "disabled": _vm.vatRates.length === 0,
      "label": _vm.$lang.labels.noServiceTax,
      "hide-details": "",
      "color": "primary"
    },
    model: {
      value: (_vm.noServiceTax),
      callback: function($$v) {
        _vm.noServiceTax = $$v
      },
      expression: "noServiceTax"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "sm6": "",
      "md4": "",
      "px-2": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "type": "number",
      "min": "0",
      "max": "100",
      "label": _vm.$lang.labels.percOfTotal
    },
    model: {
      value: (_vm.company.serviceCharges.percOfTotal),
      callback: function($$v) {
        _vm.$set(_vm.company.serviceCharges, "percOfTotal", $$v)
      },
      expression: "company.serviceCharges.percOfTotal"
    }
  })], 1)] : _vm._e()], 2), _vm._v(" "), _c('v-flex', {
    attrs: {
      "px-3": "",
      "pt-2": "",
      "pb-4": ""
    }
  }, [_c('hr')]), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('h2', {
    staticClass: "px-3 pb-3"
  }, [_vm._v("\n            " + _vm._s(_vm.$lang.header.delivery) + "\n          ")])]), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "sm4": "",
      "px-3": ""
    }
  }, [_c('v-text-field', {
    staticClass: "required",
    attrs: {
      "label": ((_vm.$lang.labels.maxDist) + " (" + (_vm.company.distanceUnit) + ")"),
      "required": "",
      "type": "number",
      "step": "0.5",
      "min": "0",
      "rules": _vm.distanceRule
    },
    model: {
      value: (_vm.company.maxDeliveryDistance),
      callback: function($$v) {
        _vm.$set(_vm.company, "maxDeliveryDistance", $$v)
      },
      expression: "company.maxDeliveryDistance"
    }
  })], 1)], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "px-3": ""
    }
  }, [_c('v-textarea', {
    attrs: {
      "label": _vm.$lang.labels.delPostal,
      "auto-grow": "",
      "rows": "1"
    },
    model: {
      value: (_vm.company.deliveryPostalCodes),
      callback: function($$v) {
        _vm.$set(_vm.company, "deliveryPostalCodes", $$v)
      },
      expression: "company.deliveryPostalCodes"
    }
  })], 1), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": "",
      "sm6": "",
      "md4": "",
      "px-3": ""
    }
  }, [_c('v-select', {
    staticClass: "required",
    attrs: {
      "label": _vm.$lang.labels.chargeType,
      "items": _vm.chargeTypesFormatted,
      "item-text": "text",
      "item-value": "value",
      "required": "",
      "rules": [function (v) { return !!v || ("" + (_vm.$lang.errors.missingChargeType)); }]
    },
    model: {
      value: (_vm.company.deliveryCharges.type),
      callback: function($$v) {
        _vm.$set(_vm.company.deliveryCharges, "type", $$v)
      },
      expression: "company.deliveryCharges.type"
    }
  })], 1), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "fade"
    }
  }, [(_vm.company.deliveryCharges.type === 'chargespermile') ? _c('v-flex', {
    attrs: {
      "xs12": "",
      "sm6": "",
      "md4": "",
      "px-3": ""
    }
  }, [_c('v-text-field', {
    staticClass: "required",
    attrs: {
      "label": _vm.company.distanceUnit === 'meters' ? _vm.$lang.labels.delChargePerMeter : _vm.$lang.labels.delChargePerMile,
      "required": "",
      "step": "0.5",
      "min": "0",
      "rules": [function (v) { return !!v || ("" + (_vm.$lang.errors.missingChargePerMile)); }],
      "type": "number"
    },
    model: {
      value: (_vm.company.deliveryCharges.chargesPerMile),
      callback: function($$v) {
        _vm.$set(_vm.company.deliveryCharges, "chargesPerMile", $$v)
      },
      expression: "company.deliveryCharges.chargesPerMile"
    }
  })], 1) : _vm._e()], 1), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "fade"
    }
  }, [(_vm.company.deliveryCharges.type === 'chargesbymiles') ? _c('v-flex', {
    attrs: {
      "xs12": "",
      "px-3": "",
      "pb-4": ""
    }
  }, [_c('v-btn', {
    staticClass: "primary mx-0",
    attrs: {
      "disabled": _vm.editingMiles
    },
    on: {
      "click": _vm.addMiles
    }
  }, [_vm._v(_vm._s(_vm.company.distanceUnit === 'meters' ? _vm.$lang.actions.chargebyMeters : _vm.$lang.actions.chargebyMiles))]), _vm._v(" "), _c('div', {
    staticClass: "v-table__overflow custom-table"
  }, [_c('table', {
    staticClass: "v-datatable v-table theme--light"
  }, [_c('thead', [_c('tr', [_c('th', {
    staticClass: "text-xs-left"
  }, [_c('div', {
    staticClass: "th-adj"
  }, [_vm._v(_vm._s(_vm.company.distanceUnit === 'meters' ? _vm.$lang.header.fromMeters : _vm.$lang.header.fromMiles)), _c('span', {
    staticClass: "error--text"
  }, [_vm._v("*")])])]), _vm._v(" "), _c('th', {
    staticClass: "text-xs-left"
  }, [_c('div', {
    staticClass: "th-adj"
  }, [_vm._v(_vm._s(_vm.company.distanceUnit === 'meters' ? _vm.$lang.header.toMeters : _vm.$lang.header.toMiles)), _c('span', {
    staticClass: "error--text"
  }, [_vm._v("*")])])]), _vm._v(" "), _c('th', {
    staticClass: "text-xs-left"
  }, [_c('div', {
    staticClass: "th-adj"
  }, [_vm._v(_vm._s(_vm.$lang.header.charges)), _c('span', {
    staticClass: "error--text"
  }, [_vm._v("*")])])]), _vm._v(" "), _c('th', [_c('v-text-field', {
    staticClass: "required",
    staticStyle: {
      "max-width": "250px"
    },
    attrs: {
      "required": "",
      "type": "number",
      "min": "0",
      "steps": "0.1",
      "label": _vm.$lang.header.defaultCharges,
      "hide-details": ""
    },
    model: {
      value: (_vm.defaultCharges),
      callback: function($$v) {
        _vm.defaultCharges = $$v
      },
      expression: "defaultCharges"
    }
  })], 1)])]), _vm._v(" "), (_vm.miles.length !== 0) ? _c('tbody', _vm._l((_vm.miles), function(charge, index) {
    return _c('tr', {
      key: index
    }, [(charge.isEdit) ? [_c('td', [_c('v-text-field', {
      attrs: {
        "type": "number",
        "min": "0",
        "step": "0.5"
      },
      model: {
        value: (_vm.tempMiles.fromMiles),
        callback: function($$v) {
          _vm.$set(_vm.tempMiles, "fromMiles", $$v)
        },
        expression: "tempMiles.fromMiles"
      }
    })], 1), _vm._v(" "), _c('td', [_c('v-text-field', {
      attrs: {
        "type": "number",
        "min": "0",
        "step": "0.5"
      },
      model: {
        value: (_vm.tempMiles.toMiles),
        callback: function($$v) {
          _vm.$set(_vm.tempMiles, "toMiles", $$v)
        },
        expression: "tempMiles.toMiles"
      }
    })], 1), _vm._v(" "), _c('td', [_c('v-text-field', {
      attrs: {
        "type": "number",
        "min": "0",
        "step": "0.5"
      },
      model: {
        value: (_vm.tempMiles.charges),
        callback: function($$v) {
          _vm.$set(_vm.tempMiles, "charges", $$v)
        },
        expression: "tempMiles.charges"
      }
    })], 1), _vm._v(" "), _c('td', {
      staticClass: "min-w-lg px-0"
    }, [_c('v-btn', {
      staticClass: "primary elevation-1",
      attrs: {
        "disabled": !_vm.tempMiles.fromMiles || !_vm.tempMiles.toMiles || !_vm.tempMiles.charges
      },
      on: {
        "click": function($event) {
          return _vm.saveMilesEdit(charge)
        }
      }
    }, [_vm._v(_vm._s(_vm.$lang.actions.save))]), _vm._v(" "), _c('v-btn', {
      staticClass: "error ml-0 elevation-1",
      on: {
        "click": function($event) {
          return _vm.closeMilesEdit(charge)
        }
      }
    }, [_vm._v(_vm._s(_vm.$lang.actions.cancel))])], 1)] : [_c('td', [_vm._v(_vm._s(charge.fromMiles))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(charge.toMiles))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(charge.charges))]), _vm._v(" "), _c('td', {
      staticClass: "actions px-0"
    }, [_c('v-btn', {
      staticClass: "primary elevation-1",
      attrs: {
        "disabled": _vm.editingMiles
      },
      on: {
        "click": function($event) {
          return _vm.editMiles(charge)
        }
      }
    }, [_vm._v(_vm._s(_vm.$lang.actions.edit))]), _vm._v(" "), _c('v-btn', {
      staticClass: "error ml-0 elevation-1",
      on: {
        "click": function($event) {
          return _vm.deleteMiles(index)
        }
      }
    }, [_vm._v(_vm._s(_vm.$lang.actions.delete))])], 1)]], 2)
  }), 0) : _vm._e()])])], 1) : _vm._e()], 1), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "fade"
    }
  }, [(_vm.company.deliveryCharges.type === 'chargesbyinvoiceamount') ? _c('v-flex', {
    attrs: {
      "xs12": "",
      "px-3": "",
      "pb-4": ""
    }
  }, [_c('v-btn', {
    staticClass: "primary mx-0",
    attrs: {
      "disabled": _vm.editingAmount
    },
    on: {
      "click": _vm.addAmount
    }
  }, [_vm._v(_vm._s(_vm.$lang.actions.chargebyAmount))]), _vm._v(" "), _c('div', {
    staticClass: "v-table__overflow custom-table"
  }, [_c('table', {
    staticClass: "v-datatable v-table theme--light"
  }, [_c('thead', [_c('tr', [_c('th', {
    staticClass: "text-xs-left"
  }, [_c('div', {
    staticClass: "th-adj"
  }, [_vm._v(_vm._s(_vm.$lang.header.fromAmount)), _c('span', {
    staticClass: "error--text"
  }, [_vm._v("*")])])]), _vm._v(" "), _c('th', {
    staticClass: "text-xs-left"
  }, [_c('div', {
    staticClass: "th-adj"
  }, [_vm._v(_vm._s(_vm.$lang.header.toAmount)), _c('span', {
    staticClass: "error--text"
  }, [_vm._v("*")])])]), _vm._v(" "), _c('th', {
    staticClass: "text-xs-left"
  }, [_c('div', {
    staticClass: "th-adj"
  }, [_vm._v(_vm._s(_vm.$lang.header.charges)), _c('span', {
    staticClass: "error--text"
  }, [_vm._v("*")])])]), _vm._v(" "), _c('th', [_c('v-text-field', {
    staticClass: "required",
    staticStyle: {
      "max-width": "250px"
    },
    attrs: {
      "required": "",
      "type": "number",
      "min": "0",
      "steps": "0.1",
      "label": _vm.$lang.header.defaultCharges,
      "hide-details": ""
    },
    model: {
      value: (_vm.defaultCharges),
      callback: function($$v) {
        _vm.defaultCharges = $$v
      },
      expression: "defaultCharges"
    }
  })], 1)])]), _vm._v(" "), (_vm.amounts.length !== 0) ? _c('tbody', _vm._l((_vm.amounts), function(amount, index) {
    return _c('tr', {
      key: index
    }, [(amount.isEdit) ? [_c('td', [_c('v-text-field', {
      attrs: {
        "type": "number",
        "min": "0",
        "step": "0.5"
      },
      model: {
        value: (_vm.tempAmount.fromAmount),
        callback: function($$v) {
          _vm.$set(_vm.tempAmount, "fromAmount", $$v)
        },
        expression: "tempAmount.fromAmount"
      }
    })], 1), _vm._v(" "), _c('td', [_c('v-text-field', {
      attrs: {
        "type": "number",
        "min": "0",
        "step": "0.5"
      },
      model: {
        value: (_vm.tempAmount.toAmount),
        callback: function($$v) {
          _vm.$set(_vm.tempAmount, "toAmount", $$v)
        },
        expression: "tempAmount.toAmount"
      }
    })], 1), _vm._v(" "), _c('td', [_c('v-text-field', {
      attrs: {
        "type": "number",
        "min": "0",
        "step": "0.5"
      },
      model: {
        value: (_vm.tempAmount.charges),
        callback: function($$v) {
          _vm.$set(_vm.tempAmount, "charges", $$v)
        },
        expression: "tempAmount.charges"
      }
    })], 1), _vm._v(" "), _c('td', {
      staticClass: "min-w-lg px-0"
    }, [_c('v-btn', {
      staticClass: "primary elevation-1",
      attrs: {
        "disabled": !_vm.tempAmount.fromAmount || !_vm.tempAmount.toAmount || !_vm.tempAmount.charges
      },
      on: {
        "click": function($event) {
          return _vm.saveAmountEdit(amount)
        }
      }
    }, [_vm._v(_vm._s(_vm.$lang.actions.save))]), _vm._v(" "), _c('v-btn', {
      staticClass: "error ml-0 elevation-1",
      on: {
        "click": function($event) {
          return _vm.closeAmountEdit(amount)
        }
      }
    }, [_vm._v(_vm._s(_vm.$lang.actions.cancel))])], 1)] : [_c('td', [_vm._v(_vm._s(amount.fromAmount))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(amount.toAmount))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(amount.charges))]), _vm._v(" "), _c('td', {
      staticClass: "actions px-0"
    }, [_c('v-btn', {
      staticClass: "primary elevation-1",
      on: {
        "click": function($event) {
          return _vm.editAmount(amount)
        }
      }
    }, [_vm._v(_vm._s(_vm.$lang.actions.edit))]), _vm._v(" "), _c('v-btn', {
      staticClass: "error ml-0 elevation-1",
      on: {
        "click": function($event) {
          return _vm.deleteAmount(index)
        }
      }
    }, [_vm._v(_vm._s(_vm.$lang.actions.delete))])], 1)]], 2)
  }), 0) : _vm._e()])])], 1) : _vm._e()], 1)], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "px-3": "",
      "pt-2": "",
      "pb-4": ""
    }
  }, [_c('hr')]), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('h2', {
    staticClass: "px-3 pb-3"
  }, [_vm._v("\n          " + _vm._s(_vm.$lang.header.automatedPrinting) + "\n        ")])]), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-data-table', {
    attrs: {
      "headers": _vm.headers,
      "items": _vm.printingConfigurations,
      "rows-per-page-items": [25, 50, 100, 200, {
        text: 'All',
        value: -1
      }]
    },
    scopedSlots: _vm._u([{
      key: "items",
      fn: function(props) {
        return [_c('td', {
          staticClass: "min-w"
        }, [_vm._v(_vm._s(props.item.sourceSystem))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(props.item.orderType))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(props.item.printType))]), _vm._v(" "), _c('td', {
          staticStyle: {
            "width": "40px"
          }
        }, [_c('v-checkbox', {
          attrs: {
            "disabled": _vm.company.address.country === 'AT' && props.item.printType === 'invoice',
            "color": "primary",
            "hide-details": ""
          },
          model: {
            value: (props.item.autoPrinting),
            callback: function($$v) {
              _vm.$set(props.item, "autoPrinting", $$v)
            },
            expression: "props.item.autoPrinting"
          }
        })], 1)]
      }
    }])
  })], 1), _vm._v(" "), (_vm.isEdit) ? _c('v-flex', {
    attrs: {
      "px-3": "",
      "pt-2": "",
      "pb-4": ""
    }
  }, [_c('hr')]) : _vm._e(), _vm._v(" "), (_vm.isEdit) ? _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('h2', {
    staticClass: "px-3 pb-3"
  }, [_vm._v("\n            " + _vm._s(_vm.$lang.header.keys) + "\n          ")])]), _vm._v(" "), (_vm.company.contactServerSettings) ? _c('v-flex', {
    attrs: {
      "xs12": "",
      "md6": "",
      "px-3": ""
    }
  }, [_c('v-textarea', {
    attrs: {
      "label": _vm.$lang.labels.contactServerKey,
      "color": "primary",
      "auto-grow": "",
      "box": "",
      "rows": "2"
    },
    model: {
      value: (_vm.company.contactServerSettings.key),
      callback: function($$v) {
        _vm.$set(_vm.company.contactServerSettings, "key", $$v)
      },
      expression: "company.contactServerSettings.key"
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.company.walletServerSettings) ? _c('v-flex', {
    attrs: {
      "xs12": "",
      "md6": "",
      "px-3": ""
    }
  }, [_c('v-textarea', {
    attrs: {
      "label": _vm.$lang.labels.walletServerKey,
      "color": "primary",
      "auto-grow": "",
      "box": "",
      "rows": "2"
    },
    model: {
      value: (_vm.company.walletServerSettings.key),
      callback: function($$v) {
        _vm.$set(_vm.company.walletServerSettings, "key", $$v)
      },
      expression: "company.walletServerSettings.key"
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.company.addressServerSettings) ? _c('v-flex', {
    attrs: {
      "xs12": "",
      "md6": "",
      "px-3": ""
    }
  }, [_c('v-textarea', {
    attrs: {
      "label": _vm.$lang.labels.addressServerKey,
      "color": "primary",
      "auto-grow": "",
      "box": "",
      "rows": "2"
    },
    model: {
      value: (_vm.company.addressServerSettings.key),
      callback: function($$v) {
        _vm.$set(_vm.company.addressServerSettings, "key", $$v)
      },
      expression: "company.addressServerSettings.key"
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.company.inventoryServerSettings) ? _c('v-flex', {
    attrs: {
      "xs12": "",
      "md6": "",
      "px-3": ""
    }
  }, [_c('v-textarea', {
    attrs: {
      "label": _vm.$lang.labels.inventoryServerKey,
      "color": "primary",
      "auto-grow": "",
      "box": "",
      "rows": "2"
    },
    model: {
      value: (_vm.company.inventoryServerSettings.key),
      callback: function($$v) {
        _vm.$set(_vm.company.inventoryServerSettings, "key", $$v)
      },
      expression: "company.inventoryServerSettings.key"
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.company.reservationServerSettings) ? _c('v-flex', {
    attrs: {
      "xs12": "",
      "md6": "",
      "px-3": ""
    }
  }, [_c('v-textarea', {
    attrs: {
      "label": _vm.$lang.labels.reservationServerSettings,
      "color": "primary",
      "auto-grow": "",
      "box": "",
      "rows": "2"
    },
    model: {
      value: (_vm.company.reservationServerSettings.key),
      callback: function($$v) {
        _vm.$set(_vm.company.reservationServerSettings, "key", $$v)
      },
      expression: "company.reservationServerSettings.key"
    }
  })], 1) : _vm._e(), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": "",
      "align-center": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": "",
      "md3": "",
      "px-3": "",
      "shrink": ""
    }
  }, [_c('v-checkbox', {
    attrs: {
      "label": _vm.$lang.labels.enableDEP,
      "readonly": _vm.company.address.country === 'UK',
      "color": "primary"
    },
    model: {
      value: (_vm.company.isDEPEnabled),
      callback: function($$v) {
        _vm.$set(_vm.company, "isDEPEnabled", $$v)
      },
      expression: "company.isDEPEnabled"
    }
  })], 1), _vm._v(" "), (_vm.company.isDEPEnabled) ? _c('v-flex', {
    attrs: {
      "xs12": "",
      "md9": "",
      "px-3": ""
    }
  }, [_c('v-textarea', {
    attrs: {
      "label": _vm.$lang.labels.depServerKey,
      "color": "primary",
      "auto-grow": "",
      "box": "",
      "rows": "2"
    },
    model: {
      value: (_vm.company.depServerSettings.key),
      callback: function($$v) {
        _vm.$set(_vm.company.depServerSettings, "key", $$v)
      },
      expression: "company.depServerSettings.key"
    }
  })], 1) : _vm._e()], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.isEdit) ? _c('v-flex', {
    attrs: {
      "px-3": "",
      "pt-2": "",
      "pb-4": ""
    }
  }, [_c('hr')]) : _vm._e(), _vm._v(" "), (_vm.err) ? _c('v-flex', {
    attrs: {
      "xs12": "",
      "px-3": ""
    }
  }, [_c('v-alert', {
    attrs: {
      "value": true,
      "type": "error"
    }
  }, [_vm._v(_vm._s(_vm.err))])], 1) : _vm._e(), _vm._v(" "), (_vm.success) ? _c('v-flex', {
    attrs: {
      "xs12": "",
      "px-3": ""
    }
  }, [_c('v-alert', {
    attrs: {
      "value": true,
      "type": "success"
    }
  }, [_vm._v(_vm._s(_vm.success))])], 1) : _vm._e(), _vm._v(" "), _c('v-layout', {
    staticClass: "px-2",
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": "",
      "sm6": "",
      "md4": "",
      "px-3": ""
    }
  }, [(_vm.isEdit && _vm.createdOn) ? _c('v-text-field', {
    attrs: {
      "label": _vm.$lang.labels.created,
      "readonly": ""
    },
    model: {
      value: (_vm.createdOn),
      callback: function($$v) {
        _vm.createdOn = $$v
      },
      expression: "createdOn"
    }
  }) : _vm._e()], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "sm6": "",
      "md4": "",
      "px-3": ""
    }
  }, [(_vm.isEdit && _vm.modifiedOn) ? _c('v-text-field', {
    attrs: {
      "label": _vm.$lang.labels.modified,
      "readonly": ""
    },
    model: {
      value: (_vm.modifiedOn),
      callback: function($$v) {
        _vm.modifiedOn = $$v
      },
      expression: "modifiedOn"
    }
  }) : _vm._e()], 1)], 1), _vm._v(" "), _c('v-layout', {
    staticClass: "px-3",
    attrs: {
      "justify-space-between": "",
      "row": "",
      "align-center": ""
    }
  }, [_c('v-btn', {
    staticClass: "mx-0",
    attrs: {
      "flat": ""
    },
    on: {
      "click": function($event) {
        return _vm.$router.push({
          name: 'companies'
        })
      }
    }
  }, [_c('v-icon', {
    attrs: {
      "dark": ""
    }
  }, [_vm._v("keyboard_arrow_left")]), _vm._v("\n          " + _vm._s(_vm.$lang.actions.cancel) + "\n        ")], 1), _vm._v(" "), _c('div', [(_vm.isEdit) ? _c('v-btn', {
    attrs: {
      "type": "submit",
      "color": "primary"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.validate($event)
      }
    }
  }, [_vm._v("\n            " + _vm._s(_vm.$lang.actions.checkValidation) + "\n          ")]) : _vm._e(), _vm._v(" "), (_vm.isEdit) ? _c('v-btn', {
    attrs: {
      "type": "submit",
      "color": "primary",
      "disabled": !_vm.valid
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.submit('pushConfig')
      }
    }
  }, [_vm._v("\n            " + _vm._s(_vm.$lang.actions.pushConfUpdate) + "\n          ")]) : _vm._e(), _vm._v(" "), _c('v-btn', {
    staticClass: "mx-0",
    attrs: {
      "type": "submit",
      "color": "primary",
      "disabled": !_vm.valid
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.submit($event)
      }
    }
  }, [_vm._v("\n            " + _vm._s(_vm.isEdit ? _vm.$lang.actions.update : _vm.$lang.actions.create) + "\n          ")])], 1)], 1)], 1)], 1), _vm._v(" "), _c('v-snackbar', {
    attrs: {
      "bottom": "",
      "timeout": _vm.timeout,
      "color": "error",
      "multi-line": ""
    },
    model: {
      value: (_vm.snackbar),
      callback: function($$v) {
        _vm.snackbar = $$v
      },
      expression: "snackbar"
    }
  }, [_vm._v("\n    " + _vm._s(_vm.$lang.labels.maxDeliveryDisWarning) + "\n    "), _c('v-btn', {
    attrs: {
      "flat": ""
    },
    on: {
      "click": function($event) {
        _vm.snackbar = false
      }
    }
  }, [_vm._v("\n      " + _vm._s(_vm.$lang.actions.close) + "\n    ")])], 1), _vm._v(" "), (_vm.validateModal) ? _c('v-dialog', {
    attrs: {
      "max-width": "1200"
    },
    model: {
      value: (_vm.validateModal),
      callback: function($$v) {
        _vm.validateModal = $$v
      },
      expression: "validateModal"
    }
  }, [_c('validate-modal', {
    attrs: {
      "companyId": _vm.companyId
    },
    on: {
      "close": function($event) {
        _vm.validateModal = false
      }
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.createCorporationDialog) ? _c('v-dialog', {
    attrs: {
      "max-width": "500"
    },
    model: {
      value: (_vm.createCorporationDialog),
      callback: function($$v) {
        _vm.createCorporationDialog = $$v
      },
      expression: "createCorporationDialog"
    }
  }, [_c('confirmation-modal', {
    attrs: {
      "text": 'Create Corporation?'
    },
    on: {
      "submit": function($event) {
        return _vm.createCorporation()
      },
      "close": function($event) {
        _vm.createCorporationDialog = false
      }
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.addressDialog) ? _c('v-dialog', {
    attrs: {
      "scrollable": "",
      "fullscreen": _vm.$vuetify.breakpoint.smAndDown,
      "max-width": "600px"
    },
    model: {
      value: (_vm.addressDialog),
      callback: function($$v) {
        _vm.addressDialog = $$v
      },
      expression: "addressDialog"
    }
  }, [_c('address-modal', {
    attrs: {
      "country": _vm.company.address.country,
      "address": _vm.company.address,
      "postal": _vm.company.address.postalcode
    },
    on: {
      "close": function($event) {
        _vm.addressDialog = false
      },
      "submit": _vm.submitAddress
    }
  })], 1) : _vm._e()], 1)
},staticRenderFns: []}

/***/ }),
/* 428 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-card', [(_vm.err) ? _c('v-flex', {
    attrs: {
      "xs12": "",
      "pt-4": "",
      "pb-2": "",
      "px-4": ""
    }
  }, [_c('v-alert', {
    attrs: {
      "value": true,
      "type": "error"
    }
  }, [_vm._v(" " + _vm._s(_vm.err))])], 1) : _vm._e(), _vm._v(" "), (_vm.success) ? _c('v-flex', {
    attrs: {
      "xs12": "",
      "pt-4": "",
      "pb-2": "",
      "px-4": ""
    }
  }, [_c('v-alert', {
    attrs: {
      "type": "success",
      "value": true
    }
  }, [_vm._v(_vm._s(_vm.success))])], 1) : _vm._e(), _vm._v(" "), _c('v-card-title', {
    staticClass: "pb-3 px-2 layout row wrap"
  }, [_c('v-btn', {
    staticClass: "primary my-0 mx-3",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.createCatalog
    }
  }, [_vm._v("\n        " + _vm._s(_vm.$lang.actions.createCatalog) + "\n      ")]), _vm._v(" "), _c('v-checkbox', {
    staticClass: "mx-1 mt-0",
    attrs: {
      "color": "primary",
      "label": _vm.$lang.labels.showActive,
      "hide-details": ""
    },
    model: {
      value: (_vm.showActive),
      callback: function($$v) {
        _vm.showActive = $$v
      },
      expression: "showActive"
    }
  }), _vm._v(" "), _c('v-spacer'), _vm._v(" "), (!_vm.isLocalAdmin) ? _c('v-autocomplete', {
    staticClass: "min-w max-w mx-3 pb-2",
    attrs: {
      "label": _vm.$lang.actions.selectCompany,
      "items": _vm.mappedCompanies,
      "hide-details": ""
    },
    model: {
      value: (_vm.selectedCompany),
      callback: function($$v) {
        _vm.selectedCompany = $$v
      },
      expression: "selectedCompany"
    }
  }) : _vm._e()], 1), _vm._v(" "), (_vm.selectedCompany || (_vm.isLocalAdmin && _vm.allCatalogs)) ? _c('div', [_c('transition', {
    attrs: {
      "name": "fade"
    }
  }, [_c('v-data-table', {
    attrs: {
      "items": _vm.showActive ? _vm.activeCatalogs : _vm.allCatalogs,
      "headers": _vm.headers,
      "loading": _vm.loading,
      "pagination": _vm.pagination,
      "rows-per-page-items": [50, 100, 250, 500, {
        text: 'All',
        value: -1
      }]
    },
    on: {
      "update:pagination": function($event) {
        _vm.pagination = $event
      }
    },
    scopedSlots: _vm._u([{
      key: "items",
      fn: function(props) {
        return [_c('td', [_vm._v(_vm._s(props.item.catalogVersion))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(props.item.catalogName))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.formatDateWithTime(props.item.createdOn)))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(props.item.status))]), _vm._v(" "), _c('td', {
          staticStyle: {
            "min-width": "340px"
          }
        }, [(props.item.status !== 'active') ? _c('v-btn', {
          staticClass: "mx-0",
          attrs: {
            "color": "primary",
            "loading": props.item.activating
          },
          on: {
            "click": function($event) {
              $event.stopPropagation();
              return _vm.activateCatalog(props.item)
            }
          }
        }, [_vm._v(_vm._s(_vm.$lang.actions.activate))]) : _vm._e(), _vm._v(" "), _c('v-btn', {
          attrs: {
            "color": "primary"
          },
          on: {
            "click": function($event) {
              return _vm.editCatalog(props.item.catalogId)
            }
          }
        }, [_vm._v(_vm._s(_vm.$lang.actions.copyEdit))]), _vm._v(" "), (_vm.$auth.roles.includes('ROLE_SUN_ADMIN_CATALOG')) ? _c('v-btn', {
          staticClass: "ml-0",
          attrs: {
            "color": "primary"
          },
          on: {
            "click": function($event) {
              return _vm.pushToCorp(props.item.catalogId)
            }
          }
        }, [_vm._v("\n                " + _vm._s(_vm.$lang.actions.pushToCorp) + "\n              ")]) : _vm._e()], 1)]
      }
    }], null, false, 2674845268)
  }, [_c('v-progress-linear', {
    attrs: {
      "slot": "progress",
      "height": "6",
      "color": "primary",
      "indeterminate": ""
    },
    slot: "progress"
  })], 1)], 1)], 1) : _vm._e()], 1), _vm._v(" "), (_vm.showActivationModal) ? _c('v-dialog', {
    attrs: {
      "max-width": "500"
    },
    model: {
      value: (_vm.showActivationModal),
      callback: function($$v) {
        _vm.showActivationModal = $$v
      },
      expression: "showActivationModal"
    }
  }, [_c('activation-modal', {
    attrs: {
      "data": _vm.activationData
    },
    on: {
      "close": function($event) {
        return _vm.closeActivation($event)
      }
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.confirmPushModal) ? _c('v-dialog', {
    attrs: {
      "persistent": "",
      "max-width": "500"
    },
    model: {
      value: (_vm.confirmPushModal),
      callback: function($$v) {
        _vm.confirmPushModal = $$v
      },
      expression: "confirmPushModal"
    }
  }, [_c('confirm-push', {
    attrs: {
      "id": _vm.catalogId
    },
    on: {
      "close": function($event) {
        _vm.confirmPushModal = false
      }
    }
  })], 1) : _vm._e()], 1)
},staticRenderFns: []}

/***/ }),
/* 429 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-card', [_c('v-card-title', {
    staticClass: "pb-0 pt-1 px-4 layout row wrap"
  }, [_c('v-text-field', {
    staticClass: "min-w max-w",
    attrs: {
      "append-icon": "search",
      "label": _vm.$lang.labels.search,
      "hide-details": ""
    },
    model: {
      value: (_vm.search),
      callback: function($$v) {
        _vm.search = $$v
      },
      expression: "search"
    }
  }), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('v-btn', {
    staticClass: "close-btn",
    attrs: {
      "fab": "",
      "small": "",
      "flat": "",
      "absolute": ""
    },
    on: {
      "click": function($event) {
        return _vm.$emit('close')
      }
    }
  }, [_c('v-icon', [_vm._v("close")])], 1)], 1), _vm._v(" "), _c('v-data-table', {
    attrs: {
      "headers": _vm.headers,
      "items": _vm.license.miniLicenses,
      "search": _vm.search,
      "loading": _vm.license.length === 0,
      "pagination": _vm.pagination,
      "rows-per-page-items": [50, 100, 250, 500, {
        text: 'All',
        value: -1
      }]
    },
    on: {
      "update:pagination": function($event) {
        _vm.pagination = $event
      }
    },
    scopedSlots: _vm._u([{
      key: "items",
      fn: function(props) {
        return [_c('td', [_vm._v(_vm._s(props.item.licenseKey))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.formatDate(props.item.createdOn)))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.formatDate(props.item.getsActiveOn)))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.formatDate(props.item.expiresOn)))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(props.item.status))])]
      }
    }])
  }, [_c('v-progress-linear', {
    attrs: {
      "slot": "progress",
      "height": "6",
      "color": "primary",
      "indeterminate": ""
    },
    slot: "progress"
  }), _vm._v(" "), _vm._v(" "), _c('v-alert', {
    attrs: {
      "slot": "no-results",
      "value": true,
      "color": "warning",
      "icon": "warning"
    },
    slot: "no-results"
  }, [_vm._v("\n        Your search for \"" + _vm._s(_vm.search) + "\" found no results.\n      ")])], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 430 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-card', [(_vm.err) ? _c('v-flex', {
    attrs: {
      "xs12": "",
      "px-4": "",
      "pt-4": ""
    }
  }, [_c('v-alert', {
    attrs: {
      "value": true,
      "type": "error"
    }
  }, [_vm._v(_vm._s(_vm.err))])], 1) : _vm._e(), _vm._v(" "), _c('v-card-title', {
    staticClass: "pb-3 px-2 layout row wrap"
  }, [_c('v-btn', {
    staticClass: "primary my-0 mx-3",
    on: {
      "click": function($event) {
        return _vm.$router.push({
          name: "appResourceCreate"
        })
      }
    }
  }, [_vm._v(_vm._s(_vm.$lang.actions.createAppRes))]), _vm._v(" "), _c('v-checkbox', {
    staticClass: "mx-1 mt-0",
    attrs: {
      "color": "primary",
      "label": _vm.$lang.labels.showActive,
      "hide-details": ""
    },
    model: {
      value: (_vm.showActive),
      callback: function($$v) {
        _vm.showActive = $$v
      },
      expression: "showActive"
    }
  }), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('v-autocomplete', {
    staticClass: "min-w max-w mx-3 pb-2",
    attrs: {
      "label": _vm.$lang.actions.selectCompany,
      "items": _vm.mappedCompanies,
      "loading": _vm.companyLoading,
      "hide-details": ""
    },
    model: {
      value: (_vm.selectedCompany),
      callback: function($$v) {
        _vm.selectedCompany = $$v
      },
      expression: "selectedCompany"
    }
  }), _vm._v(" "), (_vm.show) ? _c('v-text-field', {
    staticClass: "min-w max-w mx-3 pb-2",
    attrs: {
      "append-icon": "search",
      "label": _vm.$lang.labels.search,
      "hide-details": ""
    },
    model: {
      value: (_vm.search),
      callback: function($$v) {
        _vm.search = $$v
      },
      expression: "search"
    }
  }) : _vm._e()], 1), _vm._v(" "), (_vm.show) ? _c('v-data-table', {
    attrs: {
      "headers": _vm.headers,
      "items": _vm.showActive ? _vm.activeAppResources : _vm.allAppResources,
      "search": _vm.search,
      "loading": _vm.loading,
      "rows-per-page-items": [50, 100, 250, 500, {
        text: 'All',
        value: -1
      }]
    },
    scopedSlots: _vm._u([{
      key: "items",
      fn: function(props) {
        return [_c('td', [_vm._v(_vm._s(props.item.name))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(props.item.type))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(props.item.status))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.formatDate(props.item.createdOn)))]), _vm._v(" "), _c('td', {
          staticClass: "min-w-lg"
        }, [_c('v-btn', {
          staticClass: "primary mx-0 elevation-1",
          on: {
            "click": function($event) {
              return _vm.$router.push({
                name: 'appResourceEdit',
                params: {
                  id: props.item.id
                }
              })
            }
          }
        }, [_vm._v(_vm._s(_vm.$lang.actions.edit))]), _vm._v(" "), _c('v-btn', {
          staticClass: "primary elevation-1",
          on: {
            "click": function($event) {
              return _vm.changeStatus(props.item)
            }
          }
        }, [_vm._v(_vm._s(props.item.status === 'active' ? _vm.$lang.actions.deactivate : _vm.$lang.actions.activate))])], 1)]
      }
    }], null, false, 3426300277)
  }, [_c('v-progress-linear', {
    attrs: {
      "slot": "progress",
      "height": "6",
      "color": "primary",
      "indeterminate": ""
    },
    slot: "progress"
  }), _vm._v(" "), _vm._v(" "), _c('v-alert', {
    attrs: {
      "slot": "no-results",
      "value": true,
      "color": "warning",
      "icon": "warning"
    },
    slot: "no-results"
  }, [_vm._v("\n        Your search for \"" + _vm._s(_vm.search) + "\" found no results.\n      ")])], 1) : _vm._e()], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 431 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(_vm.$vuetify.breakpoint.lg ? _vm.drawer = false : _vm.drawer = _vm.drawer) ? _c('v-navigation-drawer', {
    staticClass: "side-bar",
    attrs: {
      "disable-resize-watcher": "",
      "floating": "",
      "fixed": "",
      "app": ""
    },
    model: {
      value: (_vm.drawer),
      callback: function($$v) {
        _vm.drawer = $$v
      },
      expression: "drawer"
    }
  }, [_c('v-list-tile', {
    staticClass: "side-bar-search"
  }, [_c('v-text-field', {
    staticClass: "min-w max-w",
    attrs: {
      "append-icon": "search",
      "label": _vm.$lang.labels.search,
      "hide-details": ""
    },
    model: {
      value: (_vm.search),
      callback: function($$v) {
        _vm.search = $$v
      },
      expression: "search"
    }
  })], 1), _vm._v(" "), _c('v-list', {
    staticClass: "mt-2",
    attrs: {
      "dense": ""
    }
  }, _vm._l((_vm.filteredLinks), function(item, index) {
    return _c('v-list-tile', {
      key: index,
      attrs: {
        "to": ("/" + _vm.language + (item.path))
      }
    }, [_c('v-list-tile-content', [_c('v-list-tile-title', [_vm._v(_vm._s(_vm.$lang.header[item.title]))])], 1)], 1)
  }), 1)], 1) : _vm._e(), _vm._v(" "), _c('v-toolbar', {
    staticClass: "py-2",
    attrs: {
      "color": "primary",
      "app": "",
      "light": ""
    }
  }, [_c('v-toolbar-side-icon', {
    attrs: {
      "color": "white--text hidden-lg-and-up"
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.drawer = !_vm.drawer
      }
    }
  }), _vm._v(" "), _c('v-toolbar-title', [_c('router-link', {
    staticClass: "logo px-0 mr-2",
    attrs: {
      "to": {
        name: 'home'
      }
    }
  }, [_vm._v("\n        " + _vm._s(_vm.$lang.global.projectName) + "\n      ")])], 1), _vm._v(" "), _c('ul', {
    staticClass: "layout row wrap pl-2 hidden-md-and-down"
  }, _vm._l((_vm.approvedLinks), function(item, index) {
    return _c('router-link', {
      key: index,
      staticClass: "px-2",
      attrs: {
        "tag": "li",
        "to": ("/" + _vm.language + (item.path)),
        "active-class": "active"
      }
    }, [_vm._v(_vm._s(_vm.$lang.header[item.title]))])
  }), 1), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('div', {
    staticClass: "d-flex"
  }, [_c('router-link', {
    staticClass: "elevation-0 log-out white--text",
    attrs: {
      "tag": "v-btn",
      "to": "/log-out"
    }
  }, [_vm._v("\n        " + _vm._s(_vm.$lang.header.logout) + "\n      ")])], 1)], 1), _vm._v(" "), _c('v-container', {
    attrs: {
      "fluid": ""
    }
  }, [_c('router-view')], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 432 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', {
    class: {
      'is-selected': _vm.itemData.selected, 'error': _vm.itemData.error
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        $event.preventDefault();
        return _vm.select($event)
      }
    }
  }, [_c('span', {
    staticClass: "arrow_to_move",
    on: {
      "click": function($event) {
        $event.stopPropagation();
        $event.preventDefault();
      }
    }
  }, [_c('i', {
    staticClass: "material-icons pointerClass",
    on: {
      "click": function($event) {
        $event.stopPropagation();
        $event.preventDefault();
        return _vm.moveItemUp($event)
      }
    }
  }, [_vm._v("keyboard_arrow_up")]), _vm._v(" "), _c('i', {
    staticClass: "material-icons pointerClass",
    on: {
      "click": function($event) {
        $event.stopPropagation();
        $event.preventDefault();
        return _vm.moveItemDown($event)
      }
    }
  }, [_vm._v("keyboard_arrow_down")])]), _vm._v(" "), _c('p', {
    staticClass: "d-inline-block",
    class: {
      bold: _vm.itemData.items && _vm.itemData.items.length > 0
    }
  }, [(_vm.itemData.colorCode) ? _c('span', {
    staticClass: "color-preview",
    style: ({
      'background-color': _vm.itemData.colorCode
    })
  }) : _vm._e(), _vm._v(" "), (_vm.itemData.abbr) ? _c('small', [_vm._v("(" + _vm._s(_vm.itemData.abbr[_vm.language]) + ")")]) : _vm._e(), _vm._v(" " + _vm._s(_vm.itemData.name[_vm.language]) + " "), (_vm.itemData.itemId) ? _c('small', [_vm._v("[" + _vm._s(_vm.itemData.itemId) + "]")]) : _vm._e(), _vm._v(" "), _c('small', [_c('span', {
    staticClass: "mx-2"
  }, [_vm._v("-")]), _vm._v(" " + _vm._s(_vm.$lang.header.views) + ": " + _vm._s(_vm.formattedViews) + "\n      "), _c('span', {
    staticClass: "mx-2"
  }, [_vm._v("-")]), _vm._v(" " + _vm._s(_vm.$lang.labels.printerCategories) + ": " + _vm._s(_vm.formattedPrintCategories) + "\n      "), (_vm.formattedSettings) ? [_c('span', {
    staticClass: "mx-2"
  }, [_vm._v("-")]), _vm._v(" " + _vm._s(_vm.$lang.labels.settings) + ": " + _vm._s(_vm.formattedSettings))] : _vm._e(), _vm._v(" "), [_c('span', {
    staticClass: "mx-2"
  }, [_vm._v("-")]), _vm._v(" " + _vm._s(_vm.$lang.labels.VAT) + ": " + _vm._s(_vm.itemData.vatRate ? _vm.itemData.vatRate : 'none'))], _vm._v(" "), (_vm.formattedSettings) ? [_c('span', {
    staticClass: "mx-2"
  }, [_vm._v("-")]), _vm._v(" " + _vm._s(_vm.$lang.labels.taxCategory) + ": " + _vm._s(_vm.itemData.taxCategory))] : _vm._e(), _vm._v(" "), (_vm.itemData.minimumTotalPrice && _vm.isEdit) ? [_c('span', {
    staticClass: "mx-2"
  }, [_vm._v("-")]), _vm._v(" " + _vm._s(_vm.$lang.labels.defPrice) + ": " + _vm._s(_vm.itemData.minimumTotalPrice))] : _vm._e()], 2)]), _vm._v(" "), _c('div', {
    staticClass: "item-actions d-inline-block"
  }, [_c('i', {
    staticClass: "material-icons",
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.addItemTrigger()
      }
    }
  }, [_vm._v("add")]), _vm._v(" "), _c('i', {
    staticClass: "material-icons",
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.addItemTrigger(true)
      }
    }
  }, [_vm._v("plus_one")]), _vm._v(" "), _c('i', {
    staticClass: "material-icons",
    on: {
      "click": [function($event) {
        $event.stopPropagation();
        return _vm.$emit('editItem', [
          [_vm.index], false
        ])
      }, function($event) {
        return _vm.showCurrent()
      }]
    }
  }, [_vm._v("edit")]), _vm._v(" "), _c('i', {
    staticClass: "material-icons",
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.$emit('deleted', [
          [_vm.index], false
        ])
      }
    }
  }, [_vm._v("delete")]), _vm._v(" "), _c('v-tooltip', {
    attrs: {
      "bottom": ""
    }
  }, [_c('v-icon', {
    staticClass: "copyItemClass",
    attrs: {
      "slot": "activator"
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.$emit('copyItem', [
          [_vm.index], false
        ])
      }
    },
    slot: "activator"
  }, [_vm._v("file_copy")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.$lang.actions.copyItem))])], 1), _vm._v(" "), _c('v-tooltip', {
    attrs: {
      "bottom": ""
    }
  }, [_c('v-icon', {
    staticClass: "massAddClass",
    attrs: {
      "slot": "activator"
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.$emit('massAdd', [
          [_vm.index], false
        ])
      }
    },
    slot: "activator"
  }, [_vm._v("add_box")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.$lang.actions.massAdd))])], 1), _vm._v(" "), _c('v-tooltip', {
    attrs: {
      "bottom": ""
    }
  }, [_c('v-icon', {
    staticClass: "massRemoveClass",
    attrs: {
      "slot": "activator"
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.$emit('massRemove', [
          [_vm.index], false
        ])
      }
    },
    slot: "activator"
  }, [_vm._v("indeterminate_check_box")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.$lang.actions.massRemove))])], 1), _vm._v(" "), (_vm.itemData.items && _vm.itemData.items.length > 0) ? _c('i', {
    staticClass: "material-icons",
    class: {
      'primary--text': _vm.itemData.open
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.$set(_vm.itemData, 'open', !_vm.itemData.open)
      }
    }
  }, [_vm._v("folder_open")]) : _vm._e()], 1), _vm._v(" "), (_vm.itemData.items) ? _c('ul', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.itemData.open),
      expression: "itemData.open"
    }],
    on: {
      "click": function($event) {
        $event.stopPropagation();
        $event.preventDefault();
      }
    }
  }, _vm._l((_vm.itemData.items), function(item, index) {
    return _c('item', {
      key: index,
      attrs: {
        "index": index,
        "views": _vm.views,
        "isEdit": _vm.isEdit,
        "itemData": item,
        "items": _vm.itemData.items
      },
      on: {
        "addItem": function($event) {
          return _vm.selectFurther($event, 'addItem')
        },
        "editItem": function($event) {
          return _vm.selectFurther($event, 'editItem')
        },
        "click": function($event) {
          $event.stopPropagation();
          $event.preventDefault();
        },
        "editItemPassing": _vm.editItemPassing,
        "deleted": function($event) {
          return _vm.selectFurther($event, 'deleted')
        },
        "copyItem": function($event) {
          return _vm.selectFurther($event, 'copyItem')
        },
        "massAdd": function($event) {
          return _vm.selectFurther($event, 'massAdd')
        },
        "massRemove": function($event) {
          return _vm.selectFurther($event, 'massRemove')
        },
        "selected": function($event) {
          return _vm.selectFurther($event, 'selected')
        }
      }
    })
  }), 1) : _vm._e()])
},staticRenderFns: []}

/***/ }),
/* 433 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-card', [(_vm.err) ? _c('v-flex', {
    attrs: {
      "xs12": "",
      "pt-4": "",
      "px-4": ""
    }
  }, [_c('v-alert', {
    attrs: {
      "type": "error",
      "value": true
    }
  }, [_vm._v(_vm._s(_vm.err))])], 1) : _vm._e(), _vm._v(" "), _c('v-card-title', {
    staticClass: "pb-3 px-2 layout row wrap"
  }, [_c('v-btn', {
    staticClass: "primary my-0 mx-3",
    on: {
      "click": function($event) {
        return _vm.$router.push({
          name: "newWebSpace"
        })
      }
    }
  }, [_vm._v(_vm._s(_vm.$lang.actions.createWebSpace))]), _vm._v(" "), _c('v-checkbox', {
    staticClass: "mx-1 mt-0",
    attrs: {
      "color": "primary",
      "label": _vm.$lang.labels.showActive,
      "hide-details": ""
    },
    model: {
      value: (_vm.showActive),
      callback: function($$v) {
        _vm.showActive = $$v
      },
      expression: "showActive"
    }
  }), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('v-autocomplete', {
    staticClass: "min-w max-w mx-3 pb-2",
    attrs: {
      "label": _vm.$lang.actions.selectCompany,
      "items": _vm.mappedCompanies,
      "loading": _vm.companyLoading,
      "hide-details": ""
    },
    model: {
      value: (_vm.selectedCompany),
      callback: function($$v) {
        _vm.selectedCompany = $$v
      },
      expression: "selectedCompany"
    }
  }), _vm._v(" "), (_vm.show) ? _c('v-text-field', {
    staticClass: "min-w max-w mx-3 pb-2",
    attrs: {
      "append-icon": "search",
      "label": _vm.$lang.labels.search,
      "hide-details": ""
    },
    model: {
      value: (_vm.search),
      callback: function($$v) {
        _vm.search = $$v
      },
      expression: "search"
    }
  }) : _vm._e()], 1), _vm._v(" "), (_vm.show) ? _c('v-data-table', {
    attrs: {
      "headers": _vm.headers,
      "items": _vm.showActive ? _vm.activeWebSpaces : _vm.allWebSpaces,
      "search": _vm.search,
      "loading": _vm.loading,
      "rows-per-page-items": [50, 100, 250, 500, {
        text: 'All',
        value: -1
      }]
    },
    scopedSlots: _vm._u([{
      key: "items",
      fn: function(props) {
        return [_c('td', [_vm._v(_vm._s(props.item.domainNameType))]), _vm._v(" "), _c('td', {
          staticClass: "text-xs-left min-w"
        }, [_vm._v(_vm._s(props.item.companyName))]), _vm._v(" "), _c('td', {
          staticClass: "text-xs-left"
        }, [_vm._v(_vm._s(props.item.type))]), _vm._v(" "), _c('td', {
          staticClass: "text-xs-left"
        }, [_vm._v(_vm._s(props.item.template))]), _vm._v(" "), _c('td', {
          staticClass: "text-xs-left"
        }, [_vm._v(_vm._s(props.item.status))]), _vm._v(" "), _c('td', {
          staticClass: "text-xs-left"
        }, [_vm._v(_vm._s(_vm.formatDate(props.item.createdOn)))]), _vm._v(" "), _c('td', {
          staticClass: "text-xs-left min-w-lg"
        }, [_c('v-btn', {
          staticClass: "primary mx-0 elevation-1",
          on: {
            "click": function($event) {
              return _vm.editWebSpace(props.item)
            }
          }
        }, [_vm._v("\n            " + _vm._s(_vm.$lang.actions.edit) + "\n          ")]), _vm._v(" "), _c('v-btn', {
          staticClass: "primary elevation-1",
          on: {
            "click": function($event) {
              return _vm.changeStatus(props.item)
            }
          }
        }, [_vm._v("\n            " + _vm._s(props.item.status === 'active' ? _vm.$lang.actions.deactivate : _vm.$lang.actions.activate) + "\n          ")])], 1)]
      }
    }], null, false, 341722568)
  }, [_c('v-progress-linear', {
    attrs: {
      "slot": "progress",
      "height": "6",
      "color": "primary",
      "indeterminate": ""
    },
    slot: "progress"
  }), _vm._v(" "), _vm._v(" "), _c('v-alert', {
    attrs: {
      "slot": "no-results",
      "value": true,
      "color": "warning",
      "icon": "warning"
    },
    slot: "no-results"
  }, [_vm._v("\n        Your search for \"" + _vm._s(_vm.search) + "\" found no results.\n      ")])], 1) : _vm._e()], 1), _vm._v(" "), (_vm.confirmationModal) ? _c('v-dialog', {
    attrs: {
      "max-width": "500"
    },
    model: {
      value: (_vm.confirmationModal),
      callback: function($$v) {
        _vm.confirmationModal = $$v
      },
      expression: "confirmationModal"
    }
  }, [_c('confirmation-modal', {
    attrs: {
      "data": _vm.confirmationData
    },
    on: {
      "close": function($event) {
        _vm.confirmationModal = false
      },
      "change": function($event) {
        return _vm.deactivate($event)
      }
    }
  })], 1) : _vm._e()], 1)
},staticRenderFns: []}

/***/ }),
/* 434 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-flex', {
    attrs: {
      "xs12": "",
      "lg9": ""
    }
  }, [_c('v-card', {
    staticClass: "px-2 py-3"
  }, [(_vm.err) ? _c('v-flex', {
    attrs: {
      "xs12": "",
      "px-3": "",
      "pb-3": ""
    }
  }, [_c('v-alert', {
    attrs: {
      "value": true,
      "type": "error"
    }
  }, [_vm._v(_vm._s(_vm.err))])], 1) : _vm._e(), _vm._v(" "), (_vm.success) ? _c('v-flex', {
    attrs: {
      "xs12": "",
      "px-3": "",
      "pb-3": ""
    }
  }, [_c('v-alert', {
    attrs: {
      "value": true,
      "type": "success"
    }
  }, [_vm._v(_vm._s(_vm.success))])], 1) : _vm._e(), _vm._v(" "), _c('v-form', {
    model: {
      value: (_vm.valid),
      callback: function($$v) {
        _vm.valid = $$v
      },
      expression: "valid"
    }
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": "",
      "justify-space-between": "",
      "align-center": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": "",
      "sm6": "",
      "px-3": ""
    }
  }, [_c('v-autocomplete', {
    attrs: {
      "items": _vm.mappedCompanies,
      "label": _vm.$lang.labels.company,
      "readonly": _vm.isView,
      "required": "",
      "rules": [function (v) { return !!v || ("" + (_vm.$lang.errors.missingCompany)); }]
    },
    model: {
      value: (_vm.license.companyId),
      callback: function($$v) {
        _vm.$set(_vm.license, "companyId", $$v)
      },
      expression: "license.companyId"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "sm6": "",
      "px-3": ""
    }
  }, [_c('v-autocomplete', {
    attrs: {
      "items": _vm.licenseTypes,
      "label": _vm.$lang.header.licenseType,
      "readonly": _vm.isView,
      "required": "",
      "rules": [function (v) { return !!v || ("" + (_vm.$lang.errors.missingLicenseType)); }]
    },
    model: {
      value: (_vm.license.licenseType),
      callback: function($$v) {
        _vm.$set(_vm.license, "licenseType", $$v)
      },
      expression: "license.licenseType"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "sm6": "",
      "px-3": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "type": "number",
      "min": "0",
      "readonly": _vm.isView || _vm.testLicense,
      "label": _vm.$lang.labels.concurrent,
      "required": "",
      "rules": [function (v) { return !!v || ("" + (_vm.$lang.errors.missingConcurrent)); }]
    },
    model: {
      value: (_vm.license.licenseAttributes.concurrentUsers),
      callback: function($$v) {
        _vm.$set(_vm.license.licenseAttributes, "concurrentUsers", $$v)
      },
      expression: "license.licenseAttributes.concurrentUsers"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "sm6": "",
      "px-3": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "readonly": _vm.isView,
      "label": _vm.$lang.labels.sunLicense,
      "required": "",
      "rules": [function (v) { return !!v || ("" + (_vm.$lang.errors.missingSunLicense)); }]
    },
    model: {
      value: (_vm.license.sunLicenseSystemVersion),
      callback: function($$v) {
        _vm.$set(_vm.license, "sunLicenseSystemVersion", $$v)
      },
      expression: "license.sunLicenseSystemVersion"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "sm6": "",
      "px-3": ""
    }
  }, [_c('v-autocomplete', {
    attrs: {
      "clearable": "",
      "readonly": _vm.isView,
      "items": _vm.instances,
      "label": _vm.$lang.header.moonInstName,
      "item-text": "name",
      "item-value": "instanceId"
    },
    model: {
      value: (_vm.license.moonInstanceId),
      callback: function($$v) {
        _vm.$set(_vm.license, "moonInstanceId", $$v)
      },
      expression: "license.moonInstanceId"
    }
  })], 1), _vm._v(" "), (_vm.isView) ? _c('v-flex', {
    attrs: {
      "xs12": "",
      "sm6": "",
      "px-3": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "readonly": _vm.isView,
      "label": _vm.$lang.labels.licenseSyncStatus
    },
    model: {
      value: (_vm.license.licenseSyncStatus),
      callback: function($$v) {
        _vm.$set(_vm.license, "licenseSyncStatus", $$v)
      },
      expression: "license.licenseSyncStatus"
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.isView) ? _c('v-flex', {
    attrs: {
      "xs12": "",
      "px-3": ""
    }
  }, [_c('v-textarea', {
    attrs: {
      "readonly": _vm.isView,
      "label": _vm.$lang.labels.moonInstID,
      "auto-grow": "",
      "rows": "1"
    },
    model: {
      value: (_vm.license.moonInstanceId),
      callback: function($$v) {
        _vm.$set(_vm.license, "moonInstanceId", $$v)
      },
      expression: "license.moonInstanceId"
    }
  })], 1) : _vm._e(), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": "",
      "justify-space-between": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": "",
      "sm6": "",
      "px-3": ""
    }
  }, [_c('v-menu', {
    ref: "menu",
    attrs: {
      "close-on-content-click": false,
      "nudge-right": 40,
      "return-value": _vm.license.getsActiveOn,
      "lazy": "",
      "transition": "scale-transition",
      "offset-y": "",
      "full-width": "",
      "min-width": "290px",
      "disabled": _vm.isView
    },
    on: {
      "update:returnValue": function($event) {
        return _vm.$set(_vm.license, "getsActiveOn", $event)
      },
      "update:return-value": function($event) {
        return _vm.$set(_vm.license, "getsActiveOn", $event)
      }
    },
    model: {
      value: (_vm.menu),
      callback: function($$v) {
        _vm.menu = $$v
      },
      expression: "menu"
    }
  }, [_c('v-text-field', {
    attrs: {
      "slot": "activator",
      "required": "",
      "readonly": "",
      "rules": [function (v) { return !!v || ("" + (_vm.$lang.errors.missingActivationDate)); }],
      "label": _vm.$lang.header.activationDate,
      "prepend-icon": "event"
    },
    slot: "activator",
    model: {
      value: (_vm.license.getsActiveOn),
      callback: function($$v) {
        _vm.$set(_vm.license, "getsActiveOn", $$v)
      },
      expression: "license.getsActiveOn"
    }
  }), _vm._v(" "), _c('v-date-picker', {
    attrs: {
      "no-title": "",
      "scrollable": "",
      "color": "primary"
    },
    on: {
      "input": function($event) {
        return _vm.$refs.menu.save(_vm.license.getsActiveOn)
      }
    },
    model: {
      value: (_vm.license.getsActiveOn),
      callback: function($$v) {
        _vm.$set(_vm.license, "getsActiveOn", $$v)
      },
      expression: "license.getsActiveOn"
    }
  })], 1)], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "sm6": "",
      "px-3": ""
    }
  }, [_c('v-menu', {
    ref: "menu2",
    attrs: {
      "close-on-content-click": false,
      "nudge-right": 40,
      "return-value": _vm.license.expiresOn,
      "lazy": "",
      "transition": "scale-transition",
      "offset-y": "",
      "full-width": "",
      "min-width": "290px",
      "disabled": _vm.isView || _vm.testLicense
    },
    on: {
      "update:returnValue": function($event) {
        return _vm.$set(_vm.license, "expiresOn", $event)
      },
      "update:return-value": function($event) {
        return _vm.$set(_vm.license, "expiresOn", $event)
      }
    },
    model: {
      value: (_vm.menu2),
      callback: function($$v) {
        _vm.menu2 = $$v
      },
      expression: "menu2"
    }
  }, [_c('v-text-field', {
    attrs: {
      "slot": "activator",
      "rules": [function (v) { return !!v || ("" + (_vm.$lang.errors.missingExpiryDate)); }],
      "readonly": "",
      "label": _vm.$lang.header.expiryDate,
      "prepend-icon": "event",
      "required": ""
    },
    slot: "activator",
    model: {
      value: (_vm.license.expiresOn),
      callback: function($$v) {
        _vm.$set(_vm.license, "expiresOn", $$v)
      },
      expression: "license.expiresOn"
    }
  }), _vm._v(" "), _c('v-date-picker', {
    attrs: {
      "no-title": "",
      "scrollable": "",
      "color": "primary"
    },
    on: {
      "input": function($event) {
        return _vm.$refs.menu2.save(_vm.license.expiresOn)
      }
    },
    model: {
      value: (_vm.license.expiresOn),
      callback: function($$v) {
        _vm.$set(_vm.license, "expiresOn", $$v)
      },
      expression: "license.expiresOn"
    }
  })], 1)], 1)], 1)], 1), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": "",
      "justify-space-between": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": "",
      "sm6": "",
      "px-3": ""
    }
  }, [(_vm.isView && _vm.createdOn) ? _c('v-text-field', {
    attrs: {
      "label": _vm.$lang.labels.created,
      "readonly": ""
    },
    model: {
      value: (_vm.createdOn),
      callback: function($$v) {
        _vm.createdOn = $$v
      },
      expression: "createdOn"
    }
  }) : _vm._e()], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "sm6": "",
      "px-3": ""
    }
  }, [(_vm.isView && _vm.modifiedOn) ? _c('v-text-field', {
    attrs: {
      "label": _vm.$lang.labels.modified,
      "readonly": ""
    },
    model: {
      value: (_vm.modifiedOn),
      callback: function($$v) {
        _vm.modifiedOn = $$v
      },
      expression: "modifiedOn"
    }
  }) : _vm._e()], 1)], 1), _vm._v(" "), _c('v-layout', {
    staticClass: "px-2",
    attrs: {
      "row": "",
      "wrap": "",
      "justify-space-between": "",
      "align-center": ""
    }
  }, [_c('v-btn', {
    staticClass: "mx-2",
    attrs: {
      "flat": ""
    },
    on: {
      "click": function($event) {
        return _vm.$router.push({
          name: 'licenses'
        })
      }
    }
  }, [_c('v-icon', [_vm._v("keyboard_arrow_left")]), _vm._v("\n          " + _vm._s(_vm.$lang.actions.close) + "\n        ")], 1), _vm._v(" "), (_vm.isView) ? _c('v-btn', {
    staticClass: "primary mx-2",
    on: {
      "click": function($event) {
        _vm.viewMiniLicense = true
      }
    }
  }, [_vm._v(_vm._s(_vm.$lang.actions.viewMiniLicense))]) : _c('v-btn', {
    staticClass: "primary mx-2",
    attrs: {
      "disabled": !_vm.valid || _vm.creating
    },
    on: {
      "click": _vm.submit
    }
  }, [_vm._v(_vm._s(_vm.$lang.actions.create))])], 1)], 1)], 1), _vm._v(" "), (_vm.viewMiniLicense) ? _c('v-dialog', {
    attrs: {
      "max-width": "800"
    },
    model: {
      value: (_vm.viewMiniLicense),
      callback: function($$v) {
        _vm.viewMiniLicense = $$v
      },
      expression: "viewMiniLicense"
    }
  }, [_c('mini-license-modal', {
    attrs: {
      "license": _vm.license
    },
    on: {
      "close": function($event) {
        _vm.viewMiniLicense = false
      }
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.showActivationModal) ? _c('v-dialog', {
    attrs: {
      "persistent": "",
      "max-width": "500"
    },
    model: {
      value: (_vm.showActivationModal),
      callback: function($$v) {
        _vm.showActivationModal = $$v
      },
      expression: "showActivationModal"
    }
  }, [_c('activation-modal', {
    attrs: {
      "licenseId": _vm.activationData
    },
    on: {
      "close": function($event) {
        _vm.showActivationModal = false
      }
    }
  })], 1) : _vm._e()], 1)
},staticRenderFns: []}

/***/ }),
/* 435 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-card', [(_vm.err) ? _c('v-flex', {
    attrs: {
      "xs12": "",
      "px-4": ""
    }
  }, [_c('v-alert', {
    attrs: {
      "value": true,
      "type": "error"
    }
  }, [_vm._v(_vm._s(_vm.err))])], 1) : _vm._e(), _vm._v(" "), _c('v-card-title', {
    staticClass: "py-3 px-2 layout row wrap"
  }, [_c('v-btn', {
    staticClass: "primary my-0 mx-3",
    on: {
      "click": function($event) {
        return _vm.$router.push({
          name: "callerIdCreate"
        })
      }
    }
  }, [_vm._v(_vm._s(_vm.$lang.actions.createCallerId))]), _vm._v(" "), _c('v-checkbox', {
    staticClass: "mx-1 mt-0",
    attrs: {
      "color": "primary",
      "label": _vm.$lang.labels.showActive,
      "hide-details": ""
    },
    model: {
      value: (_vm.showActive),
      callback: function($$v) {
        _vm.showActive = $$v
      },
      expression: "showActive"
    }
  }), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('v-autocomplete', {
    staticClass: "min-w max-w mx-3 pb-2",
    attrs: {
      "label": _vm.$lang.actions.selectCompany,
      "items": _vm.mappedCompanies,
      "hide-details": ""
    },
    model: {
      value: (_vm.selectedCompany),
      callback: function($$v) {
        _vm.selectedCompany = $$v
      },
      expression: "selectedCompany"
    }
  }), _vm._v(" "), (_vm.show) ? _c('v-text-field', {
    staticClass: "min-w max-w mx-3 pb-2",
    attrs: {
      "append-icon": "search",
      "label": _vm.$lang.labels.search,
      "hide-details": ""
    },
    model: {
      value: (_vm.search),
      callback: function($$v) {
        _vm.search = $$v
      },
      expression: "search"
    }
  }) : _vm._e()], 1), _vm._v(" "), (_vm.show) ? _c('v-data-table', {
    attrs: {
      "headers": _vm.headers,
      "items": _vm.showActive ? _vm.activeCallerIdServers : _vm.allCallerIdServers,
      "search": _vm.search,
      "loading": _vm.loading,
      "rows-per-page-items": [50, 100, 250, 500, {
        text: 'All',
        value: -1
      }]
    },
    scopedSlots: _vm._u([{
      key: "items",
      fn: function(props) {
        return [_c('td', [_vm._v(_vm._s(props.item.name))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(props.item.status))]), _vm._v(" "), _c('td', {
          staticClass: "min-w-lg"
        }, [_c('v-btn', {
          staticClass: "primary mx-0 elevation-1",
          on: {
            "click": function($event) {
              return _vm.$router.push({
                name: 'callerIdEdit',
                params: {
                  id: props.item.id
                }
              })
            }
          }
        }, [_vm._v(_vm._s(_vm.$lang.actions.edit))]), _vm._v(" "), _c('v-btn', {
          staticClass: "primary elevation-1",
          on: {
            "click": function($event) {
              return _vm.changeStatus(props.item)
            }
          }
        }, [_vm._v(_vm._s(props.item.status === 'active' ? _vm.$lang.actions.deactivate : _vm.$lang.actions.activate))])], 1)]
      }
    }], null, false, 2223549481)
  }, [_c('v-progress-linear', {
    attrs: {
      "slot": "progress",
      "height": "6",
      "color": "primary",
      "indeterminate": ""
    },
    slot: "progress"
  }), _vm._v(" "), _vm._v(" "), _c('v-alert', {
    attrs: {
      "slot": "no-results",
      "value": true,
      "color": "warning",
      "icon": "warning"
    },
    slot: "no-results"
  }, [_vm._v("\n        Your search for \"" + _vm._s(_vm.search) + "\" found no results.\n      ")])], 1) : _vm._e()], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 436 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-card', [(_vm.err) ? _c('v-flex', {
    attrs: {
      "xs12": "",
      "pt-4": "",
      "px-4": ""
    }
  }, [_c('v-alert', {
    attrs: {
      "value": true,
      "type": "error"
    }
  }, [_vm._v(_vm._s(_vm.err))])], 1) : _vm._e(), _vm._v(" "), _c('v-form', [_c('v-layout', {
    staticClass: "px-3 pt-3 pb-0",
    attrs: {
      "row": "",
      "wrap": "",
      "align-center": "",
      "justify-space-between": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": "",
      "sm6": "",
      "md6": ""
    }
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('datetime', {
    staticClass: "datetime-btn primary--text mx-2",
    attrs: {
      "phrases": {
        ok: _vm.$lang.actions.ok,
        cancel: _vm.$lang.actions.cancel
      },
      "type": "datetime",
      "placeholder": _vm.$lang.labels.fromDate
    },
    model: {
      value: (_vm.fromDate),
      callback: function($$v) {
        _vm.fromDate = $$v
      },
      expression: "fromDate"
    }
  }), _vm._v(" "), _c('datetime', {
    staticClass: "datetime-btn primary--text mx-2",
    attrs: {
      "phrases": {
        ok: _vm.$lang.actions.ok,
        cancel: _vm.$lang.actions.cancel
      },
      "type": "datetime",
      "placeholder": _vm.$lang.labels.toDate
    },
    model: {
      value: (_vm.toDate),
      callback: function($$v) {
        _vm.toDate = $$v
      },
      expression: "toDate"
    }
  })], 1)], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "sm6": "",
      "md3": "",
      "px-2": ""
    }
  }, [_c('v-select', {
    staticClass: "min-w max-w",
    attrs: {
      "chips": "",
      "deletable-chips": "",
      "hide-details": "",
      "multiple": "",
      "items": _vm.statuses,
      "label": _vm.$lang.labels.status
    },
    model: {
      value: (_vm.selectedStatuses),
      callback: function($$v) {
        _vm.selectedStatuses = $$v
      },
      expression: "selectedStatuses"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    staticClass: "text-xs-left text-md-right",
    attrs: {
      "xs12": "",
      "md3": "",
      "px-2": ""
    }
  }, [_c('v-btn', {
    staticClass: "primary mx-0",
    on: {
      "click": function($event) {
        return _vm.showDetails()
      }
    }
  }, [_vm._v(_vm._s(_vm.$lang.actions.showDetails))])], 1)], 1)], 1), _vm._v(" "), (true) ? _c('div', [_c('v-card-title', {
    staticClass: "pb-0 px-4 layout row wrap"
  }, [_c('v-spacer'), _vm._v(" "), _c('v-text-field', {
    staticClass: "min-w max-w",
    attrs: {
      "append-icon": "search",
      "label": _vm.$lang.labels.search,
      "hide-details": ""
    },
    model: {
      value: (_vm.search),
      callback: function($$v) {
        _vm.search = $$v
      },
      expression: "search"
    }
  })], 1), _vm._v(" "), _c('v-data-table', {
    attrs: {
      "headers": _vm.headers,
      "items": _vm.orders,
      "search": _vm.search,
      "loading": _vm.ordersLoading,
      "rows-per-page-items": [50, 100, 250, 500, {
        text: 'All',
        value: -1
      }]
    },
    scopedSlots: _vm._u([{
      key: "items",
      fn: function(props) {
        return [_c('td', [_c('v-btn', {
          staticClass: "primary--text ma-0",
          attrs: {
            "flat": ""
          },
          on: {
            "click": function($event) {
              return _vm.showModal(props.item.webShopOrderId)
            }
          }
        }, [_vm._v("\n              " + _vm._s(props.item.webShopOrderId) + "\n            ")]), _vm._v(" "), _c('div', {
          staticClass: "d-block",
          staticStyle: {
            "padding": "0 16px"
          }
        }, [_vm._v(_vm._s(props.item.webShopOrderSourceSystem))])], 1), _vm._v(" "), _c('td', [_vm._v(_vm._s(props.item.orderId))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(parseFloat(props.item.totalAmount).toFixed(2)))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(props.item.status))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(props.item.name))]), _vm._v(" "), _c('td', [_vm._v("\n            " + _vm._s(props.item.email) + "\n            "), _c('div', {
          staticClass: "d-block mt-1"
        }, [_vm._v(_vm._s(props.item.phone))])]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.formatDate(props.item.createdOn)))])]
      }
    }], null, false, 3291402343)
  }, [_c('v-progress-linear', {
    attrs: {
      "slot": "progress",
      "height": "6",
      "color": "primary",
      "indeterminate": ""
    },
    slot: "progress"
  }), _vm._v(" "), _vm._v(" "), _c('v-alert', {
    attrs: {
      "slot": "no-results",
      "value": true,
      "color": "warning",
      "icon": "warning"
    },
    slot: "no-results"
  }, [_vm._v("\n          Your search for \"" + _vm._s(_vm.search) + "\" found no results.\n        ")])], 1)], 1) : _vm._e(), _vm._v(" "), _c('v-btn', {
    staticClass: "ml-0 close-btn",
    attrs: {
      "absolute": "",
      "flat": ""
    },
    on: {
      "click": function($event) {
        return _vm.$router.push({
          name: 'webShop'
        })
      }
    }
  }, [_c('v-icon', [_vm._v("keyboard_arrow_left")]), _vm._v("\n      " + _vm._s(_vm.$lang.actions.close) + "\n    ")], 1)], 1), _vm._v(" "), (_vm.lastOrderModal) ? _c('v-dialog', {
    attrs: {
      "max-width": "1200"
    },
    model: {
      value: (_vm.lastOrderModal),
      callback: function($$v) {
        _vm.lastOrderModal = $$v
      },
      expression: "lastOrderModal"
    }
  }, [_c('last-order-modal', {
    attrs: {
      "lastOrder": _vm.lastOrder
    },
    on: {
      "close": function($event) {
        _vm.lastOrderModal = false
      }
    }
  })], 1) : _vm._e()], 1)
},staticRenderFns: []}

/***/ }),
/* 437 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-flex', {
    attrs: {
      "xs12": "",
      "lg9": ""
    }
  }, [_c('v-card', {
    staticClass: "py-4"
  }, [(_vm.err) ? _c('v-flex', {
    attrs: {
      "xs12": "",
      "px-4": "",
      "py-2": ""
    }
  }, [_c('v-alert', {
    attrs: {
      "value": true,
      "type": "error"
    }
  }, [_vm._v(_vm._s(_vm.err))])], 1) : _vm._e(), _vm._v(" "), (_vm.success) ? _c('v-flex', {
    attrs: {
      "xs12": "",
      "px-4": "",
      "py-2": ""
    }
  }, [_c('v-alert', {
    attrs: {
      "value": true,
      "type": "success"
    }
  }, [_vm._v(_vm._s(_vm.success))])], 1) : _vm._e(), _vm._v(" "), _c('v-form', {
    model: {
      value: (_vm.valid),
      callback: function($$v) {
        _vm.valid = $$v
      },
      expression: "valid"
    }
  }, [_c('v-layout', {
    staticClass: "px-2",
    attrs: {
      "row": "",
      "wrap": "",
      "justify-space-between": "",
      "align-center": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": "",
      "sm6": "",
      "px-3": ""
    }
  }, [(!_vm.isLocalAdmin) ? _c('v-autocomplete', {
    attrs: {
      "items": _vm.companies,
      "label": _vm.$lang.actions.selectCompany,
      "item-text": "name",
      "item-value": "id",
      "required": "",
      "readonly": _vm.isEdit,
      "loading": _vm.companyLoading,
      "rules": [function (v) { return !!v || ("" + (_vm.$lang.errors.missingCompany)); }]
    },
    model: {
      value: (_vm.printer.companyId),
      callback: function($$v) {
        _vm.$set(_vm.printer, "companyId", $$v)
      },
      expression: "printer.companyId"
    }
  }) : _vm._e()], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "sm6": "",
      "px-3": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": _vm.$lang.labels.printerName,
      "required": "",
      "rules": [function (v) { return !!v || ("" + (_vm.$lang.errors.missingPrinterName)); }]
    },
    model: {
      value: (_vm.printer.name),
      callback: function($$v) {
        _vm.$set(_vm.printer, "name", $$v)
      },
      expression: "printer.name"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "sm6": "",
      "px-3": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": _vm.$lang.header.manufacturer,
      "required": "",
      "rules": [function (v) { return !!v || ("" + (_vm.$lang.errors.missingManufacturer)); }]
    },
    model: {
      value: (_vm.printer.manufacturer),
      callback: function($$v) {
        _vm.$set(_vm.printer, "manufacturer", $$v)
      },
      expression: "printer.manufacturer"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "sm6": "",
      "px-3": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": _vm.$lang.header.model,
      "required": "",
      "rules": [function (v) { return !!v || ("" + (_vm.$lang.errors.missingModel)); }]
    },
    model: {
      value: (_vm.printer.model),
      callback: function($$v) {
        _vm.$set(_vm.printer, "model", $$v)
      },
      expression: "printer.model"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "sm6": "",
      "px-3": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": _vm.$lang.labels.ipAddress,
      "disabled": _vm.pdfPrinter
    },
    model: {
      value: (_vm.printer.ipAddress),
      callback: function($$v) {
        _vm.$set(_vm.printer, "ipAddress", $$v)
      },
      expression: "printer.ipAddress"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "sm6": "",
      "px-3": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": _vm.$lang.labels.portNumber,
      "disabled": _vm.pdfPrinter,
      "rules": [function (v) { return _vm.checkPort(v); }]
    },
    model: {
      value: (_vm.printer.portNumber),
      callback: function($$v) {
        _vm.$set(_vm.printer, "portNumber", $$v)
      },
      expression: "printer.portNumber"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "sm6": "",
      "px-3": ""
    }
  }, [_c('v-select', {
    attrs: {
      "label": _vm.$lang.actions.selectPrinterCategories,
      "multiple": "",
      "small-chips": "",
      "deletable-chips": "",
      "items": _vm.sortedCategories
    },
    model: {
      value: (_vm.printer.printerCategories),
      callback: function($$v) {
        _vm.$set(_vm.printer, "printerCategories", $$v)
      },
      expression: "printer.printerCategories"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": "",
      "sm6": "",
      "px-3": ""
    }
  }, [_c('v-textarea', {
    attrs: {
      "label": _vm.$lang.labels.notes,
      "auto-grow": "",
      "rows": "1"
    },
    model: {
      value: (_vm.printer.notes),
      callback: function($$v) {
        _vm.$set(_vm.printer, "notes", $$v)
      },
      expression: "printer.notes"
    }
  })], 1)], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "sm6": "",
      "px-3": ""
    }
  }, [_c('v-checkbox', {
    staticClass: "option",
    attrs: {
      "label": _vm.$lang.labels.pdfPrinter,
      "color": "primary",
      "hide-details": ""
    },
    model: {
      value: (_vm.pdfPrinter),
      callback: function($$v) {
        _vm.pdfPrinter = $$v
      },
      expression: "pdfPrinter"
    }
  })], 1)], 1), _vm._v(" "), _c('v-layout', {
    staticClass: "mt-3 px-2",
    attrs: {
      "row": "",
      "wrap": "",
      "justify-space-between": ""
    }
  }, [(_vm.isEdit && _vm.createdOn) ? _c('v-text-field', {
    staticClass: "min-w max-w mx-3",
    attrs: {
      "label": _vm.$lang.labels.created,
      "readonly": ""
    },
    model: {
      value: (_vm.createdOn),
      callback: function($$v) {
        _vm.createdOn = $$v
      },
      expression: "createdOn"
    }
  }) : _vm._e(), _vm._v(" "), (_vm.isEdit && _vm.modifiedOn) ? _c('v-text-field', {
    staticClass: "min-w max-w mx-3",
    attrs: {
      "label": _vm.$lang.labels.modified,
      "readonly": ""
    },
    model: {
      value: (_vm.modifiedOn),
      callback: function($$v) {
        _vm.modifiedOn = $$v
      },
      expression: "modifiedOn"
    }
  }) : _vm._e()], 1), _vm._v(" "), _c('v-layout', {
    staticClass: "px-2",
    attrs: {
      "row": "",
      "wrap": "",
      "justify-space-between": "",
      "align-content-center": ""
    }
  }, [_c('v-btn', {
    staticClass: "mx-3",
    attrs: {
      "flat": ""
    },
    on: {
      "click": function($event) {
        return _vm.$router.push({
          name: 'printers'
        })
      }
    }
  }, [_c('v-icon', [_vm._v("keyboard_arrow_left")]), _vm._v("\n          " + _vm._s(_vm.$lang.actions.close) + "\n        ")], 1), _vm._v(" "), _c('v-btn', {
    staticClass: "primary mx-3",
    attrs: {
      "disabled": !_vm.valid
    },
    on: {
      "click": _vm.submit
    }
  }, [_vm._v("\n          " + _vm._s(_vm.isEdit ? _vm.$lang.actions.update : _vm.$lang.actions.create) + "\n        ")])], 1)], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 438 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-card', {
    staticClass: "pt-3"
  }, [(_vm.err) ? _c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-alert', {
    attrs: {
      "value": true,
      "type": "error"
    }
  }, [_vm._v(_vm._s(_vm.err))])], 1) : _vm._e(), _vm._v(" "), (_vm.success) ? _c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-alert', {
    attrs: {
      "value": true,
      "type": "success"
    }
  }, [_vm._v(_vm._s(_vm.success))])], 1) : _vm._e(), _vm._v(" "), _c('v-form', {
    model: {
      value: (_vm.valid),
      callback: function($$v) {
        _vm.valid = $$v
      },
      expression: "valid"
    }
  }, [_c('v-layout', {
    staticClass: "px-2 pb-3",
    attrs: {
      "row": "",
      "wrap": "",
      "align-center": ""
    }
  }, [_c('datetime', {
    staticClass: "datetime-btn primary--text mx-3",
    attrs: {
      "phrases": {
        ok: _vm.$lang.actions.ok,
        cancel: _vm.$lang.actions.cancel
      },
      "type": "datetime"
    },
    model: {
      value: (_vm.fromDate),
      callback: function($$v) {
        _vm.fromDate = $$v
      },
      expression: "fromDate"
    }
  }), _vm._v(" "), _c('datetime', {
    staticClass: "datetime-btn primary--text mx-3",
    attrs: {
      "phrases": {
        ok: _vm.$lang.actions.ok,
        cancel: _vm.$lang.actions.cancel
      },
      "type": "datetime"
    },
    model: {
      value: (_vm.toDate),
      callback: function($$v) {
        _vm.toDate = $$v
      },
      expression: "toDate"
    }
  }), _vm._v(" "), _c('v-autocomplete', {
    staticClass: "mx-3 min-w max-w",
    attrs: {
      "clearable": "",
      "label": _vm.$lang.actions.selectCompany,
      "items": _vm.mappedCompanies,
      "loading": _vm.companyLoading,
      "hide-details": ""
    },
    model: {
      value: (_vm.companyId),
      callback: function($$v) {
        _vm.companyId = $$v
      },
      expression: "companyId"
    }
  })], 1), _vm._v(" "), _c('v-layout', {
    staticClass: "px-2",
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": "",
      "sm6": "",
      "md4": "",
      "px-3": ""
    }
  }, [_c('v-select', {
    attrs: {
      "label": _vm.$lang.labels.configUpdates,
      "items": _vm.configTypes,
      "required": "",
      "rules": [function (v) { return !!v || ("" + (_vm.$lang.errors.missingCfgUpdate)); }],
      "clearable": ""
    },
    on: {
      "change": _vm.setConfigShort
    },
    model: {
      value: (_vm.configType),
      callback: function($$v) {
        _vm.configType = $$v
      },
      expression: "configType"
    }
  })], 1), _vm._v(" "), (_vm.configType === 'Planet Configuration Updates') ? _c('v-flex', {
    attrs: {
      "xs12": "",
      "sm6": "",
      "md4": "",
      "lg3": "",
      "px-3": ""
    }
  }, [_c('v-select', {
    attrs: {
      "label": _vm.$lang.labels.planetType,
      "items": _vm.planetTypes,
      "clearable": ""
    },
    model: {
      value: (_vm.planetType),
      callback: function($$v) {
        _vm.planetType = $$v
      },
      expression: "planetType"
    }
  })], 1) : _vm._e(), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "sm6": "",
      "md4": "",
      "lg3": "",
      "px-3": ""
    }
  }, [_c('v-autocomplete', {
    attrs: {
      "label": _vm.$lang.labels.status,
      "items": _vm.statuses,
      "clearable": ""
    },
    model: {
      value: (_vm.status),
      callback: function($$v) {
        _vm.status = $$v
      },
      expression: "status"
    }
  })], 1)], 1), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-btn', {
    staticClass: "primary mx-4 mb-4",
    attrs: {
      "disabled": !_vm.valid
    },
    on: {
      "click": _vm.showUpdates
    }
  }, [_vm._v(_vm._s(_vm.$lang.actions.showUpdates))]), _vm._v(" "), _c('v-spacer'), _vm._v(" "), (_vm.show) ? _c('v-text-field', {
    staticClass: "min-w max-w mx-4",
    attrs: {
      "append-icon": "search",
      "label": _vm.$lang.labels.search,
      "hide-details": ""
    },
    model: {
      value: (_vm.search),
      callback: function($$v) {
        _vm.search = $$v
      },
      expression: "search"
    }
  }) : _vm._e()], 1)], 1), _vm._v(" "), (_vm.show) ? _c('v-data-table', {
    attrs: {
      "headers": _vm.headers,
      "items": _vm.configs,
      "search": _vm.search,
      "loading": _vm.loading,
      "pagination": _vm.pagination,
      "rows-per-page-items": [50, 100, 250, 500, {
        text: 'All',
        value: -1
      }]
    },
    on: {
      "update:pagination": function($event) {
        _vm.pagination = $event
      }
    },
    scopedSlots: _vm._u([{
      key: "items",
      fn: function(props) {
        return [(props.item.moonInsatanceName) ? _c('td', {
          staticClass: "min-w"
        }, [_vm._v(_vm._s(props.item.moonInsatanceName))]) : _vm._e(), _vm._v(" "), (props.item.planetInstanceName) ? _c('td', {
          staticClass: "min-w"
        }, [_vm._v(_vm._s(props.item.planetInstanceName))]) : _vm._e(), _vm._v(" "), _c('td', {
          staticClass: "min-w"
        }, [_vm._v(_vm._s(props.item.companyName))]), _vm._v(" "), _c('td', {
          staticClass: "min-w"
        }, [_vm._v(_vm._s(_vm.formatDate(props.item.createdOn)))]), _vm._v(" "), _c('td', {
          staticClass: "min-w"
        }, [_vm._v(_vm._s(_vm.formatDate(props.item.synchedOn)))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(props.item.status))]), _vm._v(" "), _c('td', [_c('v-btn', {
          staticClass: "primary mx-0",
          on: {
            "click": function($event) {
              return _vm.showModal(props.index)
            }
          }
        }, [_vm._v(_vm._s(_vm.$lang.actions.view))])], 1)]
      }
    }], null, false, 3966114881)
  }, [_c('v-progress-linear', {
    attrs: {
      "slot": "progress",
      "height": "6",
      "color": "primary",
      "indeterminate": ""
    },
    slot: "progress"
  }), _vm._v(" "), _vm._v(" "), _c('v-alert', {
    attrs: {
      "slot": "no-results",
      "value": true,
      "color": "warning",
      "icon": "warning"
    },
    slot: "no-results"
  }, [_vm._v("\n        Your search for \"" + _vm._s(_vm.search) + "\" found no results.\n      ")])], 1) : _vm._e()], 1), _vm._v(" "), (_vm.configUpdatesView) ? _c('v-dialog', {
    attrs: {
      "max-width": "1200"
    },
    model: {
      value: (_vm.configUpdatesView),
      callback: function($$v) {
        _vm.configUpdatesView = $$v
      },
      expression: "configUpdatesView"
    }
  }, [_c('config-modal', {
    attrs: {
      "id": _vm.configs[_vm.configIndex].id,
      "type": _vm.configTypeShort
    },
    on: {
      "close": _vm.closeModal,
      "prev": _vm.showPrev,
      "next": _vm.showNext
    }
  })], 1) : _vm._e()], 1)
},staticRenderFns: []}

/***/ }),
/* 439 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-card', {
    staticClass: "py-4"
  }, [_c('v-form', {
    model: {
      value: (_vm.valid),
      callback: function($$v) {
        _vm.valid = $$v
      },
      expression: "valid"
    }
  }, [_c('v-layout', {
    staticClass: "px-2",
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [(_vm.err) ? _c('v-flex', {
    attrs: {
      "xs12": "",
      "px-3": "",
      "py-2": ""
    }
  }, [_c('v-alert', {
    attrs: {
      "value": true,
      "type": "error"
    },
    domProps: {
      "innerHTML": _vm._s(_vm.err)
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.success) ? _c('v-flex', {
    attrs: {
      "xs12": "",
      "px-3": "",
      "py-2": ""
    }
  }, [_c('v-alert', {
    attrs: {
      "value": true,
      "type": "success"
    }
  }, [_vm._v(_vm._s(_vm.success))])], 1) : _vm._e(), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "px-3": ""
    }
  }, [_c('v-textarea', {
    attrs: {
      "id": "instanceId",
      "label": _vm.$lang.labels.instanceId,
      "readonly": "",
      "auto-grow": "",
      "rows": "1"
    },
    model: {
      value: (_vm.instance.instanceId),
      callback: function($$v) {
        _vm.$set(_vm.instance, "instanceId", $$v)
      },
      expression: "instance.instanceId"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "md6": "",
      "px-3": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": _vm.$lang.labels.name,
      "readonly": ""
    },
    model: {
      value: (_vm.instance.name),
      callback: function($$v) {
        _vm.$set(_vm.instance, "name", $$v)
      },
      expression: "instance.name"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "md6": "",
      "px-3": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": _vm.$lang.labels.status,
      "readonly": ""
    },
    model: {
      value: (_vm.instance.status),
      callback: function($$v) {
        _vm.$set(_vm.instance, "status", $$v)
      },
      expression: "instance.status"
    }
  })], 1), _vm._v(" "), (_vm.instance.currentVersion) ? _c('v-flex', {
    attrs: {
      "xs12": "",
      "md6": "",
      "px-3": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": _vm.$lang.labels.currentVersion,
      "readonly": ""
    },
    model: {
      value: (_vm.instance.currentVersion),
      callback: function($$v) {
        _vm.$set(_vm.instance, "currentVersion", $$v)
      },
      expression: "instance.currentVersion"
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.instance.previousVersion) ? _c('v-flex', {
    attrs: {
      "xs12": "",
      "md6": "",
      "px-3": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": _vm.$lang.labels.previousVersion,
      "readonly": ""
    },
    model: {
      value: (_vm.instance.previousVersion),
      callback: function($$v) {
        _vm.$set(_vm.instance, "previousVersion", $$v)
      },
      expression: "instance.previousVersion"
    }
  })], 1) : _vm._e(), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "px-3": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": _vm.$lang.labels.macAddress,
      "readonly": ""
    },
    model: {
      value: (_vm.instance.macAddresses),
      callback: function($$v) {
        _vm.$set(_vm.instance, "macAddresses", $$v)
      },
      expression: "instance.macAddresses"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "px-3": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": _vm.$lang.labels.moonUrl,
      "rules": [function (v) { return _vm.validURL(v) || ("" + (_vm.$lang.errors.notValidUrl)); }, function (v) { return _vm.checkIsJustHostname(v) || ("" + (_vm.$lang.errors.notValidUrl)); }]
    },
    model: {
      value: (_vm.instance.moonUrl),
      callback: function($$v) {
        _vm.$set(_vm.instance, "moonUrl", $$v)
      },
      expression: "instance.moonUrl"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "md3": "",
      "px-3": ""
    }
  }, [_c('v-checkbox', {
    staticClass: "option",
    attrs: {
      "label": _vm.$lang.labels.publicKeySun,
      "color": "primary",
      "hide-details": "",
      "readonly": ""
    },
    model: {
      value: (_vm.instance.sunQueuePublicKeyPresent),
      callback: function($$v) {
        _vm.$set(_vm.instance, "sunQueuePublicKeyPresent", $$v)
      },
      expression: "instance.sunQueuePublicKeyPresent"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "md3": "",
      "px-3": ""
    }
  }, [_c('v-checkbox', {
    staticClass: "option",
    attrs: {
      "label": _vm.$lang.labels.privateKeySun,
      "color": "primary",
      "hide-details": "",
      "readonly": ""
    },
    model: {
      value: (_vm.instance.sunQueuePrivateKeyPresent),
      callback: function($$v) {
        _vm.$set(_vm.instance, "sunQueuePrivateKeyPresent", $$v)
      },
      expression: "instance.sunQueuePrivateKeyPresent"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "md6": "",
      "px-3": ""
    }
  }, [_c('v-checkbox', {
    staticClass: "option",
    attrs: {
      "label": _vm.$lang.labels.publicKeyMoon,
      "color": "primary",
      "hide-details": "",
      "readonly": ""
    },
    model: {
      value: (_vm.instance.moonQueuePublicKeyPresent),
      callback: function($$v) {
        _vm.$set(_vm.instance, "moonQueuePublicKeyPresent", $$v)
      },
      expression: "instance.moonQueuePublicKeyPresent"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "md6": "",
      "px-3": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": _vm.$lang.labels.created,
      "readonly": ""
    },
    model: {
      value: (_vm.instance.createdOn),
      callback: function($$v) {
        _vm.$set(_vm.instance, "createdOn", $$v)
      },
      expression: "instance.createdOn"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "md6": "",
      "px-3": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": _vm.$lang.header.contactedOn,
      "readonly": ""
    },
    model: {
      value: (_vm.instance.lastContactOn),
      callback: function($$v) {
        _vm.$set(_vm.instance, "lastContactOn", $$v)
      },
      expression: "instance.lastContactOn"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('v-layout', {
    staticClass: "px-4",
    attrs: {
      "rwo": "",
      "wrap": "",
      "justify-space-between": "",
      "align-center": ""
    }
  }, [_c('v-btn', {
    staticClass: "mx-0",
    attrs: {
      "flat": ""
    },
    on: {
      "click": function($event) {
        return _vm.$router.push({
          name: 'moonInstances'
        })
      }
    }
  }, [_c('v-icon', [_vm._v("keyboard_arrow_left")]), _vm._v("\n        " + _vm._s(_vm.$lang.actions.close) + "\n      ")], 1), _vm._v(" "), _c('div', {
    staticClass: "d-inline-flex"
  }, [_c('v-btn', {
    staticClass: "primary mr-0",
    attrs: {
      "disabled": !_vm.valid
    },
    on: {
      "click": function($event) {
        return _vm.submit()
      }
    }
  }, [_vm._v("\n          Update\n        ")]), _vm._v(" "), _c('v-btn', {
    staticClass: "primary mr-0",
    on: {
      "click": _vm.copyKey
    }
  }, [_vm._v("\n          Copy Instance ID\n        ")])], 1)], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 440 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-card', [(_vm.err) ? _c('v-flex', {
    attrs: {
      "xs12": "",
      "px-4": "",
      "pt-4": ""
    }
  }, [_c('v-alert', {
    attrs: {
      "type": "error",
      "value": true
    }
  }, [_vm._v(_vm._s(_vm.err))])], 1) : _vm._e(), _vm._v(" "), _c('v-card-title', {
    staticClass: "pb-0 layout row wrap px-4"
  }, [_c('v-btn', {
    staticClass: "primary ma-0",
    on: {
      "click": function($event) {
        return _vm.$router.push({
          name: "newDomain"
        })
      }
    }
  }, [_vm._v(_vm._s(_vm.$lang.actions.createDomain))]), _vm._v(" "), _c('v-checkbox', {
    staticClass: "ml-3 mt-0",
    attrs: {
      "color": "primary",
      "label": _vm.$lang.labels.showActive,
      "hide-details": ""
    },
    model: {
      value: (_vm.showActive),
      callback: function($$v) {
        _vm.showActive = $$v
      },
      expression: "showActive"
    }
  }), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('v-text-field', {
    staticClass: "min-w max-w",
    attrs: {
      "append-icon": "search",
      "label": _vm.$lang.labels.search,
      "hide-details": ""
    },
    model: {
      value: (_vm.search),
      callback: function($$v) {
        _vm.search = $$v
      },
      expression: "search"
    }
  })], 1), _vm._v(" "), _c('v-data-table', {
    attrs: {
      "headers": _vm.headers,
      "items": _vm.showActive ? _vm.activeDomains : _vm.allDomains,
      "search": _vm.search,
      "loading": _vm.allDomains.length === 0,
      "rows-per-page-items": [50, 100, 250, 500, {
        text: 'All',
        value: -1
      }]
    },
    scopedSlots: _vm._u([{
      key: "items",
      fn: function(props) {
        return [_c('td', [_vm._v(_vm._s(props.item.domain))]), _vm._v(" "), _c('td', {
          staticClass: "text-xs-left"
        }, [_vm._v(_vm._s(props.item.type))]), _vm._v(" "), _c('td', {
          staticClass: "text-xs-left"
        }, [_vm._v(_vm._s(props.item.status))]), _vm._v(" "), _c('td', {
          staticClass: "text-xs-left"
        }, [_vm._v(_vm._s(_vm.formatDate(props.item.createdOn)))]), _vm._v(" "), _c('td', {
          staticClass: "text-xs-left min-w-lg"
        }, [_c('v-btn', {
          staticClass: "primary mx-0 elevation-1",
          on: {
            "click": function($event) {
              return _vm.editDomain(props.item)
            }
          }
        }, [_vm._v("\n            " + _vm._s(_vm.$lang.actions.edit) + "\n          ")]), _vm._v(" "), _c('v-btn', {
          staticClass: "primary elevation-1",
          on: {
            "click": function($event) {
              return _vm.changeStatus(props.item)
            }
          }
        }, [_vm._v("\n            " + _vm._s(props.item.status === 'active' ? _vm.$lang.actions.deactivate : _vm.$lang.actions.activate) + "\n          ")])], 1)]
      }
    }])
  }, [_c('v-progress-linear', {
    attrs: {
      "slot": "progress",
      "height": "6",
      "color": "primary",
      "indeterminate": ""
    },
    slot: "progress"
  }), _vm._v(" "), _vm._v(" "), _c('v-alert', {
    attrs: {
      "slot": "no-results",
      "value": true,
      "type": "warning"
    },
    slot: "no-results"
  }, [_vm._v("\n        Your search for \"" + _vm._s(_vm.search) + "\" found no results.\n      ")])], 1)], 1), _vm._v(" "), (_vm.confirmationModal) ? _c('v-dialog', {
    attrs: {
      "max-width": "500"
    },
    model: {
      value: (_vm.confirmationModal),
      callback: function($$v) {
        _vm.confirmationModal = $$v
      },
      expression: "confirmationModal"
    }
  }, [_c('confirmation-modal', {
    attrs: {
      "data": _vm.confirmationData
    },
    on: {
      "close": function($event) {
        _vm.confirmationModal = false
      },
      "change": function($event) {
        return _vm.deactivate($event)
      }
    }
  })], 1) : _vm._e()], 1)
},staticRenderFns: []}

/***/ }),
/* 441 */,
/* 442 */,
/* 443 */,
/* 444 */,
/* 445 */,
/* 446 */,
/* 447 */,
/* 448 */,
/* 449 */
/***/ (function(module, exports) {

module.exports = {"_args":[["weekstart@1.0.1","/opt/atlassian/pipelines/agent/build"]],"_from":"weekstart@1.0.1","_id":"weekstart@1.0.1","_inBundle":false,"_integrity":"sha512-h6B1HSJxg7sZEXqIpDqAtwiDBp3x5y2jY8WYcUSBhLTcTCy7laQzBmamqMuQM5fpvo1pgpma0OCRpE2W8xrA9A==","_location":"/weekstart","_phantomChildren":{},"_requested":{"type":"version","registry":true,"raw":"weekstart@1.0.1","name":"weekstart","escapedName":"weekstart","rawSpec":"1.0.1","saveSpec":null,"fetchSpec":"1.0.1"},"_requiredBy":["/"],"_resolved":"https://registry.npmjs.org/weekstart/-/weekstart-1.0.1.tgz","_spec":"1.0.1","_where":"/opt/atlassian/pipelines/agent/build","author":{"name":"Denis Sikuler"},"bugs":{"url":"https://github.com/gamtiq/weekstart/issues"},"description":"Library to get first day of week.","devDependencies":{"@babel/preset-env":"7.6.3","eslint":"6.5.1","eslint-config-guard":"1.0.3","ink-docstrap":"1.3.2","jest":"24.9.0","jsdoc":"3.6.3","microbundle":"0.4.4","version-bump-prompt":"5.0.5"},"homepage":"https://github.com/gamtiq/weekstart","keywords":["week","start","first","day","locale","country","region"],"license":"MIT","main":"dist/commonjs/main.js","module":"dist/es-module/main.js","name":"weekstart","repository":{"type":"git","url":"git://github.com/gamtiq/weekstart.git"},"scripts":{"all":"npm run check-all && npm run doc && npm run build","build":"npm run build-umd && npm run build-commonjs && npm run build-esm && npm run build-umd-min","build-commonjs":"microbundle build \"src/!(*.test).js\" --output dist/commonjs --format cjs --strict --no-compress","build-esm":"microbundle build \"src/!(*.test).js\" --output dist/es-module --format es --no-compress","build-umd":"microbundle build src/main.js src/full.js --output dist --format umd --strict --no-compress","build-umd-min":"microbundle build src/main.js src/full.js --output dist/min --format umd --strict","check":"npm run lint && npm test","check-all":"npm run lint-all && npm test","doc":"jsdoc -c jsdoc-conf.json","lint":"eslint --cache --max-warnings 0 \"**/*.js\"","lint-all":"eslint --max-warnings 0 \"**/*.js\"","lint-all-error":"eslint \"**/*.js\"","lint-error":"eslint --cache \"**/*.js\"","release":"bump patch --commit --tag --all --push package.json package-lock.json bower.json component.json","release-major":"bump major --commit --tag --all --push package.json package-lock.json bower.json component.json","release-minor":"bump minor --commit --tag --all --push package.json package-lock.json bower.json component.json","test":"jest"},"types":"./index.d.ts","umd:main":"dist/main.js","version":"1.0.1"}

/***/ }),
/* 450 */
/***/ (function(module, exports) {

/* (ignored) */

/***/ })
],[164]);


// WEBPACK FOOTER //
// static/js/app.095886cba326415213e4.js